import { BaseSteps } from '../../dirents';
import { newsMappings } from './domains/news-mappings';
import { pwaMappings } from './domains/pwa-mappings';

export const textMappings = {
  BogdanBegin: {
    en: 'x1',
    nb: 'x2',
    sv: 'x3',
  },
  ConnectTripletexFirst: {
    en: 'To be able to send invoice - connect Tripletex.',
    nb: 'For å kunne sende faktura - koble til Tripletex.',
  },
  InvalidContractType: {
    en: 'Invalid contract type, must be of type "option", "warrant" or "convertible"',
    nb: 'Ugyldig kontraktstype, du må velge enten "opsjon", "tegningsrett" eller "lån"',
  },
  InvalidContractStatus: {
    en: 'Invalid contract status, must be of type "not exercised", "cancelled", "exercised" or "expired"',
    nb: 'Ugyldig kontraktsstatus, du må velge enten "ikke utøvd", "kansellert", "utøvd" eller "utløpt"',
  },
  FailedStatusOnCreateAgendaItem: {
    en: 'Failed to create agenda item, only visible for superusers',
    nb: 'Feil ved oppretting av agendapunkt, kun synlig for superbrukere',
  },
  ProtocolComment: {
    en: 'Protocol comment',
    nb: 'Protokollbemerkning',
  },
  MinutesStatus: {
    en: 'Minutes status',
    nb: 'Protokollstatus',
  },
  SendForHearing: {
    en: 'Send for hearing',
    nb: 'Send på høring',
  },
  SendToSigning: {
    en: 'Send to signing',
    nb: 'Send til signering',
  },
  AreYouSureToGenerateNewMinutes: {
    en: 'Are you sure you want to start with a new draft? This will overwrite the current PDF and signatures.',
    nb: 'Er du sikker på at du vil starte med et nytt utkast? Dette vil overskrive gjeldende PDF og signeringer.',
  },
  GenerateMinutes: {
    en: 'Generate PDF',
    nb: 'Generer PDF',
  },
  MinutesPDF: {
    en: 'Minutes PDF',
    nb: 'Protokoll PDF',
  },
  Hearing: {
    en: 'Hearing',
    nb: 'Høring',
  },
  CommentTypeDialog: {
    en: 'Comment type',
    nb: 'Kommentartype',
  },
  CommentTypeDialogText: {
    en: 'Choose where the comment should be added. PDF comments are linked to the document, while meeting comments are general. PDF comments are recommended for comments on the protocol.',
    nb: 'Velg hvor kommentaren skal legges til. PDF-kommentarer knyttes til dokumentet, mens protokollnotat er generelle. PDF-kommentarer er anbefalt for kommentarer til protokollen.',
  },
  PDFComments: {
    en: 'PDF comments',
    nb: 'PDF kommentar',
  },
  MeetingComments: {
    en: 'Minutes note',
    nb: 'Protokollnotat',
  },
  NoCommentsFound: {
    en: 'No comments found',
    nb: 'Ingen kommentarer funnet',
  },
  AreYouSureToBackToHearingFromSigning: {
    en: 'The protocol is already sent for signing or completed. It is not possible to send it for hearing again. You can create a new draft, or generate a new protocol.',
    nb: 'Protokollen er allerede sendt til signering eller ferdigstilt. Det er ikke mulig å sende den på høring igjen. Lag et nytt utkast, eller generer en ny protokoll.',
  },
  AreYouSureToBackToHearingFromSigningTitle: {
    en: 'Signing already started',
    nb: 'Signering allerede startet',
  },
  'meetings.minutes.minutesGroupActiveConsolidated': {
    en: 'Joint minutes',
    nb: 'Felles protokoll',
  },
  proposedResolution: {
    en: 'Proposed resolution',
    nb: 'Forslag til vedtak',
  },
  ProtocolPreview: {
    en: 'Protocol preview',
    nb: 'Protokoll forhåndsvisning',
  },
  DisplayProtocol: {
    en: 'Preview',
    nb: 'Forhåndsvisning',
  },
  ClickToAddMinuteNotes: {
    en: 'Click to add minute notes',
    nb: 'Klikk for å legge til protokollnotat',
  },
  ViewAgendaItemDescription: {
    en: 'View agenda item description, this does not end up in the protocol',
    nb: 'Se agendapunktbeskrivelse, dette ender ikke opp i protokollen',
  },
  Hereyoucaneasilycreateane: {
    en: 'Here you can easily create a new organization in Orgbrain – either by searching for a specific organization in the Brønnøysund Registers that you have a relevant connection to, or by creating a fictitious organization. The organization will automatically be registered as a 14-day trial subscription, unless you create the organization as part of a specific offer.',
    nb: 'Her kan du enkelt opprette en ny organisasjon i Orgbrain – enten ved å søke opp en konkret organisasjon i Brønnøysundregistrene som du har relevant tilknytning til, eller ved å opprette en fiktiv organisasjon. Organisasjonen blir automatisk registrert som et 14 dagers prøveabonnement, med mindre du oppretter organisasjonen som en del av et konkret tilbud.',
  },
  SearchtheBrnnysundregiste: {
    en: 'Search for organization in the Brønnøysund Registers',
    nb: 'Søk etter organisasjon i Brønnøysundregistrene',
  },

  AreYouSureToMarkMinutesAsFinishedBeforeSigning: {
    en: 'Are you sure you want to mark the minutes as finished before hearing and signing?',
    nb: 'Er du sikker på at du vil merke protokollen som fullført før den har vært på høring og signering?',
  },
  ProtocolPreviewConfirmText: {
    en: 'Check that the protocol is correct. Minor changes in content and formatting can be made in the next step.',
    nb: 'Kontroller at protokollen er korrekt. Små endringer i innhold og formatering kan gjøres i neste steg.',
  },
  Searchfororgnrorname: {
    en: 'Search by org.nr. or name',
    nb: 'Søk med org.nr. eller foretaksnavn',
  },
  SendEmailInvitationToNewUser: {
    en: 'Email invitation to new user',
    nb: 'Epostinvitasjon til ny bruker',
  },
  MeetingEngagementReadPercentTooltip: {
    en: 'The label indicates how well you have prepared for the meeting, based on how much of the agenda and attachments you have read.',
    nb: 'Etiketten viser hvor godt du har forberedt deg til møtet, basert på hvor mye av agendaen og vedleggene du har lest.',
  },
  CurrentMeeting: {
    en: 'Current meeting',
    nb: 'Nåværende møte',
  },
  MeetingEngagementReadPercent: {
    en: ' read',
    nb: ' lest',
  },
  participantsMeeting: {
    en: 'participants',
    nb: 'deltagere',
  },
  SendEmailToNewUser: {
    en: 'Send email',
    nb: 'Send e-post',
  },
  NoEmailToNewUser: {
    en: 'No email',
    nb: 'Ingen e-post',
  },
  Organizationname: {
    en: 'Organization name',
    nb: 'Navn på organisasjon',
  },
  Checktheinformation: {
    en: 'Check the information',
    nb: 'Sjekk opplysningene',
  },
  Postcodeandlocation: {
    en: 'Postcode and location',
    nb: 'Postnr. og sted',
  },
  BoardSchoolNoPermission: {
    en: 'You do not have access to the Boardschool',
    nb: 'Du mangler tilgang til Styreskolen',
  },
  BoardSchoolNoPermissionText: {
    en: 'It looks like you do not have access to the Board School in this organization. \nTo gain access to the Board School, you can contact the administrator of the organization, or use Orgbrain in another business where you have a more comprehensive role.',
    nb: 'Det ser ut som du ikke har fått tilgang til Styreskolen i denne organisasjonen. \nFor å få tilgang til Styreskolen kan du kontakte administrator i organisasjonen, eller bruke Orgbrain i en annen virksomhet der du har en mer omfattende rolle.',
  },
  ResponseStatus: {
    en: 'Response status',
    nb: 'Svarstatus',
  },
  'landing-styreskolentitle': {
    en: 'Who should the Board School be registered with?',
    nb: 'Hvem skal Styreskolen registreres på?',
  },
  'landing-normaltitle': {
    en: 'Create new organization account – completely free',
    nb: 'Opprett ny organisasjonskonto – helt gratis',
  },
  'landing-newOrgtext': {
    en: 'The account starts as a free trial account for 14 days. You can upgrade to a subscription at any time – if not, the account will automatically end without cost.',
    nb: 'Kontoen starter som en gratis prøvekonto i 14 dager. Du kan når som helst oppgradere til et abonnement – hvis ikke avsluttes kontoen automatisk uten kostnad.',
  },
  'landing-RegisterCompany': {
    en: 'Register for a business',
    nb: 'Registrer for et foretak',
  },
  'landing-invoicetocompanystyreskolen': {
    en: 'Should the Boarding School be invoiced to a company?',
    nb: 'Skal Styreskolen faktureres et foretak?',
  },
  'landing-companysearchstyreskolen': {
    en: 'Search for the company you are affiliated with below.',
    nb: 'Søk opp foretaket du er tilknyttet nedenfor.',
  },
  'landing-mainorgstyreskolen': {
    en: 'Register as a private person',
    nb: 'Registrer som privatperson',
  },
  'landing-fakeorgstyreskolen': {
    en: 'If you are not affiliated with a company, you can create the account as a private individual. We will use the name you choose as the account name.',
    nb: 'Dersom du ikke er knyttet til et foretak, kan du opprette kontoen som privatperson. Vi bruker navnet du velger som kontonavn.',
  },
  'landing-CreateOrg': {
    en: 'Create organization',
    nb: 'Opprett organisasjon',
  },
  'landing-NameBSchoolAcc': {
    en: 'Choose a name for your Boarding School account',
    nb: 'Velg navn på din Styreskole-konto',
  },
  'landing-NameOfAcc': {
    en: 'Enter the desired name for the account.',
    nb: 'Skriv inn ønsket navn på kontoen',
  },
  Youcanalsocreateafictitio: {
    en: 'You can also create an organization manually. This is suitable for foreign companies, businesses under establishment, or testing purposes. The organization number can be entered later.',
    nb: 'Du kan også opprette en organisasjon manuelt. Dette passer for utenlandske selskaper, virksomheter under etablering eller testformål. Organisasjonsnummer kan legges inn senere.',
  },
  'phone-settings.CountryCodePlaceholder': {
    en: 'Country',
    nb: 'Land',
  },
  Organizationalreadyregist: {
    en: 'Organization already registered',
    nb: 'Organisasjonen er allerede registrert',
  },
  Anorganizationwiththeorga: {
    en: 'An organization with the organization number {{orgNr}} is already registered with Orgbrain. This may be because someone previously created a trial account.',
    nb: 'En organisasjon med organisasjonsnummer {{orgNr}} er allerede registrert hos Orgbrain. Dette kan skyldes at noen tidligere har opprettet en prøvekonto.',
  },
  Ifyouhaveanyquestionsplea: {
    en: 'If you have any questions, please contact us at support@orgbrain.no',
    nb: 'Har du spørsmål kan du kontakte oss på support@orgbrain.no',
  },
  Doyouwanttoimporttheboard: {
    en: 'Do you want to import the board?',
    nb: 'Vil du importere styret?',
  },
  Youcannowimportinformatio: {
    en: 'You can now import information about the board and CEO directly from the Brønnøysund Registers. They will not be notified until you choose to invite them. You can also choose to do this later.',
    nb: 'Du kan nå importere opplysninger om styret og daglig leder direkte fra Brønnøysundregistrene. De vil ikke bli varslet før du selv velger å invitere dem. Du kan også velge å gjøre dette senere.',
  },
  Doyouwanttoimportthemnow: {
    en: 'Do you want to import them now?',
    nb: 'Vil du importere dem nå?',
  },
  Createnewaccount: {
    en: 'Create new account',
    nb: 'Opprett ny konto',
  },
  Createaccountwith: {
    en: 'Create account with',
    nb: 'Opprett konto med',
  },
  TryOrgbrainStyreskolen: {
    en: 'Get started with the Board School',
    nb: 'Kom i gang med Styreskolen',
  },
  TryOrgbrainForFree: {
    en: 'Get started for free with Orgbrain',
    nb: 'Kom i gang gratis med Orgbrain',
  },
  Register123: {
    en: 'Register in 1-2-3 with Vipps',
    nb: 'Registrer deg på 1-2-3 med Vipps',
  },
  SignupNoPay1: {
    en: 'You pay nothing now – we will send you an invoice later',
    nb: 'Du betaler ingenting nå – vi sender faktura senere',
  },
  WhoYouAreConfirm: {
    en: 'Vipps is only used to create an account and confirm who you are',
    nb: 'Vipps brukes kun for opprette konto og bekrefte hvem du er',
  },
  SignupNoPay2: {
    en: 'No payment, just quick and secure registration',
    nb: 'Ingen betaling, bare rask og sikker registrering',
  },
  AlreadyAUser: {
    en: 'Already a user?',
    nb: 'Allerede bruker?',
  },
  LogInHere: {
    en: 'Log in here',
    nb: 'Logg inn her',
  },
  YouConfirmOurTerms: {
    en: 'By registering you accept our',
    nb: 'Ved å registrere deg godtar du våre',
  },
  GetstartedwithOrgbrainins: {
    en: "It’s easy to create an account in Orgbrain – it only takes a few seconds with Vipps! Vipps is only used to create an account and verify the user's identity; no payment will be made with Vipps.",
    nb: 'Det er enkelt å opprette en konto i Orgbrain – det tar bare noen sekunder med Vipps! Vipps brukes kun til å opprette konto og verifisere brukerens identitet, det skal ikke betales noe med Vipps.',
  },
  Alreadyhaveanaccount: {
    en: 'Already have an account?',
    nb: 'Har du allerede en bruker?',
  },
  tocreateaneworganization: {
    en: 'to create a new organization!',
    nb: 'for å opprette en ny organisasjon!',
  },
  Createwith: {
    en: 'Create with',
    nb: 'Opprett med',
  },
  Contactpersonemail: {
    en: 'Contact person email',
    nb: 'E-post kontaktperson',
  },
  OverdueNoticeEmail: {
    en: 'Overdue Notice Email',
    nb: 'Forfalt e-postmelding',
  },
  Additionaladdressline: {
    en: 'Additional address line',
    nb: 'Ekstra adresselinje',
  },
  Currency: {
    en: 'Currency',
    nb: 'Valuta',
  },
  Taxamount: {
    en: 'Tax amount',
    nb: 'Skattebeløp',
  },
  Nofeeprocessing: {
    en: '(0%) No fee processing',
    nb: '(0%) Ingen avgiftsbehandling',
  },
  Exittaxhighrate: {
    en: '(25%) Exit tax, high rate',
    nb: '(25%) Utgående avgift, høy sats',
  },
  MeetingEmails: {
    en: 'Emails',
    nb: 'E-poster',
  },
  Sendemailwhenchangingsubs: {
    en: 'Send e-mail when changing subscription',
    nb: 'Send e-post ved endring av abonnement',
  },
  'auth.guard.generic1': {
    en: 'Please contact support if this error persists: support@orgbrain.ai.',
    nb: 'Kontakt kundestøtte hvis denne feilen vedvarer: support@orgbrain.ai.',
  },
  'auth.guard.sessionExpire1': { en: 'Session has expired', nb: 'Økten har utløpt' },
  'auth.guard.sessionExpire2': {
    en: 'You’ve been inactive for a while and have been logged out for security reasons. Please log in again to continue.',
    nb: 'Du har vært inaktiv en stund, og av sikkerhetsgrunner er du blitt logget ut. Logg inn igjen for å fortsette.',
  },
  'auth.guard.sessionExpire3': {
    en: 'An authorization problem occurred and your session has been terminated. If this is an error, please send us the screenshot at support@orgbrain.ai.',
    nb: 'Det oppsto et autorisasjonsproblem, og økten din er avsluttet. Hvis dette er en feil, kan du sende oss skjermbildet på support@orgbrain.ai.',
  },
  percentageOfVotes: {
    en: 'Percentage of votes',
    nb: 'Andel av stemmer',
  },
  isMarketingContract: {
    en: 'Accepts Orgbrain emails',
    nb: 'Mottar Orgbrain nyheter',
  },
  AcceptOrgbrainEmails: {
    en: 'Accept Orgbrain emails and notifications',
    nb: 'Motta nyheter og varsler',
  },
  AcceptOrgbrainEmailsText: {
    en: 'Become a more efficient Orgbrain user by staying updated on new features, product news, and best practices. You can unsubscribe at any time. Read more in our ',
    nb: 'Bli en mer effektiv bruker av Orgbrain ved å holde deg oppdatert på nye funksjoner, produktnyheter og beste praksis. Du kan når som helst melde deg av. Les mer i vår ',
  },
  AcceptNewsEmails: {
    en: 'Accept',
    nb: 'Motta',
  },
  PolicyLowerCase: {
    nb: 'personvernerklæring',
    en: 'privacy policy',
  },
  FetchfromBrreg: {
    en: 'Fetch from Brreg',
    nb: 'Hent fra Brreg',
  },
  FetchfromTripletex: {
    en: 'Fetch from Tripletex',
    nb: 'Hent fra Tripletex',
  },
  Updateinvoicedetails: {
    en: 'Update invoice details',
    nb: 'Oppdater fakturadetaljer',
  },
  Generateinvoice: {
    en: 'Generate invoice',
    nb: 'Generer faktura',
  },
  Orderedby: {
    en: 'Ordered by',
    nb: 'Bestilt av',
  },
  Doyouwanttogenerateinvoic: {
    en: 'Do you want to generate invoice?',
    nb: 'Ønsker du å generere faktura?',
  },
  Dateoffirstautomatedinvoi: {
    en: 'Date of first automated invoice',
    nb: 'Dato for første automatiserte faktura',
  },
  Annual: {
    en: 'Annual',
    nb: 'Årlig',
  },
  ShareOverview: {
    nb: 'Fortegnelse over fremmøte',
    en: 'Attendance overview',
  },
  Monthly: {
    en: 'Monthly',
    nb: 'Månedlig',
  },
  Subscriptionprice: {
    en: 'Subscription price',
    nb: 'Tegningskurs',
  },
  Included: {
    en: 'Included',
    nb: 'Inkludert',
  },
  users: {
    en: 'users',
    nb: 'brukere',
  },
  PreOrderedAdditionalUsers: {
    en: 'Pre-Ordered Additional Users (Standard)',
    nb: 'Forhåndsbestilte tilleggsbrukere (Standard)',
  },
  Preorderedadditionalusers: {
    en: 'Pre-ordered additional users (Subgroup)',
    nb: 'Forhåndsbestilte tilleggsbrukere (Undergruppe)',
  },
  OtheractualusersStandard: {
    en: 'Other actual users (Standard)',
    nb: 'Øvrige faktiske brukere (Standard)',
  },
  OtheractualusersSubgroup: {
    en: 'Other actual users (Subgroup)',
    nb: 'Øvrige faktiske brukere (Undergruppe)',
  },
  Discounts: {
    en: 'Discounts',
    nb: 'Rabatter',
  },
  Invoiceamount: {
    en: 'Invoice amount',
    nb: 'Fakturabeløp',
  },
  Discount: {
    en: 'Discount',
    nb: 'Rabatt',
  },
  Reinvoicing: {
    en: 'Reinvoicing',
    nb: 'Refakturering',
  },
  NotificationtoOrgbrainbef: {
    en: 'Notification to Orgbrain before invoicing',
    nb: 'Varsel til Orgbrain før fakturering',
  },
  Dateofreinvoicing: {
    en: 'Date of re-invoicing',
    nb: 'Dato for refakturering',
  },
  Expirationofsubscription: {
    en: 'Expiration of subscription',
    nb: 'Utløp av abonnement',
  },
  Excluding: {
    en: 'Excluding',
    nb: 'Ekskludert',
  },
  Invoicecomment: {
    en: 'Invoice comment',
    nb: 'Fakturakommentar',
  },
  Internalcomment: {
    en: 'Internal comment',
    nb: 'Intern kommentar',
  },
  'billing.Amount': {
    en: 'Amount',
    nb: 'Beløp',
  },

  year: {
    en: '1 year',
    nb: '1 år',
  },
  years: {
    en: '2 years',
    nb: '2 år',
  },
  Forever: {
    en: 'Forever',
    nb: 'For alltid',
  },
  Theseorganizationnumbersa: {
    en: 'These organization numbers already have parent organizations',
    nb: 'Disse organisasjonsnumrene har allerede foreldreorganisasjoner',
  },
  Errorchangingthesubscript: {
    en: 'Error changing the subscription',
    nb: 'Feil ved endring av abonnementet',
  },
  Subscriptionname: {
    en: 'Subscription name',
    nb: 'Abonnementsnavn',
  },
  Periodfrom: {
    en: 'Period from',
    nb: 'Periode fra',
  },
  Periodto: {
    en: 'Period to',
    nb: 'Periode til',
  },
  invoicePaid: {
    en: 'invoicePaid',
    nb: 'invoicePaid',
  },
  Invoice: {
    en: 'Invoice',
    nb: 'Faktura',
  },
  Sendorder: {
    en: 'Send order',
    nb: 'Send ordre',
  },
  Sendinvoice: {
    en: 'Send invoice',
    nb: 'Send faktura',
  },
  Product: {
    en: 'Product',
    nb: 'Produkt',
  },
  Quantity: {
    en: 'Quantity',
    nb: 'Mengde',
  },
  Priceperitem: {
    en: 'Price per item',
    nb: 'Pris per vare',
  },
  Totalprice: {
    en: 'Total price',
    nb: 'Totalpris',
  },
  Errors: {
    en: 'Errors',
    nb: 'Feilene',
  },
  OrderID: {
    en: 'Order ID',
    nb: 'Ordre ID',
  },
  InvoiceID: {
    en: 'Invoice ID',
    nb: 'Faktura ID',
  },
  Deleteallinvoices: {
    en: 'Delete all invoices?',
    nb: 'Vil du slette alle fakturaer?',
  },
  Doyouwanttosendthisinvoic: {
    en: 'Do you want to send this invoice with Tripletex',
    nb: 'Ønsker du å sende denne fakturaen med Tripletex',
  },
  Doyouwanttomakechangestoi: {
    en: 'Do you want to make changes to invoice ?',
    nb: 'Ønsker du å gjøre endringer i fakturaen?',
  },
  Deleteinvoice: {
    en: 'Delete invoice?',
    nb: 'Vil du slette faktura?',
  },
  Resendinvitationstoselect: {
    en: 'Resend invitations to selected users',
    nb: 'Send invitasjoner til utvalgte brukere på nytt',
  },
  Viewroleshistory: {
    en: 'View roles history',
    nb: 'Vis rollehistorikk',
  },
  Doyouwanttoresendtheinvit: {
    en: 'Do you want to resend the invitation to user?',
    nb: 'Ønsker du å sende ny invitasjon til bruker?',
  },
  Areyousureyouwanttocontin: {
    en: 'Are you sure you want to continue the deletion?',
    nb: 'Er du sikker på at du vil slette disse?',
  },
  Youareabouttodeleteoneorm: {
    en: 'You are about to delete one or more contacts, this will affect the ability to send emails to contacts!',
    nb: 'Du er i ferd med å slette en eller flere kontaktpersoner, dette vil ha innvirkning på å kunne sende eposter ut til kontaktpersoner!',
  },
  Cannotdeletealluseradmins: {
    en: 'Cannot delete all user admins',
    nb: 'Kan ikke slette alle administratorer',
  },

  tillnow: {
    en: 'till now',
    nb: 'til nå',
  },
  Grantedby: {
    en: 'Granted by',
    nb: 'Utført av',
  },
  Withdrawnby: {
    en: 'Withdrawn by',
    nb: 'Tilbaketrukket av',
  },

  ShareholderMeetings: {
    en: 'Shareholder Meetings',
    nb: 'Aksjonærmøter',
  },
  Timedisplay: {
    en: 'Time display',
    nb: 'Visning av tid',
  },
  Activities: {
    en: 'Activities',
    nb: 'Aktiviteter',
  },
  Thischoicedetermineswheth: {
    en: 'This choice determines whether the duration or start time of the agenda items will be displayed. A prerequisite for calculating the start time is that the duration has been entered for all preceding agenda items.',
    nb: 'Dette valget avgjør om agendapunktenes varighet eller starttid blir vist. En forutsetning for å kunne beregne starttid er at det er lagt inn varighet for alle foregående agendapunkter.',
  },
  Showstarttimeforagendaite: {
    en: 'Show start time for agenda item (not duration)',
    nb: 'Vis starttid for agendapunkt (ikke varighet)',
  },
  Personresponsibleforagend: {
    en: 'Person responsible for agenda items in board meetings',
    nb: 'Saksansvarlig på styremøter',
  },
  Byenablingthisoptionafiel: {
    en: 'By enabling this option, a field will appear on the agenda item where administrators can enter who is responsible for presenting an item during the meeting. This option will not be displayed during general meetings/annual meetings.',
    nb: 'Ved å aktivere dette alternativet vil det vises et felt på agendapunktet der administratorer kan legge inn hvem som har ansvaret for å presentere en sak under møtet. Dette alternativet vil ikke vises under generalforsamlinger/årsmøter.',
  },
  Showpersonresponsiblefora: {
    en: 'Show person responsible for agenda items',
    nb: 'Vis saksansvarlig på agendapunkter',
  },
  Speakerlist: {
    en: 'Speaker list',
    nb: 'Talerliste',
  },
  IsEditingTheAgenda: {
    en: ' is editing the agenda',
    nb: ' redigerer agendaen',
  },
  IsEditingTheMinutes: {
    en: ' is editing the minutes',
    nb: ' redigerer referatet',
  },
  MovedAgendaItem: {
    en: ' moved an agenda item',
    nb: ' flyttet et agendapunkt',
  },
  AddedAnAgendaItem: {
    en: ' added an agenda item',
    nb: ' la til et agendapunkt',
  },
  DeletedAnAgendaItem: {
    en: ' deleted an agenda item',
    nb: ' slettet et agendapunkt',
  },
  AddedSomeAgendaItem: {
    en: ' added some agenda items',
    nb: ' la til noen agendapunkter',
  },
  ClosedVotingForAgendaItem: {
    en: ' closed voting for an agenda item',
    nb: ' stengte avstemningen for et agendapunkt',
  },
  OpenedVotingForAgendaItem: {
    en: ' opened voting for an agenda item',
    nb: ' åpnet avstemningen for et agendapunkt',
  },
  ChangedMajorityRequirementRuleForAgendaItem: {
    en: ' changed the majority requirement rule for an agenda item',
    nb: ' endret flertallskravet for et agendapunkt',
  },
  Showagendaitemcomments: {
    en: 'Show agenda item comments',
    nb: 'Vis kommentarer til agendapunkt',
  },
  Agendaitemlogs: {
    en: 'Agenda item logs',
    nb: 'Agendapunktlogger',
  },
  Bycheckingthisoptiontheor: {
    en: 'By checking this option, the organization will have a new option in the three-dot menu at the top of the meeting card called "Show agenda item log". Here, administrators can see if anyone has modified the text of an agenda item.',
    nb: 'Ved å huke av vil organisasjonen få et nytt valg i 3-prikkermenyen øverst på møtekortet som heter "Vis agendapunktlogg". Her vil administratorer kunne se om noen har endret teksten på et agendapunkt.',
  },
  Showagendaitemlogs: {
    en: 'Show agenda item logs',
    nb: 'Vis agendapunktlogger',
  },
  Engagementtracker: {
    en: 'Engagement tracker',
    nb: 'Forberedelsemåler',
  },
  Showtheengagementtrackero: {
    en: 'Show the engagement tracker on "Participants"',
    nb: 'Vis forberedelsemåleren på «Deltakere»',
  },
  Engagementtrackerprovides: {
    en: "Engagement tracker provides you, as an administrator, with better insights into how well participants have prepared for the meeting, based on the number of agenda items and attachments they have opened. Each agenda item and attachment scores points. For example, an agenda with 5 items and 3 attachments totals 8 points, which corresponds to 100%. Opening a meeting book created with Orgbrain in the file attachments is also considered 100%. You can find the Engagement tracker under 'Participants' on the meeting card.\"",
    nb: 'Forberedelsemåleren gir deg som administrator bedre innsikt i hvor godt deltakerne har forberedt seg til møtet, basert på hvor mange agendapunkter og vedlegg de har åpnet. Hver agenda og hvert vedlegg gir poeng. For eksempel gir en agenda med 5 punkter og 3 vedlegg totalt 8 poeng, som tilsvarer 100%. Åpner deltakerne en møtebok laget med Orgbrain i filvedlegg, regnes dette også som 100 %. Du finner Forberedelsemåleren under «Deltakere» på møtekortet.',
  },
  ImplicitFOR: {
    en: 'Implicit FOR',
    nb: 'Implisitt FOR',
  },
  NoimplicitFOR: {
    en: 'No implicit FOR',
    nb: 'Ikke implisitt FOR',
  },
  Agendano: {
    en: 'Agenda no.',
    nb: 'Vanlig nummer',
  },
  Itemagendano: {
    en: 'Item + agenda no.',
    nb: 'Sak + vanlig nummer',
  },
  Consecutivenumberingperyear: {
    en: 'Consecutive numbering per year',
    nb: 'Fortløpende nummerering per år',
  },
  ConsecutivenumberingperyearAndMeetingNrAndYear: {
    en: 'Consecutive numbering per year + meeting no. + year',
    nb: 'Fortløpende nummerering per år + møtenr. + år',
  },
  Itemconsecutivenumberingp: {
    en: 'Item + consecutive numbering per year',
    nb: 'Sak + fortløpende nummerering per år',
  },
  Agendanomeetingnoyear: {
    en: 'Agenda no. + meeting no. + year',
    nb: 'Agendanr. + møtenr. + år',
  },
  ConsecutiveItemAndShortFormYear: {
    en: 'Item + consecutive numbering per year + year',
    nb: 'Sak + fortløpende nummerering per år + år',
  },
  ItemAndShortFormYear: {
    en: 'Item + agenda no. + year',
    nb: 'Sak + vanlig nummer + år',
  },
  Itemagendanomeetingnoyear: {
    en: 'Item + agenda no. + meeting no. + year',
    nb: 'Sak + agendanr. + møtenr. + år',
  },
  Nonumbering: {
    en: 'No numbering',
    nb: 'Ingen nummerering',
  },
  Thisserviceincursacost: {
    en: 'This service incurs a cost',
    nb: 'Tjenesten medfører kostnad',
  },
  ThisservicecostsNOKperide: {
    en: 'This service costs NOK 5 per identification and will be invoiced later.<br/>Do you want the organization to use the service?<br/>Confirm by clicking "Yes."',
    nb: 'Denne tjenesten koster kr 5 per identifisering og vil bli etterfakturert.<br/>Ønsker du at virksomheten skal ta i bruk tjenesten?<br/>Bekreft ved å klikke "Ja."',
  },
  Managefilter: {
    en: 'Manage filter',
    nb: 'Administrer filter',
  },
  Selectfiltertype: {
    en: 'Select filter type',
    nb: 'Velg filtertype',
  },
  Enddate: {
    en: 'End date',
    nb: 'Sluttdato',
  },

  Subsidiary: {
    en: 'Subsidiary',
    nb: 'Datterselskap',
  },
  Subgroup: {
    en: 'Subgroup',
    nb: 'Undergruppe',
  },
  Andconditionisactive: {
    en: '"And" condition is active',
    nb: '"Og" tilstand aktiv',
  },
  Orconditionisactive: {
    en: '"Or" condition is active',
    nb: '"Eller" tilstand aktiv',
  },
  Addnewfilter: {
    en: 'Add new filter',
    nb: 'Legg til nytt filter',
  },
  Clearallfilters: {
    en: 'Clear all filters',
    nb: 'Fjern alle filtre',
  },
  Renamethisrole: {
    en: 'Rename this role',
    nb: 'Nytt rollenavn',
  },
  Default: {
    en: 'Default',
    nb: 'Standard',
  },
  Auto: {
    en: 'Auto',
    nb: 'Auto',
  },
  Permission: {
    en: 'Permission',
    nb: 'Tillatelser',
  },
  Permissions: {
    en: 'Permissions',
    nb: 'Tillatelser',
  },
  Chooseastartdate: {
    en: 'Choose a start date',
    nb: 'Velg en startdato',
  },
  Chooseanenddate: {
    en: 'Choose an end date',
    nb: 'Velg en sluttdato',
  },
  Assignrolestotheuser: {
    en: 'Assign role(s) to the user',
    nb: 'Gi brukeren rolle(r)',
  },
  Sendinvitationbyemail: {
    en: 'Send invitation by email',
    nb: 'Send invitasjon på e-post',
  },
  Doyouwanttoremovetheuser: {
    en: 'Do you want to remove the user?',
    nb: 'Vil du fjerne brukeren?',
  },
  Ifyousavetheuserwithoutro: {
    en: 'If you save the user without roles - user will be hidden from the list',
    nb: 'Hvis du lagrer brukeren uten roller - blir brukeren skjult fra listen',
  },
  Usernotcreated: {
    en: 'User not created',
    nb: 'Bruker ikke opprettet',
  },
  Cannotcreateauserwithoutr: {
    en: 'Cannot create a user without roles',
    nb: 'Kan ikke opprette en bruker uten roller',
  },
  Permissionsforrole: {
    en: 'Permissions for role',
    nb: 'Tilganger for rolle',
  },
  '2FAActivated': {
    en: '2FA is activated on your account',
    nb: '2FA er aktivert på kontoen din',
  },
  No2FATooltip: {
    en: 'It is recommended to enable two-factor authentication in the settings for increased security.',
    nb: 'Det anbefales å aktivere to-faktor autentisering i innstillingene for økt sikkerhet.',
  },
  No2FA: {
    en: 'No 2FA',
    nb: 'Ingen 2FA',
  },
  SendEmailOnEdit: {
    en: 'Send email?',
    nb: 'Send e-post?',
  },
  Removelogo: {
    en: 'Remove logo?',
    nb: 'Fjern logo?',
  },
  UseBrregdatatoaddboardmem: {
    en: 'Use Brreg data to add board members',
    nb: 'Bruk Brreg-data for å legge til styremedlemmer',
  },
  Groupname: {
    en: 'Group name',
    nb: 'Gruppenavn',
  },
  Anadministratorcancreateo: {
    en: "An administrator can create one or more subgroups for different types of groups or committees, such as a management group, project group, or nomination committee. The subgroup will have a setup similar to the workspace the board has access to, including the meeting module, data room, messages, and so on. Only the participants in a subgroup will have access to the group's information and activities. If, for example, the CEO needs access, they must be invited as a participant in the group.",
    nb: 'Her kan du som administrator opprette en eller flere undergrupper for ulike typer grupper eller komiteer, slik som for en ledergruppe, prosjektgruppe eller valgkomité. Undergruppen får et oppsett tilsvarende det arbeidsområdet som styret har tilgang til, med møtemodul, datarom, meldinger og så videre. Kun deltakerne i en undergruppe vil ha innsyn til gruppens informasjon og aktiviteter. Dersom for eksempel daglig leder skal ha innsyn, må vedkommende inviteres inn som deltaker i gruppen.',
  },
  Subgroupfor: {
    en: 'Subgroup for',
    nb: 'Undergruppe for',
  },
  Cannotdeletealladmins: {
    en: 'Cannot delete all admins',
    nb: 'Kan ikke slette alle administratorer',
  },
  Ifyouleavethispageyourcha: {
    en: 'If you leave this page, your changes will be lost.',
    nb: 'Hvis du forlater denne siden, vil endringene gå tapt.',
  },
  Youhaveunsavedchanges: {
    en: 'You have unsaved changes',
    nb: 'Du har ulagrede endringer',
  },
  Doyouwanttodeletetheorgan: {
    en: "Do you want to delete the organization? This can't be reversed.",
    nb: 'Ønsker du å slette organisasjonen? Dette kan ikke angres.',
  },
  Reports: {
    en: 'Reports',
    nb: 'Rapporter',
  },
  Pleaseuseavalidorganizati: {
    en: 'Please use a valid organization number',
    nb: 'Bruk et gyldig organisasjonsnummer',
  },
  Latestnews: {
    en: 'Latest news',
    nb: 'Siste nyheter',
  },
  Protecttheboardandmanagem: {
    en: 'Protect the board and management',
    nb: 'Beskytt styret og ledelsen',
  },
  Boardliabilityinsuranceis: {
    en: 'Board liability insurance is a valuable investment for any business that wants a strong and competent board. This insurance provides security and protection against legal consequences that may arise in the performance of board and management duties.',
    nb: 'En styreansvarsforsikring er en verdifull investering for enhver virksomhet som ønsker et sterkt og kompetent styre. Denne forsikringen gir trygghet og beskyttelse mot juridiske konsekvenser som kan oppstå i utførelsen av styre- og ledelsesoppgaver.',
  },
  Asauseroftheboardportalfr: {
    en: 'As a user of the board portal from Orgbrain, you get easier and more affordable access to board liability insurance through Tryg Forsikring. We have negotiated favorable prices that are exclusive to our customers.',
    nb: 'Som bruker av styreportalen fra Orgbrain, får du enklere og rimeligere tilgang til styreansvarsforsikring gjennom Tryg Forsikring. Vi har forhandlet frem gunstige priser som er eksklusivt for våre kunder.',
  },
  Anexampleofanegotiatedpri: {
    en: 'An example of a negotiated price is*:',
    nb: 'Eksempel på pris som er forhandlet frem er*:',
  },
  InsuranceamountNOKmillion: {
    en: 'Insurance amount NOK 10 million.',
    nb: 'Forsikringssum kr 10 mill.',
  },
  Housingcompanies: {
    en: 'Housing companies',
    nb: 'Boligselskaper',
  },
  Servicestradeadvice: {
    en: 'Services/trade/advice',
    nb: 'Tjenester/handel/rådgivning',
  },
  Artisanandproductionactiv: {
    en: 'Artisan and production activities',
    nb: 'Håndverker- og produksjonsvirksomhet',
  },
  Appliestobusinesseswithat: {
    en: "*') Applies to businesses with a turnover of up to NOK 50 million. The final premium is calculated by Tryg based on the company's operations and financial position.",
    nb: '*‘) Gjelder for virksomheter med en omsetning på inntil 50 millioner kroner. Endelig premie blir beregnet av Tryg ut fra selskapets virksomhet og økonomiske stilling.',
  },
  Theinsurancecoversallmemb: {
    en: 'The insurance covers all members of the board, the general manager and employees in senior positions. It is also possible to take out insurance that includes board responsibility for several group companies, other types of companies and different business sizes. Tryg is also happy to make offers on other insurances if desired.',
    nb: 'Forsikringen dekker alle medlemmer av styret, daglig leder og ansatte i ledende stillinger. Det er også mulig å tegne en forsikring som inkluderer styreansvar for flere konsernselskaper, andre typer selskaper og ulike virksomhetsstørrelser. Tryg gir også gjerne tilbud på andre forsikringer hvis det er ønskelig.',
  },
  Fillinthefieldsbelowandcl: {
    en: "Fill in the fields below and click on the button below to be contacted by Tryg regarding offers for directors' liability insurance.",
    nb: 'Fyll ut feltene under og klikk på knappen under for å bli kontaktet av Tryg vedrørende tilbud på styreansvarsforsikring.',
  },
  Choosewhichcompanyyouprim: {
    en: 'Choose which company you primarily want offers for:',
    nb: 'Velg hvilket selskap du primært ønsker tilbud på:',
  },
  Phone: {
    en: 'Phone',
    nb: 'Telefon',
  },
  Getaquotefordirectorsliab: {
    en: "Get a quote for directors' liability insurance",
    nb: 'Få tilbud på styreansvarsforsikring',
  },
  Yourinquiryhasbeenregiste: {
    en: 'Your inquiry has been registered',
    nb: 'Din henvendelse er registrert',
  },
  YouwillbecontactedbyTrygF: {
    en: 'You will be contacted by Tryg Forsikring regarding the offer of liability insurance',
    nb: 'Du vil bli kontaktet av Tryg Forsikring vedrørende tilby på ansvarsforsikring',
  },
  Onlyorganizationswithpaid: {
    en: 'Only organizations with paid subscriptions and users with administrator rights can submit insurance requests.',
    nb: 'Kun virksomheter med betalende abonnement og brukere med administratorrettigheter kan sende inn forespørsel om forsikring.',
  },
  OnlyforOrgbraincustomersG: {
    en: 'Only for Orgbrain customers: Get access to exclusive board liability insurance through Tryg. Now even smaller businesses can insure themselves.',
    nb: 'Bare for Orgbrain-kunder: Få tilgang til eksklusiv styreansvarsforsikring gjennom Tryg. Nå kan selv mindre foretak forsikre seg.',
  },
  Getmyoffer: {
    en: 'Get my offer…',
    nb: 'Få mitt tilbud…',
  },
  Youcurrentlyhavenomeeting: {
    en: 'You currently have no meetings. Meetings you are invited to will appear here',
    nb: 'Du har foreløpig ingen møter. Møter du er invitert til vil legge seg her',
  },
  emptyKeyEng: {
    en: '',
    nb: '.',
  },
  Youcurrentlyhavenonotific: {
    en: 'You currently have no notifications. Your notifications will appear here.',
    nb: 'Du har foreløpig ingen varsler. Dine varsler vil legge seg her',
  },
  Notifications: {
    en: 'Notifications',
    nb: 'Varsler',
  },
  Signatures: {
    en: 'Signatures',
    nb: 'Signeringer',
  },

  YoucurrentlyhavenotasksTa: {
    en: 'You currently have no tasks. Tasks you have to perform will appear here',
    nb: 'Du har foreløpig ingen oppgaver. Oppgaver du skal utføre vil legge seg her',
  },
  GetstartedwithOrgbrain: {
    en: 'Get started with Orgbrain',
    nb: 'Kom i gang med Orgbrain',
  },
  Wanttolearnmore: {
    en: 'Want to learn more?',
    nb: 'Ønsker du å lære mer?',
  },
  Visitoursupportpages: {
    en: 'Visit our support pages',
    nb: 'Gå til våre supportsider',
  },
  ForAdministrators: {
    en: 'For Administrators',
    nb: 'For deg som er administrator',
  },
  ForBoardMembers: {
    en: 'For Board Members',
    nb: 'For deg som er styremedlem',
  },
  ForShareholdersMembers: {
    en: 'For Shareholders/Members',
    nb: 'For deg som er aksjonær/medlem',
  },
  Customizewhatisdisplayedo: {
    en: 'Customize what is displayed on your dashboard.',
    nb: 'Her kan du tilpasse hva som skal vises på dashbordet ditt.',
  },
  'shareholders.EditButton': {
    en: 'Edit',
    nb: 'Endre',
    sv: 'Redigera',
  },
  EditToggle: {
    en: 'Edit',
    nb: 'Endre',
    sv: 'Redigera',
  },

  Security: {
    en: 'Security',
    nb: 'Sikkerhet',
  },
  off: {
    en: 'off',
    nb: 'av',
  },
  on: {
    en: 'on',
    nb: 'på',
  },

  Off: {
    en: 'Off',
    nb: 'Av',
  },
  On: {
    en: 'On',
    nb: 'På',
  },
  Doyouwanttounpublishyourp: {
    en: 'Do you want to unpublish your profile?',
    nb: 'Ønsker du å avpublisere din profil?',
  },
  Youareabouttounpublishyou: {
    en: 'You are about to unpublish your profile. This means that no one will have access to your profile or other information about you, including any organizations you have established a dialogue with.',
    nb: 'Du er i ferd med å avpublisere din profil. Dette betyr at ingen lenger vil ha tilgang til profilen din eller andre opplysninger om deg, inkludert eventuelle virksomheter du har opprettet en dialog med.',
  },
  Timeproposition: {
    en: 'Time proposition',
    nb: 'Tidsforslag',
  },
  Hereasanadministratoryouc: {
    en: 'Here, as an administrator, you can invite meeting participants to vote on alternative meeting times. First enter the meeting times that you want the participants to vote on. Then invite the participants to give their feedback. You can cast your vote, and see the results from the other participants, by going to cast votes. There you can also choose the time that suits you best based on the feedback that has been received.',
    nb: 'Her kan du som administrator invitere møtedeltakerne til å stemme over alternative møtetidspunkter. Legg først inn de møtetidspunktene som du ønsker at deltakerne skal stemme over. Inviter så deltakerne til å gi sin tilbakemelding. Du kan gi din stemme, og se resultatet fra de andre deltakerne, ved å gå til avgitte stemmer. Der kan du også velge det tidspunkt som passer best basert på de tilbakemeldingene som er kommet inn.',
  },
  Option: {
    en: 'Option',
    nb: 'Alternativ',
  },
  Sortchronologically: {
    en: 'Sort chronologically',
    nb: 'Sorter kronologisk',
  },
  Hereyouaddanewtimeoption: {
    en: 'Here you add a new time option',
    nb: 'Her legger du til et nytt tidsforslag',
  },
  NewTimeProposal: {
    en: 'New time proposal',
    nb: 'Nytt tidsforslag',
  },
  Backtomeeting: {
    en: 'Back to meeting',
    nb: 'Tilbake til møtet',
  },
  Fromalistyoucanhereinvite: {
    en: 'From a list, you can here invite those you want to give feedback on the options for a meeting time',
    nb: 'Fra en liste, kan du her invitere de som du ønsker skal gi tilbakemelding på forslagene til møtetidspunkt',
  },
  InviteToVote: {
    en: 'Invite to vote',
    nb: 'Inviter til avstemning',
  },
  Hereyoucanseewhohasvoteda: {
    en: 'Here you can see who has voted and select desired meeting time',
    nb: 'Her kan du se de som har stemt og velge ønsket møtetidspunkt',
  },

  Invitetofindameetingtime: {
    en: 'Invite to find a meeting time',
    nb: 'Inviter til å finne møtetidspunkt',
  },
  Thistextwillautomatically: {
    en: 'This text will automatically be included in the email that the invitees receive',
    nb: 'Denne teksten vil automatisk komme med i e-posten som de inviterte mottar',
  },
  Noendtime: {
    en: 'No end time',
    nb: 'Ingen sluttid',
  },
  Customendtime: {
    en: 'Custom end time',
    nb: 'Egendefinert sluttid',
  },
  Total: {
    en: 'Total',
    nb: 'Totalt',
  },
  Whattimedidyouagree: {
    en: 'What time did you agree?',
    nb: 'Hvilket tidspunkt ble dere enige om?',
  },
  Hereyoucangobacktochanget: {
    en: 'Here you can go back to change the time options that can be voted on or to send a new invitation',
    nb: 'Her kan du gå tilbake for å endre på tidsforslagene som det kan stemmes over eller eller for å sende ny invitasjon',
  },
  Backtoediting: {
    en: 'Back to editing',
    nb: 'Tilbake til redigering',
  },
  Hereyouupdatethemeetingwi: {
    en: 'Here you update the meeting with the time marked in the table',
    nb: 'Her oppdaterer du møtet med det tidspunkt som er markert i tabellen',
  },
  Setthemeetingtime: {
    en: 'Set the meeting time',
    nb: 'Sett møtetidspunkt',
  },
  Prefer: {
    en: 'Prefer',
    nb: 'Foretrekker',
  },
  Ican: {
    en: 'I can',
    nb: 'Kan',
  },

  Choose: {
    en: 'Choose',
    nb: 'Velg',
  },
  Thismeetinghasbeendeleted: {
    en: 'This meeting has been deleted',
    nb: 'Dette møtet er slettet',
  },
  Hereproposalsfortheannual: {
    en: 'Here, proposals for the annual plan will be made based on the board meetings that have taken place over the past 12 months. The meetings are scheduled on the same day of the week as the previous year, adjusted for any official holidays.',
    nb: 'Her vil det bli laget forslag til årsplan basert på styremøtene som har vært de siste 12 måneder.  Møtene blir lagt på samme ukedag som året før, justert for eventuelle offisielle fridager.',
  },
  Basedonpreviousmeetings: {
    en: 'Based on previous meetings',
    nb: 'Basert på tidligere møter',
  },
  Basedon: {
    en: 'Based on',
    nb: 'Basert på',
  },
  meetingsinthelastmonths: {
    en: 'meetings in the last 12 months',
    nb: 'møter siste 12 måneder',
  },
  Hereyouwillhavetheopportu: {
    en: 'Here you will have the opportunity to make adjustments, such as changing, removing or adding new text in addition to the fields you have already filled in. Best suited for minor adjustments at the end.',
    nb: 'Her vil du få ha mulighet til å gjøre justeringer, slik som å endre, fjerne eller legge til ny tekst utover de feltene du allerede har fylt inn. Best egnet for å gjøre mindre justeringer til slutt.',
  },
  Completelynewannualplan: {
    en: 'Completely new annual plan',
    nb: 'Helt ny årsplan',
  },
  BasedonOrgbrainsuggestion: {
    en: 'Based on Orgbrain suggestion',
    nb: 'Basert på forslag fra Orgbrain',
  },
  Inanannualplanyoucansched: {
    en: 'In an annual plan, you can schedule meetings for the next 12 months.',
    nb: 'I en årsplan kan du planlegge møter for de neste 12 månedene.',
  },
  Thisallowsyoutoefficientl: {
    en: 'This allows you to efficiently cover the key agenda items for the upcoming year.',
    nb: 'Slik kan du raskt dekke de viktigste sakspunktene for det neste året.',
  },
  Shownewmeetingplan: {
    en: 'Show new meeting plan',
    nb: 'Vis ny møteplan',
  },
  Missingvotefromyou: {
    en: 'Missing vote from you',
    nb: 'Mangler stemme fra deg',
  },
  Theproposalwasadopted: {
    en: 'The proposal was adopted',
    nb: 'Forslaget ble vedtatt',
  },
  Theproposalwasrejected: {
    en: 'The proposal was rejected',
    nb: 'Forslaget ble nedstemt',
  },
  Electionshavebeencomplete: {
    en: 'Elections have been completed',
    nb: 'Valg er gjennomført',
  },
  Electionswerenotcompleted: {
    en: 'Elections were not completed',
    nb: 'Valg ble ikke fullført',
  },
  Selectionhasbeencompleted: {
    en: 'Selection has been completed',
    nb: 'Valg er gjennomført',
  },
  Selectionhasnotbeencomple: {
    en: 'Selection has not been completed',
    nb: 'Valg ble ikke fullført',
  },
  Notopenforvoting: {
    en: 'Not open for voting',
    nb: 'Ikke åpnet for avstemning',
  },
  Deletecomment: {
    en: 'Delete comment?',
    nb: 'Slett kommentar',
  },
  Analternativeneedsamajori: {
    en: 'An alternative needs a majority of the votes cast to be approved',
    nb: 'Et alternativ krever flertall av de avgitte stemmene for å bli vedtatt',
  },
  Startingindex: {
    en: 'Starting index',
    nb: 'Startindeks',
  },
  StartingIndexExplanation: {
    en: 'The starting index is the number of the first agenda item in the meeting for the year. This is used to ensure that the agenda items are numbered consecutively. Change it below.',
    nb: 'Startindeksen er nummeret på det første agendapunktet i møtet for dette året. Dette brukes for å sikre at agendapunktene er nummerert konsekvent. Du kan endre det under.',
  },
  Responsiblefortheagendait: {
    en: 'Responsible for the agenda item',
    nb: 'Ansvarlig for agendapunktet',
  },
  Enterthetextfortheagendai: {
    en: 'Enter the text for the agenda item. This will be included in the meeting invitation',
    nb: 'Her skriver du inn tekst til agendapunktet som skal med i innkallingen til møtet.',
  },
  Hereyouenteraproposalfora: {
    en: 'Here you enter a proposal for a decision that will appear in the notice of the meeting. This text will also appear in the draft minutes.',
    nb: 'Her skriver du inn forslag til vedtak som kommer med i innkallingen til møtet. Denne teksten vil også vises i utkast til protokoll.',
  },
  Responsibleforitem: {
    en: 'Responsible for item',
    nb: 'Saksansvarlig',
  },
  Hereyouenterthetextthatwi: {
    en: 'Here you enter the text that will be included in the minutes of the meeting.',
    nb: 'Her legger du inn teksten til dette agendapunktet som skal inn i protokollen fra møtet.',
  },
  Deleteagendaitem: {
    en: 'Delete agenda item',
    nb: 'Slett dette agendapunktet',
  },
  Cloneagendaitem: {
    en: 'Clone agenda item',
    nb: 'Klone agendapunktet',
  },
  Addtolibrary: {
    en: 'Add to library',
    nb: 'Legg til bibliotek',
  },
  Downloadagendaitem: {
    en: 'Download agenda item',
    nb: 'Last ned agendapunkt',
  },
  Votingrights: {
    en: 'Voting rights',
    nb: 'Stemmerett',
  },
  Hidefrompublicminutes: {
    en: 'Hide from public minutes',
    nb: 'Skjul i offentlig protokoll',
  },
  Removenumbering: {
    en: 'Remove numbering',
    nb: 'Fjern agendanummer',
  },
  Setasadraft: {
    en: 'Set as a draft',
    nb: 'Sett som utkast',
  },
  AddComments: {
    en: 'Add Comments',
    nb: 'Kommentarer',
  },
  meetingIsNotActive: {
    en: 'Meeting is not active yet',
    nb: 'Møtet er ikke startet enda',
  },
  Openspeakerlist: {
    en: 'Open Speaker List',
    nb: 'Åpne talerliste',
  },
  CloseSpeakerList: {
    en: 'Close Speaker List',
    nb: 'Lukk talerliste',
  },
  SpeakerList: {
    en: 'Speaker List',
    nb: 'Talerliste',
  },
  SpeakerListTooltip: {
    en: 'Manage Speaker List',
    nb: 'Administrer talerlisten',
  },
  Agendainfo: {
    en: 'Agenda info',
    nb: 'Agendainfo',
  },
  Editvotes: {
    en: 'Edit votes',
    nb: 'Rediger stemmer',
  },
  Voteresult: {
    en: 'Vote result',
    nb: 'Stemmeresultat',
  },

  Estimatedtimemin: {
    en: 'Estimated time (min)',
    nb: 'Beregnet tid (min)',
  },
  Acopyoftheagendaitemwillb: {
    en: 'A copy of the agenda item will be entered as a permanent item in the agenda library.',
    nb: 'Kopi av agendapunkt vil legge seg inn som fast punkt i  agendabiblioteket',
  },
  Theagendaitemwillbedownlo: {
    en: 'The agenda item will be downloaded as a file and can be added to the agenda of another meeting by drag and drop.',
    nb: 'Agendapunktet vil bli lastet ned som fil slik at agendapunktet ved drag&drop kan legges inn i agendaen på et annet møte',
  },
  Thisagendaitemwillnotappe: {
    en: 'This agenda item will not appear in the minutes',
    nb: 'Dette agendapunktet vil ikke vises i protokollen',
  },
  Onlytheadministratorswill: {
    en: 'Only the administrators will see the agenda item',
    nb: 'Kun administratorer vil se agendapunktet',
  },
  Putmeonthespeakerlist: {
    en: 'Put me on the speaker list',
    nb: 'Sett meg på talerliste',
  },
  Removemefromspeakerlist: {
    en: 'Remove me from speaker list',
    nb: 'Fjern meg fra talerliste',
  },
  Participantswillbeabletoa: {
    en: 'Participants will be able to add private or public comments/notes to the agenda item',
    nb: 'Deltakerne vil kunne legge inn private eller offentlige kommentarer/notater til agendapunktet',
  },
  Hereyoucanadjustthepartic: {
    en: 'Here you can adjust the participants for this agenda item, for example in case of disqualification.',
    nb: 'Her kan du justere deltakerne for dette agendapunktet, for eksempel ved inhabilitet.',
  },
  Changeparticipants: {
    en: 'Change participants',
    nb: 'Endre deltakere',
  },
  Youareabouttochangewhopar: {
    en: 'You are about to change who participates in processing this agenda item. Do you want to continue?',
    nb: 'Du er i ferd med å endre hvem som deltar i behandlingen av denne saken. Vil du fortsette?',
  },
  Errorsavingstatus: {
    en: 'Error saving status',
    nb: 'Feil ved lagring av status',
  },
  Totalagendaitemsduratione: {
    en: 'Total agenda items duration exceed the meeting time',
    nb: 'Samlet varighet på agendapunkter overskrider møtetiden',
  },
  Failedtorenamethefile: {
    en: 'Failed to rename the file',
    nb: 'Kunne ikke gi nytt navn til filen',
  },
  Agendaitemwillbeaddedtoth: {
    en: 'Agenda item will be added to the end of the list',
    nb: 'Agendapunkt vil bli lagt til på slutten av listen',
  },
  AddedtoAgendaSuggestions: {
    en: 'Added to Agenda Suggestions',
    nb: 'Lagt til agendaforslag',
  },

  Enrolled: {
    en: 'Enrolled',
    nb: 'Påmeldt',
  },
  Speakerlistisempty: {
    en: 'No one has signed up on the speaker list.',
    nb: 'Ingen har satt seg opp på talerlisten.',
  },
  SpeakerlistIsClosed: {
    en: 'Speaker list is closed.',
    nb: 'Talerlisten er lukket.',
  },
  Pleaseconfirmdeleting: {
    en: 'Please confirm deleting',
    nb: 'Bekreft sletting',
  },
  Cannotbeundone: {
    en: 'Cannot be undone',
    nb: 'Kan ikke angres',
  },
  Thisiconopenstheagendalib: {
    en: 'This icon opens the agenda library and allows you to change the order of the agenda items. To edit fields in an agenda item, click directly on the text',
    nb: 'Denne knappen åpner agendabiblioteket og gir mulighet til å endre rekkefølgen på agendapunktene. For å redigere felter i et agendapunkt, klikk direkte på teksten',
  },
  Ifyouwanttoaddacommentorr: {
    en: 'If you want to add a comment or remark in the minutes, you can do so here. The text ends up at the end of the protocol.',
    nb: 'Dersom du ønsker å legge inn en kommentar eller bemerkning i protokollen kan du gjøre det her. Teksten legger seg nederst i protokollen.',
  },
  Clickheretoedit: {
    en: 'Click to edit',
    nb: 'Klikk for å redigere',
  },
  Theelectedshallsignthemin: {
    en: 'The elected shall sign the minutes',
    nb: 'Den/de som velges skal signere protokollen',
  },
  Maximumoptions: {
    en: 'Maximum options',
    nb: 'Maximum alternativer',
  },
  Selectagendasuggestiontop: {
    en: 'Select agenda suggestion topics',
    nb: 'Velg tema for agendapunktet',
  },
  Whileyoueditthecontenthas: {
    en: 'While you edit, the content has been changed. Please refresh the page to see the updated content.',
    nb: 'Mens du redigerer, er innholdet endret. Oppdater siden for å se det oppdaterte innholdet.',
  },
  Wheel: {
    en: 'Wheel',
    nb: 'Årshjul',
  },
  Reviewdeadline: {
    en: 'Review deadline',
    nb: 'Høringsfrist',
  },
  Notificationofcanceledmee: {
    en: 'Notification of canceled meeting',
    nb: 'Melding om avlyst møte',
  },
  Writeanemail: {
    en: 'Write an email',
    nb: 'Skriv en e-postmelding',
  },
  Sendupdate: {
    en: 'Send update',
    nb: 'Send oppdatering',
  },
  Incaseofanequalnumberofvo: {
    en: 'In case of an equal number of votes, the decision is automatically made by the system through an embedded lottery.',
    nb: 'Ved likt antall stemmer blir avgjørelsen automatisk tatt av systemet gjennom en innebygd loddtrekning.',
  },
  Moveup: {
    en: 'Move up',
    nb: 'Flytte opp',
  },
  Movedown: {
    en: 'Move down',
    nb: 'Flytte ned',
  },
  Information: {
    en: 'Information',
    nb: 'Informasjon',
  },
  ThiswillrenameafileintheA: {
    en: 'This will rename a file in the Attachments folder',
    nb: 'Dette vil gi nytt navn til en fil i vedleggsmappen',
  },
  Pleaseconfirmtoproceed: {
    en: 'Please confirm to proceed.',
    nb: 'Bekreft for å fortsette.',
  },
  ConfirmDialogDefaultText: {
    en: 'Press "Continue" to proceed.',
    nb: 'Trykk "Fortsett" for å fullføre.',
  },
  'meetings.Invited': {
    en: 'Invited',
    nb: 'Inviterte',
  },
  Sum: {
    en: 'Sum',
    nb: 'Sum',
  },
  AttendanceText: {
    en: 'Participates',
    nb: 'Deltar',
  },
  Physicalattendance: {
    en: 'Physical attendance',
    nb: 'Fysisk oppmøte',
  },
  Digitalattendance: {
    en: 'Digital attendance',
    nb: 'Digitalt oppmøte',
  },
  WillSelectedInvestorsAttend1: {
    en: 'Will ',
    nb: 'Skal ',
  },
  WillSelectedInvestorsAttend2: {
    en: ' attend?',
    nb: ' delta?',
  },
  Notinvited: {
    en: 'Not invited',
    nb: 'Ikke invitert',
  },
  Everybodyisalreadyinvited: {
    en: 'Everybody is already invited',
    nb: 'Alle er allerede invitert',
  },
  read: {
    en: 'read',
    nb: 'lest',
  },
  isDigitalAttendance: {
    en: 'User is attending digitally',
    nb: 'Brukeren deltar digitalt',
  },
  Thisindicatormeasureshowm: {
    en: 'This indicator measures how many agenda items and attachments the user has opened. If a participant opens a meeting book created by Orgbrain, it counts as 100%.',
    nb: 'Denne indikatoren måler hvor mange agendapunkter og vedlegg brukeren har åpnet. Om en deltaker åpner en møtebok laget av orgbrain telles det som 100%.',
  },
  Youmaywanttoreadthis: {
    en: 'Information that has not been opened',
    nb: 'Informasjon som ikke har blitt åpnet',
  },
  Notallinvitationsweresent: {
    en: 'Not all invitations were sent',
    nb: 'Ikke alle invitasjoner ble sendt',
  },
  Missingcontactdatafor: {
    en: 'Missing contact data for',
    nb: 'Mangler kontaktdata for',
  },
  Couldnotinvitemembers: {
    en: 'Could not invite members.',
    nb: 'Kunne ikke invitere medlemmene.',
  },
  Notifyofupdates: {
    en: 'Notify of updates',
    nb: 'Informer om oppdatering',
  },
  Meetingupdated: {
    en: 'Meeting updated',
    nb: 'Møte oppdatert',
  },
  Thismeetingisnowcalledand: {
    en: 'This meeting is now called and your invited members are able to respond to your invitation.',
    nb: 'Dette møtet er nå innkalt, og de inviterte har mulighet til å svare på din invitasjon.',
  },
  Invitedmemberslistisupdat: {
    en: 'Invited members list is updated, and your invited members are able to respond to your invitation.',
    nb: 'Inviterte medlemmer er oppdatert, og de inviterte har mulighet til å svare på din invitasjon.',
  },
  Invitationsupdated: {
    en: 'Invitations updated',
    nb: 'Invitasjoner oppdatert',
  },
  Continueanyway: {
    en: 'Continue anyway?',
    nb: 'Fortsett likevel?',
  },
  CouldNotFindMeeting: {
    en: 'Could not find the meeting',
    nb: 'Kunne ikke finne dette møtet',
  },
  MeetingInInThePast: {
    en: 'Do you really want to invite to a meeting date that has passed?',
    nb: 'Ønsker du virkelig å invitere til en møtedato som har passert?',
  },
  MeetingWithoutAgendaItems: {
    en: 'Do you really want to invite to a meeting without any agenda items?',
    nb: 'Vil du virkelig invitere til et møte uten noen agendapunkter?',
  },
  NoCandidatesInElectionWarning: {
    en: 'Do you want to invite to a meeting with an election without any candidates to chose from?',
    nb: 'Vil du invitere til et møte med personvalg uten noen kandidater å velge mellom?',
  },
  DurationOfAgendaItemIsLongerThanMeeting: {
    en: 'The total duration of the agenda items is longer than the time set for the meeting.',
    nb: 'Agendapunktenes samlede varighet er lengre enn tiden som er satt opp på møtet.',
  },
  AgendaDurationWarning: {
    en: 'The total duration of the agenda items is longer than the specified meeting time.',
    nb: 'Agendapunktenes samlede varighet er lenger enn den angitte møtetiden.',
  },
  ThereisnoChairoftheBoardi: {
    en: 'There is no Chair of the Board in ',
    nb: 'Det er ingen styreleder i ',
  },
  PickTimeSlot: {
    en: 'Choose final meeting date',
    nb: 'Velg endelig møtetidspunkt',
  },
  ConfirmTimeSlotSelection: {
    nb: 'Avslutt avstemning for møtetidspunkt?',
    en: 'End voting for meeting time?',
  },
  ConfirmTimeSlotSelectionMessage1: {
    en: 'Are you sure you want to update the meeting date to ',
    nb: 'Er du sikker på at du ønsker å oppdatere tidspunktet på møtet til ',
  },
  ConfirmTimeSlotSelectionMessage2: {
    en: '? This will end the voting for the meeting time.',
    nb: '? Dette vil avslutte avstemningen for møtetidspunktet.',
  },

  NotInvitedToFindTime: {
    nb: 'Administrator har ikke invitert deg til avstemningen om møtetidspunkt.',
    en: 'Administrator has not invited you to the vote on meeting date.',
  },
  NoChairWarning: {
    en: 'There is no Chair of the Board',
    nb: 'Det er ingen styreleder',
  },
  Searchmeetings: {
    en: 'Search meetings',
    nb: 'Søk møter',
  },
  Nomeetingstodisplayforthi: {
    en: 'No meetings to display for this time period',
    nb: 'Du har ingen møter i denne tidsperioden',
  },
  Agendaitemslog: {
    en: 'Agenda items log',
    nb: 'Agendapunktlogg',
  },
  Loadedat: {
    en: 'Loaded at',
    nb: 'Lastet kl',
  },
  Agendaitem: {
    en: 'Agenda item',
    nb: 'Agendapunkt',
  },
  Field: {
    en: 'Field',
    nb: 'Felt',
  },
  Oldvalue: {
    en: 'Old value',
    nb: 'Gammel verdi',
  },
  Newvalue: {
    en: 'New value',
    nb: 'Ny verdi',
  },
  Decisionnotes: {
    en: 'Decision notes',
    nb: 'Vedtakstekst',
  },
  ConfirmPDF: {
    en: 'Confirm PDF',
    nb: 'Bekreft PDF',
  },

  NoResponsible: {
    en: 'No responsible',
    nb: 'Ingen ansvarlig',
  },
  NoDurationAgendaItem: {
    en: 'Select duration',
    nb: 'Velg varighet',
  },
  NoCandidatesForElection: {
    nb: 'Avstemningen har ingen valg',
    en: 'There are no options for the vote',
  },
  AdminVoteSettings: {
    nb: 'Administrer stemmer',
    en: 'Administrate votes',
  },
  Agendaitemdeleted: {
    en: 'Agenda item deleted',
    nb: 'Agendapunkt slettet',
  },
  Powerofattorney: {
    en: 'Power of attorney',
    nb: 'Fullmakt',
  },
  Anadministratorwhoregiste: {
    en: 'An administrator who registers on behalf of others, signs to have received a  power of attorney.',
    nb: 'En administrator som registrerer på vegne av andre, signerer på mottak av fullmakt.',
  },
  Confirmproxy: {
    en: 'Confirm proxy',
    nb: 'Bekreft fullmakt',
  },
  Ifproxyhasbeenreceivedout: {
    en: 'If proxy has been received outside the Orgbrain system, you can upload the document here',
    nb: 'Om fullmakt er mottatt utenfor Orgbrain-systemet kan du laste den opp her',
  },
  UnreadAgendaItem: {
    nb: 'Ulest innhold på agendapunkt',
    en: 'Unread content on agenda item',
  },
  Uploadproxy: {
    en: 'Upload proxy',
    nb: 'Last opp fullmakt',
  },
  ProxyAdded: {
    en: 'Proxy has been successfully added',
    nb: 'Fullmakt er gitt',
  },
  ProxyAddedText: {
    en: 'You have now added a proxy. This can be revoked by changing the status to one of the other options.',
    nb: 'Du har nå gitt fullmakt. Denne kan trekkes tilbake ved å endre statusen til et av de andre alternativene.',
  },
  PowerOfAttorneyNotice1: {
    en: ' have registered that you have been granted the power of attorney to represent ',
    nb: ' har registrert at du er blitt tildelt fullmakt til å representere ',
  },
  PowerOfAttorneyNotice2: {
    en: ' at .',
    nb: ' på .',
  },
  PowerOfAttorneyNotice3: {
    en: ' in .',
    nb: ' i .',
  },
  COPYOFPROXYGIVENTO: {
    en: 'COPY OF PROXY GIVEN TO',
    nb: 'KOPI AV FULLMAKT GITT TIL',
  },
  Attendancehistory: {
    en: 'Attendance history',
    nb: 'Fremmøtehistorikk',
  },
  Type: {
    en: 'Type',
    nb: 'Type',
    sv: 'Typ',
  },
  Invitation: {
    en: 'Invitation',
    nb: 'Invitasjon',
  },
  Prevoting: {
    en: 'Pre-voting',
    nb: 'Forhåndsstemme',
  },
  Clicktochangestatus: {
    en: 'Click to change status',
    nb: 'Klikk for å endre status',
  },
  Iattended: {
    en: 'I attended',
    nb: 'Jeg deltok',
  },
  Ididnotattend: {
    en: 'I did not attend',
    nb: 'Jeg deltok ikke',
  },
  Youparticipateasarepresen: {
    en: 'You have received power of attorney.',
    nb: 'Dine fullmakter',
  },
  Youhaveassignedaproxy: {
    en: 'You have assigned a proxy',
    nb: 'Du har gitt fullmakt for',
  },
  Noresponseyet: {
    en: 'No response yet',
    nb: 'Ingen svar ennå',
  },
  with: {
    en: 'with',
    nb: 'med',
  },
  atotalof: {
    en: 'a total of',
    nb: 'totalt',
  },
  Statuswillbesetto: {
    en: 'Status will be set to',
    nb: 'Status blir satt til',
  },
  for: {
    en: 'for',
    nb: 'for',
  },
  'meetings.Pleaseconfirmthefollowing': {
    en: 'Please confirm the following attending status',
    nb: 'Bekreft følgende deltakerstatus',
  },
  allInvited: {
    en: 'All invited',
    nb: 'Alle inviterte',
  },
  Withdrawproxy: {
    en: 'Withdraw proxy',
    nb: 'Trekk fullmakt',
  },

  Hereyoucancelameetinguser: {
    en: 'Here you cancel a meeting users have been invited to.',
    nb: 'Her avlyser du et møte brukere er blitt invitert til.',
  },
  Cancelmeeting: {
    en: 'Cancel meeting',
    nb: 'Avlys møtet',
  },

  Usethismeetingasatemplate: {
    en: 'Use this meeting as a template for a new meeting. It is the agenda items that are copied.',
    nb: 'Bruk dette møtet som mal for et nytt møte. Det som blir kopiert over er agendapunktene.',
  },
  Themeetingispermanentlyde: {
    en: 'The meeting is permanently deleted, so this function must only be used if the meeting is no longer relevant.',
    nb: 'Møtet slettes permanent, så denne funksjonen må bare brukes dersom møtet ikke lenger er relevant.',
  },
  Showanoverviewofwhohasatt: {
    en: 'Show an overview of who has attended the meeting.',
    nb: 'Vis en oversikt over hvem som har deltatt på møtet.',
  },
  Showattendancehistory: {
    en: 'Show attendance history',
    nb: 'Vis fremmøtehistorikk',
  },
  Hereyouwillbeabletoseeifa: {
    en: 'Here you will be able to see if anyone has made changes to an agenda item',
    nb: 'Her vil du kunne se om noen har gjort endringer på et agendapunkt',
  },
  Showagendaitemlog: {
    en: 'Show agenda item log',
    nb: 'Vis agendapunktlogg',
  },
  TheagendaissavedasaPDFdoc: {
    en: 'The agenda is saved as a PDF document in the File Attachments section.',
    nb: 'Agendaen lagres som et PDF-dokument i Filvedlegg-seksjonen.',
  },
  APDFdocumentissavedthatst: {
    en: 'A PDF document is saved that starts with the agenda, and continues with the PDF documents that are attached to the agenda items in order. The PDF document is saved in the File Attachments section.',
    nb: 'Det lagres et PDF-dokument som starter med agendaen, og fortsetter med PDF-dokumentene som er vedlagt agendapunktene i rekkefølge. PDF-dokumentet lagres i Filvedlegg-seksjonen.',
  },
  Hereyoucaninviteexternalp: {
    en: 'Here you can invite external participants to participate in the meeting via the built-in video solution from Jitsi.',
    nb: 'Her kan du invitere eksterne deltakere til å delta i møtet via den innebygde videoløsningen fra Jitsi.',
  },
  SendJitsiInvitation: {
    en: 'Send Jitsi Invitation',
    nb: 'Send Jitsi-invitasjon',
  },
  Importproxydataandvotes: {
    en: 'Import proxy data and votes',
    nb: 'Importer fullmektig-data og stemmer',
  },
  Seeproxies: {
    en: 'See proxies',
    nb: 'Se fullmakter',
  },
  Basedontheagendayoucancre: {
    en: 'Based on the agenda, you can create a PDF document with ballot papers that can be printed.',
    nb: 'Her kan du basert på agendaen, lage et PDF-dokument med stemmesedler som kan skrives ut.',
  },
  CreateballotpapersPDF: {
    en: 'Create ballot papers (PDF)',
    nb: 'Lag stemmesedler (PDF)',
  },
  Whensharingyourscreenpres: {
    en: 'When sharing your screen/presentation, you can hide your voting',
    nb: 'Ved skjermdeling/presentasjon kan du skjule din stemmegiving',
  },
  Hidemyvotes: {
    en: 'Hide my votes',
    nb: 'Skjul stemmene mine',
  },
  Showmyvotes: {
    en: 'Show my votes',
    nb: 'Vis mine stemmer',
  },
  Themeetingwithoutanyattac: {
    en: 'The meeting, without any attachments, will be downloaded as a file, so that the meeting can be copied to another organization by drag&drop.',
    nb: 'Møtet, uten eventuelle vedlegg, vil bli lastet ned som fil, slik at møtet kan kopieres til en annen organisasjon ved drag&drop.',
  },
  Downloadmeetingdata: {
    en: 'Download meeting data',
    nb: 'Last ned møtedata',
  },
  Specifytimestampifyouwant: {
    en: 'Specify timestamp if you want to see historical status of users and events',
    nb: 'Angi tidsstempel hvis du vil se den historiske statusen til brukere og hendelser',
  },
  Loaddataattimestamp: {
    en: 'Load data at timestamp',
    nb: 'Last inn data på tidspunkt',
  },
  Deletingameetingcannotbeu: {
    en: 'Deleting a meeting can not be undone, do you wish to proceed?',
    nb: 'Sletting av et møte kan ikke angres, vil du fortsette?',
  },
  Therearealreadyinviteduse: {
    en: 'There are already invited users',
    nb: 'Det er allerede inviterte brukere',
  },
  Deletemeeting: {
    en: 'Delete meeting?',
    nb: 'Slett møte?',
  },
  Anerroroccurredpleasetrya: {
    en: 'An error occurred, please try again',
    nb: 'En feil oppstod. Vennligst prøv igjen',
  },
  Doyoureallywanttocancelth: {
    en: 'Do you really want to cancel the meeting?',
    nb: 'Ønsker du virkelig å avlyse dette møtet?',
  },
  Yesinforminvited: {
    en: 'Yes, inform invited',
    nb: 'Ja, informer inviterte',
  },
  Pdfisgeneratedandaddedtoa: {
    en: 'Pdf is generated and added to attachments',
    nb: 'Pdf genereres og legges til vedlegg',
  },
  Hours: {
    en: 'Hours',
    nb: 'Timer',
  },
  Minutes: {
    en: 'Minutes',
    nb: 'Minutter',
  },
  MinutesShortForm: {
    en: ' min',
    nb: ' min',
  },
  Election: {
    en: 'Candidates',
    nb: 'Kandidater',
  },
  Seconds: {
    en: 'Seconds',
    nb: 'Sekunder',
  },
  Applytime: {
    en: 'Apply time',
    nb: 'Bruk angitt tid',
  },
  Resettime: {
    en: 'Reset time',
    nb: 'Tilbakestill tid',
  },
  Starttime: {
    en: 'Start time',
    nb: 'Starttid',
  },
  Endtime: {
    en: 'End time',
    nb: 'Sluttid',
  },
  Switchtoadifferentvideoco: {
    en: 'Switch to a different video conference',
    nb: 'Bytt til annen videokonferanse',
  },
  Locationisnotset: {
    en: 'Location is not set',
    nb: 'Sted ikke angitt',
  },
  Inviteparticipantstovoteo: {
    en: 'Invite participants to vote on alternative meeting times.',
    nb: 'Her kan du invitere møtedeltakerne til å stemme over alternative møtetidspunkter',
  },
  Choosetime: {
    en: 'Choose time',
    nb: 'Finn tid',
  },
  Asadmin: {
    en: 'As admin',
    nb: 'Som admin',
  },
  Asuser: {
    en: 'As user',
    nb: 'Som bruker',
  },
  Inordertoprevoteyoumustvo: {
    en: 'In order to pre-vote, you must vote on each of the proposed items that you will find under «Agenda»',
    nb: 'Dette ikonet tilsier at forhåndsstemming er mulig i valg- og beslutningssaker i «Agenda»-seksjonen',
  },
  Navigatingbythislinkwilli: {
    en: 'Navigating by this link will interrupt current video conference',
    nb: 'Hvis du går via denne lenken, avbrytes den nåværende videokonferansen',
  },
  Entervideocall: {
    en: 'Enter video call',
    nb: 'Gå til videokonferanse',
  },
  Youhavechangedmeetinginfo: {
    en: 'You have changed meeting information.',
    nb: 'Du har endret møteopplysninger.',
  },
  Doyouwanttoinformtheparti: {
    en: 'Do you want to inform the participants who have already been invited?',
    nb: 'Ønsker du å informere de deltakerne som allerede er invitert?',
  },
  NB: {
    en: 'NB!',
    nb: 'NB!',
  },
  Ifyoudonotansweryoucannot: {
    en: 'If you do not answer, you can not participate in voting!',
    nb: 'Dersom du ikke svarer kan du ikke delta i stemmegiving!',
  },
  EntitiesWhichYouAreRepresentativeFor: {
    en: `You're representing`,
    nb: 'Du representerer',
  },
  ConfirmParticipation: {
    en: ' - confirm participation',
    nb: ' - bekreft deltakelse',
  },

  Willyouattend: {
    en: 'Will you attend?',
    nb: 'Skal du delta?',
  },
  Makeballots: {
    en: 'Make ballots',
    nb: 'Lag stemmesedler',
  },
  Selectagendaitemsforwhich: {
    en: 'Select agenda items for which ballot papers are to be generated',
    nb: 'Velg agendapunkter det skal genereres stemmesedler for',
  },
  CreatePDF: {
    en: 'Create PDF',
    nb: 'Lag PDF',
  },
  ballot: {
    en: 'ballot',
    nb: 'stemmeseddel',
  },
  PDFisgeneratedandaddedtoa: {
    en: 'PDF is generated and added to attachments',
    nb: 'PDF genereres og legges til vedlegg',
  },
  Nocandidatesadded: {
    en: 'No candidates added',
    nb: 'Ingen kandidater lagt til',
  },
  Nooptionsadded: {
    en: 'No options added',
    nb: 'Ingen alternativer lagt til',
  },
  Ballot: {
    en: 'Ballot',
    nb: 'Stemmeseddel',
  },
  votes: {
    en: 'votes',
    nb: 'stemmer',
  },
  CandidatesForElection: {
    en: 'Candidates for election',
    nb: 'Kandidater til valg',
  },
  Numberofcandidatesthatcan: {
    en: 'Number of candidates that can be selected',
    nb: 'Antall kandidater som kan velges',
  },
  Choiceoptions: {
    en: 'Choice options',
    nb: 'Valgalternativer',
  },
  YouAreRepresenting: {
    nb: 'Har du tenkt å delta i møtet på vegne av ',
    en: 'Are you planning to attend the meeting on behalf of ',
  },
  UnseenAgendaItem: {
    en: 'Unread agenda item',
    nb: 'Ulest sak',
  },
  UnseenAttachment: {
    en: 'Unread',
    nb: 'Ulest',
  },
  Numberofoptionsthatcanbes: {
    en: 'Number of options that can be selected',
    nb: 'Antall alternativer som kan velges',
  },
  elects: {
    en: 'elects',
    nb: 'velger',
  },
  selects: {
    en: 'selects',
    nb: 'velger',
  },
  Check: {
    en: 'Check',
    nb: 'Kryss av',
  },

  InvitetoJitsivideoconfere: {
    en: 'Invite to Jitsi video conference',
    nb: 'Inviter til Jitsi-videokonferanse',
  },
  Hereyoucangiveexternalpeo: {
    en: 'Here you can give external people the opportunity to participate in a meeting via the built-in video solution from Jitsi. This could, for example, be an auditor who will have a post on one of the agenda items, but who does not need to access the meeting information.',
    nb: 'Her kan du gi eksterne mulighet til å delta i et møtet via den innebyggede videoløsningen fra Jitsi. Dette kan for eksempel være revisor som skal ha et innlegg på et av agendapunktene, men som ikke har behov for å få tilgang til møteinformasjonen.',
  },
  Invitationlinkwillbeactiv: {
    en: 'Invitation link will be active from',
    nb: 'Invitasjonskoblingen vil være aktiv fra',
  },
  Addpeople: {
    en: 'Add people',
    nb: 'Legg til personer',
  },

  ParticipantsareinvitedIfn: {
    en: 'Participants are invited. If needed, an update can be sent to the participants by pressing “Notify of updates”.',
    nb: 'Deltakerne er invitert. Ved endringer, kan det sendes en oppdatering til deltakerne med knappen «Informer om oppdatering».',
  },
  Themeetingisinprogressand: {
    en: 'The meeting is in progress and the participants can vote.',
    nb: 'Møtet er i gang og deltakerne kan avlegge stemme.',
  },
  Themeetingstatuswillautom: {
    en: 'The meeting status will automatically change to “Completed” when everyone has signed.',
    nb: 'Når alle har signert vil møtestatus automatisk bli satt til «Fullført».',
  },
  Doyouwanttochangemeetings: {
    en: 'Do you want to change meeting status?',
    nb: 'Vil du endre møtestatusen?',
  },
  ChangeMeetingStatus: {
    en: 'Change meeting status',
    nb: 'Endre møtestatus',
  },
  YouAreAboutTOSetMeetingCalled: {
    en: 'You are about to set the meeting status to "Called". This is only a status change and will not send an invitation to the participants.',
    nb: 'Du er i ferd med å sette møtestatus til "Innkalt". Dette er kun en statusendring og vil ikke sende en innkalling til deltakerne.',
  },
  DoYouWantToInviteParticipantsClick: {
    en: 'Do you want to invite participants? Click "Invite".',
    nb: 'Ønsker du å invitere deltakere? Klikk på "Inviter".',
  },
  ChangeStatus: {
    en: 'Change status',
    nb: 'Endre status',
  },
  Newstatus: {
    en: 'New status',
    nb: 'Ny status',
  },
  MeetingStartedNotice1: {
    en: 'The meeting ',
    nb: 'Møtet ',
  },
  MeetingStartedNotice2: {
    en: ' has started.',
    nb: ' har startet.',
  },
  MeetingwillbeCompleted: {
    en: 'The meeting will be set to the status "Completed"',
    nb: 'Møtet vil bli satt til status «Fullført»',
  },
  Meetingisendinginlessthan: {
    en: 'Meeting is ending in less than 10 minutes',
    nb: 'Møtet avsluttes om mindre enn 10 minutter',
  },
  Copycontent: {
    en: 'Copy content',
    nb: 'Kopier innhold',
  },
  Restoreunfinisheddraft: {
    en: 'Restore unfinished draft',
    nb: 'Gjenopprett uferdig utkast',
  },
  Saveunfinisheddraft: {
    en: 'Save unfinished draft',
    nb: 'Lagre uferdig utkast',
  },
  Gotocomments: {
    en: 'Go to comments',
    nb: 'Gå til kommentarer',
  },
  AdminVotes: {
    en: 'Administer votes',
    nb: 'Administrer stemmegivning',
  },
  NoRelevantMatchesFoundForProtocol: {
    nb: 'Fant ingen diskusjonsemner som passet til agendapunktet',
    en: 'No relevant matches found for the agenda item',
  },
  UploadMeetingRecordingInvalidFileFormat: {
    nb: 'Filen er ikke i et gyldig format. Gyldige format: mp3, m4a, ogg, wav',
    en: 'The file is not in a valid format. Valid formats: mp3, m4a, ogg, wav',
  },
  UploadMeetingRecordingFileTooLarge: {
    nb: 'Filen er for stor. Maksimal størrelse: 100 MB. Forsøk å redusere filstørrelsen ved å endre format eller dele den opp i flere deler.',
    en: 'The file is too large. Max size: 100 MB. Try to reduce the file size by changing format or splitting it into multiple parts.',
  },
  'meetings.Approved': {
    en: 'Approved by:',
    nb: 'Godkjent av:',
  },
  Notsigned: {
    en: 'Not signed',
    nb: 'Ikke signert',
  },
  Couldnotattachminutes: {
    en: 'Could not attach minutes',
    nb: 'Kunne ikke legge ved protokoll',
  },
  PleaseuseavalidPDFfile: {
    en: 'Please use a valid PDF file',
    nb: 'Bruk en gyldig PDF-fil',
  },
  Success: {
    en: 'Success',
    nb: 'Suksess',
  },
  Emailssentsuccessfullyto: {
    en: 'Emails sent successfully to:',
    nb: 'E-postmeldinger ble sendt til:',
  },

  Errorsendingemails: {
    en: 'Error sending emails',
    nb: 'Feil ved sending av e-post',
  },
  Doyouwanttosendamissingsi: {
    en: 'Do you want to send a missing signatures reminder to the following:',
    nb: 'Vil du sende en påminnelse om manglende signering til følgende:',
  },
  Discard: {
    en: 'Discard',
    nb: 'Forkast',
  },
  Keep: {
    en: 'Keep',
    nb: 'Behold',
  },
  Errorduringserverrequest: {
    en: 'Error during server request',
    nb: 'Feil under serverforespørsel',
  },
  Notitle: {
    en: 'No title',
    nb: 'Uten tittel',
  },

  Novotinghasbeendone: {
    en: 'No voting has been done',
    nb: 'Det har ikke blitt stemt',
  },
  Someonehasntansweredthein: {
    en: "Someone hasn't answered the meeting invitation",
    nb: 'Noen har ikke svart på møteinvitasjonen',
  },
  meeting: {
    en: 'meeting',
    nb: 'møtet',
  },
  Remindersaresentafterandd: {
    en: 'Reminders are sent after 3, 7 and 21 days, but they can also be sent manually by clicking “Send reminder”. When everyone has signed, the meeting status will automatically be set to “Completed”.',
    nb: 'Påminnelse sendes etter 3, 7 og 21 dager, men det er også mulig å velge «Send påminnelse». Når alle har signert, vil møtestatus automatisk bli satt til «Fullført».',
  },
  Ifyouhavesuggestionsforch: {
    en: 'If you have suggestions for changes, enter comments directly in the PDF minutes or click "Comment on draft"',
    nb: 'Dersom du har innspill til endringer, legg inn kommentarer direkte i PDF-protokollen eller klikk «Kommenter utkast».',
  },
  Opendraft: {
    en: 'Open draft',
    nb: 'Åpne utkast',
  },
  Commentondraft: {
    en: 'Comment on draft',
    nb: 'Kommenter utkast',
  },
  Approvedraft: {
    en: 'Approve draft',
    nb: 'Godkjenn utkast',
  },
  Unapprovedraft: {
    en: 'Unapprove draft',
    nb: 'Trekk godkjenning',
  },
  Youhavepreviouslyapproved: {
    en: 'You have previously approved the protocol, but it has since been amended. You should read to take a new review.',
    nb: 'Du har tidligere godkjent protokollen, men den har i etterkant blitt endret. Du bør vurdere å ta en ny gjennomgang.',
  },
  Percentagerequirement: {
    en: 'Percentage requirement',
    nb: 'Prosentkrav',
  },
  BasedontherulesintheNorwe: {
    en: 'Based on the rules in the Norwegian Companies Act § 6-24',
    nb: 'Basert på reglene i aksjeloven § 6-24',
  },
  Newcomment: {
    en: 'New comment',
    nb: 'Nytt innlegg',
  },
  Text: {
    en: 'Text',
    nb: 'Tekst',
  },
  Nooptions: {
    en: 'No options',
    nb: 'Ingen alternativer',
  },
  Newcandidate: {
    en: 'New candidate',
    nb: 'Ny kandidat',
  },
  Youareabouttodeleteaoptio: {
    en: 'You are about to delete a option in which votes have already been cast. If you delete this option, these votes will be lost. If you want these votes to be counted, you must create a new poll where everyone votes again.',
    nb: 'Du er i ferd med å slette et valg der det allerede er avgitt stemmer. Dersom du sletter dette valget, vil disse stemmene bli borte. Hvis du ønsker at disse stemmene skal telles, må du opprette en ny avstemning der alle stemmer på nytt.',
  },
  Youhaveselectedtoomanyalt: {
    en: 'You have selected too many alternatives.',
    nb: 'Du har valgt for mange alternativer.',
  },
  Instructions: {
    en: 'Instructions',
    nb: 'Instruksjoner',
  },
  Voting: {
    en: 'Voting',
    nb: 'Stemmegivning',
  },
  unknown: {
    en: 'unknown',
    nb: 'ukjent',
  },
  Recipientsofemailnotifica: {
    en: 'Recipients of email notification',
    nb: 'Mottagere av varsel på e-post',
  },
  Alluserswithaccesstoboard: {
    en: 'All users with access to board meetings can participate in the chat dialogue.',
    nb: 'Her kan alle som har brukertilgang til styremøter delta i en chatdialog',
  },
  Therecipientswillreceivea: {
    en: 'The recipients will receive an email notification that a new message has been posted. The email will contain the title of the message.',
    nb: 'Mottakerne vil få varsel på e-post om at ny kunngjøring er lagt ut. E-posten vil inneholde tittelen på kunngjøringen.',
  },
  Everyoneinthegroup: {
    en: 'Everyone in the group',
    nb: 'Alle i gruppen',
  },
  Addindividualuserswhoshou: {
    en: 'Add individual users who should receive a notification that a new message has been posted in the portal.',
    nb: 'Her kan du legge til enkeltbrukere som skal motta varsel om at ny kunngjøring er lagt ut i portalen.',
  },
  Addusers: {
    en: 'Add users',
    nb: 'Legg til brukere',
  },
  Selectusers: {
    en: 'Select users',
    nb: 'Velge brukere',
  },

  Onlyforboard: {
    en: 'Only for board',
    nb: 'Bare for styret',
  },
  Topic: {
    en: 'Topic',
    nb: 'Emne',
  },
  NOTEIfyoucheckthisboxthet: {
    en: 'NOTE: If you check this box, the text from the description will be visible in the email sent to the recipients. If you do not check it, only the title will appear in the email.',
    nb: 'OBS: Dersom du krysser av her, vil hele meldingsteksten bli synlig i e-post som sendes mottakerne. Hvis du ikke krysser av, vil kun tittelen være synlig i e-posten',
  },
  Restoreunsaveddraft: {
    en: 'Restore unsaved draft',
    nb: 'Gjenopprett ulagret utkast',
  },
  Savedraft: {
    en: 'Save draft',
    nb: 'Lagre utkast',
  },
  Afteramessagehasbeenpubli: {
    en: 'After a message has been published, this button is used when sending notification by e-mail to new recipients that have been added to «Recipients of email notification» and for saving any changes',
    nb: 'Etter at en melding er publisert, benyttes denne knappen ved utsendelse av varsling på e-post til nye mottakere som er lagt til i «Mottagere av varsel på e-post» samt for lagring av eventuelle endringer',
  },
  Pleaseconfirmsendingemail: {
    en: 'Please confirm sending emails',
    nb: 'Bekreft å sende e-post',
  },
  Youhavenotaddedanyrecipie: {
    en: 'You have not added any recipients',
    nb: 'Du har ikke lagt til noen mottakere',
  },
  Ifyoucontinuethemessagewi: {
    en: 'If you continue, the announcement will be published without an e-mail stating that a new announcement is available. If you want to add recipients, press "Cancel" and add recipients.',
    nb: 'Om du fortsetter vil kunngjøring bli publisert uten at det går e-post om at ny kunngjøring er tilgjengelig. Om du ønsker å legge til mottakere, trykk på «Avbryt» og legg til mottakere.',
  },

  Createnewmessage: {
    en: 'Create new message',
    nb: 'Lag ny kunngjøring',
  },
  Youhavenomessagesyet: {
    en: 'You have no messages yet',
    nb: 'Du har ingen meldinger',
  },
  Guides: {
    en: 'Guides',
    nb: 'Veiledere',
  },
  Webinars: {
    en: 'Webinars',
    nb: 'Webinarer',
  },
  UserTraining: {
    en: 'User Training',
    nb: 'Brukeropplæring',
  },
  Activitystatistics: {
    en: 'Activity statistics',
    nb: 'Aktivitetsstatistikk',
  },
  Selectfiltertostart: {
    en: 'Select filter to start',
    nb: 'Velg filter for å starte',
  },
  Useractions: {
    en: 'User actions',
    nb: 'Brukerhandlinger',
  },
  Extrainfo: {
    en: 'Extra info',
    nb: 'Ekstra info',
  },
  Datefrom: {
    en: 'Date from',
    nb: 'Dato fra',
  },
  Dateto: {
    en: 'Date to',
    nb: 'Dato til',
  },
  Showstatistics: {
    en: 'Show statistics',
    nb: 'Vis statistikk',
  },
  Month: {
    en: 'Month',
    nb: 'Måned',
  },
  Tailored: {
    en: 'Tailored',
    nb: 'Skreddersydd',
  },
  RecommendedForCorporations: {
    en: 'Recommended for corporations',
    nb: 'Anbefalt for konserner',
  },
  AnnualInvoicing: {
    en: 'Annual invoicing',
    nb: 'Årlig fakturering',
    sv: 'Årlig fakturering',
  },
  OrgbrainStartText1: {
    en: 'Orgbrain Start is a free subscription that gives you access to Orgbrain with limited features. With this subscription, you can purchase access to selected individual modules from our Pro subscription.',
    nb: 'Orgbrain Start er et kostnadsfritt abonnement som gir deg tilgang til Orgbrain med et begrenset sett funksjoner. Med dette abonnementet kan du kjøpe tilgang til utvalgte enkeltmoduler fra vårt Pro-abonnement.',
  },
  OrgbrainStartText2: {
    en: 'For the best overall experience and most value for money, we recommend the Pro subscription.',
    nb: 'For best totalopplevelse og mest verdi for pengene anbefaler vi Pro-abonnementet.',
  },
  OrgbrainStartText3: {
    en: 'Here you can subscribe to one or more selected individual modules from our Pro subscription. For the best overall experience and most value for money, we recommend upgrading to the full Pro subscription.',
    nb: 'Her kan du abonnere på én eller flere utvalgte enkeltmoduler fra vårt Pro-abonnement. For best totalopplevelse og mest verdi for pengene anbefaler vi å oppgradere til fullverdig Pro-abonnement.',
    sv: 'Her kan du abonnere på en eller flere utvalgte enkeltmoduler fra vårt Pro-abonnement. For best totalopplevelse og mest verdi for pengene anbefaler vi å oppgradere til fullverdig Pro-abonnement.',
  },
  ActivatedTestSub: {
    en: 'Trial subscription activated',
    nb: 'Aktivert prøveabonnement',
  },
  Allorganizationtypes: {
    en: 'All organization types',
    nb: 'Alle organisasjonstyper',
  },
  Configureannualplan: {
    en: 'Configure annual plan',
    nb: 'Konfigurer årsplan',
  },
  Youcancreateanynumberofan: {
    en: 'You can create any number of annual plan configurations. When creating an annual plan, first the most detailed configuration will be taken, if nothing found, the fallback version without options in Norwegian language will be used',
    nb: 'Du kan opprette et hvilket som helst antall årlige plankonfigurasjoner. Når du lager en årlig plan, vil først den mest detaljerte konfigurasjonen bli tatt, hvis ingenting blir funnet, vil reserveversjonen uten opsjoner på norsk bli brukt',
  },
  Addnewannualplanconfigura: {
    en: 'Add new annual plan configuration',
    nb: 'Legg til ny årsplankonfigurasjon',
  },
  Draft: {
    en: 'Draft',
    nb: 'Utkast',
    sv: 'Utkast',
  },
  Copy: {
    en: 'Copy',
    nb: 'Kopiere',
  },
  ConfigtypeOrgtypesLanguag: {
    en: 'Config type. Org types. Language',
    nb: 'Konfigurasjonstype. Organisasjonstyper. Språk',
  },
  Copyof: {
    en: 'Copy of',
    nb: 'Kopi av',
  },
  Preview: {
    en: 'Preview',
    nb: 'Forhåndsvisning',
  },
  Thereisnoconfigsyet: {
    en: 'There is no configs yet',
    nb: 'Det er ingen konfigurasjoner ennå',
  },
  NewAcademyItem: {
    en: 'New Academy Item',
    nb: 'Nytt akademiobjekt',
  },
  Hidetextundertheimage: {
    en: 'Hide text under the image',
    nb: 'Skjul tekst under bildet',
  },
  Hideplayiconovertheimage: {
    en: 'Hide play icon over the image',
    nb: 'Skjul avspillingsikonet over bildet',
  },
  Copiedtoclipboard: {
    en: 'Copied to clipboard',
    nb: 'Kopiert til utklippstavlen',
  },
  ConfigureOrgbrainAcademy: {
    en: 'Configure Orgbrain Academy',
    nb: 'Konfigurer Orgbrain Academy',
  },
  ManagesectionsoftheAcadem: {
    en: 'Manage sections of the Academy',
    nb: 'Administrer deler av akademiet',
  },
  Academylanguage: {
    en: 'Academy language',
    nb: 'Akademispråk',
  },
  Usertraining: {
    en: 'User training',
    nb: 'Brukeropplæring',
  },
  OrgbrainEmails: {
    en: 'Orgbrain Emails',
    nb: 'Orgbrain E-post',
  },
  Sendemailstoallusers: {
    en: 'Send emails to all users',
    nb: 'Send e-post til alle brukere',
  },
  Emaillanguage: {
    en: 'Email language',
    nb: 'E-postspråk',
  },
  Maxsizeofemailgroup: {
    en: 'Max size of email group',
    nb: 'Maksimal størrelse på e-postgruppe',
  },
  Excludesentemails: {
    en: 'Exclude sent emails',
    nb: 'Ekskluder sendte e-poster',
  },
  Excludeskippedemails: {
    en: 'Exclude skipped emails',
    nb: 'Ekskluder e-poster som er hoppet over',
  },
  Excludefailedemails: {
    en: 'Exclude failed emails',
    nb: 'Ekskluder mislykkede e-poster',
  },
  EmailBulk_UserGroupType_ALL_USERS_ACTIVE_ORG: {
    en: 'All users in organization that is not suspended',
    nb: 'Alle brukere i organisasjonen som ikke er suspendert',
  },
  EmailBulk_UserGroupType_ALL_USERS_INACTIVE_ORG: {
    en: 'Users of suspended organizations',
    nb: 'Brukere av suspenderte organisasjoner',
  },
  EmailBulk_UserGroupType_ALL_USERS_PAYING_ORG: {
    en: 'Users of organizations with paid subscriptions (not test/subgroup)',
    nb: 'Brukere av organisasjoner med betalte abonnementer (ikke test/undergruppe)',
  },
  EmailBulk_UserGroupType_ALL_USERS: {
    en: 'Users of all types of organizations',
    nb: 'Brukere av alle typer organisasjoner',
  },
  EmailBulk_UserGroupType_AcceptingTerms: {
    en: 'Users who accept terms for Hubspot',
    nb: 'Brukere som godtar vilkårene for Hubspot',
  },
  EmailBulk_UserGroupType_BELONGS_TO_ORG: {
    en: 'List of organization numbers',
    nb: 'Liste over organisasjonsnumre',
  },
  EmailBulk_UserGroupType_BELONGS_TO_ORG_TYPE: {
    en: 'List of organization types (active orgs)',
    nb: 'Liste over organisasjonstyper (aktive organisasjoner)',
  },
  EmailBulk_UserGroupType_BELONGS_TO_CLIENT: {
    en: 'List of clients (active orgs)',
    nb: 'Liste over klienter (aktive organisasjoner)',
  },
  EmailBulk_UserGroupType_allWhoAcceptedTerms: {
    en: 'Users accepted terms',
    nb: 'Brukere har akseptert vilkårene',
  },
  EmailBulk_UserGroupType_typeOfUserGroup: {
    en: 'Type of organization target group',
    nb: 'Type organisasjonsmålgruppe',
  },
  EmailBulk_UserGroupType_onlyOrgAdmins: {
    en: 'Only for admins',
    nb: 'Kun for administratorer',
  },
  EmailBulk_UserGroupType_onlySuperUsers: {
    en: 'Only for super users',
    nb: 'Kun for superbrukere',
  },
  EmailBulk_UserGroupType_onlyMyself: {
    en: 'Send email to myself',
    nb: 'Send e-post til meg selv',
  },
  EmailBulk_UserGroupType_onlyRegisteredUsers: {
    en: 'Only registered users',
    nb: 'Kun registrerte brukere',
  },
  EmailBulk_UserGroupType_onlyUnInvitedUnRegisteredUsers: {
    en: 'Not registered users, not invited',
    nb: 'Ikke registrerte brukere, ikke invitert',
  },
  EmailBulk_UserGroupType_onlyInvitedUnRegisteredUsers: {
    en: 'Not registered users, invited',
    nb: 'Ikke registrerte brukere, invitert',
  },
  EmailBulk_UserGroupType_allowedOrganizationNumbers: {
    en: 'Comma separated list of org numbers',
    nb: 'Kommaseparert liste over organisasjonsnumre',
  },
  EmailBulk_UserGroupType_allowedClientIds: {
    en: 'Comma separated list of client ids',
    nb: 'Kommaseparert liste over klient-ID-er',
  },
  EmailBulk_UserGroupType_allowedOrganizationTypes: {
    en: 'Comma separated list of org types',
    nb: 'Kommaseparert liste over organisasjonstyper',
  },
  Alsoclickhereifyouwanttoi: {
    en: 'Control checkbox. Confirms that other checkboxes are correct',
    nb: 'Kontrollboks. Bekrefter at andre avmerkingsbokser er riktige',
  },
  CalculateNumberRcepients: {
    en: 'Calculate recipients',
    nb: 'Beregn mottakere',
  },
  NumberUsersTargetGroup: {
    en: 'Number of users in this target group',
    nb: 'Antall brukere i denne målgruppen',
  },
  Saveasdraft: {
    en: 'Save as draft',
    nb: 'Lagre som kladd',
  },
  Createbatches: {
    en: 'Create batches',
    nb: 'Opprett grupper',
  },
  Locked: {
    en: 'Locked',
    nb: 'Låst',
  },
  Batch: {
    en: 'Batch',
    nb: 'Gruppe',
  },
  Hidedetails: {
    en: 'Hide details',
    nb: 'Skjul detaljer',
  },
  Seedetails: {
    en: 'See details',
    nb: 'Se detaljer',
  },
  Clicktoreloademailstatuse: {
    en: 'Click to reload email statuses',
    nb: 'Klikk for å laste inn e-poststatuser på nytt',
  },
  SendText: {
    en: 'Send',
    nb: 'Sende',
  },
  Usethistemplate: {
    en: 'Use this template',
    nb: 'Bruk denne malen',
  },
  Lockthisitem: {
    en: 'Lock this item',
    nb: 'Lås dette elementet',
  },
  Pleaseconfirmcreatingbatc: {
    en: 'Please confirm creating batches',
    nb: 'Vennligst bekreft å opprette grupper',
  },
  SelectedmembersofOrgbrain: {
    en: 'Selected members of Orgbrain Default',
    nb: 'Utvalgte medlemmer av Orgbrain Default',
  },
  Doyouwanttohidethisemail: {
    en: 'Do you want to hide this email?',
    nb: 'Vil du skjule denne e-posten?',
  },
  Doyouwanttodeletethisdraf: {
    en: 'Do you want to delete this draft?',
    nb: 'Vil du slette dette utkastet?',
  },
  Thisisasoftdelete: {
    en: 'This is a soft delete',
    nb: 'Dette er en myk sletting',
  },
  Thisisaharddelete: {
    en: 'This is a hard delete',
    nb: 'Dette er en hard sletting',
  },
  Anemailwillbesenttoselect: {
    en: 'An email will be sent to selected members',
    nb: 'En e-post vil bli sendt til utvalgte medlemmer',
  },
  Templatetype: {
    en: 'Template type',
    nb: 'Maltype',
  },
  Texteditor: {
    en: 'Text editor',
    nb: 'Tekstredigerer',
  },
  Bigheadertext: {
    en: 'Big header text',
    nb: 'Stor overskriftstekst',
  },
  ImageURL: {
    en: 'Image URL',
    nb: 'Bilde-URL',
  },
  Emptyspace: {
    en: 'Empty space',
    nb: 'Tomrom',
  },
  HTMLTemplateparts: {
    en: 'HTML Template parts',
    nb: 'HTML-maldeler',
  },
  ConfigureOrgbrainNews: {
    en: 'Configure Orgbrain News',
    nb: 'Konfigurer Orgbrain Nyheter',
  },
  CreatenewsthatallOrgbrain: {
    en: 'Create news that all Orgbrain users will see',
    nb: 'Lag nyheter som alle Orgbrain-brukere vil se',
  },
  Addnews: {
    en: 'Add news',
    nb: 'Legg til nyheter',
  },
  Newswithoutaname: {
    en: 'News without a name',
    nb: 'Nyheter uten navn',
  },
  Templatebody: {
    en: 'Template body',
    nb: 'Malens kropp',
  },
  Sometagsarenotunique: {
    en: 'Some tags are not unique',
    nb: 'Noen tagger er ikke unike',
  },
  Defaultfolderforsavingfil: {
    en: 'Default folder for saving files',
    nb: 'Standardmappe for lagring av filer',
  },
  Defaultfolder: {
    en: 'Default folder',
    nb: 'Standardmappe',
  },
  Subfolder: {
    en: 'Subfolder',
    nb: 'Undermappe',
  },
  Checkboxwillbecheckedbyde: {
    en: 'Checkbox will be checked by default',
    nb: 'Avmerkingsboksen vil være merket som standard',
  },
  Checkboxwillbeuncheckedby: {
    en: 'Checkbox will be unchecked by default',
    nb: 'Avmerkingsboksen vil være umerket som standard',
  },
  Defaultfieldvalue: {
    en: 'Default field value',
    nb: 'Standard feltverdi',
  },
  Helpertext: {
    en: 'Helper text',
    nb: 'Hjelpetekst',
  },
  Unused: {
    en: 'Unused',
    nb: 'Ubrukt',
  },
  Tagid: {
    en: 'Tag id',
    nb: 'Tag-ID',
  },
  Tagtype: {
    en: 'Tag type',
    nb: 'Tag type',
  },
  Pleaseuse: {
    en: 'Please use',
    nb: 'Vennligst bruk',
  },
  keywordwhereyouneedavaria: {
    en: 'keyword where you need a variable.',
    nb: 'nøkkelord der du trenger en variabel.',
  },
  'orgbrain-configure.Labeltext': {
    en: 'Label',
    nb: 'Merkelapp',
  },
  Optionsforselection: {
    en: 'Options for selection',
    nb: 'Valgmuligheter',
  },
  Inputtypestring: {
    en: 'Input type: string',
    nb: 'Inndatatype: streng',
  },
  Inputtypenumber: {
    en: 'Input type: number',
    nb: 'Inndatatype: nummer',
  },
  Inputtypedate: {
    en: 'Input type: date',
    nb: 'Inndatatype: dato',
  },
  Selectoption: {
    en: 'Select option',
    nb: 'Velg alternativ',
  },
  Valueoremptyspace: {
    en: 'Value or empty space',
    nb: 'Verdi eller tom plass',
  },
  ConfigureOrgbrainTemplate: {
    en: 'Configure Orgbrain Templates',
    nb: 'Konfigurer Orgbrain Maler',
  },
  CreatetemplatethatallOrgb: {
    en: 'Create template that all Orgbrain users will see',
    nb: 'Lag mal som alle Orgbrain-brukere vil se',
  },
  Addtemplate: {
    en: 'Add template',
    nb: 'Legg til mal',
  },
  Templatewithoutaname: {
    en: 'Template without a name',
    nb: 'Mal uten navn',
  },
  Changepassword: {
    en: 'Change password',
    nb: 'Endre passord',
  },
  Pleasecroptheimage: {
    en: 'Please crop the image',
    nb: 'Vennligst beskjær bildet',
  },
  Removeavatar: {
    en: 'Remove avatar?',
    nb: 'Fjern avatar?',
  },
  Youarenotsubscribedtothen: {
    en: 'You are not subscribed to the notification service. You may be running the app in incgonito mode or you may have set the browser notification settings to blocked.',
    nb: 'Du er ikke abonnert på varslingstjenesten. Det kan hende at du kjører appen i inkgonitomodus, eller du i har satt at varsel skal blokkeres i nettleserens varslingsinnstillinger.',
  },
  Allowreceivingwebpushnoti: {
    en: 'Allow receiving web-push notifications',
    nb: 'Tillat å motta web-push-varsler',
  },
  Notificationsareblocked: {
    en: 'Notifications are blocked',
    nb: 'Varsler er blokkert',
  },
  Notificationsareblockedin: {
    en: 'Notifications are blocked in browser. Please allow notifications in browser settings.',
    nb: 'Varsler er blokkert i nettleseren. Tillat varsler i nettleserinnstillingene.',
  },
  Couldnotturnonwebpushnoti: {
    en: 'Could not turn on web-push notifications yet',
    nb: 'Kunne ikke slå på web-push-varsler ennå',
  },
  Maybeyourbrowserisblockin: {
    en: 'Maybe your browser is blocking web-push notifications. Please allow notifications in browser settings.',
    nb: 'Kanskje nettleseren blokkerer web-push-varsler. Tillat varsler i nettleserinnstillingene.',
  },
  Documentupload: {
    en: 'Document upload',
    nb: 'Dokumentopplasting',
  },
  UTLcode: {
    en: 'UTL code',
    nb: 'UTL-kode',
  },

  Residentialaddress: {
    en: 'Residential address',
    nb: 'Bostedsadresse',
  },
  Orgnr: {
    en: 'Org.nr',
    nb: 'Org.nr',
  },
  Useralreadyexists: {
    en: 'User already exists',
    nb: 'Brukeren eksisterer allerede',
  },
  Socialsecuritynumberdifit: {
    en: 'Social security number (11 difits)',
    nb: 'Fødselsnummer (11 siffer)',
  },
  Altinnuserpassword: {
    en: 'Altinn user password',
    nb: 'Altinn-brukerpassord',
  },
  DatasystemID: {
    en: 'Data system ID',
    nb: 'Datasystem-ID',
  },
  Datasystempassword: {
    en: 'Data system password',
    nb: 'Datasystempassord',
  },
  FromAltinn: {
    en: 'From Altinn',
    nb: 'Fra Altinn',
  },
  Shareholderregisterstatem: {
    en: 'Shareholder register statement',
    nb: 'Aksjonærregisteroppgaven',
  },
  Theshareholderregistersta: {
    en: 'The shareholder register statement for the income year',
    nb: 'Aksjonærregisteroppgaven for inntektsåret',
  },
  isreadytobesenttoAltinn: {
    en: 'is ready to be sent to Altinn',
    nb: 'er klar til å sendes til Altinn',
  },
  hasbeensenttoAltinnbutitr: {
    en: 'has been sent to Altinn, but it remains to be checked, signed and sent from there to the Norwegian Tax Administration. Link to',
    nb: 'har blitt sendt over til Altinn, men det gjenstår å kontrollere, signere og sende det videre derfra til Skatteetaten. Lenke til',
  },
  hasnotbeensentduetoerror: {
    en: 'has not been sent due to error',
    nb: 'har ikke blitt sendt på grunn av feil',
  },
  SendtoAltinn: {
    en: 'Send to Altinn',
    nb: 'Send til Altinn',
  },
  RestartRecordingWarningTitle: {
    en: 'Recording is restarting ',
    nb: 'Opptaket starter på nytt',
  },
  RestartRecordingWarningText: {
    en: 'The recording has reached the maximum duration in accordance with the settings in the system. Therefore, the recording is automatically stopped and restarted after approximately 10 seconds. You will not lose anything from the recording so far. You do not need to do anything.',
    nb: 'Opptaket har nå nådd maksimal lengde i henhold til innstillingene i systemet. Derfor avsluttes opptaket automatisk og starter på nytt om ca. 10 sekunder. Du mister ingenting av opptaket så langt. Du trenger ikke å gjøre noe.',
  },
  Tryagain: {
    en: 'Try again',
    nb: 'Prøv igjen',
  },
  YouareloggedintoAltinntil: {
    en: 'You are logged into Altinn till',
    nb: 'Du er logget inn i Altinn frem til kl',
  },
  Logout: {
    en: 'Log out',
    nb: 'Logg ut',
  },
  Changesmustbemadeinthesha: {
    en: 'Changes must be made in the shareholder book itself. This is just a preview of the information submitted to Altinn. Go through the points carefully and check that everything is correct before submitting the form. Check in particular capital events such as changes in ownership, capital increases and dividends. Further information about the solution can be found in our',
    nb: 'Endringer må gjøres i selve aksjeeierboken. Dette er bare en forhåndsvisning av informasjonen som sendes inn til Altinn. Gå nøye gjennom punktene og sjekk at alt stemmer før du sender inn skjemaet. Sjekk spesielt kapitalhendelser slik som eierskifte, kapitalforhøyelse og utbytte. Ytterligere informasjon om løsningen, finner du i vår',
  },
  guideforreportingtheShare: {
    en: 'guide for reporting the Shareholder register task (RF-1086) in Orgbrain',
    nb: 'veileder for rapportering av Aksjonærregisteroppgaven (RF-1086) i Orgbrain',
  },
  Fetchdataforthepreviousye: {
    en: 'Fetch data for the previous year',
    nb: 'Hent data for foregående år',
  },
  Hereyoucansendanemailtoal: {
    en: 'Here you can send an e-mail to all company shareholders who have been declared to meet the conditions for the tax incentive scheme when investing in start-up companies. The e-mail will contain the information that appears in item 23 of the shareholder form',
    nb: 'Her kan du sende e-post til alle selskapsaksjonærer som det er oppgitt at oppfyller vilkårene for skatteinsentivordningen ved investering i oppstartsbedrifter. E-posten vil inneholde de opplysningene som fremkommer i post 23 i aksjonærskjemaet',
  },
  Notificationoftaxincentiv: {
    en: 'Notification of tax incentive',
    nb: 'Melding om skatteinsentiv',
  },
  Mainform: {
    en: 'Main form',
    nb: 'Hovedskjema',
  },
  Incomeyear: {
    en: 'Income year',
    nb: 'Inntektsår',
  },
  NoMinuteNotes: {
    en: 'Click to edit',
    nb: 'Klikk for å redigere',
  },
  ISINonlyforcompaniesregis: {
    en: 'ISIN (only for companies registered in VPS)',
    nb: 'ISIN (kun for selskaper registrert i VPS)',
  },
  Companyinformation: {
    en: 'Company information',
    nb: 'Selskapsinformasjon',
  },
  Sharecapitalfortheentirec: {
    en: 'Share capital for the entire company',
    nb: 'Aksjekapital for hele selskapet',
  },
  Sharecapitalinthissharecl: {
    en: 'Share capital in this share class',
    nb: 'Aksjekapital i denne aksjeklassen',
  },
  Nominalvaluepershare: {
    en: 'Nominal value per share',
    nb: 'Pålydende per aksje',
  },
  Numberofsharesinthisshare: {
    en: 'Number of shares in this share class',
    nb: 'Antall aksjer i denne aksjeklassen',
  },
  Paidsharecapitalinthissha: {
    en: 'Paid share capital in this share class',
    nb: 'Innbetalt aksjekapital i denne aksjeklassen',
  },
  Premiumpaidinthissharecla: {
    en: 'Premium paid in this share class',
    nb: 'Innbetalt overkurs i denne aksjeklassen',
  },
  Totalassetvalueforthecomp: {
    en: 'Total asset value for the company',
    nb: 'Total formuesverdi for selskapet',
  },
  Dividends: {
    en: 'Dividends',
    nb: 'Utbytte',
  },
  Distributedtaxdividenddur: {
    en: 'Distributed tax dividend during the income year',
    nb: 'Utdelt skatterettslig utbytte i løpet av inntektsåret',
  },
  Eventtype: {
    en: 'Event type',
    nb: 'Hendelsestype',
  },
  Totaldividenddistributedi: {
    en: 'Total dividend distributed (in this share class)',
    nb: 'Totalt utdelt utbytte (i denne aksjeklassen)',
  },
  Distributeddividendpersha: {
    en: 'Distributed dividend per share',
    nb: 'Utdelt utbytte per aksje',
  },
  Issuanceofsharesuponincor: {
    en: 'Issuance of shares upon incorporation, new issue, new issue upon conversion of receivables, new issue upon intra-group transfer, taxable merger/demerger and transformation into a limited company',
    nb: 'Utstedelse av aksjer ved stiftelse, nyemisjon, nyemisjon ved konvertering av fordring, nyemisjon ved konsernintern overføring, skattepliktig fusjon/fisjon og omdannelse til aksjeselskap',
  },
  Newlyissuedshares: {
    en: 'Newly issued shares',
    nb: 'Nyutstedte aksjer',
  },
  Numberofnewlyissuedshares: {
    en: 'Number of newly issued shares',
    nb: 'Antall nyutstedte aksjer',
  },
  Numberofsharesafter: {
    en: 'Number of shares after',
    nb: 'Antall aksjer etter',
  },
  Premiumpaidpershare: {
    en: 'Premium paid per share',
    nb: 'Innbetalt overkurs per aksje',
  },
  Numberofownsharestransfer: {
    en: 'Number of own shares transferred',
    nb: 'Antall egne aksjer overført',
  },
  Issuanceofsharesbyfundiss: {
    en: 'Issuance of shares by fund issue, split, tax-free merger/demerger and merger/split of share class',
    nb: 'Utstedelse av aksjer ved fondsemisjon, splitt, skattefri fusjon/fisjon og sammenslåing/deling av aksjeklasse',
  },
  Newlyissuedsharesredistri: {
    en: 'Newly issued shares (redistribution)',
    nb: 'Nyutstedte aksjer (omfordeling)',
  },
  Nominalvalueperissuedshar: {
    en: 'Nominal value per issued share',
    nb: 'Pålydende per utstedt aksje',
  },
  ISINShareclass: {
    en: 'ISIN/Shareclass',
    nb: 'ISIN/Aksjeklasse',
  },
  Deletionofsharesinliquida: {
    en: 'Deletion of shares in liquidation, partial liquidation, taxable merger/fission, taxable redemption in relation to tax-free merger/fission and deletion of own shares to cover losses and allocation to funds',
    nb: 'Sletting av aksjer ved likvidasjon, partiell likvidasjon, skattepliktig fusjon/fisjon, skattepliktig innløsning ifm. skattefri fusjon/fisjon og sletting av egne aksjer til dekning av tap og avsetning til fond',
  },
  Deletedshareswithdrawal: {
    en: 'Deleted shares (withdrawal)',
    nb: 'Slettede aksjer (avgang)',
  },
  Numberofdeletedshares: {
    en: 'Number of deleted shares',
    nb: 'Antall slettede aksjer',
  },
  Averagepaidinpremiumperde: {
    en: 'Average paid-in premium per deleted share',
    nb: 'Gjennomsnittlig innbetalt overkurs per slettet aksje',
  },
  TotalremunerationDisburse: {
    en: 'Total remuneration/Disbursed of paid-in capital',
    nb: 'Totalt vederlag/Utbetalt av innbetalt kapital',
  },
  Deletionofsharesintheeven: {
    en: 'Deletion of shares in the event of mergers, tax-free mergers/fissions and mergers/splitting of share classes',
    nb: 'Sletting av aksjer ved spleis, skattefri fusjon/fisjon og sammenslåing/deling av aksjeklasse',
  },
  Deletedsharesredistributi: {
    en: 'Deleted shares (redistribution)',
    nb: 'Slettede aksjer (omfordeling)',
  },
  Nominalvaluepershareafter: {
    en: 'Nominal value per share after splice',
    nb: 'Pålydende per aksje etter spleis',
  },
  Changesinsharecapitalshar: {
    en: 'Changes in share capital/share premium and increase/decrease in nominal value',
    nb: 'Endringer i aksjekapital/overkurs og økning/reduksjon av pålydende',
  },
  Reductionofpaidinpremiumw: {
    en: 'Reduction of paid-in premium with refund to shareholders during the income year',
    nb: 'Nedsettelse av innbetalt overkurs med tilbakebetaling til aksjonærene i løpet av inntektsåret',
  },
  Reductionofpaidinpremium: {
    en: 'Reduction of paid-in premium',
    nb: 'Nedsettelse av innbetalt overkurs',
  },
  Shareholderforms: {
    en: 'Shareholder forms',
    nb: 'Aksjonærskjema',
  },
  Log: {
    en: 'Log',
    nb: 'Logg',
  },
  Youhavenotcreatedashareho: {
    en: 'You have not created a shareholder book',
    nb: 'Du har ikke opprettet aksjeeierbok',
  },
  Youcannotsubmittheassignm: {
    en: "You cannot submit the assignment to Altinn before you have created the share owner's book",
    nb: 'Du kan ikke sende inn oppgaven til Altinn før du har laget aksjeeierbok',
  },
  YouonlyhaveasnapshotIfcap: {
    en: 'You only have a snapshot. If capital changes have occurred since the last snapshot, the Shareholder Book must be updated',
    nb: 'Du kun har et øyeblikksbilde. Har det skjedd kapitalendringer siden siste øyeblikksbilde må Aksjeeierboken oppdateres',
  },
  Companyidentification: {
    en: 'Company identification',
    nb: 'Selskapsidentifikasjon',
  },
  Shareholderinformationnam: {
    en: 'Shareholder information - (name, address, number of shares and dividends)',
    nb: 'Aksjonæropplysninger - (navn, adresse, antall aksjer og utbytte)',
  },
  Shareholdersnameaddressbi: {
    en: "Shareholder's name, address, birth number, organization number, foreign shareholder ID, country code",
    nb: 'Aksjonærens navn, adresse, fødselsnummer, organisasjonsnummer, utenlandsk aksjonær-ID, landskode',
  },
  Shareholderidentification: {
    en: 'Shareholder identification (birth number, organization number)',
    nb: 'Aksjonæridentifikasjon (fødselsnr, org.nr)',
  },
  Countrycode: {
    en: 'Country code',
    nb: 'Landskode',
  },
  Numberofsharespersharehol: {
    en: 'Number of shares per shareholder',
    nb: 'Antall aksjer per aksjonær',
  },
  January: {
    en: '1 January',
    nb: '1 Januar',
  },
  December: {
    en: '31 December',
    nb: '31 Desember',
  },
  Dividendforthisshareholde: {
    en: 'Dividend for this shareholder',
    nb: 'Utbytte for denne aksjonæren',
  },
  Distributedtaxdividendtot: {
    en: 'Distributed tax dividend to the shareholder for this share class (withholding tax is relevant for shareholders domiciled abroad).',
    nb: 'Utdelt skatterettslig utbytte til aksjonæren for denne aksjeklassen (kildeskatt er relevant for aksjonærer hjemmehørende i utlandet).',
  },
  Distributeddividendtotal: {
    en: 'Distributed dividend (total)',
    nb: 'Utdelt utbytte (totalt)',
  },
  Numberofshares: {
    en: 'Number of shares',
    nb: 'Antall aksjer',
  },
  Withholdingtaxin: {
    en: 'Withholding tax in %',
    nb: 'Kildeskatt i %',
  },
  Withholdingtaxinkroner: {
    en: 'Withholding tax in kroner',
    nb: 'Kildeskatt i kroner',
  },
  Withholdingtaxcountrycode: {
    en: 'Withholding tax country code',
    nb: 'Kildeskatt landkode',
  },
  Repaymentofpreviouslypaid: {
    en: 'Repayment of previously paid-in capital',
    nb: 'Tilbakebetaling av tidligere innbetalt kapital',
  },
  'shareholder.TransactionType': {
    en: 'Transaction Type',
    nb: 'Transaksjonstype',
    sv: 'Transaktionstyp',
  },
  Transactionssharesaddedde: {
    en: 'Transactions (shares added/departed) for this shareholder',
    nb: 'Transaksjoner (aksjer i tilgang/avgang) for denne aksjonæren',
  },
  Egpurchasefoundationtaxab: {
    en: 'E.g. purchase, foundation, taxable merger/fission (for a complete overview of transaction types, see the guidance)',
    nb: 'F.eks. kjøp, stiftelse, skattepliktig fusjon/fisjon (for fullstendig oversikt over transaksjonstyper, se rettledningen)',
  },
  Sharesinaccessacquisition: {
    en: 'Shares in access (acquisition)',
    nb: 'Aksjer i tilgang (anskaffelse)',
  },
  Numberofsharesinaccess: {
    en: 'Number of shares in access',
    nb: 'Antall aksjer i tilgang',
  },
  Totalacquisitionvalue: {
    en: 'Total acquisition value',
    nb: 'Total anskaffelsesverdi',
  },
  Giversinheritorsno: {
    en: 'Givers / inheritors no.',
    nb: 'Givers/arvelaters f.nr.',
  },
  Giversorgnr: {
    en: 'Givers org.nr.',
    nb: 'Givers org.nr.',
  },
  Fundissuesplittaxfreemerg: {
    en: 'Fund issue, split, tax-free merger, tax-free demerger and merger/split of share class',
    nb: 'Fondsemisjon, splitt, skattefri fusjon, skattefri fisjon og sammenslåing/deling av aksjeklasse',
  },
  Sharesinaccessbyredistrib: {
    en: 'Shares in access by redistribution.',
    nb: 'Aksjer i tilgang ved omfordeling.',
  },
  Supervisedcompanyorgno: {
    en: 'Supervised. company org.no.',
    nb: 'Overd. selskaps org.nr.',
  },
  SupervisedcompanysISINsha: {
    en: "Supervised. company's ISIN/share class",
    nb: 'Overd. selskaps ISIN/aksjeklasse',
  },
  Supervisedcompanysnominal: {
    en: "Supervised. company's nominal value per share",
    nb: 'Overd. selskaps pålydende per aksje',
  },
  Egsaleliquidationtaxablem: {
    en: 'E.g. sale, liquidation, taxable merger/fission (for a complete overview of transaction types, see the guidelines)',
    nb: 'F.eks. salg, likvidasjon, skattepliktig fusjon/fisjon (for fullstending oversikt over transaksjonstyper, se rettledningen)',
  },
  Sharesonsale: {
    en: 'Shares on sale',
    nb: 'Aksjer i avgang',
  },
  Numberofsharessold: {
    en: 'Number of shares sold',
    nb: 'Antall aksjer i avgang',
  },
  TotalconsiderationDisburs: {
    en: 'Total consideration/Disbursed of paid-in ch.',
    nb: 'Totalt vederlag/Utbetalt av innbetalt kap.',
  },
  RecipientsIDno: {
    en: "Recipient's ID no.",
    nb: 'Mottakers f.nr.',
  },
  Recipientsorganizationno: {
    en: "Recipient's organization no.",
    nb: 'Mottakers org.nr.',
  },
  Mergertaxfreemergertaxfre: {
    en: 'Merger, tax-free merger, tax-free demerger and merger/split of share class',
    nb: 'Spleis, skattefri fusjon, skattefri fisjon og sammenslåing/deling av aksjeklasse',
  },
  Sharesinretirementduetore: {
    en: 'Shares in retirement due to redistribution.',
    nb: 'Aksjer i avgang ved omfordeling.',
  },
  Numberofsharesinretiremen: {
    en: 'Number of shares in retirement',
    nb: 'Antall aksjer i avgang',
  },
  Changeinsharecapitalandsh: {
    en: 'Change in share capital and share premium - payments and receipts',
    nb: 'Endring i aksjekapital og overkurs - utbetalinger og innbetalinger',
  },
  Refundedpreviouslypaidpre: {
    en: 'Refunded previously paid premium for the shares',
    nb: 'Tilbakebetalt tidligere innbetalt overkurs for aksjene',
  },
  Fetchtheinitialvalueforpo: {
    en: "Fetch the initial value for post 6 from last year's form from Altinn",
    nb: 'Hent inngangsverdien for post 6 fra fjorårets skjema fra Altinn',
  },
  Pleaseconfirmthatthevalue: {
    en: 'Please confirm that the values for paid-in share capital in post 5 and paid-in premium in post 6 are correct. They should be identical to the initial values of the previous year.',
    nb: 'Vennligst bekreft at verdiene for innbetalt aksjekapital i post 5 og innbetalt overkurs i post 6 er korrekte. De skal være identiske med utgangsverdiene for foregående år.',
  },
  Correctpremium: {
    en: 'Confirm values in post 5 and post 6?',
    nb: 'Bekreft verdier i post 5 og post 6?',
  },
  Sincethisyearhasachangeof: {
    en: 'Since this year has a change of share class event, Orgbrain doesn’t have enough information to compute the Post 6. This is because the distribution of premiums to the new share class is unknown.<br/><br/>You need to manually set the Post 6 values for the shareclasses in the Altinn interface before submitting the form to Skatteetaten. Remember that Post 9 and Post 13 can also affect the value of Post 6 in addition to the initial distribution of premium to shareclasses.',
    nb: 'Siden det i år er en hendelse med endring av aksjeklasser, har ikke Orgbrain tilstrekkelig informasjon til å beregne Post 6. Dette skyldes at fordelingen av overkurs til den nye aksjeklassen er ukjent.<br/><br/>Du må manuelt angi verdiene for Post 6 for aksjeklassene i Altinn-grensesnittet før du sender inn skjemaet til Skatteetaten. Husk at Post 9 og Post 13 også kan påvirke verdien i Post 6 i tillegg til den opprinnelige fordelingen av overkurs til aksjeklassene!',
  },
  Emailnotificationtoinvest: {
    en: 'Email notification to investors (not required)',
    nb: 'E-postmelding til investorer (ikke påkrevd)',
  },
  Taxdeductionsforinvestmen: {
    en: 'Tax deductions for investment in {{orgName}}',
    nb: 'Skattefradrag ved investering i {{orgName}}',
  },
  Whensubmittingthesharehol: {
    en: 'When submitting the shareholder register statement (RF-1086) for {{year}}, we have reported that {{entityName}} participated in a capital increase in {{orgName}} and fulfills the conditions for tax incentive scheme when investing in start-up companies, cf. Tax Act section 6 -53.',
    nb: 'Ved innsendingen av aksjonærregisteroppgaven (RF-1086) for {{year}}, har vi meldt inn at {{entityName}} deltok i kapitalforhøyelse i {{orgName}} og oppfyller vilkårene for skatteinsentivordning ved investering i oppstartsbedrifter, jf. skatteloven § 6-53.',
  },
  Inorderforpersonalshareho: {
    en: 'In order for personal shareholders in {{entityName}} to receive the deduction, this must also be reported in the shareholder register statement for {{entityName}}.',
    nb: 'For at personlige aksjonærer i {{entityName}} skal få fra fradraget må dette også rapporteres i aksjonærregisteroppgaven for {{entityName}}.',
  },
  TheeventtypeDeductionfori: {
    en: 'The event type "Deduction for investment in start-up company" must be used in item 23 of the shareholder register statement for all the investment company\'s personal owners who can claim the deduction in their tax return. If there are several personal owners in the investment company, the basis for deduction must be entered according to the shareholders\' share of ownership.',
    nb: 'Det skal benyttes hendelsestype «Fradrag for investering i oppstartsselskap» i post 23 i aksjonærregisteroppgaven for alle investeringsselskapets personlige eiere som kan kreve fradraget i sin skattemelding. Dersom det er flere personlige eiere i investeringsselskapet, må fradragsgrunnlaget føres etter aksjonærenes eierandel.',
  },
  Thefollowinginformationmu: {
    en: 'The following information must be filled in {{entityName}} in item 23 of the shareholder register statement:',
    nb: 'Følgende opplysninger skal {{entityName}} fylle inn i post 23 i aksjonærregisteroppgaven:',
  },
  Acquisitionvalueintotal: {
    en: 'Acquisition value in total',
    nb: 'Anskaffelsesverdi totalt',
  },
  Issuersorganizationnumber: {
    en: "Issuer's organization number",
    nb: 'Avgivers organisasjonsnummer',
  },
  Deductionforinvestmentina: {
    en: 'Deduction for investment in a start-up company',
    nb: 'Fradrag for investering i oppstartsselskap',
  },
  nameofinvestorsinvestment: {
    en: "<name of investor's investment company>",
    nb: '<navn på investors investeringsselskap>',
  },
  Timeinitem: {
    en: '<Time in item 23>',
    nb: '<Tidspunkt i post 23>',
  },
  Totalacquisitionvalueinit: {
    en: '<Total acquisition value in item 23>',
    nb: '<Total anskaffelsesverdi i post 23>',
  },
  Messagetext: {
    en: '<Message text>',
    nb: '<Meldingstekst>',
  },
  Enterthepersonalpasswordy: {
    en: 'Enter the personal password you created on Altinn when you set up the connection between Altinn and Orgbrain. Further information about the connection between Orgbrain and Altinn can be found in our',
    nb: 'Skriv inn det personlige passordet du opprettet på Altinn da du satte opp tilkoblingen mellom Altinn og Orgbrain. Ytterligere informasjon om tilkoblingen mellom Orgbrain og Altinn, finner du i vår',
  },
  guideforconnectionbetween: {
    en: 'guide for connection between Orgbrain and Altinn',
    nb: 'veileder for tilkobling mellom Orgbrain og Altinn',
  },
  Seehereforhowtocreatesuch: {
    en: 'See here for how to create such a password',
    nb: 'Se her for hvordan du oppretter et slikt passord',
  },
  Ihaveforgottenthepassword: {
    en: 'I have forgotten the password',
    nb: 'Jeg har glemt passordet',
  },
  Selectloginmethod: {
    en: 'Select login method',
    nb: 'Velg innloggingsmetode',
  },
  Pincodeletter: {
    en: 'Pin code letter',
    nb: 'Altinn kodebrev',
  },
  Pincode: {
    en: 'Pin code',
    nb: 'Pinkode',
  },
  Login: {
    en: 'Log in',
    nb: 'Logg inn',
  },
  ConfigureyouAltinncredent: {
    en: 'Configure you Altinn credentials',
    nb: 'Konfigurer din Altinn-legitimasjon',
  },
  LoginintoAltinn: {
    en: 'Log in into Altinn',
    nb: 'Logg inn i Altinn',
  },
  Enterpincode: {
    en: 'Enter pin code',
    nb: 'Skriv inn pinkode',
  },
  Newclaim: {
    en: 'New claim',
    nb: 'Ny pant',
  },
  Attachafile: {
    en: 'Attach a file',
    nb: 'Legg ved fil',
  },
  Claims: {
    en: 'Claims',
    nb: 'Pant',
  },
  SignedDocuments: {
    en: 'Signed Documents',
    nb: 'Signerte dokumenter',
  },
  Downloadsigneddocuments: {
    en: 'Download signed documents',
    nb: 'Last ned signerte dokumenter',
  },
  Orderform: {
    en: 'Order form',
    nb: 'Bestillingsblankett',
  },
  DownloadOrderform: {
    en: 'Download order form',
    nb: 'Last ned bestillingsblankett',
  },
  Formfororderingshares: {
    en: 'Form for ordering shares',
    nb: 'Blankett for bestilling av aksjer',
  },
  Thesubscriptionpriceforth: {
    en: 'The subscription price for the capital increase has been set to',
    nb: 'Tegningskursen ved kapitalforhøyelsen er satt til',
  },
  Priortothecapitalincrease: {
    en: 'Prior to the capital increase,',
    nb: 'Før kapitalforhøyelsen er det utstedt',
  },
  shareshavebeenissuedinthe: {
    en: 'shares have been issued in the company.',
    nb: 'aksjer i Selskapet',
  },
  Editorderform: {
    en: 'Edit order form',
    nb: 'Rediger bestillingsblanketten',
  },
  Therearefieldsintheformth: {
    en: 'There are missing fields in the form',
    nb: 'Det mangler informasjon',
  },
  TherearefieldsintheformthText: {
    en: 'Some fields in the form are not filled out. Confirm that you want to continue anyway.',
    nb: 'Noen felt i skjemaet er ikke fylt ut. Bekreft at du ønsker å fortsette likevel.',
  },
  NoAttachmentAdded: {
    en: 'Have you added all attachments?',
    nb: 'Alle vedlegg lagt til?',
  },
  NoAttachmentAddedText: {
    en: 'Make sure that you attach the documents to be sent to the investors together with the order form, such as articles of association, accounts or shareholder agreements. You can also add attachments later.',
    nb: 'Pass på at du legger ved dokumentene som skal sendes til investorene sammen med bestillingsblanketten, for eksempel vedtekter, regnskap eller aksjonæravtale. Du kan også legge til vedlegg senere.',
  },
  AmountInvestorsSigned: {
    en: 'Amount of invited investors who have signed',
    nb: 'Antall inviterte investorer som har signert',
  },
  Startoforderperiod: {
    en: 'Start of order period',
    nb: 'Dato for start av bestillingsperioden',
  },
  Endoforderperiod: {
    en: 'End of order period',
    nb: 'Dato for slutt av bestillingsperioden',
  },
  Endtimeoforderperiod: {
    en: 'End time of order period',
    nb: 'Slutttidspunkt for bestillingsperioden',
  },
  Estimateofordernotifcatio: {
    en: 'Estimate of order notifcation',
    nb: 'Estimert dato for betalingsvarsel',
  },
  Companyaccountnumber: {
    en: 'Company account number',
    nb: 'Kontonummer',
  },
  Estimatedpaymentdate: {
    en: 'Estimated payment date',
    nb: 'Estimert betalingsdato',
  },
  Iwehavereceivedreviewedan: {
    en: 'I / we have received, reviewed and understood the shareholder agreement that the Company has established with other shareholders prior to this capital increase and accedes to it.',
    nb: 'jeg/vi har mottatt, gjennomgått og forstått aksjonæravtalen som Selskapet har etablert med øvrige aksjonærer i forkant av denne kapitalforhøyelsen og tiltrer denne.',
  },
  Youarechangingtheparamete: {
    en: 'You are changing the parameters',
    nb: 'Du endrer parametrene',
  },
  Makesurethattheorderformi: {
    en: 'Make sure that the order form is updated so that it corresponds to new values.',
    nb: 'Pass på at bestillingsblanketten oppdateres slik at den stemmer overens med nye verdier.',
  },
  New: {
    en: 'New',
    nb: 'Ny',
  },
  Textinemailinvitation: {
    en: 'Text in e-mail invitation',
    nb: 'Tekst i e-postinvitasjon',
  },
  Instructionsforsurvey: {
    en: 'Instructions for survey',
    nb: 'Instruksjoner for undersøkelse',
  },
  Answersgivenasfreetext: {
    en: 'Answers given as free text',
    nb: 'Svar gitt som fritekst',
  },
  Freeanswer: {
    en: 'Free form',
    nb: 'Fritekst',
  },
  Doyoureallywanttodeleteth: {
    en: 'Do you really want to delete the report and evaluation?',
    nb: 'Ønsker du virkelig å slette rapporten og evalueringen?',
  },
  Zoomlevel: {
    en: 'Zoom level',
    nb: 'Zoomnivå',
  },
  Hour: {
    en: 'Hour',
    nb: 'Time',
  },
  Day: {
    en: 'Day',
    nb: 'Dag',
  },
  Week: {
    en: 'Week',
    nb: 'Uke',
  },
  Year: {
    en: 'Year',
    nb: 'År',
  },
  Uploadfilesrelevanttothet: {
    en: 'Upload files relevant to the task.',
    nb: 'Her kan du laste opp filer som er relevante for oppgaven.',
  },
  Sendtoresponsible: {
    en: 'Send to responsible',
    nb: 'Send til ansvarlig',
  },
  NOTEIfyoucheckheretheenti: {
    en: 'NOTE: If you check here, the entire text will be visible in e-mails sent to the recipients. If not checked, only the title will be visible in the email',
    nb: 'OBS: Dersom du krysser av her, vil hele teksten bli synlig i e-post som sendes mottakerne. Hvis du ikke krysser av, vil kun tittelen være synlig i e-posten',
  },
  Seecommentinemail: {
    en: 'See comment in email',
    nb: 'Vis kommentaren i e-posten',
  },
  AnemailwillbesentTheemail: {
    en: 'An email will be sent. The e-mail will contain the text you have entered. Be careful about adding sensitive information to the message',
    nb: 'En e-post blir sendt. E-posten vil inneholde teksten du har lagt inn. Vær forsiktig med å legge sensitiv informasjon i meldingen',
  },
  Anemailwillbesent: {
    en: 'An email will be sent.',
    nb: 'En e-post blir sendt.',
  },
  Alreadynotified: {
    en: 'Already notified',
    nb: 'Allerede varslet',
  },
  Entercommentsquestionsans: {
    en: 'Enter comments, questions, answers etc., visible to everyone who has access to the task.',
    nb: 'Her kan du legge inn en kommentarer, spørsmål, svar, o.l., som er synlig for alle som har tilgang til oppgaven.',
  },
  Thistaskhasthereferenceto: {
    en: 'This task has the reference to a file',
    nb: 'Denne oppgaven har referanse til en fil',
  },
  Informationaboutthisform: {
    en: 'Information about this form',
    nb: 'Informasjon om dette skjemaet',
  },
  Editingmodefortemplatetex: {
    en: 'Editing mode for template text',
    nb: 'Redigeringsmodus for maltekst',
  },
  Aftereditingtemplatetexty: {
    en: 'After editing template text, you can not revert to changes via the form fields',
    nb: 'Etter redigering av maltekst kan du ikke gå tilbake til endringer via skjemafeltene',
  },
  Ifyouhavesavedapreviousdr: {
    en: 'If you have saved a previous draft using «Save unfinished draft», you can retrieve the draft here',
    nb: 'Dersom du har lagret et tidligere utkast ved bruk av «Lagre uferdig utkast», kan du her hente tilbake utkastet',
  },
  Hereyoucansaveadraftofate: {
    en: 'Here you can save a draft of a template that you have not completely finished. It is only possible to save one draft, and only you will have access to the draft. You can retrieve the draft by clicking on «Restore unfinished draft».',
    nb: 'Her kan du lagre et utkast til en mal du ikke helt er ferdig med. Det er kun mulig å lagre ett utkast, og bare du vil ha tilgang til utkastet. Du kan hente tilbake utkastet ved å klikke på «Gjenopprett uferdig utkast».',
  },
  Edittemplatetext: {
    en: 'Edit template text',
    nb: 'Rediger malteksten',
  },
  Hereyoucansavethedocument: {
    en: 'Here you can save the document in PDF format in the data room. The system will automatically suggest a folder, but you can easily select another folder.',
    nb: 'Her kan du lagre dokumentet i PDF-format i datarommet. Systemet vil automatisk foreslå en mappe, men du kan enkelt velge en annen mappe.',
  },
  SavePDF: {
    en: 'Save PDF',
    nb: 'Lagre PDF',
  },
  Pleasewriteafilename: {
    en: 'Please write a file name',
    nb: 'Vennligst skriv et filnavn',
  },
  Templates: {
    en: 'Templates',
    nb: 'Maler',
  },
  Howitworks: {
    en: 'How it works',
    nb: 'Slik fungerer det',
  },
  Selectthetemplateyouwantt: {
    en: 'Select the template you want to use',
    nb: 'Velg malen du ønsker å benytte',
  },
  Enteryourinformationinthe: {
    en: 'Enter your information in the form fields',
    nb: 'Legg inn dine opplysninger i skjemafeltene',
  },
  Youcantheneditthetemplate: {
    en: 'You can then edit the template text',
    nb: 'Du kan deretter redigere selve malteksten',
  },
  Userswithadministratoracc: {
    en: 'Users with administrator access can now finalize the PDF and save the form in the Data Room.',
    nb: 'De som er gitt admin-tilgang, kan nå ferdigstille PDF og lagre skjemaet i datarommet. Øvrige brukere kan kopiere teksten til et tekstdokument for ferdigstillelse.',
  },
  Notemplatesyet: {
    en: 'No templates yet',
    nb: 'Ingen maler ennå',
  },
  Savedtemplates: {
    en: 'Saved templates',
    nb: 'Lagrede maler',
  },
  Nosavedtemplatesyet: {
    en: 'No saved templates yet',
    nb: 'Ingen lagrede maler ennå',
  },
  Editdocumentagain: {
    en: 'Edit document again',
    nb: 'Rediger dokumentet på nytt',
  },
  ShowPDF: {
    en: 'Show PDF',
    nb: 'Vis PDF',
  },
  Newpassword: {
    en: 'New password',
    nb: 'Nytt passord',
  },
  Repeatnewpassword: {
    en: 'Repeat new password',
    nb: 'Repeter nytt passord',
  },
  Registrationinviteisexpir: {
    en: 'Registration invite is expired, please contact the admin to get a new invite',
    nb: 'Registreringsinvitasjonen er utløpt, kontakt administratoren for å få en ny invitasjon',
  },
  Editmessage: {
    en: 'Edit message',
    nb: 'Rediger melding',
  },
  Meetingchat: {
    en: 'Meeting chat',
    nb: 'Møtechat',
  },
  BoardChat: {
    en: 'Board Chat',
    nb: 'Styrechat',
  },
  Groupchat: {
    en: 'Group chat',
    nb: 'Gruppechat',
  },
  Enteryourtexthere: {
    en: 'Enter your text here',
    nb: 'Skriv inn teksten din her',
  },
  Updatefilestatus: {
    en: 'Update file status',
    nb: 'Oppdater filstatus',
  },
  Thereisafileattachedtothi: {
    en: 'There is a file attached to this task. It is possible to update the seller and/or buyer status to Completed for this file.',
    nb: 'Det er vedlagt en fil til denne oppgaven. Det er mulig å oppdatere selger- og/eller kjøperstatus til Fullført for denne filen.',
  },
  Sellerstatus: {
    en: 'Seller status',
    nb: 'Status selger',
  },
  Buyerstatus: {
    en: 'Buyer status',
    nb: 'Status kjøper',
  },
  Setthisstatusonallunderly: {
    en: 'Set this status on all underlying folders and files',
    nb: 'Sett denne statusen på alle underliggende mapper og filer',
  },
  Typetofind: {
    en: 'Type to find',
    nb: 'Skriv for å finne',
  },
  Copyvaluetoclipboard: {
    en: 'Copy value to clipboard',
    nb: 'Kopier verdien til utklippstavlen',
  },
  Cleanthefilter: {
    en: 'Clean the filter',
    nb: 'Rengjør filteret',
  },
  Copied: {
    en: 'Copied',
    nb: 'Kopiert',
  },
  Searchorganization: {
    en: 'Search organization',
    nb: 'Søk organisasjon',
  },
  Dragtoresizevideo: {
    en: 'Drag to resize video',
    nb: 'Dra for å endre størrelse på video',
  },
  Collapsevideo: {
    en: 'Collapse video',
    nb: 'Skjul videoen',
  },
  Fullwindowvideo: {
    en: 'Full window video',
    nb: 'Full vindu video',
  },
  Showvideo: {
    en: 'Show video',
    nb: 'Vis video',
  },
  Helpandsupport: {
    en: 'Help and support',
    nb: 'Hjelp og support',
  },
  HelpandsupportDesc: {
    en: 'This is where you can get support for Orgbrain. You can visit our support page that provides different information about Orgbrain, or you can contact us directly via email or phone. You can also choose to get one of our tour guides',
    nb: 'Her kan du få support for Orgbrain. Du kan besøke vår supportside, eller du kan kontakte oss direkte via e-post eller telefon. Du kan også velge å få en av våre omvisninger',
  },
  HelpandsupportIntro: {
    en: 'Orbrain offers support in several ways:',
    nb: 'Orgbrain tilbyr brukerstøtte på flere måter:',
  },
  HelpandsupportP1: {
    en: 'On the homepage (Dashboard) you will find a chat in the lower right corner.',
    nb: 'På startsiden (Dashboard) finner du en chat nede til høyre.',
  },
  HelpandsupportP2: {
    en: 'You can go to our support page for access to tutorial videos and step-by-step guides.',
    nb: 'Du kan gå til vår supportside for tilgang til veiledningsvideoer og trinnvise guider.',
  },
  HelpandsupportP3: {
    en: 'You can also contact us at support@orgbrain.no or call us at 22 12 00 28.',
    nb: 'Du kan også kontakte oss på support@orgbrain.no eller ringe oss på telefon 22 12 00 28.',
  },
  HelpandsupportP4: {
    en: 'If you want to get a tour guide, you can select one of the tours below.',
    nb: 'Nederst finner du produktomvisninger som gir deg veiledning direkte på den siden du trenger hjelp til.',
  },
  TourGuideListDesc: {
    en: 'Select a product tour from the list below.',
    nb: 'Velg en produktomvisning fra listen under.',
  },
  HelpandsupportLink: {
    en: 'Go to support page',
    nb: 'Gå til supportsiden',
  },
  BoardLibrary: {
    en: 'Board Library',
    nb: 'Styrebibliotek',
  },
  'templates.Created': {
    en: 'Created',
    nb: 'Laget',
  },
  BoardSchool: {
    en: 'Board School',
    nb: 'Styreskolen',
  },
  Boardblog: {
    en: 'Board blog',
    nb: 'Styrebloggen',
  },
  Alltemplates: {
    en: 'All templates',
    nb: 'Alle maler',
  },
  CreateaNewSurvey: {
    en: 'Create a New Survey',
    nb: 'Lag nytt skjema',
  },
  OrgbrainNews: {
    en: 'News and information',
    nb: 'Nyheter og informasjon',
  },
  OrgbrainTemplates: {
    en: 'Orgbrain Templates',
    nb: 'Orgbrain Maler',
  },
  LatestNews: {
    en: 'Latest news',
    nb: 'Siste nytt',
  },
  OrgbrainAcademy: {
    en: 'Orgbrain Academy',
    nb: 'Orgbrain Academy',
  },
  NEW: {
    en: 'NEW',
    nb: 'NY',
  },
  Boardinsurance: {
    en: 'Board insurance',
    nb: 'Styreansvarsforsikring',
  },
  TransparencyAct: {
    en: 'Transparency Act',
    nb: 'Åpenhetsloven',
  },
  TransparencyActHeader: {
    en: 'Get control of the Transparency Act',
    nb: 'Få kontroll på åpenhetsloven',
  },
  TransparencyActTitle: {
    en: 'Get control of the Transparency Act with Tavler',
    nb: 'Få kontroll på åpenhetsloven med Tavler',
  },
  TransparencyActText: {
    en: 'The Transparency Act does not have to be complicated. By using Tavler, you get a digital tool that systematizes the work - and makes it easy to follow up.',
    nb: 'Åpenhetsloven trenger ikke å være komplisert. Bruker man Tavler får man et digitalt verktøy som systematiserer arbeidet  -  og gjør det enkelt å følge opp.',
  },
  TransparencyActCTA: {
    en: 'Learn more',
    nb: 'Les mer',
  },
  Carbonaccounting: {
    en: 'Carbon accounting',
    nb: 'Klimaregnskap',
  },
  NotRespondedto: {
    en: 'Not Responded to',
    nb: 'Ubesvart',
  },
  Supporthistory: {
    en: 'Support history',
    nb: 'Historikk',
  },
  User: {
    en: 'User',
    nb: 'Bruker',
    sv: 'Användare',
  },
  newPhoneNumberValidationText: {
    en: 'To validate your new number an  SMS message code will be sent.',
    nb: 'For å validere ditt nye nummer vil du motta en SMS med en kode.',
  },
  bodyEntercode: {
    en: 'You should have received an SMS message with a code. Please enter that code below to register the phone as yours.',
    nb: 'Du skal ha mottatt en SMS med en kode. Vennligst skriv inn koden nedenfor for å registrere telefonen som din.',
  },
  sendCode: { en: 'Send code', nb: 'Send kode' },
  resendCode: { en: 'Resend code', nb: 'Send kode på nytt' },
  submitCodeText: { en: 'Submit', nb: 'Send kode' },
  Event: {
    en: 'Event',
    nb: 'Hendelse',
  },
  turnedonGrantOrgbrainacce: {
    en: 'Granted support access.',
    nb: 'Ga supporttilgang.',
  },
  turnedoffGrantOrgbrainacc: {
    en: 'Revoked support access.',
    nb: 'Fjernet supporttilgang.',
  },
  GrantOrgbrainaccessOff: {
    en: 'Grant support access (Off)',
    nb: 'Gi supporttilgang (Av)',
  },
  GrantOrgbrainaccessOn: {
    en: 'Grant support access (On)',
    nb: 'Gi supporttilgang (På)',
  },
  WhenyouactivatetheGrantOr: {
    en: 'When you activate the "Grant Support Access" switch, you give Orgbrain users permission to register as a support user in the portal. This permission provides the support user with full administrator access. Orgbrain will only use this access to assist you with what you have requested help with. You can revoke this access at any time by turning off the switch.',
    nb: 'Når du aktiverer bryteren «Gi supporttilgang», gir du brukere hos Orgbrain tillatelse til å legge seg inn som supportbrukere i portalen. Tillatelsen gir brukeren full administratortilgang. Orgbrain vil kun bruke denne tilgangen til å hjelpe deg med det du har bedt om hjelp med. Du kan fjerne denne tilgangen når som helst ved å slå av bryteren.',
  },
  CaseInformation: {
    en: 'Comment',
    nb: 'Saksopplysning',
  },

  EditTimeSlots: {
    nb: 'Rediger tidspunkter og inviter flere',
    en: 'Edit time slots and invite more',
  },
  'services.Pleaseenteracomment': {
    en: 'Please enter a comment',
    nb: 'Her kan du legge inn informasjon om hva saken gjelder',
  },
  EnableVoting: {
    en: 'Change your votes',
    nb: 'Endre på dine stemmer',
  },
  ShowOverview: {
    en: 'Voting overview',
    nb: 'Stemmeoversikt',
  },
  TimeSlotSortBy: {
    en: 'Sort by',
    nb: 'Sorter etter',
  },
  TimeSlotScoreSort: {
    en: 'Relevance',
    nb: 'Relevans',
  },
  TimeSlotUnanswered: {
    nb: 'Ubesvart',
    en: 'Unanswered',
  },
  TimeSlotVoteFor: {
    nb: 'Passer',
    en: 'Works',
  },
  TimeSlotVoteNeutral: {
    en: 'Neutral',
    nb: 'Kan passe',
  },
  TimeSlotVoteDigital: {
    en: 'Digital',
    nb: 'Kan digitalt',
  },
  Digital: {
    en: 'Digital',
    nb: 'Digital',
  },
  TimeSlotVoteAgainst: {
    en: 'Not possible',
    nb: 'Passer ikke',
  },

  NotFinishedVoting1: {
    en: 'You have not voted on all time slots yet. Click ',
    nb: 'Du har ikke stemt på alle tidspunktene enda. Klikk ',
  },
  NotFinishedVoting2: {
    en: ' to vote on the time slots you have not voted on yet.',
    nb: ' for å stemme på de tidspunktene du ikke har stemt på enda.',
  },
  Pleaseenteracomment: {
    en: 'Please enter a comment',
    nb: 'Her kan du legge inn informasjon om hva saken gjelder',
  },
  Hereyoucancreateataskwhic: {
    en: 'Here you can create a task, which can be a desire to answer a question ("Q&A"), that is related to this file or folder, and that will appear under "Tasks" in the left menu.',
    nb: 'Her kan du lage en oppgave, som kan være et ønske om å besvare et spørsmål («Q&A»), som er knyttet til denne filen eller mappen, og som legger seg under «Oppgaver» i venstremenyen.',
  },
  Startsat: {
    en: 'Starts at',
    nb: 'Oppstart',
  },
  Search: {
    en: 'Search',
    nb: 'Søk',
    sv: 'Sök',
  },
  Finishediting: {
    en: 'Finish editing',
    nb: 'Avslutt redigering',
  },
  Addyourvariant: {
    en: 'Add your variant',
    nb: 'Legg til din variant',
  },
  Responseoptions: {
    en: 'Response options',
    nb: 'Svaralternativer',
  },
  Responseoption: {
    en: 'Response option',
    nb: 'Svaralternativ',
  },
  Addoption: {
    en: 'Add option',
    nb: 'Nytt alternativ',
  },
  CopyCurrentQuestion: {
    en: 'Copy Question',
    nb: 'Kopier spørsmål',
  },
  Allowgivinganswersasfreet: {
    en: 'Enable free text alternative',
    nb: 'Tillat å gi svar som fritekst',
  },
  Entertextwhichisdisplayed: {
    en: 'Enter text which is displayed below the response in the final report. This can be information about how the specific questions should be interpreted.',
    nb: 'Her kan du legge inn tekst som vises under svaret i sluttrapporten. Dette kan for eksempel være informasjon om hvordan det konkrete svaret skal tolkes.',
  },
  Givethequestionaheadline: {
    en: 'Give the question a headline.',
    nb: 'Her kan gir du spørsmålene en overskrift. For eksempel har Orgbrain sin styreevaluering overskrifter som «Virksomheten», «Styrekollegiet», «Styremøter» osv.',
  },
  Enterthenumberofchoicesth: {
    en: 'Enter the number of choices the respondent can check. Generally, it is appropriate to have only one answer choice.',
    nb: 'Her legger du inn hvor mange svaralternativer respondenten kan krysse av for på spørsmålet. Ofte vil det være hensiktsmessig å bare ha ett svaralternativ',
  },
  Entertheanswerchoicesasso: {
    en: 'Enter the answer choices associated with the question. You can add more options by clicking “Add option”.',
    nb: 'Her legger du inn svaralternativene som er koblet opp til spørsmålet. Du kan legge inn flere svaralternativer ved å klikke på «Legg til».',
  },
  Allowparticipantstoprovid: {
    en: 'Allow participants to provide open-text answers. If you want to allow both open-text answers and answers to other questions, you must put the number “2” or higher in the “Maximum answers” field.',
    nb: 'Her kan du gi deltakerne mulighet til å gi svar som fritekst. Dersom det både skal være mulig å svare som fritekst og gi svar på øvrige spørsmål, må du minimum ha tallet 2 i feltet «Maksimale svar»',
  },
  Addnewquestion: {
    en: 'Add new question',
    nb: 'Legg til nytt spørsmål',
  },
  Createacopyofthesurvey: {
    en: 'Create a copy of the survey',
    nb: 'Lag kopi av skjema',
  },
  Untitledsurvey: {
    en: 'Untitled survey',
    nb: 'Spørreskjema uten navn',
  },
  Doyouwanttoremovethisacce: {
    en: 'Do you want to remove this access?',
    nb: 'Ønsker du å fjerne denne tilgangen?',
  },
  Downloaddata: {
    en: 'Download data?',
    nb: 'Last ned data?',
  },
  Congratulations: {
    en: 'Congratulations',
    nb: 'Gratulerer',
  },
  Youareabouttodownloadthes: {
    en: 'You are about to download the selected files as a zip file. The download link is valid for 5 minutes. Do you want to continue?',
    nb: 'Du er i ferd med å laste ned de valgte filene som en zip-fil. Nedlastingslenken er gyldig i 5 minutter. Ønsker du å fortsette?',
  },
  Yourdataisdownloadedandre: {
    en: 'Your data is downloaded and ready. The download link is valid for 5 minutes.',
    nb: 'Dataene dine er lastet ned og klare. Nedlastingskoblingen er gyldig i 5 minutter.',
  },
  Downloadfile: {
    en: 'Download file',
    nb: 'Last ned fil',
  },
  Deletingfiles: {
    en: 'Deleting files',
    nb: 'Sletter filer',
  },
  Close: {
    en: 'Close',
    nb: 'Lukk',
    sv: 'Stäng',
  },
  Youcangotoataskbyclicking: {
    en: 'You can go to a task by clicking on the task name',
    nb: 'Du kan gå til en oppgave ved å klikke på oppgavenavnet',
  },
  Deviation: {
    en: 'Deviation',
    nb: 'Avvik',
  },
  Inprocess: {
    en: 'In process',
    nb: 'I prosess',
  },
  CompletedNA: {
    en: 'Completed / NA',
    nb: 'Fullført / NA',
  },
  Showingonlyfilesthatyouha: {
    en: 'Showing only files that you have access to',
    nb: 'Viser bare filer du har tilgang til',
  },
  Hereyoucaneasilygetanover: {
    en: 'Here you can easily get an overview of the status of the underlying folders and files entered in the data room.',
    nb: 'Her kan du på en enkel måte få oversikt over hvilken status de underliggende mapper og filer som er lagt inn i datarommet har.',
  },
  Foldersstatus: {
    en: 'Folders status',
    nb: 'Status mapper',
  },
  Filesstatus: {
    en: 'Files status',
    nb: 'Status filer',
  },
  Thisisthefilterthatyouhav: {
    en: 'This is the filter that you have created. You can delete this by clicking the cross, or change the criteria by clicking the button.',
    nb: 'Dette er filter som du har opprettet. Du kan slette dette ved å klikke på krysset, eller endre kriteriene ved å klikke på knappen.',
  },
  Thedataroomusesatrafficli: {
    en: 'The data room uses a "traffic light system" with color codes to keep control of the status of the documents, where green indicates "completed/approved/not applicable", yellow indicates "status in process/must be completed" and red color is used for "deviation/for follow-up".',
    nb: 'Datarommet benytter et «trafikklyssystem» med fargekoder for å holde kontroll på status på dokumentene, der grønn indikerer «fullført/godkjent/ikke aktuelt», gul indikerer «i prosess/må ferdigstilles» og rød farge benyttes ved «avvik/til oppfølging».',
  },
  Downloadasziparchive: {
    en: 'Download as zip archive',
    nb: 'Last ned som zip-arkiv',
  },
  Removeselectedfilesfolder: {
    en: 'Remove selected files/folders',
    nb: 'Fjern valgte filer/mapper',
  },
  Copyselectedfilesfolderst: {
    en: 'Copy selected files/folders to poste buffer',
    nb: 'Kopier valgte filer/mapper til utklippsbuffer',
  },
  Seewhichfolderlevelyouare: {
    en: 'See which folder level you are at within the Data Room. Click on a specific folder level to go directly to it.',
    nb: 'Her ser du hvilke mappenivå du er på i datarommet. Du kan klikke på et konkret mappenivå for å gå direkte til det.',
  },
  Sharewith: {
    en: 'Share with',
    nb: 'Delt med',
  },
  Allowotherstomakechanges: {
    en: 'Allow others to make changes',
    nb: 'Tillat andre å gjøre endringer',
  },
  Decidewhetheradministrato: {
    en: 'Decide whether administrators in the organizations, which have access to the folder, should have the ability to add files, delete files, and make other changes in the folder, or if they should only have reading access.',
    nb: 'Her kan du bestemme om administratorer i de organisasjoner som har tilgang til mappen skal ha mulighet for å legge inn filer, slette filer og gjøre andre endringer i mappen, eller om de bare skal ha lesetilgang.',
  },
  Allusershaveaccess: {
    en: 'All users have access',
    nb: 'Alle brukerne har tilgang',
  },
  Onlyboardusershaveaccess: {
    en: 'Only board users have access',
    nb: 'Kun styrebrukere har tilgang',
  },
  Ifyougiveaccesstoallusers: {
    en: 'If you give access to all users, all those registered in the organization will see the contents of the folder. If only board members are given access, only the users who have access to board documents will see the content.',
    nb: 'Dersom du gir alle brukerne tilgang, vil samtlige som er registrert på organisasjon se innholdet i mappen. Dersom kun styrebrukere får tilgang, vil kun de brukere som har tilgang til styredokumenter se innholdet.',
  },
  Cannotdeletethefolderbeca: {
    en: 'Cannot delete the folder because it is not empty',
    nb: 'Kan ikke slette mappen fordi den ikke er tom',
  },
  Selectthisfolder: {
    en: 'Select this folder',
    nb: 'Velg denne mappen',
  },
  Downloadtheselectedfilesf: {
    en: 'Download the selected files/folders as a zip archive',
    nb: 'Last ned valgte filer/mapper som zip-arkiv',
  },

  Buyer: {
    en: 'Buyer',
    nb: 'Kjøper',
  },
  Files: {
    en: 'Files',
    nb: 'Filer',
  },
  Activityhistory: {
    en: 'Activity history',
    nb: 'Aktivitetslogg',
  },
  Addnewtask: {
    en: 'Add new task',
    nb: 'Lag ny oppgave',
  },
  Thisfolderisempty: {
    en: 'This folder is empty',
    nb: 'Mappen er tom',
  },
  Dropfilesorfoldershere: {
    en: 'Drop files or folders here',
    nb: 'Slipp filer eller mapper her',
  },
  Dropfilesorfolderstoaddto: {
    en: 'Drop files or folders to add to data room',
    nb: 'Slipp filer eller mapper for å legge til i datarom',
  },
  Uploadafolder: {
    en: 'Upload a folder',
    nb: 'Last opp mappe',
  },
  Uploadfromzip: {
    en: 'Upload from zip',
    nb: 'Last opp fra zip',
  },
  Hereyoucancreateyourownse: {
    en: 'Here you can create your own search filters, for example to only bring up the folders and files a specific user is responsible for.',
    nb: 'Her kan du lage dine egne søkefilter, for eksempel å kun få frem de mapper og filer en konkret bruker har ansvaret for.',
  },
  Newfilter: {
    en: 'New filter',
    nb: 'Nytt filter',
  },
  Editpermissionsonselected: {
    en: 'Edit permissions on selected files/folders',
    nb: 'Rediger rettigheter på valgte filer/mapper',
  },
  Deleteselectedfilesfolder: {
    en: 'Delete selected files/folders permanently',
    nb: 'Slett valgte filer/mapper permanent',
  },
  lastused: {
    en: 'last used',
    nb: 'sist brukt',
  },
  Attachdocument: {
    en: 'Attach document',
    nb: 'Legg ved dokument',
  },
  Hereyoucanuploadfilesordr: {
    en: 'Here you can upload files or "drag & drop" folders.',
    nb: 'Her kan du laste opp filer eller «drag & drop» mapper.',
  },
  Hereyoucanseethefilesandf: {
    en: 'Here you can see the files and folders that have been deleted. You can also restore a file or folder that has been deleted, or delete permanently.',
    nb: 'Her kan du se de filer og mapper som er blitt slettet. Du kan også gjenopprette en fil eller mappe som er slettet, eller slette permanent.',
  },
  Hereyoucangivefoldersandf: {
    en: 'Here you can give folders and files a color code/status that is searchable, so that it is easier to keep an overview. Green indicates "completed/approved/not applicable", yellow indicates "status in process/must be completed" and red is used for "deviations/for follow-up".',
    nb: 'Her kan du gi mapper og filer en fargekode/status som er søkbar, slik at det blir enklere å holde oversikt. Grønn indikerer «fullført/godkjent/ikke aktuelt», gul indikerer «status i prosess/må ferdigstilles» og rød farge benyttes ved «avvik/til oppfølging».',
  },
  Hereyoucanassignresponsib: {
    en: 'Here you can assign responsibility for a folder or file to a specific user.',
    nb: 'Her kan du tildele ansvaret for en mappe eller fil til en konkret bruke.',
  },
  Hereyoucanseewhentheconte: {
    en: 'Here you can see when the content was last changed/updated.',
    nb: 'Her ser du når innholdet sist ble endret/oppdatert.',
  },
  Hereyouseehowmanytasksare: {
    en: 'Here you see how many tasks are directly linked to the specific file or folder.',
    nb: 'Her ser du hvor mange oppgaver i som er direkte tilknyttet den konkrete filen eller mappen.',
  },
  Hereyouseethetotalnumbero: {
    en: 'Here you see the total number of files stored under a folder.',
    nb: 'Her ser du hvor mange filer som totalt ligger lagret under en mappe.',
  },
  Hereyoucancreateanewfolde: {
    en: 'Here you can create a new folder.',
    nb: 'Her kan du opprette en ny mappe.',
  },
  Hereyoucanchangethenameof: {
    en: 'Here you can change the name of the file or folder',
    nb: 'Her kan du endre navn på filen eller mappen',
  },
  Hereyoucangetmoredetailed: {
    en: 'Here you can get more detailed information about the folder or file',
    nb: 'Her kan du få frem mer detaljert informasjon om mappen eller filen',
  },
  Hereyoucanseeactivitieson: {
    en: 'Here you can see activities on a file, for example who has viewed it.',
    nb: 'Her kan du se aktiviteter på en fil, for eksempel hvem som har sett på den.',
  },
  Hereyoucancopyafileorfold: {
    en: 'Here you can copy a file or folders to other areas in the data room.',
    nb: 'Her kan du kopiere en fil eller mapper til andre områder i datarommet.',
  },
  Createanewfolderoruploadf: {
    en: 'Create a new folder or upload files/folders. Content can also be uploaded using drag and drop.',
    nb: 'Her kan du lage en ny mappe eller laste opp filer/mapper. Innhold kan også lastes opp med "dra-og-slipp".',
  },
  Unassignresponsible: {
    en: 'Unassign responsible',
    nb: 'Fjern tildeling av ansvarlig',
  },
  Selectresponsible: {
    en: 'Select responsible',
    nb: 'Velg ansvarlig',
  },
  Forallunderlyingfoldersan: {
    en: 'For all underlying folders and files',
    nb: 'For alle underliggende mapper og filer',
  },
  Uploadinterruptedduetoerr: {
    en: 'Upload interrupted due to error',
    nb: 'Opplastingen ble avbrutt på grunn av feil',
  },
  Youhavecancelledfileuploa: {
    en: 'You have cancelled file upload for',
    nb: 'Du har avbrutt filopplasting for',
  },
  Doyouwanttostopthewholeup: {
    en: 'Do you want to stop the whole upload?',
    nb: 'Vil du stoppe hele opplastingen?',
  },
  Canceltheupload: {
    en: 'Cancel the upload',
    nb: 'Avbryt opplastingen',
  },
  Continueupload: {
    en: 'Continue upload',
    nb: 'Fortsett opplastingen',
  },
  Ifyouusethebuttontoattach: {
    en: 'If you use the button to attach files, try using drag&drop instead',
    nb: 'Hvis du bruker knappen for å legge ved filer, prøv heller å benytte drag&drop',
  },
  isnotempty: {
    en: 'is not empty',
    nb: 'er ikke tom',
  },
  Permanentlydeletefolderan: {
    en: 'Permanently delete folder and it’s contents',
    nb: 'Slett mappen og dens innhold',
  },
  Abort: {
    en: 'Abort',
    nb: 'Avbryt',
  },
  Folderisnotempty: {
    en: 'Folder is not empty',
    nb: 'Mappen er ikke tom',
  },
  Givefolderaname: {
    en: 'Give folder a name',
    nb: 'Gi mappen et navn',
  },
  Foldername: {
    en: 'Folder name',
    nb: 'Mappenavn',
  },
  Hereyouuploadalldocuments: {
    en: 'Here you upload all documents to be shared in connection with a due diligence process.',
    nb: 'Her laster du opp alle dokumenter som skal deles i forbindelse med en due diligence-prosess.',
  },
  Alldocumentsbelongingtome: {
    en: 'All documents belonging to meetings that are created via the meeting module in the portal are automatically saved here.',
    nb: 'Her lagres automatisk alle dokumenter som tilhører møter som opprettes via møtemodulen i portalen.',
  },
  Hereeachindividualusercan: {
    en: 'Here, each individual user can save private files that only the user has access to.',
    nb: 'Her kan hver enkelt bruker lagre private filer som kun brukeren har tilgang til.',
  },
  Updateavailable: {
    en: 'Update available',
    nb: 'Oppdatering tilgjengelig',
  },
  UniqueUsersInEnterprise: {
    en: 'Unique users in enterprise ex. investor/owner',
    nb: 'Unike brukere i konsern eks. investor/eier',
  },
  NewOrgModuleLabel: {
    en: 'New organization',
    nb: 'Ny organisasjon',
  },
  join: {
    en: 'Join',
    nb: 'Bli med',
    sv: 'Ansluta sig till',
  },
  VisibilityLevel: {
    nb: 'Innsyn i aksjeeierboken',
    en: 'View shareholder register',
  },
  NOBODY: {
    en: 'Nobody',
    nb: 'Ingen',
  },
  ADD_USER_DID: {
    en: 'added a user',
    nb: 'la til en bruker',
  },
  ADD_ROLE_DID: {
    en: 'added a role',
    nb: 'lagt til en rolle',
  },
  ADD_USER_SEVERAL_DID: {
    en: 'added users',
    nb: 'lagt til brukere',
  },
  REMOVE_USER_DID: {
    en: 'removed a user',
    nb: 'fjernet en bruker',
  },
  REMOVE_USER_SEVERAL_DID: {
    en: 'removed users',
    nb: 'fjernede brukere',
  },
  REMOVE_ROLE_DID: {
    en: 'removed a role',
    nb: 'fjernet en rolle',
  },
  'share-registry': {
    en: 'Suggestion generated from the shareholder registry',
    nb: 'Forslag ble generert med data fra aksjonærregisteret',
    sv: 'Ansluta sig till',
  },
  'tax-office': {
    en: 'Suggestion generated from the Norwegian tax office',
    nb: 'Forslag ble generert med data fra Skatteetaten',
    sv: 'Ansluta sig till',
  },
  'tax-and-registry': {
    en: 'Suggestion generated from the Norwegian tax office and Orgbrain',
    nb: 'Forslag ble generert med data fra Skatteetaten og Orgbrain',
    sv: 'Ansluta sig till',
  },
  newTaskModuleLabel: {
    en: 'Create new task',
    nb: 'Lag ny oppgave',
    sv: 'Ny uppgift',
  },
  MoreBeneficialOwners: {
    nb: 'Mangler du opplysninger for å kunne identifisere noen av virksomhetens reelle rettighetshavere?',
    en: "Do you lack information to identify some of the organization's beneficial owners?",
  },
  UsageTracking: {
    en: 'Cookies',
    nb: 'Informasjonskapsler',
  },
  UsageTrackingInfo1: {
    en: 'We use cookies to give you a better user experience. You can read more about this in our ',
    nb: 'Vi bruker informasjonskapsler til å forbedre brukeropplevelsen. Du kan lese mer om dette i vår ',
  },
  UsageTrackingInfo2: {
    en: 'privacy policy',
    nb: 'personvernserklæring',
  },
  UsageTrackingInfo3: {
    en: 'You can edit this on the settings page.',
    nb: 'Du kan redigere dette på innstillingssiden.',
  },
  AcceptUsageTracking: {
    en: 'Accept',
    nb: 'Aksepter',
  },
  DeclineUsageTracking: {
    en: 'Reject',
    nb: 'Avvis',
  },
  MoreBeneficialOwnersHelpText: {
    nb: 'For å kunne identifisere reelle rettighetshavere må du ha opplysninger om fødselsnummer eller fødselsdato, navn, bostedsland og statsborgerskap',
    en: 'To identify beneficial owners, you need information about the national identity number or date of birth, name, country of residence and citizenship',
  },
  UnidentifedBeneficialOwners: {
    en: 'The organization has one or more beneficial owners which can not be identified',
    nb: 'Virksomheten har en eller flere reelle eiere som ikke kan identifiseres',
  },
  OwnersMapModuleLabel: {
    en: 'Owners map',
    nb: 'Eierkart',
  },
  CreateNewMeetingModuleLabel: {
    en: 'Meeting',
    nb: 'Møte',
  },
  CreateAnnualPlanModuleLabel: {
    en: 'New annual plan',
    nb: 'Ny årsplan',
  },
  SearchInFiles: {
    en: 'Search in all files',
    nb: 'Søk i alle filer',
  },
  OrgDeleteUser: {
    en: 'Delete representative',
    nb: 'Slett representant',
  },
  DeleteAttachedUser: {
    en: 'Delete user info',
    nb: 'Slett brukerinfo',
  },
  InvestorsMissingInformation1: {
    en: 'Some of the ',
    nb: 'Noen av ',
  },
  RecordingFrom: {
    en: 'Recording from ',
    nb: 'Opptak fra ',
  },
  InvestorsMissingInformation2: {
    en: ' have incomplete profiles. Check the status on ',
    nb: ' har uferdige profiler. Sjekk statusen på ',
  },
  InvestorsMissingInformation3: {
    en: ' in the table below.',
    nb: ' i tabellen under.',
  },
  InvestorIsMissingFollowingFields: {
    en: 'To be a valid investor according to the Companies Act, the following fields must be filled out: ',
    nb: 'For at denne investoren skal være gyldig ifølge aksjeloven, må følgende felter utfylles: ',
  },
  JitsiRecordingStarted: {
    en: 'Meeting recording has started.',
    nb: 'Møteopptak har startet.',
  },
  'set-par-value': {
    en: 'Set par value',
    nb: 'Sett pålydende',
  },

  'new-stock-splice': {
    en: 'New stock splice',
    nb: 'Ny aksjespleis',
  },
  'new-stock-split': {
    en: 'New stock split',
    nb: 'Ny aksjesplitt',
  },
  emissions: {
    en: 'Emission',
    nb: 'Kapitalforhøyelse',
  },
  emissionsTableHeader: {
    en: 'Emission',
    nb: 'Kapitalforhøyelse',
  },
  emissionPropertyTableHeader: {
    en: ' ',
    nb: ' ',
  },
  ChooseNewEventType: {
    en: 'Choose event type',
    nb: 'Velg hendelsestype',
  },
  NewEvent: {
    en: 'New event',
    nb: 'Ny hendelse',
  },
  InvestorsMissingEmails: {
    en: 'Missing email: ',
    nb: 'Mangler e-post: ',
  },
  InvestorsMissingDob: {
    en: 'Missing complete date of birth: ',
    nb: 'Mangler komplett fødselsdato: ',
  },
  SharedFolder: {
    en: 'Shared folder',
    nb: 'Delt mappe',
  },
  organizationAuthTitle: {
    en: 'Organization security (2FA)',
    nb: 'Organisasjonssikkerhet (2FA)',
  },
  policyInfo: {
    // nb: 'Her har du mulighet til å velge mellom ulike innstillinger for når brukerne må benytte tofaktor-autentisering (2FA).',
    en:
      'Here you choose the security settings for your organization.  That is when users must use two-factor authentication (2FA).' +
      ' By default a user will have to use 2FA when they access the organization from a new device or browser.' +
      ' After a period of inactivity greater than 30 days the user will be required to use  2FA to access this organisation.' +
      ' If you which to use a different timeout period please contact Orgbrain support.',
    nb:
      'Her velger du sikkerhetsinnstillingene for organisasjonen din. Det vil si når brukere må bruke tofaktorautentisering (2FA).' +
      ' Som standard må en bruker benytte 2FA når de skal ha tilgang til organisasjonen fra en ny enhet eller nettleser.' +
      ' Etter en periode med inaktivitet på mer enn 30 dager, må brukeren bruke 2FA for å få tilgang til denne organisasjonen.' +
      ' Hvis du vil bruke en annen timeout-periode, kan du kontakte Orgbrain support.',
  },
  noAuthPolicy: { en: 'No policy.  Blah blah about policies etc.', nb: 'Ingen policy' },
  createButton: { en: 'Create policy', nb: 'Opprett policy' },
  deleteButton: { en: 'Delete policy', nb: 'Slett policy' },
  securityTitle: { en: 'Security groups', nb: 'Sikkerhetsgrupper' },
  securityDescription: {
    en: 'Security groups for the organization which can be associated with permissions. You can edit these if you want to override the rules in the predefined policy',
    nb: 'Sikkerhetsgrupper for organisasjonen som kan knyttes til tillatelser. Du kan redigere disse hvis du vil overstyre reglene i den forhåndsdefinerte policyen',
  },
  permissionSecurityTitle: {
    en: 'Security groups for Permissions ',
    nb: 'Sikkerhetsgrupper for tillatelser',
  },
  overridenParamsBody: {
    en: 'This policy has overridden the parameters of a canned policy',
    nb: 'Denne policyen har overstyrt parameterne til en ferdiglaget policy',
  },
  overridenPermissionsBody: {
    en: 'This policy has overridden the parameters of a canned policy',
    nb: 'Denne policyen har overstyrt parameterne til en ferdiglaget policy',
  },
  noPolicy: { en: 'No policy', nb: 'Ingen policy' },
  advanced: { en: 'Advanced', nb: 'Avansert' },
  advancedTitle: { en: 'Advanced mode', nb: 'Avansert modus' },
  advancedBody: {
    en: 'Advanced mode allows you to edit the policy directly.  This is not recommended unless you know what you are doing.',
    nb: 'Avansert modus lar deg redigere policyen direkte. Dette anbefales ikke med mindre du vet hva du gjør.',
  },
  CreateSharedFolder: {
    en: 'Create shared folder',
    nb: 'Opprett delt mappe',
  },
  OutOfSigned: {
    en: ' out of ',
    nb: ' av ',
  },
  hasSigned: {
    en: ' has signed',
    nb: ' har signert',
  },
  OrgbrainSigning: {
    en: 'Orgbrain eSign',
    nb: 'Orgbrain eSign',
  },
  CRIIPTOSigning: {
    en: 'BankID',
    nb: 'BankID',
  },
  DeleteSurveyWarning: {
    en: 'Are you sure you want to delete the survey? This can not be undone.',
    nb: 'Er du sikker på at du vil slette undersøkelsen? Dette kan ikke angres.',
  },
  OpenUnsignedDocument: {
    en: 'Show unsigned document',
    nb: 'Vis usignert dokument',
  },
  OpenSignedDocument: {
    en: 'Show signed document',
    nb: 'Vis signert dokument',
  },
  CreateNewSignOrder: {
    en: 'New signature',
    nb: 'Ny signatur',
  },
  UnknownPage: {
    en: 'Unknown page',
    nb: 'Ukjent side',
  },
  UnknownPageText: {
    en: 'This page does not exist. Use the button below to return to the homepage',
    nb: 'Denne siden eksisterer ikke. Bruk knappen under for å komme tilbake til hjemmesiden',
  },
  UnknownShareholderEvent: {
    en: 'This event does not exist anymore',
    nb: 'Denne hendelsen eksisterer ikke lenger',
  },
  ToHomePage: {
    en: 'Back to homepage',
    nb: 'Tilbake til hjemmesiden',
  },

  CREATEDSignTaskTranslation: {
    en: 'Unsigned',
    nb: 'Usignert',
  },
  COMPLETEDSignTaskTranslation: {
    en: 'Finished',
    nb: 'Fullført',
  },
  PENDINGSignTaskTranslation: {
    en: 'Pending',
    nb: 'Venter',
  },
  REJECTEDSignTaskTranslation: {
    en: 'Rejected',
    nb: 'Avvist',
  },
  DELETEDSignTaskTranslation: {
    en: 'Deleted',
    nb: 'Slettet',
  },

  ChooseMeetingType: {
    en: 'Choose meeting type',
    nb: 'Velg møtetype',
  },
  MeetingTypeWarning: {
    en: 'NOTE: This can not be changed after the meeting has been created',
    nb: 'OBS: Dette får du ikke endret på etter du har opprettet møtet',
  },
  UseExternalVideoConferance: {
    en: 'Use external video conferance',
    nb: 'Bruk en annen videokonferansetjeneste',
  },

  SUBSCRIPTION_PACKAGE: {
    en: 'Subscription',
    nb: 'Abonnement',
    sv: 'Prenumeration',
  },
  DownloadDate: {
    en: 'What date would you like to retrieve the snapshot from?',
    nb: 'Hvilken dato ønsker du å hente øyeblikksbildet fra?',
  },
  DownloadDateTip: {
    en: 'Events on the specified date are included. The situation at the start of the day is available by selecting the previous date.',
    nb: 'Hendelser på angitt dato inkluderes. Situasjonen ved starten av dagen er tilgjengelig ved å velge foregående dato.',
  },
  FileNameText: {
    en: 'Name of the file',
    nb: 'Navn på filen',
  },
  SUBSCRIPTION_PACKAGE_UPGRADE: {
    en: 'Subscription update',
    nb: 'Abonnementsoppdatering',
    sv: 'Prenumerationsuppdatering',
  },
  SUBSCRIPTION_PACKAGE_USER_EXTENSION: {
    en: 'Subscription update: extra users',
    nb: 'Abonnementsoppdatering: ekstra brukere',
    sv: 'Prenumerationsuppdatering: extra användare',
  },
  SUBSCRIPTION_PACKAGE_REMAINDER: {
    en: 'Remainder from previous subscription',
    nb: 'Resten fra forrige abonnement',
    sv: 'Resterande från tidigare prenumeration',
  },
  FREE_USERS: {
    en: 'Free standard users',
    nb: 'Gratis standardbrukere',
  },
  FREE_SUBGROUP_USERS: {
    en: 'Free subgroup users',
    nb: 'Gratis undergruppebrukere',
  },
  USERS_INCLUDED_IN_SUBSCRIPTION: {
    en: 'Users included in',
    nb: 'Brukere inkludert i',
  },
  EmailSent: {
    en: 'Email sent',
    nb: 'E-post sendt',
    sv: 'E-post skickad',
  },
  EmailSendtToYou: {
    en: 'An email has been sent to you',
    nb: 'En e-post er sendt til deg',
    sv: 'Ett e-postmeddelande har skickats till dig',
  },
  NextEmail: {
    en: 'Next email',
    nb: 'Neste e-post',
    sv: 'Nästa e-post',
  },
  PreviousEmail: {
    en: 'Previous email',
    nb: 'Forrige e-post',
    sv: 'Föregående e-post',
  },
  'Subscription has changed': {
    en: 'Subscription has changed',
    nb: 'Abonnementet er endret',
    sv: 'Prenumerationen har ändrats',
  },
  CreatedByOrgbrain: {
    en: 'Retrieved from shareholder registry in Orgbrain for ',
    nb: 'Hentet fra aksjeeierbok i Orgbrain for ',
    sv: 'Hentet fra aksjeeierbok i Orgbrain for ',
  },

  NobodyToInvite: {
    en: 'Nobody to invite',
    nb: 'Ingen å invitere',
  },
  toShareclass: {
    en: 'To shareclass',
    nb: 'Til aksjeklasse',
  },
  fromShareclass: {
    en: 'From shareclass',
    nb: 'Fra aksjeklasse',
  },
  originalValue: {
    en: 'Original value',
    nb: 'Opprinnelig verdi',
  },
  'Users before': {
    en: 'Users before',
    nb: 'Brukere før',
    sv: 'Användare tidigare',
  },
  SIGNATURE_CRIIPTO: {
    en: 'Signature Bank ID',
    nb: 'Signering Bank ID',
    sv: 'Signatur Bank ID',
  },
  'Variable costs': {
    en: 'Variable costs',
    nb: 'Variable kostnader',
    sv: 'Användare tidigare',
  },
  'Users after': {
    en: 'Users after',
    nb: 'Brukere etter',
    sv: 'Användare efter',
  },
  previewTheEmail: {
    en: 'Previewing the email',
    nb: 'Forhåndsvisning av e-posten',
  },
  emailsendt: { en: 'Email is sent', nb: 'E-post er sendt' },
  emailsendtmsg: {
    en: 'A test has now been sent to your email address',
    nb: 'En test er nå send til din e-postadresse',
  },
  sendsMailToYourselfTooltip: {
    en: 'Sends an email to your own email address',
    nb: 'Sender en e-post til din egen e-postadresse',
  },
  sendTestEmail: { en: 'Send test email', nb: 'Send test e-post' },
  openPreview: {
    en: 'Preview email',
    nb: 'Forhåndsvis e-post',
  },
  mattooltipMessageOfTransaction: {
    en: 'Here you can choose whether to send an email notification about the entry in the shareholder register, cf. the Companies Act § 4-10. The message will contain information about transaction type, time, seller, recipient, share class, quantity and new shareholding.',
    nb: 'Her kan du velge om det skal gå ut melding på e-post om innføring i aksjeeierboken, jf. aksjeloven § 4-10. Meldingen vil inneholde opplysninge om transaksjonstype, tidspunkt, avhender, mottaker, aksjeklasse, antall og ny aksjebeholdning.',
  },
  NoticeOfIntroductionToTheShareRegister: {
    en: 'Notification of entry in the shareholder register',
    nb: 'Melding om  innføring i aksjeeierboken',
  },

  SellerInfoText: {
    en: 'The transferor must be added to the shareholder register and registered with shares.',
    nb: 'Avhenderen må være lagt til i aksjeeierboken og være registrert med aksjer.',
  },
  InfoAboutTransactionText: {
    en: 'Choose the type and time of the transaction.',
    nb: 'Bestem typen og tidspunkt for transaksjonen.',
  },
  SharesInfoText: {
    en: 'Remaining shares are calculated based on the time of transaction.',
    nb: 'Antall aksjer er beregnet ut ifra transaksjonstidspunktet.',
  },
  RecipientInfoText: {
    en: 'Choose the recipient or create a new owner.',
    nb: 'Velg mottakeren eller opprett en ny eier.',
  },

  SendEmailToSeller: {
    en: 'Send email to transferor?',
    nb: 'Send epost til avhender?',
  },
  SendEmailToBuyer: {
    en: 'Send email to recipient?',
    nb: 'Send epost til mottaker?',
  },
  TransactionInfoBox: {
    en: 'Register a transaction (e.g., purchase/sale) that is automatically updated in the shareholder register. You can only register one transaction at a time. (Note: You also have the option to upload spreadsheets with multiple transactions through "Import transactions"). You can choose to send a message to the seller and buyer regarding the entry in the shareholder register.',
    nb: 'Her kan du registrere en transaksjon (for eksempel kjøp/salg) som automatisk blir oppdatert i aksjeeierboken. Du kan kun registrere én transaksjon om gangen (NB: Du har også mulighet til å laste regneark med flere transaksjoner via «Aksjedata»). Du har også mulighet til å velge om det skal sendes ut melding til avhender og mottaker om innføring i aksjeeierboken.',
  },
  seller: {
    en: 'Seller',
    nb: 'Selger',
  },
  TimeOfTransaction: {
    en: 'Time of transaction:',
    nb: 'Transaksjonstidspunkt:',
  },
  warningText1: {
    nb: 'Transaksjonstidspunktet er før siste hendelse.',
    en: 'The transaction date is before the last event.',
  },
  warningText2: {
    nb: 'Dette kan være problematisk dersom denne transaksjonen endrer på forutsetninger som etterfølgende hendelser er avhengig av (f.eks. dersom en aksjonær selger aksjer som allerede er solgt).',
    en: 'This can be problematic if this transaction changes assumptions that subsequent events depend on (e.g., if a shareholder sells shares that have already been sold).',
  },
  haveSnapshotsWarningText1: {
    nb: 'NB: Det finnes et øyeblikksbilde etter transaksjonstidspunktet.',
    en: 'NB: There is a snapshot after the transaction time.',
  },
  haveSnapshotsWarningText2: {
    nb: 'Dette vil føre til at tidspunktet blir ansett som ugyldig dersom antallet overstiger det selger har av tilgjengelige aksjer.',
    en: 'This will cause the time to be considered invalid if the number exceeds what the seller has of available shares.',
  },
  SendPreview: {
    en: 'Send test to me',
    nb: 'Send test til meg',
  },
  BOARD_PORTAL: {
    en: 'Board portal',
    nb: 'Styreportal',
    sv: 'Styrelsens portal',
  },
  INVOICE_PERIOD: {
    en: 'Invoice period',
    nb: 'Fakturaperiode',
    sv: 'Fakturaperiod',
  },
  PER_MNTH: {
    en: 'per month',
    nb: 'pr. mnd.',
    sv: 'pr. mnd.',
  },
  USER_PACKAGE: {
    en: 'Users',
    nb: 'Brukere',
    sv: 'Användare',
  },
  YEARLY_AGREEMENT: {
    en: 'Annual agreement',
    nb: 'Årsavtale',
    sv: 'Årsavtal',
  },
  MONTHLY_AGREEMENT: {
    en: 'Monthly agreement',
    nb: 'Månedlig avtale',
    sv: 'Månadsavtal',
  },
  SUBGROUP_USER_PACKAGE: {
    en: 'Subgroup users',
    nb: 'Undergruppebrukere',
    sv: 'Undergruppsanvändare',
  },
  ADDITIONAL_USER_PACKAGE: {
    en: 'Additional users',
    nb: 'Ytterligere brukere',
    sv: 'Ytterligare användare',
  },
  ADDITIONAL_SUBGROUP_USER_PACKAGE: {
    en: 'Additional subgroup users',
    nb: 'Ytterligere undergruppebrukere',
    sv: 'Ytterligare undergruppsanvändare',
  },
  DISCOUNT_CASH_TOTAL: {
    en: 'Money discount',
    nb: 'Penger rabatt',
    sv: 'Pengar rabatt',
  },
  DISCOUNT_INVOICE: {
    en: 'Discount',
    nb: 'Rabatt',
    sv: 'Rabatt',
  },
  DISCOUNT_PERCENT_TOTAL: {
    en: 'Percentage discount',
    nb: 'Prosentvis rabatt',
    sv: 'Procentuell rabatt',
  },
  DD_PROCESSES_GROUPS: {
    en: 'Due diligence processes',
    nb: 'Due diligence-prosesser',
    sv: 'Due diligence-processer',
  },
  FOLLOW_UP_LABEL: {
    en: 'Follow-up',
    nb: 'Oppfølging',
    sv: 'Uppföljning',
  },
  DECISION_LABEL: {
    en: 'Decision',
    nb: 'Beslutning',
    sv: 'Beslut',
  },
  RISK_AND_COMPLIANCE_LABEL: {
    en: 'Risk and compliance',
    nb: 'Risiko og compliance',
    sv: 'Risk och efterlevnad',
  },
  STRATEGIC_PLANNING_LABEL: {
    en: 'Strategic planning',
    nb: 'Strategisk planlegging',
    sv: 'Strategisk planering',
  },
  DATAROOM_STORAGE: {
    en: 'Dataroom storage',
    nb: 'Datarom lagring',
    sv: 'Datarumslagring',
  },
  SIGNING_DOCUMENTS: {
    en: 'Signing documents',
    nb: 'Signering av dokumenter',
    sv: 'Underteckna dokument',
  },
  NOK: {
    en: 'NOK',
    nb: 'kr',
    sv: 'kr',
  },
  per: {
    en: 'per',
    nb: 'pr',
    sv: 'per',
  },
  NotificationSettings: {
    en: 'Notification settings',
    nb: 'Varsler',
  },
  NotificationSettingsInfo: {
    en: 'Here you can change the what notification type you get when certain events in Orgbrain happen. These settings only affect your currently selected organization',
    nb: 'Her kan du stille inn hvilke varsler du får når det skjer hendelser i Orgbrain. Disse innstillingene påvirker bare den organisasjon du er inne på nå',
  },
  SavedSettings: {
    en: 'Your settings are saved',
    nb: 'Dine innstillinger er lagret',
  },
  EMAILOption: {
    en: 'Email',
    nb: 'E-post',
    sv: 'kr',
  },
  EMAILOptionTooltip: {
    en: 'Send the notification on email.',
    nb: 'Send varselen på E-post.',
    sv: 'kr',
  },
  BELLOption: {
    en: 'Bell',
    nb: 'Bjelle',
    sv: 'kr',
  },
  BELLOptionTooltip: {
    en: 'Add notification to the bell.',
    nb: 'Legg til varselen i bjellen.',
    sv: 'kr',
  },
  PUSHOption: {
    en: 'Push-notification',
    nb: 'Push-varsel',
    sv: 'kr',
  },
  Label: {
    en: 'Labels',
    nb: 'Merkelapper',
    sv: 'kr',
  },
  NewLabel: {
    en: 'Create label',
    nb: 'Opprett merkelapp',
    sv: 'kr',
  },
  LabelName: {
    en: 'Choose label name',
    nb: 'Velg merkelapp navn',
    sv: 'kr',
  },
  ChooseColor: {
    en: 'Choose label color',
    nb: 'Velg merkelapp farge',
    sv: 'kr',
  },
  CreateLabel: {
    en: 'Create label',
    nb: 'Opprett merkelapp',
    sv: 'kr',
  },

  PUSHOptionTooltip: {
    en: 'Send this notification as a push notification on your computer or phone along with a sound. You have to turn on webpush for this function to work.',
    nb: 'Send denne varselen som en push varsel på datamaskinen eller telefonen din, sammen med en lyd. Du må skru på webpush for at denne funksjonen skal fungere.',
    sv: 'kr',
  },
  BATCHOption: {
    en: 'Email batch',
    nb: 'E-post batch',
    sv: 'kr',
  },
  BATCHOptionTooltip: {
    en: 'Send this along with similar notifications in a batch every 2 hours',
    nb: 'Send sammen med like varsler i en gruppe hver andre time',
    sv: 'kr',
  },

  //Turn these keys in to translations

  Answered: {
    en: 'Answered: ',
    nb: 'Besvarte: ',
  },
  ViewSurvey: {
    en: 'Go to survey',
    nb: 'Gå til undersøkelse',
  },
  ViewReport: {
    en: 'View report',
    nb: 'Se rapport',
  },
  DeleteSurvey: {
    en: 'Deleted the survey',
    nb: 'Slett undersøkelse',
  },
  InviteToSurvey: {
    en: 'Add more users to the survey',
    nb: 'Legg til flere brukere i undersøkelsen',
  },
  SendReminderSurvey: {
    en: 'Send reminder for the survey',
    nb: 'Send påminnelse for undersøkelsen',
  },

  CreatedConversation: {
    en: ' created a new conversation',
    nb: ' lagde en ny samtale',
  },
  CreatedAt: {
    en: 'Fetched from the share register in Orgbrain ',
    nb: 'Hentet fra aksjeeierboken i Orgbrain ',
    sv: 'PDF Opprettet: ',
  },
  DemoteAdmin: {
    en: 'Remove conversation admin privileges',
    nb: 'Fjern samtaleadministrator tillatelser',
    sv: 'kr',
  },
  'files.MakeCaseFromFile': {
    en: 'New agenda item',
    nb: 'Nytt agendapunkt',
  },
  MeetingFolderNotFound: {
    en: 'Meeting folder not found',
    nb: 'Møtemappe ble ikke funnet',
  },
  MeetingNotFound: {
    en: 'Meeting not found',
    nb: 'Møte ble ikke funnet',
  },
  NoCalendarItemsFound: {
    en: 'No activities found',
    nb: 'Ingen aktiviteter funnet',
  },
  DeleteContactConfirm: {
    en: 'This will delete this contact group forever. None of the conversations connected with the contact group will be affected',
    nb: 'Dette vil slette denne kontaktgruppen permanent. Ingen av samtalene knyttet til denne kontaktgruppen vil bli påvirket',
    sv: 'kr',
  },
  imageTextForWebpush: {
    en: '<Image>',
    nb: '<Bilde>',
    sv: '<Bilde>',
  },
  repeatConversationTitle: {
    en: 'Similar Conversation Exists',
    nb: 'Lignende samtale finnes allerede',
    sv: 'Liknande konversation finns redan',
  },
  repeatConversationBody: {
    en: 'A conversation with the same members already exists. Would you like to start a new one or open the existing conversation?',
    nb: 'En samtale med de samme medlemmene finnes allerede. Vil du opprette en ny, eller åpne den eksisterende samtalen?',
    sv: 'En konversation med samma medlemmar finns redan. Vill du skapa en ny eller öppna den befintliga konversationen?',
  },
  StartNewConversation: {
    en: 'Start New Conversation',
    nb: 'Start ny samtale',
    sv: 'Starta ny konversation',
  },
  NewContact: {
    en: 'Contact Group',
    nb: 'Kontaktgruppe',
  },
  NoConversations1: {
    en: 'You have no personal conversations yet. ',
    nb: 'Du har ingen personlige samtaler enda. ',
  },
  NoConversationsAdmin2: {
    en: 'Click "New Conversation" to send a message to other users',
    nb: 'Klikk på "Ny samtale" for å sende en melding til andre brukere',
  },
  NoConversations2: {
    en: 'Click "Contact" to find the company\'s contact groups',
    nb: 'Klikk på "Kontakt" for å finne selskapets kontaktgrupper',
  },
  NoContacts: {
    en: 'There are currently no contact groups that can be contacted.',
    nb: 'Det er foreløpig ikke opprettet noen kontaktgrupper som kan kontaktes.',
  },
  NoContactsContacted: {
    en: 'No contact groups have been contacted yet.',
    nb: 'Ingen kontaktgrupper har blitt kontaktet ennå.',
  },
  StartContact: {
    en: 'Contact',
    nb: 'Ta kontakt',
  },
  SendReminderTooltip: {
    en: 'Send a reminder to the users that have not completed the signing task yet',
    nb: 'Send en påminnelse til brukere som enda ikke har fullført signeringsoppgaven',
    sv: 'Starta ny konversation',
  },
  SigningRequest: {
    en: 'Signing request',
    nb: 'Signeringsforespørsel',
  },
  SigningRequestSubmitted: {
    en: 'Signing request submitted',
    nb: 'Signeringsforespørsel sendt',
  },
  SigningRequestSubmittedDetail: {
    en: 'Users which have been invited to sign the document will be notified by email.',
    nb: 'Brukere som har blitt invitert til å signere dokumentet vil bli varslet på e-post.',
  },
  Conversation: {
    en: 'Chat',
    nb: 'Samtale',
  },
  CreateCustomConversation: {
    en: 'Custom group',
    nb: 'Egendefinert gruppe',
  },
  NoAgendaItems: {
    en: 'No agenda items',
    nb: 'Ingen agendapunkter',
  },
  TypeEntity: {
    en: 'Type',
    nb: 'Type',
    sv: 'Typ av enhet',
  },
  TypeEntityText1: {
    en: 'Specify the type of ',
    nb: 'Spesifiser hvilken type ',
    sv: 'Ange typ av enhet.',
  },
  TypeEntityText2: {
    en: ' this is',
    nb: ' dette er',
    sv: 'Ange typ av enhet.',
  },
  BasicInformation: {
    en: 'Basic Information',
    nb: 'Grunnleggende informasjon',
    sv: 'Basinformation',
  },
  BasicInformationText: {
    en: 'Enter basic information about ',
    nb: 'Skriv inn grunnleggende informasjon ',
  },
  EntityUsers: {
    en: 'Attached user',
    nb: 'Tilknyttet bruker',
  },
  EntityUsersText: {
    en: 'Manage users associated with ',
    nb: 'Administrer brukere knyttet til ',
  },
  OrgEntityUsers: {
    en: 'Representatives',
    nb: 'Representanter',
  },
  OrgEntityUsersText: {
    en: 'Manage representatives associated with ',
    nb: 'Administrer representanter knyttet til ',
  },

  EntityAddressOrg: {
    en: 'Business address',
    nb: 'Forretningsadresse',
  },
  EntityAddressIndividual: {
    en: 'Address',
    nb: 'Adresse',
  },
  EntityAddressOrgText: {
    en: 'Enter the address for the organization.',
    nb: 'Forretningsadresse for organisasjonen',
  },
  EntityAddressIndividualText: {
    en: 'Address for ',
    nb: 'Adresse for ',
  },
  PostalAddressText: {
    en: 'Enter the postal address details for ',
    nb: 'Skriv inn postadressdetaljer for ',
    sv: 'Ange postadressdetaljer.',
  },
  ExtraInformationEntity: {
    en: 'Extra information',
    nb: 'Ekstra informasjon',
    sv: 'Ange postadressdetaljer.',
  },
  ExtraInformationText: {
    en: 'Enter extra information about ',
    nb: 'Tilleggsinformasjon om ',
    sv: 'Ange postadressdetaljer.',
  },
  UTLCode: {
    en: 'UTL Code',
    nb: 'UTL-kode',
  },
  OpenNews: {
    en: 'Open',
    nb: 'Åpne',
  },
  OpenTask: {
    en: 'Open',
    nb: 'Åpne',
  },
  UndefinedUser: {
    en: 'Attached user',
    nb: 'Tilknyttet bruker',
    sv: 'Odefinierad användare',
  },
  UndefinedRepresentative: {
    en: 'Representative',
    nb: 'Representant',
    sv: 'Odefinierad användare',
  },
  AddRepresentative: {
    en: 'Add representative',
    nb: 'Legg til representant',
    sv: 'Odefinierad användare',
  },
  AddUser: {
    en: 'Add user',
    nb: 'Legg til bruker',
    sv: 'Odefinierad användare',
  },
  Overview: {
    en: 'Overview',
    nb: 'Oversikt',
  },
  TotalShares: {
    en: 'Total',
    nb: 'Antall',
  },
  FinancialContracts: {
    nb: 'Finansielle avtaler',
    en: 'Financial Agreements',
  },
  CreateSurvey: {
    en: 'Start survey',
    nb: 'Start undersøkelse',
  },
  NewSurveyTemplate: {
    en: 'New custom',
    nb: 'Ny egendefinert',
  },
  Loading: {
    en: 'Loading...',
    nb: 'Laster...',
  },
  questionnaireQuestions: {
    en: ' questions',
    nb: ' spørsmål',
  },
  PredefinedConfigs: {
    en: 'Surveys from Orgbrain',
    nb: 'Undersøkelser fra Orgbrain',
  },
  CustomConfigs: {
    en: 'Custom',
    nb: 'Egendefinerte',
  },
  ViewQuestionnaire: {
    en: 'View template',
    nb: 'Vis mal',
  },
  DeleteQuestionnaire: {
    en: 'Delete template',
    nb: 'Slett mal',
  },
  DuplicateQuestionnaire: {
    en: 'Duplicate template and insert it in the list',
    nb: 'Dupliser mal og legg det inn i listen',
  },
  DeletedQuestionnaire: {
    en: 'Deleted template',
    nb: 'Slettet mal',
  },
  Surveys: {
    en: 'Surveys',
    nb: 'Undersøkelser',
  },
  MySurveys: {
    en: 'Inbox',
    nb: 'Innboks',
  },
  MySurveysText: {
    en: `This page shows the surveys you haven't answered yet.`,
    nb: 'Her vises en liste over undersøkelser som du enda ikke har besvart',
  },
  SectionNameNoName: {
    en: 'Section without name',
    nb: 'Seksjon uten navn',
  },
  QuestionTextNoName: {
    en: 'Question without name',
    nb: 'Spørsmål uten navn',
  },
  HelpTextNoName: {
    en: 'Help text without name',
    nb: 'Hjelpetekst uten navn',
  },
  Completed: {
    en: 'Completed',
    nb: 'Fullført',
  },
  Incomplete: {
    en: 'Incomplete',
    nb: 'Ikke fullført',
  },
  SurveysList: {
    en: 'Reports',
    nb: 'Rapporter',
  },
  SurveysListText: {
    en: 'From this page you can manage and create surveys',
    nb: 'Her kan du administrere og opprette undersøkelser',
  },
  SurveysTemplates: {
    en: 'Administer',
    nb: 'Administrer',
  },
  SurveysTemplatesText: {
    en: 'From this page you can create and edit templates that are used in surveys',
    nb: 'Her kan du lage og redigere maler som blir brukt i undersøkelser',
  },
  CreateSurveyInfoText: {
    en: 'From this page you can create new surveys based on the templates from Orgbrain and the ones you have created',
    nb: 'Her kan du lage nye undersøkelser basert på malene fra Orgbrain og de du har laget selv',
  },
  OpenAlreadyExisting: {
    en: 'Open Conversation',
    nb: 'Åpne samtale',
    sv: 'Öppna konversation',
  },
  SimilarConversations: {
    en: 'Similar Conversations',
    nb: 'Lignende samtaler',
    sv: 'Öppna konversation',
  },

  LeaveCurrentMeetingBeforeJoin: {
    en: 'Leave current call before joining new',
    nb: 'Forlat ditt nåværende videomøte for å bli med i et nytt',
    sv: 'Forlat ditt nåværende videomøte for å bli med i et nytt',
  },
  PromoteAdmin: {
    en: 'Give user conversation admin privileges',
    nb: 'Gi brukeren samtaleadministrator tillatelser',
    sv: 'kr',
  },
  LeaderRequired: {
    en: 'All conversations need atleast one user with conversation admin privileges',
    nb: 'Alle samtaler må ha ihvertfall en bruker med samtaleadministrator tillatelser',
    sv: 'kr',
  },
  GenerateTranscription: {
    en: 'Transcribe',
    nb: 'Transkriber',
  },

  ddProcesses: {
    en: 'Due diligence processes',
    nb: 'Due diligence-prosesser',
    sv: 'Due diligence-processer',
  },
  NIF_START: {
    en: 'NIF Basis',
    nb: 'NIF Basis',
    sv: 'NIF Basis',
  },
  NIF_PRO: {
    en: 'NIF Pro',
    nb: 'NIF Pro',
    sv: 'NIF Pro',
  },
  FREEMIUM: {
    en: 'Orgbrain Start',
    nb: 'Orgbrain Start',
  },
  DD_SUBSCRIPTION: {
    en: 'Due Diligence',
    nb: 'Due Diligence',
    sv: 'Due Diligence',
  },
  buyerStatus: {
    en: 'Buyer status',
    nb: 'Kjøperstatus',
  },
  sellerStatus: {
    en: 'Seller status',
    nb: 'Selgerstatus',
  },
  SummaryOfIssue: {
    en: 'Share issue summary',
    nb: 'Sammendrag av saken',
  },
  InvestorAttachments: {
    en: 'Attachments to the investor',
    nb: 'Vedlegg til investor',
  },
  PaymentInformation: {
    en: 'Payment information',
    nb: 'Betalingsinformasjon',
  },
  CapitalValue: {
    en: 'Assessed capital value',
    nb: 'Formuesverdi',
  },
  CapitalValueBold: {
    en: 'Add assessed capital value',
    nb: 'Legg til formuesverdi',
  },
  CapitalValueText: {
    en: 'Here you can enter the capital value per share and send a message to the shareholders.',
    nb: 'Her kan du legge inn formuesverdi per aksje og sende ut melding til aksjonærene.',
  },
  CapitalValueLabel: {
    en: 'Assessed capital value',
    nb: 'Formuesverdi',
  },
  CapitalValueDateLabel: {
    en: 'Date of assessed capital value',
    nb: 'Dato for formuesverdi',
  },
  FAKE_NAME_GRUNDER: {
    nb: 'Rabatt: Gründerpakke',
    en: 'Discount: Founder',
    sv: 'Rabatt: Grundarpaket',
  },
  FAKE_NAME_LITEN_BEDRIFT: {
    nb: 'Rabatt: Lite foretakspakke',
    en: 'Discount: Small business',
    sv: 'Rabatt: Litet företag',
  },
  FOUNDER2024: {
    en: 'Orgbrain Pro - Founder',
    nb: 'Orgbrain Pro - Gründer',
  },
  SMALL_BUSINESS2024: {
    en: 'Orgbrain Pro - Small Business',
    nb: 'Orgbrain Pro - Liten bedrift',
  },
  STANDARD2024: {
    en: 'Orgbrain Pro',
    nb: 'Orgbrain Pro',
    sv: 'Orgbrain Pro',
  },
  SHAREHOLDER_BASIS: {
    en: 'Shareholder Basis',
    nb: 'Aksjonærer Basis',
  },
  SHAREHOLDER_PRO: {
    en: 'Shareholders Pro',
    nb: 'Aksjonærer Pro',
  },
  ACADEMY_2025: {
    en: 'Academy & Board School',
    nb: 'Academy & Styreskolen',
  },
  BOARD_EVALUATION: {
    en: 'Surveys',
    nb: 'Undersøkelser',
  },
  SIGNATURE_PACKAGE: {
    en: 'BankID',
    nb: 'BankID',
  },
  AI_TRANSCRIPTION_PACKAGE: {
    en: 'AI-transcription',
    nb: 'AI-transkribering',
  },
  SECURITY_PRO: {
    en: 'Security package',
    nb: 'Sikkerhets-pakke',
  },
  DISCOUNT_USER_COUNT_GENERAL: {
    en: 'Number of free users',
    nb: 'Antall gratis brukere',
    sv: 'Antal gratisanvändare',
  },
  DISCOUNT_USER_COUNT_SUBGROUP: {
    en: 'Number of free subgroup users',
    nb: 'Antall gratis undergruppebrukere',
    sv: 'Antal gratis undergruppsanvändare',
  },
  DISCOUNT_USER_COUNT_ROLE_BASED: {
    en: 'Number of free users by role',
    nb: 'Antall gratis brukere etter rolle',
    sv: 'Antal lediga användare per roll',
  },
  Removed: {
    en: ' removed ',
    nb: ' fjernet ',
    sv: ' fjernet',
  },
  RemovedUppercase: {
    en: 'Removed ',
    nb: 'Fjernet ',
    sv: 'Fjernet',
  },
  FromGroup: {
    en: ' from the conversation',
    nb: ' fra samtalen',
  },
  Added: {
    en: ' added ',
    nb: ' la til ',
  },
  AddedUppercase: {
    en: 'Added ',
    nb: 'La til ',
  },
  AddedToConversationTitle: {
    en: 'Added in ',
    nb: 'Lagt til i ',
  },
  AddedToConversation1: {
    en: 'You were added in the conversation',
    nb: 'Du ble lagt til i samtalen',
  },
  AddedToConversation2: {
    en: 'by',
    nb: 'av',
  },
  RemovedFromConversationTitle: {
    en: 'Removed from ',
    nb: 'Fjernet fra ',
  },

  RemovedFromConversation: {
    en: 'You were removed from the conversation',
    nb: 'Du ble fjernet fra samtalen',
  },
  ACCESS_TO_BOARD_MEETINGSUserPermission: {
    en: 'User with access to board meetings',
    nb: 'Bruker med tilgang til styremøter',
  },
  ACCESS_TO_GA_MEETINGSUserPermission: {
    en: 'User with access to general assembly/annual meeting',
    nb: 'Bruker med generalforsamling/årsmøte-tilgang',
  },
  ADMINUserPermission: {
    en: 'User with admin access',
    nb: 'Bruker med admin-tilgang',
  },

  ViewDocumentTooltip: {
    en: 'Users are allowed to view the document, but not download it',
    nb: 'Brukere har lov til å se dokument, men ikke laste det ned',
  },
  DownloadDocumentWaterMark: {
    en: 'Download with watermark',
    nb: 'Last ned med vannmerke',
  },
  DownloadDocumentWaterMarkTooltip: {
    en: 'Users are allowed to download the documents with watermark',
    nb: 'Brukere har lov til å laste ned dokumenter med vannmerke',
  },
  DownloadDocument: {
    en: 'Download',
    nb: 'Last ned',
  },
  DownloadDocumentTooltip: {
    en: 'Users are allowed to download the documents without watermark',
    nb: 'Brukere har lov til å laste ned dokumenter uten vannmerke',
  },
  Mention: {
    en: 'Mention',
    nb: 'Nevne',
  },
  MentionedInConversation: {
    en: 'has mentioned you in the conversation',
    nb: 'har nevnt deg i samtalen',
  },
  MentionedInConversationTitle: {
    en: 'mentioned you',
    nb: 'nevnte deg',
  },
  ToGroup: {
    en: ' to the conversation',
    nb: ' i samtalen',
  },
  LeftGroup: {
    en: ' left the conversation',
    nb: ' forlot samtalen',
  },
  RenamedConversation: {
    en: ' renamed the conversation to ',
    nb: ' endret navnet på samtalen til ',
  },
  RenamedConversationUppercase: {
    en: 'Renamed conversation ',
    nb: 'Endret navnet på samtalen ',
  },
  ChangeConversationName: {
    en: 'Rename the conversation',
    nb: 'Endre navnet på samtalen',
  },

  ChangeConversationTopic: {
    en: 'Change conversation topic',
    nb: 'Endre samtaleemne',
  },

  CreateConversationFromNewsTooltip: {
    en: 'Here you can start a conversation about this announcement with the rest of the organization.',
    nb: 'Her kan du opprette en samtale om denne kunngjøringen med resten av virksomheten',
  },

  CreateConversation: {
    en: 'Create conversation',
    nb: 'Start samtale',
  },
  AddReaction: {
    en: 'Find other reaction',
    nb: 'Finn en annen reaksjon',
    sv: 'Ny konversation',
  },
  ConversationAdmin: {
    en: 'This user has admin permissions in this conversation',
    nb: 'Denne brukeren har admin tilgang i denne samtalen',
    sv: 'Ny konversation',
  },
  titleTooltipText: {
    nb: 'Her gir du spørreskjemaet et navn, for eksempel «Styreevaluering», «HMS-undersøkelse» o.l.',
    en: 'Give the survey a name, for example "Board evaluation", "HSE survey" etc.',
  },
  aboutQuestionarie: {
    nb: 'Om spørreskjemaet',
    en: 'About the Questionnaire',
  },
  aboutQuestionarieTooltipText: {
    nb: 'Her kan du gi en nærmere beskrivelse av spørreundersøkelsen, slik at den som inviterer til undersøkelsen forstår hva som er formålet med spørreskjemaet. Teksten vil ikke være synlig for de som blir invitert til å delta i undersøkelsen.',
    en: 'Here you can provide a more detailed description of the survey, so that the person inviting to the survey understands the purpose of the questionnaire. The text will not be visible to those invited to participate in the survey.',
  },
  Boardchat: { en: 'Board Chat', nb: 'Styrets nettprat (chat)' },
  NewConversation: {
    en: 'New conversation',
    nb: 'Ny samtale',
    sv: 'Ny konversation',
  },
  ConversationName: {
    en: 'Conversation name (if desired)',
    nb: 'Tittel for samtalen (om ønskelig)',
  },
  Conversations: {
    en: 'Conversations',
    nb: 'Samtaler',
    sv: 'Konversationer',
  },
  JoinedCallTranscript: {
    en: ' joined the call',
    nb: ' ble med i videomøtet',
    sv: ' ble med i videomøtet',
  },
  StartCall: {
    en: 'Join the call',
    nb: 'Bli med i videomøte',
    sv: 'Bli med i videomøte',
  },
  JoinedCall: {
    en: ' started a call',
    nb: ' startet et videomøte',
    sv: ' ble med i videomøte',
  },
  StartCallUppercase: {
    en: 'Started a call',
    nb: 'Startet et videomøte',
    sv: ' ble med i videomøte',
  },
  CallEndedUppercase: {
    en: 'Call ended',
    nb: 'Videomøtet er avsluttet',
    sv: ' ble med i videomøte',
  },
  CallEnded: {
    en: 'All members have left the call',
    nb: 'Alle medlemmer har forlatt videomøtet',
    sv: ' Videomøtet ble avslutte',
  },

  AddToConversation: {
    en: 'Add to conversation',
    nb: 'Legg til i samtale',
    sv: 'Lägg till i konversation',
  },
  MembersInConversation: {
    en: 'Members in conversation',
    nb: 'Medlemmer i samtalen',
    sv: 'Medlemmar i konversationen',
  },
  LeaveConversation: {
    en: 'Leave conversation',
    nb: 'Forlat samtale',
    sv: 'Lämna konversation',
  },
  RemoveFromGroup: {
    en: 'Remove from conversation',
    nb: 'Fjern fra samtalen',
    sv: 'Ta bort från konversationen',
  },
  AddPeopleToConversation: {
    en: 'Add people to conversation',
    nb: 'Legg til personer i samtalen',
    sv: 'Lägg till personer i konversationen',
  },
  CreateNewConversation: {
    en: 'Create new conversation',
    nb: 'Opprett ny samtale',
    sv: 'Skapa ny konversation',
  },
  MakeTask: {
    en: `Make task`,
    nb: 'Lag oppgave',
    sv: 'Skapa ny konversation',
  },
  MakeTaskTooltip: {
    en: `Here you can create a new task which is based on this message.`,
    nb: 'Her kan du lage en ny oppgave som er basert på denne meldingen.',
    sv: 'Skapa ny konversation',
  },
  Leave: {
    en: 'Leave',
    nb: 'Forlat',
    sv: 'Lämna',
  },
  Remove: {
    en: 'Remove',
    nb: 'Fjern',
    sv: 'Ta bort',
  },
  LeaveConversationText: {
    en: 'Do you want to leave the conversation?',
    nb: 'Vil du forlate samtalen?',
    sv: 'Vill du lämna konversationen?',
  },
  RemoveMembersFromConversationText: {
    en: 'Do you want to remove this member from the conversation?',
    nb: 'Ønsker du å fjerne dette medlemmet fra samtalen?',
    sv: 'Ta bort medlemmar från konversationen?',
  },
  DescriptionHasChanged: {
    en: 'Task has been changed by someone else. If you save now - you will overwrite the changes.',
    nb: 'Oppgaven har blitt endret av noen andre. Hvis du lagrer nå - vil du overskrive endringene.',
  },

  WantToDeleteChatMessage: {
    en: 'Are you sure you want to delete this message?',
    nb: 'Er du sikker på at du vil slette denne meldingen?',
  },
  BeneficialOwner: {
    en: 'Beneficial owner',
    nb: 'Reell rettighetshaver',
  },
  BenficialOwnerEmailSubject: {
    en: 'Registered as beneficial owner',
    nb: 'Registrert som reell rettighetshaver',
  },
  BenficialOwnerBoldText1: {
    en: ' has registered ',
    nb: ' har registret ',
  },
  BenficialOwnerBoldText2: {
    en: ' as a beneficial owner.',
    nb: ' som reell rettighetshaver.',
  },
  BenficialOwnerText00: {
    en: 'In accordance with the regulation to the law on the register of beneficial owners § 2-6, ',
    nb: 'I henhold til forskrift til lov om register over reelle rettighetshavere § 2-6 er ',
  },
  BenficialOwnerText01: {
    en: ' is obliged to notify you of this. ',
    nb: ' forpliktet til å varsle deg om dette. ',
  },
  BenficialOwnerText1: {
    en: 'I henhold til forskrift til lov om register over reelle rettighetshavere § 2-6 er forpliktet til å varsle deg om dette.  The information is reported to the register of beneficial owners. If you believe this is incorrect, please contact the company',
    nb: 'Opplysningene meldes inn til registeret over reelle rettighetshavere. Dersom du mener at dette ikke er korrekt, ber vi deg ta kontakt med selskapet',
  },
  BenficialOwnerText2: {
    en: 'More information about beneficial owners can be found here: https://www.brreg.no/reelle-rettighetshavere/',
    nb: 'Mer informasjon om reelle rettighetshavere finner du her: https://www.brreg.no/reelle-rettighetshavere/',
  },
  OwnerMissingEmail: {
    en: 'Some beneficial owners are missing email addresses. Please add email addresses to all beneficial owners before sending the email',
    nb: 'Noen reelle rettighetshavere mangler e-postadresser. Vennligst legg til e-postadresser på alle reelle rettighetshavere før du sender e-posten',
    sv: 'x6',
  },
  ErrorInSendingEmail: {
    en: 'Error when sending email',
    nb: 'Feil ved sending av e-post',
    sv: 'x6',
  },
  EmailSentToBeneficialOwner: {
    en: 'Email sent to beneficial owner',
    nb: 'E-post sendt til reell rettighetshaver',
    sv: 'x6',
  },
  SigningMethod: {
    en: 'Signing method',
    nb: 'Signeringsmetode',
  },
  completeMeetingAction: {
    en: 'Complete meeting',
    nb: 'Fullfør møtet',
  },
  annualPlanCreated: {
    en: 'Annual plan created',
    nb: 'Årsplan opprettet',
  },
  allChatMembers: {
    en: 'All chat members',
    nb: 'Alle chatmedlemmer',
  },
  NotifyEveryoneInCurrentConversation: {
    en: 'Notify everyone in current conversation',
    nb: 'Varsle alle i gjeldende samtale',
  },
  annualPlanDeleted: {
    en: 'Annual plan deleted',
    nb: 'Årsplan slettet',
  },
  'meetings.minutes.noConsolidation': {
    en: 'Ordinary minutes',
    nb: 'Vanlig protokoll',
  },
  'Template-onlyGeneratedProtokoll': {
    en: 'Only minutes are generated for this company in the ordinary way.',
    nb: 'Det genereres kun protokoll for dette selskapet på ordinær måte.',
  },
  'meetings.minutes.Oneidenticalminutes': {
    en: 'A single, identical protocol is generated for all companies in the selected list. The names of all companies are displayed at the top of the protocol.',
    nb: 'Det genereres én likelydende protokoll for alle selskapene i den valgte listen. Navn på alle selskapene vises øverst i protokollen.',
  },
  'meetings.minutes.Identicalminutesaregenerated': {
    en: 'Identical protocols are generated for all companies in the list, but each protocol only shows the name of the company in question. Each protocol must be signed separately.',
    nb: 'Det genereres likelydende protokoller for alle selskapene i listen, men hver protokoll viser kun navnet på det aktuelle selskapet. Hver protokoll må signeres separat.',
  },

  'meetings.minutes.Merk': {
    en: 'Note',
    nb: 'Merk',
  },
  'meetings.minutes.ForGroupMnutes': {
    en: 'For group minutes, generic numbering of agenda items is used.',
    nb: 'Ved gruppeprotokoll brukes generisk nummerering av agendapunkter.',
  },
  'meetings.minutes.ForGroupMnutes2': {
    en: 'Attachments added to agenda items in this meeting are not automatically copied to the data room for each subsidiary.',
    nb: 'Vedlegg som legges til agendapunkter i dette møtet kopieres ikke automatisk til datarommet for hvert datterselskap.',
  },
  'meetings.minutes.reGeneratePlease': {
    en: 'Please re-generate minutes after changing settings',
    nb: 'Vennligst generer protokollen på nytt etter at du har endret innstillingene',
  },
  'meetings.minutes.hasBeenHeld': {
    en: 'been held in the following companies',
    nb: 'har blitt avhold i følgende selskaper',
  },
  MinutesGroups: {
    en: 'Company groups',
    nb: 'Selskapsgrupper',
  },

  AllComments: {
    en: 'All comments',
    nb: 'Alle kommentarer',
  },

  'meetings.minutes.minutesGroupActiveSeparate': {
    en: 'Separate minutes',
    nb: 'Separate protokoller',
  },
  'meetings.minutes.ConnectionName': {
    en: 'Group name',
    nb: 'Gruppenavn',
  },
  ChangesInSubscriptions: {
    en: 'Changes in subscriptions',
    nb: 'Endringer i abonnementer',
  },
  BogdanEnd: {
    en: 'x4',
    nb: 'x5',
    sv: 'x6',
  },
  PaulBegin: {
    en: 'x1',
    nb: 'x2',
    sv: 'x3',
  },
  [BaseSteps._SHARED_WITH_ME_]: {
    en: 'Shared with me',
    nb: 'Delt med meg',
    sv: 'Delat med mig',
  },
  [BaseSteps._SHARED_I_CONTROL_]: {
    en: 'Shares I control',
    nb: 'Delinger jeg kontrollerer',
    sv: 'Delningar jag kontrollerar',
  },
  EMAIL_ORG_CREATE_iscreated: {
    en: 'is created',
    nb: 'er opprettet',
  },
  EMAIL_ORG_CREATE_iscreated2: {
    en: 'Thank you for creating',
    nb: 'Takk for at du har opprettet',
  },
  EMAIL_ORG_CREATE_iscreated3: {
    en: 'at Orgbrain. To explore the possibilities in Orgbrain, you will find useful tips and information on our',
    nb: 'hos Orgbrain. For å utforske mulighetene i Orgbrain, finner du nyttige tips og informasjon på vår',
  },
  helppage: {
    en: 'help page',
    nb: 'hjelpeside',
  },
  loginToPortal: {
    en: 'Login to the portal',
    nb: 'Innlogging til portalen',
  },
  EMAIL_ORG_CREATE_iscreated4: {
    en: "Do you have any questions? Feel free to contact us via the chat in the portal – we'll be happy to help you!",
    nb: 'Har du spørsmål? Ta gjerne kontakt med oss via chatten i portalen – vi hjelper deg gjerne!',
  },
  WeWishYouANiceDay: {
    en: 'We wish you a nice day.',
    nb: 'Vi ønsker deg en fortsatt fin dag.',
  },
  OrgbrainTeam: {
    en: 'Orgbrain team',
    nb: 'Orgbrain-teamet',
  },
  PaulEnd: {
    en: 'x4',
    nb: 'x5',
    sv: 'x6',
  },
  EivindBegin: {
    en: 'x1',
    nb: 'x2',
    sv: 'x3',
  },
  EivindEnd: {
    en: 'x4',
    nb: 'x5',
    sv: 'x6',
  },
  PederBegin: {
    en: 'x1',
    nb: 'x2',
    sv: 'x3',
  },
  NoCurrentContracts: {
    en: 'No contracts are currently active',
    nb: 'Ingen kontrakter er aktive.',
  },
  NoContracts: {
    en: 'No contracts have been made yet. Press the button "New contract" to create your first contract.',
    nb: 'Ingen kontrakter er laget enda. Trykk på knappen "Ny kontrakt" for å lage din første kontrakt.',
  },

  Home: {
    en: 'Home',
    nb: 'Hjem',
    sv: 'Hem',
  },
  PederEnd: {
    en: 'x4',
    nb: 'x5',
    sv: 'x6',
  },
  ViktorBegin: {
    en: 'x1',
    nb: 'x2',
    sv: 'x3',
  },
  ViktorEnd: {
    en: 'x4',
    nb: 'x5',
    sv: 'x6',
  },
  SondreBegin: {
    en: 'x1',
    nb: 'x2',
    sv: 'x3',
  },
  SondreEnd: {
    en: 'x4',
    nb: 'x5',
    sv: 'x6',
  },
  Next: {
    en: 'Next',
    nb: 'Neste',
    sv: 'Nästa',
  },
  MeetingSubtitle: {
    en: 'Subtitle',
    nb: 'Undertittel',
    sv: 'Underrubrik',
  },
  NewShareclass: {
    en: 'New share class',
    nb: 'Ny aksjeklasse',
  },
  ShowMore: {
    en: 'Show more',
    nb: 'Vis mer',
  },
  proceedDataUnsavedText: {
    nb: 'Er du sikker på om at du vil forkaste endringene dine?',
    en: 'Are you sure you want to discard your changes?',
    sv: 'x6',
  },
  MeetingNr: {
    nb: 'Møte nr.',
    en: 'Meeting No.',
  },
  BasicInformationMeeting: {
    en: 'Meeting information',
    nb: 'Møteinformasjon',
  },
  FormOfMeeting: {
    en: 'Meeting format',
    nb: 'Møteform',
  },
  ExtraSettingsMeeting: {
    en: 'Ekstra settings',
    nb: 'Ekstra detaljer',
  },
  MeetingTitle: {
    en: 'Subtitle',
    nb: 'Undertittel',
  },
  CreateNewMeeting: {
    en: 'Create new meeting',
    nb: 'Opprett nytt møte',
  },
  HistoricalComments: {
    en: 'Comments',
    nb: 'Kommentarer',
  },
  MeetingStatus: {
    en: 'Meeting status',
    nb: 'Møtestatus',
  },
  PDFVersionFrom: {
    en: 'PDF version from',
    nb: 'PDF-versjon fra',
  },
  Reminder: {
    en: 'Reminder',
    nb: 'Påminnelse',
    sv: 'Påminnelse',
  },
  NoEmailSetWarning: {
    en: 'No email',
    nb: 'Ingen e-postadresse',
  },
  and: {
    en: 'and',
    nb: 'og',
    sv: 'och',
  },
  of: {
    en: 'of',
    nb: 'av',
    sv: 'av',
  },
  Page: {
    en: 'Page',
    nb: 'Side',
    sv: 'Sida',
  },
  Pages: {
    en: 'Pages',
    nb: 'Sider',
    sv: 'Sidor',
  },
  InviteInvestors: {
    en: 'Invite investors',
    nb: 'Inviter investorer',
    sv: 'Bjud in investerare',
  },
  SendReminder: {
    en: 'Send reminder',
    nb: 'Send påminnelse',
    sv: 'Skicka påminnelse',
  },
  SendReminderToAll: {
    en: 'Remind all unsigned',
    nb: 'Påminn alle usignerte',
    sv: 'Skicka påminnelse',
  },
  Contact: {
    en: 'Contact',
    nb: 'Kontakt',
    sv: 'Skicka påminnelse',
  },

  'This document package contains': {
    en: 'This document package contains',
    nb: 'Denne dokumentpakken inneholder',
  },
  'Signing of encrypted files is not supported': {
    en: 'Signing of encrypted files is not supported',
    nb: 'Signering av kryptert fil støttes ikke',
  },
  'The original document': {
    en: 'The original document',
    nb: 'Det originale dokumentet',
  },
  'This signature page at the end': {
    en: 'This signature page at the end',
    nb: 'Denne signatursiden på slutten',
  },
  'Signature pages at the end': {
    en: 'Signature pages at the end',
    nb: 'Signatur sidene på slutten',
  },
  'COUNTRY:NO': {
    en: 'Norway',
    nb: 'Norge',
    sv: 'Norge',
  },
  'COUNTRY:SE': {
    en: 'Sweden',
    nb: 'Sverige',
    sv: 'Sverige',
  },
  'COUNTRY:DK': {
    en: 'Denmark',
    nb: 'Danmark',
    sv: 'Danmark',
  },
  'registertype.registerOverReelleRettighetshavereIBelgia': {
    en: 'Belgium',
    nb: 'Belgia',
  },
  'registertype.registerOverReelleRettighetshavereIBulgaria': {
    en: 'Bulgaria',
    nb: 'Bulgaria',
  },
  'registertype.registerOverReelleRettighetshavereIDanmark': {
    en: 'Denmark',
    nb: 'Danmark',
  },
  'registertype.registerOverReelleRettighetshavereIEstland': {
    en: 'Estonia',
    nb: 'Estland',
  },
  'registertype.registerOverReelleRettighetshavereIFinland': {
    en: 'Finland',
    nb: 'Finland',
  },
  'registertype.registerOverReelleRettighetshavereIFrankrike': {
    en: 'France',
    nb: 'Frankrike',
  },
  'registertype.registerOverReelleRettighetshavereIHellas': {
    en: 'Greece',
    nb: 'Hellas',
  },
  'registertype.registerOverReelleRettighetshavereIIrland': {
    en: 'Ireland',
    nb: 'Irland',
  },
  'registertype.registerOverReelleRettighetshavereIIsland': {
    en: 'Iceland',
    nb: 'Island',
  },
  'registertype.registerOverReelleRettighetshavereIItalia': {
    en: 'Italy',
    nb: 'Italia',
  },
  'registertype.registerOverReelleRettighetshavereIKroatia': {
    en: 'Croatia',
    nb: 'Kroatia',
  },
  'registertype.registerOverReelleRettighetshavereIKypros': {
    en: 'Cyprus',
    nb: 'Kypros',
  },
  'registertype.registerOverReelleRettighetshavereILatvia': {
    en: 'Latvia',
    nb: 'Latvia',
  },
  'registertype.registerOverReelleRettighetshavereILiechtenstein': {
    en: 'Liechtenstein',
    nb: 'Liechtenstein',
  },
  'registertype.registerOverReelleRettighetshavereILitauen': {
    en: 'Lithuania',
    nb: 'Litauen',
  },
  'registertype.registerOverReelleRettighetshavereILuxembourg': {
    en: 'Luxembourg',
    nb: 'Luxembourg',
  },
  'registertype.registerOverReelleRettighetshavereIMalta': {
    en: 'Malta',
    nb: 'Malta',
  },
  'registertype.registerOverReelleRettighetshavereINederland': {
    en: 'Netherlands',
    nb: 'Nederland',
  },
  'registertype.registerOverReelleRettighetshavereIPolen': {
    en: 'Poland',
    nb: 'Polen',
  },
  'registertype.registerOverReelleRettighetshavereIPortugal': {
    en: 'Portugal',
    nb: 'Portugal',
  },
  'registertype.registerOverReelleRettighetshavereIRomania': {
    en: 'Romania',
    nb: 'Romania',
  },
  'registertype.registerOverReelleRettighetshavereISlovakia': {
    en: 'Slovakia',
    nb: 'Slovakia',
  },
  'registertype.registerOverReelleRettighetshavereISlovenia': {
    en: 'Slovenia',
    nb: 'Slovenia',
  },
  'registertype.registerOverReelleRettighetshavereISpania': {
    en: 'Spain',
    nb: 'Spania',
  },
  'registertype.registerOverReelleRettighetshavereISverige': {
    en: 'Sweden',
    nb: 'Sverige',
  },
  'registertype.registerOverReelleRettighetshavereITsjekkia': {
    en: 'Czech Republic',
    nb: 'Tsjekkia',
  },
  'registertype.registerOverReelleRettighetshavereITyskland': {
    en: 'Germany',
    nb: 'Tyskland',
  },
  'registertype.registerOverReelleRettighetshavereIUngarn': {
    en: 'Hungary',
    nb: 'Ungarn',
  },
  'registertype.registerOverReelleRettighetshavereIOesterrike': {
    en: 'Austria',
    nb: 'Østerrike',
  },
  EMAIL_ATTACHMENTS: {
    en: 'Email attachments',
    nb: 'E-postvedlegg',
    sv: 'E-postbilagor',
  },
  PROXY_FOLDER: {
    en: 'Proxy',
    nb: 'Fullmektig',
    sv: 'Ombud',
  },
  ATTACHMENTS: {
    en: 'Attachments',
    nb: 'Vedlegg',
    sv: 'Bilagor',
  },
  MeetingHasNotStartedYet: {
    en: ': Not started yet',
    nb: ': Ikke startet ennå',
  },
  MeetingStartingIn: {
    en: ': Starting in ',
    nb: ': Starter om ',
  },
  DRAFT: {
    en: 'Draft',
    nb: 'Kladd',
    sv: 'Förslag',
  },
  PLANNED: {
    en: 'Planned',
    nb: 'Planlagt',
    sv: 'Planerad',
  },
  CALLED: {
    nb: 'Innkalling til møte',
    en: 'Meeting called',
    sv: 'Möte kallat',
  },
  ACTIVE: {
    nb: 'Møtet har startet',
    en: 'Meeting has started',
  },
  ANNUAL_PLAN: {
    en: 'Annual Plan',
    nb: 'Årsplan',
    sv: 'Årlig plan',
  },
  REQUIRES_SIGNATURES: {
    en: 'Signing',
    nb: 'Signering',
    sv: 'Signering',
  },
  COMPLETED: {
    en: 'Completed',
    nb: 'Fullført',
    sv: 'Färdigt',
  },
  CANCELLED: {
    en: 'Cancelled',
    nb: 'Avlyst',
    sv: 'Inställt',
  },
  TEST: {
    en: 'Trial (Expired)',
    nb: 'Prøve (Utløpende)',
    sv: 'Rättegång (Utlöper)',
  },
  TEST2024: {
    en: 'Trial',
    nb: 'Prøve',
    sv: 'Rättegång',
  },
  DEPENDENT: {
    en: 'Dependent',
    nb: 'Avhengig',
    sv: 'Beroende',
  },
  ALLSTATUS: {
    en: 'Alle statuses',
    nb: 'Alle statuser',
  },
  RELEVANTADS: {
    en: 'Relevant ads',
    nb: 'Aktuelle annonser',
  },
  RELEVANTCANDIDATES: {
    en: 'Relevant candidates',
    nb: 'Aktuelle kandidater',
  },
  POSITIVE: {
    en: 'Interesting',
    nb: 'Interessant',
  },
  NEGATIVE: {
    en: 'Not interesting',
    nb: 'Ikke interessant',
  },
  NEUTRAL: {
    en: 'Maybe interesting',
    nb: 'Kanskje interessant',
    sv: 'Kanskje interessant',
  },
  Neutral: {
    en: 'Blank',
    nb: 'Blank',
  },
  BOARDSCHOOL: {
    en: 'Board School',
    nb: 'Styreskolen',
    sv: 'Styrelseskolan',
  },
  SUSPENDED: {
    en: 'Expired',
    nb: 'Utgått',
    sv: 'Utgånget',
  },
  GRUNDER: {
    en: 'Founder (Expired)',
    nb: 'Gründer (Utløpende)',
    sv: 'Grundare (Utlöper)',
  },
  SMALL_BUSINESS: {
    en: 'Small business (Expired)',
    nb: 'Lite foretak (Utløpende)',
    sv: 'Litet företag (Utlöper)',
  },
  FOUNDER: {
    en: 'Founder package (Expired)',
    nb: 'Gründerpakke (Utløpende)',
    sv: 'Grundarpaket (Utlöper)',
  },
  SMALL_BUSINESS2: {
    en: 'Small business (Expired)',
    nb: 'Lite foretak (Utløpende)',
    sv: 'Småföretagspaket (Utlöper)',
  },
  BASIS: {
    en: 'Standard (Expired)',
    nb: 'Standard (Utløpende)',
    sv: 'Standard (Utlöper)',
  },
  ENTERPRISE: {
    en: 'Enterprise',
    nb: 'Enterprise',
    sv: 'Enterprise',
  },
  PersonalFiles: {
    en: 'Personal Files',
    nb: 'Personlige filer',
    sv: 'Personliga filer',
  },
  MeetingFiles: {
    en: 'Meeting Files',
    nb: 'Møtefiler',
    sv: 'Mötesfiler',
  },
  all_meeting: {
    en: 'Board',
    nb: 'Styre',
    sv: 'Styrelse',
  },
  ga_meetings: {
    en: 'Owner/Member',
    nb: 'Eier/Medlem',
    sv: 'Ägare / medlem',
  },
  admin: {
    en: 'Admin',
    nb: 'Admin',
    sv: 'Administration',
  },
  buyer: {
    en: 'Data Room',
    nb: 'Datarom',
    sv: 'Datarum',
  },
  DataRoomRoot: {
    en: 'Data Room',
    nb: 'Datarom',
    sv: 'Datarum',
  },
  hasVoted: {
    en: 'has voted',
    nb: 'har stemt',
  },
  Activate: {
    en: 'Activate',
    nb: 'Aktiver',
    sv: 'Aktivera',
  },
  Enable: {
    en: 'Enable',
    nb: 'Aktiver',
    sv: 'Gör det möjligt',
  },
  Disable: {
    en: 'Disable',
    nb: 'Deaktiver',
    sv: 'Inaktivera',
  },
  Enabled: {
    en: 'Enabled',
    nb: 'Aktivert',
    sv: 'Aktiverad',
  },
  ChooseTimePoint: {
    en: 'Choose date and time',
    nb: 'Velg dato og tidspunkt',
    sv: 'Aktiverad',
  },
  Users: {
    en: 'Users',
    nb: 'Brukere',
    sv: 'Brukere',
  },
  ReactedWith: {
    en: ' reacted with ',
    nb: ' reagerte med ',
    sv: ' reagerte med ',
  },
  MeetingUserListInfoText: {
    en: ' Here you can enter a historical user status. This can be used, for example, if there have been changes to the board, and there is a need to create a record of the status before the changes occurred. ',
    nb: ' Her kan du legge inn en brukerstatus tilbake i tid. Dette kan for eksempel benyttes dersom det har skjedd endringer i styret, og det er behov for å lage en protokoll med status før endringene skjedde. ',
    sv: 'Aktiverad',
  },
  Disabled: {
    en: 'Disabled',
    nb: 'Deaktivert',
    sv: 'Inaktiverad',
  },
  Yes: {
    en: 'Yes',
    nb: 'Ja',
    sv: 'Ja',
  },
  No: {
    en: 'No',
    nb: 'Nei',
    sv: 'Nej',
  },
  'Meeting type': {
    en: 'Meeting type',
    nb: 'Møtetype',
    sv: 'Möte typ',
  },
  Digitally: {
    en: 'Digital',
    nb: 'Digitalt',
  },
  NoAttendeesInvite: {
    en: 'No attendees here',
    nb: 'Ingen deltakere her',
  },
  AttendingAsProxy: {
    en: ' has given you power of attorney',
    nb: ' har gitt deg fullmakt',
  },
  'Settings.Transcriptions': {
    nb: 'Møte-AI',
    en: 'Meeting AI',
  },
  'Settings.TranscriptionsText': {
    nb: 'Velg hvordan organisasjonen ønsker å bruke Møte-AI.',
    en: 'Choose how the organization wants to use Meeting AI.',
  },
  TurnOn: {
    en: 'Turn on',
    nb: 'Skru på',
  },
  NotNow: {
    en: 'Not now',
    nb: 'Ikke nå',
  },
  UnidentifiedInParticipant1: {
    en: 'Detected ',
    nb: 'Det er oppdaget ',
  },
  UnidentifiedInParticipant2: {
    en: ' different voices on this user. You can choose to give them a name below.',
    nb: ' forskjellige stemmer på denne brukeren. Du kan velge å gi dem navn under.',
  },
  NotPossibleToConfirmParticipationNow: {
    en: 'It is only possible to confirm participation half an hour before the meeting starts',
    nb: 'Det er kun mulig å bekrefte deltakelse i en halvtime før møtet starter',
  },
  ConfirmParticipationTooltip: {
    en: 'Confirm your meeting attendance, this is necessary to vote in the meeting.',
    nb: 'Bekreft din møtedeltakelse, dette er nødvendig for å kunne stemme i møtet.',
  },
  AttendanceType: {
    en: 'Hybrid meeting',
    nb: 'Hybridmøte',
  },
  WhichAttendanceType: {
    en: 'How will you attend the meeting?',
    nb: 'Hvordan skal du delta på møtet?',
  },
  PhysicalAttendance: {
    en: 'Physical',
    nb: 'Fysisk',
  },
  YourRepresentation: {
    en: 'You represent',
    nb: 'Du representerer',
  },
  MeetingParticipationConfirmed: {
    nb: 'Oppmøte bekreftet',
    en: 'Attendance confirmed',
  },
  Attending: {
    en: ' has marked that they plan to attend.',
    nb: ' har markert at de planlegger å delta.',
  },
  AttendingDigitally: {
    en: ' has marked that they plan to attend digitally.',
    nb: ' har markert at de planlegger å delta digitalt.',
  },
  NotAttending: {
    en: ' is not attending',
    nb: ' deltar ikke',
  },
  GivenProxy: {
    en: ' has given power of attorney',
    nb: ' har gitt fullmakt',
  },
  AttendPhysically: {
    en: 'Attend physically',
    nb: 'Delta fysisk',
  },
  AttendDigitally: {
    en: 'Attend digitally',
    nb: 'Delta digitalt',
  },
  nullTranslation: {
    en: 'Loading...',
    nb: 'Laster...',
  },
  PHYSICAL_MEETING: {
    en: 'In-person Meeting',
    nb: 'Fysisk møte',
    sv: 'Fysiskt möte',
  },
  PHONE_MEETING: {
    en: 'Phone Meeting',
    nb: 'Telefonmøte',
    sv: 'Telefonkonferens',
  },
  HYBRID_MEETING: {
    en: 'Hybrid Meeting',
    nb: 'Hybridmøte',
    sv: 'Hybrid möte',
  },
  DIGITAL_MEETING: {
    en: 'Digital Meeting',
    nb: 'Digitalt møte',
    sv: 'Digital möte',
  },
  VIDEO_CONFERENCE: {
    en: 'Video Conference',
    nb: 'Videokonferanse',
    sv: 'Videokonferens',
  },
  WRITTEN_PROCEDURE: {
    en: 'Written Procedure',
    nb: 'Skriftlig behandling',
    sv: 'Skriftligt förfarande',
  },
  OTHER_PROCEDURE: {
    en: 'Other Procedure',
    nb: 'Annen møteform',
    sv: 'Annat förfarande',
  },
  Date: {
    en: 'Date',
    nb: 'Dato',
    sv: 'Datum',
  },
  Location: {
    en: 'Location',
    nb: 'Sted',
    sv: 'Plats',
  },
  EditVotesAndVoters: {
    en: 'Edit votes',
    nb: 'Rediger stemmer',
  },
  'Proposed resolution': {
    en: 'Proposed resolution',
    nb: 'Forslag til vedtak',
    sv: 'Föreslagen resolution',
  },
  manageVotes: {
    en: 'Manage votes',
    nb: 'Administrer stemmer',
  },
  LinkToEmission: {
    en: 'Link to emission',
    nb: 'Lenke til kapitalforhøyelse',
    sv: 'Länk till emission',
  },
  For: {
    en: 'For',
    nb: 'For',
    sv: 'För',
  },
  Against: {
    en: 'Against',
    nb: 'Imot',
    sv: 'Mot',
  },
  AdvisersClientsTab: {
    en: 'Advisers',
    nb: 'Rådgivere',
  },
  ReportsClientsTab: {
    en: 'Reports',
    nb: 'Rapporter',
    sv: 'Rapporter',
  },
  'General comments': {
    en: 'General comments',
    nb: 'Generelle kommentarer',
    sv: 'Generella kommentarer',
  },
  Participants: {
    en: 'Participants',
    nb: 'Deltakere',
    sv: 'Deltagarna',
  },
  'Did not participate': {
    en: 'Did not participate',
    nb: 'Deltok ikke',
    sv: 'Deltog inte',
  },
  'Chair of the meeting': {
    en: 'Chair of the meeting',
    nb: 'Møteleder',
    sv: 'Ordförande för mötet',
  },
  TieResolutionText: {
    en: 'In the event of a tie, the decision is made by a built-in lottery',
    nb: 'Ved stemmelikhet, treffes avgjørelsen ved en innebygget loddtrekning',
    sv: 'I händelse av oavgjort fattas beslutet av ett inbyggt lotteri',
  },
  minutesInfoForProcedureTypePhysicalMeeting: {
    en: 'The proceedings were carried out as a meeting.',
    nb: 'Styrebehandlingen ble gjennomført som et møte.',
    sv: 'Förfarandet genomfördes som ett möte.',
  },
  minutesInfoForProcedureTypeHybridMeeting: {
    en: 'The proceedings were carried out as a hybrid meeting.',
    nb: 'Styrebehandlingen ble gjennomført som et hybridmøte.',
    sv: 'Förfarandet genomfördes som ett hybridmöte.',
  },
  minutesInfoForProcedureTypeDigitalMeeting: {
    en: 'The proceedings were carried out as a digital meeting.',
    nb: 'Styrebehandlingen ble gjennomført som et digitalt møte.',
    sv: 'Förfarandet genomfördes som ett digital möte.',
  },

  minutesInfoForProcedureTypePhoneMeeting: {
    en: 'The proceedings were carried out as a phone meeting.',
    nb: 'Styrebehandlingen ble gjennomført per telefon.',
    sv: 'Förfarandet genomfördes som ett telefonmöte.',
  },
  minutesInfoForProcedureTypeVideoConference: {
    en: 'The proceedings were carried out as a video conference.',
    nb: 'Styrebehandlingen ble gjennomført som en videokonferanse.',
    sv: 'Förfarandet genomfördes som en videokonferens.',
  },
  minutesInfoForProcedureTypeWrittenProcedure: {
    en: 'The proceedings were carried out in writing without a meeting.',
    nb: 'Styrebehandlingen ble gjennomført skriftlig og uten møte.',
    sv: 'Förfarandet genomfördes skriftligen utan möte.',
  },
  MeetingVotedOnAndApproved: {
    en: 'The following decision was voted on and approved:',
    nb: 'Følgende forslag ble stemt over og vedtatt:',
    sv: 'Följande beslut röstades om och godkändes:',
  },
  MeetingVotedOnAndRejected: {
    en: 'The following decision was voted on but rejected:',
    nb: 'Følgende forslag ble stemt over, men fikk ikke flertall:',
    sv: 'Följande beslut röstades om men avvisades:',
  },
  MeetingVotePassedAllFor: {
    en: 'There was a unanimous vote in favour of the following decision:',
    nb: 'Følgende forslag ble enstemmig vedtatt:',
    sv: 'Följande beslut röstades enhälligt för:',
  },
  MeetingVotePassedWithAllDecisionsUnanimous: {
    en: 'The following decision was made:',
    nb: 'Det ble fattet følgende vedtak:',
    sv: 'Följande beslut fattades:',
  },
  MeetingVoteRjectedAllAgainst: {
    en: 'There was a unanimous vote against the following decision:',
    nb: 'Følgende forslag ble enstemmig nedstemt:',
    sv: 'Följande beslut röstades enhälligt emot:',
  },
  MeetingThoseForDecision: {
    en: 'The following voted in favour of the decision:',
    nb: 'Følgende stemte for forslaget:',
    sv: 'Följande röstade för beslutet:',
  },
  MeetingThoseAgainstDecision: {
    en: 'The following voted against the decision:',
    nb: 'Følgende stemte imot forslaget:',
    sv: 'Följande röstade emot beslutet:',
  },
  MeetingThoseNeutralDecision: {
    en: 'The following voted neutral:',
    nb: 'Følgende avga ikke stemme:',
    sv: 'Följande röstade neutralt:',
  },
  restrictedGuysText1: {
    en: 'The following did not participate in the proceedings:',
    nb: 'Følgende deltok ikke i behandlingen:',
  },
  restrictedGuysText2: {
    en: 'The following joined the proceedings:',
    nb: 'Følgende tiltrådte i behandlingen:',
  },
  fromNOK: {
    en: 'from NOK',
    nb: 'fra NOK',
    sv: 'från NOK',
  },
  Nok: {
    en: 'NOK',
    nb: 'kr',
  },
  toNOK: {
    en: 'to NOK',
    nb: 'til NOK',
    sv: 'till NOK',
  },
  AccountNumberForEmission: {
    en: 'ACCOUNT NUMBER FOR EMISSION',
    nb: 'KONTONUMMER FOR EMISJONEN',
    sv: 'KONTO NUMMER FÖR EMISSIONEN',
  },
  by: {
    en: 'by',
    nb: 'innen',
    sv: 'innan',
  },
  enterDateAndTime: {
    en: 'Enter date and time',
    nb: 'Skriv inn dato og tid',
    sv: 'Ange datum och tid',
  },
  ShareParValuePointEmission: {
    en: 'The nominal value of the shares is NOK ',
    nb: 'Aksjenes pålydende verdi er NOK ',
    sv: 'Aktiernas nominella värde är NOK ',
  },
  enterAmount: {
    en: 'enter amount',
    nb: 'legg inn beløp',
    sv: 'ange belopp',
  },
  emissionDecisionSuggestionText1: {
    en: 'The capital increase is carried out either on the basis of a general meeting resolution (cf. the Companies Act § 10-1) or a board resolution (cf. the Companies Act § 10-17, provided that the board has a valid authorization). ',
    nb: 'Gjennomføringen av kapitalforhøyelsen skjer enten på bakgrunn av et generalforsamlingsvedtak (jf. aksjeloven § 10-1) eller et styrevedtak (jf. aksjeloven § 10-17, forutsatt at styret har gyldig fullmakt).',
  },
  emissionDecisionSuggestionText2: {
    en: "The following are factors that may be included in the proposed resolution, but which must be adapted to the company's special situation:",
    nb: 'Følgende er momenter som kan inngå i forslaget til vedtak, men som må tilpasses selskapets spesifikke situasjon:',
  },
  emissionDecisionSuggestionText3: {
    en: 'The share capital will increase by NOK ',
    nb: 'Aksjekapitalen økes med NOK ',
    sv: 'Aktiekapitalet ökas med NOK ',
  },
  emissionDecisionSuggestionText4: {
    en: 'The new shares belong to the share class',
    nb: 'De nye aksjene tilhører aksjeklassen ',
    sv: 'De nya aktierna tillhör aktieklassen ',
  },
  emissionDecisionSuggestionText5: {
    en: 'The shares are subscribed for in the minutes by those who appear in the appendix to the minutes.',
    nb: 'Aksjene tegnes i protokollen av de som fremgår av vedlegg til protokollen.',
    sv: 'Aktierna tecknas i protokollet av de som framgår av bilagan till protokollet.',
  },
  emissionDecisionSuggestionText6: {
    en: "The subscription amount should be payed out to the account with account number The subscription amount must be paid into the company's bank account",
    nb: 'Tegningsbeløpet skal innbetales til selskapets bankkonto',
    sv: 'Teckningsbeloppet ska betalas in på bolagets bankkonto',
  },
  emissionDecisionSuggestionText7: {
    en: 'There are only minor administration costs in connection with the capital increase, estimated at around NOK',
    nb: 'Det påløper kun mindre administrasjonskostnader i forbindelse med kapitalforhøyelsen, estimert til rundt NOK ',
    sv: 'Det uppstår endast mindre administrationskostnader i samband med kapitalökningen, uppskattat till cirka NOK ',
  },
  emissionDecisionSuggestionText8: {
    en: 'which are covered by the company',
    nb: 'som dekkes av selskapet',
    sv: 'som täcks av bolaget',
  },
  emissionDecisionSuggestionText9: {
    en: "The shareholders' pre-emptive right to subscribe for the new shares is waived.",
    nb: 'Aksjeeiernes fortrinnsrett til å tegne de nye aksjene frafalles.',
    sv: 'Aktieägarnas företrädesrätt att teckna de nya aktierna upphävs.',
  },
  emissionDecisionSuggestionText10: {
    en: "The new shares are equated with the company's already issued shares. The shares entitle to dividend from and including the current financial year.",
    nb: 'De nye aksjene likestilles med selskapets allerede utstedte aksjer. Aksjene gir rett til utbytte fra og med inneværende regnskapsår.',
    sv: 'De nya aktierna jämställs med bolagets redan utgivna aktier. Aktierna berättigar till utdelning från och med innevarande räkenskapsår.',
  },
  emissionDecisionSuggestionText11: {
    en: 'The share contribution can be disposed of by the company before the capital increase is registered in The Register of Business Enterprises, cf. the Companies Act § 10-13 second paragraph.',
    nb: 'Aksjeinnskuddet kan disponeres av selskapet før kapitalforhøyelsen er registrert i Foretaksregisteret, jf. aksjeloven § 10-13 annet ledd.',
    sv: 'Aktieinsatsen kan disponeras av bolaget innan kapitalökningen är registrerad i Bolagsverket, jfr. aktiebolagslagen § 10-13 andra stycket.',
  },
  MeetingAllUnanimousStatement: {
    en: 'All decisions were passed unanimously.',
    nb: 'Det var enstemmighet i alle avstemningene.',
    sv: 'Alla beslut fattades enhälligt.',
  },
  TheFollowingMustSignRead: {
    en: 'The following must sign that the minutes have been read:',
    nb: 'Følgende skal signere at protokollen er lest:',
    sv: 'Följande måste underteckna att protokollet har lästs:',
  },
  theFollowingWasApproved: {
    en: 'The following was approved',
    nb: 'Følgende ble vedtatt',
    sv: 'Följande godkändes',
  },
  ChatMessageSeen: {
    en: 'Seen',
    nb: 'Sett',
    sv: 'Sett',
  },
  theFollowingWasRejected: {
    en: 'The following was rejected',
    nb: 'Følgende ble nedstemt',
    sv: 'Följande avvisades',
  },
  overviewOfVoting: {
    en: 'Overview of voting',
    nb: 'Oversikt over stemmegiving',
    sv: 'Översikt över omröstning',
  },
  Item: {
    en: 'Item',
    nb: 'Sak',
    sv: 'Fall',
  },

  'In person': {
    en: 'In person',
    nb: 'Personlig',
    sv: 'I person',
  },
  Proxy: {
    en: 'Proxy',
    nb: 'Fullmektig',
    sv: 'Ombud',
  },
  'Represented by': {
    en: 'Represented by',
    nb: 'Representert ved',
    sv: 'Representerad av',
  },
  'Follow-up case': {
    en: 'Follow-up case',
    nb: 'Oppfølgingssak',
    sv: 'Uppföljningsfall',
  },
  BenficialOwnersInfoHeader1: {
    nb: 'Kort om reelle rettighetshavere',
    en: 'Overview of beneficial owners',
  },
  BenficialOwnersInfoText11: {
    nb: 'Lov om reelle rettighetshavere ',
    en: 'The act on beneficial owners ',
  },
  BenficialOwnersInfoText12: {
    nb: 'og den tilhørende ',
    en: 'and the associated ',
  },
  BenficialOwnersInfoText13: {
    nb: 'forskriften ',
    en: 'regulation ',
  },
  BenficialOwnersInfoText14: {
    nb: 'pålegger virksomheter å dokumentere hvem som er reelle rettighetshavere, og rapportere dette inn til myndighetenes register. Hensikten med registeret er å vite hvem som direkte eller indirekte eier og kontrollerer virksomheter, blant annet som et tiltak for å bekjempe hvitvasking, terrorfinansiering og økonomisk kriminalitet. Du kan lese mer om reelle rettighetshavere på ',
    en: 'requires businesses to document who the beneficial owners are and report this to the government’s registry. The purpose of the registry is to know who directly or indirectly owns and controls businesses, as part of efforts to combat money laundering, terrorist financing, and economic crime. You can read more about beneficial owners at ',
  },
  BenficialOwnersInfoHeader2: {
    nb: 'Reelle rettighetshavere i Orgbrain',
    en: 'Beneficial owners in Orgbrain',
  },
  BenficialOwnersInfoText21: {
    nb: 'Det er laget en',
    en: 'A ',
  },
  SolutionKeyword: {
    nb: 'løsning',
    en: 'solution',
  },
  BenficialOwnersInfoText23: {
    nb: 'hos Brønnøysundregistrene som kan brukes til innrapporteringen, men det er ikke alene tilstrekkelig å oppfylle alle lov- og forskriftskrav på dette feltet.',
    en: 'has been developed by the Brønnøysund Register Centre which can be used for reporting, but it is not sufficient on its own to meet all legal and regulatory requirements in this area.',
  },
  BenficialOwnersInfoText3: {
    nb: 'Kunder av Orgbrain kan benytte den innebygde løsningen for reelle rettighetshavere som har en rekke fordeler som forenkler både rapportering og etterlevelse av lovkrav:',
    en: 'Orgbrain customers can use the built-in solution for beneficial owners, which offers a number of advantages that simplify both reporting and compliance with legal requirements:',
  },

  BenficialOwnersInfoPointTitle1: {
    nb: 'Automatisk identifisering: ',
    en: 'Automatic Identification: ',
  },
  BenficialOwnersInfoPoint1: {
    nb: 'Orgbrain bruker aksjeeierboken og data fra Skatteetaten for å identifisere reelle rettighetshavere og generere en oppdatert statusrapport.',
    en: 'Orgbrain uses the shareholder registry and data from the Norwegian Tax Administration to identify beneficial owners and generate an updated status report.',
  },
  BenficialOwnersInfoPointTitle2: {
    nb: 'Oppbevaring av tilleggsinformasjon: ',
    en: 'Storage of Additional Information: ',
  },
  BenficialOwnersInfoPoint2: {
    nb: 'Virksomheten har et juridisk ansvar for å oppbevare tilleggsinformasjon om reelle rettighetshavere. Orgbrain forenkler denne prosessen.',
    en: 'The business has a legal obligation to store additional information about beneficial owners. Orgbrain simplifies this process.',
  },
  BenficialOwnersInfoPointTitle3: {
    nb: 'Rapportering til Brønnøysundregistrene: ',
    en: 'Reporting to the Brønnøysund Register Centre: ',
  },
  BenficialOwnersInfoPoint3: {
    nb: 'Med Orgbrain kan du rapportere reelle rettighetshavere til Brønnøysundregistrene med få klikk, slik at all nødvendig informasjon er samlet på ett sted.',
    en: 'With Orgbrain, you can report beneficial owners to the Brønnøysund Register Centre with just a few clicks, ensuring all necessary information is gathered in one place.',
  },
  BenficialOwnersInfoPointTitle4: {
    nb: 'Informering av rettighetshavere: ',
    en: 'Notification of Beneficial Owners: ',
  },
  BenficialOwnersInfoPoint4: {
    nb: 'Det er et lovkrav å informere personer om at de er reelle rettighetshavere. Med Orgbrain kan du raskt og enkelt sende denne informasjonen via e-post.',
    en: 'It is a legal requirement to inform individuals that they are beneficial owners. With Orgbrain, you can quickly and easily send this information via email.',
  },
  BenficialOwnersInfoPointTitle5: {
    nb: 'Gjenbruk av data: ',
    en: 'Data Reuse: ',
  },
  BenficialOwnersInfoPoint5: {
    nb: 'Ved å kopiere tidligere versjoner kan du enkelt gjenbruke data og fylle ut årets skjema uten å måtte starte fra bunnen av.',
    en: "By copying previous versions, you can easily reuse data and complete this year's form without starting from scratch.",
  },
  BenficialOwnersInfoTextBold4: {
    nb: 'Tillatelser',
    en: 'Permissions',
  },
  BenficialOwnersInfoText4: {
    nb: 'For å kunne sende inn reelle rettighetshavere til Brønnøysundregistrene, må du være lagt til i virksomheten via Altinn med en av de følgende rollene:',
    en: 'To submit beneficial owners to the Brønnøysund Register Centre, you must be added to the business via Altinn with one of the following roles:',
  },

  BenficialOwnersInfoRoleList1: {
    nb: 'Daglig leder',
    en: 'Managing director',
  },
  BenficialOwnersInfoRoleList2: {
    nb: 'Deltaker med delt ansvar',
    en: 'Partner with shared liability',
  },
  BenficialOwnersInfoRoleList3: {
    nb: 'Deltaker med fullt ansvar',
    en: 'Partner with unlimited liability',
  },
  BenficialOwnersInfoRoleList4: {
    nb: 'Forretningsfører',
    en: 'Business manager',
  },
  BenficialOwnersInfoRoleList5: {
    nb: 'Kontaktperson',
    en: 'Contact person',
  },
  BenficialOwnersInfoRoleList6: {
    nb: 'Kontaktperson for NUF',
    en: 'Contact person for NUF',
  },
  BenficialOwnersInfoRoleList7: {
    nb: 'Nestleder',
    en: 'Deputy chair',
  },
  BenficialOwnersInfoRoleList8: {
    nb: 'Norsk representant for utenlandsk enhet',
    en: 'Norwegian representative for foreign entity',
  },
  BenficialOwnersInfoRoleList9: {
    nb: 'Styremedlem',
    en: 'Board member',
  },
  BenficialOwnersInfoRoleList10: {
    nb: 'Styrets leder',
    en: 'Chair of the board',
  },
  BenficialOwnersInfoRoleList11: {
    nb: 'Ansvarlig revisor',
    en: 'Responsible auditor',
  },
  BenficialOwnersInfoRoleList12: {
    nb: 'Revisormedarbeider',
    en: 'Audit assistant',
  },
  BenficialOwnersInfoRoleList13: {
    nb: 'Regnskapsfører med signeringsrett',
    en: 'Accountant with signing authority',
  },
  BenficialOwnersInfoRoleList14: {
    nb: 'Regnskapsfører uten signeringsrett',
    en: 'Accountant without signing authority',
  },
  BenficialOwnersInfoRoleList15: {
    nb: 'Regnskapsmedarbeider',
    en: 'Accounting assistant',
  },

  CurrentVersion: {
    nb: 'Registrert informasjon',
    en: 'Registered information',
  },
  BeneficialDraft: {
    nb: 'Utkast',
    en: 'Draft',
  },
  BeneficialDone: {
    nb: 'Ferdig',
    en: 'Completed',
  },
  NotifyOwner: {
    nb: 'Varsle rettighetshavere',
    en: 'Notify beneficial owners',
  },
  NewVersion: {
    nb: 'Ny versjon',
    en: 'New version',
  },
  CopyPrevVersion: {
    nb: 'Kopier forrige versjon',
    en: 'Copy previous version',
  },
  Previous: {
    nb: 'Forrige',
    en: 'Previous',
  },
  AddNewBeneficialOwner: {
    nb: 'Reell rettighetshaver',
    en: 'Beneficial owner',
  },
  AddNewBeneficialOwnerTooltip: {
    nb: 'Legg til ny en reell rettighetshaver',
    en: 'Add new beneficial owner',
  },
  AddNewPersonTooltip: {
    nb: 'Legg til ny en ledende person',
    en: 'Add new leading person',
  },
  ExtraInformation: {
    nb: 'Ekstra informasjon (blir ikke sendt inn til Altinn)',
    en: 'Extra information (is not sent to Altinn)',
  },

  CopyPrevVersionTooltip: {
    nb: 'Kopier den nåværende registrerte informasjonen',
    en: 'Copy the currently registered information',
  },
  SavedVersion: {
    nb: 'Versjonen er lagret',
    en: 'Saved this version',
  },
  OrgbrainSuggestionHeader: {
    nb: 'Reelle rettighetshavere er identifisert',
    en: 'Beneficial owners have been identified',
  },
  OrgbrainSuggestionText: {
    nb: 'Orgbrain har identifisert potensielle reelle rettighetshavere. Ønsker du at disse automatisk legges til på siden, trykk "Fortsett".',
    en: 'Orgbrain has identified potential beneficial owners. If you wish to automatically add them to the page, click "Continue".',
  },
  CreateNewOwner: {
    nb: 'Opprett ny',
    en: 'Create new',
  },
  SaveDraft: {
    nb: 'Lagre utkast',
    en: 'Save draft',
  },
  OrgbrainSuggestionSubText: {
    nb: 'Forslagene systemet gir er basert på informasjon hentet fra aksjeeierregisteret og Skatteetaten. Det gis ingen garanti for at informasjonen som benyttes, eller forslagene som gis, er presise eller fullstendige. Forslagene er kun ment som en hjelp i prosessen med å identifisere reelle rettighetshavere. Hver enkelt bruker må selv gjøre en uavhengig vurdering av hvilke kilder og prosedyrer som best kan gi et korrekt bilde av situasjonen i sin virksomhet.',
    en: 'The suggestions provided by the system are based on information obtained from the shareholder registry and the Norwegian Tax Administration. There is no guarantee that the information used, or the suggestions provided, are accurate or complete. The suggestions are only intended as an aid in the process of identifying beneficial owners. Each user must independently assess which sources and procedures are best suited to provide an accurate representation of the actual situation in their business.',
  },
  OrgbrainSuggestion: {
    nb: 'Dette valget er anbefalt av Orgbrain basert på informasjonen som er tilgjengelig',
    en: 'This option is recommended by Orgbrain based on the information available',
  },
  OrgbrainSuggestions: {
    nb: 'Forslag fra Orgbrain',
    en: 'Suggestions from Orgbrain',
  },
  CreateBeneficialOwners: {
    nb: 'Opprett reelle rettighetshavere',
    en: 'Create beneficial owners',
  },
  BeneficialOwnerStatus: {
    nb: 'Har virksomheten reelle rettighetshavere?',
    en: 'Does the business have beneficial owners?',
  },

  NoHistoryBeneficialOwners: {
    nb: 'Det er ikke lagt inn noen opplysninger.',
    en: 'No information has been provided.',
  },
  AddNewPerson: {
    nb: 'Legg til person',
    en: 'Add new person',
  },
  BeneficialFnr: {
    nb: 'Personnummer/D-nr',
    en: 'National ID number/D-number',
  },
  BeneficialFnrFormat: {
    nb: 'Format: ddmmyyxxxxx',
    en: 'Format: ddmmyyxxxxx',
  },
  DateOfBirthFormat: {
    nb: 'Format: yyyy-mm-dd',
    en: 'Format: yyyy-mm-dd',
  },
  BeneficialOwns: {
    nb: 'Aksjeandel',
    en: 'Share ownership',
  },
  ReasonForPostion: { nb: 'Grunnlagstype', en: 'Basis type' },
  direct_ownershipBeneficialOwners: { nb: 'Direkte eierskap', en: 'Direct ownership' },
  indirect_ownershipBeneficialOwners: { nb: 'Indirekte eierskap', en: 'Indirect ownership' },
  owner_by_contractBeneficialOwners: {
    nb: 'Gjennom enighet eller avtale',
    en: 'Through agreement or contract',
  },
  SendInvite: {
    nb: 'Send epostinvitasjon til representanter',
    en: 'Send email invitation to representatives',
  },
  SendInvitesToReps: {
    nb: 'Inviter brukere',
    en: 'Invite users',
  },
  SendInvitesToRepsText: {
    nb: 'Ønsker du å sende epostinvitasjoner til valgte brukere',
    en: 'Do you want to send email invitations to selected users',
  },
  NotSent: { nb: ' - Ikke innlevert', en: ' - Not sent' },
  NotifiedOwners: { nb: 'Rettighetshavere ble varslet', en: 'Owners notified' },
  NoBeneficialOwners: {
    nb: 'Ingen reelle rettighetshavere',
    en: 'No beneficial owners',
  },
  NoBeneficialOwnersIdentified: {
    nb: 'Ingen reelle rettighetshavere identifisert',
    en: 'No beneficial owners identified',
  },
  BeneficialOwnersEmailSuccess: {
    nb: 'Reelle rettighetshavere varslet',
    en: 'Beneficial owners notified',
  },
  BeneficialOwnersEmailSuccessText: {
    nb: 'De utvalgte reelle rettighetshaverne er nå varslet.',
    en: 'The selected beneficial owners have now been notified.',
  },
  OwnersMap: {
    nb: 'Eierkart',
    en: 'Ownership map',
  },
  OwnersMapInfoBox: {
    nb: 'Eierkartet er basert på data fra aksjeeierboken, kombinert med tilgjengelig informasjon fra Skatteetaten om eierskap.',
    en: 'The ownership map is based on data from the shareholder registry, combined with available information from the Norwegian Tax Administration about ownership.',
  },
  OwnersMapPercentFilter: {
    nb: 'Eierandel filter',
    en: 'Ownership filter',
  },
  OwnersMapPercentFilterTooltip: {
    nb: 'Filtrer på eiere basert på prosentandel, inkluderer også mellomliggende selskaper',
    en: 'Filter owners based on percentage, also includes intermediate companies',
  },
  SuccessSend: {
    nb: 'Innsendelsen var vellykket',
    en: 'The submission was successful',
  },
  SuccessSendText: {
    nb: 'Gratulerer! Meldingen om reelle rettighetshavere er nå innlevert. Du kan finne kvitteringen i Altinn.',
    en: 'Congratulations! The notification of beneficial owners has now been submitted. You can find the receipt in Altinn.',
  },
  SuccessSendTextForIdentifiedState: {
    nb: 'NB: Husk å varsle de som er identifisert som reelle rettighetshavere.',
    en: 'NOTE: Remember to notify those who are identified as beneficial owners.',
  },
  OwnersMapByOrgbrain: {
    nb: 'Eierkart i Orgbrain',
    en: 'Owners map in Orgbrain',
  },
  NoAccessToOwnersMap: {
    nb: 'Du har ikke tilgang til å se eierkartet',
    en: 'You do not have access to view the ownership map',
  },
  NoAccessToOwnersMapText: {
    nb: 'Be en administrator om å gi deg tilgang ved å skru på "Innsyn i aksjeeierbok" på organisasjonssiden.',
    en: 'Ask an administrator to grant you access by enabling "View shareholder register" on the organization page.',
  },

  ErrorInValidation: {
    nb: 'Feil i validering av reelle rettighetshavere. Kontakt Support',
    en: 'Error in validation of beneficial owners. Contact Support',
  },
  ErrorInValidationObjectReference: {
    nb: 'Altinn oppdaget feil i denne versjonen',
    en: 'Altinn marked an error in this version',
  },
  ErrorInValidationObjectReferenceText: {
    nb: 'Er personnummer på reelle rettighetshavere korrekt fylt ut?',
    en: 'Is the national ID number correctly filled out?',
  },
  NoPartOwnsMoreThan25: {
    nb: 'Ingen fysiskperson eier mer enn 25 % av virksomheten',
    en: 'No individual owns more than 25 % of the business',
  },

  BeneficialOwnerStatusInfo: {
    nb: 'Reell rettighetshaver er en person som eier eller kontrollerer en registreringspliktig virksomhet i siste instans hvis personen har en eller flere av disse posisjonene:',
    en: 'A beneficial owner is a person who owns or controls a registered business ultimately if the person holds one or more of these positions:',
  },
  UserStatus: {
    nb: 'Brukerstatus',
    en: 'User status',
  },

  BeneficialOwnerStatusInfoPoint1: {
    nb: 'Eierskap på mer enn 25 %',
    en: 'Ownership of more than 25 %',
  },
  BeneficialOwnerStatusInfoPoint2: {
    nb: 'Kontroll over mer enn 25 % av stemmerettighetene',
    en: 'Control over more than 25 % of the voting rights',
  },
  BeneficialOwnerStatusInfoPoint3: {
    nb: 'Rett til å utpeke eller avsette over 50 % av styremedlemmene i virksomheten',
    en: 'The right to appoint or dismiss more than 50 % of the board members in the business',
  },
  BeneficialOwnerStatusInfoPoint4: {
    nb: 'Kontroll på annen måte',
    en: 'Control in another way',
  },

  IsPublicCompanyHelpText1: {
    nb: 'Noen virksomheter skal rapportere om en offentlig virksomhet, direkte eller indirekte, kontrollerer minimum 75 % gjennom eierskap eller stemmerettighet. Du finner informasjon om hvem dette gjelder i ',
    en: 'Some businesses must report if a public organization, directly or indirectly, controls a minimum of 75 % through ownership or voting rights. You can find information about who this applies to in ',
  },
  IsPublicCompanyHelpText2: {
    nb: ' under punktene f til l.  Dette gjelder også for utenlandske virksomheter.',
    en: ' under points f to l. This also applies to foreign businesses.',
  },
  IsPublicCompanyHelpTextLink: {
    nb: 'forskrift til lov om register over reelle rettighetshavere § 3-4,',
    en: 'regulation to the act on the register of beneficial owners § 3-4,',
  },

  IsOwnedByPublicOrg: {
    nb: 'Virksomheten er kontrollert av en offentlig myndighet',
    en: 'The business is controlled by a public authority',
  },
  IsOwnedByForeignPublicOrg: {
    nb: 'Virksomheten er kontrollert av en utenlandsk offentlig virksomhet',
    en: 'T he business is controlled by a foreign public organization',
  },

  ErrorsInVersion: { nb: 'Kan ikke fullføre', en: 'Cannot complete' },
  NotDoneBeneficialOwnersError: { nb: 'Ikke market som ferdig', en: 'Not marked as done' },
  NoOwnersBeneficialOwnersError: {
    nb: 'Ingen reelle rettighethavere eiere registrert',
    en: 'No beneficial owners registered',
  },
  FnrErrorBeneficialOwnersError: {
    nb: 'Det mangler komplett fødselsnummer for følgende reelle rettighetshavere: ',
    en: 'The following beneficial owners are missing a complete national ID number: ',
  },
  NoOptionSelectedBeneficialOwnersError: {
    nb: 'Det er ikke gitt forklaring på valgt status',
    en: 'No explanation has been provided for the selected status',
  },

  ForeignPersonErrorBeneficialOwnersError: {
    nb: 'Påkrevde feltene på disse utenlandske reell rettighetshaverene er ikke fylt ut: ',
    en: 'The required fields on these foreign beneficial owners are not filled out: ',
  },
  NoPositionsBeneficialOwnersError: {
    nb: 'Ingen posisjoner er satt på disse reell rettighetshaverene: ',
    en: 'No positions selected on these beneficial owners: ',
  },
  NoCriteriaBeneficialOwnersError: {
    nb: 'Ingen grunnlagstyper valgt på disse reell rettighetshaverene: ',
    en: 'No basis types selected on these beneficial owners: ',
  },
  'shareholders.CreateCopyOfThis': {
    nb: 'Lag kopi av denne',
    en: 'Create copy of this',
  },
  DeleteBeneficialVersionTitle: {
    nb: 'Slett versjon',
    en: 'Delete version',
  },
  DeleteBeneficialVersion: {
    nb: 'Er du sikker på at du vil slette denne versjonen?',
    en: 'Are you sure you want to delete this version?',
  },
  DeleteBeneficialOwnerTitle: {
    nb: 'Slett reell rettighetshaver',
    en: 'Delete beneficial owner',
  },
  DeleteBeneficialOwner: {
    nb: 'Er du sikker på at du vil slette denne reelle rettighetshaveren?',
    en: 'Are you sure you want to delete this beneficial owner?',
  },
  Finish: {
    nb: 'Ferdig',
    en: 'Complete',
    sv: 'Slutföra',
  },
  notificationNotSentBeneficialOwnersError: {
    nb: 'Varsel er ikke sendt til reelle rettighetshavere',
    en: 'Notification has not been sent to beneficial owners',
  },
  AltinnNotSentBeneficialOwnersError: {
    nb: 'Reelle rettighetshavere er ikke levert til Altinn',
    en: 'Beneficial owners have not been sent to Altinn',
  },
  BeneficialOwnership: { nb: 'Eierskap', en: 'Ownership' },
  BeneficialVotingRights: { nb: 'Stemmerettigheter', en: 'Voting rights' },
  OwnerIncompleteBeneficialOwnersError: {
    nb: 'Rettighetshaveren er ikke fullstendig utfylt',
    en: 'The beneficial owner is not fully completed',
  },
  SendInnToAltinn: {
    nb: 'Send til Altinn',
    en: 'Send to Altinn',
  },
  OtherInfo: {
    nb: 'Annen informasjon',
    en: 'Other information',
  },
  IsNationalPeopleRegister: {
    nb: 'Har personen enten fødselsnummer eller d-nummer?',
    en: 'Does the person have a norwegian national ID number or D-number?',
  },
  OwnershipPercent: {
    nb: 'Hvilken eierandel har personen',
    en: 'What percentage of ownership does the person have',
  },
  BeneficialOwnerPositionsHelpText: {
    nb: 'Dersom en person både har eierskap og/eller stemmerettigheter over 25 % eller rett til å utpeke eller avsette mer enn 50 % av styremedlemmene, skal du velge det førstnevnte. Hvis ingen av disse kriteriene er oppfylt, velger du annen posisjon.',
    en: 'If a person both has ownership and/or voting rights over 25 % or the right to appoint or dismiss more than 50 % of the board members, you should choose the former. If none of these criteria are met, choose other position.',
  },
  ElectBoardmembersHelpText: {
    nb: 'Bestemmelse i vedtekter eller avtaler som gir rett til å utpeke eller avsette over halvparten av styremedlemmene i virksomheten',
    en: 'Provision in articles of association or agreements that gives the right to appoint or dismiss more than half of the board members in the business',
  },
  ShareFileTitle: { nb: 'Administrer filtilgang', en: 'Share file control' },
  ShareFileInfo: {
    nb: 'Her kan du kontrollere hvem som skal ha tilgang til en delt fil eller mappe. Brukere som er lagt til her vil kunne finne filen i datarommet under mappen "Delt med meg".',
    en: 'Here you can control who should have access to a shared file or folder. Users added here will be able to find the file in the data room under the folder "Shared with',
  },
  RemoveSharedFileAccess: {
    nb: 'Fjern delt tilgang for denne brukeren.',
    en: 'Remove shared access for this user.',
  },
  SearchFieldHelpText: {
    nb: 'Søk på sider, samtaler, møter og mer',
    en: 'Search for pages, conversations, meetings, and more',
  },
  'new-orgModuleLabel': {
    nb: 'Ny organisasjon',
    en: 'New organization',
  },
  FindTimeTitle: {
    nb: 'Finn tid for ',
    en: 'Find time for ',
  },
  VotingPercent: {
    nb: 'Hvilken andel av stemmerettighetene har personen',
    en: 'What percentage of voting rights does the person have',
  },
  ReasonForNoBeneficialOwners: {
    nb: 'Er det en eller flere offentlige virksomheter som, direkte eller indirekte, kontrollerer 75 % eller mer av eierandelene eller stemmerettighetene?',
    en: 'Is there one or more public organizations that, directly or indirectly, control 75 % or more of the ownership or voting rights?',
  },
  ReasonIsPublicOrganization: {
    nb: 'Er den offentlige virksomheten utenlandsk?',
    en: 'Is the public organization foreign?',
  },
  FindTimeStartDate: {
    nb: 'Dato',
    en: 'Date',
  },
  FindTimeStartTime: {
    nb: 'Tidspunkt',
    en: 'Time',
  },
  FindTimeDuration: {
    nb: 'Varighet',
    en: 'Duration',
  },
  FindTimeSuggestion: {
    nb: 'Forslag',
    en: 'Suggestion',
  },
  NoEndDateSet: {
    nb: 'Ingen sluttdato',
    en: 'No end date',
  },
  isForeignPublicCompany: {
    nb: 'Den offentlige virksomheten er en utenlandsk virksomhet',
    en: 'The public organization is a foreign organization',
  },
  'NoPersonOwnMoreThan25%': {
    nb: 'Ingen person eier mer enn 25 %',
    en: 'No person owns more than 25 %',
  },
  sendToAltinnTooltip: {
    nb: 'Gå til ID-porten for å sende informasjon til Altinn',
    en: 'Go to ID-porten to send information to Altinn',
  },

  NotifyOwnerTooltip: {
    nb: 'Her kan du velge hvem som skal motta varsel på e-post',
    en: 'Here you can choose who will receive a notification by email',
  },
  VotingRightsCriteria: {
    nb: 'Oppgi grunnlaget for stemmerettighet',
    en: 'State the basis for voting rights',
  },
  IntermediateOrganizationsVoting: {
    nb: 'Oppgi de mellomliggende organisasjonene som gir stemmerettigheter',
    en: 'Specify the intermediate organizations that grant voting rights',
  },
  Organizations: {
    nb: 'Organisasjoner',
    en: 'Organizations',
  },
  Modules: {
    nb: 'Moduler',
    en: 'Modules',
  },
  ModulesYouCanUse: {
    nb: 'Moduler du kan abonnere på',
    en: 'Available subscription modules',
  },
  IntermediateOrganizations: {
    nb: 'Oppgi de mellomliggende organisasjonene',
    en: 'Specify the intermediate organizations',
  },
  IntermediateOrganization: {
    nb: 'Mellomliggende organisasjon',
    en: 'Intermediate organization',
  },
  AddNewIntermediateOrg: {
    nb: 'Legg til',
    en: 'Add',
    sv: 'Lägg till',
  },
  IsForeignOrganiaztion: {
    nb: 'Er organisasjonen norsk eller utenlandsk',
    en: 'Is the organization norwegian or foreign',
  },
  OrganizationNumber: {
    nb: 'Organisasjonsnummer',
    en: 'Organization number',
    sv: 'Organisationsnummer',
  },
  RegistrationNumber: {
    nb: 'Registreringsnummer i hjemlandet',
    en: 'Registration number in home country',
  },
  EnterName: {
    nb: 'Skriv inn navn',
    en: 'Enter name',
  },
  AddressOfOrganization: {
    nb: 'Organisasjonens adresse',
    en: 'Address of the organization',
  },
  Decisions: {
    nb: 'Beslutninger',
    en: 'Decisions',
  },
  OtherHighlights: {
    nb: 'Andre høydepunkter',
    en: 'Other highlights',
  },
  ForeignCountry: {
    nb: 'Hva er hjemlandet til organisasjonen',
    en: 'What is the home country of the organization',
  },
  address: {
    nb: 'Adresse',
    en: 'Address',
  },
  LessThan25Percent: {
    nb: 'Mindre enn 25 %',
    en: 'Less than 25 %',
  },
  BeneficialOwnerPositionReason: {
    nb: 'Beskriv kort på hvilken måte personen kontrollerer virksomheten',
    en: 'Briefly describe how the person controls the business',
  },
  OwnerShipOrVotingRights: {
    nb: 'Eierskap og/eller stemmerettigheter, over 25 %',
    en: 'Ownership or voting rights, over 25 %',
  },
  ElectBoardmembers: {
    nb: 'Rett til å utpeke eller avsette mer enn 50 % av styremedlemmene',
    en: 'The right to appoint or dismiss more than 50 % of the board members',
  },
  OtherPosition: {
    nb: 'Annen posisjon',
    en: 'Other position',
  },
  BeneficialVotes: {
    nb: 'Stemmeandel',
    en: 'Voting rights',
  },
  BeneficialSource: {
    nb: 'Kilde',
    en: 'Source',
  },
  BeneficialOwners: {
    nb: 'Reelle rettighetshavere',
    en: 'Beneficial owners',
  },
  SentToAltinn: {
    nb: 'Innsendt',
    en: 'Delivered',
  },
  ChangedBeneficialOwnersVersion: {
    nb: 'Sist endret',
    en: 'Last updated',
  },
  BeneficialVersionNote: {
    nb: 'Legg til eller rediger notat',
    en: 'Add or edit note',
  },
  CreateBeneficialOwner: {
    nb: 'Opprett reell rettighetshaver',
    en: 'Create beneficial owner',
  },
  EditBeneficialOwner: {
    nb: 'Rediger reell rettighetshaver',
    en: 'Edit beneficial owner',
  },
  SendNotifToBeneficalOwnerTitle: {
    nb: 'Varsle reelle rettighetshavere',
    en: 'Notify beneficial owners',
  },
  SendNotifToBeneficalOwnerText: {
    nb: 'Ønsker du å sende varsel til de som er identifisert som reelle rettighetshavere?',
    en: 'Do you want to send a notification to those identified as beneficial owners?',
  },
  CancelEditing: {
    nb: 'Ønsker du å avbryte redigeringen? Informasjon som ikke er lagret vil gå tapt.',
    en: 'Do you want to cancel editing? Unsaved information will be lost.',
  },
  ChooseRecipients: {
    nb: 'Velg mottakere',
    en: 'Choose recipients',
  },
  Description: {
    en: 'Description',
    nb: 'Beskrivelse',
    sv: 'Beskrivning',
  },
  'Responsible for follow-up': {
    en: 'Responsible for follow-up',
    nb: 'Ansvarlig for oppfølging',
    sv: 'Ansvarig för uppföljning',
  },
  'Follow-up date': {
    en: 'Follow-up date',
    nb: 'Oppfølgingsdato',
    sv: 'Uppföljningsdatum',
  },
  'By drawing lots': {
    en: 'By drawing lots',
    nb: 'Ved loddtrekning',
    sv: 'Genom att dra lod',
  },
  Repeat: {
    en: 'Repeat',
    nb: 'Gjenta',
  },
  PriceShareholdersEvents: {
    en: 'Amount per share',
    nb: 'Beløp per aksje',
  },

  'Repeat annually': {
    en: 'Repeat annually',
    nb: 'Gjenta årlig',
  },
  'Repeats annually': {
    en: 'Repeats annually',
    nb: 'Gjentas årlig',
  },
  Elected: {
    en: 'Elected',
    nb: 'Valgt',
    sv: 'Vald',
  },
  'Elected candidates': {
    en: 'Elected candidates',
    nb: 'Valgte kandidater',
    sv: 'Valda kandidater',
  },
  'Elected candidate': {
    en: 'Elected candidate',
    nb: 'Valgt kandidat',
    sv: 'Vald kandidat',
  },
  orderOfCandidatesWSithSameNumberOfVotesDecidedRandomly: {
    en: 'The order of candidates with the same number of votes was decided by drawing lots.',
    nb: 'Rekkefølgen på kandidatene med likt antall stemmer er avgjort av systemet ved en tilfeldig loddtrekning.',
    sv: 'Ordningen på kandidater med samma antal röster bestämdes genom att dra lod.',
  },
  'On election': {
    en: 'On election',
    nb: 'På valg',
    sv: 'Vid valet',
  },
  position_electionResults: {
    en: 'Place',
    nb: 'Plass',
    sv: 'Placera',
  },

  'of votes represented': {
    en: 'of votes represented',
    nb: 'av stemmer representert',
    sv: 'av de representerade rösterna',
  },
  Candidate: {
    en: 'Candidate',
    nb: 'Kandidat',
    sv: 'Kandidat',
  },
  'Settings.VoteBlankSettings': {
    en: 'Vote blank',
    nb: 'Stemme blankt',
  },
  'Settings.VoteBlankSettingsDescription': {
    en: 'Give users the opportunity to vote blank at the general meeting.',
    nb: 'Gjør det også mulig å velge blank stemme under generalforsamlingen.',
  },
  'Votes cast': {
    en: 'Votes cast',
    nb: 'Stemmer avgitt',
    sv: 'Avgivna röster',
  },
  'Votes for': {
    en: 'Votes for',
    nb: 'Stemmer for',
    sv: 'Röstar på',
  },
  'Votes against': {
    en: 'Votes against',
    nb: 'Stemmer imot',
    sv: 'Röstar emot',
  },
  'Votes blank': {
    en: 'Votes blank',
    nb: 'Stemmer blank',
  },
  Blank: {
    en: 'Blank',
    nb: 'Blank',
  },
  VotedBlankFor: {
    en: 'You voted blank on behalf of ',
    nb: 'Du stemte blankt på vegne av ',
  },
  voteForChosen: {
    en: 'Vote for chosen',
    nb: 'Stem på valgte',
  },
  BlankVoteBlank: {
    en: 'Vote blank',
    nb: 'Stem blankt',
  },
  'meetings.against': {
    en: 'against',
    nb: 'imot',
  },
  'meetings.for': {
    en: 'for',
    nb: 'for',
  },
  'meetings.cancelled': {
    en: 'is cancelled',
    nb: 'er avlyst',
  },
  'meetings.changed': {
    en: 'is changed',
    nb: 'er endret',
  },
  'meetings.informPrefix': {
    en: 'Meeting Changed',
    nb: 'Endring i møtet',
  },
  'of votes cast': {
    en: 'of votes cast',
    nb: 'av stemmer avgitt',
    sv: 'av avgivna röster',
  },
  'of cast': {
    en: 'of cast',
    nb: 'av avgitt',
    sv: 'av avgivna',
  },
  'Total represented': {
    en: 'Total represented',
    nb: 'Totalt representert',
    sv: 'Totalt representerat',
  },
  Abstained: {
    en: 'Abstained',
    nb: 'Avstått',
    sv: 'Avstod',
  },
  Result: {
    en: 'Result',
    nb: 'Resultat',
    sv: 'Resultat',
  },
  Approved: {
    en: 'Approved',
    nb: 'Vedtatt',
    sv: 'Godkänd',
  },
  Rejected: {
    en: 'Rejected',
    nb: 'Nedstemt',
    sv: 'avvisade',
  },
  voteRuleExplanationStatutoryChange: {
    en: 'in accordance with majority requirement rules',
    nb: 'i overenstemmelse med flertallskrav',
    sv: 'i enlighet med regler för majoritetskrav',
  },
  voteRuleExplanationQualifiedMajority: {
    en: 'in accordance with qualified majority requirement',
    nb: 'i overenstemmelse med krav til kvalifisert flertall',
    sv: 'i enlighet med kvalificerad majoritet',
  },
  voteRuleExplanationUnanimity: {
    en: 'in accordance with unanimity requirement',
    nb: 'i overenstemmelse med krav til enstemmighet',
    sv: 'i enlighet med enhällighetskrav',
  },
  voteRuleExplanationInvestigation: {
    en: 'in accordance with vote approval requirement for proposition for investigation cases',
    nb: 'i overenstemmelse med stemmekrav for forslag om gransking',
    sv: 'i enlighet med kravet på röstgodkännande för förslag till utredningsärenden',
  },
  'Represented directly': {
    en: 'Represented directly',
    nb: 'Representert direkte',
    sv: 'Representeras direkt',
  },
  'Represented by pre-voting': {
    en: 'Represented by pre-voting',
    nb: 'Representert ved forhåndsstemme',
    sv: 'Representeras av förhandsröstning',
  },
  'Represented by joining': {
    en: 'Represented by joining',
    nb: 'Representert ved oppmøte',
    sv: 'Representeras genom att gå med',
  },
  'Voting shares': {
    en: 'Voting shares',
    nb: 'Aksjer med stemmerett',
    sv: 'Röstningsandelar',
  },
  'of voting-eligible shares': {
    en: 'of voting-eligible shares',
    nb: 'av stemme&shy;berettigede aksjer',
    sv: 'av röstberättigade aktier',
  },
  'own shares': {
    en: 'own shares',
    nb: 'egne aksjer',
    sv: 'egna aktier',
  },
  'Represented by proxy': {
    en: 'Represented by proxy',
    nb: 'Representert ved fullmakt',
    sv: 'Representeras av ombud',
  },
  'Reminder of meeting for': {
    en: 'Reminder of meeting for',
    nb: 'Påminnelse om møte for',
    sv: 'Påminnelse om möte för',
  },
  'New subgroup': {
    en: 'New subgroup',
    nb: 'Ny undergruppe',
    sv: 'Ny undergrupp',
  },
  RemainingSharesAfterTransaction: {
    en: 'Remaining shares after transaction ',
    nb: 'Gjenstående aksjer etter transaksjon ',
  },

  MinutesFrom: {
    en: 'Minutes from',
    nb: 'Protokoll fra',
    sv: 'Protokoll från',
  },
  Recipients: {
    en: 'Recipients',
    nb: 'Mottakere',
    sv: 'Mottagare',
  },
  'AllRequirementsFullfilled?companyType=FLI': {
    en: 'All the formal requirements for notice and number of attendance are fulfilled.',
    nb: 'Alle de formelle krav til innkalling og antall deltakere er oppfylt.',
    sv: 'Alla formella krav för uppsägning och antal närvaro är uppfyllda.',
  },
  'AllRequirementsFullfilled?jurisdiction=NO': {
    en: 'The proceeding fulfills the requirements presented in Norwegian Companies Act § 6-24.',
    nb: 'Saksbehandlingen oppfyller kravene i aksjeloven § 6-24.',
    sv: 'Förfarandet uppfyller kraven i aktiebolagslagen § 6-24.',
  },
  'AllRequirementsFullfilled?companyType=ASA': {
    en: 'The proceeding fulfills the requirements presented in the Public Limited Liability Companies Act § 6-24.',
    nb: 'Saksbehandlingen oppfyller kravene i allmennaksjeloven § 6-24.',
    sv: 'Förfarandet uppfyller kraven i aktiebolagslagen § 6-24.',
  },
  'AllRequirementsFullfilled?jurisdiction=EN': {
    en: 'The proceeding fulfills the requirements presented in the Companies Act.',
    nb: 'Saksbehandlingen oppfyller kravene i aksjeloven.',
    sv: 'Förfarandet uppfyller kraven i aktiebolagslagen.',
  },
  'AllRequirementsFullfilled?jurisdiction=SE': {
    en: 'The proceeding fulfills the requirements presented in the Companies Act ch.8 § 21.',
    nb: 'Saksbehandlingen oppfyller kravene i aktiebolagslagen 8 kap. 21 §.',
    sv: 'Förfarandet uppfyller kraven i aktiebolagslagen kap. 8 § 21.',
  },
  'AllRequirementsFullfilled?jurisdiction=DK': {
    en: 'The proceeding fulfills the requirements presented in the Companies Act § 124.',
    nb: 'Saksbehandlingen oppfyller kravene i selskabsloven § 124.',
    sv: 'Förfarandet uppfyller kraven i aktiebolagslagen § 124.',
  },
  'AllRequirementsNotFullfilled?companyType=FLI': {
    en: 'The formal requirements for notice and/or number of attendance are not fulfilled.',
    nb: 'De formelle krav til innkalling og/eller antall deltakere er ikke oppfylt.',
    sv: 'De formella kraven för anmälan och / eller antal närvaro uppfylls inte.',
  },
  'AllRequirementsNotFullfilled?jurisdiction=NO': {
    en: 'The proceeding does not meet the requirements presented in Norwegian Companies Act § 6-24.',
    nb: 'Saksbehandlingen oppfyller ikke kravene i aksjeloven § 6-24.',
    sv: 'Förfarandet uppfyller inte kraven i norska aktiebolagslagen § 6-24.',
  },
  'AllRequirementsNotFullfilled?companyType=ASA': {
    en: 'The proceeding does not meet the requirements presented in the Public Limited Liability Companies Act § 6-24.',
    nb: 'Saksbehandlingen oppfyller ikke kravene i allmennaksjeloven § 6-24.',
    sv: 'Förfarandet uppfyller inte kraven i aktiebolagslagen § 6-24.',
  },
  'AllRequirementsNotFullfilled?jurisdiction=EN': {
    en: 'The proceeding does not meet the requirements presented in the Companies Act.',
    nb: 'Saksbehandlingen oppfyller ikke kravene i aksjeloven.',
    sv: 'Förfarandet uppfyller inte kraven i aktiebolagslagen.',
  },
  'AllRequirementsNotFullfilled?jurisdiction=SE': {
    en: 'The proceeding does not meet the requirements presented in the Companies Act ch.8 § 21.',
    nb: 'Saksbehandlingen oppfyller ikke kravene i aktiebolagslagen 8 kap. 21 §.',
    sv: 'Förfarandet uppfyller inte kraven i aktiebolagslagen kap. 8 § 21.',
  },
  'AllRequirementsNotFullfilled?jurisdiction=DK': {
    en: 'The proceeding does not meet the requirements presented in the Companies Act § 124.',
    nb: 'Saksbehandlingen oppfyller ikke kravene i selskabsloven § 124.',
    sv: 'Förfarandet uppfyller inte kraven i aktiebolagslagen § 124.',
  },
  'There is quorum, decisions can be taken': {
    en: 'There is quorum, decisions can be taken',
    nb: 'Styret er beslutningsdyktig',
    sv: 'Det finns beslutsförmåga, beslut kan fattas',
  },
  'There is not a quorum, decisions cannot be taken': {
    en: 'There is not a quorum, decisions cannot be taken',
    nb: 'Styret er ikke beslutningsdyktig',
    sv: 'Det finns inte beslutsfattande, beslut kan inte fattas',
  },
  'ThereWasQuorumMinutesPdf?jurisdiction=NO': {
    en: 'There was a quorum, and the requirements listed in Norwegian Companies Act § 6-24 for making decisions were met.',
    nb: 'Styret var beslutningsdyktig i henhold til aksjeloven § 6-24.',
    sv: 'Det var beslutsfattande och kraven i norska aktiebolagslagen § 6-24 för att fatta beslut uppfylldes.',
  },
  'ThereWasQuorumMinutesPdf?companyType=ASA': {
    en: 'There was a quorum, and the requirements listed in the Public Limited Liability Companies Act § 6-24 for making decisions were met.',
    nb: 'Styret var beslutningsdyktig i henhold til allmennaksjeloven § 6-24.',
    sv: 'Det var beslutsfattande och kraven i aktiebolagslagen § 6-24 för att fatta beslut uppfylldes.',
  },
  'ThereWasQuorumMinutesPdf?jurisdiction=EN': {
    en: 'There was a quorum, and the requirements listed in the Companies Act for making decisions were met.',
    nb: 'Styret var beslutningsdyktig i henhold til aksjeloven.',
    sv: 'Det var beslutsfattande och kraven i företagslagen för att fatta beslut uppfylldes.',
  },
  'ThereWasQuorumMinutesPdf?jurisdiction=SE': {
    en: 'There was a quorum, and the requirements listed in the Companies Act ch.8 § 21 for making decisions were met.',
    nb: 'Styret var beslutningsdyktig i henhold til aktiebolagslagen 8 kap. 21 §.',
    sv: 'Det var beslutsfattande och kraven i aktiebolagslagen kap. 8 § 21 för att fatta beslut uppfylldes.',
  },
  'ThereWasQuorumMinutesPdf?jurisdiction=DK': {
    en: 'There was a quorum, and the requirements listed in the Companies Act § 124 for making decisions were met.',
    nb: 'Styret var beslutningsdyktig i henhold til selskabsloven § 124.',
    sv: 'Det var beslutsfattande och kraven i aktiebolagslagen § 124 för att fatta beslut uppfylldes.',
  },
  'ThereWasNoQuorumMinutesPdf?jurisdiction=NO': {
    en: 'There was no quorum, and the requirements listed in Norwegian Companies Act § 6-24 for making decisions were as such not met.',
    nb: 'Styret var ikke beslutningsdyktig i henhold til aksjeloven § 6-24.',
    sv: 'Det fanns inget beslutsfattande och kraven i norska aktiebolagslagen § 6-24 för att fatta beslut uppfylldes inte som sådana.',
  },
  'ThereWasNoQuorumMinutesPdf?companyType=ASA': {
    en: 'There was no quorum, and the requirements listed in the Public Limited Liability Companies Act § 6-24 for making decisions were as such not met.',
    nb: 'Styret var ikke beslutningsdyktig i henhold til allmennaksjeloven § 6-24.',
    sv: 'Det fanns inget beslutsfattande och kraven i aktiebolagslagen § 6-24 för att fatta beslut var inte uppfyllda.',
  },
  'ThereWasNoQuorumMinutesPdf?jurisdiction=EN': {
    en: 'There was no quorum, and the requirements listed in the Companies Act for making decisions were as such not met.',
    nb: 'Styret var ikke beslutningsdyktig i henhold til aksjeloven.',
    sv: 'Det fanns inget beslutsfattande, och kraven i företagslagen för att fatta beslut uppfylldes inte som sådana.',
  },
  'ThereWasNoQuorumMinutesPdf?jurisdiction=SE': {
    en: 'There was no quorum, and the requirements listed in the Companies Act ch.8 § 21 for making decisions were as such not met.',
    nb: 'Styret var ikke beslutningsdyktig i henhold til aktiebolagslagen 8 kap. 21 §.',
    sv: 'Det fanns inget beslutsfattande och de krav som anges i aktiebolagslagen kap. 8 § 21 för att fatta beslut var inte uppfyllda.',
  },
  'ThereWasNoQuorumMinutesPdf?jurisdiction=DK': {
    en: 'There was no quorum, and the requirements listed in the Companies Act § 124 for making decisions were as such not met.',
    nb: 'Styret var ikke beslutningsdyktig i henhold til selskabsloven § 124.',
    sv: 'Det fanns inget beslutsfattande och kraven i aktiebolagslagen § 124 för att fatta beslut var som sådan inte uppfyllda.',
  },
  isSubsidiaryTextFli: {
    en: 'Shall not exercise voting rights',
    nb: 'Skal ikke utøve stemmerett',
    sv: 'Ska inte utöva rösträtt',
  },
  isSubsidiaryText: {
    en: 'Is a subsidiary of {{orgName}} and shall not exercise voting rights',
    nb: 'Er datterselskap av {{orgName}} og skal ikke utøve stemmerett',
    sv: 'Är ett dotterbolag till {{orgName}} och ska inte utöva rösträtt',
  },
  'isSubsidiaryText?jurisdiction=NO': {
    en: 'Is a subsidiary of {{orgName}} and shall not exercise voting rights, The Norwegian law of stocks (Aksjeloven) § 5-3 (3)',
    nb: 'Er datterselskap av {{orgName}} og skal ikke utøve stemmerett, jf. aksjeloven § 5-3 (3)',
    sv: 'Är ett dotterbolag till {{orgName}} och ska inte utöva rösträtt, jfr. den norska aktiebolagslagen § 5-3 (3)',
  },
  cantUpdateMeetingStatusTooltip: {
    en: 'Only administrators can change attendance status after the meeting has started.',
    nb: 'Kun møteadministrator kan endre din deltakerstatus etter at møtet har startet.',
    sv: 'Endast mötesadministratören kan ändra din deltagarestatus efter att mötet har startat.',
  },
  VotingTieTextHelper2: {
    en: "tie; final result is based on the meeting chair's deciding vote",
    nb: 'likt stemmetall; endelig resultat er basert på møteleders avgjørende stemme',
    sv: 'slips; slutresultatet baseras på mötesordförandens avgörande röst',
  },
  'No info': {
    en: 'No info',
    nb: 'Ingen info',
    sv: 'Ingen info',
  },
  'Rendering Failure': {
    en: 'Rendering Failure',
    nb: 'Gjengivelsesfeil',
    sv: 'Rendering misslyckande',
  },
  Send: {
    en: 'Send',
    nb: 'Send',
    sv: 'Skicka',
  },
  Reject: {
    en: 'Reject',
    nb: 'Avvis',
    sv: 'Avvisa',
  },
  Complaint: {
    en: 'Complaint',
    nb: 'Klage',
    sv: 'Klagomål',
  },
  Bounce: {
    en: 'Bounce',
    nb: 'Sprette',
    sv: 'Studsa',
  },
  InvalidUse: {
    en: 'Invalid Use',
    nb: 'Ugyldig bruksstørrelse',
  },
  SearchTranscription: {
    en: 'Search transcription and participants',
    nb: 'Søk i transkripsjon og deltakere',
  },
  InvalidUseContract: {
    en: 'Invalid execution',
    nb: 'Ugyldig utøvelse',
  },
  TranscriptionShortSummary: {
    en: 'Short meeting summary',
    nb: 'Kort møteoppsummering',
  },
  TranscriptionSummary: {
    nb: 'Referat',
    en: 'Summary',
  },
  Transcription: {
    en: 'Transcription',
    nb: 'Transkripsjon',
  },
  UseAuthorization: {
    en: 'Use authorization',
    nb: 'Bruk fullmakt',
  },
  UseContract: {
    en: 'Register execution of agreement',
    nb: 'Registrer utøvelse av avtale',
  },
  NoAuth: {
    en: 'No authorizations have been made yet. Press the button "New authorization" to create your first authorization. Or you can import your companies earlier authorizations by clicking on the import auths button.',
    nb: 'Ingen fullmakter er foretatt ennå. Trykk på knappen "Ny fullmakt" for å opprette din første fullmakt. Ellers kan importere bedriftens tidligere autorisasjoner ved å klikke på "Importer fra Brønnøysundregistrene".',
  },
  NoAuth2: {
    en: 'No active authorizations registered',
    nb: 'Ingen aktive fullmakter registrert',
  },
  NoSummaryYet: {
    en: 'No summary yet',
    nb: 'Ingen sammendrag opprettet',
  },
  CreateMeetingSummary: {
    en: 'Create meeting summary',
    nb: 'Opprett møtesammendrag',
  },
  IssueSharesAuth: {
    en: 'Increase share capital',
    nb: 'Forhøye aksjekapital',
    sv: 'T',
  },
  ConvertibleAuth: {
    en: 'Issue convertible loans',
    nb: 'Ta opp konvertible lån',
    sv: 'Issue Convertible debt',
  },
  BuySharesAuth: {
    en: 'Acquire own shares',
    nb: 'Erverve egne aksjer',
    sv: 'Issue Convertible debt',
  },
  ClaimSharesAuth: {
    en: 'Acquire contractual lien in own shares',
    nb: 'Erverve avtalepant i egne aksjer',
    sv: 'Issue Convertible debt',
  },
  CommentsCannotBeCreatedAfterMeetingEnd: {
    nb: 'Notater kan ikke opprettes etter at møtet er over',
    en: 'Comments cannot be created after the meeting end',
  },
  OptionsAuth: {
    en: 'Grant options',
    nb: 'Dele ut opsjoner',
    sv: 'Issue Convertible debt',
  },
  DividendsAuth: {
    en: 'Distribution of dividends',
    nb: 'Utdeling av utbytte',
    sv: 'Issue Convertible debt',
  },
  IssueSharesType: {
    en: 'Issue Shares',
    nb: 'Forhøye aksjekapital',
    sv: 'T',
  },
  ConvertibleType: {
    en: 'Convertible loan',
    nb: 'Ta opp konvertible lån',
    sv: 'Issue Convertible debt',
  },
  BuySharesType: {
    en: 'Aquire own shares',
    nb: 'Erverve egne aksjer',
    sv: 'Issue Convertible debt',
  },
  ClaimSharesType: {
    en: 'Claim shares',
    nb: 'Erverve avtalepant i egne aksjer',
    sv: 'Issue Convertible debt',
  },
  OptionsType: {
    en: 'Grant options',
    nb: 'Dele ut opsjoner',
    sv: 'Issue Convertible debt',
  },
  DividendsType: {
    en: 'Grant dividends',
    nb: 'Utdeling av utbytte',
    sv: 'Issue Convertible debt',
  },
  Size: {
    en: 'Size',
    nb: 'Størrelse',
    sv: 'Størrelse sv',
  },
  Remaining: {
    en: 'Remaining',
    nb: 'Rest',
  },
  SizeRemaining: {
    en: 'Size remaining',
    nb: 'Gjenværende størrelse',
    sv: 'Størrelse sv',
  },
  SizeRemainingBeforeUse: {
    en: 'Size before use',
    nb: 'Størrelse før bruk',
    sv: 'Størrelse sv',
  },
  SizeRemainingBeforeUseContract: {
    en: 'Quantity before',
    nb: 'Antall før',
    sv: 'Antall før sv',
  },
  SizeRemainingAfterUse: {
    en: 'Remaining after use',
    nb: 'Gjenværende etter bruk',
    sv: 'Størrelse sv',
  },
  SizeRemainingAfterUseContract: {
    en: 'Quantity after',
    nb: 'Antall etter',
    sv: 'Størrelse sv',
  },
  Used: {
    en: 'Used',
    nb: 'Benyttet',
  },
  UseAmountPlaceholder: {
    en: 'Use size',
    nb: 'Bruksstørrelse',
    sv: 'Størrelse sv',
  },
  UseAmountPlaceholderContract: {
    en: 'Quantity',
    nb: 'Antall',
    sv: 'Størrelse sv',
  },
  UseAmountTooltip: {
    en: 'The size of the usage',
    nb: 'Størrelsen på bruken',
    sv: 'Størrelse sv',
  },
  UseAmountTooltipContract: {
    en: 'The size of the execution',
    nb: 'Størrelsen på utøvelsen',
    sv: 'Størrelse sv',
  },

  UseDate: {
    en: 'Date Used',
    nb: 'Bruksdato',
  },
  UseDatePlaceholder: {
    en: 'Use date',
    nb: 'Bruksdato',
    sv: 'Størrelse sv',
  },
  UseDatePlaceholderContract: {
    en: 'Date',
    nb: 'Dato',
    sv: 'Størrelse sv',
  },
  UseDateTooltipContract: {
    en: 'The date of the execution',
    nb: 'Datoen til utøvelsen',
    sv: 'Størrelse sv',
  },
  UseDateTooltip: {
    en: 'The date of the usage',
    nb: 'Dato til bruken',
    sv: 'Størrelse sv',
  },
  UpdateUse: {
    en: 'Update use',
    nb: 'Oppdater bruk',
    sv: 'Størrelse sv',
  },
  NewUse: {
    en: 'Register use',
    nb: 'Registrer bruk',
    sv: 'UpdateUse sv',
  },
  NewUseContract: {
    en: 'Register execution',
    nb: 'Registrer utøvelse',
    sv: 'UpdateUse sv',
  },
  RegisterContract: {
    en: 'Register',
    nb: 'Registrer',
    sv: 'UpdateUse sv',
  },
  NewUseTitle: {
    en: 'Register use of authorization',
    nb: 'Registrer bruk av fullmakt',
    sv: 'NewUseTitle sv',
  },
  NewUseTitleContract: {
    en: 'Register execution of agreement',
    nb: 'Registrer utøvelse av avtale',
    sv: 'NewUseTitle sv',
  },
  DeleteUseTitle: {
    en: 'Delete use',
    nb: 'Slett bruk',
  },
  DeleteUseText: {
    en: 'Deleting a use cannot be undone. Do you want to delete?',
    nb: 'Sletting av bruk kan ikke angres. Ønsker du å slette?',
  },
  Created: {
    en: 'Created',
    nb: 'Vedtatt',
    sv: 'Størrelse sv',
  },
  CreatedNew: {
    en: 'Created',
    nb: 'Opprettet',
    sv: 'Størrelse sv',
  },
  BoardAccess: {
    en: 'Only for board',
    nb: 'Bare for styret',
    sv: 'Størrelse sv',
  },
  Public: {
    en: 'Public',
    nb: 'Offentlig',
  },
  PublishedText: {
    en: 'Published',
    nb: 'Publisert',
    sv: 'Publicerad',
  },
  ALLTASKS: {
    en: 'All',
    nb: 'Alle',
    sv: 'Størrelse sv',
  },
  COMPLETEDTASKS: {
    en: 'Only complete',
    nb: 'Kun fullført',
    sv: 'Størrelse sv',
  },
  UNFINISHEDTASKS: {
    en: 'Only incomplete',
    nb: 'Kun uferdige',
    sv: 'Størrelse sv',
  },
  xlsx: {
    en: 'Excel (.xlsx)',
    nb: 'Excel (.xlsx)',
    sv: 'Excel (.xlsx)',
  },
  csv: {
    en: 'CSV (.csv)',
    nb: 'CSV (.csv)',
    sv: 'CSV (.csv)',
  },
  DateRange: {
    en: 'Created date range',
    nb: 'Opprettet datointervall',
  },
  DeleteMessageHeader: {
    en: 'Warning',
    nb: 'Advarsel',
  },
  DeleteMessageText: {
    en: 'Are you sure that you want to delete the message? This action cannot be undone.',
    nb: 'Er du sikker på at du vil slette meldingen? Denne handlingen kan ikke angres.',
  },
  DeleteGenericObjectText: {
    en: 'Are you sure that you want to delete this item? This action cannot be undone.',
    nb: 'Er du sikker på at du vil slette dette elementet? Denne handlingen kan ikke angres.',
  },
  Expires: {
    en: 'Expires',
    nb: 'Utløper',
    sv: 'Størrelse sv',
  },
  Registered: {
    en: 'Registered',
    nb: 'Registrert',
    sv: 'Størrelse sv',
  },
  GAMeetingInterest: {
    en: 'Meeting interest',
    nb: 'Møteinteresse',
  },
  statusTableHeader: { nb: 'Møteinteresse', en: 'Meeting interest' },
  IssuingSharesTitle: {
    en: 'Authorization For Issuing New Shares',
    nb: 'Fullmakt til å forhøye aksjekapital',
    sv: 'Størrelse sv',
  },
  ClaimTitle: {
    en: 'Authorization For Stock Claim',
    nb: 'Fullmakt til å erverve avtalepant i egne aksjer',
    sv: 'Størrelse sv',
  },
  ConvertibleTitle: {
    en: 'Authorization For Convertible Loan',
    nb: 'Fullmakt til å ta opp konvertibelt lån',
    sv: 'Størrelse sv',
  },
  BuySharesTitle: {
    en: 'Authorization For Buying Company Shares',
    nb: 'Fullmakt til å erverve egne aksjer',
    sv: 'Størrelse sv',
  },
  DividendsTitle: {
    en: 'Authorization For Granting Dividends',
    nb: 'Fullmakt til utdeling av utbytte',
    sv: 'Størrelse sv',
  },
  OptionsTitle: {
    en: 'Authorization For Granting Options',
    nb: 'Fullmakt opsjonsprogram',
    sv: 'Størrelse sv',
  },
  AuthBuySharesInfo: {
    en: "The general assembly's decision must contain information on how long the authorization will be valid, the highest nominal value of the shares the company can acquire in total, that is, the sum of the number of shares x nominal value stated in the articles of association, the minimum and maximum amount that can be paid for the shares, and in which ways the acquisition and disposal of own shares can take place. The general assembly's decision must be reported to the Norwegian companies register and must be registered before shares can be acquired in accordance with the authorization.",
    nb: 'Generalforsamlingens beslutning skal inneholde opplysninger om hvor lenge fullmakten skal gjelde, den høyeste pålydende verdien av aksjene selskapet i alt kan erverve, det vil si summen av antall aksjer x pålydende verdi som er oppgitt i vedtektene, det minste og høyeste beløpet som kan betales for aksjene, og om hvilke måter erverv og avhendelse av egne aksjer kan skje på. Generalforsamlingens beslutning skal meldes til Foretaksregisteret og må være registrert før aksjer kan erverves i henhold til fullmakten.',
  },
  AuthClaimInfo: {
    en: "The general assembly's decision must contain information on how long the authorization is to be valid, the highest nominal value of the shares the company can acquire in total, that is, the sum of the number of shares x nominal value stated in the articles of association, the minimum and maximum amount that can be paid for the shares, and in which ways the acquisition and disposal of own shares can take. The general assembly's decision must be reported to the Norwegian companies register and must be registered before shares can be acquired in accordance with the authorization.",
    nb: 'Generalforsamlingens beslutning skal inneholde opplysninger om hvor lenge fullmakten skal gjelde, den høyeste pålydende verdien av aksjene selskapet i alt kan erverve, det vil si summen av antall aksjer x pålydende verdi som er oppgitt i vedtektene, det minste og høyeste beløp som kan betales for aksjene, og på hvilke måter erverv og avhendelse av egne aksjer kan skje. Generalforsamlingens beslutning skal meldes til Foretaksregisteret og må være registrert før aksjer kan erverves i henhold til fullmakten.',
  },
  AuthConvertibleInfo: {
    en: "The General Assembly's decision must contain information on the total loan amount that can be taken out, the amount by which the share capital can be increased, and how long the authorization is to be valid.",
    nb: 'Generalforsamlingens beslutning skal inneholde opplysninger om det samlede lånebeløp som kan tas opp, beløpet aksjekapitalen skal kunne forhøyes med, og hvor lenge fullmakten skal gjelde.',
  },
  AuthDividendsInfo: {
    en: 'When the annual accounts for the last year have been approved, the general meeting can authorize the board to decide on the distribution of dividends. The authorization is valid until the next ordinary general meeting.',
    nb: 'Når årsregnskapet for siste år er godkjent, kan generalforsamlingen gi styret fullmakt til å beslutte utdeling av utbytte. Fullmakten gjelder frem til neste ordinære generalforsamling.',
  },
  AuthIssueSharesInfo: {
    en: "The general assembly can authorize the board to increase the share capital by issuing new shares. The general assembly's decision must state the amount by which the share capital is to be increased, and how long the authorization is to be valid. The general assembly's decision on board authorization must be reported to the Companies Register without delay. The board cannot make use of the authorization before it has been registered.",
    nb: 'Generalforsamlingen kan gi styret fullmakt til å forhøye aksjekapitalen ved nytegning av aksjer. I generalforsamlingens beslutning må det stå oppgitt beløpet aksjekapitalen skal forhøyes med, og hvor lenge fullmakten skal gjelde. Generalforsamlingens beslutning om styrefullmakt skal uten opphold meldes til Foretaksregisteret. Styret kan ikke gjøre bruk av fullmakten før den er registrert.',
  },
  AuthOptionsInfo: {
    en: 'The general assembly can authorize the board to increase the share capital by issuing new shares. In connection with such an authorization, the board at the general assembly can obtain an authorization on how much of the authorization can be used in connection with an option program.',
    nb: 'Generalforsamlingen kan gi styret fullmakt til å forhøye aksjekapitalen ved nytegning av aksjer. I forbindelse med en slik fullmakt kan styret på generalforsamling få en fullmakt på hvor mye av fullmakten som kan benyttes i forbindelse med et opsjonsprogram.',
  },
  AuthBuySharesReadMore: {
    en: 'Read more in sections 9-2 and 9-4 of the Norwegian Companies Act.',
    nb: 'Les mer i aksjeloven §§ 9-2 og 9-4.',
  },
  AuthClaimReadMore: {
    en: 'Read more in section 9-5 of the Norwegian Companies Act.',
    nb: 'Les mer i aksjeloven § 9-5.',
  },
  AuthConvertibleReadMore: {
    en: 'Read more in section 11-8 of the Norwegian Companies Act.',
    nb: 'Les mer i aksjeloven § 11-8.',
  },
  AuthDividendsReadMore: {
    en: 'Read more in section 8-2 of the Norwegian Companies Act.',
    nb: 'Les mer i aksjeloven § 8-2.',
  },
  AuthIssueSharesReadMore: {
    en: 'Read more in chapter 10 of the Norwegian Company Act.',
    nb: 'Les mer i aksjeloven kapittel 10.',
  },
  AuthBuySharesReadMoreASA: {
    en: 'Read more in section 9-2 and 9-4 of the Norwegian public Limited Liability Companies Act.',
    nb: 'Les mer i allmennaksjeloven §§ 9-2 og 9-4.',
  },
  AuthClaimReadMoreASA: {
    en: 'Read more in section 9-5 of the Norwegian public Limited Liability Companies Act.',
    nb: 'Les mer i allmennaksjeloven § 9-5.',
  },
  AuthConvertibleReadMoreASA: {
    en: 'Read more in section 11-8 of the Norwegian public Limited Liability Companies Act.',
    nb: 'Les mer i allmennaksjeloven § 11-8.',
  },
  AuthDividendsReadMoreASA: {
    en: 'Read more in section 8-2 of the Norwegian public Limited Liability Companies Act.',
    nb: 'Les mer i allmennaksjeloven § 8-2.',
  },
  AuthIssueSharesReadMoreASA: {
    en: 'Read more in the Norwegian public Limited Liability Companies Act, chapter 10.',
    nb: 'Les mer i allmennaksjeloven kapittel 10.',
  },

  ImportAuthorizations: {
    en: 'Import from Brønnøysund Registers',
    nb: 'Importer fra Brønnøysundregistrene',
    sv: 'Størrelse sv',
  },
  IssueSharesAuthCreated: {
    en: 'Issue shares authorization created',
    nb: 'Fullmakt til å øke aksjekapitalen ble registrert',
    sv: 'Størrelse sv',
  },
  ConvertibleLoanAuthCreated: {
    en: 'Convertible loan authorization created',
    nb: 'Fullmakt til å ta opp konvertibelt lån ble registrert',
    sv: 'Størrelse sv',
  },
  BuySharesAuthCreated: {
    en: 'Buy shares authorization created',
    nb: 'Fullmakt til å erverve egne aksjer ble registrert',
    sv: 'Størrelse sv',
  },
  ClaimAuthCreated: {
    en: 'Claim authorization created',
    nb: 'Fullmakt til å erverve avtalepant på egne aksjer ble registrert',
    sv: 'Størrelse sv',
  },
  DividendsAuthCreated: {
    en: 'Dividends authorization created',
    nb: 'Utbytte fullmakt ble registrert',
    sv: 'Størrelse sv',
  },
  OptionsAuthCreated: {
    en: 'Options authorization created',
    nb: 'Opsjons fullmakt ble registrert',
    sv: 'Størrelse sv',
  },
  AuthDeleted: {
    en: 'Authorization deleted',
    nb: 'Fullmakt slettet',
    sv: 'Størrelse sv',
  },
  AuthSizePlaceholder: {
    en: 'Authorization Size (NOK)',
    nb: 'Fullmaktens størrelse (NOK)',
    sv: 'Størrelse sv',
  },
  AuthSizeTooltip: {
    en: 'The size of the authorization (NOK)',
    nb: 'Størrelsen på fullmakten (NOK)',
    sv: 'Størrelse sv',
  },
  LoanSizePlaceholder: {
    en: 'Loan size (NOK)',
    nb: 'Lånets størrelse (NOK)',
    sv: 'Størrelse sv',
  },
  LoanSizeTooltip: {
    en: 'The size of the loan (NOK)',
    nb: 'Størrelsen på lånet (NOK)',
    sv: 'Størrelse sv',
  },
  AuthStartDate: {
    en: 'Date given',
    nb: 'Dato gitt',
  },
  AuthStartDateTooltip: {
    en: 'The starting date of the authorization',
    nb: 'Datoen fullmakten er gitt',
  },
  AuthExpirationDate: {
    en: 'Date expires',
    nb: 'Utløpsdato',
  },
  AuthExpirationDateTooltip: {
    en: 'The expiration date of the authorization',
    nb: 'Utløpsdatoen til fullmakten',
  },
  RegistrationDate: {
    en: 'Registered in Brreg',
    nb: 'Registrert i Brreg',
    sv: 'Størrelse sv',
  },
  RegistrationDateTooltip: {
    en: 'The Registration date in the Foretaksregister',
    nb: 'Datoen fullmakten ble registrert i Foretaksregistert',
    sv: 'Størrelse sv',
  },
  Notes: {
    en: 'Notes',
    nb: 'Notater',
    sv: 'Størrelse sv',
  },
  NorwegianCompany: {
    en: 'Norwegian',
    nb: 'Norsk',
    sv: 'Størrelse sv',
  },
  ForeignCompany: {
    en: 'Foreign',
    nb: 'Utenlandsk',
    sv: 'Størrelse sv',
  },

  NotesTooltip: {
    en: 'Here you can enter free text, for example whether there are criteria that must be met for the agreement to be exercised.',
    nb: 'Here you can enter free text, for example whether there are criteria that must be met for the agreement to be exercised.',
    sv: 'Størrelse sv',
  },
  NotesPlaceholder: {
    en: 'Here you can enter notes for the authorization',
    nb: 'Her kan du skrive inn notater for fullmakten',
    sv: 'Størrelse sv',
  },
  EmailNoInfo: {
    en: 'No information about the invitation is available. Has an invitation been sent via email to this user?',
    nb: 'Ingen informasjon om invitasjonen er tilgjengelig. Er det sendt invitasjon på e-post til denne brukeren?',
  },
  Delivery: {
    en: 'Invitation has been sent via email. Click on the icon for more information.',
    nb: 'Invitasjon er sendt på e-post. Klikk på ikonet for ytterligere informasjon.',
  },
  NewUserDelivery: {
    en: 'Invitation has been sent via email.',
    nb: 'Invitasjon er sendt på e-post.',
  },
  NewUserPending: {
    en: 'Pending registeration email',
    nb: 'Venter på registrerings e-post',
  },
  NewUserRegistered: {
    en: 'This user is registered.',
    nb: 'Denne brukeren er registrert.',
  },

  EmailRecipients: {
    en: 'Email recipients',
    nb: 'E-postmottakere',
  },
  EmailRecipientsTooltip: {
    en: 'Here you can add recipients of the email by clicking the "Add people" button and entering their information ',
    nb: 'Her kan du legge til mottakere av e-posten ved å klikke på knappen "Legg til personer" og legge inn deres informasjon',
  },
  AddRecipients: {
    en: 'Add recipients',
    nb: 'Legg til mottakere',
  },
  OpenText: {
    en: "The invitation has been opened in the user's email program. Click on the icon for more information.",
    nb: 'Invitasjonen er åpnet i brukerens e-postprogram. Klikk på ikonet for ytterligere informasjon.',
    sv: 'Invitasjonen er åpnet i brukerens e-postprogram. Klikk på ikonet for ytterligere informasjon.',
  },
  Click: {
    en: 'The user has clicked the button in the invitation to join the meeting. Click on the icon for more information.',
    nb: 'Brukeren har trykket på knappen i invitasjonen for å gå til møtet. Klikk på ikonet for ytterligere informasjon.',
    sv: 'Brukeren har trykket på knappen i invitasjonen for å gå til møtet. Klikk på ikonet for ytterligere informasjon.',
  },
  Library: {
    en: 'Library',
    nb: 'Bibliotek',
    sv: 'Bibliotek',
  },
  'New item': {
    en: 'New item',
    nb: 'Ny sak',
    sv: 'Nytt ämne',
  },
  SelectMeeting: {
    en: 'Select meeting',
    nb: 'Velg møte',
    sv: 'Välj möte',
  },
  MinutesCreated: {
    en: 'Minutes created',
    nb: 'Agendapunkt opprettet',
    sv: 'Protokoll skapad',
  },
  durationLabel: {
    nb: 'Beregnet tid (min)',
    en: 'Estimated time (min)',
  },
  CreateMinutcase: {
    en: 'Create agenda item for meeting',
    nb: 'Opprett agendapunkt til møte',
    sv: 'Skapa minnesmapp för möte',
  },
  CreateMinutcaseFromTaskButtonText: {
    en: 'Create',
    nb: 'Opprett',
    sv: 'Skapa minnesmapp', //TODO: Translate
  },
  NoMeetingsAvailable: {
    en: "You don't have any future meetings that this agenda item can be linked to.",
    nb: 'Du har ingen fremtidige møter som dette agendapunktet kan knyttes til.',
    sv: 'Du har ingen fremtidige møter som dette agendapunktet kan knyttes til.',
  },
  MeetingInformation: {
    en: 'Meeting information',
    nb: 'Møteinformasjon',
    sv: 'Mötesinformation',
  },

  MeetingDate: {
    en: 'Meeting date',
    nb: 'Møtedato',
    sv: 'Mötesdatum',
  },
  CaseCreated: {
    nb: 'Styresak er lagret!',
    en: 'Board case saved!',
  },
  OpenMeeting: {
    en: 'Open meeting',
    nb: 'Åpne møtet',
    sv: 'Öppna mötet',
  },

  LinkToTask: {
    en: 'Link to task',
    nb: 'Lenke til oppgave',
    sv: 'Länk till uppgift',
  },
  'Add new agenda item': {
    en: 'Add new agenda item',
    nb: 'Legg til nytt agenda punkt',
    sv: 'Lägg till nytt ämne',
  },
  AgendaSuggestions: {
    en: 'About agenda suggestions',
    nb: 'Om agendaforslag',
    sv: 'Om agendaforslag',
  },
  ManageAgendaSuggestions: {
    en: 'Manage agenda suggestions',
    nb: 'Administrer agendaforslag',
    sv: 'Administrer agendaforslag',
  },
  ManageAgendaSuggestionsInfo: {
    en: 'Agenda suggestions are templates for new agenda items in a meeting. Orgbrain has several agenda suggestions ready to use. In addition, you can create custom agenda suggestions for your organization. The agenda suggestions will appear when you edit the agenda for a meeting.',
    nb: 'Agendaforslag er maler for nye agendapunkter i et møte. Orgbrain har mange agendaforslag klare til bruk. I tillegg kan du lage egendefinerte agendaforslag for din organisasjon. Agendaforslagene dukker opp når du redigerer agendaen for et møte.',
  },
  DeleteEmissionPlanQuestion2: {
    en: 'You are about to delete a capital increase. This cannot be undone. Do you want to delete?',
    nb: 'Du er i ferd med å slette en kapitalforhøyelse. Dette kan ikke angres. Ønsker du å slette? ',
    sv: 'Du håller på att ta bort en kapitalökning. Detta kan inte ångras. Vill du ta bort?',
  },
  FilterByTopic: {
    en: 'Filter',
    nb: 'Filtrer etter tema',
    sv: 'Filtrer etter tema',
  },
  MeetingType: {
    en: 'Meeting type',
    nb: 'Møtetype',
    sv: 'Møtetype',
  },
  MeetingTypeInfoBox: {
    en: 'Select the type of meetings the agenda item applies to. The agenda item will only appear in these meetings.',
    nb: 'Velg hvilken type møter agendapunktet gjelder for. Agendapunktet vil kun vises på disse møtene.',
    sv: 'sv',
  },
  MaximumAlternatives: {
    en: 'Maximum alternatives',
    nb: 'Antall alternativer',
    sv: 'Antall alternativer',
  },
  MaximumElected: {
    en: 'Election',
    nb: 'Personvalg',
    sv: 'Antall posisjoner',
  },
  ProposedSolution: {
    en: 'Proposed solution',
    nb: 'Forslag til vedtak',
    sv: 'Løsning',
  },
  HelpText: {
    en: 'Helptext',
    nb: 'Hjelpetekst',
    sv: 'Hjelpetekst',
  },
  CancelEdit: {
    en: 'Cancel editing',
    nb: 'Avbryt redigering',
    sv: 'Avbryt redigering',
  },
  SetConversationHistoryText: {
    en: 'How much of the conversation history do you want to share with the user?',
    nb: 'Hvor mye av samtale historien vil du dele med brukeren?',
    sv: 'Hvor mye av samtale historien vil du dele med brukeren?',
  },

  BeginningOfConversationText: {
    en: 'This is the beginning of the conversation',
    nb: 'Dette er begynnelsen på samtalen',
  },
  ConversationHistory: {
    en: 'Change the access this user has to the conversation history',
    nb: 'Endre tilgangen denne brukeren har til samtalehistorikken',
  },
  ReadAccessDate: {
    en: 'Share conversation history',
    nb: 'Del samtale historie',
    sv: 'Del samtale historie',
  },
  CompleteHistory: {
    en: 'Share complete history',
    nb: 'Del fullstendig samtalehistorikk',
    sv: 'Del samtale historie',
  },
  PeriodHistory: {
    en: 'Share last month',
    nb: 'Del siste måneden',
    sv: 'Del samtale historie',
  },
  NoneHistory: {
    en: `Don't share any history`,
    nb: 'Ikke del noen samtalehistorikk',
    sv: 'Del samtale historie',
  },
  CustomHistory: {
    en: 'Choose date',
    nb: 'Velg dato',
    sv: 'Del samtale historie',
  },
  NewAltinnSystemTitle: {
    en: 'New Altinn system',
    nb: 'Ny innlevering av aksjonærregisteroppgaven',
  },
  NewAltinnSystemQuestion: {
    en: 'Do you want to use the new Altinn system?',
    nb: 'Altinn har oppdatert innleveringen av aksjonærregisteroppgaven. Vil du ta i bruk det nye systemet? Dette vil medføre at innleveringen ender opp i "Nye Altinn"',
  },
  UseOldSystem: {
    en: 'Use old system',
    nb: 'Bruk gammelt system',
  },
  EmojiSearch: {
    en: 'Search',
    nb: 'Søk',
    sv: 'Söka',
  },
  EmojiNoResults1: {
    en: '',
    nb: '',
  },
  EmojiNoResults2: {
    en: 'This emoji does not exist',
    nb: 'Denne emojien finnes ikke',
    sv: 'Denna emoji finns inte',
  },
  EmojiPick: {
    en: 'Pick an emoji',
    nb: 'Velg en emoji',
    sv: 'Välj en emoji',
  },
  EmojiAddCustom: {
    en: 'Add custom emoji',
    nb: 'Legg til tilpasset emoji',
    sv: 'Lägg till anpassad emoji',
  },

  EmojiCategoriesActivity: {
    en: 'Activity',
    nb: 'Aktivitet',
    sv: 'Aktivitet',
  },
  EmojiCategoriesCustom: {
    en: 'Custom',
    nb: 'Tilpasset',
    sv: 'Anpassad',
  },
  EmojiCategoriesFlags: {
    en: 'Flags',
    nb: 'Flagg',
    sv: 'Flaggor',
  },
  EmojiCategoriesFoods: {
    en: 'Food & Drink',
    nb: 'Mat & Drikke',
    sv: 'Mat & Dryck',
  },
  EmojiCategoriesRecent: {
    en: 'Frequently used',
    nb: 'Ofte brukt',
    sv: 'Ofta använd',
  },
  EmojiCategoriesNature: {
    en: 'Animals & Nature',
    nb: 'Dyr & Natur',
    sv: 'Djur & Natur',
  },
  EmojiCategoriesObjects: {
    en: 'Objects',
    nb: 'Objekter',
    sv: 'Objekt',
  },
  EmojiCategoriesPeople: {
    en: 'Smileys & People',
    nb: 'Smileys & Mennesker',
    sv: 'Smileys & Människor',
  },
  EmojiCategoriesPlaces: {
    en: 'Travel & Places',
    nb: 'Reise & Steder',
    sv: 'Resor & Platser',
  },
  EmojiCategoriesSearch: {
    en: 'Search Results',
    nb: 'Søkeresultater',
    sv: 'Sökresultat',
  },
  EmojiCategoriesSymbols: {
    en: 'Symbols',
    nb: 'Symboler',
    sv: 'Symboler',
  },
  EmojiSkinsChoose: {
    en: 'Choose default skin tone',
    nb: 'Velg standard hudtone',
    sv: 'Välj standard hudfärg',
  },
  EmojiSkins1: {
    en: 'Default',
    nb: 'Standard',
    sv: 'Standard',
  },
  EmojiSkins2: {
    en: 'Light',
    nb: 'Lys',
    sv: 'Ljus',
  },
  EmojiSkins3: {
    en: 'Medium-Light',
    nb: 'Mellom-Lys',
    sv: 'Mellan-Ljus',
  },
  EmojiSkins4: {
    en: 'Medium',
    nb: 'Medium',
    sv: 'Medium',
  },
  EmojiSkins5: {
    en: 'Medium-Dark',
    nb: 'Mellom-Mørk',
    sv: 'Mellan-Mörk',
  },
  EmojiSkins6: {
    en: 'Dark',
    nb: 'Mørk',
    sv: 'Mörk',
  },
  NoTranscriptionsYet: {
    en: 'Use artificial intelligence to analyze the meeting and generate suggestions for the protocol. Record a video meeting with the built-in video solution or upload a recording.',
    nb: 'Bruk kunstig intelligens til å analysere møtet og lage forslag til protokoll. Ta opptak med den innebygde videoløsningen eller last opp et opptak.',
  },
  ImportantInfo: {
    en: 'Important information',
    nb: 'Viktig informasjon',
  },
  ConversationsIntroHeader: {
    en: 'Introduction to conversations',
    nb: 'Introduksjon til samtaler',
    sv: 'Del samtale historie',
  },
  YourActivities: {
    en: 'Your activities',
    nb: 'Dine aktiviteter',
  },
  AllOrgs: {
    en: 'All Organizations',
    nb: 'Alle selskaper',
  },
  ConversationsInfoText1: {
    en: 'Conversations is a chat solution in the portal. A board conversation is already created and all users with board access have access to this chat. Board users can create their own conversations with one or more users. Users without rights to create a conversation can be invited into one.',
    nb: 'Samtaler er en chat-løsning i portalen. En styre-chat er allerede opprettet og alle brukere med styretilgang har tilgang til denne chatten. Styrebrukere kan opprette egne chatter med en eller flere brukere. Brukere uten rettigheter til å opprette en samtale kan inviteres inn i en.',
  },
  ConversationsInfoHeader4: {
    en: 'Contact Groups',
    nb: 'Kontaktgrupper',
  },
  ConversationsInfoText4: {
    en: 'Administrator users can create contact groups that make it easier for users to get in touch with the right person or role. When a user (for example, an owner) starts a dialog with a contact group, a shared chat is created with that person and everyone defined as part of the group. Examples of contact groups could be: "Contact the Board", "Contact the Safety Representative", "Contact the General Manager".',
    nb: 'Administratorbrukere kan opprette kontaktgrupper som gjør det enklere for brukere å ta kontakt med riktig person eller rolle. Når en bruker (eksempelvis en eier) starter en dialog med en kontaktgruppe, opprettes det en felles chat med vedkommende og alle som er definert som del av gruppen. Eksempler på kontaktgrupper kan være: “Kontakt styret”, “Kontakt verneombud”, “Kontakt daglig leder”.',
  },
  ChatMessageMentionSetting: {
    en: 'When you are mentioned in a conversation or chat',
    nb: 'Når du blir nevnt i en samtale eller chat',
  },
  ChatMessageReplySetting: {
    en: 'When someone replies to your message in a conversation or chat',
    nb: 'Når noen svarer på meldingen din i en samtale eller chat',
  },
  UnreadChatMessagesSetting: {
    en: 'When there are unread messages in a conversation or chat that you are part of',
    nb: 'Når det er uleste meldinger i en samtale eller chat du er del av',
  },

  PrimaryResponsible: {
    en: 'This user is the primary responsible for this task',
    nb: 'Denne brukeren er hovedansvarlig for oppgaven',
  },
  AddedToConversationSetting: {
    en: 'When you are added to a conversation',
    nb: 'Når du blir lagt til i en samtale',
  },
  RemovedFromConversationSetting: {
    en: 'When you are removed from a conversation',
    nb: 'Når du blir fjernet fra en samtale',
  },
  NewCallInConversationSetting: {
    en: 'When someone starts a new call in a conversation',
    nb: 'Når noen starter et nytt videomøte i en samtale',
  },
  AddedAdminToUppercase: {
    en: 'Added admin to ',
    nb: 'Ga admin til ',
  },
  RemovedAdminFromUppercase: {
    en: 'Removed admin from ',
    nb: 'Fjernet admin fra ',
  },
  AddedAdminTo: {
    en: ' added admin to ',
    nb: ' ga admin til ',
  },
  RemovedAdminFrom: {
    en: ' removed admin from ',
    nb: ' fjernet admin fra ',
  },
  ConversationsInfoHeader1: {
    en: 'Conversations',
    nb: 'Samtaler',
    sv: 'TODO',
  },
  MessagePlaceholder: {
    en: 'Message ',
    nb: 'Melding til ',
    sv: 'Melding til ',
  },
  ConversationsInfoBoxText: {
    en: 'Conversations is a feature where conversation groups can be created, allowing users to discuss specific topics or send private messages to each other. Only those with the necessary permissions can create a new conversation. A user can be a member of several conversations at the same time. Only members of a conversation group have access to it. After a conversation group is created, new users can be invited to join.',
    nb: 'Samtaler er en funksjon der det opprettes samtalegrupper hvor brukerne kan diskutere spesifikke temaer eller sende private meldinger til hverandre. Kun de som har fått nødvendige rettigheter, kan opprette en ny samtale. En bruker kan være medlem av flere samtaler samtidig. Kun medlemmer av en samtalegruppe har tilgang til den. Etter at en samtalegruppe er opprettet, kan nye brukere inviteres inn.',
    sv: 'Hjelpetekst',
  },

  HelptextInfoBox: {
    en: 'Here you can optionally include help text that assists users in better understanding the matter. This could, for example, be references to a law paragraph or best practices.',
    nb: 'Her kan du eventuelt legge inn hjelpetekst som hjelper brukerne å forstå saken bedre. Dette kan for eksempel være henvisninger til en lovparagraf eller beste praksis.',
    sv: 'sv',
  },
  MinuteNotesInfoBox: {
    en: 'Here you insert the text from the agenda item that should be included in the meeting minutes.',
    nb: 'Her legger du inn teksten fra agendapunktet som skal inn i møteprotokollen.',
    sv: 'sv',
  },
  DescInfoBox: {
    en: 'Here you write the text for the agenda item that should be included in the meeting notice.',
    nb: 'Her skriver du inn tekst til agendapunktet som skal med i innkallingen til møtet.',
    sv: ' sv',
  },
  DecisionInfoBox: {
    en: 'Here you write the proposed resolution to be included in the meeting notice. This text will also appear in the draft minutes.',
    nb: 'Her skriver du inn forslag til vedtak som kommer med i innkallingen til møtet. Denne teksten vil også vises i utkast til protokoll.',
    sv: 'sv',
  },
  CategoryInfoBox: {
    en: 'Assign the agenda item to the appropriate category from the menu. This category determines the processing procedure.',
    nb: 'Gi agendapunktet riktig kategori fra menyen. Denne kategorien bestemmer saksbehandlingsprosessen.',
    sv: 'sv',
  },
  TitleInfoBox: {
    en: 'Give the agenda item a title that briefly describes the matter.',
    nb: 'Gi agendapunktet en tittel som kort beskriver saken.',
    sv: 'sv',
  },
  ContactList: {
    en: 'Contact groups',
    nb: 'Kontaktgrupper',
  },
  StartContactConversation: {
    en: 'Start conversation with the contact',
    nb: 'Start samtale med kontakten',
  },
  StartConversationAdmin: {
    en: 'Start conversation',
    nb: 'Start samtale',
  },
  ContactDialogInfo: {
    en: `Here you can start a conversation with the contacts listed below.`,
    nb: `Her kan du starte en samtale med kontaktene som er oppført i listen nedenfor.`,
  },

  ContactDialogInfoAdmin: {
    en: `Here you can create different groups that users can contact if they wish to reach out to the organization. When creating the group, you choose who will be the contacts. For example, you can create a group called "The Board" where all board members are added as contacts, allowing shareholders to send inquiries and start a conversation or dialogue. Only those who are listed as contacts in the group, along with the user initiating contact, will be able to see the conversation.`,
    nb: `Her kan du opprette ulike grupper som brukerne kan kontakte dersom de ønsker å komme i kontakt med virksomheten. Når du oppretter gruppen, velger du hvem som skal være kontaktpersoner. For eksempel kan du opprette en gruppe som heter "Styret"' hvor alle styremedlemmer legges inn som kontaktpersoner, slik at aksjonærene kan sende henvendelser og starte en samtale eller dialog. Kun de som er lagt inn som kontaktpersoner i gruppen, samt brukeren som tar kontakt, vil kunne se samtalen.`,
  },
  CreateContactList: {
    en: 'Contact groups',
    nb: 'Kontaktgrupper',
  },
  AddYourselfAsResponsible: {
    en: 'Add yourself as responsible',
    nb: 'Legg deg selv til som ansvarlig',
  },
  CreateContactGroup: {
    en: 'Create contact group',
    nb: 'Opprett kontaktgruppe',
  },
  EditContactGroup: {
    en: 'Edit contact group',
    nb: 'Rediger kontaktgruppe',
  },
  ContactName: {
    en: 'Name of contact group',
    nb: 'Navn på kontaktgruppen',
  },
  AddPeopleContact: {
    en: 'Add people to contact group',
    nb: 'Legg til i kontaktgruppen',
  },
  CreateNewContact: {
    en: 'New contact group',
    nb: 'Ny kontaktgruppe',
  },
  createConversationWithContactGroup: {
    en: 'Start conversation with the contact group',
    nb: 'Start samtale med kontaktgruppen',
  },
  startConversationWithContactTitle: {
    en: `Send message`,
    nb: `Send melding`,
  },
  Preferences: {
    en: `Preferences`,
    nb: `Preferanser`,
  },
  startConversationWithContact: {
    en: `You can start a conversation or send a message to the contact group by writing your inital message in the field below and clicking "Send"`,
    nb: `Du kan starte en samtale eller sende en melding til kontaktgruppen ved å fylle ut meldingen din i feltet under og deretter klikke "Send"`,
  },
  ContactConversation: {
    en: 'Contact conversations',
    nb: 'Kontaktsamtaler',
  },
  InviteToCall: {
    en: 'Invite to call',
    nb: 'Inviter til videomøte',
  },
  Invited: {
    en: ' invited ',
    nb: ' inviterte ',
  },
  ToCall: {
    en: ' to a call.',
    nb: ' til et videomøte.',
  },

  Members: {
    en: 'Members',
    nb: 'Medlemmer',
  },
  Category: {
    en: 'Category',
    nb: 'Kategori',
    sv: 'Kategori',
  },
  now: {
    en: 'now',
    nb: 'nå',
    sv: 'nu',
  },
  minuteShortFormat: {
    en: 'minute',
    nb: 'minutt',
    sv: 't',
  },
  hourShortFormat: {
    en: 'hour',
    nb: 'time',
    sv: 't',
  },
  hoursShortFormat: {
    en: 'hours',
    nb: 'timer',
    sv: 't',
  },
  dayShortFormat: {
    en: 'day',
    nb: 'dag',
    sv: 't',
  },
  daysShortFormat: {
    en: 'days',
    nb: 'dager',
    sv: 't',
  },
  timeAgo: {
    en: '',
    nb: '',
    sv: 't',
  },
  DeleteConversation: {
    en: 'Delete the entire conversation',
    nb: 'Slett hele samtalen',
    sv: 't',
  },
  DeleteConversationText: {
    en: 'You are about to delete the entire conversation, are you sure?',
    nb: 'Du er i ferd med å slette hele samtalen, er du sikker?',
    sv: 't',
  },
  MessageHistoryTooltip: {
    en: 'The date shows the history that has been shared with the user',
    nb: 'Datoen viser samtalehistorikken som er delt med brukeren',
    sv: 't',
  },
  FilterAgenda: {
    en: 'Find agenda suggestions',
    nb: 'Finn agendaforslag',
    sv: 'Kategori',
  },
  NewAgenda: {
    en: 'Make new agenda suggestion',
    nb: 'Lag nytt agendaforslag',
    sv: 'Kategori',
  },
  DeleteEmissionPlanQuestion: {
    en: 'You are about to delete a capital increase. This cannot be undone. Do you want to delete?',
    nb: 'Du er i ferd med å slette en kapitalforhøyelse. Dette kan ikke angres. Ønsker du å slette? ',
    sv: 'Du håller på att ta bort en kapitalökning. Detta kan inte ångras. Vill du ta bort?',
  },
  OrgbrainSignFooter: {
    en: 'This document is signed with Orgbrain eSign\n- a standard electronic signature compliant\nwith EU regulation 910/2014 (eIDAS).',
    nb: 'Dokumentet er signert med Orgbrain eSign\n- en standard elektronisk signatur i samsvar\nmed EU-forordning 910/2014 (eIDAS).',
  },
  SearchMessages: {
    en: 'Search for messages',
    nb: 'Søk på meldinger',
  },
  IncludeShareNumbersTooltip: {
    en: 'Do you want to include share numbers in the PDF. NOTE: This option is only shown for companies with valid share numbers',
    nb: 'Ønsker du å inkludere aksjenummer i PDF-en. OBS: Dette valget vises kun om selskapet ditt har gyldige aksjenummer',
  },
  IncludeShareNumbers: {
    en: 'Include share numbers',
    nb: 'Inkluder aksjenummer',
  },

  owners: {
    en: 'owners',
    nb: 'eiere',
  },
  SearchGlobal: {
    en: 'Search for conversations, people and messages',
    nb: 'Søk på samtaler, personer og meldinger',
  },
  ConversationSearch: {
    en: 'Conversations search',
    nb: 'Samtale søk',
  },
  SearchConversations: {
    en: 'Conversations search',
    nb: 'Samtale søk',
  },

  NewName: {
    en: 'New conversation name',
    nb: 'Nytt samtale navn',
  },
  SearchMessagesText: {
    en: 'No messages, use the search field to find messages in this conversation (minimum 3 characters)',
    nb: 'Ingen meldinger her, bruk søkefeltet for å finne meldinger i denne samtalen (minimum 3 tegn)',
  },
  'Error in message-search': {
    en: 'Error in message search',
    nb: 'Feil i meldingssøk',
  },
  SearchInCurrentChat: {
    en: 'This chat',
    nb: 'Denne samtalen',
  },
  SearchInAllChats: {
    en: 'All chats',
    nb: 'Alle samtaler',
  },
  OrgbrainSignQRFooter: {
    en: 'For more information see\n \nOr scan the QR code',
    nb: 'For mer informasjon se\n \nEller skann QR koden',
  },
  DeleteContact: {
    en: 'Delete contact group',
    nb: 'Slett kontaktgruppen',
  },

  OrgbrainSignHeader: {
    en: 'This document is signed with Orgbrain eSign - a standard electronic\nsignature compliant with EU regulation 910/2014 (eIDAS).',
    nb: 'Dokumentet er signert med Orgbrain eSign - en standard elektronisk\nsignatur i samsvar med EU-forordning 910/2014 (eIDAS).',
  },

  SignicatRequestHeader: {
    en: 'Orgbrain Signing Request',
    nb: 'Orgbrain signering forespørsel.',
  },

  SignicatTaskTitle: {
    en: 'Orgbrain signing request',
    nb: 'Orgbrain signering forespørsel.',
  },

  SignicatTaskMessage: {
    en: 'Please sign this document',
    nb: 'Vennligst signer dette dokumentet',
  },
  NOLang: {
    en: 'Norwegian',
    nb: 'Norsk',
  },
  ENLang: {
    en: 'English',
    nb: 'Engelsk',
  },
  SELang: {
    en: 'Swedish',
    nb: 'Svensk',
  },
  INFORMATION: {
    en: 'Information',
    nb: 'Informasjon',
  },
  DISCUSSION: {
    en: 'Discussion',
    nb: 'Diskusjon',
  },
  DECISION: {
    en: 'Decision',
    nb: 'Beslutning',
  },
  AgendaItemFiles: { en: 'Show agenda item files', nb: 'Vis agendapunktets filer' },
  MeetingCommentsAndNotes: {
    en: 'Show meeting comments and personal notes',
    nb: 'Vis møtekommentarer og personlige notater',
  },
  ELECTION: {
    en: 'Election',
    nb: 'Personvalg',
  },
  FormalitiesTopic: {
    en: 'Formalities',
    nb: 'Formalia',
  },
  moveShares: {
    nb: 'Endre aksjeklasse',
    en: 'Change share class',
  },
  refreshShareNumbers: {
    nb: 'Regenerer aksjenummer',
    en: 'Regenerate sharenumbers',
  },
  refreshShareNumbersTooltip: {
    nb: 'Automatisk gi aksjene nye nummer basert på nåværende status i aksjeeierboken',
    en: 'Automatically assign new numbers to the shares based on the current status in the shareholder register.',
  },
  RefreshShareNumberEventAdded: {
    nb: 'Hendelsen regenerer aksjenummer har blitt opprettet.',
    en: 'The event regenerate sharenumbers has been created.',
  },
  ReportingTopic: {
    en: 'Reporting',
    nb: 'Rapportering',
  },
  Representative: {
    en: 'Representative',
    nb: 'Representant',
  },
  ShareholdersEvents: {
    en: 'shareholders',
    nb: 'aksjonærer',
  },
  ShareholderEvents: {
    en: 'shareholder',
    nb: 'aksjonær',
  },
  EconomyTopic: {
    en: 'Economy',
    nb: 'Økonomi',
  },
  toBuyer: {
    en: ' to ',
    nb: ' til ',
  },
  Timestamp: {
    en: 'Timestamp',
    nb: 'Tidspunkt',
  },

  PersonnelTopic: {
    en: 'Personnel',
    nb: 'Personale',
  },
  AppointmentsTopic: {
    en: 'Appointments',
    nb: 'Avtaler',
  },
  SupervisionTopic: {
    en: 'Supervision',
    nb: 'Tilsyn',
  },
  ShareholdersTopic: {
    en: 'Owners/Members',
    nb: 'Eiere/Medlemmer',
  },
  CEOTopic: {
    en: 'CEO',
    nb: 'Daglig leder',
  },
  StrategyTopic: {
    en: 'Strategy',
    nb: 'Strategi',
  },
  ProxyTopic: {
    en: 'Power of attorney',
    nb: 'Fullmakter',
  },
  StatutesTopic: {
    en: 'Statutes',
    nb: 'Vedtekter',
  },
  UseSuggestion: {
    en: 'Use suggestion',
    nb: 'Bruk forslag',
  },

  AddAgendaItem: {
    en: 'Add agenda item',
    nb: 'Legg til agendapunkt',
  },
  GenerateProtocolDialog: {
    en: 'Generate protocol',
    nb: 'Generer protokoll',
  },
  GenerateProtocolDialogText: {
    en: 'Change the settings for protocol generation',
    nb: 'Endre på innstillingen for protokollgenerering',
  },
  ShortProtocol: {
    en: 'Short protocol',
    nb: 'Kort protokoll',
  },
  ShortProtocolText: {
    en: 'A short and precise version of the protocol will be generated',
    nb: 'En kort og presis versjon av protokollen vil bli generert',
  },
  SuggestedAgendaItem: {
    en: 'Suggested agenda item',
    nb: 'Forslag til agendapunkt',
  },
  LongProtocol: {
    en: 'Long protocol',
    nb: 'Lang protokoll',
  },
  LongProtocolText: {
    en: 'A more extensive and detailed version of the protocol will be generated',
    nb: 'En en større og mer utfyllende versjon av protokollen vil bli generert',
  },
  PAUSE: {
    en: 'Pause',
    nb: 'Pause',
  },
  NO_CATEGORY: {
    en: 'No category',
    nb: 'Ingen kategori',
  },
  ALTERNATIVE_OPTIONS: {
    en: 'Alternative options',
    nb: 'Alternativvalg',
  },
  NoMeetingType: {
    en: 'Unmarked meetings',
    nb: 'Umarkerte møter',
  },

  InviteLink: {
    en: 'Invitation link',
    nb: 'Invitasjonskoblingen',
  },
  LinkDuration: {
    en: 'Duration for the invitation link',
    nb: 'Varighet for invitasjonskoblingen',
  },
  EmailMessage: {
    en: 'Email message',
    nb: 'E-postmelding',
  },

  NewMessageFrom: {
    en: 'New announcement from',
    nb: 'Ny kunngjøring fra',
  },
  HereLink: {
    en: 'here',
    nb: 'her',
  },
  'Email address update': {
    en: 'Email address update',
    nb: 'Oppdatering av e-postadresse',
  },
  'Please use the code below to confirm your new email address': {
    en: 'Please use the code below to confirm your new email address',
    nb: 'Vennligst bekreft din nye e-postadresse ved å benytte koden under',
  },
  resetPassword: {
    en: 'Reset password',
    nb: 'Tilbakestille passord',
  },
  addInvestorsFromSpreadsheet: {
    en: 'Add investors from spreadsheet',
    nb: 'Legg til investorer fra regneark',
  },
  Move_shares: {
    en: 'Change shareclass',
    nb: 'Endre aksjeklasse',
  },
  weReceivedRequest: {
    en: 'We have received a request to reset the password for',
    nb: 'Vi har mottatt en forespørsel om å tilbakestille passordet for',
  },
  pleaseUseLink: {
    en: 'Please use the following link',
    nb: 'Bruk følgende lenke',
  },
  HelloEmailText: {
    en: 'Hi',
    nb: 'Hei',
  },
  InvitedToSurveyText: {
    en: 'You have been invited to respond to a survey for {{ORG}}.',
    nb: 'Du er blitt invitert til å svare på en undersøkelse for {{ORG}}.',
  },
  ReminderForSigningRequest: {
    en: 'Reminder for signing request',
    nb: 'Påminnelse om signeringsforespørsel',
  },
  DontConfirm: {
    en: 'Skip',
    nb: 'Hopp over',
  },
  GaveActionPointResponsibility: {
    en: 'gave you a new task or question titled',
    nb: 'har tildelt deg, eller lagt til informasjon, i oppgaven',
  },
  Task: {
    en: 'Task',
    nb: 'Oppgave',
  },
  WithDeadline: {
    en: 'With deadline:',
    nb: 'Frist:',
  },
  ClickBelowTask: {
    en: 'Click the button below to view the task.',
    nb: 'Klikk på knappen under for å se oppgaven.',
  },
  HasSavedInformationTask: {
    en: 'has entered new information in the task',
    nb: 'har lagt inn ny informasjon i oppgaven',
  },
  GoToTask: {
    en: 'Go to Task',
    nb: 'Gå til oppgave',
  },

  SharesHaveBeenTransferredToYou: {
    en: 'Shares have been transferred to you',
    nb: 'Aksjer har blitt overført til deg',
  },
  MessageAboutTransferOfSharesIn: {
    nb: 'Melding om overføring av aksjer i',
    en: 'Message about transfer of shares in',
  },

  TheFollowingHasBeenRegisteredOn: {
    en: 'The following has been registered on ',
    nb: 'Følgende er blitt registrert på ',
  },
  InTheShareholderRegisterOf: {
    en: ' in the shareholder register of ',
    nb: ' i aksjeeierboken til ',
  },
  Recipient: {
    en: 'Recipient',
    nb: 'Mottaker',
  },
  BestRegards: {
    en: 'Best regards',
    nb: 'Vennlig hilsen',
  },
  Sender: {
    en: 'Sender',
    nb: 'Avsender',
  },
  Hi: {
    en: 'Hi',
    nb: 'Hei',
  },
  Time: {
    en: 'Time',
    nb: 'Tidspunkt',
  },
  NewInventory: {
    en: 'New inventory',
    nb: 'Ny beholdning',
  },
  ShareClass: {
    en: 'Share class',
    nb: 'Aksjeklasse',
  },
  Amount: {
    en: 'Amount',
    nb: 'Antall',
    sv: 'Antall',
  },
  SharesWithClass: {
    en: 'shares, with class',
    nb: 'aksjer, med aksjeklasse',
  },
  HasBeenRegisteredToYou: {
    en: 'has been registered on you in an share issue',
    nb: 'har blitt registrert på deg i en kapitalforhøyelse',
  },
  ShareWithClass: {
    en: 'share, with class',
    nb: 'aksje, med aksjeklasse',
  },
  OfYourSharesWithClass: {
    en: 'of your shares, with class',
    nb: 'av dine aksjer, med aksjeklasse',
  },
  in: {
    en: 'in',
    nb: 'i',
  },
  HasBeenTransferredToYouFrom: {
    en: 'has been transferred to you from',
    nb: 'har blitt overført til deg fra',
  },
  HasBeenTransferredTo: {
    en: 'has been transferred to',
    nb: 'har blitt overført til',
  },
  WeWantToInformYouThat: {
    en: 'We would like to inform you that',
    nb: 'Vi vil med dette opplyse deg at',
  },
  HasBeenRegisteredAsBeneficialOwner: {
    en: 'has been registered as a beneficial owner with',
    nb: 'er registrert som reell rettighetshaver hos',
  },
  HasDecided: {
    nb: 'har vedtatt å tildele',
    en: 'has decided to award',
  },
  AsFollows: {
    nb: 'som følger',
    en: 'as follows',
  },
  PayoutDate: {
    en: 'Payout date',
    nb: 'Utbetalingsdato',
  },
  PayoutPerShare: {
    en: 'Payout per share',
    nb: 'Utbetaling per aksje',
  },
  TotalPayout: {
    en: 'Total payout',
    nb: 'Total utbetaling',
  },
  TotalPaidOut: {
    en: 'Paid out total',
    nb: 'Utbetaling totalt',
  },
  PayoutAccount: {
    en: 'Payout account',
    nb: 'Utbetalingskonto',
  },
  HeadlineTransaction1: {
    en: 'Decision on award of',
    nb: 'Vedtak om tildeling av',
  },
  HeadlineTransaction2: {
    en: 'from',
    nb: 'fra',
  },
  Shareholderreciver: {
    en: 'Shareholder',
    nb: 'Aksjonær',
  },
  Shareownerreciver: {
    en: 'Shareowner',
    nb: 'Aksjeeier',
  },
  NumberOfNewShares: {
    en: 'New shares',
    nb: 'Nye aksjer',
  },
  NewShareholding: {
    en: 'New shareholding',
    nb: 'Ny beholdning',
  },
  AwardTime: {
    en: 'Award time',
    nb: 'Tidspunkt',
  },
  Regards: {
    en: 'Regards',
    nb: 'Hilsen',
  },
  CurrentMeetingRecording: {
    en: 'A user in the meeting has started a meeting recording.',
    nb: 'En bruker i møtet har startet et møteopptak.',
  },
  MeetingRecordingStartedHeader: {
    en: 'Meeting recording started',
    nb: 'Møteopptak startet',
  },

  numQuestionsTableHeader: {
    en: 'Questions asked',
    nb: 'Spørsmål stilt',
  },

  ShowNewAgendaItems: {
    en: 'Show suggestions for new agenda items',
    nb: 'Vis forslag til agendapunkter',
  },
  speakingTimePercentageTableHeader: {
    en: 'Speaking time percentage',
    nb: 'Taletidandel',
  },
  MeetingRecordingStartedText: {
    en: 'The meeting recording has started by a user.',
    nb: 'Møteopptaket har startet av en bruker.',
  },
  MeetingRecordingEndedHeader: {
    en: 'Meeting recording ended',
    nb: 'Møteopptak avsluttet',
  },
  MeetingRecordingEndedText: {
    en: 'The meeting recording has ended by a user.',
    nb: 'Møteopptaket er avsluttet av en bruker.',
  },
  MeetingRecording: {
    en: 'Meeting recording',
    nb: 'Møteopptak',
  },
  BankNrNotSet: {
    nb: 'OBS! Det ser ut som vi ikke har registrert hvilken bankkonto utbetalingen skal skje til. Vennligst ta kontakt med oss slik at vi kan få registrert dette.',
    en: 'OBS! It seems like we have not registered which bank account the payout should be made to. Please contact us so that we can register this.',
  },
  ByBeneficialOwnerMeaning: {
    en: 'The law defines a beneficial owner as a natural person or persons who ultimately owns or controls a legal person, event, entity or other association.',
    nb: 'Med reell rettighetshaver menes i loven den eller de fysiske personene som i siste instans eier eller kontrollerer en juridisk person, arrangement, enhet eller annen sammenslutning.',
  },
  YouHaveBeenRegisteredAsABeneficialOwner: {
    en: 'You have been registered as a beneficial owner',
    nb: 'Du har blitt registrert som reell rettighetshaver',
  },
  ReadMoreHere: {
    en: 'Read more',
    nb: 'Les mer',
  },
  InvitationToVoteForMeetingTime: {
    en: 'Invitation to find a meeting time',
    nb: 'Invitasjon til å finne møtetidspunkt',
  },
  Svarfrist: {
    en: 'Reply before',
    nb: 'Svarfrist',
  },
  VoteTimeButtonText: {
    en: 'Vote on time',
    nb: 'Stem på tidspunkt',
  },
  BodyTextEmailForMeetingTime: {
    en: 'You have been invited to provide input on a meeting time for a scheduled meeting {{meetingName}} in {{orgName}}. Press the button below to give your feedback.',
    nb: 'Du har blitt invitert til å gi innspill til møtetidspunkt for et planlagt møte {{meetingName}} i {{orgName}}. Trykk på knappen under for å gi din tilbakemelding.',
  },
  FindTimeEmailDescription: {
    en: 'Email text',
    nb: 'E-post tekst',
  },
  Transaction: {
    en: 'Transaction',
    nb: 'Transaksjon',
  },
  DeleteEvent: {
    en: 'Delete event',
    nb: 'Slett hendelse',
  },
  TransactionSeller: {
    en: 'Seller',
    nb: 'Selger',
  },
  TransactionBuyer: {
    en: 'Buyer',
    nb: 'Kjøper',
  },
  Price: {
    en: 'Price',
    nb: 'Pris',
    sv: 'Pris',
  },
  NumStocks: {
    en: 'Number of stocks',
    nb: 'Antall aksjer',
  },
  numSharesToBeSold: {
    en: 'Number of stocks to be sold',
    nb: 'Antall aksjer som skal selges',
  },
  pricePerShare: {
    en: 'Price per share',
    nb: 'Pris per aksje',
  },
  TotalPrice: {
    en: 'Total price',
    nb: 'Total pris',
  },
  EventsDeleteSubheader1: {
    en: 'This event will be deleted',
    nb: 'Denne hendelsen vil bli slettet',
  },
  TransferenceTo: {
    en: 'Transference to',
    nb: 'Overføring til',
  },
  TransferenceFrom: {
    en: 'Transference from',
    nb: 'Overføring fra',
  },
  TODO: {
    en: 'To-do',
    nb: 'Skal gjøres',
  },
  DOING: {
    en: 'Ongoing',
    nb: 'Pågår',
  },
  DONE: {
    en: 'Done',
    nb: 'Ferdig',
  },
  CRITICAL: {
    en: 'Critical',
    nb: 'Kritisk',
  },
  HIGH: {
    en: 'High',
    nb: 'Høy',
  },
  MEDIUM: {
    en: 'Medium',
    nb: 'Middels',
  },
  LOW: {
    en: 'Low',
    nb: 'Lav',
  },
  MAYBE: {
    en: 'No priority',
    nb: 'Ingen',
    sv: 'Ingen',
  },
  parValue: {
    en: 'Par value',
    nb: 'Pålydende',
    sv: 'Pålydande',
  },
  Options: {
    en: 'Options',
    nb: 'Alternativer',
    sv: 'Alternativ',
  },
  Instruction: {
    en: 'Instruction',
    nb: 'Instruksjon',
    sv: 'Instruktion',
  },
  CurrentProposedResolution: {
    en: 'Current proposed resolution',
    nb: 'Nåværende forslag til vedtak',
  },
  SuggestionsFromAI: {
    en: 'AI suggestion',
    nb: 'AI-forslag',
  },
  DeleteEntireTranscription: {
    en: 'Delete all',
    nb: 'Slett alt',
  },
  TranscriptionParts: {
    en: 'Transcription',
    nb: 'Transkripsjon',
  },
  MeetingNotes: {
    en: 'Meeting summary',
    nb: 'Møteoppsummering',
  },
  OverwriteMinutesSuggestion: {
    en: 'Overwrite',
    nb: 'Overskriv',
  },
  AppendMinutesSuggestion: {
    en: 'Use both',
    nb: 'Bruk begge',
  },
  UseMinutesSuggestion: {
    en: 'Use',
    nb: 'Bruk',
  },
  OverwriteProposedResolution: {
    en: 'Overwrite proposed resolution',
    nb: 'Overskriv forslag til vedtak',
  },
  AppendProposedResolution: {
    en: 'Append proposed resolution',
    nb: 'Legg til forslag til vedtak',
  },

  ProposedResolutionFromTranscription: {
    en: 'Proposed resolution from transcription',
    nb: 'Forslag til vedtak fra transkripsjon',
  },
  AttachmentTo: {
    en: 'Attachment to:',
    nb: 'Vedlegg til:',
  },
  MeetingBook: {
    en: 'Meeting book',
    nb: 'Møtebok',
  },
  sharedFolderTooltip: {
    en: 'A shared folder is a feature where you, as an administrator, can create a folder which can be shared. The folder can be shared with other organizations in the same corporate structure or with other organizations where you are the administrator. The organization that creates the folder is the owner and covers any storage and signing costs.',
    nb: 'Delt mappe er en funksjon der du som administrator kan opprette en mappe som kan deles med andre organisasjoner som er i samme konsernstruktur eller øvrige organisasjoner der du er administrator. Det er organisasjonen som oppretter mappen som er eier av mappen, og som dekker eventuelle kostnader ved lagring og signering.',
  },
  Tasks: {
    nb: 'Oppgaver',
    en: 'Tasks',
    SV: 'Uppgifter',
  },
  tasks: {
    nb: 'oppgaver',
    en: 'tasks',
  },
  TasksSelectDocumentType: {
    en: 'Download tasks',
    nb: 'Last ned oppgaver',
  },
  AnErrorOccured: {
    en: 'An error occurred',
    nb: 'Det oppstod en feil',
  },
  YourEntities: {
    nb: 'Eiere du representerer',
    en: 'Owners you represent',
  },
  YourProxies: {
    nb: 'Fullmakter du har',
    en: 'Powers of attorney you hold',
  },
  NewTask: {
    en: 'New task',
    nb: 'Ny oppgave',
  },
  DownloadTasks: {
    en: 'Download tasks',
    nb: 'Last ned oppgaver',
    sv: 'Ladda ner uppgifter',
  },
  TasksModuleHelper1: {
    nb: 'Her kan du lage oppgaver/aktiviteter med tidsfrist og prioritet som kan tildeles brukere i portalen. Du kan også opprette private oppgaver som kun du har tilgang til. For bedre prosjektstyring kan du registrere avhengigheter mellom oppgaver. Det er nyttig i tilfeller der en oppgave må fullføres (f.eks "Bygg grunnmur") før en annen ("Sett opp vegger") kan starte. En oppgave kan også settes opp til å bestå av flere underoppgaver. Det passer når alle underoppgavene må gjøres før oppgaven ferdigstilles.',
    en: 'Here you can create tasks/activities with deadlines and priorities that can be assigned to users in the portal. You can also create private tasks that only you have access to. For better project management, you can register dependencies between tasks. This is useful in cases where one task must be completed (e.g., "Build the foundation") before another ("Set up walls") can begin. A task can also be set up to consist of several subtasks. This is ideal when all subtasks need to be completed before the main task is finished.',
    sv: 'Här kan du skapa uppgifter/aktiviteter med tidsfrister och prioriteringar som kan tilldelas användare i portalen. Du kan också skapa privata uppgifter som endast du har tillgång till. För bättre projektledning kan du registrera beroenden mellan uppgifter. Det är användbart i fall där en uppgift måste slutföras (t.ex. "Bygg grunden") innan en annan ("Sätt upp väggarna") kan börja. En uppgift kan också ställas in för att bestå av flera underuppgifter. Det är lämpligt när alla underuppgifter måste slutföras innan huvuduppgiften är klar.',
  },
  Complete: {
    en: 'Complete',
    nb: 'Fullfør',
    sv: 'Fullborda',
  },
  TasksModuleHelper2: {
    nb: 'Du kan velge mellom listevisning eller diagramvisning for å organisere oppgavene. I Gantt-diagrammet kan du enkelt flytte oppgaver og justere tidsplanen visuelt. I tillegg kan du starte en dialog med brukere som har tilgang til en oppgave, noe som gjør det enkelt å samarbeide og dele oppdateringer direkte i systemet.',
    en: 'You can choose between a list view or a diagram view to organize the tasks. In the Gantt chart, you can easily move tasks and adjust the schedule visually. Additionally, you can start a dialogue with users who have access to a task, making it easy to collaborate and share updates directly in the system.',
    sv: 'Du kan välja mellan listvy eller diagramvy för att organisera dina uppgifter. I Gantt-diagrammet kan du enkelt flytta uppgifter och justera schemat visuellt. Dessutom kan du starta en dialog med användare som har tillgång till en uppgift, vilket gör det enkelt att samarbeta och dela uppdateringar direkt i systemet.',
  },
  MeetingsAndTasks: {
    en: 'Meetings and tasks',
    nb: 'Møter og oppgaver',
  },
  Meetings: {
    en: 'Meetings',
    nb: 'Møter',
  },
  CircularDependency: {
    en: 'This task can not be linked with the selected task',
    nb: 'Denne oppgaven kan ikke bli koblet sammen med den valgte oppgaven',
  },
  IncompleteTasks: {
    en: 'Incomplete tasks',
    nb: 'Uferdige oppgaver',
  },
  CompletedTasks: {
    en: 'Completed tasks',
    nb: 'Fullførte oppgaver',
  },
  MyIncompleteTasks: {
    en: 'My incomplete tasks',
    nb: 'Mine uferdige oppgaver',
  },
  MyCompletedTasks: {
    en: 'My completed tasks',
    nb: 'Mine fullførte oppgaver',
  },
  AllTasks: {
    en: 'All',
    nb: 'Alle',
    sv: 'Alla',
  },
  SearchTasks: {
    en: 'Search',
    nb: 'Søk',
  },
  ListViewTasks: {
    en: 'List view',
    nb: 'Listevisning',
  },
  DiagramViewTasks: {
    en: 'Chart view',
    nb: 'Diagramvisning',
  },
  StatusTasks: {
    en: 'Status',
    nb: 'Status',
    sv: 'Status',
  },
  'shareholders.Status': {
    en: 'Status',
    nb: 'Status',
  },
  'meetings.whichCandidatesAreXShareOwnersVotingFor_voteAdministrationText1': {
    en: 'Which candidates ',
    nb: 'Hvilke kandidater ',
  },
  'meetings.whichCandidatesAreXShareOwnersVotingFor_voteAdministrationText2': {
    en: 'voting for?',
    nb: 'stemmer for?',
  },
  PriorityTasks: {
    en: 'Priority',
    nb: 'Prioritet',
  },
  TitleTasks: {
    en: 'Title',
    nb: 'Tittel',
  },
  ResponsibleTasks: {
    en: 'Responsible',
    nb: 'Ansvarlig',
  },
  CreateMinuteCase: {
    nb: 'Lag nytt agendapunkt',
    en: 'Create agenda item',
  },

  CreateMinuteCaseModuleLabel: {
    nb: 'Lag nytt agendapunkt',
    en: 'Create agenda item',
  },
  CreateNews: {
    en: 'Create announcement',
    nb: 'Lag ny kunngjøring',
  },
  CreateNewsModuleLabel: {
    en: 'Create new announcement',
    nb: 'Lag ny kunngjøring',
  },
  EditNews: {
    en: 'Edit announcement',
    nb: 'Rediger kunngjøring',
  },
  GenericCallError: {
    en: 'An error occurred. Please try again later.',
    nb: 'Det oppstod en feil. Vennligst prøv igjen senere.',
  },
  MeetingRecordingTitle: {
    en: 'Transcription',
    nb: 'Transkripsjon',
  },
  UseAllSuggestions: {
    en: 'Use all suggestions and save',
    nb: 'Bruk alle forslag og lagre',
  },
  ProtocolFromTranscription: {
    en: 'Protocol suggestion from Transcription',
    nb: 'Protokollforslag fra transkripsjon',
  },
  CurrentProtocol: {
    en: 'Current protocol',
    nb: 'Nåværende protokoll',
  },
  ShortMinutesSuggestion: {
    en: 'Short suggestion',
    nb: 'Kort forslag',
  },
  NoDataToSendToAltinn: {
    en: 'No data to send to Altinn',
    nb: 'Ingen data til å sende til Altinn',
  },
  SystemNotVerified: {
    en: 'System not verified, try again',
    nb: 'System ikke verifisert, prøv igjen',
  },
  AIMinutesSuggestionPossible: {
    en: 'This agenda item has a minutes suggestion generated by Meeting-AI.',
    nb: 'Dette agendapunktet har et forslag til protokoll generert av Møte-AI.',
  },
  LongMinutesSuggestion: {
    en: 'Long suggestion',
    nb: 'Langt forslag',
  },
  MeetingReportTitle: {
    en: 'Meeting Report',
    nb: 'Møtereferat',
  },
  MinutesPartsText: {
    en: 'Meeting parts',
    nb: 'Møteemner',
  },
  MeetingReportDescription: {
    nb: 'Møtereferatet er en forkortet og formalisert versjon av transkripsjonen.',
    en: 'The meeting report is a shortened and formalized version of the transcription.',
  },
  userTableHeader: { nb: 'Deltager', en: 'Participant' },
  speakingTimeTableHeader: { nb: 'Total taletid', en: 'Speaking Time' },
  longestSpeechDurationTableHeader: { nb: 'Lengste innlegg', en: 'Longest Speech Duration' },
  noTasksTableHeader: { nb: 'Oppgaver', en: 'Tasks' },
  timesSpokenTableHeader: { nb: 'Antall innlegg', en: 'Times Spoken' },
  MeetingRecordingDescription: {
    en: 'You can edit any mistakes in the transcription here. The transcription serves as the basis for Meeting Statistics and Minutes.',
    nb: 'Du kan rette eventuelle feil i transkripsjonen her. Transkripsjonen danner utgangspunkt for Møtestatistikk og Protokoll.',
  },

  MeetingPolishedLanguageDescription: {
    en: 'This page shows the transcription after it has been polished by AI, you can still edit the text and listen to the recording.',
    nb: 'Denne siden viser transkripsjonen som er språkvasket av AI, du kan fortsatt redigere teksten og lytte til opptaket.',
  },
  ExecutiveSummary: {
    en: 'Executive summary',
    nb: 'Sammendrag',
  },
  MeetingMinutesTitle: {
    en: 'Meeting Minutes',
    nb: 'Møteprotokoll',
  },
  MeetingMinutesDescription: {
    en: 'The meeting minutes provide a summary of the discussion and decisions made during the meeting.',
    nb: 'Møteprotokollen gir et sammendrag av diskusjonen og beslutningene som ble tatt under møtet.',
  },
  TRANSCRIPTION_PAGE: {
    nb: 'Transkripsjon',
    en: 'Transcription',
  },
  POLISH_PAGE: {
    nb: 'Språkvask',
    en: 'Language Polishing',
  },
  MEETING_NOTES_PAGE: {
    nb: 'Referat',
    en: 'Meeting Notes',
  },
  STATISTICS_PAGE: {
    nb: 'Analyse',
    en: 'Analysis',
  },
  MINUTES_PAGE: {
    nb: 'Protokoll',
    en: 'Minutes',
  },
  ExtraResponsibleTasks: {
    en: 'Extra responsible',
    nb: 'Andre ansvarlige',
  },
  DeadlineTasks: {
    en: 'Deadline',
    nb: 'Frist',
  },
  LinkCopiedText: {
    en: 'The link is now ready to be pasted and shared with others who have portal access.',
    nb: 'Lenken er nå klar for å limes inn og deles med andre med portaltilgang.',
  },
  TaskLinkTooltip: {
    en: 'Copy the task link to the clipboard.',
    nb: 'Kopier oppgavelenken til utklippstavlen.',
  },
  EditTask: {
    en: 'Edit',
    nb: 'Rediger',
    sv: 'Redigera',
  },
  Delete: {
    en: 'Delete',
    nb: 'Slett',
    sv: 'Sletta',
  },
  LabelTooltip: {
    en: 'Add and create labels to be able to sort and seperate tasks',
    nb: 'Legg til og opprett merkelapper for å kunne sortere og gjenkjenne oppgaver',
  },
  FindTime: {
    en: 'Find time',
    nb: 'Finn tid',
  },
  MeetingRecordings: {
    en: 'Meeting AI',
    nb: 'Møte-AI',
  },
  SearchInMessages: {
    en: 'Search in messages',
    nb: 'Søk i meldinger',
  },
  ConversationSettings: {
    en: 'Conversation settings',
    nb: 'Samtaleinnstillinger',
  },
  TranscriptStatusTranscription: {
    en: 'Transcription',
    nb: 'Transkripsjon',
  },
  TranscriptStatusSummary: {
    en: 'Summary',
    nb: 'Sammendrag',
  },
  TranscriptStatusRecording: {
    en: 'Recording',
    nb: 'Opptak',
  },
  OpenTranscription: {
    en: 'Open',
    nb: 'Åpne',
  },
  SelectTasks: {
    en: 'Select tasks',
    nb: 'Velg oppgaver',
  },
  SelectTask: {
    en: 'Select task',
    nb: 'Velg oppgave',
  },
  SubTask: {
    en: 'Subtasks',
    nb: 'Underoppgaver',
  },
  SubTaskTooltip: {
    en: 'Add and create subtasks for this task',
    nb: 'Legg til og opprett underoppgaver for denne oppgaven',
  },
  DependentOnThis: {
    en: 'Tasks that are dependent on this',
    nb: 'Oppgaver som er avhengig av denne',
  },

  CreateDependentTask: {
    en: 'Create dependent task',
    nb: 'Opprett avhengig oppgave',
  },
  CreateDependentTaskTooltip: {
    en: 'Create a new task and automatically set it as dependant on this task.',
    nb: 'Opprett en ny oppgave og automatisk gjør den avhengig av denne oppgaven.',
  },
  AddDependentTask: {
    en: 'Add dependent task',
    nb: 'Legg til avhengig oppgave',
  },
  AddDependentTaskTooltip: {
    en: 'Make an existing task dependent on this task.',
    nb: 'Gjør en eksisterende oppgave avhengig av denne oppgaven.',
  },
  CreateSubtask: {
    en: 'Create subtask',
    nb: 'Opprett underoppgave',
  },
  CreateSubtaskTooltip: {
    en: 'Create a new task and automatically set it as a subtask for this task.',
    nb: 'Opprett en ny oppgave og automatisk legg den til som underoppgave på denne oppgaven.',
  },
  AddSubtask: {
    en: 'Add subtask',
    nb: 'Legg til underoppgave',
  },
  AddSubtaskTooltip: {
    en: 'Add an existing task as a subtask for this task.',
    nb: 'Legg til en eksisterende oppgave som underoppgave på denne oppgaven.',
  },
  'Org.nr': {
    en: 'Org.nr',
    nb: 'Org.nr',
  },
  EditUser: {
    en: 'Edit user',
    nb: 'Rediger bruker',
  },
  YouHaveNotBeenInvitedToAnySurvey: {
    en: 'You have no unanswered surveys',
    nb: 'Du har ingen ubesvarte undersøkelser',
  },
  NoSurveysStarted: {
    en: 'There are outstanding surveys',
    nb: 'Det er ingen utsendte undersøkelser',
  },
  NoSignaturesHelpText: {
    en: 'There are currently no signing tasks created.',
    nb: 'Det er foreløpig ikke opprettet noen signeringsoppgaver.',
  },
  TransfereUser: {
    en: 'Transfere user',
    nb: 'Overfør bruker',
  },
  DeleteContent: {
    en: 'Delete content',
    nb: 'Slett innhold',
  },
  PleaseConfirmPermanentDelete: {
    en: 'You are about to delete chosen content permanently. this action cannot be undone. Do you wish to delete permanently?',
    nb: 'Du er i ferd med å slette valgte innhold permanent. Dette kan ikke angres. Ønsker du å slette permanent?',
  },

  Menu: {
    en: 'Menu',
    nb: 'Meny',
  },
  rolesText: {
    en: 'Roles',
    nb: 'Roller',
  },
  OrgOrgbrainWatermarkinginfo: {
    en: 'Administrators can set settings to include a watermark on documents downloaded from the portal. This makes it easier to trace documents that have been downloaded to the person who performed the download.',
    nb: 'Endre på hvordan ulike tilganger påvirker hvordan du kan samhandle og laste ned dokumenter i portalen',
  },
  OrgEditUserInfoBox: {
    en: 'The administrator can assign and revoke access to the portal. The role(s) the users are assigned determines what they have access to. When inviting new users, make sure that the "Send invitation by email" box is checked, ensuring the new user receives the message. If you forget to do this, simply check the "Send invitation by email" box and save, and the recipient will receive an email. In the email sent, the individual will be asked to register their personal user account.',
    nb: 'Her kan administrator tildele og fjerne tilganger til portalen. Rollen(e) brukerne blir tildelt bestemmer hva de får tilgang til. Ved invitasjon av nye brukere, pass på å at feltet “Send invitasjon på e-post” er fylt ut slik at den nye brukeren mottar meldingen. Dersom du glemmer dette, er det bare å krysse av “Send invitasjon på e-post” og så lagre, da vil mottakeren motta e-post. I e-posten som sendes vil vedkommende bli bedt om å registrere sin personlige brukerkonto.',
  },
  ResendSendEmail: {
    en: 'Resend email',
    nb: 'Send E-post på nytt',
  },
  userIdentityRequirementsHelp1: {
    en: 'Manual verification should be conducted before adding a new user, to ensure good user control within the portal. The users themselves must have control and access to the email with which they are invited.',
    nb: 'For å ha god kontroll på brukere som inviteres inn i portalen, bør det gjennomføres manuell kontroll før ny bruker leggs til. Portalen krever minimum at brukeren må ha kontroll på e-postadressen som de inviteres inn med.',
  },
  userIdentityRequirementsHelp2: {
    en: 'If the organization desires increased control, they can require that all users must further confirm their identity using one of the methods outlined, or else the user will be denied access to the organization. It is possible to choose both methods, but the user only needs to confirm their identity once. An administrator can override an identification by verifying the user manually.',
    nb: 'Dersom organisasjonen ønsker økt kontroll, kan det legges inn et krav om at alle brukerne må bekrefte sin identitet ytterligere med en av metodene som er angitt her, ellers blir brukeren nektet tilgang til organisasjonen. Det er mulig å velge begge metodene, men brukeren trenger kun å bekrefte sin identitet én gang. Det er mulig for en administrator å overstyre en identifisering ved å verifisere brukeren manuelt.',
  },
  userIdentityRequirementsHelp3: {
    en: 'Note: The organization will be billed NOK 5 per user who confirms their identity. See the terms of use for more information.',
    nb: 'NB: Organisasjonen faktureres kr 5 pr. bruker som bekrefter identiteten. Se brukervilkårene for ytterligere opplysninger.',
  },
  ImportOrganizationInfo: {
    en: 'Import from Brønnøysund',
    nb: 'Import fra Brønnøysund',
  },
  AskForAssistance: {
    en: 'Expert assistance',
    nb: 'Få eksperthjelp',
  },
  //I would like to be contacted by phone
  IWouldLikeToBeContactedAtPhone: {
    en: 'I would like to be contacted by phone',
    nb: 'Jeg ønsker å bli kontaktet på telefon',
  },
  EraseTooltip: {
    en: 'Erase drawings',
    nb: 'Viske ut tegninger',
  },
  CommentAndDrawTooltip: {
    en: 'Draw with note',
    nb: 'Tegne med notat',
  },
  DrawTooltip: {
    en: 'Draw freely',
    nb: 'Tegne fritt',
  },
  NoteTooltip: {
    en: 'Write a note',
    nb: 'Skriv notat',
  },
  askForAssistanceButton: {
    en: 'Get expert assistance',
    nb: 'Be om bistand',
  },
  CanAlsoContactOnEmail: {
    en: 'You can also reach us by email: support@orgbrain.no',
    nb: 'Du kan også nå oss på e-post: support@orgbrain.no',
  },
  SupportRequestFrom: {
    en: 'Support request from',
    nb: 'Forespørsel fra',
  },
  HasRequestedAssistanceOnPhone: {
    // has requested assistance. Contact the the user on
    en: 'has requested assistance. Contact the the user on phone',
    nb: 'har bedt om konsulentbistand. Kontakt brukeren på telefon',
  },
  GetAssistanceText1: {
    en: 'Are your days busy?',
    nb: 'Har du travle dager?',
  },
  GetAssistanceText2: {
    en: 'Get help with performing your tasks in the portal from a consultant who is an expert on the',
    nb: 'Få hjelp med utføre dine oppgaver i portalen av en konsulent som er ekspert på',
  },
  GetAssistanceText3: {
    nb: 'programvaren.',
    en: 'software.',
  },
  GetAssistanceText4: {
    nb: 'Pris: kr 400 for hvert påbegynt kvarter',
    en: 'Price: kr 400 for each commenced quarter',
  },

  GetAssistanceTooltip: {
    en: 'Are your days busy? Get help with performing your tasks in the portal from a consultant who is an expert on the software.',
    nb: 'Har du travle dager? Få hjelp med utføre dine oppgaver i portalen av en konsulent som er ekspert på programvaren.',
    sv: 'Har du fullt upp? Få hjälp med att utföra dina uppgifter i portalen av en konsult som är expert på programvaran.',
  },
  Parvalue: {
    en: 'Par value',
    nb: 'Pålydende',
    sv: 'Pålydande',
  },
  NewUser: {
    en: 'New user',
    nb: 'Ny bruker',
    sv: 'Ny användare',
  },
  Rights: {
    en: 'Rights',
    nb: 'Rettigheter',
    sv: 'Rättigheter',
  },
  Access: {
    en: 'Access',
    nb: 'Tilgang',
  },

  General: {
    en: 'General settings',
    nb: 'Generelle innstillinger',
  },
  GeneralOrganizationSettings: {
    en: 'General settings for the organization',
    nb: 'Generelle innstillinger for organisasjonen',
  },
  OrganizationLanguage: {
    en: 'Organization language',
    nb: 'Organisasjonsspråk',
  },
  JurisdictionText: {
    en: 'The jurisdiction of the organization',
    nb: 'Organisasjonens jurisdiksjon',
  },

  CouldNotDelete: {
    nb: 'Kunne ikke slettes',
    en: 'Could not delete',
  },
  Jurisdiction: {
    en: 'Jurisdiction',
    nb: 'Jurisdiksjon',
  },
  TimeSpentOnAgendaItems: {
    en: 'Time spent on agenda items',
    nb: 'Tid brukt per agendapunkt',
  },
  MeetingHighlights: {
    en: 'Meeting highlights',
    nb: 'Nøkkelpunkter fra møtet',
  },
  RemoveSuggestion: {
    en: 'Restore original text',
    nb: 'Gjenopprett originaltekst',
  },
  'Settings.ProtocolSigningSettings': {
    en: 'Minutes signing',
    nb: 'Signering av protokoll',
  },
  'Settings.ProtocolSigningSettingsText': {
    en: 'Here you can change settings related to minutes signing.',
    nb: 'Velg hvem som skal signere at protokollen fra styremøtet er lest.',
  },
  'Settings.CEO': {
    en: 'CEO',
    nb: 'Daglig leder',
  },
  'Settings.ProtocolSettings': {
    en: 'Protocol presentation',
    nb: 'Protokollvisning',
  },
  'Settings.ProtocolSettingsText': {
    nb: 'Her kan du endre innstillinger relatert til protokoll.',
    en: 'Here you can change settings related to protocol.',
  },
  TIME_DISPLAY_IN_MINUTES: {
    en: 'Time display in the minutes',
    nb: 'Visning av tid i protokollene',
  },
  'Settings.General': {
    nb: 'Generelle innstillinger',
    en: 'General settings',
  },
  'Settings.GeneralText': {
    nb: 'Her kan du endre på generelle innstillinger for organisasjonen.',
    en: 'Here you can change general settings for the organization.',
  },
  MeetingAIAdvertisementTitle: {
    en: 'Auto generated minute notes?',
    nb: 'Automatisk protokoll?',
  },
  MeetingAIAdvertisementText: {
    en: 'Do you want to get automatic meeting notes and minutes after the meeting? Click on the "Meeting AI" tab to read more and try it for free.',
    nb: 'Ønsker du å få automatisk generert referat og protokoll etter møtet? Klikk på fanen "Møte-AI" for å lese mer og prøve det gratis.',
  },
  'Settings.Ai': {
    nb: 'AI-hjelper',
    en: 'AI assistant',
  },
  'Settings.AiText': {
    nb: 'Skru på kunstig intelligens (KI/AI) i portalen for å forenkle arbeidet ditt. Data behandles sikkert og i tråd med GDPR-regler.',
    en: 'Turn on artificial intelligence (AI) in the portal to streamline your work. Data is processed securely and in accordance with GDPR regulations.',
  },
  'Settings.DeputiesWhoAttended': {
    nb: 'Varamedlemmer som deltok i møtet',
    en: 'Deputies who attended the meeting',
  },
  'Settings.BMWhoDidNotAttend': {
    en: 'who did not attend the meeting',
    nb: 'som ikke deltok i møtet',
  },
  'Settings.ObserversWhoAttended': {
    nb: 'Observatører som deltok i møtet',
    en: 'Observers who attended the meeting',
  },
  'Settings.hideSigningTextForRoles': {
    nb: 'Utelat tekst fra protokollen',
    en: 'Exclude text from the minutes',
  },
  'Settings.hideSigningTextForRolesText': {
    nb: '"Følgende skal signere at protokollen er lest:" blir utelatt fra protokoll. (OBS: Dette øker potensielt ansvaret for de som signerer.)',
    en: '"The following shall sign that the minutes have been read:" blir utelatt fra protokoll. (NOTE: This potentially increases the responsibility for those who sign.)',
  },
  'Settings.Meeting': {
    nb: 'Møteinstillinger',
    en: 'Meeting settings',
  },
  'Settings.MeetingText': {
    nb: 'Her kan du endre innstillinger relatert til møter.',
    en: 'Here you can change settings related to meetings.',
  },
  'Settings.AgendaNumbersBoardmeeting': {
    nb: 'Agenda nummerering for styremøter',
    en: 'Agenda numbering for board meetings',
  },
  'Settings.AgendaNumbersBoardmeetingText': {
    nb: 'Ønsket format på nummerering av agendapunkter.',
    en: 'Desired format for numbering agenda items.',
  },
  'Settings.AgendaNumbersGeneralAssembly': {
    nb: 'Agenda nummerering for generalforsamlinger',
    en: 'Agenda numbering for general assemblies',
  },
  'Settings.AgendaNumbersGeneralAssemblyText': {
    nb: 'Ønsket format på nummerering av agendapunkter.',
    en: 'Desired format for numbering agenda items.',
  },
  'Settings.AgendaNumbersShareholderMeeting': {
    nb: 'Agenda nummerering for aksjonærmøter',
    en: 'Agenda numbering for shareholder meetings',
  },
  'Settings.AgendaNumbersShareholderMeetingText': {
    nb: 'Ønsket format på nummerering av agendapunkter.',
    en: 'Desired format for numbering agenda items.',
  },
  'Settings.AgendaNumbersMeeting': {
    nb: 'Agenda nummerering for møter',
    en: 'Agenda numbering for meetings',
  },
  'Settings.AgendaNumbersMeetingText': {
    nb: 'Ønsket format på nummerering av agendapunkter.',
    en: 'Desired format for numbering agenda items.',
  },
  'Settings.Poll': {
    nb: 'Standard stemme',
    en: 'Default vote',
  },
  'Settings.PollText': {
    nb: 'Velg hva som skal ligge inne som standard når styremedlemmer skal stemme på en sak.',
    en: 'Select what should be included as default when board members vote on a case.',
  },
  'Settings.TimeDisplay': {
    nb: 'Visning av tid',
    en: 'Time display',
  },
  'Settings.TimeDisplayText': {
    nb: 'Vis varighet eller starttid på agendapunkt. Forutsetter at det er lagt inn varighet for alle foregående agendapunkter.',
    en: 'Show duration or start time on agenda item. Requires that duration is set for all preceding agenda items.',
  },
  'Settings.AgendaItemResponsible': {
    nb: 'Saksansvarlig på styremøter',
    en: 'Responsible for agenda items in board meetings',
  },
  'Settings.AgendaItemResponsibleText': {
    nb: 'Hvert agendapunkt får et eget felt som angir saksansvarlig.',
    en: 'Each agenda item gets its own field indicating the responsible person.',
  },
  'Settings.SpeakerList': {
    nb: 'Talerliste',
    en: 'Speaker list',
  },
  'Settings.SpeakerListText': {
    nb: 'Administrator kan legge til talerliste på generalforsamlinger/årsmøter.',
    en: 'Administrator can add speaker list to general assemblies/annual meetings.',
  },
  'Settings.ShowProcedureType': {
    nb: 'Vis sakstype i PDF-protokoll',
    en: 'Show procedure type in PDF protocol',
  },
  'Settings.ShowProcedureTypeText': {
    nb: 'La sakskategori (Informasjon, Beslutning osv.) vises i PDF-protokollen.',
    en: 'Let the case category (Information, Decision, etc.) be displayed in the PDF protocol.',
  },
  'Settings.whichOrgsAllowedToConnect': {
    nb: 'Organisasjoner som kan legge til i grupper',
    en: 'Organizations that can add to groups',
  },
  ConsolidatedMinutes: {
    nb: 'Konsernprotokoll',
    en: 'Group minutes',
  },
  'HelpTextCM.ConsolidatedMinutes': {
    nb: 'Denne organisasjonen har aktivert muligheten for å generere protokoll på tvers av konsern. Du har tre valg for hvordan protokollen skal lages.',
    en: 'This organization has enabled the ability to generate protocols across the group. You have three choices for how the protocol should be created.',
  },
  'HelpTextCM.ConsolidatedMinutes2': {
    nb: 'Du kan når som helst endre valget ved å velge en ny type og generere et nytt utkast. Forrige protokoll blir da overskrevet. Protokollen lagres automatisk i seksjonen "Møtefiler" i datarommet til hvert selskap.',
    en: 'You can change your selection at any time by selecting a new type and generating a new draft. The previous minutes will then be overwritten. The minutes will be automatically saved in the "Meeting Files" section of each company\'s data room.',
  },
  'Settings.connectionListSettings': {
    nb: 'Som enterprise-kunde kan du sette opp en gruppe selskaper du har administratorrettigheter til, som skal dele felles møteprotokoll. Når denne gruppen er opprettet, vil den vises som et valg i protokollseksjonen på møtekortet.',
    en: 'As an enterprise customer, you can set up a group of companies for which you have admin rights to share common meeting minutes. Once this group is created, it will appear as a selection in the minutes section of the meeting card.',
  },
  'Settings.addGroup': {
    nb: 'Legg til gruppe',
    en: 'Add group',
  },
  'Settings.removeGroup': {
    nb: 'Fjern gruppe',
    en: 'Remove group',
  },
  'Settings.AgendaComments': {
    nb: 'Kommentarer på agendapunkt',
    en: 'Comments on agenda item',
  },
  'Settings.AgendaCommentsText': {
    nb: 'Alle møtedeltakere kan legge til kommentarer på agendapunkter.',
    en: 'All meeting participants can add comments on agenda items.',
  },
  'Settings.AgendaItemsLogs': {
    nb: 'Agendapunkterlogger',
    en: 'Agenda item log',
  },
  'Settings.AgendaItemsLogsText': {
    nb: 'Se logg over endringer på agendapunkter i 3-prikkmenyen øverst på møtekortet.',
    en: 'See log of changes to agenda items in the 3-dot menu at the top of the meeting card.',
  },
  'Settings.ShowVoteResult': {
    nb: 'Vis møtedeltakers stemmer',
    en: 'Show meeting participants votes',
  },
  'Settings.ShowVoteResultText': {
    nb: 'Tillat administrator å se hva deltakerne stemmer på generalforsamlinger/årsmøter.',
    en: 'Allow administrator to see what participants vote on general assemblies/annual meetings.',
  },
  'Settings.EngagementTracker': {
    nb: 'Vis forberedelsemåler',
    en: 'Show engagement tracker',
  },
  'Settings.EngagementTrackerText': {
    nb: 'Administrator kan under “Deltakere” se hvor godt deltakerne har forberedt seg, basert på hvor mange agendapunkter og vedlegg de har åpnet.',
    en: 'Administrator can see how well participants have prepared themselves under "Participants", based on how many agenda items and attachments they have opened.',
  },
  'Settings.NoVotesTableInPDF': {
    nb: 'Fjern stemmetabell i PDF',
    en: 'Remove votes table in PDF',
  },
  'Settings.NoVotesTableInPDFText': {
    nb: 'Fjern tabellen over avstamningsresultater i PDF-Protokollen.',
    en: 'Remove votes table in PDF Protocol.',
  },
  'Settings.DetailedVotesDistribution': {
    nb: 'Detaljert stemmefordeling',
    en: 'Detailed votes distribution',
  },
  'Settings.DetailedVotesDistributionText': {
    nb: 'Gir foretak med flere aksjeklasser en detaljert oversikt over fremmøte og stemmefordelingen basert på aksjeklasse.',
    en: 'Provides companies with multiple share classes a detailed overview of attendance and vote distribution based on share class.',
  },
  'Settings.OrgbrainAccess': {
    nb: 'Supporttilgang',
    en: 'Support access',
  },
  'Settings.OrgbrainAccessText': {
    nb: 'Gir Orgbrain full administratortilgang for å bistå med det du har bedt om hjelp til.',
    en: 'Gives Orgbrain full administrator access to assist with what you have requested help with.',
  },
  'Settings.Support': {
    nb: 'Gi Orgbrain supporttilgang',
    en: 'Give Orgbrain support access',
  },
  'Settings.SupportText': {
    nb: 'Gi Orgbrain tillatelse til å logge inn som supportbruker i portalen.',
    en: 'Give Orgbrain permission to log in as a support user in the portal.',
  },

  NOLanguageKey: {
    nb: 'Norsk',
    en: 'Norwegian',
  },
  ENLanguageKey: {
    nb: 'Engelsk',
    en: 'English',
  },
  ItIsNotPossibleToDeleteAllAdmins: {
    nb: 'Det er ikke mulig å slette alle med administratorrettigheter fra en undergruppe. Dersom du ønsker å slette undergruppen, ta kontakt med Orgbrain på support@orgbrain.no',
    en: 'It is not possible to delete all administrators from a subgroup. If you want to delete the subgroup, contact Orgbrain at support@orgbrain.no',
  },
  NewSubGroupCreated: {
    nb: 'Ny gruppe er opprettet',
    en: 'New subgroup created',
  },
  YouCanFindTheNewSubgroup: {
    nb: 'Den nye gruppen finner du som en underenhet til din organisasjon. Du kan gå til den ved å klikke på nedtrekksmenyen for organisasjoner øverst til høyre i portalen.',
    en: 'The new subgroup is found as a subunit to your organization. You can go to it by clicking on the drop-down menu for organizations at the top right of the portal.',
  },
  ChangesToPremissionsDiffersFromParent: {
    en: 'Changes have been made. There are now <b>deviations</b> in access from the folder above',
    nb: 'Det er foretatt endringer. Det er nå <b>avvik</b> i tilgang fra mappen over',
  },
  AccessControlWarningContainer: {
    en: 'Users marked in red have been given access to this level without having access to the level above. You must also grant access to the folders above for the access to take effect.',
    nb: 'Brukere som er merket rødt, er blitt gitt tilgang til dette nivået uten å ha fått tilgang til nivået over. Du må også gi tilgang på mappene over for at tilgangen skal ha effekt.',
  },
  CreateQuestionnaire: {
    en: 'Create a New Survey',
    nb: 'Opprett spørreskjema',
  },
  ExtraContacts: {
    en: 'Extra contacts: ',
    nb: 'Ekstra kontakter: ',
  },
  ExtraContactsHelpText: {
    en: 'Must be filled inn with yes to signal that the contact is an extra contact for the row above it. It is possible to have more than one extra contact for the same row, by filling in yes for each row above it will connect to the first with nothing.',
    nb: 'Må fylles inn med ja for å signalisere at kontakten er en ekstra kontakt for raden over. Det er mulig å ha flere ekstra kontakter for samme rad, ved å fylle inn ja for hver rad over vil den koble seg til den første med ingenting.',
  },
  DateSent: {
    en: 'Date sent',
    nb: 'Sendt dato',
  },
  Contract: {
    en: 'Contract',
    nb: 'Kontrakt',
  },
  dueDiligenceInfoBox: {
    en: 'Here you have the opportunity to limit which users should have access to the content of folders and files. Access you set here will be reused in all subfolders. You also have the opportunity to limit access further to fewer users in subfolders.',
    nb: 'Her har du mulighet til å avgrense hvilke brukere som skal ha tilgang til innholdet i mapper og filer. Tilganger du setter her vil gjenbrukes i alle underliggende mapper. Du har også mulighet til å avgrense tilgangen ytterligere til færre brukere i underliggende mapper.',
  },
  SendPaymentInformation: {
    en: 'Send payment information',
    nb: 'Send betalingsinformasjon',
  },
  SendPaymentInformationSubtitle: {
    en: 'The message will only be sent to recipients who have been assigned shares.',
    nb: 'Meldingen sendes kun til mottakere som har fått tildelt aksjer.',
  },
  EmissionInviteInvestors: {
    en: 'Invite investors',
    nb: 'Inviter investorer',
  },
  SubmitAndSendEmail: {
    en: 'Submit and send email',
    nb: 'Gjennomfør og send e-post',
  },
  SubmitAndSendEmailTooltipDividend: {
    en: 'Here you can complete the assignment and choose who should receive notification of the assignment by e-mail.',
    nb: 'Her kan du gjennomføre tildelingen og velge hvem som skal motta melding om tildelingen på e-post.',
  },
  SendMessage: {
    en: 'Send message',
    nb: 'Send melding',
  },
  Address: {
    en: 'Address',
    nb: 'Adresse',
  },

  VpsNumber: {
    en: 'VPS number',
    nb: 'VPS-nummer',
  },
  LeiNumber: {
    en: 'LEI number',
    nb: 'LEI-nummer',
  },
  CopyForm: {
    en: 'Copy form',
    nb: 'Kopier skjema',
  },
  dobfield: {
    en: 'Date of Birth (DDMMYY)',
    nb: 'Fødselsdato (DDMMÅÅ)',
  },
  PNRLable: {
    nb: 'P. nr. (5 siffer)',
    en: 'SSN (5 digits)',
  },

  helpTextAnnualPlan: {
    en: 'By choosing "Based on previous meetings", a proposal for an annual plan will be made based on the meetings that have been held in the last 12 months. The meetings will be held on the same day of the week as the year before, adjusted for any official holidays. By choosing "Completely new annual plan", you will get the opportunity to set up a completely new annual plan based on your adjustments.',
    nb: 'Ved valg av «Basert på tidligere møter» vil det bli laget forslag til årsplan basert på møtene som har vært de siste 12 måneder. Møtene blir lagt på samme ukedag som året før, justert for eventuelle offisielle fridager. Ved valg av «Helt ny årsplan» vil du få muligheten til å sette opp helt ny årsplan basert på dine tilpasninger.',
  },

  BusinessAdress: {
    nb: 'Forretningsadresse',
    en: 'Business address',
  },
  NewClaim: {
    en: 'New claim',
    nb: 'Ny pant',
  },

  DateEntered: {
    en: 'Date entered',
    nb: 'Dato innført',
  },
  PostalAddress: {
    nb: 'Postadresse',
    en: 'Postal address',
  },
  ManageSignatures: {
    en: 'Signing requests',
    nb: 'Utsendte signaturer',
  },
  ManageSignaturesHelpText: {
    en: 'Here you will find an overview of sent signing requests. Go to the data room or meeting module to create signing requests that will then appear here.',
    nb: 'Her finner du en oversikt over utsendte signaturer. Gå til datarom eller møte modulen for å lage signeringsforespørsler som så dukker opp her.',
  },
  AdditionalInformation: {
    en: 'Additional information',
    nb: 'Ytterligere opplysninger',
  },

  ExtraTextAnswers: {
    en: 'Extra comments from respondents',
    nb: 'Ekstra kommentarer fra besvarende',
  },
  DescriptionTask: {
    en: 'Description',
    nb: 'Beskrivelse',
    sv: 'Beskrivning',
  },
  sentbyYou: {
    en: 'You: ',
    nb: 'Deg: ',
  },

  YouHaveNoSubgroups: {
    en: 'You have no subgroups',
    nb: 'Du har ingen undergrupper',
  },
  PleaseAddSubgroupName: {
    nb: 'Opprett ny undergruppe',
    en: 'Create new subgroup',
  },
  CreateAdminUser: {
    nb: 'Legg til første administrator',
    en: 'Create first administrator',
  },
  Meeting: {
    en: 'Meeting',
    nb: 'Møte',
  },
  AssociatedFile: {
    en: 'Associated file',
    nb: 'Tilknyttet fil',
  },
  HidePath: {
    en: 'Hide path',
    nb: 'Skjul filsti',
  },
  ShowPath: {
    en: 'Show path',
    nb: 'Vis filsti',
  },
  SubTasks: {
    en: 'Subtasks',
    nb: 'Underoppgaver',
  },
  ParentTask: {
    en: 'Parent task',
    nb: 'Foreldreoppgave',
  },
  DependsOn: {
    en: 'Depends on',
    nb: 'Avhengig av',
  },
  Comments: {
    en: 'Comments',
    nb: 'Kommentarer',
  },
  StartTask: {
    en: 'Start',
    nb: 'Start',
  },
  ModifiedTasks: {
    en: 'Modified',
    nb: 'Endret',
  },
  ProgressTask: {
    en: 'Progress',
    nb: 'Fremdrift',
  },
  ShowFollowupInCalendarForResponsible: {
    en: 'The user responsible for the task will see the task in the calendar.',
    nb: 'Den som er satt som ansvarlig for oppgaven, vil se oppgaven i sin kalenderen.',
  },
  ShowInCalendarForResponsible: {
    en: 'Show in calendar for responsible',
    nb: 'Vis i kalenderen for ansvarlig',
  },
  ShowFollowupInCalendarForEverybody: {
    en: 'Those who have access to the the task will see the it in the calendar.',
    nb: 'De som har tilgang til oppgaven vil se den i kalenderen.',
  },
  ShowInCalendarForEverybody: {
    en: 'Show in calendar for everyone',
    nb: 'Vis i kalenderen for alle',
  },
  MessagesSearch: {
    en: 'Conversation messages',
    nb: 'Samtalemeldinger',
  },
  startConversationWithUser: {
    en: 'Start a new private conversation with this user.',
    nb: 'Start en ny privat samtale med denne brukeren.',
  },
  SendNotificationEmail: {
    en: 'Send notification by email',
    nb: 'Send varsling på e-post',
  },
  Notify: {
    en: 'Notify',
    nb: 'Varsle',
  },
  SendToResponsibleTooltip: {
    en: 'Those assigned to be responsible for the task will receive an bell notification along with an email whenever a change is saved or a comment is added.',
    nb: 'De som er satt som ansvarlige for oppgaven, vil motta en varsling på e-post og i bjellen hver gang det lagres en endring eller legges til en kommentar.',
  },
  UndoTaskMoveTooltip: {
    en: 'Undo changes on task dates',
    nb: 'Angre på flytting av oppgave',
  },
  ResponsibleTasksTooltip: {
    en: 'Here you can add more people responsible for this task.',
    nb: 'Her kan du legge til flere ansvarlige for denne oppgaven.',
  },
  AnnuallyRepeatingTaskTooltip: {
    en: 'Whether this task should be repeated annually. When the deadline has passed, a copy of the task is created one year in the future. If no deadline is set, the copy is created when the start time has passed.',
    nb: 'Angi om oppgaven skal gjentas årlig. Når fristen er passert, opprettes en kopi av oppgaven ett år frem i tid. Om ingen frist er satt, opprettes kopien når starttidspunktet er passert.',
  },
  Calendar: {
    en: 'Calendar',
    nb: 'Kalender',
    sv: 'Kalender',
  },

  CalendarDates: {
    en: 'Calendar dates',
    nb: 'Kalender datoer',
  },

  ResponsibleTooltip: {
    en: 'Add responsible connected to this task',
    nb: 'Legg til ansvarlige som er knyttet til oppgaven',
  },
  Responsible: {
    en: 'Responsible',
    nb: 'Ansvarlig',
  },
  AddResponsible: {
    en: 'Add responsible',
    nb: 'Legg til ansvarlige',
  },
  DependsOnTootip: {
    en: 'Add a task this one depends on',
    nb: 'Legg til en oppgave som denne er avhengig av',
  },
  MovedTask: {
    en: 'Moved task: ',
    nb: 'Flyttet oppgave: ',
  },
  DependsOnTask: {
    en: 'Dependencies',
    nb: 'Avhengigheter',
  },
  AddDependentTasks: {
    en: 'Add dependency',
    nb: 'Legg til en forutsetning',
  },
  CalendarTooltipTask: {
    en: 'Make changes to calendar settings',
    nb: 'Gjør endringer på kalender innstillinger',
  },
  EmailTooltipTask: {
    en: 'Make changes to email settings',
    nb: 'Gjør endringer på e-post innstillinger',
  },
  OrderedAmount: {
    en: 'Ordered amount',
    nb: 'Bestilt beløp',
  },
  UniqueOwners: {
    en: 'Unique owners ',
    nb: 'Unike eiere ',
  },
  shouldFillOutDob: {
    en: 'In order to have a valid register, it is mandatory to fill out the date of birth',
    nb: 'For å ha et gyldig register er det påbudt å fylle ut fødselsdato',
  },
  shouldFillOutAddress: {
    en: 'In order to have a valid register, it is mandatory to fill out the address',
    nb: 'For å ha et gyldig register er det påbudt å fylle ut adresse',
  },
  DateOfBirth: {
    en: 'Date of birth',
    nb: 'Fødselsdato',
  },
  OrderedShares: {
    en: 'Ordered shares',
    nb: 'Bestilte aksjer',
  },
  SendToResponsible: {
    en: 'Send to responsible',
    nb: 'Send til ansvarlige',
  },
  SendToMorePeople: {
    en: 'Send to more people',
    nb: 'Send til flere',
  },
  IncludeTheDescriptionTooltip: {
    nb: 'Hvis du ikke huker av her, vil kun tittelen på oppgaven sendes i e-posten, slik at mottakerne må følge lenken til Orgbrain for å se beskrivelsen av oppgaven.',
    en: 'If this box is not checked, only the title of the task will be visible in the email and the recipients must follow a link to Orgbrain to see the description of the task.',
  },
  IncludeDescriptionInEmail: {
    en: 'Include the description in the email',
    nb: 'Inkluder beskrivelsen i e-posten',
  },
  Cancel: {
    en: 'Cancel',
    nb: 'Avbryt',
    sv: 'Avbryt',
  },
  Save: {
    en: 'Save',
    nb: 'Lagre',
    sv: 'Spara',
  },
  TaskPriority: {
    en: 'Task priority',
    nb: 'Oppgaveprioritet',
  },
  TaskStatus: {
    en: 'Task status',
    nb: 'Oppgavestatus',
  },
  TaskProgress: {
    en: 'Task progress',
    nb: 'Oppgavefremdrift',
  },
  AuthToBoard: {
    en: 'Board Authorizations',
    nb: 'Styrefullmakter',
  },
  Title: {
    en: 'Title',
    nb: 'Tittel',
  },
  AddVote: {
    en: 'Add vote',
    nb: 'Legg til stemme',
  },
  TitleTooltip: {
    en: 'Give the authorization a title',
    nb: 'Her gir du fullmakten en tittel',
  },
  NoContactsDescription: {
    en: 'Only administrator users have access to create new contact groups',
    nb: 'Kun administrator brukere har tilgang til å opprette nye kontaktgrupper',
  },
  CandidateGotVotes1: {
    en: 'You gave the candidate ',
    nb: 'Du gav kandidaten ',
  },
  ElectionWinner: {
    en: 'Election winner',
    nb: 'Vinner av valget',
  },
  CandidateGotVotes2: {
    en: ' votes on behalf of ',
    nb: ' stemmer på vegne av ',
  },
  Subscription: {
    en: 'Subscription',
    nb: 'Abonnement',
  },
  Subgroups: {
    en: 'Subgroups',
    nb: 'Undergrupper',
  },
  FileSystem: {
    en: 'File System',
    nb: 'Filsystem',
  },
  SuperCheck: {
    en: 'Super check',
    nb: 'Super sjekk',
  },
  Sentlog: {
    en: 'Sent log',
    nb: 'Sendingslogg',
  },
  ThisIsAPrivateTask: {
    en: 'This is a private task',
    nb: 'Dette er en privat oppgave',
  },
  Private: {
    en: 'Private',
    nb: 'Privat',
  },
  Download: {
    en: 'Download',
    nb: 'Last ned',
  },

  nameSort: {
    en: 'Alphabetically',
    nb: 'Alfabetisk',
  },
  ShareRegistryAt: {
    en: 'Show status at ',
    nb: 'Viser status per ',
  },
  RegistryFor: {
    en: 'Share register for ',
    nb: 'Aksjeeierbok for ',
  },
  ExportOption: {
    en: 'What do you wish to do?',
    nb: 'Hva ønsker du å gjøre?',
  },

  SendEmail: {
    en: 'Send email',
    nb: 'Send på e-post',
  },
  Sort: {
    en: 'Sort',
    nb: 'Sorter',
  },
  Percent: {
    en: 'Percent',
    nb: 'Prosent',
  },
  SelectRecipients: {
    en: 'Add recipients',
    nb: 'Velg mottakere',
  },
  AddEmails: {
    en: 'Add external recipients',
    nb: 'Legg til eksterne mottakere',
  },
  NoRecipentsSelected: {
    en: 'No valid emails found in selected.',
    nb: 'Det ble ikke funnet noen gyldige eposter i valgte.',
  },
  EmailsSent: {
    en: 'Email has been sent to recipients.',
    nb: 'E-post har blitt sendt til mottakere.',
  },
  ChooseOrgbrainUsers: {
    en: 'Choose Orgbrain users',
    nb: 'Velg Orgbrain-brukere',
  },
  pleaseChooseOrganization: {
    en: 'Please choose an organization first, as this menu requires organization context',
    nb: 'Vennligst velg en organisasjon først, da denne menyen krever organisasjonskontekst',
  },
  IncludeCreatedAtTime: {
    en: 'Show creation date in the document',
    nb: 'Vis opprettelsesdato i dokumentet',
  },
  IncludeCompanyLogo: {
    en: 'Show company logo in the document',
    nb: 'Vis selskapets logo i dokumentet',
  },
  IncludeDistributionDiagram: {
    en: 'Show distribution diagram',
    nb: 'Vis fordelingsdiagram',
  },
  DontIncludeSensitiveOption: {
    en: 'Remove sensitive informasjon',
    nb: 'Fjern sensitiv informasjon',
  },
  Filename: {
    en: 'File name',
    nb: 'Filnavn',
  },
  ExportSettings: {
    en: 'Download settings',
    nb: 'Nedlastningsinnstillinger',
  },
  ExportRegistrySubject: {
    en: 'Shareholder register for ',
    nb: 'Aksjeeierboken for ',
  },
  ExportRegistryText1: {
    en: ' has shared their shareholder register with you. The shareholder register has been created and entered in Orgbrain',
    nb: ' har delt sin aksjeeierbok med deg. Aksjeeierboken er opprettet og ført i fagsystemet levert av Orgbrain.',
  },
  ExportRegistryText2: {
    en: 'You will find the shareholder register attached to this email',
    nb: 'Du finner aksjeeierboken som vedlegg i denne e-posten',
  },
  ExportRegistryText3: {
    en: 'Best regards ',
    nb: 'Med vennlig hilsen ',
  },
  ExportRegistryText4: {
    en: '(Shared through Orgbrain - easy and professional shareholder management)',
    nb: '(Delt via Orgbrain - enkel og profesjonell aksjonæradministrasjon)',
  },

  StartTime: {
    en: 'Start time',
    nb: 'Starttid',
  },

  DeletedMessage: {
    en: 'This message has been deleted',
    nb: 'Denne meldingen har blitt slettet',
  },
  ChooseTask: {
    en: 'Choose tasks',
    nb: 'Velg oppgaver',
  },
  Selected: {
    en: 'Selected',
    nb: 'Valgt',
  },
  DeleteTask: {
    en: 'Delete task',
    nb: 'Slett oppgave',
  },
  'Deleting a task cannot be undone. Do you want to delete this task permanently?': {
    en: 'Deleting a task cannot be undone. Do you want to delete this task permanently?',
    nb: 'Sletting av en oppgave kan ikke angres. Ønsker du å slette denne oppgaven permanent?',
  },

  UntitledTask: {
    en: 'Untitled task',
    nb: 'Oppgave uten tittel',
  },
  Undo: {
    en: 'Undo',
    nb: 'Angre',
  },
  UndoTaskMove: {
    en: 'Undo move',
    nb: 'Angre flytting',
  },

  TaskCompleted: {
    en: 'Task completed',
    nb: 'Oppgave fullført',
  },
  UnlinkFile: {
    en: 'Do you want to disconnect this task from a data room file?',
    nb: 'Vil fjerne koblingen mellom denne oppgaven og dataromfilen?',
  },
  UnlinkFileWarningText: {
    en: 'The file in attachments will not be deleted automatically.',
    nb: 'Filen i vedlegg vil ikke bli slettet automatisk.',
  },
  Ok: {
    en: 'Ok',
    nb: 'Ok',
  },
  DisabledTaskTooltip: {
    en: 'You do not have permission to modify this task',
    nb: 'Du har ikke tillatelse til å endre denne oppgaven',
  },
  Critical: {
    en: 'Critical',
    nb: 'Kritisk',
  },
  High: {
    en: 'High',
    nb: 'Høy',
  },
  Medium: {
    en: 'Medium',
    nb: 'Middels',
  },
  Low: {
    en: 'Low',
    nb: 'Lav',
  },
  Maybe: {
    en: 'No priority',
    nb: 'Ingen prioritet',
  },
  NoPriority: {
    en: 'No priority',
    nb: 'Ingen prioritet',
  },
  Ongoing: {
    en: 'Ongoing',
    nb: 'Pågår',
  },
  NotDone: {
    en: 'Not done',
    nb: 'Ikke gjort',
  },
  Done: {
    en: 'Done',
    nb: 'Ferdig',
  },
  CreateATask: {
    en: 'Create a task',
    nb: 'Opprett en oppgave',
  },
  Create: {
    en: 'Create',
    nb: 'Opprett',
  },
  SaveAndContinue: {
    en: 'Save and continue',
    nb: 'Lagre og fortsett',
  },
  MakeSubTask: {
    en: 'Parent task',
    nb: 'Foreldreoppgave',
  },
  MakeSubTaskTooltip: {
    en: 'Choose a new parent task to make this task a subtask',
    nb: 'Velg en ny foreldreoppgave for å gjøre denne oppgaven til en underoppgave.',
  },
  RemoveParentTask: {
    en: 'Remove Parent Link',
    nb: 'Fjern Foreldrekobling',
  },
  RemoveParentTaskTooltip: {
    en: 'Remove the link between this task and its parent',
    nb: 'Fjern koblingen mellom denne oppgaven og dens foreldreoppgave.',
  },
  TaskSaved: {
    en: 'Saved task',
    nb: 'Lagret oppgave',
  },
  Back: {
    en: 'Back',
    nb: 'Tilbake',
    sv: 'Tillbaka',
  },
  MakeTaskDependent: {
    en: 'Add dependency',
    nb: 'Legg til avhengighet',
  },
  MakeTaskDependentTooltip: {
    en: 'Add a task which this task is dependent on',
    nb: 'Legg til en oppgave som denne oppgaven er avhengig av',
  },

  CreatedBy: {
    en: 'Created by',
    nb: 'Opprettet av',
  },
  PrivateTaskTooltip: {
    nb: 'Dersom du markerer en oppgave som privat, vil oppgaven kun være synlig for deg.',
    en: 'By marking the task as private, the task will only be visible to you.',
  },
  Warning: {
    en: 'Warning',
    nb: 'Advarsel',
  },

  CloseTaskEditWarning: {
    nb: 'Du har lagt inn ny informasjon som ikke er lagret. Ønsker du å fortsette uten å lagre eller gå tilbake for å lagre?',
    en: 'You have entered new information that has not been saved. Do you want to continue without saving or go back to save?',
  },
  CloseOwnerWarning: {
    nb: 'Du har lagt inn ny informasjon som ikke er lagret. Ønsker du å fortsette uten å lagre eller gå tilbake for å lagre?',
    en: 'You have entered new information that has not been saved. Do you want to continue without saving or go back to save?',
  },
  Continue: {
    nb: 'Fortsett',
    en: 'Continue',
  },
  GoBack: {
    nb: 'Gå tilbake',
    en: 'Go back',
  },
  TaskNotChanged: {
    nb: 'Oppgaven er ikke endret',
    en: 'The task is not changed',
  },
  NoUndoneTasks: {
    nb: 'Ingen uferdige oppgaver',
    en: 'No undone tasks',
  },
  EmailWillContainTextWarning: {
    en: 'An email will be sent. The e-mail will contain the text you have entered. Be careful about adding sensitive information to the message',
    nb: 'En e-post vil bli sendt. E-posten vil inneholde teksten du har skrevet inn. Vær forsiktig med å legge til sensitiv informasjon i meldingen',
  },
  EmailsWillBeSent: {
    en: 'Emails will be sent',
    nb: 'E-poster vil bli sendt',
  },
  instructionsTobeGivenPowerOfAthorizedInfo: {
    en: 'Here you can choose to enter instructions on how you want the recipient of the power of attorney to vote on one or more of the cases that are under consideration.',
    nb: 'Her kan du velge å legge inn en instruksjon på hvordan du ønsker at mottakeren av fullmakten skal stemme på en eller flere av de sakene som er til behandling.',
  },
  signingPowerOfAthorizedInfo: {
    en: 'If an administrator registers a power of attorney on behalf of others, the administrator signs to confirm that the power of attorney has been received.',
    nb: 'Dersom en administrator registrerer en fullmakt på vegne av andre, signerer administrator for å bekrefte at fullmakt er mottatt.',
  },
  SendNotification: {
    en: 'Send notification',
    nb: 'Send varsel',
  },
  Notification: {
    en: 'Notifications',
    nb: 'Varsler',
  },
  Emails: {
    en: 'Emails',
    nb: 'E-poster',
  },
  signedBy: {
    en: 'Signed by',
    nb: 'Signert av',
  },
  LongTextInTheBottomProxy: {
    en: 'If the person who has received power of attorney don`t have access to participate digitally using Orgbrain`s portal, the person must either attend by personal appearance or otherwise stated by the company.',
    nb: 'Dersom den som er blitt tildelt fullmakt ikke er gitt tilgang til å delta digitalt via portalen, må vedkommende som er gitt fullmakt delta ved personlig oppmøte eller på annen måte oppgitt av selskapet.',
  },
  AreYouSure: {
    en: 'Are you sure?',
    nb: 'Er du sikker?',
  },
  ChangeStatusOfProxyToNotAttending: {
    en: 'Are you sure you want to give up the proxy for this shareholder? This cannot be undone.',
    nb: 'Er du sikker på at du ønsker å gi fra deg fullmakten til denne aksjonæren? Dette kan ikke angres',
  },
  DeleteTasks: {
    en: 'This will delete all selected tasks',
    nb: 'Dette vil slette alle oppgaver som du har valgt',
  },
  ConfirmSendingEmails: {
    en: 'Send email notification',
    nb: 'Send varsel på e-post',
  },
  TaskAreYouSure: {
    en: 'You are about to send an email notification to the specified individuals that an update has been made to the task.\nAre you sure?',
    nb: 'Du er i ferd med å sende et varsel på e-post til de angitte personene om at det er foretatt en oppdatering på oppgaven.\nEr du sikker?',
  },
  Select: {
    en: 'Select',
    nb: 'Velg',
  },
  deleteTask: {
    en: 'Delete task',
    nb: 'Slett oppgaven',
  },
  openTaskToolbar: {
    en: 'Open and close the toolbar',
    nb: 'Åpne og lukke verktøylinjen',
  },
  SendPaymentInformationToInvestorsTooltip: {
    en: 'Here you will find a draft of a notification about payment that can be sent to the selected investors',
    nb: 'Her vil du finne utkast til en melding om innbetaling som kan sendes til de utvalgte investorene',
  },
  NoTasks: {
    en: 'No tasks yet',
    nb: 'Det finnes ingen oppgaver enda',
  },
  NoCompletedTasks: {
    en: 'There are no completed tasks',
    nb: 'Det finnes ingen fullførte oppgaver',
  },
  NoIncompleteTasks: {
    en: 'There are no incomplete tasks',
    nb: 'Det finnes ingen uferdige oppgaver',
  },
  YouHaveNoTasks: {
    en: 'You have no tasks',
    nb: 'Du har ingen oppgaver',
  },
  YouHaveNoIncompleteTasks: {
    en: 'You have no incomplete tasks',
    nb: 'Du har ingen uferdige oppgaver',
  },
  YouHaveNoCompletedTasks: {
    en: 'You have no completed tasks',
    nb: 'Du har ingen fullførte oppgaver',
  },
  YouHaveNoPrivateTasks: {
    en: 'You have no private tasks',
    nb: 'Du har ingen private oppgaver',
  },
  ThereAreNoTasks: {
    en: 'No tasks yet',
    nb: 'Det finnes ingen oppgaver enda',
  },
  PrivateTasks: {
    en: 'Private tasks',
    nb: 'Private oppgaver',
  },
  NoemissionsYet: {
    en: 'There are no ongoing share issues',
    nb: 'Du har ingen pågående kapitalforhøyelser',
  },
  CopyShareIssueEmission: {
    en: 'Clone previous share issue',
    nb: 'Klone tidligere kapitalforhøyelse',
  },
  NewShareIssueMenu: {
    en: 'Create',
    nb: 'Opprett',
  },
  CopyEmissionTooltip: {
    en: 'Create a new share issue using a previous one as a template.',
    nb: 'Opprett en ny kapitalforhøyelse ved å bruke en tidligere som mal.',
  },
  CreateEmissionTooltip: {
    en: 'Create an entirely new share issue.',
    nb: 'Opprett en helt ny kapitalforhøyelse.',
  },
  NoEmissionsFound: {
    en: 'No previous or ongoing share issues were found.',
    nb: 'Ingen tidligere eller pågående kapitalforhøyelser ble funnet.',
  },
  SelectShareIssueEmission: {
    en: 'Select previous share issue',
    nb: 'Velg tidligere kapitalforhøyelse',
  },
  ShareIssueDeletionSuccess: {
    en: 'The share issue is now deleted',
    nb: 'Kapitalforhøyelsen er nå slettet',
  },
  ShareIssueDeletionFailed: {
    en: 'Error: deletion failed',
    nb: 'Error: sletting feilet',
  },

  NoInvestorsInvited: {
    en: 'No investors invited',
    nb: 'Ingen investorer er invitert',
  },
  ShareRegisterInfo4: {
    en: 'looks like right now that provide a detailed history of the current membership situation.',
    nb: 'ser ut som akkurat nå som gir en detaljert historikk over den aktuelle medlemssituasjonen.',
  },
  NewContract: {
    en: 'New contract',
    nb: 'Ny kontrakt',
  },
  ContractOwner: {
    en: 'Contract owner',
    nb: 'Kontraktsinnehaver',
  },
  History: {
    en: 'History',
    nb: 'Historikk',
  },
  TaxIncentive: {
    en: 'Tax Incentive',
    nb: 'Skatteinsentiv',
  },
  ImportContracts: {
    en: 'Upload contracts',
    nb: 'Last opp kontrakter',
  },
  ExportContracts: {
    en: 'Download contracts',
    nb: 'Last ned kontrakter',
  },
  andContractInformation: {
    en: 'and contract information',
    nb: 'og kontraktsinformasjon',
  },
  Contracts: {
    en: 'Contracts',
    nb: 'Kontrakter',
  },
  Proportion: {
    en: 'Proportion',
    nb: 'Andel',
  },
  ContractTitle: {
    en: 'Contract title',
    nb: 'Avtaletittel',
  },
  NameOfShareclass: {
    en: 'Name of share class',
    nb: 'Navn på aksjeklasse',
  },
  ImportContractTitleText: {
    en: 'Is the title of the contract, and is used to identify the contract. This is a required field and is used to identify exisitng contracts in the registry.',
    nb: 'Er tittelen på kontrakten, og brukes til å identifisere kontrakten. Dette er et obligatorisk felt og brukes til å identifisere eksisterende kontrakter i registeret.',
  },
  contractedAmount: {
    en: 'Contracted amount',
    nb: 'Kontraktbeløp',
  },
  ImportContractedAmountText: {
    en: 'Is the contracted amount of the contract, and is used as the amount field in contracts. This is a required field and is used to sett the amount in a contract.',
    nb: 'Er kontraktsbeløpet i kontrakten, og brukes som beløpsfelt i kontrakter. Dette er et obligatorisk felt og brukes til å sette beløpet i en kontrakt.',
  },
  contractType: {
    en: 'Contract type',
    nb: 'Kontraktstype',
  },
  ImportContractTypeText: {
    en: 'Is the type of the contract, and is used to identify the contract type. This is an required field and is used to identify exisitng contracts in the registry and sett the contract type.',
    nb: 'Er kontraktstypen, og brukes til å identifisere kontraktstypen. Dette er et obligatorisk felt og brukes til å identifisere eksisterende kontrakter i registeret og sette kontraktstypen.',
  },
  contractStatus: {
    en: 'Contract status',
    nb: 'Kontrakt status',
  },
  ImportContractStatusText: {
    en: 'Is the status of the contract, and is used to identify the contract status. This is an optional field and is used to sett contract status.',
    nb: 'Er kontrakten status, og brukes til å identifisere kontrakten status. Dette er et valgfritt felt og brukes til å sette kontrakten status.',
  },
  contractExpiryDate: {
    en: 'Contract expiry date',
    nb: 'Kontrakt utløpsdato',
  },
  ImportContractExpiryDateText: {
    en: 'Is the expiry date of the contract, and is used to identify the contract expiry date. This is an optional field and is used to sett contract expiry date.',
    nb: 'Er kontraktens utløpsdato, og brukes til å identifisere kontrakten utløpsdato. Dette er et valgfritt felt og brukes til å sette kontrakten utløpsdato.',
  },
  strikePrice: {
    en: 'Strike price',
    nb: 'Innløsningskurs',
  },
  StrikePriceTable: {
    en: 'Strike price',
    nb: 'Kurs',
  },
  ReadMessageMenu: {
    en: 'Seen by',
    nb: 'Sett av',
  },
  ChatSeenBy: {
    en: 'Seen by: ',
    nb: 'Sett av: ',
  },
  CurrentUserText: {
    en: 'You',
    nb: 'Deg',
  },
  ImportStrikePriceText: {
    en: 'Is the strike price of the contract, and is used to identify the contract strike price. This is a required field and is used to sett contract strike price.',
    nb: 'Er innløsningskursen på kontrakten, og brukes til å identifisere kontrakten innløsningskurs. Dette er et obligatorisk felt og brukes til å sette kontrakten innløsningskurs.',
  },
  totalLoan: {
    en: 'Total loan',
    nb: 'Lånebeløp',
  },
  ImportTotalLoanText: {
    en: 'Is the total loan of the contract, and is used to identify the contract total loan in the loan contract type. This is a optional field and is used in loans to sett contract total loan amount.',
    nb: 'Er lånebeløpet på kontrakten, og brukes til å identifisere kontrakten lånebeløp i lånekontraktstypen. Dette er et valgfritt felt og brukes i lån til å sette kontrakten lånebeløp.',
  },
  effectiveInterestRate: {
    en: 'Effective interest rate',
    nb: 'Effektiv lånerente',
  },
  ImportEffectiveInterestRateText: {
    en: 'Is the effective interest rate of the contract, and is used to identify the contract effective interest rate in the loan contract type. This is a optional field and is only used in loans to sett contract interest rate.',
    nb: 'Er den effektive lånerenten på kontrakten, og brukes til å identifisere kontrakten effektive lånerente i lånekontraktstypen. Dette er et valgfritt felt og brukes kun i lån til å sette kontrakten effektive lånerente.',
  },
  convertibleShareOfLoan: {
    en: 'Convertible share of loan',
    nb: 'Konverteringsbeløp',
  },
  ImportConvertibleShareOfLoanText: {
    en: 'Is the convertible share of loan of the contract, and is used to identify the contract convertible share of loan in the loan contract type. This is a optional field and is only used in loans to sett contract convertible share of loan.',
    nb: 'Er konverteringsbeløpet på kontrakten, og brukes til å identifisere kontrakten konverteringsbeløp i lånekontraktstypen. Dette er et valgfritt felt og brukes kun i lån til å sette kontrakten konverteringsbeløp.',
  },
  contractTerms: {
    en: 'Contract terms',
    nb: 'Betingelser',
  },
  ImportContractTermsText: {
    en: 'Is the contract terms of the contract, and is used to identify the contract terms in the loan contract type. This is a optional field and is only used in loans to sett contract terms.',
    nb: 'Er betingelsene på kontrakten, og brukes til å identifisere kontrakten betingelser i lånekontraktstypen. Dette er et valgfritt felt og brukes kun i lån til å sette kontrakten betingelser.',
  },
  contractPaymentStructure: {
    en: 'Contract payment structure',
    nb: 'Lånets betalingsstruktur',
  },
  ImportContractPaymentStructureText: {
    en: 'Is the contract payment structure of the contract, and is used to identify the contract payment structure in the loan contract type. This is a optional field and is only used in loans to sett contract payment structure.',
    nb: 'Er betalingsstrukturen på kontrakten, og brukes til å identifisere kontrakten betalingsstruktur i lånekontraktstypen. Dette er et valgfritt felt og brukes kun i lån til å sette kontrakten betalingsstruktur.',
  },
  InTheImport: {
    en: 'in the import',
    nb: 'i importen',
  },
  Strikeprice: {
    en: 'Strike price',
    nb: 'Innløsningskurs',
  },
  ContractInvestor: {
    en: 'Investor',
    nb: 'Investor',
  },
  ActiveMeeting: {
    en: 'Active',
    nb: 'Aktivt',
  },

  NoShareClasses: {
    en: 'No share classes',
    nb: 'Ingen aksjeklasser',
  },
  CreateShareClassToSolvetheproblem: {
    en: 'You need to create a shareclass or import to use this functionality',
    nb: 'Du må opprette en aksjeklasse eller importere for å bruke denne funksjonaliteten',
  },
  CreateShareclass: {
    en: 'Create share class',
    nb: 'Opprett aksjeklasse',
  },
  MoreOptions: {
    en: 'More options',
    nb: 'Flere valg',
  },
  NotificationViewTooltip: {
    en: 'Use this button to switch between showing notifications sorted by time or by organization',
    nb: 'Bruk denne knappen for å veksle mellom å vise varsler sortert etter tid eller etter organisasjon',
  },
  FilterNotifications: {
    en: 'Filter your notifications by their type',
    nb: 'Filtrer varsler dine etter typene deres',
  },
  Filters: {
    en: 'Filters',
    nb: 'Filtere',
  },
  PublishMessageTooltip: {
    en: 'Make the message publicly available',
    nb: 'Gjør meldingen offentlig tilgjenlig',
  },
  RestoreMessageTooltip: {
    en: 'The message was not saved correctly, press to restore an unsaved draft',
    nb: 'Meldingen var ikke lagret riktig, trykk for å gjenopprette et ulagret utkast',
  },
  Restore: {
    en: 'Restore',
    nb: 'Gjenopprett',
  },
  Publish: {
    en: 'Publish',
    nb: 'Publiser',
  },
  outOf: {
    en: 'out of',
    nb: 'av',
  },
  PreviousEmails: {
    en: 'previous email',
    nb: 'forrige e-post',
  },
  FirstEmail: {
    en: 'First email',
    nb: 'Første e-post',
  },

  LastEmail: {
    en: 'Last email',
    nb: 'Siste e-post',
  },
  TurnOffFilter: {
    en: 'Turn off the filter',
    nb: 'Skru av filter',
  },
  ShowLess: {
    en: 'Show less',
    nb: 'Vis mindre',
  },
  'capital-value': {
    en: 'Assessed capital value',
    nb: 'Formuesverdi',
  },
  parvalueTooltip: {
    nb: 'Legg inn pålydende beløp per aksje som angitt i vedtektene',
    en: 'Enter the par value per share as stated in the articles of association',
  },
  NoRegistered: {
    en: 'There are no registered ',
    nb: 'Det er ingen registrerte ',
  },
  ReadMoreOnEmissions: {
    en: 'Read more about share issues in orgbrain',
    nb: 'Les mer om kapitalforhøyelser i orgbrain',
  },
  titleTableHeader: { nb: 'Tittel', en: 'Title' },
  createdAtTableHeader: { nb: 'Opprettet', en: 'Created At' },
  sharesAfterEmissionTableHeader: { nb: 'Aksjer', en: 'Shares' },
  pricePerShareTableHeader: { nb: 'Kurs', en: 'Price' },
  totalAmountTableHeader: { nb: 'Beløp', en: 'Amount' },
  completedDateTableHeader: { nb: 'Fullført', en: 'Completed' },
  CreateEmission: {
    en: 'Create share issue',
    nb: 'Opprett kapitalforhøyelse',
  },
  sharePrice: {
    nb: 'Aksjekurs',
    en: 'Share price',
  },
  ShareIssue: {
    en: 'Share issue',
    nb: 'Kapitalforhøyelse',
  },
  ListView: {
    en: 'List view',
    nb: 'Listevisning',
  },

  Diagram: {
    en: 'Diagram',
    nb: 'Diagram',
  },
  UserIsNotActiveTitle: {
    en: 'This inquery is not active',
    nb: 'Hendvendelsen er ikke aktiv',
  },
  UserIsNotActiveText: {
    en: 'The inquery you are trying to contact is not active in boardmatch anymore.',
    nb: 'Hendvendelsen du prøver å kontakte er ikke lenger aktiv i styrematch.',
  },
  CreateAnnouncement: {
    nb: 'Ny kunngjøring',
    en: 'New announcement',
  },
  capitalValue: {
    nb: 'Formuesverdi',
    en: 'Assessed capital value',
  },
  CapitalValueMessageHeader: {
    nb: 'Formuesverdi per aksje',
    en: 'Assessed capital value per share',
  },
  CapitalValueMessageText1: {
    nb: 'Skattemessig formuesverdi per aksje i ',
    en: 'Assessed capital value per share in ',
  },
  CapitalValueMessageText2: {
    nb: ' var den ',
    en: ' was on the ',
  },
  CapitalValueMessageText3: {
    nb: 'Vennlig hilsen ',
    en: 'Best regards ',
  },
  NewCloneShareIssue: {
    en: 'New/clone share issue',
    nb: 'Ny/klone kapitalforhøyelse',
  },
  PointZeroNewShareIssueInfo: {
    en: 'Go to "Create" to initiate a brand new capital increase, or to create a new one by cloning a previous capital increase as a template.',
    nb: 'Gå til "Opprett" for å lage en helt ny kapitalforhøyelse, eller for å opprette en ny ved å klone en tidligere kapitalforhøyelse som mal.',
  },
  PointTwoNewShareIssueInfo: {
    en: 'Make an order form based on a template and add potentially relevant attachments to investors',
    nb: 'Lag en bestillingsblankett basert på mal og legg til eventuelle relevante vedlegg til investorene.',
  },
  CanAddShareclass: {
    en: 'You can add ',
    nb: 'Du kan legge til ',
  },
  ByImport: {
    en: ' by importing data in the',
    nb: ' ved å importere data i ',
  },
  NoInvestors: {
    en: 'No investors have been added yet.',
    nb: 'Ingen investorer har blitt lagt til ennå.',
  },

  AddOwnersDirectlyBegin: {
    en: ' or add them directly by using the "New ',
    nb: ' eller legge dem til direkte ved å bruke "Ny ',
  },
  AddOwnersDirectlyEnd: {
    en: '" button.',
    nb: '" knappen.',
  },
  AttachFileTask: {
    en: 'Attachments',
    nb: 'Vedlegg',
  },
  NotesBeneficialOwners: {
    en: 'Notes and attachments',
    nb: 'Notater og vedlegg',
  },

  NotSentToAltinnBeneficialOwners1: {
    en: 'All businesses have a legal responsibility to store additional information about beneficial owners. Here you can easily store extra documentation that will not be sent to Altinn.',
    nb: 'Myndighetene kan etterspørre dokumentasjon på vurderingene som er gjort i forbindelse med rapporteringen av reelle rettighetshavere. Det er derfor viktig at virksomheten kan dokumentere grunnlaget for identifiseringen, slik at den kan bistå myndighetene ved forespørsel om ytterligere informasjon.',
  },
  NotSentToAltinnBeneficialOwners2: {
    en: 'In this section, you can easily store documentation. This information is not part of the automatic reporting to Altinn.',
    nb: 'I denne seksjonen kan du enkelt lagre dokumentasjon. Denne informasjonen er ikke en del av den automatiske rapporteringen til Altinn.',
  },
  NoBeneficialOwnersWithEmailTitle: {
    en: 'No beneficial owners with email',
    nb: 'Ingen reelle rettighetshavere med e-post',
  },
  NoBeneficialOwnersWithEmail: {
    en: 'You have not added a email address to any beneficial owners. To notify beneficial owners, add an email address.',
    nb: 'Du har ikke lagt til e-postadresse til noen reelle rettighetshavere. For å varsle reelle rettighetshavere, legg til en e-postadresse.',
  },
  AttachFile: {
    en: 'Attachments',
    nb: 'Vedlegg',
  },
  AttachFileTaskTooltip: {
    en: 'Add attachments to the task',
    nb: 'Legg til vedlegg på oppgaven',
  },
  AttachFileMessageTooltip: {
    en: 'Add attachments to the message',
    nb: 'Legg til vedlegg på meldingen',
  },
  Upload: {
    en: 'Upload',
    nb: 'Last opp',
    sv: 'Ladda upp',
  },
  Dataroom: {
    en: 'Dataroom',
    nb: 'Datarom',
  },

  UploadHelpShareclass: {
    en: 'by uploading data in the',
    nb: 'ved å laste opp data i',
  },
  OrCreateShareclass: {
    en: 'Alternatively, you can create a',
    nb: 'Alternativt kan du opprette en',
  },
  ManuallyShareclass: {
    en: 'manually by pressing "New',
    nb: 'manuelt ved å trykke "Ny',
  },
  WhereManuallyShareClass: {
    en: 'at the top right corner of this page',
    nb: 'øverst i høyre hjørne på denne siden',
  },
  ThisActionCannotBeUndoneDialog: {
    nb: 'Denne handlingen kan ikke angres.',
    en: 'This action cannot be undone.',
    sv: 'Denna åtgärd kan inte ångras.',
  },
  shareClasses: {
    en: 'share classes',
    nb: 'aksjeklasser',
  },
  ConversationReadByMore1: {
    en: 'og ',
    nb: 'and',
  },
  ConversationReadByMore2: {
    en: ' flere',
    nb: ' more',
  },
  shareClass: {
    en: 'share class',
    nb: 'aksjeklasse',
  },
  shareRegistry: {
    en: 'share registry',
    nb: 'aksjeregister',
  },
  shareCategories: {
    en: 'share categories',
    nb: 'aksjekategorier',
  },
  shareCategory: {
    en: 'share category',
    nb: 'aksjekategori',
  },
  noBeneficialOwnersIdentified: {
    nb: 'Virksomheten må dokumentere hva som er gjort for å identifisere dem, jf. lov om register over reelle rettighetshavere § 4 tredje ledd. Dokumentasjonen med begrunnet vurdering, skal være tilgjengelig for offentlige myndigheter og rapporteringspliktige.',
    en: 'The company must document what has been done to identify them, cf. the Act on the register of beneficial owners § 4 third paragraph. The documentation with reasoned assessment must be available to public authorities and reporting entities.',
  },
  noBeneficialOwnersIdentifiedPointPublic: {
    nb: 'Offentlige myndigheter, se ',
    en: 'Public authorities, see ',
  },
  noBeneficialOwnersIdentifiedPointPrivate: {
    nb: 'Rapporteringspliktige, se ',
    en: 'Reporting entities, see ',
  },
  noBeneficialOwnersIdentifiedPointPublicLink: {
    nb: 'forskrift til lov om reelle rettighetshavere § 3-11.',
    en: 'regulation to the Act on beneficial owners § 3-11.',
  },
  noBeneficialOwnersIdentifiedPointPrivateLink: {
    nb: 'lov om tiltak mot hvitvasking og terrorfinansiering § 4.',
    en: 'Act on measures against money laundering and terrorist financing § 4.',
  },
  NoneIdentifiedBeneficialOwners: {
    nb: 'Du har valgt at virksomheten har reelle rettighetshavere som den ikke kan identifisere',
    en: 'You have choosen that the business has beneficial owners which it can not identify',
  },
  unitRegister: {
    en: 'unit register',
    nb: 'enhetsregister',
  },
  GenerateSharenumbers: {
    en: 'Generate share numbers',
    nb: 'Generer aksjenummer',
  },
  sectionCategories: {
    en: 'section categories',
    nb: 'seksjonskategorier',
  },
  sectionCategory: {
    en: 'section category',
    nb: 'seksjonskategori',
  },
  sectionOwnerRegister: {
    en: 'section owner register',
    nb: 'seksjonseierregister',
  },
  memberCategories: {
    en: 'member categories',
    nb: 'medlemskategorier',
  },
  memberCategory: {
    en: 'member category',
    nb: 'medlemskategori',
  },
  membershipRegister: {
    en: 'membership register',
    nb: 'medlemsregister',
  },
  Action: {
    en: 'Action',
    nb: 'Handling',
  },
  SendInvitation: {
    en: 'Send invitation',
    nb: 'Send invitasjon',
  },
  SendInvitationEmissionHelpText: {
    en: 'Invite the investor to sign an order form where they can fill out the investment amount.',
    nb: 'Inviter investoren til å signere en tegningsblankett hvor de kan fylle ut investeringsbeløpet.',
  },
  PrefillShares: {
    en: 'Prefill shares',
    nb: 'Forhåndsutfyll aksjer',
  },
  PrefillSharesHelpText: {
    en: 'Register the investor as ordering a specific investment amount (useful if a paper order form has been received)',
    nb: 'Registrer investoren som bestiller et spesifikt investeringsbeløp (nyttig hvis en papirordre er mottatt)',
  },
  AddInvestorHelpText: {
    en: 'Here you can add, prefill shares, or invite a single investor manually. If the investor does not exist in the system from before, you can create a new investor by clicking "New investor".',
    nb: 'Her kan du legge til, fylle ut aksjer for, eller invitere en enkelt investor manuelt. Eksisterer ikke investoren i systemet fra før, kan du lage en ny investor ved å trykke på "Ny investor".',
  },
  PleaseSelectFromDropdown: {
    en: 'Please select a value from the dropdown',
    nb: 'Vennligst velg en verdi fra rullegardinmenyen',
  },
  Invitations: {
    en: 'Invitations',
    nb: 'Invitasjoner',
  },
  Add: {
    en: 'Add',
    nb: 'Legg til',
    sv: 'Lägg till',
  },
  Modified: {
    en: 'Modified',
    nb: 'Endret',
  },
  NewAuthorization: {
    en: 'New authorization',
    nb: 'Ny fullmakt',
  },
  AuthorizationsModuleInfo: {
    en: 'The board can register authorizations granted by the general meeting to the board. Using the "New Authorization" button, you can either add authorizations manually or import all authorizations registered in the Brønnøysund Registers.',
    nb: 'Her kan styret registrere fullmakter som generalforsamlingen har gitt styret. Via knappen "Ny fullmakt" kan du enten legge til fullmakter manuelt eller importere alle fullmakter som er registrert i Brønnøysundregistrene.',
  },
  Summary: {
    en: 'Summary',
    nb: 'Oversikt',
  },
  OrderedInRelationToMinimum: {
    en: 'Ordered in relation to the minimum requirement of',
    nb: 'Bestilt i forhold til minstekravet på',
  },

  AllocatedInRelationToShares: {
    en: 'Allocated in relation to existing shares',
    nb: 'tildelt i forhold til eksisterende aksjer',
  },
  ContractOwnerAlt: {
    en: 'Owner',
    nb: 'Innehaver',
  },
  Active: {
    en: 'Active',
    nb: 'Aktive',
  },
  AuthorizationImportError: {
    en: 'Error while importing authorizations',
    nb: 'Feil ved import av fullmakter',
  },
  AuthorizationImportSuccess: {
    en: 'Authorizations imported',
    nb: 'Fullmakter importert',
  },
  DeleteAuthorization: {
    en: 'Delete authorization',
    nb: 'Slett fullmakt',
  },
  DeleteAuthorizationPrompt: {
    en: 'Are you sure you want to delete this authorization?',
    nb: 'Er du sikker på at du vil slette denne fullmakten?',
  },
  InvestorExistsErrorEmission: {
    en: 'This investor already exists, you might want to uncheck new investor and search for them instead',
    nb: 'Denne investoren finnes allerede, du vil kanskje fjerne haken for ny investor og heller søke etter dem',
  },
  SimilarNameEmissionWarning: {
    en: 'There is an investor with a similar name in the registry. If this is the investor you want to add, uncheck new investor and search for this person',
    nb: 'Det finnes en investor med lignende navn i registeret. Hvis dette er investoren du vil legge til fjern hukingen fra ny investor og søk etter denne personen',
  },
  All: {
    en: 'All',
    nb: 'Alle',
    sv: 'Alla',
  },
  Liquidation: {
    en: 'Liquidation',
    nb: 'Likvidasjon',
  },
  AIAbbreviation: {
    en: 'AI',
    nb: 'KI',
  },
  AiFormPublish: {
    en: 'Create suggestion',
    nb: 'Lag forslag',
  },
  AiNewsDialogTitle: {
    en: 'AI Announcement Suggestions',
    nb: 'AI-kunngjøringsforslag',
  },
  AIInputPlaceholderText: {
    en: 'Write or paste raw text here.',
    nb: 'Skriv eller lim inn råtekst her.',
  },
  AiNewsDescription: {
    en: 'Write or paste raw text in the field below. AI generates suggestions that you can edit before publishing.',
    nb: 'Skriv eller lim inn råtekst i feltet under. AI genererer forslag som du kan redigere før publisering.',
  },
  AiOwnersDialogTitle: {
    en: 'AI Owner Suggestion',
    nb: 'AI eierforslag',
  },
  AiOwnersDescription: {
    en: 'Write or paste raw text in the field below. AI generates suggestions that you can edit before publishing.',
    nb: 'OSkriv eller lim inn råtekst i feltet under. AI genererer forslag som du kan redigere før publisering.',
  },
  AiFormDialogTitle: {
    en: 'AI Form Suggestion',
    nb: 'AI skjemaforslag',
  },
  AiFormDescription: {
    en: 'Generate a draft of the form using AI. You can then edit the form before publishing it.',
    nb: 'Generer et utkast av skjemaet ved bruk av KI. Du kan deretter redigere skjemaet før publisering.',
  },
  Equal_partial_liquidation: {
    en: 'Equal partial liquidation',
    nb: 'Likvidasjon lik fordeling',
  },
  Unequal_partial_liquidation: {
    en: 'Unequal partial liquidation',
    nb: 'Likvidasjon ulik fordeling',
  },
  Taxable_merger: {
    en: 'Taxable merger',
    nb: 'Skattepliktig fusjon',
  },
  Taxable_demerger: {
    en: 'Taxable demerger',
    nb: 'Skattepliktig fisjon',
  },
  Cancellation_of_treasury_shares_to_cover_losses_and_allocations_to_funds: {
    en: 'Cancellation of treasury shares to cover losses and allocations to funds',
    nb: 'Sletting av egne aksjer for å dekke tap og overføringer til fond',
  },
  Taxable_redemption_in_connection_with_TaxFree_merger_Or_demerger: {
    en: 'Taxable redemption in connection with TaxFree merger Or demerger',
    nb: 'Skattepliktig innløsning i forbindelse med skattefri fusjon eller fisjon',
  },
  Relocation_of_company_to_and_from_Norway: {
    en: 'Relocation of company to and from Norway',
    nb: 'Flytting av selskap til og fra Norge',
  },
  OnlyVisibleToBoard: {
    en: 'To board only',
    nb: 'Til styret',
  },
  discountType: {
    en: 'Rabatttype',
    nb: 'Discount type',
  },
  YourContract: {
    en: 'Your contract',
    nb: 'Din kontrakt',
  },
  Entity: {
    en: 'Entity',
    nb: 'Entitet',
  },
  Maturity: {
    en: 'Maturity',
    nb: 'Forfall',
  },
  Status: {
    en: 'Status',
    nb: 'Status',
    sv: 'Status',
  },
  Strike: {
    en: 'Strike',
    nb: 'Strike',
  },
  LastSharePrice: {
    en: 'Last share price',
    nb: 'Siste aksjekurs',
  },
  EstimatedValueOfPosition: {
    en: 'Estimated position value',
    nb: 'Estimert verdi på posisjon',
  },
  YourPosition: {
    en: 'Your position',
    nb: 'Din posisjon',
  },
  StrikeRelativeToSharePrice: {
    en: 'Strike relative to share price',
    nb: 'Strike i forhold til aksjekurs',
  },
  NumberOfOwners: {
    en: 'Number of owners',
    nb: 'Antall eiere',
  },
  TotalNumberOfShares: {
    en: 'Total number of shares',
    nb: 'Totalt antall aksjer',
  },
  EstimatedValueOfCompany: {
    en: 'Estimated company value',
    nb: 'Estimert verdi på selskap',
  },
  Company: {
    en: 'Company',
    nb: 'Selskap',
    sv: 'Företag',
  },
  YouHaveNoPositions: {
    en: 'You have no positions',
    nb: 'Du har ingen posisjoner',
  },
  YouHaveNoContracts: {
    en: 'You have no agreements',
    nb: 'Du har ingen avtaler',
  },
  Percentage: {
    en: 'Percentage',
    nb: 'Prosent',
  },
  OrderForms: {
    en: 'Order forms',
    nb: 'Bestillingsblanketter',
  },
  InvestorPortfolioInfo: {
    en: 'See your investments, financial agreements, and order forms for ongoing capital increases.',
    nb: 'Her kan du se dine investeringer, finansielle kontrakter og bestillingsblanketter for pågående kapitalforhøyelser.',
  },
  Organization: {
    en: 'Organization',
    nb: 'Organisasjon',
    sv: 'Organisation',
  },
  RemainingAmountContract: {
    en: 'Remaining',
    nb: 'Gjenværende',
  },
  RemainingTooltip: {
    en: 'Here you enter the number of shares that is remaining in the agreement',
    nb: 'Her skriver du inn antall aksjer som er igjen i avtalen',
  },
  //BOARDMATCH
  CouldNotGenerateCompanyvalue: {
    en: 'Could not generate company value',
    nb: 'Kunne ikke generere selskapsverdi',
  },
  Error: {
    en: 'Error',
    nb: 'Feil',
  },
  Boardmatch: {
    en: 'Boardmatch',
    nb: 'Styrematch',
  },
  MyBoardmatch: {
    en: 'My Boardmatch',
    nb: 'Min Styrematch',
  },
  CreateProfile: {
    en: 'Create Profile',
    nb: 'Opprett profil',
  },
  BoardmatchCandidate: {
    en: 'Boardmatch Me',
    nb: 'Styrematch meg',
  },
  CandidateNetwork: {
    en: 'Candidate Network',
    nb: 'Kandidatnettverk',
  },
  BoardmatchOrg: {
    en: 'Boardmatch Org',
    nb: 'Styrematch org',
  },
  GoToDialog: {
    en: 'Go to dialog',
    nb: 'Gå til dialog',
  },
  AboutBoardmatch: {
    en: 'About Boardmatch',
    nb: 'Om Styrematch',
  },
  AboutBoardschool: {
    en: 'About Boardschool',
    nb: 'Om Styreskolen',
  },

  RedirectHeader: {
    en: 'Redirect',
    nb: 'Omdirigering',
  },
  RedirectMessage: {
    en: 'Are you sure you want to redirect to the website below:',
    nb: 'Er du sikker på at du vil omdirigeres til nettstedet nedenfor:',
  },
  MenuCandidate: {
    en: 'Candidate',
    nb: 'Deg som kandidat',
  },
  MenuOrg: {
    en: 'Organization',
    nb: 'Din organisasjon',
  },
  City: {
    en: 'City',
    nb: 'Poststed',
  },
  PublicAdvertTooltip: {
    en: 'By publishing your advertisement, you will gain access to and be matched with relevant candidates',
    nb: 'Ved å publisere annonsen deres, vil dere få tilgang til og bli matchet med relevante kandidater',
  },
  CandidatePublishProfileTooltip: {
    en: 'By publishing your profile, you will gain access to and be matched with relevant positions',
    nb: 'Ved å publisere profilen din, vil du få tilgang til og bli matchet med relevante stillinger',
  },
  CandidateAnonymousProfileTooltip: {
    en: 'By making your profile anonymous, your name or your LinkedIn profile will not be visible when someone views your profile',
    nb: 'Ved å gjøre profilen anonym, vil ikke navnet ditt eller LinkedIn-profilen din være synlig når noen ser på din profil',
  },
  CandidateProfileInfoBox: {
    en: 'This is where you put in information about your personal profile. It is up to you how much information you wish to include, but we recommend that you put in as much as possible to make it easier to find a good match. By making your profile anonymous, your name or your LinkedIn profile will not be visible when someone views your profile.',
    nb: 'Her legger du inn opplysninger om din personlige profil. Det er opp til deg hvor mye informasjon du ønsker å inkludere, men vi anbefaler at du legger inn så mye som mulig for å gjøre det enklere for løsningen å finne en passende match. Ved å gjøre profilen anonym, vil ikke navnet ditt eller LinkedIn-profilen din være synlig når noen ser på din profil.',
  },
  OrgProfileInfoBox: {
    en: 'This is where you register information about your business and what type of candidate you seek. It is up to the business how much information they give, but we recommend that you put in as much as possible to make it easier to find a good match. If you are seeking candidates for multiple roles, you have to create a new advertisement for every role you are searching for.',
    nb: 'Her registrerer dere opplysninger om virksomheten og hvilken type kandidat dere søker. Det er opp til virksomheten å velge hvor mye informasjon man legger inn, men vi anbefaler at dere legger inn så mye som mulig for å gjøre det enklere for løsningen å finne en god match. Hvis dere er ute etter kandidater til ulike verv, må det opprettes en ny annonse for hvert verv dere søker etter.',
  },

  BoardmatchSubheader: {
    en: 'We match your profile with the right company',
    nb: 'Vi matcher din profil med den rette virksomheten',
  },
  BoardmatchSubheaderOrg: {
    en: 'We match your advertisement with the right candidate',
    nb: 'Vi matcher din annonse med den rette kandidaten',
  },
  BoardmatchDescription: {
    en: 'Boardmatch is a feature that connects candidates seeking positions for boards, committees, advisory boards, and other corporate roles with companies looking for such positions.',
    nb: 'Styrematch er en funksjon som kobler kandidater som er ute etter verv i styrer, komiteer, advisory board og andre selskapsverv, med virksomheter som er ute etter slike verv.',
  },
  BoardmatchDescription2: {
    en: 'When you create a profile, you gain access to advertisements from companies that match the criteria you have specified. Similarly, companies will be able to see your profile if there is a match.',
    nb: 'Når du oppretter en profil i løsningen, får du tilgang til annonser fra virksomheter som matcher de kriteriene du har spesifisert. På samme måte vil virksomheter kunne se din profil hvis det er en match.',
  },
  BoardmatchDescription3: {
    en: 'The company will then have the opportunity to send a message expressing their interest in initiating a dialogue.',
    nb: 'Virksomheten vil da ha mulighet til å sende en melding om at de er interessert i å innlede en dialog.',
  },
  BoardmatchDescription4: {
    en: 'You can choose whether your name should be visible to others or if you prefer to be anonymous. Only the companies that have published an advertisement and that match your profile will have access to view it.',
    nb: 'Du kan velge om ditt navn skal være synlig for andre eller om du ønsker å være anonym. Kun de virksomhetene som har publisert en annonse og som matcher med profilen din, vil ha tilgang til å se den.',
  },
  BoardmatchDescriptionOrg: {
    en: 'Boardmatch is a feature that connects businesses looking for candidates for board positions, committees, advisory boards and other corporate roles, with candidates seeking such roles.',
    nb: 'Styrematch er en funksjon som kobler virksomheter som er ute etter kandidater til styret, komiteer, advisory board og andre selskapsverv, med kandidater som er ute etter slike verv.',
  },
  BoardmatchDescription2Org: {
    en: 'When you publish an advertisement through «Boardmatch Org», your organization will gain access to a selection of registered candidates who meet the criteria you have defined. Similarily, candidates who create a profile will be presented with advertisements that match their profile.',
    nb: 'Når du publiserer en stillingsannonse gjennom «Styrematch org», vil virksomheten din få tilgang til et utvalg av registrerte kandidater som møter de kriteriene dere har definert. På tilsvarende vis vil kandidater som oppretter en profil bli presentert for annonser som matcher deres profil.',
  },
  BoardmatchDescription3Org: {
    en: 'This allows candidates with a match to send a message to the organization to express their interest in initiating a dialogue.',
    nb: 'Dette gir kandidatene som har en match mulighet til å sende en melding til virksomheten for å uttrykke sin interesse i å innlede en dialog.',
  },
  BoardmatchDescription4Org: {
    en: 'Candidates can choose whether they want to have a profile where their name is visible, or if they prefer to remain anonymous. Your organization can also use the system to build and maintain a network of potential candidates.',
    nb: 'Kandidater kan velge om de ønsker å ha en profil der navnet er synlig for andre, eller om de foretrekker å være anonym. Din virksomhet kan også benytte systemet til å bygge og vedlikeholde et nettverk med potensielle kandidater.',
  },
  HowItWorks: {
    en: 'How it works',
    nb: 'Slik fungerer det',
  },
  HowItWorksDesc: {
    en: 'The candidate creates a profile and the company creates an advertisement. Our algorithms find matches, and dialogue can be initiated.',
    nb: 'Kandidaten oppretter profil og virksomheten lager en annonse. Våre algoritmer finner match, og dialog kan innledes.',
  },
  RegisterAsCandidate: {
    en: 'Register as candidate',
    nb: 'Register deg som kandidat',
  },
  RegisterOrganization: {
    en: 'Register organization',
    nb: 'Registrer organisasjon',
  },
  GoToCandidateProfile: {
    en: 'Go to candidate profile',
    nb: 'Gå til din kandidatprofil',
  },
  GoToOrgPage: {
    en: 'Go to advertisements',
    nb: 'Gå til deres stillingsannonser',
  },
  AddCandidateProfile: {
    en: 'Create profile',
    nb: 'Opprett profil',
  },
  NoCandidateProfile: {
    en: 'You have not created a profile yet.',
    nb: 'Du har ikke opprettet en profil ennå.',
  },
  Profile: {
    en: 'Profile',
    nb: 'Profil',
  },
  Published: {
    en: '(Published)',
    nb: '(Publisert)',
  },
  PublishedTooltip: {
    en: 'Your profile is published and visible to businesses.',
    nb: 'Profilen er publisert og synlig for virksomheter.',
  },
  PublishedAdTooltip: {
    en: 'Your avdertisement is published and visible to candidates.',
    nb: 'Annonsen er publisert og synlig for kandidater.',
  },
  NotPublished: {
    en: '(Not published)',
    nb: '(Ikke publisert)',
  },
  NotPublishedTooltip: {
    en: 'To publish your profile, check "Public profile" when editing.',
    nb: 'For å publisere profilen din, huk av "Publisert profil" når du redigerer.',
  },
  NotPublishedAdTooltip: {
    en: 'To publish your advertisement, check "Publish advertisement" when editing.',
    nb: 'For å publisere annonsen, huk av "Publiser annonse" når du redigerer.',
  },
  PublishAdToSeeMatch: {
    en: 'Publish this advertisement to find candidates.',
    nb: 'Publiser denne annonsen for å finne kandidater.',
  },
  PublishAdsAppearHere: {
    en: 'Published advertisements will appear here. Update profile to see ads that match your profile.',
    nb: 'Publiserte annonser vil vises her. Oppdater profil for å se annonser som matcher din profil.',
  },
  PublishProfileToSeeMatch: {
    en: 'Publish your profile to find a match.',
    nb: 'Publiser din profil for å finne en match.',
  },
  RerouteToConnectedProfile: {
    en: 'Go to their profile',
    nb: 'Gå til deres profil',
  },
  ConnectedProfileTooltip: {
    en: 'Go to their profile',
    nb: 'Gå til deres profil',
  },
  Anonymous: {
    en: 'Anonymous',
    nb: 'Anonym',
  },
  AnonymousProfile: {
    en: 'Make profile anonymous',
    nb: 'Gjør profil anonym',
  },

  Name: {
    en: 'Name',
    nb: 'Navn',
  },
  DeleteProfile: {
    en: 'Delete profile',
    nb: 'Slett profil',
  },
  DeleteFromNetwork: {
    en: 'Delete from network',
    nb: 'Slett fra nettverk',
  },
  EditInfo: {
    en: 'Edit info',
    nb: 'Rediger info',
  },
  Edit: {
    en: 'Edit',
    nb: 'Rediger',
    sv: 'Redigera',
  },
  AboutMe: {
    en: 'About me',
    nb: 'Om meg',
    sv: 'Om mig',
  },
  BasicInfo: {
    en: 'Basic info',
    nb: 'Basisinformasjon',
  },
  YearFounded: {
    en: 'Year founded',
    nb: 'År stiftet',
  },
  Birthdate: {
    en: 'Birthdate',
    nb: 'Fødselsdato',
  },
  Age: {
    en: 'Age',
    nb: 'Alder',
  },
  Residence: {
    en: 'Residence',
    nb: 'Bosted',
  },
  CountryOfResidence: {
    en: 'Country of residence',
    nb: 'Bostedsland',
  },
  Candidates: {
    en: 'Candidates',
    nb: 'Kandidater',
  },
  Nationality: {
    en: 'Nationality',
    nb: 'Nasjonalitet',
  },
  SelectMultiple: {
    en: 'Select multiple',
    nb: 'Velg flere',
  },

  DatePickerShareholders: {
    en: 'Historic view',
    nb: 'Historisk visning',
  },
  SharesAmount: {
    en: 'Amount of shares',
    nb: 'Antall Aksjer',
  },
  SelectMultipleTasksTooltip: {
    en: 'Select and delete multiple tasks at once',
    nb: 'Velg og slett flere oppgaver på engang',
  },
  SelectMultipleEventsTooltip: {
    en: 'Select and delete multiple events at once',
    nb: 'Velg og slett flere hendelser på engang',
  },
  SubTaskLinkOf: {
    en: 'Remove link to subtask',
    nb: 'Fjern kobling til underoppgave',
  },
  DependencyLinkOff: {
    en: 'Remove link to dependent task',
    nb: 'Fjern kobling til avhengig oppgave',
  },
  NewInquiry: {
    en: 'New Inquiry',
    nb: 'Ny henvendelse',
  },
  NoInquiries: {
    en: 'You have not yet recieved inquiries from any businesses.',
    nb: 'Du har ikke mottatt noen henvendelser fra virksomheter ennå.',
  },
  NoInquiriesOrg: {
    en: 'No candidates have sent you inquiries yet.',
    nb: 'Ingen kandidater har sendt dere noen henvendelser ennå.',
  },
  AS: {
    en: 'Joint-Stock Company',
    nb: 'Aksjeselskap',
  },
  ENK: {
    en: 'Sole Proprietorship',
    nb: 'Enkeltpersonforetak',
  },
  ES: {
    en: 'Condominium Assosiaction',
    nb: 'Eierseksjonssameie',
  },
  ANS: {
    en: 'General Partnership',
    nb: 'Ansvarlig selskap',
  },
  DA: {
    en: 'Partnership with Shared Liability',
    nb: 'Delt ansvar selskap',
  },
  NUF: {
    en: 'Norwegian Branch of Foreign Company',
    nb: 'Norsk avdeling av utenlandsk foretak',
  },
  SA: {
    en: 'Cooperative',
    nb: 'Samvirkeforetak',
  },
  IKS: {
    en: 'Intermunicipal Company',
    nb: 'Interkommunalt selskap',
  },
  IKSR: {
    en: 'Intermunicipal Company Representative',
    nb: 'Interkommunalt selskap Representant',
  },
  KS: {
    en: 'Limited Partnership',
    nb: 'Kommandittselskap',
  },
  BA: {
    en: 'Housing Cooperative',
    nb: 'Borettslag',
  },
  SP: {
    en: 'Limited Liability Company',
    nb: 'Selskap med begrenset ansvar',
  },
  STI: {
    en: 'Foundation',
    nb: 'Stiftelse',
  },
  FLI: {
    en: 'Association/Organization',
    nb: 'Forening/lag/innretning',
  },
  VOF: {
    en: 'Charitable or Nonprofit Organization',
    nb: 'Veldedig eller allmennyttig foretak',
  },
  GFS: {
    en: 'Mutual Insurance Company',
    nb: 'Gjensidig forsikringsselskap',
  },
  HF: {
    en: 'Health Enterprise',
    nb: 'Helseforetak',
  },
  SF: {
    en: 'State Enterprise',
    nb: 'Statsforetak',
  },
  KF: {
    en: 'Municipal Enterprise',
    nb: 'Kommunalt foretak',
  },
  FKF: {
    en: 'County Municipal Enterprise',
    nb: 'Fylkeskommunalt foretak',
  },
  Message: {
    en: 'Message',
    nb: 'Melding',
  },
  WantedRole: {
    en: 'Wanted role',
    nb: 'Ønsket type verv',
  },
  WantedRoleQuestion: {
    en: 'What type of role do you wish to fill?',
    nb: 'Hvilken type rolle ønsker dere å fylle?',
  },
  WhichWantedRole: {
    en: 'What type of position do you want?',
    nb: 'Hvilken type verv ønsker du deg?',
  },
  NetworkWhichWantedRole: {
    en: 'What type of position would be relevant for the candidate?',
    nb: 'Hvilken type verv kan være relevant for kandidaten?',
  },
  WantedGender: {
    en: 'Wanted gender',
    nb: 'Krav til kjønn',
  },
  WantedAge: {
    en: 'Preferred age interval',
    nb: 'Ønsket aldersintervall',
  },
  WantedEducation: {
    en: 'Preferred education level/experience',
    nb: 'Preferert utdanningsnivå/erfaring',
  },
  PersonalProfile: {
    en: 'My page',
    nb: 'Min side',
  },
  Role: {
    en: 'Role',
    nb: 'Rolle',
    sv: 'Roll',
  },
  'role.key': {
    en: 'Role Key',
    nb: 'Rolle Nøkkel',
  },
  Business: {
    en: 'Business',
    nb: 'Bransje',
  },
  WorkLanguage: {
    en: 'Work language',
    nb: 'Språk i stillingen',
  },
  Website: {
    en: 'Website',
    nb: 'Hjemmeside',
  },
  ExpandedHistorySpan: {
    en: ' expanded access to message history - ',
    nb: ' utvidet innsyn i meldingshistorikken - ',
  },
  LimitedHistorySpan: {
    en: ' limited access to message history - ',
    nb: ' begrenset innsyn i meldingshistorikken - ',
  },
  'meetings.is': {
    en: 'is',
    nb: 'er',
  },
  'meetings.are': {
    en: 'are',
    nb: 'er',
  },
  'meetings.VotingForOrAgainst1': {
    en: 'Is',
    nb: 'Stemmer',
  },
  'meetings.VotingForOrAgainst1pl': {
    en: 'Are',
    nb: 'Stemmer',
  },
  'meetings.VotingForOrAgainst2': {
    en: 'voting for or against?',
    nb: 'for eller imot?',
  },
  ViewMessagesAfter: {
    en: ' sees messages from ',
    nb: ' ser meldinger fra ',
  },
  ViewAllMessages: {
    en: ' sees all messages',
    nb: ' ser alle meldinger',
  },
  ViewOnlyMessages: {
    en: ' sees only messages from ',
    nb: ' ser kun meldinger fra ',
  },
  TitleOfAnounce: {
    en: 'Title of the advertisement',
    nb: 'Tittel på annonsen',
  },
  'Restore subscription state': {
    en: 'Restore subscription',
    nb: 'Gjenopprett abonnement',
  },
  ConfirmResetPackage: {
    en: 'This action will restore the validity of the selected subscription. All further main subscriptions will be removed.',
    nb: 'Denne handlingen vil gjenopprette gyldigheten til det valgte abonnementet. Alle ytterligere hovedabonnementer vil bli fjernet.',
  },
  ConfirmResetPackage2: {
    en: 'Any uninvoiced balance will be removed as well. Please review current status:',
    nb: 'Eventuell ufakturert saldo vil også bli fjernet. Vennligst gjennomgå gjeldende status:',
  },
  'profile.location?': {
    en: 'Profile Location?',
    nb: 'Profilsted?',
  },
  ShowInterest: {
    en: 'Show interest',
    nb: 'Meld interesse',
  },
  ShowInterestDescCandidate: {
    en: 'The candidate will be notified that you would like to make contact. You can write a message to the candidate in the field below.',
    nb: 'Kandidaten vil bli informert om at dere er interesserte i å komme i kontakt. Du kan skrive en melding til kandidaten i feltet under.',
  },
  ShowInterestDescOrg: {
    en: 'The organization will be notified that you are interested in this position. You can write a message to the organization in the field below.',
    nb: 'Selskapet vil bli informert om at du er interessert i stillingen. Du kan legge ved en melding til selskapet i feltet nedenfor.',
  },
  ShowProfile: {
    en: 'Show Profile',
    nb: 'Vis profil',
  },
  Inquirys: {
    en: 'Inquiries',
    nb: 'Henvendelser',
  },
  TotalInquiries: {
    en: 'Inquiries',
    nb: 'henvendelser',
  },
  NewInquiries: {
    en: 'New Inquiries',
    nb: 'Nye henvendelser',
  },
  InquiriesDisabled: {
    en: 'Start an inquiry to enable the dialog',
    nb: 'Start en henvendelse for å aktivere dialogen',
  },
  DialogWith: {
    en: 'You are in dialog with',
    nb: 'Du er i dialog med',
  },
  YouHave: {
    en: 'You have',
    nb: 'Du har',
  },
  Network: {
    en: 'Network',
    nb: 'Nettverk',
  },
  ViewNetwork: {
    en: 'View Network',
    nb: 'Vis nettverk',
  },
  PublishedAd: {
    en: 'Published',
    nb: 'Publiserte',
  },
  PublishAdDialogTitle: {
    en: 'Publish ad?',
    nb: 'Publiere annonsen?',
  },
  PublishAdDialogText: {
    en: 'You are about to publish the advertisement. Do you want to continue?',
    nb: 'Du er i ferd med å publisere annonsen. Vil du fortsette?',
  },
  UnpublishAdDialogTitle: {
    en: 'Unpublish ad?',
    nb: 'Avpublisere annonsen?',
  },
  UnpublishAdDialogText: {
    en: 'You are about to unpublish the advertisement. Do you want to continue?',
    nb: 'Du er i ferd med å avpublisere annonsen. Vil du fortsette?',
  },
  Unpublish: {
    en: 'Unpublished',
    nb: 'Avpubliser',
  },
  WantToPublishAd: {
    en: 'Want to publish',
    nb: 'Ønsker å publisere',
  },
  NoActiveAd: {
    en: 'No active advertisements',
    nb: 'Ingen aktive annonser',
  },
  NoPublishedAd: {
    en: 'No published advertisements',
    nb: 'Ingen publiserte annonser',
  },
  WantToUnpublishAd: {
    en: 'Want to unpublish',
    nb: 'Ønsker å ikke publisere',
  },
  NotPublishedAd: {
    en: 'Not Published',
    nb: 'Ikke publiserte',
  },
  AddAddvertisements: {
    en: 'Your advertisements will be shown here when you have created them',
    nb: 'Dine annonser vil legge seg her når du har opprettet dem',
  },
  AddAddvertisementsProfile: {
    en: 'Your inquiries will be shown here after you have created a profile',
    nb: 'Dine henvendelser vil legge seg her etter at du har opprettet en profil',
  },
  AddNewCandidate: {
    en: 'Add Candidate',
    nb: 'Legg til kandidat',
  },
  PotentialCandidates: {
    en: 'Potential candidates',
    nb: 'Aktuelle kandidater',
  },
  AddNewCandidateManual: {
    en: 'Add manually',
    nb: 'Legg til manuelt',
  },
  NoCandidatesInNetwork: {
    en: 'No candidates have been added to your network',
    nb: 'Ingen kandidater er lagt til i ditt nettverk',
  },
  NoAdsInNetwork: {
    en: 'No advertisements has been created. Creat an and end start expanding your network',
    nb: 'Ingen annonser er opprettet. Opprett en annonse og begynn å utvide ditt nettverk',
  },
  AddToCurrentProfile: {
    en: 'Add to current advertisement',
    nb: 'Legg til i valgt annonse',
    sv: 'Lägg till i vald annons',
  },
  FirstName: {
    en: 'First name',
    nb: 'Fornavn',
    sv: 'Förnamn',
  },
  LastName: {
    en: 'Last name',
    nb: 'Etternavn',
    sv: 'Efternamn',
  },
  ContactInfo: {
    en: 'Contact info',
    nb: 'Kontaktinfo',
  },
  Email: {
    en: 'E-mail',
    nb: 'E-post',
    sv: 'E-post',
  },
  'azet-register.Email': {
    en: 'Email',
    nb: 'E-post',
    sv: 'E-post',
  },
  PhoneNumber: {
    en: 'Phone number',
    nb: 'Telefonnummer',
  },
  InquiryDate: {
    en: 'Inquiry Date',
    nb: 'Forespørselsdato',
  },
  Contacted: {
    en: 'Contacted',
    nb: 'Kontaktet',
  },
  LastChanged: {
    en: 'Last changed',
    nb: 'Sist endret',
  },
  CreateNewProfile: {
    en: 'Register profile',
    nb: 'Registrer profil',
  },
  NoProfile: {
    en: 'No profiles have been created.',
    nb: 'Dere har ikke opprettet en profil ennå.',
  },
  NoAdvert: {
    en: 'No advertisements have been created.',
    nb: 'Dere har ikke opprettet en annonse ennå.',
  },
  has2FA: {
    en: 'Enable 2FA',
    nb: 'Aktiver 2FA',
  },
  hasBoardmatchProfile: {
    en: 'Create Boardmatch Profile',
    nb: 'Opprett Styrematch-profil',
  },
  hasBoardschoolCertificate: {
    en: 'Completed Boardschool',
    nb: 'Bestått Styreskolen',
  },
  hasProfilePicture: {
    en: 'Add profile picture',
    nb: 'Legg til profilbilde',
  },
  PublicProfile: {
    en: 'Publish profile',
    nb: 'Publiser profil',
  },
  PublicAdvert: {
    en: 'Publish advertisement',
    nb: 'Publiser annonse',
  },
  'IN DIALOG': {
    en: 'In dialog',
    nb: 'I dialog',
  },
  CONTACTED: {
    en: 'Contacted',
    nb: 'Kontaktet',
  },
  'NOT CONTACTED': {
    en: 'Not contacted',
    nb: 'Ikke kontaktet',
  },
  ERROR: {
    en: 'ERROR',
    nb: 'FEIL',
  },
  Messages: {
    en: 'Messages',
    nb: 'Meldinger',
    sv: 'Meddelanden',
  },
  AddNewMessage: {
    en: 'Write a message',
    nb: 'Skriv en melding',
  },
  NewMessage: {
    en: 'Write message...',
    nb: 'Skriv melding...',
  },
  EditMessage: {
    en: 'Edit message',
    nb: 'Rediger melding',
  },
  EditAd: {
    en: 'Edit Advertisement',
    nb: 'Rediger annonse',
  },
  ViewAd: {
    en: 'View Advertisement',
    nb: 'Vis annonse',
  },
  EditProfile: {
    en: 'Edit profile',
    nb: 'Rediger profil',
  },
  DeleteInquiry: {
    en: 'Delete inquiry',
    nb: 'Slett henvendelse',
  },
  DeleteMessage: {
    en: 'Delete message',
    nb: 'Slett melding',
  },
  none: {
    en: 'None',
    nb: 'Ingen',
  },
  CompanyOnStockMarket: {
    en: 'Choose if the company is registered on a stock exchange',
    nb: 'Velg om selskapet er registrert på et regulert marked (børs)',
  },
  IsRegisteredOnAnotherForeignRegister: {
    en: 'Select if the company is registered on a another register for beneficial owners',
    nb: 'Velg om selskapet er registrert i et utenlandsk register over reelle rettighetshavere',
  },

  'markedstype.euronextOslo': {
    en: 'Euronext Oslo',
    nb: 'Euronext Oslo',
  },
  'markedstype.euronextExpandOslo': {
    en: 'Euronext Expand Oslo',
    nb: 'Euronext Expand Oslo',
  },
  EditedMessage: {
    en: '(edited)',
    nb: '(redigert)',
  },
  InquiryNotes: {
    en: 'Notes',
    nb: 'Notater',
  },
  DescLimit: {
    en: '(Max 750 characters)',
    nb: '(Maks 750 tegn)',
  },
  descPlaceholder: {
    en: 'Description...',
    nb: 'Beskrivelse...',
  },
  CandidateProfile: {
    en: 'Candidate Profile',
    nb: 'Kandidatprofil',
  },
  MyProfile: {
    en: 'My profile',
    nb: 'Min profil',
  },
  NetworkCandidateProfile: {
    en: 'Candidate Profile (Network)',
    nb: 'Kandidatprofil (Nettverk)',
  },
  EditNetworkCandidateProfile: {
    en: 'Edit Candidate Profile (Network)',
    nb: 'Rediger Kandidatprofil (Nettverk)',
  },
  CreateNetworkCandidateProfile: {
    en: 'Create Candidate Profile (Network)',
    nb: 'Opprett Kandidatprofil (Nettverk)',
  },
  CandidateDescription: {
    en: 'A short description of you',
    nb: 'En kort beskrivelse av deg',
  },
  CandidateDescriptionNetwork: {
    en: 'A short description of the candidate',
    nb: 'En kort beskrivelse av kandidaten',
  },
  Gender: {
    en: 'Gender',
    nb: 'Kjønn',
  },
  FEMALE: {
    en: 'Female',
    nb: 'Kvinne',
  },
  MALE: {
    en: 'Male',
    nb: 'Mann',
  },
  ANY: {
    en: 'Any gender',
    nb: 'Ikke spesifisert',
  },
  OTHERGENDER: {
    en: 'Other',
    nb: 'Annet',
  },
  CONVERSATIONAL: {
    en: 'Conversational',
    nb: 'Grunnleggende',
  },
  FLUENT: {
    en: 'Fluent',
    nb: 'Flytende',
  },
  LinkedIn: {
    en: 'LinkedIn',
    nb: 'LinkedIn',
  },
  Language: {
    en: 'Language',
    nb: 'Språk',
  },
  LanguageHeader: {
    en: 'Which languages do you speak?',
    nb: 'Hvilke språk behersker du?',
  },
  LanguageHeaderNetwork: {
    en: 'Which languages does the candidate speak?',
    nb: 'Hvilke språk behersker kandidaten?',
  },
  Proficiency: {
    en: 'Proficiency',
    nb: 'Ferdighetsnivå',
  },
  'Add Language': {
    en: 'Add Language',
    nb: 'Legg til språk',
  },
  Education: {
    en: 'Education',
    nb: 'Utdanning',
  },
  EducationHeader: {
    en: 'What educations do you have?',
    nb: 'Hvilke utdanninger har du?',
  },
  AddEducation: {
    en: 'Add education',
    nb: 'Legg til utdanning',
  },
  AddIndustryExperience: {
    en: 'Add industry experience',
    nb: 'Legg til bransjeerfaring',
  },
  'educ.key': {
    en: 'Education Key',
    nb: 'Utdanningsnøkkel',
  },
  AndOther: {
    en: 'and other(s)',
    nb: 'og andre',
  },
  OrgbrainBoardSchool: {
    en: 'Orgbrain/Board School',
    nb: 'Orgbrain/Styreskolen',
  },
  NetworkCompletedOrgbrainBoardSchool: {
    en: 'Is the candidate certified through Orgbrain/Board School?',
    nb: 'Er kandidaten sertifisert gjennom Orgbrain/Styreskolen?',
  },
  NetworkCompletedOtherBoardCourses: {
    en: 'Has the candidate completed other board courses?',
    nb: 'Har kandidaten fullført andre styrekurs?',
  },
  CompletedOrgbrainBoardSchool: {
    en: 'Are you certified through Orgbrain/Board School?',
    nb: 'Er du sertifisert gjennom Orgbrain/Styreskolen?',
  },
  CompletedBoardCourses: {
    en: 'Have you completed any board courses?',
    nb: 'Har du fullført styrekurs?',
  },
  CompletedOtherBoardCourses: {
    en: 'Have you completed other board courses?',
    nb: 'Har du fullført andre styrekurs?',
  },
  CourseType: {
    en: 'Course Type',
    nb: 'Kurstype',
  },
  AddCourse: {
    en: 'Add Course',
    nb: 'Legg til kurs',
  },
  NoCourses: {
    en: 'No Courses',
    nb: 'Ingen kurs',
  },
  AdTitleTooltip: {
    en: 'Give the advertisement a title, for example what you are looking for (for example «We seek a chairman to SaaS company in growth»)',
    nb: 'Her gir du annonsen en tittel, for eksempel hva dere søker (for eksempel «Vi søker styreleder til SaaS selskap i vekst»).',
  },
  AdAboutTooltip: {
    en: 'Here you can give a short description of your business and explain why this position is interesting to apply for.',
    nb: 'Her kan du gi en kort beskrivelse av virksomheten din og forklare hvorfor stillingen er interessant å søke på.',
  },
  Traits: {
    en: 'Personal traits',
    nb: 'Personlige egenskaper',
  },
  TraitsQuestion: {
    en: 'Which personal traits are most important to you?',
    nb: 'Hvilke personlige egenskaper er viktigst for dere?',
  },
  TraitsSubheader: {
    en: 'Pick those that are most applicable to you.',
    nb: 'Velg de du mener passer best for deg.',
  },
  NetworkTraitsSubheader: {
    en: 'Pick those that are most applicable to the candidate.',
    nb: 'Velg de du mener passer best for kandidaten.',
  },
  'trait.key': {
    en: 'Trait Key',
    nb: 'Egenskapsnøkkel',
  },
  Industry: {
    en: 'Industry',
    nb: 'Bransje',
    sv: 'Bransch',
  },
  BusinessType: {
    en: 'Business type',
    nb: 'Type virksomhet',
  },
  BusinessLocation: {
    en: 'Location',
    nb: 'Lokalisering',
  },
  IndustryExperience: {
    en: 'Industry experience',
    nb: 'Bransjeerfaring',
  },
  IndustryExperienceHeader: {
    en: 'Enter relevant industry experience',
    nb: 'Oppgi relevant bransjeerfaring',
  },
  'experience.key': {
    en: 'Experience Key',
    nb: 'Erfaringsnøkkel',
  },
  Competancy: {
    en: 'Areas of expertise',
    nb: 'Kompetanseområder',
  },
  CompetancyHeader: {
    en: 'Enter your competancy',
    nb: 'Oppgi dine kompetanseområder',
  },
  CompetancyQuestion: {
    en: 'What competency are you seeking?',
    nb: 'Hvilken kompetanse er dere ute etter?',
  },
  'skill.key': {
    en: 'Skill Key',
    nb: 'Ferdighetsnøkkel',
  },
  Experience: {
    en: 'Relevant experience',
    nb: 'Relevant erfaring',
  },
  RelevantExperienceHeader: {
    en: 'Enter relevant experience',
    nb: 'Oppgi relevante verv og roller',
  },
  OrgType: {
    en: 'Org. type',
    nb: 'Org.type',
  },
  FromDate: {
    en: 'From date',
    nb: 'Fra dato',
  },
  ToDate: {
    en: 'To date',
    nb: 'Til dato',
  },
  From: {
    en: 'From',
    nb: 'Fra',
    sv: 'Från',
  },
  To: {
    en: 'To',
    nb: 'Til',
    sv: 'Till',
  },
  from: {
    en: 'from',
    nb: 'fra',
    sv: 'från',
  },
  to: {
    en: 'to',
    nb: 'til',
    sv: 'till',
  },
  FromYear: {
    en: 'From year',
    nb: 'Fra år',
    sv: 'Från år',
  },
  ToYear: {
    en: 'To year',
    nb: 'Til år',
  },
  VOCATIONAL: {
    en: 'Vocational',
    nb: 'Yrkesfaglig',
  },
  BACHLOR: {
    en: 'Bachelor',
    nb: 'Bachelor',
  },
  MASTER: {
    en: 'Master',
    nb: 'Master',
  },
  EXPERIENCE: {
    en: 'Experience',
    nb: 'Bransjeerfaring',
  },
  ALL: {
    en: 'All',
    nb: 'Alle',
    sv: 'Alla',
  },
  YOUNG: {
    en: 'Under 35 years',
    nb: 'Under 35 år',
  },
  MIDDEL: {
    en: '35 to 60 years',
    nb: '35 til 60 år',
  },
  OLD: {
    en: 'Over 60 years',
    nb: 'Over 60 år',
  },
  Country: {
    en: 'Country',
    nb: 'Land',
    sv: 'Land',
  },
  AddExperience: {
    en: 'Add Experience',
    nb: 'Legg til erfaring',
  },
  InternationalExperience: {
    en: 'International experience',
    nb: 'Internasjonal erfaring',
  },
  InternationalExperienceQ: {
    en: 'Required international experience',
    nb: 'krav om internasjonal erfaring',
  },
  InternationalExperienceImportance: {
    en: 'Is international experience important?',
    nb: 'Er det viktig med internasjonal erfaring?',
  },
  InternationalExperienceYears: {
    en: 'International experience years',
    nb: 'Internasjonale erfaringsår',
  },
  InternationalExperienceQuestion: {
    en: 'Do you have international experience?',
    nb: 'Har du internasjonal erfaring?',
  },
  WantedRemuneration: {
    en: 'Wanted remuneration',
    nb: 'Ønsket honorar',
  },
  BoardmatchHeadline: {
    en: 'New inquiry on Boardmatch',
    nb: 'Ny henvendelse på Styrematch',
  },

  BoardmatchHeaderToOrg: {
    en: 'Boardmatch - new candidate has shown interest',
    nb: 'Styrematch - ny kandidat har vist interesse',
  },
  BoardmatchHeaderToCandidate: {
    en: 'Boardmatch - someone has shown interest in your profile',
    nb: 'Styrematch - noen har vist interesse for din profil',
  },
  GoToAdvertisment: {
    en: 'Log in',
    nb: 'Logg inn',
  },
  BoardmatchEmailToOrg1: {
    en: 'A new candidate has shown interest in your advertisement on Boardmatch and wishes to start a dialogue.',
    nb: 'En ny kandidat har vist interesse for annonsen din på Styrematch og ønsker å starte en dialog.',
  },
  BoardmatchEmailToOrg2: {
    en: 'Log in to Orgbrain to see who it is.',
    nb: 'Logg inn på Orgbrain for å se hvem det gjelder.',
  },
  BoardmatchEmailToCandidate1: {
    en: 'A business has shown interest in your profile on Boardmatch and wishes to start a dialogue.',
    nb: 'En virksomhet har vist interesse for profilen din på Styrematch og ønsker å starte en dialog. ',
  },
  BoardmatchEmailToCandidate2: {
    en: 'Log in to Orgbrain to see who it is.',
    nb: 'Logg inn på Orgbrain for å se hvem det gjelder.',
  },
  NoneMunicipality: {
    en: 'Not given ',
    nb: 'Ikke angitt ',
  },
  AtSchool: {
    en: 'from ',
    nb: 'fra ',
  },
  In: {
    en: 'in ',
    nb: 'i ',
  },
  School: {
    en: 'School',
    nb: 'Skole',
  },
  MinusSharesFound: {
    en: 'Investor with negative shares found',
    nb: 'Investor med negative antall funnet',
  },
  MinusSharesInRegisteryDescription: {
    en: 'The number of shares in the registry is negative for one or more of the investors in the registry. This can cause problems if not solved before the import is completed.',
    nb: 'Antall aksjer i registeret er negative for en eller flere av investorene i registeret. Dette kan føre til problemer om ikke løst før importeringen gjennobmføres.',
  },
  ExpectedRemunerationQuestion: {
    en: 'Are you willing to work for free in certain cases?',
    nb: 'Er du villig til å jobbe frivillig i noen sammenhenger?',
  },
  ExpectedRemunerationAmount: {
    en: 'Expectations regarding remuneration',
    nb: 'Forventninger om honorar',
  },
  ExpectedRemuneration: {
    en: 'Expectation of remuneration',
    nb: 'Forventning til honorar',
  },
  NOREM: {
    en: 'No Remuneration',
    nb: 'Ingen honorar',
  },
  remuneration: {
    en: 'Remuneration',
    nb: 'Honorar',
  },
  RemunerationOrg: {
    en: 'Remuneration',
    nb: 'Honorering',
  },
  OrgProfile: {
    en: 'Organization Profile',
    nb: 'Organisasjonsprofil',
  },
  OurPage: {
    en: 'Our page',
    nb: 'Vår side',
  },
  CreateNewAd: {
    en: 'Create new advertisement',
    nb: 'Opprett stillingsannonse',
  },
  DeleteAd: {
    en: 'Delete advertisement',
    nb: 'Slett annonse',
  },
  AllAds: {
    en: 'All advertisements',
    nb: 'Alle annonser',
  },
  Ads: {
    en: 'Advertisements',
    nb: 'Annonser',
  },
  Advert: {
    en: 'Job advertisement',
    nb: 'Stillingsannonse',
  },
  Ad: {
    en: 'Advertisement',
    nb: 'Annonse',
  },
  FindCandidate: {
    en: 'Find candidates',
    nb: 'Finn kandidater',
  },
  FindBoard: {
    en: 'Find positions',
    nb: 'Finn verv',
  },
  Personal: {
    en: 'Personal',
    nb: 'Personlig',
  },
  ConversationTabText: {
    en: 'Chats',
    nb: 'Samtaler',
  },
  AnnouncementTabText: {
    en: 'Announcements',
    nb: 'Kunngjøringer',
  },
  OrgHomeInfoBox: {
    en: 'Here you can create advertisements to find candidates sith a profile in Orgbrain. When an advertisement is created, you get an overview of candidates that fit to your ad. You can also create and maintain an overview of candidates in your network.',
    nb: 'Her kan du lage annonser for å finne kandidater som har en profil i Orgbrain. Når en annonse er opprettet, får du en oversikt over kandidater som passer til annonsen din. Du kan også lage og holde ved like en oversikt over kandidater i ditt nettverk.',
  },
  OrganizationProfile: {
    en: 'Organization Profile',
    nb: 'Organisasjonsprofil',
  },
  DescHeader: {
    en: 'About the business',
    nb: 'Om virksomheten',
  },
  Turnover: {
    en: 'Turnover',
    nb: 'Omsetning',
  },
  NumEmployees: {
    en: 'Number of Employees',
    nb: 'Antall Ansatte',
  },
  OrgNationality: {
    en: 'Organization Nationality',
    nb: 'Organisasjonsnasjonalitet',
  },
  OrgNationalityQuestion: {
    en: 'Is the organization',
    nb: 'Er organisasjonen',
  },
  Norwegian: {
    en: 'Norwegian',
    nb: 'Norsk',
  },
  Nordic: {
    en: 'Nordic',
    nb: 'Nordisk',
  },
  International: {
    en: 'International',
    nb: 'Internasjonal',
  },
  LocationImportance: {
    en: 'Location Importance',
    nb: 'Stedsbetydning',
  },
  LocationImportanceQuestion: {
    en: 'Is it important that the candidate lives geographically nearby?',
    nb: 'Er det viktig at kandidaten bor geografisk nærme?',
  },
  WantedTitle: {
    en: 'Preferred education/work title',
    nb: 'Preferert utdanning/yrkestittel',
  },
  SummaryView: {
    en: 'View summary of finished video calls',
    nb: 'Se oppsummering av gjennomførte videomøter',
  },
  VideoMeetingsRecordings: {
    en: 'Recordings',
    nb: 'Opptak',
  },
  WorkTitle: {
    en: 'Work title',
    nb: 'Yrkestittel',
  },
  OrganizationType: {
    en: 'Organization Type',
    nb: 'Organisasjonstype',
  },
  BoardCourse: {
    en: 'Completed Board Course',
    nb: 'Fullført styrekurs',
  },
  WantedMeetings: {
    en: 'Expected amount of meetings in a year',
    nb: 'Forventet antall møter i året',
  },
  PhysicalMeets: {
    en: 'Physical meetings',
    nb: 'Fysiske møter',
  },
  DigitalMeets: {
    en: 'Digital meetings',
    nb: 'Digitale møter',
  },
  Remuneration: {
    en: 'Remuneration',
    nb: 'Honorar',
  },
  'rem.key': {
    en: 'Remuneration Key',
    nb: 'Lønnsnøkkel',
  },
  NoneValidCandidateProfile: {
    en: 'None Valid Candidate Profile',
    nb: 'Ingen gyldig kandidatprofil',
  },
  AddToContactList: {
    en: 'Add to network',
    nb: 'Legg til i nettverk',
  },
  AlreadySentInquiry: {
    en: 'Inquiry sent',
    nb: 'Henvendelse er sendt',
  },
  AlreadyAddedToNetwork: {
    en: 'In your network',
    nb: 'Ligger i ditt nettverk',
  },
  Duration: {
    en: 'Duration',
    nb: 'Varighet',
  },
  SendInquiry: {
    en: 'Send inquiry',
    nb: 'Send henvendelse',
  },
  ANALYTICAL: {
    en: 'Analytical',
    nb: 'Analytisk',
  },
  STRATEGIC: {
    en: 'Strategic',
    nb: 'Strategisk',
  },
  TEAM_PLAYER: {
    en: 'Team Player',
    nb: 'Lagspiller',
  },
  RELATIONSHIP_BUILDER: {
    en: 'Relationship Builder',
    nb: 'Relasjonsbygger',
  },
  SOLUTION_ORIENTED: {
    en: 'Solution Oriented',
    nb: 'Løsningsorientert',
  },
  CURIOUS: {
    en: 'Curious',
    nb: 'Nysgjerrig',
  },
  PROACTIVE: {
    en: 'Proactive',
    nb: 'Initiativrik',
  },
  INFLUENCER: {
    en: 'Influencer',
    nb: 'Påvirker',
  },
  RELIABLE: {
    en: 'Reliable',
    nb: 'Pålitelig',
  },
  EXECUTION_POWER: {
    en: 'Execution Power',
    nb: 'Gjennomføringskraft',
  },
  FOCUSED: {
    en: 'Focused',
    nb: 'Fokusert',
  },
  SALES: {
    en: 'Sales and Sales management',
    nb: 'Salg og salgsledelse',
  },
  MARKETING: {
    en: 'Marketing',
    nb: 'Markedsføring',
  },
  STRATEGY: {
    en: 'Strategy',
    nb: 'Strategi',
  },
  ECONOMICS: {
    en: 'Economics',
    nb: 'Økonomi',
  },
  LEADERSHIP: {
    en: 'Leadership',
    nb: 'Ledelse',
  },
  COMMUNICATION: {
    en: 'Communication',
    nb: 'Kommunikasjon',
  },
  LABOR_ORGANIZATIONS: {
    en: 'Labor and Employer Organizations',
    nb: 'Arbeidstaker- og arbeidsgiverorganisasjoner',
  },
  ARCHITECTURE_AND_INTERIOR: {
    en: 'Architecture, Area and Interior',
    nb: 'Arkitektur, areal og interiør',
  },
  ARCHIVE_AND_LIBRARY: {
    en: 'Archive and Library',
    nb: 'Arkiv og bibliotek',
  },
  BANKING_AND_INSURANCE: {
    en: 'Banking, Finance and Insurance',
    nb: 'Bank, finans og forsikring',
  },
  EDUCATION: {
    en: 'Children, School and Education',
    nb: 'Barn, skole og undervisning',
  },
  AUTOMOTIVE: {
    en: 'Automotive, Vehicles and Workshop',
    nb: 'Bil, kjøretøy og verksted',
  },
  AUTO_PRODUCTION: {
    en: 'Automobile and Component Production',
    nb: 'Bil- og bildelproduksjon',
  },
  RETAIL: {
    en: 'Retail and Commerce',
    nb: 'Butikk og varehandel',
  },
  CONSTRUCTION: {
    en: 'Construction and Building',
    nb: 'Bygg og anlegg',
  },
  MAINTENANCE_SERVICES: {
    en: 'Maintenance Services',
    nb: 'Drift og vedlikeholdstjenester',
  },
  ANIMAL_HEALTH: {
    en: 'Animals and Animal Health',
    nb: 'Dyr og dyrehelse',
  },
  REAL_ESTATE: {
    en: 'Real Estate',
    nb: 'Eiendom',
  },
  ELECTRONICS: {
    en: 'Electronics',
    nb: 'Elektronikk',
  },
  EVENTS_AND_ARRANGEMENTS: {
    en: 'Events and Arrangements',
    nb: 'Event og arrangementer',
  },
  PHARMACY_AND_MEDICINE: {
    en: 'Pharmacy and Medicine',
    nb: 'Farmasi og legemiddel',
  },
  FISHERIES_AND_AQUACULTURE: {
    en: 'Fisheries and Aquaculture',
    nb: 'Fiskeri og oppdrett',
  },
  PUBLISHING_AND_PRINTING: {
    en: 'Publishing and Printing',
    nb: 'Forlag og trykkeri',
  },
  RESEARCH_AND_SCIENCE: {
    en: 'Research and Science',
    nb: 'Forskning, utdanning og vitenskap',
  },
  DEFENSE_AND_MILITARY: {
    en: 'Defense and Military',
    nb: 'Forsvar og militær',
  },
  WHOLESALE_TRADE: {
    en: 'Wholesale Trade',
    nb: 'Grossisthandel import/eksport',
  },
  HR_AND_RECRUITMENT: {
    en: 'HR and Recruitment',
    nb: 'HR, organisasjonsutvikling og rekruttering',
  },
  HEALTHCARE: {
    en: 'Healthcare',
    nb: 'Helse og omsorg',
  },
  HOTEL_AND_ACCOMMODATION: {
    en: 'Hotel and Accommodation',
    nb: 'Hotell og overnatting',
  },
  CRAFT_SERVICES: {
    en: 'Craft Services',
    nb: 'Håndverkstjenester',
  },
  IT: {
    en: 'IT',
    nb: 'IT',
  },
  IT_HARDWARE: {
    en: 'IT Hardware',
    nb: 'IT-maskinvare',
  },
  IT_SOFTWARE: {
    en: 'IT Software',
    nb: 'IT-programvare',
  },
  NON_PROFIT_ORGANIZATIONS: {
    en: 'Non-Profit Organizations',
    nb: 'Ideelle organisasjoner',
  },
  SPORTS_AND_FITNESS: {
    en: 'Sports and Fitness',
    nb: 'Idrett og trening',
  },
  INDUSTRIAL_PRODUCTION: {
    en: 'Industrial Production',
    nb: 'Industri og produksjon',
  },
  INTERNET_SERVICES: {
    en: 'Internet Services',
    nb: 'Internettbaserte tjenester',
  },
  AGRICULTURE_AND_FORESTRY: {
    en: 'Agriculture and Forestry',
    nb: 'Jordbruk og skogbruk',
  },
  LEGAL_SERVICES: {
    en: 'Legal Services',
    nb: 'Juridiske tjenester',
  },
  CHURCH_AND_MINISTRY: {
    en: 'Church and Ministry',
    nb: 'Kirke og menighet',
  },
  CHEMICAL_INDUSTRY: {
    en: 'Chemical Industry',
    nb: 'Kjemisk industri',
  },
  CONSULTING: {
    en: 'Consulting',
    nb: 'Konsulent og rådgivning',
  },
  POWER_AND_ENERGY: {
    en: 'Power and Energy',
    nb: 'Kraft og energi',
  },
  ARTS_AND_CULTURE: {
    en: 'Arts and Culture',
    nb: 'Kunst og kultur',
  },
  AVIATION: {
    en: 'Aviation',
    nb: 'Luftfart',
  },
  MARITIME_AND_OFFSHORE: {
    en: 'Maritime and Offshore',
    nb: 'Maritim og offshore',
  },
  MARKET_RESEARCH: {
    en: 'Market Research',
    nb: 'Markedsanalyse',
  },
  MARKETING_AND_ADVERTISING: {
    en: 'Marketing and Advertising',
    nb: 'Markedsføring og annonsering',
  },
  FOOD_PRODUCTION: {
    en: 'Food Production',
    nb: 'Matvareproduksjon og -industri',
  },
  MEDIA_AND_CONTENT_PRODUCTION: {
    en: 'Media and Content Production',
    nb: 'Medie- og innholdsproduksjon',
  },
  MEDICAL_EQUIPMENT: {
    en: 'Medical Equipment',
    nb: 'Medisinsk utstyr og rekvisita',
  },
  METALS_AND_MINERALS: {
    en: 'Metals and Minerals',
    nb: 'Metaller og mineraler',
  },
  ENVIRONMENTAL_SERVICES: {
    en: 'Environmental Services',
    nb: 'Miljøtjenester',
  },
  MUSEUMS_AND_CULTURAL_HERITAGE: {
    en: 'Museums and Cultural Heritage',
    nb: 'Museer, gallerier og kulturminne',
  },
  PUBLIC_ADMINISTRATION: {
    en: 'Public Administration',
    nb: 'Offentlig administrasjon',
  },
  OIL_AND_GAS: {
    en: 'Oil and Gas',
    nb: 'Olje og gass',
  },
  ORGANIZATIONS: {
    en: 'Organizations',
    nb: 'Organisasjoner',
  },
  PR_AND_COMMUNICATION: {
    en: 'PR and Communication',
    nb: 'PR, informasjon og kommunikasjon',
  },
  POLICE_AND_SECURITY: {
    en: 'Police and Security',
    nb: 'Politi og sikkerhet',
  },
  TRAVEL_AND_TOURISM: {
    en: 'Travel and Tourism',
    nb: 'Reise og turisme',
  },
  WASTE_MANAGEMENT: {
    en: 'Waste Management',
    nb: 'Renovasjon og renhold',
  },
  FOOD_AND_BEVERAGE: {
    en: 'Food and Beverage',
    nb: 'Restaurant, mat og uteliv',
  },
  SHIPPING: {
    en: 'Shipping',
    nb: 'Shipping',
  },
  CATERING: {
    en: 'Catering',
    nb: 'Storhusholdning og catering',
  },
  TEXTILE: {
    en: 'Textile',
    nb: 'Tekstil',
  },
  TELECOMMUNICATIONS: {
    en: 'Telecommunications',
    nb: 'Telekommunikasjon',
  },
  TRANSPORT_AND_LOGISTICS: {
    en: 'Transport and Logistics',
    nb: 'Transport og logistikk',
  },
  WOOD_INDUSTRY: {
    en: 'Wood Industry',
    nb: 'Trevareindustri',
  },
  ENTERTAINMENT: {
    en: 'Entertainment',
    nb: 'Underholdning',
  },
  HVAC: {
    en: 'HVAC',
    nb: 'VVS',
  },
  WELLNESS: {
    en: 'Wellness',
    nb: 'Velvære',
  },
  HEAVY_INDUSTRY: {
    en: 'Heavy Industry',
    nb: 'Verksindustri',
  },
  FINANCE_AND_ACCOUNTING: {
    en: 'Finance and Accounting',
    nb: 'Økonomi og regnskap',
  },
  STRATEGIC_PARTNER_SALES: {
    en: 'Strategic Partner Sales',
    nb: 'Strategisk partnersalg',
  },
  BRANDING: {
    en: 'Branding',
    nb: 'Merkevarebygging',
  },
  CAPITAL_RAISING: {
    en: 'Capital Raising',
    nb: 'Kapitalinnhenting',
  },
  INITIAL_PUBLIC_OFFERING: {
    en: 'Initial Public Offering',
    nb: 'Børsnotering',
  },
  OTHER_INDUSTRY: {
    en: 'Other',
    nb: 'Annet',
  },
  OTHER: {
    en: 'Other',
    nb: 'Annet',
  },
  POLITICS: {
    en: 'Politics',
    nb: 'Politikk',
  },
  SALG: {
    en: 'Sales and Sales management',
    nb: 'Salg og salgsledelse',
  },
  ADMINISTRATION: {
    en: 'Administration',
    nb: 'Administrasjon',
  },
  HR: {
    en: 'Human Resources',
    nb: 'HR',
  },
  FOU: {
    en: 'Research and Development',
    nb: 'FOU',
  },
  SUSTAINABILITY_ESG: {
    en: 'Sustainability/ESG',
    nb: 'Bærekraft/ESG',
  },
  COMPETENCY_SECURITY_FIRM: {
    en: 'Securities firm',
    nb: 'Verdipapirforetak',
  },
  COMPETENCY_ASSET_MNGMNT: {
    en: 'Asset management',
    nb: 'Fondsforvaltning',
  },
  COMPETENCY_POLITICS: {
    en: 'Politics',
    nb: 'Politikk',
  },
  COMPETENCY_JUSS: {
    en: 'Law',
    nb: 'Juss',
  },
  INTERNATIONALIZATION: {
    en: 'Internationalization',
    nb: 'Internasjonalisering',
  },
  PROGRAMMING: {
    en: 'Programming',
    nb: 'Programmering',
  },
  AI: {
    en: 'Artificial intelligence',
    nb: 'Kunstig intelligens',
  },
  BLOCKCHAIN: {
    en: 'Blockchain',
    nb: 'Blockchain',
  },
  MERGERSANDACQUISITIONS: {
    en: 'Mergers and Acquisitions',
    nb: 'Fusjon og oppkjøp',
  },
  TECHNOLOGY: {
    en: 'Technology',
    nb: 'Teknologi',
  },
  CULTUREANDENTERTAINMENT: {
    en: 'Culture and Entertainment',
    nb: 'Kultur og underholdning',
  },
  EDUCATION_TRAINING: {
    en: 'Education/Training',
    nb: 'Utdanning/opplæring',
  },
  SERVICE_CUSTOMERSUPPORT: {
    en: 'Service/Customer Support',
    nb: 'Service/kundestøtte',
  },
  CHAIRMANOFTHEBOARD: {
    en: 'Chairman of the Board',
    nb: 'Styreleder',
  },

  ALTERNATEMEMBER: {
    en: 'Deputy Member',
    nb: 'Varamedlem',
  },
  NOMINATIONCOMMITTEE: {
    en: 'Nomination Committee',
    nb: 'Valgkomité',
  },
  REMUNERATIONCOMMITTEE: {
    en: 'Remuneration Committee',
    nb: 'Godgjørelsesutvalg',
  },
  CONTROLCOMMITTEE: {
    en: 'Control Committee',
    nb: 'Kontrollutvalg',
  },
  AUDITCOMMITTEE: {
    en: 'Audit Committee',
    nb: 'Revisjonsutvalg',
  },
  ADVISORYBOARD: {
    en: 'Advisory Board',
    nb: 'Advisory board',
  },
  MANAGINGDIRECTOR: {
    en: 'Managing Director',
    nb: 'Daglig leder',
  },
  ADVISOR: {
    en: 'Advisor',
    nb: 'Rådgiver',
  },
  MENTOR: {
    en: 'Mentor',
    nb: 'Mentor',
  },
  INVESTOR: {
    en: 'Investor',
    nb: 'Investor',
  },
  ENGLISH: {
    en: 'English',
    nb: 'Engelsk',
  },
  SPANISH: {
    en: 'Spanish',
    nb: 'Spansk',
  },
  GERMAN: {
    en: 'German',
    nb: 'Tysk',
  },
  FRENCH: {
    en: 'French',
    nb: 'Fransk',
  },
  SWEDISH: {
    en: 'Swedish',
    nb: 'Svensk',
  },
  CHINESE: {
    en: 'Chinese',
    nb: 'Kinesisk',
  },
  RUSSIAN: {
    en: 'Russian',
    nb: 'Russisk',
  },
  ITALIAN: {
    en: 'Italian',
    nb: 'Italiensk',
  },
  JAPANESE: {
    en: 'Japanese',
    nb: 'Japansk',
  },
  ARABIC: {
    en: 'Arabic',
    nb: 'Arabisk',
  },
  NORTHERNSAMI: {
    en: 'Northern Sami',
    nb: 'Nordsamisk',
  },
  PORTUGUESE: {
    en: 'Portuguese',
    nb: 'Portugisisk',
  },
  DUTCH: {
    en: 'Dutch',
    nb: 'Nederlandsk',
  },
  LATIN: {
    en: 'Latin',
    nb: 'Latin',
  },
  GREEK: {
    en: 'Greek',
    nb: 'Gresk',
  },
  DANISH: {
    en: 'Danish',
    nb: 'Dansk',
  },
  FINNISH: {
    en: 'Finnish',
    nb: 'Finsk',
  },
  POLISH: {
    en: 'Polish',
    nb: 'Polsk',
  },
  TURKISH: {
    en: 'Turkish',
    nb: 'Tyrkisk',
  },
  KOREAN: {
    en: 'Korean',
    nb: 'Koreansk',
  },
  HEBREW: {
    en: 'Hebrew',
    nb: 'Hebraisk',
  },
  PERSIAN: {
    en: 'Persian',
    nb: 'Persisk',
  },
  URDU: {
    en: 'Urdu',
    nb: 'Urdu',
  },
  HINDI: {
    en: 'Hindi',
    nb: 'Hindi',
  },
  THAI: {
    en: 'Thai',
    nb: 'Thai',
  },
  VIETNAMESE: {
    en: 'Vietnamese',
    nb: 'Vietnamesisk',
  },
  INDONESIAN: {
    en: 'Indonesian',
    nb: 'Indonesisk',
  },
  HUNGARIAN: {
    en: 'Hungarian',
    nb: 'Ungarsk',
  },
  CZECH: {
    en: 'Czech',
    nb: 'Tsjekkisk',
  },
  ROMANIAN: {
    en: 'Romanian',
    nb: 'Rumensk',
  },
  NORWEGIAN: {
    en: 'Norwegian',
    nb: 'Norsk',
  },
  LinkedInTooltip: {
    en: 'Add a link to your linkedIn in this format: https://www.linkedin.com/in/YOUR USER/',
    nb: 'Legg til en link til din LinkedIn profil i dette formatet: https://www.linkedin.com/in/YOUR USER/',
  },
  TitleToolTip: {
    en: 'Enter a title for your ad, for example what you are looking for',
    nb: 'Legg inn en tittel på din annonse, for eksempel hva du søker etter',
  },
  AllProfiles: {
    en: 'All advertisements',
    nb: 'Alle annonser',
  },
  NoSelectedProfile: {
    en: 'No selected advertisement',
    nb: 'Ingen annonse valgt',
  },
  WantToDelete: {
    en: 'Are you sure you want to delete? This cannot be undone.',
    nb: 'Er du sikker på at du vil slette? Dette kan ikke angres.',
  },
  WantToDeleteHeader: {
    en: 'Warning',
    nb: 'Advarsel',
  },
  WantToDeleteAd: {
    en: 'Are you sure you want to delete the advertisement? This cannot be undone.',
    nb: 'Er du sikker på at du vil slette annonsen? Dette kan ikke angres.',
  },
  WantToDeleteProfile: {
    en: 'Are you sure you want to delete your profile? This cannot be undone.',
    nb: 'Er du sikker på at du vil slette din profil? Dette kan ikke angres.',
  },
  WantToDeleteMsg: {
    en: 'Are you sure you want to delete this message? This cannot be undone.',
    nb: 'Er du sikker på at du vil slette meldingen? Dette kan ikke angres.',
  },
  WantToDeleteInquiry: {
    en: 'Are you sure you want to delete this inquiry? This cannot be undone.',
    nb: 'Er du sikker på at du vil slette denne henvendelsen? Dette kan ikke angres.',
  },
  AnErrorHaveOcurred: {
    en: 'An error have occured',
    nb: 'Det har oppstått en feil',
  },
  CheckIfYourEventsAreConsistentIfThisErrorPersistsContactSupport: {
    en: 'Check if your events are consistent. If this error persists, contact support.',
    nb: 'Sjekk om hendelser er konsistente. Hvis denne feilen vedvarer, kontakt support.',
  },
  NoSubscriptionsEmission: {
    en: 'You currently have no subscriptions, historic or ongoing...',
    nb: 'Du har for øyeblikket ingen bestillingsblanketter, verken historiske eller pågående...',
  },
  ShareClassOnly: {
    en: 'Share class',
    nb: 'Aksjeklasse',
  },
  CompanyOnly: {
    en: 'Company',
    nb: 'Selskap',
  },
  Ownershare: {
    en: 'Share of ownership',
    nb: 'Eierandel',
  },
  EstimatedValue: {
    en: 'Estimated value',
    nb: 'Estimert verdi',
  },
  Portfolio: {
    en: 'Portfolio',
    nb: 'Portefølje',
  },
  FromNetwork: {
    en: 'From network',
    nb: 'Fra nettverk',
  },
  STARTUP: {
    en: 'Start-up business',
    nb: 'Oppstartselskap',
  },
  SMB: {
    en: 'SMB',
    nb: 'SMB',
  },
  BIGBUSINESS: {
    en: 'Big business',
    nb: 'Stor virksomhet',
  },
  LISTED: {
    en: 'Listed',
    nb: 'Børsnotert',
  },
  ASSOCIATION: {
    en: 'Association',
    nb: 'Forening',
  },
  FOUNDATION: {
    en: 'Foundation',
    nb: 'Stiftelse',
  },
  SPORTS: {
    en: 'Sports',
    nb: 'Idrett',
  },
  PAYED: {
    en: 'Paid for in money',
    nb: 'Betalt i penger',
  },
  NOTPAYED: {
    en: 'Unpaid position',
    nb: 'Ikke betalt verv',
  },
  PAYEDSTOCKS: {
    en: 'Options, stocks, other',
    nb: 'Opsjoner, aksjer, annet',
  },
  NEGOTIATION: {
    en: 'After further agreement',
    nb: 'Etter nærmere avtale',
  },
  Latest: {
    en: 'Latest',
    nb: 'Nyeste',
  },
  BestMatch: {
    en: 'Best match',
    nb: 'Beste match',
  },
  HideContactedOrgs: {
    en: 'Hide contacted organizations',
    nb: 'Skjul kontaktede organisasjoner',
  },
  ProfileDeleted: {
    en: 'Profile deleted',
    nb: 'Profil slettet',
  },
  ErrorOnDelete: {
    en: 'Error on deleting',
    nb: 'Feil ved sletting',
  },
  ErrorOnUpdate: {
    en: 'Error on updating',
    nb: 'Feil ved oppdatering',
  },

  recordingEnabled: {
    nb: 'Lagre lydopptak',
    en: 'Save audio recordings',
  },
  recordingEnabledText: {
    nb: 'Lydopptak blir lagret og gjort tilgjengelig for avspilling for brukere med tilgang under fanen Møte-AI. Hvis lydopptak ikke lagres, vil lyden kun bli brukt som grunnlag for å lage transkripsjon, protokoll og møteanalyse. Om ønskelig er det mulig å slette lydopptak manuelt, f.eks. etter at protokollen er ferdigstilt.',
    en: 'Audio recordings are saved and made available for playback for users with access under the Meeting-AI tab. If audio recordings are not saved, the audio will only be used as a basis for creating transcription, protocol and meeting analysis. If desired, it is possible to delete audio recordings manually, e.g. after the protocol is finished.',
  },
  transcriptionEnabled: {
    nb: 'Lagre transkribering',
    en: 'Save transcription',
  },
  transcriptionEnabledText: {
    nb: 'Transkripsjon blir beholdt og gjort tilgjengelig for brukere med tilgang under fanen Møte-AI.',
    en: 'Transcription is kept and made available for users with access under the Meeting-AI tab.',
  },
  MinutesGenerationEnabled: {
    nb: 'Lag referat og protokoll',
    en: 'Create meeting notes and minutes',
  },
  MinutesGenerationEnabledText: {
    nb: 'AI brukes til å lage referat- og protokollutkast ut fra agendaen og transkripsjonen. Resultatet legges under fanen Møte-AI i etterkant av møtet. Prosessen benytter per i dag en språkmodell (LLM) som kjøres trygt på Microsofts servere i Sverige.',
    en: 'AI is used to create meeting notes and minutes from the agenda and transcription. The result is displayed under the Meeting-AI tab a few minutes after the meeting has ended. The process currently uses a Large Language Model that is run securely on Microsoft’s servers in Sweden.',
  },
  transcriptionsStatisticsEnabled: { nb: 'Lag møteanalyse', en: 'Create meeting analysis' },
  transcriptionsStatisticsEnabledText: {
    nb: 'AI brukes til å analysere møtet, for eksempel samtaletid per deltaker og oppgaver som omtalt på opptaket. Resultatet legges under fanen Møte-AI i etterkant av møtet.',
    en: 'AI is used to analyze the meeting, for example speaking time per participant and tasks that are mentioned on the recording. The result is displayed under the Meeting-AI tab after the meeting has ended.',
  },
  'Settings.hideAgendaTabForParticipants': {
    nb: 'Skjul agendafane ',
    en: 'Hide agenda tab',
  },
  'Settings.hideAgendaTabForParticipantsText': {
    nb: 'Skjul agendafanen for ikke-admin brukere',
    en: 'Hide the agenda tab for non-admin users',
  },
  deleteMeetingRecording: {
    nb: 'Slett lydopptak',
    en: 'Delete audio recordings',
  },
  deleteMeetingRecordingText: {
    nb: 'Lydopptak og transkripsjon blir automatisk slettet og er aldri tilgjengelig.',
    en: 'Audio recordings and transcription are automatically deleted and are never available.',
  },
  ListenToParticipant: {
    nb: 'Lytt til deltagerens stemme',
    en: 'Listen to participant',
  },
  GoToFirstOccurrenceOfParticipant: {
    nb: 'Hopp til transkripsjon av deltagers stemme',
    en: 'Go to transcription of participants voice',
  },
  InquiryDeleted: {
    en: 'Inquiry deleted',
    nb: 'Henvendelse slettet',
  },
  ErrorOnDeleteInquiry: {
    en: 'Error on deleting inquiry',
    nb: 'Feil ved sletting av henvendelse',
  },
  PostedInquiry: {
    en: 'Posted inquiry',
    nb: 'Henvendelse sendt',
  },
  ErrorFetchInquiry: {
    en: 'Error fetching inquiry',
    nb: 'Feil ved henting av henvendelse',
  },
  DeletedMessageAction: {
    en: 'Message deleted',
    nb: 'Slettet melding',
  },
  ExportTransactions: {
    en: 'Download events',
    nb: 'Last ned hendelser',
  },

  ImportTransactionSpreadSheet: {
    en: 'Upload spreadsheet',
    nb: 'Last opp regneark',
  },
  RF1086: {
    en: 'Shareholder register statement',
    nb: 'Aksjonærregisteroppgaven',
  },

  ErrorDeletingMessage: {
    en: 'Error on deleting message',
    nb: 'Feil ved sletting av melding',
  },
  PostedMessage: {
    en: 'Message sent',
    nb: 'Melding sendt',
  },
  ErrorPostingMessage: {
    en: 'Error on sending message',
    nb: 'Feil ved sending av melding',
  },
  SavedNotes: {
    en: 'Saved notes',
    nb: 'Internt notat lagret',
  },
  NotesText: {
    nb: 'Internt notat',
    en: 'Internal note',
    sv: 'Internt not',
  },
  ErrorSavingNotes: {
    en: 'Error on saving notes',
    nb: 'Feil ved lagring av notat',
  },
  CandidateEmail: {
    en: 'Email: ',
    nb: 'Email: ',
  },
  CandidatePhone: {
    en: 'Phone number: ',
    nb: 'Telefon nr: ',
  },
  ProfileSaved: {
    en: 'Profile saved',
    nb: 'Lagret profil',
  },
  ErrorProfileSaved: {
    en: 'Error saving profile',
    nb: 'Feil ved lagring av profil',
  },
  ProfileNotValid: {
    en: 'Profile not valid',
    nb: 'Profilen er ugyldig',
  },
  ErrorFetchingProfile: {
    en: 'Error fetching profile',
    nb: 'Feil ved henting av profil',
  },
  NetworkCandidateProfileDeleted: {
    en: 'Network candidate deleted',
    nb: 'Nettverkskandidat slettet',
  },
  NoneValidProfileId: {
    en: 'Ivalid profile ID',
    nb: 'Ugyldig profil-ID',
  },
  SavedAd: {
    en: 'Saved advertisement',
    nb: 'Lagret annonse',
  },
  ErrorSavingAd: {
    en: 'Error on saving advertisement',
    nb: 'Feil ved lagring av annonse',
  },
  DuplicateToNetwork: {
    en: 'Can not add duplicates to network',
    nb: 'Kan ikke lagre duplikater til nettverk',
  },
  SavedToNetwork: {
    en: 'Saved to network',
    nb: 'Lagret i nettverk',
  },
  ErrorSavingToNetwork: {
    en: 'Error on saving to network',
    nb: 'Feil ved lagring i nettverk',
  },
  PublishProfile: {
    en: 'Publish profile',
    nb: 'Publiser profil',
  },
  PublishProfileDesc: {
    en: 'You can publish your profile for businesses, or save it as a draft only visible to yourself.',
    nb: 'Du kan publisere profilen din for virksomheter, eller lagre den som utkast kun synlig for deg selv.',
  },
  PublishAd: {
    en: 'Publish advertisement',
    nb: 'Publiser annonse',
  },
  PublishAdDesc: {
    en: 'You can publish the advertisement for candidates, or save it as a draft only visible to your organisation.',
    nb: 'Du kan publisere annonsen for kandidater, eller lagre den som utkast kun synlig for din organisasjon.',
  },
  SaveAsDraft: {
    en: 'Save as draft',
    nb: 'Lagre som utkast',
  },
  SaveAndPublish: {
    en: 'Save and publish',
    nb: 'Lagre og publiser',
  },
  MoreInfo: {
    en: 'More information',
    nb: 'Mer informasjon',
  },
  GetStarted: {
    en: 'Get started',
    nb: 'Kom i gang',
  },
  NoMatchesOrg: {
    en: "It looks like there aren't any matches right now, but new candidates get added frequently. Keep paying attention!",
    nb: 'Det ser ut som det ikke er noen match akkurat nå, men nye kandidater legges stadig til. Følg med!',
  },
  NoMatchesCandidate: {
    en: "It looks like there aren't any matches right now, but new opportunities appear frequently. Keep paying attention!",
    nb: 'Det ser ut som det ikke er noen match akkurat nå, men nye muligheter dukker stadig opp. Følg med!',
  },
  InterestingCandidate: {
    en: 'Is the candidate interesting?',
    nb: 'Er kandidaten interessant?',
  },
  InterestingCandidateInfoBox: {
    en: 'Show interest. There you have the option to mark a candidate as interesting, not interesting, or maybe. This will not be visible to the candidate. Please note that if you mark a candidate as "No", the candidate will disappear from your match.',
    nb: 'Meld interesse. Der har du muligheten til å merke en kandidat som interessant, ikke interessant, eller kanskje. Dette vil ikke være synlig for kandidaten. Vær oppmerksom på at hvis du markerer en kandidat som "Nei", vil kandidaten forsvinne fra din match.',
  },
  InterestingAd: {
    en: 'Is the ad interesting?',
    nb: 'Er annonsen interessant?',
  },
  InterestingAdInfoBox: {
    en: 'Here you have the option of marking an ad as interesting, not interesting, or maybe. This will not be visible to the advertiser. Please note that if you mark an ad as "No", the ad will disappear from your match.',
    nb: 'Her har du muligheten til å merke en annonse som interessant, ikke interessant, eller kanskje. Dette vil ikke være synlig for annonsøren. Vær oppmerksom på at hvis du markerer en annonse som "Nei", vil annonsen forsvinne fra din match.',
  },
  MaybeInteresting: {
    en: 'Maybe',
    nb: 'Kanskje',
  },
  ShowOnlyRatedProfiles: {
    en: 'Only show rated profiles',
    nb: 'Vis bare vurderte profiler',
  },
  ShowOnlyRatedAds: {
    en: 'Only show rated advertisements',
    nb: 'Vis bare vurderte annonser',
  },
  Years: {
    en: ' years',
    nb: ' år',
  },
  MUSIC: {
    en: 'Music',
    nb: 'Musikk',
  },
  AddToNetworkTooltip: {
    en: 'Here you can add the candidate to your network in Boardmatch. This will not be visible to the candidate.',
    nb: 'Her kan du legge kandidaten til ditt nettverk i Styrematch. Dette vil ikke være synlig for kandidaten.',
  },
  ShowInterestCandidateTooltip: {
    en: 'Here you can send a message to the candidate.',
    nb: 'Du kan her sende en melding til kandidaten.',
  },
  ShowInterestOrgTooltip: {
    en: 'Here you can send a message to the business.',
    nb: 'Du kan her sende en melding til virksomheten.',
  },
  WantToDeleteFromNetwork: {
    en: 'Are you sure you want to delete this candidate from your network? This cannot be undone.',
    nb: 'Er du sikker på at du vil slette denne kandidaten fra nettverket ditt? Dette kan ikke angres.',
  },
  NetworkConnectedToOrgbrain: {
    en: 'This candidate is connected to an Orgbrain account.',
    nb: 'Denne kandidaten er koblet til en Orgbrain-bruker.',
  },
  AllOwners: {
    en: 'All owners',
    nb: 'Alle eiere',
  },
  OpenOrderForms: {
    en: 'Open order forms',
    nb: 'Åpne bestillingsblanketter',
  },
  HistoricalOrderForms: {
    en: 'Historical order forms',
    nb: 'Historiske bestillingsblanketter',
  },
  OpenOrderFormsInfo: {
    en: 'See all open order forms you have received for capital increases that have not yet been completed.',
    nb: 'Her kan du se alle åpne bestillingsblanketter du har mottatt for kapitalforhøyelser som enda ikke er fullført.',
  },
  HistoricalOrderFormsInfo: {
    en: 'Here you can see all historical order forms, both completed and canceled.',
    nb: 'Her kan du se alle historiske bestillingsblanketter, både fullførte og avbrutte.',
  },
  ShareClassSaved: {
    en: 'Share class saved',
    nb: 'Aksjeklasse lagret',
  },
  ErrorSavingShareClass: {
    en: 'Error on saving share class',
    nb: 'Feil ved lagring av aksjeklasse',
  },
  OK: {
    en: 'OK',
    nb: 'OK',
    sv: 'OK',
  },
  ParValue: {
    en: 'Par value',
    nb: 'Pålydende',
    sv: 'Pålydande',
  },
  VoteWeight: {
    en: 'Vote weight',
    nb: 'Stemmevekt',
    sv: 'Röstvikt',
  },
  VotingLimit: {
    en: 'Votes limit',
    nb: 'Stemmetak',
  },
  ErrorCreatingParValueEvent: {
    en: 'Error creating par value event',
    nb: 'Feil ved opprettelse av endring av pålydende hendelse',
    sv: 'Fel vid skapande av händelse för ändring av pålydande',
  },
  Seller: {
    en: 'Transferor',
    nb: 'Avhender',
  },
  InfoAboutSeller: {
    en: 'Information about transferor',
    nb: 'Informasjon om avhender',
  },
  DownloadTemplate: {
    en: 'Download template',
    nb: 'Last ned mal',
  },
  'shareholders.TotalAmount': {
    en: 'Total amount',
    nb: 'Beløp',
  },
  PaymentPerShare: {
    en: 'Payment per share:',
    nb: 'Utbetaling per aksje:',
  },
  TransactionStateInvalid: {
    en: 'Inconsistent state in register',
    nb: 'Uoverensstemmelse i registeret',
  },
  TransactionStateInvalidText: {
    en: 'It looks like this change creates a conflict in the register. Please check the history of transactions and ownership changes that may have caused this. Click "Continue" to add the event to the register anyway.',
    nb: 'Det ser ut som denne endringen skaper en konflikt i registeret. Vennligst sjekk historikken for transaksjoner og eierskapsendringer som kan ha forårsaket dette. Klikk "Fortsett" for å legge til hendelsen i registeret likevel.',
  },
  InfoAboutTransaction: {
    en: 'Transaction information',
    nb: 'Transaksjonsinformasjon',
  },
  Individual: {
    en: 'Individual',
    nb: 'Individ',
  },
  BoardMembers: {
    en: 'Board Members',
    nb: 'Styremedlemmer',
  },
  SpreadsheetMustShowHistoryOfTransaction: {
    en: 'The spreadsheet must show the history of transactions, ownership changes and other events from the start to today.',
    nb: 'Last opp alle transaksjoner, eierskifter og andre hendelser fra oppstart til i dag via et regneark.',
  },
  ChooseAMethodToImportThe: {
    en: 'Choose a method to import the ',
    nb: 'Velg en metode for å legge inn ',
  },
  UploadSnapshotText: {
    en: "Upload a spreadsheet with a snapshot of today's register.",
    nb: 'Last opp et regneark med et øyeblikksbilde av dagens register.',
  },
  PaidAmount: {
    en: 'Amount paid',
    nb: 'Betalt',
  },
  Settings: {
    en: 'Settings',
    nb: 'Innstillinger',
    sv: 'Inställningar',
  },
  TermsOfUse: {
    en: 'Terms of use',
    nb: 'Brukervilkår',
  },
  agreementTerms: {
    nb: 'avtalevilkårene',
    en: 'terms of use',
    sv: 'användarvillkoren',
  },
  IAgreeToTermsOfUse: {
    en: 'I agree to',
    nb: 'Jeg aksepterer',
  },
  'azet-register.SubmitRegistrationAzets': {
    en: 'Validate identity using Azets SSO',
    nb: 'Sjekk identiteten med Azets Cozone',
  },
  'azet-register.SubmitRegistrationAzetsOrgbrainButton': {
    en: 'Use email to register',
    nb: 'Ny konto fra e-postadresse',
  },
  'azet-register.EmailInviteIsInvalidTitle': {
    en: 'Email invite is invalid!',
    nb: 'E-postinvitasjon er ugyldig!',
  },
  'azet-register.EmailInviteIsInvalidText': {
    en: 'This can happen if you have already registered OR your invite has expired. Please contact your system administrator for help.',
    nb: 'Dette kan skje hvis du allerede har registrert deg ELLER invitasjonen din har utløpt. Vennligst kontakt systemadministratoren din for hjelp.',
  },
  'azet-register.ItIsNoUsePleaseStopTrying': {
    en: 'It is no use, please stop trying.',
    nb: 'Det nytter ikke.',
  },
  'azet-register.TransferInviteDialogTitle': {
    en: 'Transfer invitation',
    nb: 'Overfør invitasjon',
  },
  'azet-register.TransferInviteExplanation': {
    en: 'NB! A e-mail with a login link will be sent from Orgbrain to the e-mail address you have entered.',
    nb: 'NB!  En e-post med innloggingslenke vil bli sendt fra Orgbrain til e-postadressen du har oppgitt.',
  },
  'azet-register.TransferInviteSuccesTitle': {
    en: 'Your invite has been transfered.',
    nb: 'Din invitasjon er blitt overført.',
  },
  'azet-register.TransferInviteSuccesBody1': {
    en: 'An invation email has been sent to',
    nb: 'En invitasjon er blitt sendt til',
  },
  'azet-register.TransferInviteSuccesBody2': {
    en: 'using email',
    nb: 'på e-post',
  },
  'azet-register.TransferInviteSuccesBody3': {
    en: 'Your previous email invitation is now invalid. If you have made an mistake transferring your invite you will need to contact Orgbrain.',
    nb: 'Dersom du angrer på denne overføringen må du ta kontakt med Orgbrain support.',
  },
  'azet-register.TransferInviteSuccesBody4': {
    en: 'You can now close this window',
    nb: 'Du kan nå lukke dette vinduet',
  },
  'azet-register.CreateOrgbrainAccount': {
    en: 'Create an Orgbrain user',
    nb: 'Opprett en bruker i Orgbrain"',
  },
  Client: {
    en: 'Client',
    nb: 'Klient',
  },
  Roles: {
    en: 'Roles',
    nb: 'Roller',
  },
  aiTitle: { en: 'Artificial intelligence (AI)  ', nb: 'Kunstig intelligens (AI) ' },
  aiTooltip: {
    en: 'Enable AI to write better texts',
    nb: 'Aktiver AI for å skrive bedre tekster',
  },
  aiBodyText: {
    en: 'Get help from artificial intelligence to write better texts and perform other tasks. You can find more information about the use of AI in our ',
    nb: 'Få hjelp fra kunstig intelligens til å skrive bedre tekster og til å utføre øvrige oppgaver. Du kan finne mer informasjon om bruken av AI i våre ',
  },
  AISuggestions: {
    en: 'AI Suggestions',
    nb: 'AI forslag',
  },
  AddedToAgenda: {
    en: 'Added to agenda',
    nb: 'Lagt til agenda',
  },
  UseAi: {
    en: 'Search with AI in Orgbrain',
    nb: 'Søk med AI i Orgbrain',
  },
  aiTermsLink: { en: 'terms of use', nb: 'brukervilkår' },
  emailLabel: { en: 'Email', nb: 'E-postadresse' },
  totpLabel: { en: 'Authenticator App', nb: 'Authenticator app' },
  addTotpButton: { en: 'Add', nb: 'Legg til' },
  changeTotpButton: { en: 'Change', nb: 'Endre', sv: 'Ändra' },
  contactTitle: { en: 'Account', nb: 'Konto' },
  other: { en: 'Other', nb: 'Annet' },
  calendarAPI: { en: 'Calendar API', nb: 'Kalender API' },
  phoneLabel: { en: 'Mobile (SMS 2FA)', nb: '2FA ved bruk av SMS' },
  name: { en: 'Name', nb: 'Navn' },
  Confirm: {
    en: 'Confirm',
    nb: 'Bekreft',
  },
  PolicyName: {
    en: 'Security level',
    nb: 'Sikkerhetsnivå',
  },
  Admin_2FA: {
    en: 'Admin',
    nb: 'Admin',
  },
  Medium_2FA: {
    en: 'Board',
    nb: 'Styre',
  },
  All_2FA: {
    en: 'Global (7 days)',
    nb: 'Globalt (7 dager)',
  },
  nameInfo: {
    nb: 'Her kan du endre navnet på din bruker. For eksempel dersom du har endret ditt etternavn. ',
    en: 'Here you can change the display name of your user. For example, if you have changed your surname.',
  },
  emailInfo: {
    nb: `Her har du mulighet til å endre den e-postadresse som din brukerkonto er koblet til.
      Du kan bare endre til en e-postadresse som ikke allerede er i bruk hos Orgbrain. Dersom det er nødvendig å slå sammen to aktive kontoer, vennligst ta kontakt med Orgbrains kundestøtte.
      `,
    en: `Here you have the option to change the e-mail address to which your user account is linked.
      You can only change to an email address that is not already in use at Orgbrain. If it is necessary to merge two active accounts, please contact Orgbrain's customer support.
      `,
  },
  TransactionEmails: {
    en: 'E-mail',
    nb: 'E-post',
  },
  TransactionEmailsInfo: {
    en: `Here you can choose who will receive an email about this transaction.`,
    nb: `Velg hvem som skal motta epost om denne transaksjonen.`,
  },
  AnnualPlan: {
    en: 'Annual plan',
    nb: 'Årsplan',
  },
  SearchOrgbrain: {
    en: 'Search Orgbrain',
    nb: 'Søk i Orgbrain',
  },
  passwordInfoBox: {
    nb: `Her har du mulighet til å endre passord som din brukerkonto er koblet til.`,
    en: `Here you have the option to change the password to which your user account is linked.`,
  },
  sportsidInfo: {
    en: `Here you can register authentication  using SportsID`,
    nb: `Her kan du registrere autentisering ved bruk av SportsID`,
  },
  irrelevantForCompanyValue: {
    en: `Irrelevant for the company value`,
    nb: `Irrelevant for selskapsverdien`,
  },
  irrelevantForCompanyValueTooltip: {
    en: `Mark this event as irrelevant for the company value. This will hide the price and volume for this event in graphs showing the company value or price history.`,
    nb: `Marker denne hendelsen som irrelevant for selskapsverdien. Dette vil skjule prisen og volumet for denne hendelsen i grafer som viser selskapsverdien eller prishistorikk.`,
  },
  bankidInfo: {
    en: `Here you can register the two-factor authentication (2FA) using BankID`,
    nb: `Her kan du registrere tofaktorautentiseringen (2FA) ved bruk av BankID`,
  },
  phoneInfo: {
    en: `Here you can enter and change your mobile number. This can be used, among other things, for two-factor authentication (2FA)`,
    nb: `Her kan du legge inn og endre mobilnummer. Dette kan blant annet benyttes ved tofaktorautentisering (2FA)`,
  },
  toptInfo: {
    en: `Here you can register the two-factor authentication (2FA) using an app that supports Google Authenticator and other apps that support TOTP (Time-based One-time Password).`,
    nb: `Her kan du registrere tofaktorautentiseringen (2FA) ved bruk av app gir støtte for Google Authenticator og andre apper som støtter TOTP (Time-based One-time Password).
      `,
  },
  AccountSettingsUserInformation: {
    en: 'User information',
    nb: 'Brukerinformasjon',
  },
  SessionAnddevicesSettingsTab: {
    en: 'Sessions and devices',
    nb: 'Økter og enheter',
  },
  TransferAccount: {
    en: 'Transfer account',
    nb: 'Overfør konto',
  },
  editingLocked: {
    nb: 'Lås opp for å endre',
    en: 'Unlock to make changes',
  },
  editingEnabled: {
    en: 'Editing enabled',
    nb: 'Redigering aktivert',
  },
  passwordLable: {
    en: 'Password',
    nb: 'Passord',
  },
  repeatPasswordLable: {
    en: 'Repeat password',
    nb: 'Repeter passord',
  },
  'self-service.PasswordsMustBeMessageX': {
    en: 'Passwords must be at least 8 characters including a number, a lowercase letter and an uppercase letter.',
    nb: 'Passord må være minst 8 tegn, inkludert et tall, en liten bokstav og en stor bokstav',
  },
  'self-service.SubmitRegistration': {
    en: 'Sign up',
    nb: 'Registrer deg',
  },
  'user-credential.PasswordsMustBeMessageX': {
    en: 'Passwords must be at least 8 characters including a number, a lowercase letter and an uppercase letter.',
    nb: 'Passord må være minst 8 tegn, inkludert et tall, en liten bokstav og en stor bokstav',
  },
  'password-error.PasswordsMustBeMessageX': {
    en: 'Passwords must be at least 8 characters including a number, a lowercase letter and an uppercase letter.',
    nb: 'Passord må være minst 8 tegn, inkludert et tall, en liten bokstav og en stor bokstav',
  },
  'password-error.TransferInviteButton': {
    en: 'Change email',
    nb: 'Endre e-post',
  },

  'user-credential.Logon': {
    en: 'Log in',
    nb: 'Logg inn',
  },
  passwordInfo: {
    nb: 'Som en sikkerhetsmekanisme har det blitt sent en e-post til deg med en lenke for å endre passord.',
    en: 'As a security measure, an email has been sent to you with a link to change your password.',
  },
  passwordMailSent: {
    en: 'Mail sent',
    nb: 'E-post sendt',
  },
  passwordSubject: {
    nb: 'Endre passord',
    en: 'Change password',
  },
  orgbrainPasswordTitle: { en: 'Orgbrain password', nb: 'Passord' },
  ResetPassword: {
    en: 'Reset',
    nb: 'Tilbakestill',
  },
  UploadNewRecording: {
    en: 'Upload new recording',
    nb: 'Last opp nytt opptak',
  },
  'password-prompt.Password': {
    en: 'Password',
    nb: 'Passord',
  },
  'password-error.Password': {
    en: 'Password',
    nb: 'Passord',
  },
  'password-error.RepeatPassword': {
    en: 'Repeat password',
    nb: 'Repeter passord',
  },
  'phone-settings.SetPhoneNumber': {
    en: 'Set Phone Number',
    nb: 'Registrer mobil',
  },
  'user-Credential.RecommendedTOTPAppsTitle': {
    en: 'Recommended TOTP apps',
    nb: 'Anbefalte apper for tofaktorautentisering (2FA)',
  },
  'phone-validation.ValidatePhoneNumber': {
    en: 'Validate Phone Number',
    nb: 'Bekreft telefonnummer',
  },
  'phone-validation.MobilePhonePlaceholder': {
    en: 'Phone number',
    nb: 'Mobilnummer',
  },
  'phone-validation.ValidateUnregisteredPhoneNumberSendCodeButton': {
    en: 'Send SMS code',
    nb: 'Send SMS-kode',
  },
  'phone-settings.MobilePhoneLabel': {
    en: 'Phone number',
    nb: 'Mobiltelefon',
  },
  'phone-settings.NewMobilePhoneLabel': {
    en: 'Phone number',
    nb: 'Nytt nummer',
  },
  'phone-settings.CurrentMobilePhonePlaceholder': {
    en: 'Current number',
    nb: 'Nåværende nummer',
  },
  CopyLink: {
    en: 'Copy link',
    nb: 'Kopier lenke',
  },
  SetNewParvalue: {
    en: 'Set new par value',
    nb: 'Sett ny pålydende verdi',
  },
  EditParValue: {
    en: 'Edit par value',
    nb: 'Rediger pålydende',
  },
  NoneLabel: {
    en: 'All labels',
    nb: 'Alle merkelapper',
  },
  RecipientsTooltip: {
    en: 'Select the recipients of the message',
    nb: 'Velg mottakere av meldingen',
  },
  BOARD: {
    en: 'The board',
    nb: 'Styret',
  },
  BOARDTooltip: {
    en: 'The message is only visible to users who have board access.',
    nb: 'Melding blir kun synlig for de som har styretilgang.',
  },
  AttachementInEmail: {
    nb: 'Vedlegg synlig i e-post',
    en: 'Attachments visible in email',
  },
  AttachementInEmailTooltip: {
    nb: 'OBS: Dersom du krysser av her, vil alle vedlegg bli synlig i e-post som sendes mottakerne.',
    en: 'NOTE: If you check this box, all attachments will be visible in the email sent to the recipients.',
  },

  messageIsAvailableInEmail: {
    en: 'The message is visible in  the email',
    nb: 'Meldingen er synlig i e-post',
  },
  StartConversation: {
    en: 'Start conversation',
    nb: 'Start samtale',
  },
  CopyMessageLinkTooltip: {
    en: 'Copy the link of the announcement to clipboard',
    nb: 'Kopier lenken til denne kunngjøringen til utklippstavlen',
  },
  CopyMessageLink: {
    en: 'Copy link',
    nb: 'Kopier lenke',
  },
  TranscriptionDialogTitle: {
    en: 'Meeting started',
    nb: 'Møte startet',
  },
  TranscriptionDialogText: {
    en: 'Would you like to start transcribing this meeting? This can also be done with the AI symbol in the toolbar.',
    nb: 'Ønsker du å starte transkripsjon av dette møtet? Dette kan også gjøres med AI-symbolet i verktøyslinjen.',
  },
  TranscriptionDialogButton: {
    en: 'Start transcription',
    nb: 'Start transkripsjon',
  },
  TranscriptionStarted: {
    en: 'Starting transcription process',
    nb: 'Starter transkripsjonsprosess',
  },
  SummarizingTranscription: {
    en: 'Summarizing transcription',
    nb: 'Oppsummerer transkripsjon',
  },
  GeneratingProtocol: {
    en: 'Generating protocol',
    nb: 'Genererer protokoll',
  },
  TranscriptionAwaiting: {
    en: 'Preparing data for transcription',
    nb: 'Klargjør data for transkripsjon',
  },

  TranscriptionProcessing: {
    en: 'Transcribing',
    nb: 'Transkriberer',
  },
  TranscriptionFinished: {
    en: 'Finishing transcription',
    nb: 'Ferdigstiller transkripsjon',
  },
  RecordingEnableConfirmTitle: {
    en: 'Enable recording',
    nb: 'Skru på møteopptak?',
  },
  RecordingDisableConfirmTitle: {
    en: 'Disable recording',
    nb: 'Skru av møteopptak?',
  },

  AttendanceDialogHeader: {
    en: 'Entities that you represent',
    nb: 'Eiere som du representerer',
  },
  AttendanceDialogHeaderProxies: {
    en: 'Proxies that you represent',
    nb: 'Fullmakter du har mottatt',
  },
  ErrorLoadingTranscriptions: {
    en: 'Error loading recordings',
    nb: 'Feil ved innlasting av møteopptak',
  },
  DeleteRecordingError: {
    en: 'Error deleting recording',
    nb: 'Feil ved sletting av møteopptak',
  },
  DeleteTranscriptionTitle: {
    en: 'Delete recording',
    nb: 'Slett møteopptak',
  },
  DeleteTranscriptionText: {
    en: 'Are you sure you want to delete this recording?',
    nb: 'Er du sikker på at du vil slette dette møteopptaket?',
  },
  RecordingEnableConfirmText: {
    en: 'Are you sure you want to enable recording of this meeting? Other meeting participants will be notified that the meeting is being recorded.',
    nb: 'Er du sikker på at du vil starte et opptak av dette møtet? Andre møtedeltakere vil bli varslet om at møtet blir tatt opp.',
  },
  RecordingDisableConfirmText: {
    en: 'Are you sure you want to stop recording of this meeting? Other meeting participants will be notified that the recording has been stopped.',
    nb: 'Er du sikker på at du vil avslutte opptak av dette møtet? Andre møtedeltakere vil bli varslet om at opptaket er stoppet.',
  },
  InvestorsHelpText1: {
    en: 'Here you can edit and add information about ',
    nb: 'Her kan du redigere og legge til informasjon om ',
  },
  InvestorsHelpText2: {
    en: '. The term «',
    nb: '. I aksjeeierboken bruker vi «',
  },
  InvestorsHelpText3: {
    en: '» is used as a collective term for both individuals and organizations that are part of the ',
    nb: '» som et samlebegrep for både personer og organisasjoner som inngår i ',
  },
  InvestorsHelpText4: {
    en: 'administration – this includes current ',
    nb: 'administrasjonen – dette omfatter nåværende ',
  },
  InvestorsHelpText5: {
    en: ', previous ',
    nb: ', tidligere ',
  },
  InvestorsHelpText6: {
    en: ' and potential new ',
    nb: ' og potensielle nye ',
  },
  InvestorsHelpText7: {
    en: '. You can also register one or more representatives associated with each ',
    nb: '. Du kan også registrere én eller flere representanter knyttet til hver ',
  },
  DeleteMessageTooltip: {
    en: 'Delete this message permanently',
    nb: 'Slett denne meldingen permanent',
  },
  nameSortTooltip: {
    en: 'Sort alphabetically by name of the shareholder (first name and company name)',
    nb: 'Sorteres alfabetisk etter navn på aksjonæren (fornavn og selskapsnavn)',
  },
  aboutBoardSchoolTooltip: {
    en: 'Read more about the Board School',
    nb: 'Les mer om Styreskolen',
  },
  identifiedBeneficialOwners: {
    en: 'The company believes that there are beneficial owners',
    nb: 'Virksomheten mener det er reelle rettighetshavere',
  },
  AttachDifferentUser: {
    en: 'Do you want to attach a different user to ',
    nb: 'Ønsker du å knytte en annen bruker til ',
  },
  ManualOnboardingHeader: {
    nb: 'Manuell registrering',
    en: 'Manual registration',
  },
  ManualRegistrationText1: {
    nb: 'Legg inn ',
    en: 'Enter ',
  },
  ManualRegistrationText2: {
    nb: ' én og én direkte i systemet. Passer godt for selskaper med få ',
    en: ' one by one directly into the system. Suitable for companies with few ',
  },
  AutomaticOnboardingHeader: {
    nb: 'Hent fra Skatteetaten',
    en: 'Fetch from Skatteetaten',
  },
  Details: {
    en: 'Details',
    nb: 'Detaljer',
  },
  NoClaims: {
    en: 'There does not appear to be any claims',
    nb: 'Det ser ikke ut til å være noen pant',
  },
  AutomaticOnboardingText: {
    nb: 'Kom raskt i gang med data hentet fra Skatteetaten. Tilleggsinformasjon kan legges inn senere.',
    en: 'Quickly get started with data fetched from the tax authority. Additional information can be added later.',
  },
  EditShares: {
    en: 'Edit shares',
    nb: 'Rediger aksjer',
  },
  ShareclassStep: { nb: 'aksjeklasser', en: 'Share classes' },
  AddInvestorStep: { nb: 'Investorer', en: 'Investors' },
  AddShareHolderData: { nb: 'Oversikt', en: 'Overview' },
  shareClassTableHeader: { nb: 'Aksjeklasse', en: 'Share class' },
  dividendTableHeader: { nb: 'Beløp per aksje', en: 'Price per share' },
  totalTableHeader: { nb: 'Total pris', en: 'Total price' },
  ImportEventSharePriceTooltip: {
    nb: 'Aksjekursen brukes ved simulering av selskapets verdi. Denne kan legges inn senere ved å redigere hendelsen.',
    en: 'The share price is used when simulating the value of the company. This can be added later by editing the event.',
  },
  ImportEvent: {
    nb: 'Rediger øyeblikksbilde',
    en: 'Edit snapshot',
  },
  ShareholderDataText: { nb: 'Hendelsesinformasjon', en: 'Event information' },
  ShareholderDataSubText: {
    nb: 'Her kan du endre mellom stiftelse eller øyeblikksbilde',
    en: 'Choose between a snapshot or a incorporation',
  },
  UploadTransactionHistoryHeader: {
    nb: `Om opplasting`,
    en: `About upload`,
  },
  UploadTransactionHistoryText1: {
    nb: 'Her kan du laste opp et regneark som inneholder en komplett oversikt over historiske hendelser som påvirker aksjonærregisteret i selskapet. Du får mulighet til å gjennomgå og bekrefte resultatene før innsending.',
    en: `Here you can upload a spreadsheet with an overview of the shareholders and their positions in the company. You will have the opportunity to review and confirm the data before it is saved.`,
  },
  UploadTransactionHistoryText2: {
    nb: `Bruk knappen "Last ned mal" for å laste ned en mal for hendelseshistorikken som kan brukes ved opplasting.`,
    en: `Use the "Download template" button to download a template for the transaction history that can be used for upload.`,
  },
  UploadSnaphotText11: {
    nb: 'Her kan du laste opp et regneark med en oversikt over ',
    en: `Here you can upload a spreadsheet with an overview of `,
  },
  UploadSnaphotText12: {
    nb: ' og deres posisjoner i selskapet. Du får mulighet til å gjennomgå og bekrefte dataene før de lagres.',
    en: ` and their positions in the company. You will have the opportunity to review and confirm the data before it is saved.`,
  },
  UploadSnaphotText2: {
    nb: `Bruk knappen "Last ned mal" for å laste ned en eksempelmal som kan brukes ved opplasting.`,
    en: `Use the "Download template" button to download an example template that can be used for upload.`,
  },

  uploadImportSpreedsheetText: {
    nb: 'Du kan også lese mer om hvordan malen fungerer her',
    en: 'You can also read more about how the template works her',
  },
  here: {
    nb: 'her',
    en: 'here',
  },
  TransactionImportGeneralInformation: {
    nb: 'Importer hendelseshistorikk',
    en: 'Import transaction history',
  },
  ImportSnapshotGeneralInformation: {
    nb: 'Importer øyeblikksbilde',
    en: 'Import snapshot',
  },
  ShareRegisterInfoInvestor1: {
    nb: 'Her kan du få en oversikt over ',
    en: 'Here you can get an overview of the ',
  },
  ShareRegisterInfoInvestor2: {
    nb: ' i foretaket.',
    en: ' in the company.',
  },
  NoShareholders1: {
    nb: 'Det et foreløpig ingen ',
    en: 'There are currently no ',
  },
  NoShareholders2: {
    nb: ' registrert i ',
    en: ' registered in the ',
  },
  InfoHoverBoxHeader: {
    nb: 'Informasjon',
    en: 'Information',
  },
  ImportTaxData: { nb: 'Import', en: 'Import' },
  TaxDataFound: {
    nb: 'Vil du importere data fra Skatteetaten?',
    en: 'Would you like to import data from Skatteetaten?',
  },
  TaxDataFoundText: {
    nb: 'Ved å benytte Skatteetatens virksomhetsdata har Orgbrain identifisert aksjedata for selskapet ditt. Ønsker du å bruke denne informasjonen for å forenkle utfyllingen av aksjonærregisteret?',
    en: "By using the tax authority's business data, Orgbrain has identified shareholder information for your company. Would you like to use this data to simplify filling out the shareholder register?",
  },
  TaxDataFoundWarning: {
    nb: 'OBS: Dataene gjelder per 31. desember det året Skatteetaten har gjort informasjonen tilgjengelig. Dersom det har skjedd endringer i selskapet etter denne datoen, må du oppdatere aksjonærinformasjonen manuelt.',
    en: 'NOTE: The data applies as of December 31 of the year the tax authority has made the information available. If there have been changes in the company after this date, you must update the shareholder information manually.',
  },
  AddEmailsWarningOnboarding1: {
    nb: 'For å forbedre nytten du får av Orgbrain er det anbefalt å legge til e-postadresser på ',
    en: 'To improve the usefulness you get from Orgbrain, it is recommended to add email addresses to the ',
  },
  AddEmailsWarningOnboarding2: {
    nb: '. Dette kan også gjøres på et senere tidspunkt.',
    en: '. This can also be done at a later time.',
  },
  Skip: { nb: 'Hopp over', en: 'Skip' },
  UseTaxData: { nb: 'Bruk skattedata', en: 'Use tax data' },
  UploadShareHistory: {
    en: 'Upload transaction history',
    nb: 'Last opp hendelseshistorikk',
  },
  UploadSnapshot: {
    en: 'Upload snapshot',
    nb: 'Last opp øyeblikksbilde',
  },
  ExportDialogTitle: {
    en: 'Download ',
    nb: 'Last ned ',
  },
  UploadTemplateDescription: {
    en: 'Choose how you want to upload the shareholder register',
    nb: 'Velg hvordan du vil laste opp aksjeeierboken',
  },
  ExportDialogDescription1: {
    en: 'Choose between downloading the ',
    nb: 'Velg mellom å laste ned ',
  },
  ExportDialogDescription2: {
    en: ' as a PDF or spreadsheet.',
    nb: ' som PDF eller regneark.',
  },
  downloadSnapshotText1: {
    en: 'Download a snapshot of the ',
    nb: 'Last ned et øyeblikksbilde av ',
  },
  downloadSnapshotText2: {
    en: ' as a spreadsheet to your computer.',
    nb: '  som et regneark til din datamaskin.',
  },
  downloadSnapshotPDFText1: {
    en: 'Download a snapshot of the ',
    nb: 'Last ned et øyeblikksbilde av ',
  },
  downloadSnapshotPDFText2: {
    en: ' as a PDF to your computer.',
    nb: ' som et PDF-dokument til din datamaskin.',
  },
  nameTableHeader: { nb: 'Navn', en: 'Name' },
  Unknown: {
    en: 'Unknown',
    nb: 'Ukjent',
  },
  RepeatShareClassError1: {
    en: 'This combination of ',
    nb: 'Denne kombinasjonen av ',
  },
  RepeatShareClassError2: {
    en: ' and',
    nb: ' og ',
  },
  RepeatShareClassError3: {
    en: ' already exists',
    nb: ' finnes allerede',
  },
  noneBeneficialOwners: {
    en: 'The company believes that there are no beneficial owners',
    nb: 'Virksomheten mener det ikke er noen reelle rettighetshavere',
  },
  none_identifiedBeneficialOwners: {
    en: 'The company believes that there are one or more beneficial owners, but can not identify these',
    nb: 'Virksomheten mener det finnes en eller flere reelle rettighetshavere, men kan ikke identifisere disse',
  },
  nullBeneficialOwnersError: {
    en: 'No status selected',
    nb: 'Ingen status valgt',
  },

  nullBeneficialOwners: {
    en: 'No status selected',
    nb: 'Ingen status valgt',
  },

  nullBeneficialOwnersShort: {
    en: 'No status selected',
    nb: 'Ingen status valgt',
  },
  SendInBeneficalOwnerTitle: {
    en: 'Send information to Altinn',
    nb: 'Send informasjon til Altinn',
  },
  SendInBeneficalOwnerText: {
    en: 'You can now log in to Altinn and submit status information about beneficial owners.',
    nb: 'Du kan nå logge inn i Altinn og sende inn statusinformasjon om reelle rettighetshavere.',
  },
  identifiedBeneficialOwnersShort: {
    en: 'Identified beneficial owners',
    nb: 'Identifisert reelle rettighetshavere',
  },
  noneBeneficialOwnersShort: { en: 'No beneficial owners', nb: 'Ingen reelle rettighetshavere' },
  none_identifiedBeneficialOwnersShort: {
    en: 'Not identified beneficial owners',
    nb: 'Ikke identifisert reelle rettighetshavere',
  },
  NoTransactionsHelpText: {
    en: 'There are currently no transactions.',
    nb: 'Det er ingen registrerte hendelser.',
  },
  NoShareRegistryAltinn: {
    en: 'You have not created a shareholder book.',
    nb: 'Du har ikke opprettet aksjeeierbok.',
  },
  NoProtocolGenerated: {
    en: 'It was not possible to generate a protocol for this meeting',
    nb: 'Det var ikke mulig å generere protokoll for dette møtet',
  },
  ShareclassFormHelpText1: {
    nb: 'Her legger du ved ',
    en: 'Here you add the ',
  },
  ShareclassFormHelpText2: {
    nb: ' i selskapet ditt. Dette kan endres senere.',
    en: ' in your company. This can be changed later.',
  },
  InvestorFormHelpText1: {
    en: 'Here you can add ',
    nb: 'Her kan du legge til ',
  },
  InvestorFormHelpText2: {
    en: ' that are part of the ',
    nb: ' som skal være del av ',
  },
  SignProtocolMeeting: {
    en: 'Signing',
    nb: 'Signering',
  },
  SendSigningInvitationStep: {
    en: 'Invite to sign',
    nb: 'Inviter til signering',
  },
  InvestorFormHelpText3ForAS: {
    en: 'Their positions will be registered in the next step.',
    nb: 'Deres akjseposter blir registrert på neste steg.',
  },

  LeadingPeople: {
    en: 'Leading people',
    nb: 'Ledende personer',
  },
  FreeTestFor14Days: {
    en: 'Free test for 14 days',
    nb: 'Gratis testperiode i 14 dager',
    sv: 'Gratis testperiod i 14 dagar',
  },
  Annualayment: {
    en: 'Annual payment',
    nb: 'Årsavtale',
    sv: 'Årsavtal',
  },
  MonthlyPayment: {
    en: 'Monthly payment',
    nb: 'Månedsavtale',
    sv: 'Månadsavtal',
  },
  Custom: {
    en: 'Custom',
    nb: 'Egendefinert',
    sv: 'Anpassad',
  },
  SubscriptionIsManagedBySubgroupParent: {
    en: 'The subscription is managed by the parent group',
    nb: 'Abonnementet administreres av undergruppens overordnede organisasjon',
    sv: 'Prenumerationen hanteras av undergruppens överordnade organisation',
  },
  DaughterCompanies: {
    en: 'Daughter companies',
    nb: 'Datterselskaper',
    sv: 'Dotterbolag',
  },
  None: {
    en: 'None',
    nb: 'Ingen',
    sv: 'Ingen',
  },
  'boardschool.CongratulationsOnPassingTheExam': {
    en: 'Congratulations on passing the exam!',
    nb: 'Gratulerer med bestått eksamen!',
    sv: 'Grattis till godkänd tentamen!',
  },
  'boardschool.YouHaveNowPassedTheExamForTheBoardschool': {
    en: 'You have now passed the exam for the Boardschool',
    nb: 'Du har nå bestått eksamen for Styreskolen.',
    sv: 'Du har nu godkänt tentamen för Styreskolan.',
  },
  'boardschool.YouCanDownloadYourCertificateByClickingTheButtonBelow': {
    en: 'You can download your certificate by clicking the button below.',
    nb: 'Du kan laste ned sertifiseringsbeviset ditt ved å klikke på knappen nedenfor.',
    sv: 'Du kan ladda ner ditt certifikat genom att klicka på knappen nedan.',
  },
  'boardschool.GoToBoardschool': {
    en: 'Go to the Boardschool',
    nb: 'Gå til Styreskolen',
    sv: 'Gå till Styreskolan',
  },
  'boardschool.ReminderBoardschool': {
    en: 'Reminder: Boardschool',
    nb: 'Påminnelse: Styreskolen',
    sv: 'Påminnelse: Styreskolan',
  },
  'boardschool.ReminderOfNotCompletingTheBoardschoolCourseText': {
    en: 'We remind you that you have not yet completed the certification course in board work from the Board School.',
    nb: 'Vi minner deg på at du ennå ikke har fullført sertifiseringskurset i styrearbeid fra Styreskolen.',
    sv: 'Vi påminner dig om att du ännu inte har slutfört certifieringskursen i styrelsearbete från Styreskolan.',
  },
  'boardschool.ClickTheButtonBelowToGoToTheBoardSchool': {
    en: 'Click the button below to go to the Board School.',
    nb: 'Klikk på knappen nedenfor for å gå til Styreskolen.',
    sv: 'Klicka på knappen nedan för att gå till Styreskolan.',
  },
  'billing.confirmOrder': {
    en: 'Confirm order',
    nb: 'Bekreft bestilling',
  },
  'billing.confirmOrderMoreText': {
    en: 'You are about to order a subscription. Thank you for choosing Orgbrain!',
    nb: 'Du er i ferd med å bestille et abonnement. Takk for at du velger Orgbrain!',
  },
  'billing.youCanReadMore': {
    en: 'You can read more about our prices at',
    nb: 'Du kan lese mer om prisene våre på',
  },
  'billing.webpage': {
    en: 'the website',
    nb: 'nettsiden',
  },
  'billing.OnlyForCompaniesWithLessThan3MillionInTurnoverAnd10MillionInBalanceSheetValue': {
    en: 'Only for companies with less than NOK 3 million in turnover and NOK 10 million in balance sheet value. (Duration: max 24 months)',
    nb: 'Kun for selskaper som har under 3 millioner kroner i omsetning og 10 millioner kroner i balanseverdi. (Varighet: maks 24 måneder)',
    sv: 'Endast för företag med mindre än 3 miljoner i omsättning och 10 miljoner i balansräkning. (Varaktighet: max 24 månader)',
  },
  'billing.OnlyForCompaniesWithLessThan10MillionInTurnover': {
    en: 'Only for companies with less than NOK 10 million in turnover.',
    nb: 'Kun for selskaper som har under 10 millioner kroner i omsetning.',
    sv: 'Endast för företag med mindre än 10 miljoner i omsättning.',
  },
  'billing.Included6Users': {
    en: 'Included 6 users',
    nb: 'Inkludert 6 brukere',
    sv: 'Inkluderat 6 användare',
  },
  'billing.ActiveTestSubscription': {
    nb: 'Aktivert prøveabonnement',
    en: 'Activated test subscription',
    sv: 'Aktiverat testabonnemang',
  },
  'billing.ForMediumCompanies': {
    en: 'For medium-sized companies',
    nb: 'For mellomstore selskaper',
    sv: 'För medelstora företag',
  },
  'billing.OtherSubscriptions': {
    en: 'Other subscriptions',
    nb: 'Andre abonnement',
    sv: 'Andra prenumerationer',
  },
  'billing.foradmins': {
    en: 'For administrators',
    nb: 'For administratorer',
    sv: 'För administratörer',
  },
  'billing.ForNIForganizations': {
    en: 'For NIF organizations',
    nb: 'For NIF-organisasjoner',
    sv: 'För NIF-organisationer',
  },
  'billing.Services': {
    en: 'Services',
    nb: 'Tjenester',
    sv: 'Tjänster',
  },
  'billing.daysleft': {
    en: 'days left',
    nb: 'dager igjen',
    sv: 'dagar kvar',
  },
  'billing.dayleft': {
    en: 'day left',
    nb: 'dag igjen',
    sv: 'dag kvar',
  },
  'billing.StorrageSpace': {
    en: 'Storage',
    nb: 'Lagringsplass',
    sv: 'Lagringsutrymme',
  },
  'billing.FreeForShareholders': {
    en: 'Free for shareholders',
    nb: 'Gratis for aksjonærbrukere',
    sv: 'Gratis för aktieägare',
  },
  'billing.OnlyForCompaniesLessThen3MillionInTurnoverAnd5MillionInBalanceSheetValue': {
    en: 'Only for companies with less than NOK 3 million in turnover and NOK 5 million in balance sheet value.',
    nb: 'Kun for foretak med under 3 millioner kroner i omsetning og 5 millioner kroner i balanseverdi.',
    sv: 'Endast för företag med mindre än 3 miljoner i omsättning och 5 miljoner i balansräkning.',
  },
  'billing.OnlyForCompaniesLessThen10MillionInTurnover': {
    en: 'Only for companies with less than NOK 10 million in turnover and NOK 10 million in balance sheet value.',
    nb: 'Kun for foretak med under 10 millioner kroner i omsetning og 10 millioner kroner i balanseverdi.',
    sv: 'Endast för företag med mindre än 10 miljoner i omsättning och 10 miljoner i balansräkning.',
  },
  'billing.DurationMax24Months': {
    en: 'Duration max 24 months.',
    nb: 'Varighet maks 24 måneder.',
    sv: 'Varaktighet max 24 månader.',
  },
  'billing.ExtraSubscriptions': {
    en: 'Extra subscriptions',
    nb: 'Ekstra abonnement',
    sv: 'Extra prenumeration',
  },
  'billing.InvoiceInformation': {
    en: 'Invoice information',
    nb: 'Fakturainformasjon',
    sv: 'Fakturainformation',
  },
  'billing.SubgroupUsers': {
    en: 'Subgroup users',
    nb: 'Gruppebrukere',
    sv: 'Gruppanvändare',
  },
  'billing.contactUsToChangePackage': {
    en: 'Please contact us to change package',
    nb: 'Kontakt oss for å endre pakken',
    sv: 'Kontakta oss för att ändra paketet',
  },
  'billing.noEndDate': {
    en: 'no end date',
    nb: 'ingen sluttdato',
    sv: 'ingen slutdatum',
  },
  'billing.Invoices': {
    en: 'Invoices',
    nb: 'Fakturaer',
    sv: 'Fakturor',
  },
  'billing.SigningBankID': {
    en: 'Signing BankID',
    nb: 'Signering BankID',
    sv: 'Signering BankID',
  },
  Storrage: {
    en: 'Storage',
    nb: 'Lagring',
    sv: 'Lagring',
  },
  'billing.StorageIncludedInGB': {
    en: 'Storage included in GB',
    nb: 'Lagring inkludert i GB',
    sv: 'Lagring inkluderat i GB',
  },
  'billing.PricePerExtraGBPerMonth': {
    en: 'Pris pr ekstra GB pr mnd (NOK)',
    nb: 'Price per extra GB per month (NOK)',
    sv: 'Pris per extra GB per månad (NOK)',
  },
  'billing.UserIdentification': {
    en: 'User identification',
    nb: 'Brukeridentifisering',
    sv: 'Användaridentifiering',
  },
  'billing.PricePerIdentification': {
    en: 'Price per identification (NOK)',
    nb: 'Pris pr identifisering (NOK)',
    sv: 'Pris per identifiering (NOK)',
  },
  'billing.SMSAuthentication': {
    en: 'Authentication with SMS',
    nb: 'Autentisering med SMS',
    sv: 'Autentisering med SMS',
  },
  'billing.PricePerSMS': {
    en: 'Price per SMS (NOK)',
    nb: 'Pris pr SMS (NOK)',
    sv: 'Pris per SMS (NOK)',
  },
  'billing.PricePerUserPerMonth': {
    en: 'Number of free signings per year',
    nb: 'Antall gratis signering per år',
    sv: 'Antal gratis signeringar per år',
  },
  'billing.PricePerUserPerMonthNOK': {
    en: 'Price per subsequent signature (NOK)',
    nb: 'Pris pr påfølgende signatur (NOK)',
    sv: 'Pris per efterföljande signatur (NOK)',
  },
  'billing.TrippeltexConnection': {
    en: 'Tripletex connection',
    nb: 'Tripletex tilkobling',
    sv: 'Tripletex tilkopling',
  },
  'billing.NotConnected': {
    en: 'Not connected',
    nb: 'Ikke tilkoblet',
    sv: 'Inte ansluten',
  },
  'billing.CreateNew': {
    en: 'Create new',
    nb: 'Opprett ny',
    sv: 'Skapa ny',
  },
  'billing.AccountManager': {
    en: 'Account manager',
    nb: 'Kontoansvarlig',
    sv: 'Kontoansvarig',
  },
  'billing.DueDays': {
    en: 'Due days',
    nb: 'Forfallsdager',
    sv: 'Förfallodagar',
  },
  'billing.SendInvoiceVia': {
    en: 'Send invoice via',
    nb: 'Send faktura via',
    sv: 'Skicka faktura via',
  },
  'billing.ElectronicInvoiceAddress': {
    en: 'Electronic invoice address',
    nb: 'Elektronisk fakturaadresse',
    sv: 'Elektronisk fakturaadress',
  },
  'billing.SendEmailInvoiceAs': {
    en: 'Send email invoice as',
    nb: 'Send e-postfaktura som',
    sv: 'Skicka e-postfaktura som',
  },
  'billing.Attachment': {
    en: 'Attachment',
    nb: 'Vedlegg',
    sv: 'Bilaga',
  },
  'billing.LinkOption': {
    en: 'Link',
    nb: 'Lenke',
    sv: 'Länk',
  },
  'meetings.Item': {
    en: 'Item',
    nb: 'Sak',
    sv: 'Ärende',
  },
  'meetings.hour': {
    en: 'hour',
    nb: 'time',
    sv: 'timme',
  },
  'meetings.hours': {
    en: 'hours',
    nb: 'timer',
    sv: 'timmar',
  },

  NotConfirmedAttendance1: {
    nb: 'Du har ikke bekreftet deltakelse på vegne av ',
    en: 'You have not confirmed attendance for ',
  },
  NotConfirmedAttendance22: {
    nb: ' du representerer.',
    en: ' you represent.',
  },
  ReOpenMeetingTooltip: {
    en: 'Re-open meeting for attendance',
    nb: 'Åpne møte på nytt for påmelding',
  },
  ReOpenMeeting: {
    en: 'Open participation',
    nb: 'Åpne påmelding',
  },
  NotConfirmedAttendance2: {
    nb: 'før møtestart. Du kan derfor ikke avgi stemme.',
    en: 'before the meeting starts. You can therefore not vote.',
  },
  NotConfirmedAttendanceWarningTip: {
    nb: 'Du kan ikke avgi stemme fordi deltakelsen ikke er bekreftet.',
    en: 'You cannot vote because your attendance has not been confirmed.',
  },

  'meetings.FollowingAreVisitingMeetingButHaveNotCorrectMeetingStatusDialog': {
    en: 'Unconfirmed users attending',
    nb: 'Ubekreftede brukere tilstede',
    sv: 'Följande besöker detta möte,  men har inte rätt närvarostatus',
  },
  'meetings.ChangeStatusToDialog': {
    en: 'The following users are attending the meeting page, but have not confirmed their attendance status: ',
    nb: 'Følgende brukere er tilstede på møtetsiden, men har ikke bekreftet deres oppmøtestatus: ',
    sv: 'Vill du ändra status för',
  },
  RepresentedVotes: {
    en: 'Represented votes',
    nb: 'Representerte stemmer',
  },
  'meetings.toAttendingDialog': {
    en: 'Do you want to change their status to attending?',
    nb: 'Ønsker du å bekrefte deres oppmøte?',
    sv: 'Vill du ändra status till att delta?',
  },
  'meetings.confirmChangeMeetingStatusDialog': {
    en: 'Please confirm changing meeting status',
    nb: 'Bekreft endring av møtestatus',
    sv: 'Bekräfta ändring av mötesstatus',
  },
  'meetings.NotAllRespondedDialog': {
    en: 'Not everyone has responded to invitation. When meeting status is not "called" only admin will be able to edit attendance status',
    nb: 'Ikke alle har svart på invitasjonen. Når møtestatus ikke er "innkalt", er det bare administrator som kan redigere oppmøtestatus',
    sv: 'Inte alla har svarat på inbjudan. När mötesstatus inte är "kallad" kan bara administratören redigera närvarostatus',
  },
  'meetings.agendaItemswithoutVotersParticipationDialog': {
    en: 'There are agenda items where not all participants have cast their vote. Proceed anyway?',
    nb: 'Det er agendapunkter der ikke alle deltakerne har avgitt sin stemme. Ønsker du likevel å avslutte møte?',
    sv: 'Det finns ärenden där inte alla deltagare har röstat. Vill du ändå avsluta mötet?',
  },
  'meetings.youHaveBeenInvitedTo': {
    en: 'Notice on',
    nb: 'Du har blitt invitert til et',
    sv: 'Du har blivit inbjuden till',
  },
  'meetings.forMoreInformationFollowThisLink': {
    en: 'For more information, follow this link:',
    nb: 'For mer informasjon, følg denne lenken:',
    sv: 'För mer information, följ denna länk:',
  },
  'meetings.NoticeOf': {
    en: 'Notice of',
    nb: 'Innkalling til',
    sv: 'Kallelse till',
  },
  'meeting.for': {
    en: 'for',
    nb: 'for',
    sv: 'för',
  },
  'meetings.WrittenProcedure': {
    en: 'Written procedure',
    nb: 'Skriftlig behandling',
    sv: 'Skriftligt förfarande',
  },
  'meetings.NoResponseYet': {
    en: 'No response yet',
    nb: 'Ingen svar ennå',
    sv: 'Inget svar ännu',
  },
  'meetings.attending': {
    en: 'Attending',
    nb: 'Deltar',
    sv: 'Deltar',
  },
  'meetings.proxy': {
    en: 'Proxy',
    nb: 'Fullmektig',
    sv: 'Fullmakt',
  },
  'meetings.notAttending': {
    en: 'Not attending',
    nb: 'Deltar ikke',
    sv: 'Deltar inte',
  },
  'meetings.with': {
    en: 'with',
    nb: 'med',
    sv: 'med',
  },
  'meetings.aTotalOf': {
    en: 'a total of',
    nb: 'totalt',
    sv: 'totalt',
  },
  'meetings.StatusWillBeSettTo': {
    en: 'Status will be set to',
    nb: 'Status blir satt til',
    sv: 'Status kommer att sättas till',
  },
  'meetings.DoYouWantToWithdrawProxyFor': {
    en: 'Would you like to withdraw proxy for',
    nb: 'Ønsker du å trekke fullmakten for',
    sv: 'Vill du dra tillbaka fullmakten för',
  },
  'meetings.WithdrawProxy': {
    en: 'Withdraw proxy',
    nb: 'Trekk fullmakt',
    sv: 'Återkalla fullmakt',
  },
  'meetings.NoElectionMajorityVoteCast': {
    en: 'None of the alternatives was approved with a majority of the votes cast.',
    nb: 'Ingen av alternativene ble valgt med alminnelig flertall.',
    sv: 'Inget av alternativen godkändes med majoritet av de avgivna rösterna.',
  },
  'shareholders.user': {
    en: 'user',
    nb: 'bruker',
    sv: 'användare',
  },
  'shareholders.users': {
    en: 'users',
    nb: 'brukere',
    sv: 'användare',
  },
  'shareholders.aboutOrderFormFirst': {
    en: 'Here you create the order form that each investor must sign in connection with subscribing for shares. You can also upload any attachments that should be made available to the investor, such as a shareholder agreement or articles of association.',
    nb: 'Her oppretter du bestillingsblanketten som den enkelte investor skal signere i forbindelse med tegning av aksjer. Du kan også laste opp eventuelle vedlegg som skal gjøres tilgjengelig for investoren, for eksempel aksjonæravtale eller vedtekter.',
    sv: 'Här skapar du beställningsblanketten som varje investerare ska underteckna i samband med teckning av aktier. Du kan också ladda upp eventuella bilagor som ska göras tillgängliga för investeraren, såsom en aktieägaravtal eller bolagsordning.',
  },
  'shareholders.aboutOrderFormSecond': {
    en: 'An order form contains practical information about the capital increase, such as the subscription price, number of shares in the company and how the shares are subscribed for.',
    nb: 'En bestillingsblankett inneholder praktisk informasjon om kapitalinnhentingen, som tegningskurs, antall aksjer i selskapet og hvordan aksjene tegnes.',
    sv: 'En beställningsblankett innehåller praktisk information om kapitalanskaffningen, såsom teckningskurs, antal aktier i företaget och hur aktierna tecknas.',
  },
  'shareholders.aboutOrderFormThird': {
    en: 'Orgbrain has prepared a general template with suggested text that can be used in the order form. The template is adapted to situations where the decision to carry out the capital increase is made afterwards, either at a general meeting or a board meeting (provided that the board has been given the necessary authorization). You can easily edit the content of the template as needed.',
    nb: 'Orgbrain har utarbeidet en generell mal med forslag til tekst som kan brukes i blanketten. Malen er tilpasset situasjoner der beslutningen om å gjennomføre kapitalforhøyelsen tas i etterkant, enten i en generalforsamling eller et styremøte (forutsatt at styret har fått nødvendig fullmakt). Du kan enkelt redigere innholdet i malen etter behov.',
    sv: 'Orgbrain har tagit fram en generell mall med förslag på text som kan användas i beställningsblanketten. Mallen är anpassad till situationer där beslutet att genomföra kapitalökningen fattas i efterhand, antingen vid en bolagsstämma eller ett styrelsemöte (förutsatt att styrelsen har fått nödvändigt bemyndigande). Du kan enkelt redigera innehållet i mallen efter behov.',
  },
  'shareholders.aboutOrderFormFourth': {
    en: 'When you go through the template, you will see several open fields where you should fill in relevant information. Enter what is tailored to your capital increase.',
    nb: 'Når du går gjennom malen, vil du se flere åpne felt hvor du skal fylle inn relevant informasjon. Legg inn det som er tilpasset din kapitalforhøyelse.',
    sv: 'När du går igenom mallen kommer du att se flera öppna fält där du ska fylla i relevant information. Ange det som är anpassat till din kapitalökning.',
  },
  'shareholders.aboutOrderFormFifth': {
    en: 'If you are unsure about what the order form should contain, or if you do not know the regulations for capital increases well enough, we recommend that you contact a legal advisor with expertise in company law.',
    nb: 'Dersom du er usikker på hva bestillingsblanketten bør inneholde, eller ikke kjenner regelverket for kapitalforhøyelser godt nok, anbefaler vi å kontakte en juridisk rådgiver med kompetanse innen selskapsrett.',
    sv: 'Om du är osäker på vad som ska ingå i just ditt formulär, eller om du saknar kunskap om vad du behöver göra i samband med en kapitalökning rekommenderar vi att du kontaktar en juridisk rådgivare som har kompetens inom bolagsrätt.',
  },
  'shareholders.aboutOrderFormSixth': {
    en: 'The form is sent to the investors, who sign the document digitally in PDF format.',
    nb: 'Blanketten sendes til investorene, som signerer dokumentet digitalt i PDF-format.',
    sv: 'Blanketten skickas till investerarna, som signerar dokumentet digitalt i PDF-format.',
  },
  'shareholders.aboutOrderFormSeventh': {
    en: 'You can go back and adjust the form all the way up to when you invite the investors.',
    nb: 'Du kan gå tilbake og justere blanketten helt frem til du inviterer investorene.',
    sv: 'Du kan gå tillbaka och justera blanketten ända fram till att du bjuder in investerarna.',
  },
  'shareholders.aboutOrderFormEighth': {
    en: 'You can read more about how capital increases work on our support page.',
    nb: 'Du kan lese mer om hvordan kapitalforhøyelse fungerer på vår supportside.',
    sv: 'Du kan läsa mer om hur kapitalökning fungerar på vår supportsida.',
  },
  'shareholders.invitesYouToParticipateInAnEquityIssueFirstParagraph': {
    en: '("the Company"), carries out a capital increase through new subscription of shares. On that occasion, this form is used to describe the conditions of the capital increase, and to obtain a binding order for shares from those who wish to participate in the capital increase.',
    nb: '(«Selskapet»), gjennomfører en kapitalforhøyelse gjennom nytegning av aksjer. I den anledning benyttes denne blanketten for å beskrive betingelsene i kapitalforhøyelsen, og for å innhente bindende bestilling av aksjer fra de som ønsker å delta i kapitalforhøyelsen.',
    sv: '("Bolaget"), genomför en kapitalökning genom teckning av nya aktier. I Vid detta tillfälle används denna form för att beskriva förhållandena i kapitalökning, och att erhålla bindande beställningar av aktier från dem som vill delta i kapitalökningen.',
  },
  'shareholders.invitesYouToParticipateInAnEquityIssueSecondParagraph': {
    en: 'We point out that no special prospectus has been prepared in connection with this capital increase, cf. the Securities Trading Act, Chapter 7.',
    nb: 'Vi gjør oppmerksom på at det ikke er utarbeidet et særskilt prospekt i forbindelse med denne kapitalforhøyelsen, jf. verdipapirhandelloven kapittel 7.',
    sv: 'Vänligen notera att inget särskilt prospekt har upprättats med anledning av med denna kapitalökning, jfr 7 kap.',
  },
  'shareholders.invitesYouToParticipateInAnEquityIssueThirdParagraph': {
    en: "The final decision on the implementation of the capital increase is made by the general meeting or in a board meeting based on an authorization given by the general meeting. By decision of the general meeting, the subscription of the new shares in the minutes of the general meeting takes place. In the case of a subscription based on a board authorization, the new shares are subscribed for on a document that reproduces the general meeting's decision on the board authorization and the board's decision on the capital increase.",
    nb: 'Endelig beslutning om gjennomføring av kapitalforhøyelsen treffes av generalforsamlingen eller i styremøte basert på fullmakt gitt av generalforsamlingen. Ved beslutning i generalforsamling, skjer tegningen av de nye aksjene i protokollen for generalforsamlingen. Ved tegning basert på styrefullmakt, skjer tegningen av de nye aksjene på et dokument som gjengir generalforsamlingens beslutning om styrefullmakt og styrets beslutning om kapitalforhøyelse.',
    sv: 'Det slutliga beslutet om genomförandet av kapitalökningen kommer att fattas av bolagsstämma eller vid ett styrelsemöte med stöd av ett bemyndigande från Generalförsamling. För det fall bolagsstämman beslutar ska teckning av den nya aktierna i protokollet från bolagsstämman. Vid teckning baserad på ett styrelsebemyndigande, Teckningen av de nya aktierna sker i ett dokument som återger bolagsstämmans Beslut om bemyndigande för styrelsen och styrelsens beslut om kapitalökning.',
  },
  'shareholders.invitesYouToParticipateInAnEquityIssueFourthParagraph': {
    en: "In connection with the capital increase, the shareholders' pre-emptive rights pursuant to section 10-4 of the Norwegian Companies Act may be waived.",
    nb: 'I forbindelse med kapitalforhøyelsen kan aksjeeiernes fortrinnsrett etter aksjeloven § 10-4 fravikes.',
    sv: 'I samband med kapitalökningen kommer aktieägarnas företrädesrätt enligt aktiebolagslagen att Avvikelse görs från §§ 10-4.',
  },
  'shareholders.companyInformationFirstParagraph': {
    en: "Investor presentation, articles of association, the notice convening the general meeting with appendices as well as the annual accounts and the annual report for the last two years are kept available at the Company's office.",
    nb: 'Investorpresentasjon, vedtekter, innkallingen til generalforsamling med vedlegg samt årsregnskapet og årsberetningen for de to siste år, holdes tilgjengelig på Selskapets kontor.',
    sv: 'Investerarpresentation, bolagsordning, kallelse till bolagsstämma och bilagor samt årsredovisningen och förvaltningsberättelsen för de två senaste åren, finns tillgängliga på Företagets kontor.',
  },
  'shareholders.companyInformationSecondParagraph': {
    en: 'Information as mentioned above, as well as other relevant information, can also be sent by e-mail by contacting the Company through the chairman of the board.',
    nb: 'Informasjon som nevnt over, samt annet annen relevant informasjon, kan også sendes per e-post ved henvendelse til Selskapet ved styrets leder.',
    sv: 'Information som nämns ovan, liksom annan relevant information, kan också skickas via e-post om Bolaget blir kontaktat av styrelsens ordförande.',
  },
  'shareholders.ImportIdentifierHelptext1': {
    en: 'Orgbrain uses three different identifiers to identify existing',
    nb: 'Orgbrain bruker tre forskjellige identifikatorer for å identifisere eksisterende',
  },
  'shareholders.ImportIdentifierHelptext2': {
    en: 'in the registry from an import.',
    nb: 'i registeret fra en import.',
  },
  'shareholders.ImportIdentifierHelptext3': {
    en: 'and, when none of these exist,',
    nb: 'og, når ingen av disse eksisterer,',
  },
  'shareholders.organizationNumbrs': {
    en: 'organization numbers',
    nb: 'orgnr',
  },
  'shareholders.Orgno': {
    en: 'Orgno',
    nb: 'Orgnr',
  },
  'shareholders.Dob': {
    en: 'Dob',
    nb: 'Fødselsdato',
  },
  'shareholders.EmailSuggestions': {
    en: 'Email suggestions',
    nb: 'Klikk for forslag til e-post"',
  },
  'shareholders.FirstName': {
    en: 'First name',
    nb: 'Fornavn',
  },
  'shareholders.LastName': {
    en: 'Last name',
    nb: 'Etternavn',
  },
  'shareholders.names': {
    en: 'names',
    nb: 'navn',
  },
  'shareholders.Company': {
    en: 'Company',
    nb: 'Selskap',
  },
  'shareholders.ImportBisnodeData': {
    en: 'Bisnode',
    nb: 'Bisnode',
  },
  'shareholders.CSV': {
    en: 'CSV',
    nb: 'CSV',
  },
  'shareholders.Onboard': {
    en: 'Onboard',
    nb: 'Legge inn',
  },
  'shareholders.ImportTaxofficeData': {
    en: 'Import Taxoffice Data',
    nb: 'Hent data fra Skatteetaten',
  },
  'shareholders.ClearTable': {
    en: 'Clear table',
    nb: 'Tøm tabell',
  },
  'shareholders.NoShareholdersHelpText5': {
    en: ' or add them directly by using the new ',
    nb: ' eller legge dem til direkte ved å bruke ny ',
  },
  'shareholders.NoShareholdersHelpText6': {
    en: ' button.',
    nb: ' knappen.',
  },
  'shareholders.withoutSharestext': { en: 'without', nb: 'uten' },
  'shareholders.withSharestext': { en: 'with', nb: 'med' },
  'shareholders.All': { en: 'All', nb: 'Alle' },
  'shareholders.ImportEmailsHelptext1': {
    en: 'Orgbrain assumes that each physical',
    nb: 'Orgbrain antar at hver enkel',
  },
  'shareholders.ImportEmailsHelptext2': {
    en: 'has a unique email, this is to distinguish and identify who voted in a general assembly. The email is used to generate a unique user for',
    nb: 'har en unik e-post. Dette er for å kunne skille mellom hvilken bruker som stemte i en generalforsamling. E-posten blir brukt når en unik bruker blir laget for',
  },
  'shareholders.ImportEmailsHelptext3': {
    en: 'and preferably it should be included in an import.',
    nb: ' En e-postaddresse bør helst være med i en import.',
  },
  'shareholders.Email': {
    en: 'Email',
    nb: 'E-post',
  },
  'shareholders.OrganizationNumber': {
    en: 'Organization number',
    nb: 'Organisasjonsnummer',
  },
  'shareholders.ImportOrgNrHelptext': {
    en: 'To identify organizations, Orgbrain uses org numbers which by definition is unique to the individual organization.',
    nb: 'brukes som en identifiserende kolonne for organisasjoner.',
  },
  'shareholders.ImportFirstLastNameHelptext1': {
    en: 'First name and last name',
    nb: 'Fornavn og etternavn',
  },
  'shareholders.ImportFirstLastNameHelptext2': {
    en: 'This is the preferred way to input names through a spreadsheet. Because Orgbrain does not need to make an assumption on what is a lastname and what is a firstname. Preferably this should be the legal name of the physical',
    nb: 'Dette er den foretrukne måten å inkludere navn på i importdataen. Fordi Orgbrain ikke må gjøre antakelser om hva som er fornavn og etternavn. Disse navnene bør helst være det juridiske navnet til personen.',
  },
  'shareholders.ImportFirstLastNameHelptext3': {
    en: 'to make subsequent imports easier.',
    nb: 'for å gjøre senere import enklere.',
  },
  'shareholders.ImportNameOfOrgHelpText1': {
    en: 'Name of organization',
    nb: 'Navn på organisasjon',
  },
  'shareholders.ImportNameOfOrgHelpText2': {
    en: 'Is not used as an identifier, but Orgbrain requires the extra information to help you distinguish between the organizations easily.',
    nb: 'Blir ikke brukt som en identifiserende kolonne, men Orgbrain behøver denne informasjonen for å hjelpe deg med å enkelt identifisere hvilke organisasjoner som er del av registeret.',
  },
  'shareholders.ImportFullNameHelpText1': {
    en: 'Full name',
    nb: 'Fullt navn',
  },
  'shareholders.ImportFullNameHelpText2': {
    en: 'Orgbrain splits the last part off of the name field and uses this as a lastname, the rest is treated as a first name. In many cases this type of name is not preferred by you, the user, nor Orgbrain.',
    nb: 'Dersom du ikke klarer å skille fornavn og etternavn i to kolonner, må du i importregnearket lage en kolonne med overskriften "Fullt navn" der du legger inn det fulle navnet sammen sammen med øvrig informasjon. Orgbrain deler det fulle navnet i to, hvor det siste navnet blir brukt som etternavn, og de resterende navnene blir brukt som fornavn. Vi anbefaler at dere deler opp navnet korrekt i to kolonner før dere laster inn data.',
  },
  'shareholders.ImportASShareinfoTitle': {
    en: 'names',
    nb: 'navn',
  },
  'shareholders.OrgbrainUses': {
    en: 'Orgbrain uses ',
    nb: 'Orgbrain bruker ',
  },
  'shareholders.ImportASShareinfoHelptext2': {
    en: ' Name of ',
    nb: ' Navn på ',
  },
  'shareholders.ImportASShareinfoHelptext3': {
    en: ' to identify the position of ',
    nb: ' for å identifisere posisjonen til ',
  },
  'shareholders.ImportASShareinfoHelptext4': {
    en: ' in the registry.',
    nb: ' i registeret.',
  },
  'shareholders.orgbrainUses': {
    en: 'Orgbrain uses ',
    nb: 'Orgbrain bruker ',
  },
  'shareholders.ImportFLIHelptext1': {
    en: 'to identify the position of',
    nb: 'for å identifisere posisjonen til',
  },
  'shareholders.ImportFLIHelptext2': {
    en: 'in the registry.',
    nb: 'i registeret.',
  },
  'shareholders.NumberOfSharesImportsHelpText1': {
    en: 'Here you enter the total ',
    nb: 'Her legger du inn totalt ',
  },
  'shareholders.NumberOfSharesImportsHelpText2': {
    en: ' that the',
    nb: ' som',
  },
  'shareholders.NumberOfSharesImportsHelpText3': {
    en: ' owns of the specific ',
    nb: ' for den konkrete ',
  },
  'shareholders.ShareNumbersImportsHelpText1': {
    en: 'Here you enter the assigned',
    nb: 'Her legger du inn tildelt',
  },
  'shareholders.ShareNumbersImportsHelpText2': {
    en: ' to the',
    nb: ' til',
  },
  'shareholders.HereYouEnterInThe': {
    en: 'Here you enter in the',
    nb: 'Her legger du inn i',
  },
  'shareholders.ImportsSharenumberHelptext1': {
    en: 'Is a comma separated list of',
    nb: 'er en kommaseparert liste med',
  },
  'shareholders.ImportsSharenumberHelptext2': {
    en: ' intervals. (example: "1-50, 200-250") This is an optional field, however Orgbrain generates the numbers if none is provided.',
    nb: ' (for eksempel: "1-50, 200-250"). Dette feltet er valgfritt. Om feltene ikke er korrekt formatert eller tomme vil Orgbrain varsle deg og gi deg muligheten til å generere nummere automatisk, basert på rekkefølgen i importdataen.',
  },
  'shareholders.ImportsShareclassHelptext1': {
    en: ' is the name of the ',
    nb: ' er navnet på ',
  },
  'shareholders.ImportsShareclassHelptext2': {
    en: ' of the position',
    nb: ' en som posisjonen innehar',
  },
  'shareholders.ImportSSNHelpText1': {
    en: 'Is the second part of a Norwegian identity numbe. It is also used as an extra identifier, and is important for tax reporting together with the',
    nb: 'Et nummer med 5 siffer som er den andre delen av et norsk fødselsnummer. Personnummer er viktig for skatterapportering, spesielt sammen med ',
  },
  'shareholders.ImportSSNHelpText2': {
    en: 'date of birth',
    nb: 'fødselsdato',
  },
  'shareholders.ImportSSNHelpText3': {
    en: ' This is the second part of a Norwegian identity number',
    nb: ' Disse to til sammen danner et norsk fødselsnummer',
  },
  'shareholders.ImportTelephoneNumber': {
    en: 'Telephone number',
    nb: 'Telefonnummer',
    sv: 'Telefonnummer',
  },
  'shareholders.ImportTelephoneNumberText': {
    en: 'The number of the',
    nb: 'Nummeret til',
    sv: 'Numret till',
  },
  'shareholders.ImportAddress': {
    en: 'Address',
    nb: 'Adresse',
  },
  'shareholders.OnboardingAddress': {
    en: 'Address',
    nb: 'Adresse',
  },
  'shareholders.BisnodeRef': {
    en: 'BisnodeRef.',
    nb: 'Bisnode-referanse',
  },

  'shareholders.ImportAddressText': {
    en: 'The address of the ',
    nb: 'Adressen til ',
  },
  'shareholders.ImportZIP': {
    en: 'ZIP',
    nb: 'Postnummer',
  },
  'shareholders.ImportZIPText': {
    en: ' the zip code of the',
    nb: ' Postnummeret til',
  },
  'shareholders.ImportCity': {
    en: 'City',
    nb: 'By',
  },
  'shareholders.ImportCityText': {
    en: 'The city of the ',
    nb: 'Byen til ',
  },
  'shareholders.ImportVPS': {
    en: 'VPS number',
    nb: 'VPS-nummer',
  },
  'shareholders.ImportVPSText': {
    en: 'The VPS number of the ',
    nb: 'VPS nummer for ',
  },
  'shareholders.ImportLEI': {
    en: 'LEI number',
    nb: 'LEI-nummer',
  },
  'shareholders.ImportLEIText': {
    en: 'The LEI number of the ',
    nb: 'LEI nummer for ',
  },
  'shareholders.ImportsShareclassHelptextContractVariant1': {
    en: 'is the name of the ',
    nb: 'er navnet på ',
  },
  'shareholders.ImportsShareclassHelptextContractVariant2': {
    en: ' that is to be used. Only the first contract for the users',
    nb: ' som skal brukes. Bare den første kontrakten for brukeren',
  },
  'shareholders.ImportsShareclassHelptextContractVariant3': {
    en: ' need to have the field filled in. If there is a contract in a different shareclass this will then need to have the field filled like the first.',
    nb: ' må ha feltet fylt ut. Hvis det er en kontrakt i en annen aksjeklasse, må dette feltet fylles ut som den første.',
  },
  'shareholders.Type': {
    en: 'Type',
    nb: 'Type',
    sv: 'Typ',
  },
  'shareholders.CapTable': {
    en: 'Cap table',
    nb: 'Cap table',
  },
  'shareholders.NoInvestorsHaveBeenAdded': {
    en: 'No investors have been added yet.',
    nb: 'Ingen investorer har blitt lagt til enda.',
    sv: 'Inga investerare har lagts till ännu.',
  },
  'shareholders.ImportExistingOwnersNotIdentified1': {
    en: 'Existing',
    nb: 'Eksisterende',
  },
  'shareholders.ImportExistingOwnersNotIdentified2': {
    en: 'that were not identified in the spreadsheet',
    nb: 'som ikke kunne bli identifisert i regnearket',
  },
  'shareholders.Some': {
    en: 'Some',
    nb: 'Noen',
  },
  'shareholders.SomeOwnersWereNotIdentified': {
    en: 'who are already in Orgbrain were not identified in the new import data. This is based on the fact that neither the email address, date of birth, social security number, organization number, name, or a combination of these match. Check that this is correct before completing the import.',
    nb: 'som er i Orgbrain fra før, ble ikke identifisert i de nye importdataene. Dette er basert på at verken e-postadresse, fødselsdato, personnummer, organisasjonsnummer, navnet, eller en kombinasjon av disse, matcher. Sjekk at dette stemmer før du fullfører importen.',
  },
  'shareholders.SomeOwnersWereNotIdentified1': {
    en: ' who are already in Orgbrain were not identified in the new import data. This is based on the fact that neither the email address, date of birth, social security number, organization number, name, or a combination of these match ',
    nb: ' som er i Orgbrain fra før, ble ikke identifisert i de nye importdataene. Dette er basert på at verken e-postadresse, fødselsdato, personnummer, organisasjonsnummer, navnet, eller en kombinasjon av disse, matcher ',
  },
  'shareholders.Conditions': {
    en: 'Conditions',
    nb: 'Betingelser',
  },
  'shareholders.UnderlyingShareclass': {
    en: 'Underlying shareclass',
    nb: 'Underliggende aksjeklasse',
  },
  'shareholders.ImportTheseEventsWillNotBeOverwritten': {
    en: 'These events happened after the chosen date and will not be overwritten:',
    nb: 'Disse hendelsene hendte etter den valgte datoen og vil ikke bli overskrevet',
  },
  'shareholders.EventRegistered': {
    en: 'Registered',
    nb: 'Registrert',
  },
  'shareholders.TypeOfLastEvent': {
    en: 'Last transaction',
    nb: 'Siste hendelse',
  },
  'shareholders.unique': {
    en: 'unique',
    nb: 'unik',
  },
  'shareholders.duplicateNames': {
    en: ' duplicate names',
    nb: ' duplikate navn',
  },
  'shareholders.with': {
    en: 'with',
    nb: 'med',
  },
  'shareholders.without': {
    en: 'without',
    nb: 'uten',
  },
  'meetings.AreTheSellectedShareholdersVotingForOrAgainstText1': {
    en: 'Are the ',
    nb: 'Stemmer de ',
  },
  'meetings.AreTheSellectedShareholdersVotingForOrAgainstText2': {
    en: ' selected shareholders voting for or against?',
    nb: ' valgte aksjeeierne for eller imot?',
  },
  'meetings.hasVotedFor': {
    en: 'has voted for the ',
    nb: 'har stemt på ',
  },
  'meetings.candidate': {
    en: 'candidate',
    nb: 'kandidat',
  },
  'meetings.candidates': {
    en: 'candidates',
    nb: 'kandidater',
  },
  'shareholders.EmissionContractConfirmText1': {
    en: 'I / we hereby order the following number of shares at NOK ',
    nb: 'Jeg / vi bestiller herved følgende antall aksjer à NOK ',
  },
  'shareholders.EmissionContractConfirmText2': {
    en: ' price per share',
    nb: '  per aksje',
  },
  'shareholders.PaymentStructureOfTheLoan': {
    en: 'Payment structure of the loan',
    nb: 'Betalingstrukturen til lånet',
  },
  'shareholders.Loaninformation': {
    en: 'Loan information',
    nb: 'Informasjon om lånet',
  },
  'shareholders.SomeOwnersWereNotIdentified2': {
    nb: ' Sjekk at dette stemmer før du fullfører importen.',
    en: ' Check that this is correct before completing the import.',
  },
  'shareholders.Option': {
    en: 'Option',
    nb: 'Opsjon',
    sv: 'Alternativ',
  },
  'shareholders.Warrant': {
    en: 'Warrant',
    nb: 'Tegningsrett',
    sv: 'Tegningsrett',
  },
  'shareholders.ConvertibleLoan': {
    en: 'Convertible loan',
    nb: 'Konvertibel lån',
    sv: 'Konvertibel lån',
  },
  'shareholders.Underlying': {
    en: 'Underlying',
    nb: 'Underliggende',
    sv: 'Underliggande',
  },
  'shareholders.Amount': {
    en: 'Amount',
    nb: 'Antall',
  },
  'shareholders.Expires': {
    en: 'Expires',
    nb: 'Utløper',
  },
  'shareholders.SplitAndSpliceExplanationText1': {
    en: 'To include a split or splice in the spreadsheet you need to include a number',
    nb: 'To include a split or splice in the spreadsheet you need to include a number',
  },
  'shareholders.SplitAndSpliceExplanationText2': {
    en: 'which specifies the ratio of how many resulting shares will be distributed. You also need to include a strategy for share amounts that are not discrete. There are currently two supported strategies',
    nb: 'som spesifiserer forholdet mellom eksisterende og resulterende antall aksjer. Du er også nødt til å inkludere en strategi for når antallet aksjer ikke blir en diskret verdi. Det er foreløpig to støttede strategier ',
  },
  'shareholders.SplitAndSpliceExplanationText3': {
    en: 'The "up" strategy rounds all fractional amounts up to the nearest integer and the "down" strategy rounds down to the nearest integer.',
    nb: '"Opp" strategien runder alle ikke diskrete antall opp til nærmeste heltall og "ned" strategien runder ned til nærmeste heltall.',
  },
  'shareholders.from': {
    en: 'from',
    nb: 'fra',
  },
  'shareholders.and': {
    en: 'and',
    nb: 'og',
  },
  'shareholders.to': {
    en: 'to',
    nb: 'til',
  },
  'shareholders.down': {
    en: 'down',
    nb: 'ned',
  },
  'shareholders.up': {
    en: 'up',
    nb: 'opp',
  },
  'shareholders.ShareIssueTransactionExplanation': {
    en: 'This is a type of transaction that creates new shares to be distributed in the company. A transaction of this type can span multiple rows and therefore multiple participants. However this will only count as a single emission when the date is the same in all the rows.',
    nb: ' Denne typen hendelse lager nye aksjer som blir distribuert til de spesifiserte aksjonærene. En hendelse av denne typen kan gå over flere rader og kan derfor ha flere aksjonærer. Forutsetningen for at radene blir inkludert i samme hendelse, er at datoen er den samme for hver rad.',
  },
  'shareholders.TransactionImportGeneralInformationtext1': {
    en: 'Orgbrain lets you import transactions in a specific format using a spreadsheet. This is to enable more features related to transactions.',
    nb: 'Orgbrain gir deg muligheten til å importere hendelser i et spesifikt format fra et regneark. Dette er for å muliggjøre flere funksjoner relatert til hendelser.',
  },
  'shareholders.TransactionImportGeneralInformationtext2': {
    en: 'Having a proper transaction history is important for tax reporting purposes, share numbers, and more functionality that enables a consistent shareholder registry.',
    nb: 'Å ha en god historikk er viktig for skatterapportering, aksjenummer, og mer funksjonalitet som åpner for et mer konsekvent aksjonærregister.',
  },
  'shareholders.RewindHelpText1': {
    en: 'Rewinding permanently deletes the last transaction and rebuilds the shareholder registry as if the transaction never happened.',
    nb: 'Sletter siste hendelse permanent og endrer selskapsregisteret for å reflektere endringen.',
  },
  'shareholders.RewindHelpText2': {
    en: 'This action cannot be reversed.',
    nb: 'Du kan ikke angre på denne handlingen.',
  },
  'shareholders.FollowFollowingRecipieToSetUpYourRegistryManually': {
    en: 'Follow following recipie to set up the',
    nb: 'Følg følgene oppskrift for å legge inn',
  },
  'shareholders.editSnapshot': {
    en: 'edit snapshot',
    nb: 'rediger øyebliksbilde',
  },
  'shareholders.AndCreateANewEvent': {
    en: 'and create a new event.',
    nb: 'og lag en ny hendelse.',
  },
  'shareholders.ToTheSnapshotOrEvent': {
    en: 'to the snapshot or event',
    nb: 'til øyeblikksbildet eller hendelsen',
  },
  'shareholders.YouHaveNoRegisteredInvestorsText1': {
    en: 'have been registered yet. Go to',
    nb: 'har blitt registrert enda. Gå til',
  },
  'shareholders.YouHaveNoRegisteredInvestorsText2': {
    en: 'sellect "New',
    nb: 'velg "Ny ',
  },
  'shareholders.YouHaveNoRegisteredInvestorsText3': {
    en: ' and add one or more',
    nb: ' og legg til en eller flere',
  },
  'shareholders.YouHaveNoRegisteredInvestorsText4': {
    en: 'before you continue.',
    nb: 'før du fortsetter.',
  },
  'shareholders.ShareholderEditPositionHelpText1': {
    en: 'You can edit the ',
    nb: 'Du kan redigere ',
  },
  'shareholders.ShareholderEditPositionHelpText2': {
    en: ' of ',
    nb: ' for ',
  },
  'shareholders.ShareholderEditPositionHelpText3': {
    en: 'by editing',
    nb: 'ved å redigere',
  },
  'shareholders.ShareclassesHelpTextModuleInfoText1': {
    en: 'Here you can edit, view and delete',
    nb: 'Her kan du redigere, se og slette',
  },
  'shareholders.ShareclassesHelpTextModuleInfoText2': {
    en: ' that are used in many parts of Orgbrain.',
    nb: ' som er brukt i mange deler av Orgbrain.',
  },
  'shareholders.infoOnEditTaxincentive2': {
    en: 'The system will automaticly round down to a amount divided on the share price in the emission.',
    nb: 'Systemet vil automatisk avrunde slik at beløp er delelig på aksjekursen i emisjonen.',
  },
  'shareholders.Invested': {
    en: 'Invested',
    nb: 'Investert',
  },
  'shareholders.amount': {
    en: 'amount',
    nb: 'beløp',
  },
  'shareholders.PossibleTaxincentives1': {
    en: 'Possible',
    nb: 'Mulig',
  },
  'shareholders.IncentiveForRF-1086title1': {
    en: 'Incentive ',
    nb: 'Insentiv',
  },
  'shareholders.IncentiveForRF-1086title2': {
    en: 'for RF-1086',
    nb: 'til RF-1086',
  },
  'shareholders.PossibleTaxincentives2': {
    en: 'taxincentives',
    nb: 'skatteinsentiver',
  },
  'shareholders.SnapshotAfterEmissionWarningText1': {
    en: 'The transaction history has a snapshot event after the selected date. The shares from this emission will not be included in the shareholder registry.',
    nb: 'Transaksjonshistorikken har et øyeblikksbilde etter den valgte datoen. Aksjene fra denne emisjonen vil ikke bli inkludert i aksjeeierboka.',
  },
  'shareholders.SnapshotAfterEmissionWarningText2': {
    en: 'To fix this you either need to remove the import events after this date, or choose a different date.',
    nb: 'For å fikse dette kan du enten fjerne øyeblikksbilder etter denne datoen, eller velge en annen dato.',
  },
  'shareholders.EmissionContractFactsText': {
    en: 'Each share has a nominal value of NOK',
    nb: 'Hver aksje har pålydende NOK',
  },
  'shareholders.YourOrderWasSuccessfulText1': {
    en: 'Name of investor ',
    nb: 'Navn på investor ',
  },
  'shareholders.YourOrderWasSuccessfulText2': {
    en: ' has been allotted ',
    nb: ' har blitt tildelt  ',
  },
  'shareholders.YourOrderWasSuccessfulText3': {
    en: 'amount',
    nb: 'antall',
  },
  'shareholders.YourOrderWasSuccessfulText4': {
    en: ' of shares at a price of NOK ',
    nb: ' aksjer til kurs NOK ',
  },
  'shareholders.YourOrderWasSuccessfulText5': {
    en: ' in connection with the capital increase in ',
    nb: ' i forbindelse med kapitalforhøyelsen i ',
  },
  'shareholders.YourOrderWasSuccessfulText6': {
    en: '. Please pay NOK ',
    nb: '. Vennligst innbetal NOK ',
  },
  'shareholders.YourOrderWasSuccessfulText7': {
    en: ' total ',
    nb: ' beløp som skal betales ',
  },
  'shareholders.YourOrderWasSuccessfulText8': {
    en: ' to the bank account ',
    nb: ' til bankkonto ',
  },
  'shareholders.YourOrderWasSuccessfulText9': {
    en: ' within ',
    nb: ' innen ',
  },
  'shareholders.YourOrderWasSuccessfulText10': {
    en: 'Remember that the payment must be made from an account belonging to the ',
    nb: 'Husk at innbetalingen må skje fra konto som tilhører ',
  },
  'shareholders.YourOrderWasSuccessfulText11': {
    en: 'Name of the investor',
    nb: 'Navn på investor',
  },
  'shareholders.YourOrderWasSuccessfulText12': {
    en: '. Note the payment "Capital increase".',
    nb: '. Merk betalingen "Kapitalforhøyelse".',
  },
  'shareholders.Shareholder': {
    en: 'Shareholder',
    nb: 'Aksjonær',
  },
  'shareholders.DividendEmailTextPart1': {
    en: ' have desided to pay out a ',
    nb: ' har besluttet å utbetale ',
  },
  'shareholders.EmissionEmailText1': {
    en: 'The following have been recorded for ',
    nb: 'Følgende er blitt registrert på ',
  },
  'shareholders.EmissionEmailText2': {
    en: '«Name of the Investor»',
    nb: '«Navn på investor»',
  },
  'shareholders.EmissionEmailText3': {
    en: ' in to the shareholder book of ',
    nb: ' i aksjeeierboken til ',
  },
  'shareholders.ElectronicSignatureBoardLeaderPowerOfAttorneyText1': {
    en: 'Electronic signature:',
    nb: 'Elektronisk signatur:',
  },
  'shareholders.ElectronicSignatureBoardLeaderPowerOfAttorneyText2': {
    en: ' with power of attorney',
    nb: ' med fullmakt',
  },
  'shareholders.InvestorSpecifiedMaxText1': {
    en: 'The investor has specified a max of ',
    nb: 'Investoren har bestilt maks ',
  },
  'shareholders.InvestorSpecifiedMaxText2': {
    en: ' shares in this equity issue. The max position size is specified by the investor in the associated contract of this position.',
    nb: ' aksjer i denne kapitalforhøyelsen. Maks antallet er presisert i bestillingsblanketten investoren har skrevet under på.',
  },
  'shareholders.of': {
    en: 'of',
    nb: 'av',
  },
  'shareholders.selected': {
    en: 'selected',
    nb: 'valgt',
  },
  'shareholders.NoContractsHaveBeenCreatedText': {
    en: 'No contracts have been made yet. Press the button "New contract" to create your first contract.',
    nb: 'Ingen kontrakter har blitt laget enda. Trykk på "Ny kontrakt" for å lage din første kontrakt.',
  },
  'backend.organization.ReminderCreationOfUserIn': {
    en: 'Reminder: Creation of user in',
    nb: 'Påminnelse: Opprettelse av bruker til',
  },
  'notifications.ClickTheButtonBelowToGoToTheMinutes': {
    en: 'Click the button below to go to the protocol.',
    nb: 'Klikk på knappen nedenfor for å gå til protokollen.',
    sv: 'Klicka på knappen nedan för att gå till protokollet.',
  },
  'notifications.GoToTheProtocol': {
    en: 'Go to the protocol',
    nb: 'Gå til protokollen',
    sv: 'Gå till protokollet',
  },
  'notification.GoToDocumentButton': {
    en: 'Go to the document',
    nb: 'Gå til dokumentet',
    sv: 'Gå till dokumentet',
  },
  'notifications.ClickTheButtonBelowToGoToTheSurvey': {
    en: 'Click the button below to go to the survey.',
    nb: 'Klikk på knappen nedenfor for å gå til spørreundersøkelsen.',
    sv: 'Klicka på knappen nedan för att gå till undersökningen.',
  },
  'notifications.GoToSurveyButton': {
    en: 'Go to the survey.',
    nb: 'Gå til spørreundersøkelsen.',
    sv: 'Gå till undersökningen.',
  },
  'backend.organization.ReminderCreationOfUserInFirstLine': {
    en: 'We remind you that',
    nb: 'Vi minner deg på at',
    sv: 'Vi påminner dig om att',
  },
  'backend.organization.ReminderCreationOfUserInSecondLine': {
    en: 'has asked you to create a user in the board portal from Orgbrain.',
    nb: 'har invitert deg til å opprette bruker i styreportalen fra Orgbrain',
    sv: 'har bjudit in dig att skapa användare i styrelseportalen från Orgbrain.',
  },
  'backend.organization.ClickToCreateNewUser': {
    en: 'Click the button below to create a user account',
    nb: 'Klikk på knappen nedenfor for å opprette din bruker',
    sv: 'Klicka på knappen nedan för att skapa en användare',
  },
  GoToOrgbrain: {
    en: 'Go to the Orgbrain',
    nb: 'Gå til Orgbrain',
    sv: 'Gå till Orgbrain',
  },
  'meetings.AgendaSuggestionTopics': {
    en: 'Agenda suggestion topics',
    nb: 'Forslag til agenda punkter',
  },
  'settings.MFASmallPrintPhoneNotValidated': {
    en: 'You need to register and verify a mobile phone to enable SMS based 2FA.',
    nb: 'Du må registrere og bekrefte en mobiltelefon for å aktivere 2FA.',
  },
  'shareholders.InvitationToParticipateInACapitalIncreaseFor': {
    en: 'Invitation to participate in a capital increase for ',
    nb: 'Invitasjon til å delta i en kapitalforhøyelse for',
    sv: 'Inbjudan att delta i en kapitalökning för',
  },
  'shareholders.InvitationToParticipateInCapitalIncrease': {
    en: 'Invitation to participate in a capital increase for',
    nb: 'Invitasjon til å delta i en kapitalforhøyelse for',
    sv: 'Inbjudan att delta i en kapitalökning för',
  },
  'shareholders.haveBeenInvitedToPartisipateFor': {
    en: 'have been invited to participate in a capital increase for',
    nb: 'er invitert til å delta i en kapitalforhøyelse for',
    sv: 'har blivit inbjuden att delta i en kapitalökning för',
  },
  'shareholders.hello': {
    en: 'Hello',
    nb: 'Hei',
    sv: 'Hej',
  },
  'shareholders.You': {
    en: 'You',
    nb: 'Du',
    sv: 'Du',
  },
  'shareholders.PressButtonForDetailsForShareIssueAndRegister': {
    en: 'Press the button below to see the details about the issue and register.',
    nb: 'Trykk på knappen under for å se detaljene om emisjonen og registrer deg.',
    sv: 'Tryck på knappen nedan för att se detaljerna om emissionen och registrera dig.',
  },
  'shareholders.GoToEquityIssueButton': {
    en: 'Go to equity issue',
    nb: 'Gå til kapitalforhøyelsen',
    sv: 'Gå till kapitalökningen',
  },
  'shareholders.PaymentInformationEquidyIssueSubject': {
    en: 'Payment information for equity issue in',
    nb: 'Betalingsinformasjon for kapitalforhøyelse i',
    sv: 'Betalningsinformation för kapitalökning i',
  },
  'lib-backend.signingRequest': {
    en: 'Signing request',
    nb: 'Signeringsforespørsel',
    sv: 'Signeringsförfrågan',
  },
  'lib-backend.inviteToVideoMeeting': {
    en: 'Invitation to video meeting for',
    nb: 'Invitasjon til videomøte for',
    sv: 'Inbjudan till videomöte för',
  },
  'register.RegisterInvitationExpiredContactAdmin': {
    en: 'Registration invite is expired, please contact the admin to get a new invite',
    nb: 'Registreringsinvitasjonen er utløpt, kontakt administratoren for å få en ny invitasjon',
    sv: 'Registreringsinbjudan har gått ut, kontakta administratören för att få en ny inbjudan',
  },
  'lib-contigo-frontend.service.oops': {
    en: 'Ooops!',
    nb: 'Ooops!',
    sv: 'Ooops!',
  },
  'lib-contigo-frontend.service.popupBlocked': {
    en: 'An error occurred because pop-ups are blocked by the browser. Enable pop-ups in your browser settings. Alternatively, the content can be displayed in the active window.',
    nb: 'Det oppstod en feil fordi popup-vinduer er blokkert av nettleseren. Aktiver popup-vinduer i nettleserinnstillingen. Alternativt kan innholdet vises i det aktive vinduet.',
    sv: 'Ett fel uppstod eftersom popup-fönster är blockerade av webbläsaren. Aktivera popup-fönster i webbläsarinställningarna. Alternativt kan innehållet visas i det aktiva fönstret.',
  },
  'lib-contigo-frontend.service.showInActiveWindow': {
    en: 'Show in active window',
    nb: 'Vis i aktivt vindu',
    sv: 'Visa i aktivt fönster',
  },
  'document-viewer.NeedsDownlaodPermissionForFile': {
    en: 'You need to have a download permission to view this file',
    nb: 'Du må ha nedlastingstillatelse for å se denne filen',
    sv: 'Du må ha nedladdningstillstånd för att se den här filen',
  },
  'services.NavigationWithThisLinkInterupsThisCall': {
    en: 'Navigating by this link will interrupt current video conference',
    nb: 'Hvis du går via denne lenken, avbrytes den nåværende videokonferansen',
    sv: 'Navigering via denna länk avbryter den aktuella videokonferensen',
  },
  'services.PersonElection': {
    en: 'Election',
    nb: 'Personvalg',
    sv: 'Personval',
  },
  'services.ALTERNATIVEOPTIONS': {
    en: 'Alternatives',
    nb: 'Alternativvalg',
    sv: 'Valalternativ',
  },
  'services.boardMeeting': {
    en: 'Board meeting',
    nb: 'Styremøte',
    sv: 'Styrelsemöte',
  },
  'services.AnualGeneralMeeting': {
    en: 'Annual General Meeting',
    nb: 'Ordinær generalforsamling',
    sv: 'Årsstämma',
  },
  'services.ExtaordinaryGeneralMeeting': {
    en: 'Extraordinary General Meeting',
    nb: 'Ekstraordinær generalforsamling',
    sv: 'Extra bolagsstämma',
  },
  'services.ShareholderMeeting': {
    en: 'Shareholder Meeting',
    nb: 'Aksjonærmøte',
    sv: 'Aktieägarmöte',
  },
  'services.Meeting': {
    en: 'Meeting',
    nb: 'Møte',
    sv: 'Möte',
  },
  'services.MemberMeeting': {
    en: 'Member meeting',
    nb: 'Medlemsmøte',
    sv: 'Medlemsmöte',
  },
  'services.AnnualMeeting': {
    en: 'Annual meeting',
    nb: 'Årsmøte',
    sv: 'Årsmöte',
  },
  'services.ExtraordinaryAnnualMeeting': {
    en: 'Extraordinary annual meeting',
    nb: 'Ekstraordinært årsmøte',
    sv: 'Extraordinärt årsmöte',
  },
  'services.GeneralMeeting': {
    en: 'General meeting',
    nb: 'Generalforsamling',
    sv: 'Bolagsstämma',
  },
  'services.ExtraordinaryGeneralMeeting': {
    en: 'Extraordinary General Meeting',
    nb: 'Ekstraordinær generalforsamling',
    sv: 'Extra bolagsstämma',
  },
  'services.UnitholdersMeeting': {
    en: 'Unitholders meeting',
    nb: 'Andelseiermøte',
    sv: 'Andelsägarmöte',
  },
  'services.OrdinaryAnnualMeeting': {
    en: 'Ordinary annual meeting',
    nb: 'Ordinært årsmøte',
    sv: 'Ordinarie årsstämma',
  },
  'services.SectionOwnerMeeting': {
    en: 'Section owner meeting',
    nb: 'Seksjonseiermøte',
    sv: 'Sektionsägarmöte',
  },
  'ceberus.ThisMessageWasSentFromOrgbrain': {
    en: 'This message was sent via software provided by Orgbrain',
    nb: 'Denne meldingen er sendt via programvare levert av Orgbrain',
    sv: 'Detta meddelande skickades via programvara som tillhandahålls av Orgbrain',
  },
  'ceberus.onbehalfOf': {
    en: 'on behalf of',
    nb: 'på vegne av',
    sv: 'på uppdrag av',
  },
  'cerberus.YouCannotReplyToThisMessage': {
    en: 'Please do not reply to this email',
    nb: 'Vennligst ikke svar på denne e-posten',
    sv: 'Vänligen svara inte på detta e-postmeddelande',
  },
  'shared-menu.ChatTextAllUsersWithAccessTodMeetings': {
    en: 'All users with access to board meetings can participate in the chat dialogue.',
    nb: 'Her kan alle som har brukertilgang til møter delta i en chatdialog',
    sv: 'Här kan alla som har användaråtkomst till möten delta i en chatt-dialog',
  },
  'shared-menu.TasksText': {
    en: 'Tasks is a function where you can make and keep track of tasks, action points or other events that must be followed up.',
    nb: 'Oppgaver er en funksjon der du kan lage, og holde orden på, oppgaver, aksjonspunkter eller andre hendelser som skal følges opp.',
    sv: 'Uppgifter är en funktion där du kan skapa och hålla reda på uppgifter, åtgärdspunkter eller andra händelser som måste följas upp.',
  },
  'shared-menu.MeetingsText': {
    en: 'Create meetings and invite users.',
    nb: 'Her kan det opprette møter som brukerne kan inviteres til.',
    sv: 'Skapa möten och bjud in användare.',
  },
  'shared-menu.FilesText': {
    en: 'Upload files and folders to be shared with users.',
    nb: 'Her kan du laste opp filer og mapper som kan deles med andre brukere.',
    sv: 'Ladda upp filer och mappar som ska delas med användare.',
  },
  'shared-menu.OrganizationText': {
    en: 'Among other things, the administrator can invite users and enter key information.',
    nb: 'Her kan administrator blant annet invitere brukere og legge inn annen nøkkelinformasjon.',
    sv: 'Här kan administratören bland annat bjuda in användare och ange annan nyckelinformation.',
  },
  'shared-menu.ChatTextAllUsersWithAccessToBoardMeetings': {
    en: 'All users with access to board meetings can participate in the chat dialogue.',
    nb: 'Her kan alle som har brukertilgang til styremøter delta i en chatdialog',
    sv: 'Här kan alla som har användaråtkomst till styrelsemöten delta i en chatt-dialog',
  },
  'services.EmailsSendtTotext': {
    en: 'Emails sent successfully to: ',
    nb: 'E-postmeldinger ble sendt til: ',
    sv: 'E-postmeddelanden skickades till: ',
  },
  'services.ErrorSendingEmail': {
    en: 'Error sending emails',
    nb: 'Feil ved sending av e-post',
    sv: 'Fel vid sändning av e-post',
  },
  'services.SendReminderToText': {
    en: 'Do you want to send a missing signatures reminder to the following: ',
    nb: 'Vil du sende en påminnelse om manglende signering til følgende: ',
    sv: 'Vill du skicka en påminnelse om uteblivna signaturer till följande: ',
  },
  'services.AreYouSureText': {
    en: 'Are you sure?',
    nb: 'Er du sikker?',
    sv: 'Är du säker?',
  },
  'services.public': {
    en: 'public',
    nb: 'offentlig',
    sv: 'offentlig',
  },
  'shareholders.CopyOfOrderFormCanBeFoundUnderInvestmentsInLeftMenu': {
    en: 'A copy of the order form can be found under "Investments" in the left menu.',
    nb: 'Kopi av bestillingsblanketten finner du under «Investeringer» i venstremenyen.',
    sv: 'En kopia av beställningsblanketten hittar du under "Investeringar" i vänstermenyn.',
  },
  'shareholders.WithBestRegards': {
    en: 'With best regards',
    nb: 'Med vennlig hilsen',
    sv: 'Med vänliga hälsningar',
  },
  'shareholders.NotePaymentAsCapitalIncrease': {
    en: 'Note the payment "Capital increase".',
    nb: 'Merk betalingen «Kapitalforhøyelse».',
    sv: 'Notera betalningen "Kapitalökning".',
  },
  'shareholders.RememberThatPaymentHaveToBeMadeFrom': {
    en: 'Remember that the payment must be made from an account belonging to',
    nb: 'Husk at innbetalingen må skje fra konto som tilhører',
    sv: 'Kom ihåg att betalningen måste göras från ett bankkonto i ditt namn.',
  },
  'shareholders.within': {
    en: 'within',
    nb: 'innen',
    sv: 'inom',
  },
  'shareholders.toBankAccount': {
    en: 'to the bank account',
    nb: 'til bankkonto',
    sv: 'till bankkonto',
  },
  'shareholders.PleasePay': {
    en: 'Please pay',
    nb: 'Vennligst innbetal',
    sv: 'Vänligen betala',
  },
  'shareholders.inConnectionWith': {
    en: 'in connection with the capital increase in',
    nb: 'i forbindelse med kapitalforhøyelsen i',
    sv: 'i samband med kapitalökningen i',
  },
  'shareholders.atPrice': {
    en: 'at a price of',
    nb: 'til kurs',
    sv: 'till kurs',
  },
  'shareholders.ofShares': {
    en: 'per share',
    nb: 'aksje',
    sv: 'per aktie',
  },
  'shareholders.hasBeenAllotted': {
    en: 'has been allotted',
    nb: 'er blitt tildelt ',
    sv: 'har tilldelats',
  },
  'common-register.YouHaveToAcceptTerms': {
    en: 'You have to accept the terms in order to proceed with registration',
    nb: 'Du må godta vilkårene for å kunne fortsette med registreringen',
    sv: 'Du måste acceptera villkoren för att fortsätta',
  },
  // we do translations from here
  AnnualPayment: {
    en: 'Annual payment',
    nb: 'Årsavtale',
  },

  PerOrganization: {
    en: 'per organization',
    nb: 'per selskap',
  },
  PerMonth: {
    en: 'per month',
    nb: 'per måned',
  },
  ForExtraUsers: {
    en: 'For extra users over',
    nb: 'For ekstra brukere over',
  },
  PerUser: {
    en: 'per user',
    nb: 'per bruker',
  },
  NoLimitOnUsers: {
    en: 'No limit on users',
    nb: 'Ingen begrensning på antall brukere',
  },
  Storage: {
    en: 'Storage',
    nb: 'Lagringsplass',
  },
  IncludedFiveUsers: {
    en: 'Included five users',
    nb: 'Inkludert fem brukere',
  },
  FreeForShareholders: {
    en: 'Free for shareholders',
    nb: 'Gratis for aksjonærbrukere',
  },
  Validity: {
    en: 'Validity',
    nb: 'Varighet',
  },
  'button.Active': {
    en: 'Active',
    nb: 'Aktiv',
    sv: 'Aktiv',
  },
  'meetings.whichCandidatesAreTheXSelectedShareOwnersVotingFor1': {
    en: 'Which candidates are the ',
    nb: 'Hvilke kandidater stemmer de ',
  },
  'meetings.whichCandidatesAreTheXSelectedShareOwnersVotingFor2': {
    en: ' selected share owners voting for?',
    nb: ' valgte aksjeeierne på?',
  },
  'meetings.whichCandidatesAreXShareOwnersVotingFor1': {
    en: 'Which candidates is ',
    nb: 'Hvilke kandidater stemmer ',
  },
  'meetings.whichCandidatesAreXShareOwnersVotingFor1pl': {
    en: 'Which candidates are ',
    nb: 'Hvilke kandidater stemmer ',
  },
  'meetings.whichCandidatesAreXShareOwnersVotingFor2': {
    en: ' voting for?',
    nb: ' på?',
  },
  Change: {
    en: 'Change',
    nb: 'Endre',
  },
  DaughterCompanySubscription: {
    en: 'Daughter company subscription',
    nb: 'Abonnement for datterselskap',
  },
  OrderPackage: {
    en: 'Subscribe',
    nb: 'Abonnér',
  },
  BuildSubscriptions: {
    en: 'Build subscription',
    nb: 'Bygg abonnement',
    sv: 'Bygg abonnemang',
  },
  TakeContact: {
    en: 'Take contact',
    nb: 'Ta kontakt',
  },
  AnErrorHasOccured: {
    en: 'An error occurred',
    nb: 'En feil oppstod',
  },
  ConfirmCancelPackage: {
    en: 'Do you want to cancel the subscription?',
    nb: 'Ønsker du å kansellere abonnementet?',
    sv: 'Vill du avbryta prenumerationen?',
  },
  CancelPackageRules: {
    en: 'If you cancel today, you will still have access to the subscription till',
    nb: 'Hvis du kansellerer i dag, vil du fortsatt ha tilgang til abonnementet til',
  },
  Cancellation: {
    en: 'Cancellation',
    nb: 'Kansellering',
    sv: 'Avbokning',
  },
  CancelWithCapitalK: {
    en: 'Cancel',
    nb: 'Kansellere',
  },
  CancellationConfirmation: {
    en: 'Kanselleringen er registrert. Abonnementet vil ikke automatisk bli fornyet.',
    nb: 'Kanselleringen er registrert. Abonnementet vil ikke automatisk bli fornyet.',
    sv: 'Avbokningen har registrerats. Prenumerationen kommer inte att förnyas automatiskt.',
  },
  SubscriptionHistory: {
    en: 'Subscription history',
    nb: 'Abonnementshistorikk',
  },
  ValidFrom: {
    en: 'Valid from',
    nb: 'Gyldig fra',
  },
  ValidUntil: {
    en: 'Valid until',
    nb: 'Gyldig til',
  },

  Requester: {
    en: 'Requester',
    nb: 'Forespørsel',
  },
  MVA: {
    en: 'Orgnr.',
    nb: 'Org.nr.\n',
  },
  email: {
    en: 'Email',
    nb: 'E-post',
  },
  SendEmailInvitation: {
    en: 'Send invitation on email',
    nb: 'Send e-postinvitasjon',
  },
  ContactPerson: {
    en: 'Contact person',
    nb: 'Kontaktperson',
  },
  PersonalAddress: {
    en: 'Address',
    nb: 'Adresse',
  },
  Zip: {
    en: 'Zip',
    nb: 'Postnummer',
  },
  createdAt: {
    en: ' Created at',
    nb: ' Opprettet',
  },
  QuantityLabel: {
    en: 'Quantity',
    nb: 'Antall',
  },
  PleaseConfirmDeletion: {
    en: 'Please confirm deletion',
    nb: 'Vennligst bekreft sletting',
  },
  YourUpgradeIsComplete: {
    en: 'Your upgrade is complete!',
    nb: 'Din oppgradering er gjennomført!',
  },
  CancelButton: {
    en: 'Cancel',
    nb: 'Avbryt',
  },
  NewVersionReloadNow: {
    en: 'Reload now',
    nb: 'Last inn på nytt',
  },
  NewVersionLater: {
    en: 'Later',
    nb: 'Senere',
  },
  OrganizationName: {
    en: 'Organization name',
    nb: 'Organisasjonsnavn',
  },
  //OrganizationName: {
  //  en: 'Organizaiton name',
  //  nb: 'Organisasjonens navn',
  //},
  TotalBelop: {
    en: 'Total',
    nb: 'Tegningsbeløp',
  },

  RoleOrRolesTimes: {
    en: 'Roles and times',
    nb: 'Roller og tidspunkter',
  },
  EmailAddress: {
    en: 'Email',
    nb: 'E-postadresse',
  },
  Transfer: {
    en: 'Transfer',
    nb: 'Overfør',
  },
  UpdatedAt: {
    en: ' Updated ',
    nb: ' Oppdatert ',
  },
  SuppressedEmailEventHeader: {
    en: 'Event',
    nb: 'Hendelse',
  },
  SuppressedEmailDateHeader: {
    en: 'Time',
    nb: 'Tid',
  },
  SuppressedEmailDiagnosticHeader: {
    en: 'Diagnostic',
    nb: 'Teknisk melding',
  },
  ReinstateSuppresedEmailButtonLabel: {
    en: ' Reinstate ',
    nb: 'Benytt adresse',
  },
  TestSuppresedEmailButtonLabel: {
    en: ' Debounce ',
    nb: ' Debounce ',
  },
  Dismiss: {
    en: 'Dismiss',
    nb: 'Avvis',
  },
  DeleteSelectUsers: {
    en: 'Remove selected users',
    nb: 'Fjern valgte brukere',
  },
  ResendInvitationTitle: {
    en: 'New invitation to email',
    nb: 'Ny invitasjon på e-post',
  },
  ResendTheInvitation: {
    en: 'Do you want to resend the invitation to selected users?',
    nb: 'Ønsker du å sende invitasjon til utvalgte brukere på nytt?',
  },
  ConfirmToContinue: {
    en: 'Confirm to continue',
    nb: 'Bekreft for å fortsette.',
  },
  ClinetUsers: {
    en: 'Client Users',
    nb: 'Klientbrukere',
  },
  first_name: {
    en: 'First name',
    nb: 'Fornavn',
  },
  role: {
    en: 'Admin',
    nb: 'Admin',
  },
  last_name: {
    en: 'Last name',
    nb: 'Etternavn',
  },
  phone: {
    en: 'Phone',
    nb: 'Telefon',
    sv: 'Telefon',
  },
  accepted_invitation: {
    en: 'Accepted',
    nb: 'Akseptert',
  },
  invite: {
    en: 'Invite',
    nb: 'Inviter',
  },
  clientAdminHeader: {
    en: 'Admin',
    nb: 'Administrator',
  },
  ClientSalesHeader: {
    en: 'Sales',
    nb: 'Selger',
  },
  InviteSentSnack: {
    en: 'Invite sent',
    nb: 'Invitasjon sendt',
  },
  DeleteUsers: {
    en: 'Remove user',
    nb: 'Fjern bruker',
  },
  OrganizationDownloadWatermarkSettingHeader: {
    en: ' Download and watermarking of documents ',
    nb: ' Nedlasting og vannmerke av dokumenter',
  },
  GroupView: {
    en: 'View only',
    nb: 'Kun lesetilgang',
  },
  GroupWatermark: {
    en: 'Download with water mark',
    nb: 'Last ned med vannmerke',
  },
  GroupDownload: {
    en: 'Download',
    nb: 'Last ned',
  },
  Member: {
    en: ' Member ',
    nb: 'Medlem',
  },
  HasAccess: {
    en: 'Access Status',
    nb: ' Tilgangsstatus',
  },
  ManualIdenties: {
    en: ' Manually Verified ',
    nb: 'Verifisert manuelt',
  },
  IdentyMethods: {
    en: ' Methods ',
    nb: 'Metoder',
  },
  MaunalIdAddedBy: {
    en: 'Added by',
    nb: 'Endret av',
  },
  MaunalIdRemovedBy: {
    en: 'Removed by',
    nb: 'Fjernet av ',
  },
  ManualVerificationLabel: {
    en: 'Manual Verification',
    nb: 'Manuell verifisering',
  },
  GroupTag: {
    en: ' Group Orgnr. ',
    nb: 'Gruppe org.nr.',
  },
  orderSource: {
    en: ' Source ',
    nb: 'Kilde',
  },
  Comment: {
    en: 'Comment',
    nb: 'Kommentar',
  },
  CreateAdittional: {
    en: 'Create',
    nb: 'Legg til',
    sv: 'Skapa',
  },
  OrganizationAddress: {
    en: 'Organization address',
    nb: 'Organisasjonens adresse',
  },
  OrganizationClient: {
    en: 'Organization client',
    nb: ' Klient-ID',
  },
  sender: {
    en: ' Sender ',
    nb: 'Avsender',
  },
  subject: {
    en: 'Subject',
    nb: 'Emne',
  },
  timeSent: {
    en: 'Sent',
    nb: 'Sendt',
  },
  minutesViewGeneralMeetingsAnnualMeetings: {
    en: ' Minutes view - General meetings/annual meetings ',
    nb: ' Protokollvisning - Generalforsamling/årsmøter ',
  },
  MinutesSettingsMeetingsHelp: {
    en: ' Here you can make settings on what should be shown in the minutes of general meetings/annual meetings. By checking "Use simplified PDF", the poll results table will not appear in the PDF protocol that is automatically created in the portal. "Detailed distribution of votes" allows the company, which has several classes of shares, to show in the minutes how the list of attendees, as well as votes, is distributed per share class. ',
    nb: ' Her kan du gjøre innstillinger på hva som skal vises i protokoll fra generalforsamlinger/årsmøter. Ved å huke av for «Bruk forenklet PDF» vil ikke tabell over avstemningsresultat vises i PDF-protokollen som automatisk blir laget i portalen. «Detaljert fordeling av stemmer», gir selskapet som har flere aksjeklasser, mulighet til å vise i protokollen hvordan fortegnelsen over fremmøtte, samt avstemninger, fordeler seg per aksjeklasse. ',
  },
  UseSimplifiedPDFForMeetings: {
    en: ' Use simplified PDF for meetings ',
    nb: ' Bruk forenklet PDF for møter ',
  },
  etailedDistributionOfVotes: {
    en: ' Detailed distribution of votes ',
    nb: ' Detaljert fordeling av stemme ',
  },
  GeneralSettingsHelpText: {
    en: ' Here you can choose which languages your organization wants to use for the content of the software. Each user also has their own personal language setting ',
    nb: ' Her kan du velge hvilke språk som organisasjonen ønsker å benytte på innholdet i programvaren. Hver enkelt bruker har i tillegg sin personlige språkinnstilling ',
  },
  OrganizationJurisdiction: {
    en: 'Organization jurisdiction',
    nb: 'Organisasjonens jurisdiksjon',
  },
  UnidentifiedParticipants: {
    nb: 'Uidentifiserte deltakere',
    en: 'Unidentified participants.',
  },
  UnidentifiedParticipantsText: {
    nb: 'Hvis en deltaker har stor variasjon i stemmeleiet, eller hvis flere personer har snakket i samme mikrofon, kan AI registrere dette som flere stemmer fra den samme mikrofonen. Du trenger ikke å gjøre noe dersom det i praksis er samme person som er identifisert med flere stemmevariasjoner. Hvis en annen person har snakket i vedkommendes mikrofon, kan du legge inn korrekt navn i navnefeltet for den aktuelle deltakeren.',
    en: "If a participant has a large variation in speech, or if multiple people have spoken in the same microphone, AI may register this as multiple voices from the same microphone. You do not need to do anything if it is the same person identified with multiple voice variations. If another person has spoken in the participant's microphone, you can enter the correct name in the name field for the participant.",
  },
  MeetingParticipant: {
    en: 'Participant ',
    nb: 'Deltaker ',
  },
  UploadRecording: {
    en: 'Upload Recording',
    nb: 'Last opp opptak',
  },
  VisibillitySettingsHelpText: {
    en: ' Here, each organization can choose to allow shareholders/members to see the names of other shareholders/members. ',
    nb: ' Her kan hver enkelt organisasjon velge å la aksjeeiere/medlemmer se navn på andre aksjeeiere/medlemmer. ',
  },
  DeleteNote: {
    en: 'Delete note?',
    nb: 'Slett notat?',
  },
  DeleteNoteText: {
    en: 'Are you sure you want to delete this note?',
    nb: 'Er du sikker på at du vil slette dette notatet?',
  },
  Signing: {
    en: 'Signing',
    nb: 'Signering',
  },
  SigningSettingsHelpText: {
    en: ' Normally, only board members present during board deliberations must sign the minutes of the meeting. In order to document that more people are familiar with the decisions that have been made, one can choose that others should also sign that the protocol has been read. ',
    nb: ' Normalt er det kun styremedlemmer som er til stede under styrebehandlingen som skal signere protokollen fra møtet. For å dokumentere at flere er kjent med de vedtak som er fattet, kan man her velge at også andre skal signere at protokollen er lest. ',
  },
  MeetingConfirmParticipation: {
    en: 'Confirm participation',
    nb: 'Bekreft deltakelse',
  },
  HasConfirmedAttendance: {
    en: 'Confirmed attendance',
    nb: 'Bekreftet oppmøte',
  },
  UseMeetingAI: {
    en: 'Setup Meeting AI',
    nb: 'Sett i gang med Møte-AI',
  },
  MeetingAIPreviewTitle: {
    en: 'Get finished minutes and meeting analysis in minutes',
    nb: 'Få ferdig protokoll og møteanalyse på minutter',
  },

  MeetingAITrial: {
    en: 'Try Meeting AI for 30 days',
    nb: 'Prøv Møte-AI i 30 dager',
  },
  MeetingAIPreviewText1: {
    en: 'Meeting AI is a feature in Orgbrain that helps you get more value out of your meetings. It can create transcription, minutes, draft protocols, and meeting analysis based on what is said in the meeting. If the meeting agenda is entered in advance, it is used as a basis to make the draft protocol as accurate as possible.',
    nb: 'Møte-AI er en funksjon i Orgbrain som hjelper dere å få mer verdi ut av møtene. Den kan lage transkripsjon, referat, protokollutkast og møteanalyse basert på det som blir sagt i møtet. Dersom møteagenda er lagt inn på forhånd, brukes den som grunnlag for å gjøre protokollutkastet mest mulig presist.',
  },
  MeetingAIPreviewText2: {
    en: "Do you have questions about Meeting AI? We're happy to help. Get in touch in the chat or send an email to support@orgbrain.no.",
    nb: 'Har du spørsmål om Møte-AI? Vi hjelper gjerne. Ta kontakt i chatten eller send e-post til support@orgbrain.no.',
  },
  MeetingAIReadMore: {
    en: 'Read more about Meeting AI here.',
    nb: 'Les mer om Møte-AI her.',
  },
  DeleteAgendaSuggestion: {
    en: 'Delete agenda suggestion?',
    nb: 'Slett forslag til agendapunkt?',
  },
  AreYouSureYouWantToDeleteTheSelectedAgendaSuggestion: {
    en: 'Are you sure you want to delete the selected agenda suggestion?',
    nb: 'Er du sikker på at du vil slette dette forslaget til agendapunkt?',
  },
  UseMeetingAIDescription: {
    en: 'Setup Meeting AI to fit you and your companys needs. This can be changed at any time from the settings of the company.',
    nb: 'Sett opp Møte-AI slik at det passer deg og ditt selskapet. Dette kan når som helst endres fra innstillingene til selskapet.',
  },
  MeetingAISetupFinishedTitle: {
    en: 'You are ready!',
    nb: 'Du er klar!',
  },
  MeetingAISetupFinishedPara1: {
    en: 'Meeting AI is a feature in Orgbrain that helps you get more value from your meetings. It can create more or less verbatim transcriptions, summaries, draft minutes, and meeting analysis based on what is said in the meeting, and optionally the meeting agenda.',
    nb: 'Møte-AI er en funksjon i Orgbrain som hjelper dere å få mer verdi ut av møtene. Den kan lage mer eller mindre ordrett transkribering, referat, protokollutkast og møteanalyse basert på det som blir sagt i møtet, og eventuelt møteagendaen.',
  },
  MeetingAISetupFinishedPara2: {
    en: 'Needs vary. Some do not want the audio recording to remain available after the meeting. Therefore, Meeting AI is flexible. You can get the results without storing the audio recording. The recording is then only used to generate the content and is not stored once the result is ready. You can also choose whether the transcription should be stored, or only used as a basis for the results.',
    nb: 'Behovene varierer. Noen ønsker ikke at lydopptaket skal bli liggende tilgjengelig etter møtet. Derfor er Møte-AI fleksibel. Dere kan få resultatene uten at lydopptak lagres. Opptaket brukes da kun til å generere innholdet, og blir ikke lagret når resultatet er klart. Dere kan også velge om transkriberingen skal lagres, eller bare brukes som grunnlag for resultatene.',
  },
  MeetingAISetupFinishedPara3: {
    en: 'When meeting recording is enabled, you can record in Orgbrain\'s built-in video solution or upload an audio file. The results become available under the "Meeting AI" after the meeting has ended and the meeting administrator will be notified when the content is ready.',
    nb: 'Når møteopptak er aktivert, kan dere ta opptak i Orgbrains innebygde videoløsning eller laste opp en lydfil. Resultatene blir tilgjengelige under fanen "Møte-AI" i etterkant av møtet og Møteadministrator får varsel når innholdet er klart.',
  },
  MeetingAISetupFinishedPara4: {
    en: 'The data in Meeting AI is processed securely and in accordance with privacy legislation (GDPR).',
    nb: 'Daten i Møte-AI blir prosessert trygt og i henhold til personvernlovgivingen (GDPR).',
  },
  MeetingAISetupFinishedPara5: {
    en: 'Here you can set up the settings you want on Meeting AI. This can be changed at any time from the settings of the company.',
    nb: 'Under kan du sette opp innstillingene du ønsker på Møte-AI. Dette kan endres senere på innstillingssiden til selskapet.',
  },
  MeetingAiInfoIntroPara1: {
    en: 'Meeting AI is a feature in Orgbrain that helps you get more value from your meetings. It can create more or less verbatim transcriptions, summaries, draft minutes, and meeting analysis based on what is said in the meeting. If a meeting agenda is added in advance, this will also be used to ensure the minutes are as good as possible.',
    nb: 'Møte-AI er en funksjon i Orgbrain som hjelper dere å få mer verdi ut av møtene. Den kan lage en mer eller mindre ordrett transkripsjon, referat, protokollutkast og møteanalyse basert på det som blir sagt i møtet. Dersom det er lagt inn en møteagenda på forhånd vil denne også benyttes for at protokollen skal bli så god som mulig.',
  },
  MeetingAiInfoIntroPara2: {
    en: 'Needs vary. Some do not want the audio recording to remain available after the meeting. Therefore, Meeting AI is flexible. You can get the results without storing audio recordings. The audio is then only used as a basis for further processing and is not stored once the result is ready. You can also choose whether the transcription should be made available, or only used as a basis for the results.',
    nb: 'Behovene varierer. Noen ønsker ikke at lydopptaket skal bli liggende tilgjengelig etter møtet. Derfor er Møte-AI fleksibel. Dere kan få resultatene uten at lydopptak lagres. Lyden brukes da bare som grunnlag til videre prosessering, og blir ikke lagret når resultatet er klart. Dere kan også velge om transkripsjonen skal gjøres tilgjengelig, eller bare brukes som grunnlag for resultatene.',
  },
  MeetingAiInfoIntroPara3: {
    en: 'When meeting recording is enabled, you can record in Orgbrain\'s built-in video solution or upload an audio file. The results become available under the "Meeting AI" tab a few minutes after the recording is stopped or the audio file is uploaded, depending on the length of the recording. The meeting administrator will be notified when the content is ready.',
    nb: 'Når møteopptak er aktivert, kan dere ta opptak i Orgbrains innebygde videoløsning eller laste opp en lydfil. Resultatene blir tilgjengelige under fanen "Møte-AI" noen minutter etter at opptaket er stoppet eller lydfilen er lastet opp, avhengig av lengden på opptaket. Møteadministrator får varsel når innholdet er klart.',
  },
  MeetingAiInfoGettingStartedTitle: {
    en: 'How to get started with Meeting AI',
    nb: 'Slik kommer dere i gang med Møte-AI',
  },
  MeetingAiInfoGettingStartedPara1: {
    en: 'You can test Meeting AI free of charge for 30 days. The subscription does not renew automatically after the trial period unless you request it. Here is how you get started:',
    nb: 'Dere kan teste Møte AI kostnadsfritt i 30 dager. Abonnementet fornyes ikke automatisk etter prøveperioden, med mindre dere ber om det. Slik kommer dere i gang:',
  },
  MeetingAiInfoGettingStartedStep1: {
    en: 'Activate Meeting AI in Orgbrain by logging in, going to Organization → Subscription and activate Meeting AI.',
    nb: 'Aktiver Møte-AI i Orgbrain ved å logge inn, gå til Organisasjon → Abonnement og aktiver Møte-AI.',
  },
  MeetingAiInfoGettingStartedStep2: {
    en: 'Choose which settings should apply for meeting recording and what should be created. This can always be changed by going to Organization and Settings.',
    nb: 'Velg hvilke innstillinger som skal gjelde for møteopptak og hva som skal lages. Dette kan alltid endres ved å gå til Organisasjon og Innstillinger.',
  },
  MeetingAiInfoGettingStartedStep3: {
    en: 'Choose which features you want to use: save audio recording, save transcription, create summary and minutes, create meeting analysis.',
    nb: 'Velg hvilke funksjoner dere vil bruke, lagre lydopptak, lagre transkribering, lag referat og protokoll, lag møteanalyse.',
  },
  MeetingAiInfoGettingStartedStep4: {
    en: 'When conducting meetings, use the built-in video conferencing feature and start recording in the meeting, or upload an audio file under the "Meeting AI" tab on the meeting card.',
    nb: 'Når dere gjennomfører møter, bruk den innebygde videokonferansefunksjonen og start opptak i møtet, eller last opp en lydfil under fanen "Møte AI" på møtekortet',
  },
  MeetingAiInfoWhatYouFindTitle: {
    en: 'What you find under "Meeting AI"',
    nb: 'Hva du finner under "Møte-AI"',
  },
  MeetingAiInfoTranscriptionTitle: {
    en: 'Transcription',
    nb: 'Transkripsjon',
  },
  MeetingAiInfoTranscriptionPara: {
    en: 'Here you find the basis for Meeting AI, the transcription text, and a summary of highlights. If audio storage is enabled, the audio file will also be available. If the AI has not been able to identify all voices, you can manually enter names for the participants.',
    nb: 'Her finner du grunnlaget for Møte-AI, transkripsjonsteksten og en oppsummering av høydepunkter. Hvis lagring av lyd er aktivert, vil også lydfilen være tilgjengelig. Dersom AI ikke har klart å identifisere alle stemmene, kan du legge inn navn på deltakerne manuelt.',
  },
  MeetingAiInfoMinutesTitle: {
    en: 'Summary',
    nb: 'Referat',
  },
  MeetingAiInfoMinutesPara: {
    en: 'Here you find an AI-generated summary of the meeting. The content is grouped by topics that the AI has identified automatically. Under each topic, you will find tasks, questions, decisions, and risk points also suggested by the AI.',
    nb: 'Her finner du en AI-generert oppsummering av møtet. Innholdet er gruppert etter emner som AI har identifisert automatisk. Under hvert emne finner du oppgaver, spørsmål, beslutninger og risikopunkter som også er foreslått av AI.',
  },
  MeetingAiInfoProtocolTitle: {
    en: 'Minutes',
    nb: 'Protokoll',
  },
  MeetingAiInfoProtocolPara: {
    en: 'Draft minutes based on the agenda, both a short and an extended version. You can edit and save, and the minutes on the meeting card will then be updated. If the meeting contains topics that cannot be linked to the agenda, they are shown as new suggestions at the bottom of the agenda.',
    nb: 'Utkast til protokoll basert på agendaen, både en kort og en utvidet versjon. Du kan redigere og lagre, og da oppdateres protokollen på møtekortet. Hvis møtet inneholder temaer som ikke kan knyttes til agendaen, vises de som nye forslag nederst på agendaen.',
  },
  MeetingAiInfoAnalysisTitle: {
    en: 'Analysis',
    nb: 'Analyse',
  },
  MeetingAiInfoAnalysisPara: {
    en: 'Statistics and insights from the meeting, such as speaking time per participant, time spent per agenda item, and an overview of identified tasks, decisions, questions, and risks.',
    nb: 'Statistikk og innsikt fra møtet, for eksempel taletid per deltaker, tidsbruk per agendapunkt, og oversikt over identifiserte oppgaver, beslutninger, spørsmål og risikoer.',
  },
  MeetingAiInfoStorageTitle: {
    en: 'Storage and Access',
    nb: 'Lagring og tilgang',
  },
  MeetingAiInfoStoragePara1: {
    en: 'You can choose whether audio recordings and transcriptions should be saved. Initially, only the meeting administrator has access to recordings and transcriptions from meetings, but it is possible to change this so that, for example, all board members can have access. Recordings and transcriptions can be deleted at any time, for example after the minutes are finalized.',
    nb: 'Du kan velge om lydopptak og transkribering skal lagres. I utgangspunktet er det kun møteadministrator som har tilgang til opptak og transkribering fra møter, men det er mulig å endre på dette slik at for eksempel alle styremedlemmene kan få tilgang. Opptak og transkribering kan slettes når som helst, for eksempel etter at protokollen er ferdigstilt.',
  },
  MeetingAiInfoStoragePara2: {
    en: 'The technology is in continuous development. The actual transcription, i.e. the conversion from speech to text, is done on our virtual server in this version. For now, an OpenAI language model is used, without OpenAI being directly involved, because the solution runs on Microsoft’s infrastructure in Sweden.',
    nb: 'Teknologien er i kontinuerlig utvikling. Selve transkriberingen, altså konverteringen fra tale til tekst, gjøres i denne versjonen på vår virtuelle server. Foreløpig benyttes en språkmodell fra OpenAI, uten at OpenAI er direkte involvert, fordi løsningen kjøres på Microsofts infrastruktur i Sverige.',
  },
  MeetingAiInfoQualityTitle: {
    en: 'Important about Quality and Control',
    nb: 'Viktig om kvalitet og kontroll',
  },
  MeetingAiInfoQualityPara: {
    en: 'Meeting AI generates suggestions based on recordings and transcriptions. The content is automatically generated and may contain errors, misunderstandings, or omissions. Therefore, use the results as a draft, and quality-assure the minutes, decisions, tasks, and risk points before sharing, saving, or using the content as a basis for further work.',
    nb: 'Møte-AI genererer forslag basert på opptak og transkribering. Innholdet er automatisk generert og kan inneholde feil, misforståelser eller mangler. Bruk derfor resultatene som et utkast, og kvalitetssikre protokoll, beslutninger, oppgaver og risikopunkter før dere deler, lagrer eller bruker innholdet som grunnlag for videre arbeid.',
  },
  MeetingAiInfoTipsTitle: {
    en: '5 tips for better transcription',
    nb: '5 tips for bedre transkribering',
  },
  MeetingAiInfoTipsIntro: {
    en: 'Transcription provides great value when the audio basis is good and the meeting is conducted in a way that makes it easy to distinguish who says what and which case is being handled. Small adjustments beforehand and along the way can therefore provide clearly better output and more precise summaries, also when using automatic minutes. Below you will find five simple tips that raise quality, reduce errors, and make the result more useful afterwards.',
    nb: 'Transkribering gir stor verdi når lydgrunnlaget er godt og møtet gjennomføres på en måte som gjør det enkelt å skille hvem som sier hva, og hvilken sak som behandles. Små justeringer i forkant og underveis kan derfor gi tydelig bedre utskrift og mer presise oppsummeringer, også når dere bruker automatisk protokoll. Under finner dere fem enkle tips som løfter kvaliteten, reduserer feil og gjør resultatet mer nyttig i etterkant.',
  },
  MeetingAiInfoTip1Title: {
    en: 'Check audio and equipment before the meeting starts',
    nb: 'Sjekk lyd og utstyr før møtet starter',
  },
  MeetingAiInfoTip1Para: {
    en: 'Ensure all meeting participants have a working microphone and a stable internet connection. It is a good idea to test that everyone can hear each other clearly before getting started. If you have a physical meeting where several people share the same microphone, it is an advantage to use a conference microphone designed for meeting rooms, with 360-degree recording, noise reduction, and range covering the entire table. For larger rooms, multiple microphones may be necessary.',
    nb: 'Sørg for at alle møtedeltakere har fungerende mikrofon og stabil nettilkobling. Test gjerne at alle hører hverandre klart før dere går i gang. Hvis dere har et fysisk møte der flere deler samme mikrofon, er det en en fordel om det benyttes en konferansemikrofon som er laget for møterom, med 360 graders opptak, støydemping og rekkevidde som dekker hele bordet. For større rom kan det være nødvendig med flere mikrofoner.',
  },
  MeetingAiInfoTip2Title: {
    en: 'Inform about transcription in advance',
    nb: 'Informer om transkribering på forhånd',
  },
  MeetingAiInfoTip2Para: {
    en: "All participants should be aware that recording/transcription is starting. If Orgbrain's built-in video conferencing system is used, this will be clearly shown in the interface. If several people participate from a shared microphone/device, it can be useful for them to say their name the first time they speak. Orgbrain automatically keeps track of who is speaking if each person participates with their own user and device.",
    nb: 'Alle deltakere bør være inneforstått med at opptak/transkribering startes. Dersom Orgbrains innebygde videokonferansesystem benyttes, vil dette fremgå tydelig i grensesnittet. Dersom flere deltar fra felles mikrofon/enhet, kan det være nyttig at de sier navnet sitt første gang de tar ordet. Orgbrain holder automatisk styr på hvem som snakker dersom hver person deltar med sin egen bruker og enhet.',
  },
  MeetingAiInfoTip3Title: {
    en: 'Speak one at a time and avoid cross-talk',
    nb: 'Snakk én om gangen og unngå kryssprat',
  },
  MeetingAiInfoTip3Para: {
    en: 'Transcription becomes better when only one person speaks at a time. The meeting leader can contribute with stricter turn-taking if participants forget this in an engaging discussion.',
    nb: 'Transkriberingen blir bedre når kun én person snakker om gangen. Møteleder kan gjerne bidra med strammere ordstyring dersom deltakerne glemmer dette i en engasjerende diskusjon.',
  },
  MeetingAiInfoTip4Title: {
    en: 'Mark clearly when the meeting starts and when you switch cases',
    nb: 'Marker tydelig når møtet starter, og når dere bytter sak',
  },
  MeetingAiInfoTip4Para: {
    en: 'Be clear about when the formal meeting starts and when you move on to a new case on the agenda. The meeting leader can say something like: "We are now finished with case 1, and are moving on to case 2, which is a briefing on operations by the CEO." This will make it clear which case is being handled at all times and will increase the chance that the automatically generated minutes will be of high quality. Normally, the minutes will capture the essentials anyway, unless the conversation is very scattered.',
    nb: 'Vær tydelig på når det formelle møtet starter og når dere går over til en ny sak på agendaen. La gjerne møteleder si noe a la: "Vi sier oss nå ferdige med sak 1, og går nå over til sak 2, som er en orientering om driften ved daglig leder." Dette vil gjøre det klart hvilken sak som til enhver tid blir behandlet, og vil øke sjansen for at den automatisk genererte protokollen får en høy kvalitet. Normalt vil protokollen uansett fange opp det viktigste, med mindre samtalen er svært springende.',
  },
  MeetingAiInfoTip5Title: {
    en: 'Stop recording for sensitive cases',
    nb: 'Stopp opptaket ved sensitive saker',
  },
  MeetingAiInfoTip5Para: {
    en: 'If you do not want recording/transcription of a part of the meeting, it is easy to stop and start the recording. It can be appropriate when handling particularly sensitive topics or during breaks.',
    nb: 'Dersom dere ikke ønsker opptak/transkribering av en del av møtet, er det enkelt å stoppe og starte opptaket. Det kan være hensiktmessig ved behandlingen av spesielt sensitive temaer eller ved pauser.',
  },
  MeetingAISetupFinishedSettingsTitle: {
    en: 'Settings for Meeting AI',
    nb: 'Innstillinger for Møte-AI',
  },
  MeetingAISetupFinishedSettingsDescription: {
    en: 'Here you can set up the settings you want on Meeting AI. This can be changed at any time from the settings of the company.',
    nb: 'Her kan du sette opp innstillingene du ønsker på Møte-AI. Dette kan endres senere på innstillingssiden til selskapet.',
  },
  MeetingAIBeta: {
    en: 'Beta version',
    nb: 'Beta versjon',
  },
  MeetingAIInfoTitle: {
    en: 'About Meeting AI',
    nb: 'Om Møte-AI',
  },
  ConfirmedAttendance: {
    en: ' invited has confirmed attendance',
    nb: ' inviterte har bekreftet oppmøte',
  },
  ConfirmedAttendanceOf: {
    en: ' of ',
    nb: ' av ',
  },
  DeputiesWhoAttended: {
    en: 'Deputies who attended the meeting',
    nb: 'Varamedlemmer som deltok i møtet',
  },
  InvalidInputAltinnNumber: {
    en: 'Invalid input, must be a number without spaces and max 2 decimals',
    nb: 'Ugyldig inndata, må være et tall uten mellomrom og maks 2 desimaler',
  },
  ObserversWhoAttended: {
    en: 'Observers who attended the meeting',
    nb: 'Observatører som deltok i møtet',
  },
  agenda: {
    en: 'Agenda',
    nb: 'Agenda',
  },
  FormattingOfAgendaItems: {
    en: 'Formatting of agenda items',
    nb: 'Formatering av agendapunkter',
  },
  FormatingMinutesSettingsHelpText: {
    en: ' Here it is possible to enter different types of numbering of agenda items. By default, there is numbering 1, 2.3, etc. per meeting ("Regular number"). ',
    nb: ' Her er det mulighet å legge inn ulike type nummerering av agendapunkter. Standardinnstillingen er at det er nummerering 1, 2,3 osv. per møte («Vanlig nummer»). ',
  },
  BoardMeeting: {
    en: 'Board Meeting',
    nb: 'Styremøte',
  },
  DefaultSettingFornumbering: {
    en: 'Default setting for numbering',
    nb: 'Default innstilling ved nummerering',
  },
  GeneralAssembly: {
    en: 'General assembly',
    nb: 'Generalforsamling/Årsmøte',
  },
  Poll: {
    en: 'Poll',
    nb: 'Avstemning',
  },
  PollHelpText: {
    en: ' Here you can choose whether it should be stated by default that board members vote for a matter that is under consideration, or whether each board member must actively click on "For" or "Against" when a case requires a decision. ',
    nb: ' Her kan man velge om det som default skal ligge inne at styremedlemmer stemmer for en sak som er til behandling, eller om at hver styremedlem aktivt må klikke på «For» eller «Imot» når en sak krever et vedtak. ',
  },
  OrganizationImplicitVoting: {
    en: 'Organization implicit voting',
    nb: 'Standardinnstilling for stemmegivning',
  },
  ShowVoteResult: {
    en: 'Show vote result',
    nb: 'Vis stemmeresultat',
  },
  VoteSettingsHelpText: {
    en: ' To make it easier for the chairman to exercise control over the decisions made at general meetings/annual meetings, it is possible for those with administrator access to see what each participant votes. ',
    nb: ' For at møteledelsen enklere skal kunne føre kontroll over de vedtak som fattes på generalforsamlinger/årsmøter, kan man åpne for at de med administratortilgang, kan se hva den enkelte deltaker stemmer. ',
  },
  AllowInsightToVotingGeneralMeetings: {
    en: ' Allow the administrator to see what the participants are voting for at general meetings',
    nb: ' Tillat administrator å se hva deltakerne stemmer på generalforsamlinger',
  },
  OrganizationIdentityRequirements: {
    en: ' Identity Requirements ',
    nb: 'Krav til identifisering',
  },
  meetingEmail_from: {
    en: 'From',
    nb: 'Fra',
  },
  cancel: {
    en: 'Cancel',
    nb: 'Avbryt',
  },
  SaveButton: {
    en: 'Save',
    nb: 'Lagre',
  },
  recipients: {
    en: ' Recipients ',
    nb: ' Mottaker ',
  },
  status: {
    en: ' Status ',
    nb: 'Status',
  },
  timeUpdated: {
    en: ' Updated ',
    nb: ' Oppdatert ',
  },
  noStatusMessage: {
    en: 'No status',
    nb: 'Ingen status',
  },
  sendStatus: {
    en: 'Send',
    nb: 'Sendt',
  },
  deliveryStatus: {
    en: 'Delivery',
    nb: 'Mottatt',
  },
  clickStatus: {
    en: 'Click',
    nb: 'Klikk',
  },
  ComplaintStatus: {
    en: 'Complaint',
    nb: 'Klage',
  },
  OpenStatus: {
    en: 'Open',
    nb: 'Åpnet',
  },
  RejectStatus: {
    en: 'Reject',
    nb: 'Avist',
  },
  RenderingStatus: {
    en: 'Rendering Failure',
    nb: 'Rendering feilet',
  },
  failureStatus: {
    en: 'Failure',
    nb: 'Feilet',
  },
  hardbounceStatus: {
    en: 'Hard bounce',
    nb: 'Melding blokert',
  },
  EditUserHistory: {
    en: 'Edit User history',
    nb: 'Rediger brukerhistorikk',
  },
  EditPastRolesText: {
    en: 'Edit past role(s) for this user',
    nb: 'Rediger tidligere rolle(r) for denne bruker',
  },
  AddButton: {
    en: 'Add',
    nb: 'Legg til',
    sv: 'Lägg till',
  },
  DoneButton: {
    en: 'Done',
    nb: 'Utført',
    sv: 'Klar',
  },
  Submit: {
    en: 'Submit',
    nb: 'Send inn',
  },

  AllowClientNameInEmails: {
    en: 'Allow using client logo in emails',
    nb: 'Tillat bruk av klientlogo i e-poster',
  },
  AllowCustomBillingSystem: {
    en: 'Allow using custom billing system',
    nb: 'Tillat å bruke tilpasset faktureringssystem',
  },
  ClientOrderKey: {
    en: 'Order key',
    nb: 'Ordrenr.',
  },
  Orders: {
    en: 'Orders',
    nb: 'Ordrer',
  },
  FetchingClientInformation: {
    en: 'Fetching client information',
    nb: 'Henter klientinformasjon',
  },
  MeetingsSoon: {
    en: 'Meetings soon',
    nb: 'Kommende møter',
  },
  CreateCompany: {
    en: 'Create New Company',
    nb: 'Opprett ny organisasjon',
  },
  AddOrgNameAndNumber: {
    en: ' Add organization name and number ',
    nb: ' Legg inn navn og nummer på organisasjonen ',
  },
  OrgNumber: {
    en: 'Organization number',
    nb: 'Organisasjonsnummer',
    sv: 'Organisationsnummer',
  },
  votingForAgendaItemIsClosed: {
    en: 'Vote closed',
    nb: 'Avstemning stengt',
  },
  votingForAgendaItemIsOpen: {
    en: 'Vote open',
    nb: 'Avstemning åpen',
  },
  'meetings.noVotesRegisteredForPl': {
    en: 'No votes registered for',
    nb: 'Ingen stemmer registrert for',
  },
  'meetings.noVotesRegisteredFor': {
    en: 'No vote registered for',
    nb: 'Ingen stemme registrert for',
  },
  ValidOrgNoMessage: {
    en: ' Must be a least 3 characters. Only numbers and letters are allowed. ',
    nb: 'Må være minst 3 tegn. Bare tall og bokstaver er tillatt.',
  },
  ContinueButton: {
    en: ' Continue ',
    nb: 'Fortsette',
  },
  OrgnumberAlreadyTakenTitle: {
    en: 'Could not create organization',
    nb: 'Kan ikke opprette organisasjon',
  },
  LoadBisnodeDataTitle: {
    en: 'Import board members?',
    nb: 'Importer styremedlemmer?',
  },
  OnboardWithOutAdminTitle: {
    en: 'You have not defined any user as an administrator!',
    nb: 'Du har ikke definert noen brukere som administrator!',
  },
  OnboardWithOutAdminMessage: {
    en: 'You must give at least one of the users in the organization the role of administrator. If not, no one will be able to manage the organization',
    nb: 'Du må gi minst én av brukerne administratorrettigheter. Hvis ikke, vil ingen kunne administrere organisasjonen.',
  },
  SendInviteToUsersTitle: {
    en: 'Send invites to the users?',
    nb: 'Send invitasjoner til brukerne?',
  },
  SendInviteToUsers: {
    en: 'Send email to new users with a registration link?',
    nb: 'Send e-post til de brukerne du har lagt inn, slik at de kan registrere seg? ',
  },
  yes: {
    en: 'Yes',
    nb: 'Ja',
  },
  OnboardingSuccess: {
    en: 'Onboarding successful',
    nb: 'Registrering er nå gjennomført',
  },
  OnboardingNoTaxWarning: {
    en: 'Onboarding successful but no tax office data',
    nb: 'Registrering er gjennomført, men uten data fra skatteetaten',
  },
  ErrorOnboarding: {
    en: 'Problem onboarding company',
    nb: 'Problem med å registrere organisasjonen',
  },
  ContactSupport: {
    en: 'Please contact support',
    nb: 'Vennligst kontakt den i selskapet som er administrator',
  },
  ThereAreUsersWithoutEmailsDetails: {
    en: 'If you continue these users will be discarded.',
    nb: 'Det er ikke lagt inn e-postadresse på alle brukerne. Hvis du fortsetter vil disse brukerne bli fjernet.',
  },
  ThereAreUsersWithoutEmailsContinue: {
    en: 'Continue',
    nb: 'Fortsett',
  },
  ThereAreUsersWithoutEmailsCancel: {
    en: 'Cancel',
    nb: 'Avbryt',
  },
  ThereAreInvalidEmails: {
    en: 'There are invalid emails.',
    nb: 'Det er e-postadresser med mangler.',
  },
  TransactionTableType: {
    en: 'Type',
    nb: 'Type',
  },
  Chair: {
    en: 'Chair',
    nb: 'Styrets leder',
  },
  Established: {
    en: 'Established',
    nb: 'Stiftelsesdato',
  },
  ConfirmRestore: {
    en: 'Restore',
    nb: 'Gjenopprett',
  },
  LoadingPleaseWait: {
    en: 'loading please wait',
    nb: 'Laster vennligst vent',
  },
  EmailsNotValidTitle: {
    en: 'Some emails are not valid.',
    nb: 'Noen e-postmeldinger er ikke gyldige.',
  },
  SaveAnywayAndLose: {
    en: 'If you proceed only users with valid emails will be saved.',
    nb: 'Hvis du fortsetter vil kun brukere med gyldige e-postadresse bli lagret.',
  },
  delete: {
    en: 'Delete',
    nb: 'Slett',
  },
  TotalNumUniqUsers: {
    en: 'Total number of unique users',
    nb: 'Totalt antall unike brukere',
  },
  EksEksclusiveShort: {
    en: 'ex',
    nb: 'eks',
  },
  NumUniqUsersSubgr: {
    en: 'Unique users in subgroups',
    nb: 'Unike brukere i undergrupper',
  },
  UniqUsertypeUsers: {
    en: 'Unique $USERTYPE users',
    nb: 'Unike brukere $USERTYPE',
  },
  'Clients-clients': {
    en: 'Clients',
    nb: 'Klienter',
  },
  ClientId: {
    en: ' ClientId ',
    nb: ' KlientId ',
  },
  Organisation_name: {
    en: 'Name',
    nb: ' Navn',
  },
  SuperListUsers: {
    en: 'Users',
    nb: 'Brukere',
  },
  CreatedText: {
    en: 'Created',
    nb: 'Opprettet',
  },
  AddDaughterCompany: {
    en: 'Add daughter company',
    nb: 'Legg til datterselskap',
  },
  VerifyIdentity: {
    en: ' Verify identity ',
    nb: 'Bekreft identitet',
  },
  ShowAllNews: {
    en: 'Show all news',
    nb: 'Se alle nyheter',
  },
  ShowLessNews: {
    en: 'Show less news',
    nb: 'Se færre nyheter',
  },
  UpcomingMeetings: {
    en: 'Upcoming meetings',
    nb: 'Kommende møter',
    sv: 'Kommande möten',
  },
  ShowAll: {
    en: 'Show all',
    nb: 'Se alle',
    sv: 'Visa alla',
  },
  ShowLessText: {
    en: 'Show less',
    nb: 'Se færre',
    sv: 'Visa mindre',
  },
  SearchfilesInfoText: {
    en: ' Here you can search for the files to which you have been given access. ',
    nb: ' Her kan du gjøre søk på de filene som du er gitt tilgang til. ',
  },

  SharesAssigned: {
    en: ' Shares assigned ',
    nb: 'Tildelte aksjer',
  },
  AssignedTotal: {
    en: ' Assigned total ',
    nb: 'Tildelt beløp',
  },
  SharesOrdered: {
    en: ' Shares ordered ',
    nb: 'Bestilte aksjer',
  },
  Kurs: {
    en: 'Share price',
    nb: 'Kurs',
  },
  ContractDeal: {
    en: 'Contract',
    nb: 'Avtale',
    sv: 'Avtal',
  },
  correctPersonalInfoDialouge: {
    en: ' We depend on correct information about you to give you the best service and follow up. It is good if you can adjust the information that might be wrong, add information that might be missing and at the end confirm that the information is correct. ',
    nb: ' Vi er avhengig av riktige opplysninger om deg for å gi deg best mulig service og oppfølging. Fint om du kan justere opplysninger som eventuelt er feil, legge inn opplysninger som eventuelt mangler og til slutt bekrefte at opplysningene stemmer. ',
  },
  DateOfBirthSixNumbers: {
    en: 'Date of birth (ddmmyy, 6 numbers)',
    nb: 'Fødselsdato (ddmmyy, 6 siffer)',
  },
  PersonalNumberFiveNumbers: {
    en: 'Personal number (5 numbers)',
    nb: 'Personnummer (5 siffer)',
  },
  AdressText: {
    en: 'Address',
    nb: 'Forretningsadresse',
    sv: 'Address',
  },
  PercentageComplete: {
    en: 'Percentage complete',
    nb: 'Andel gjennomført',
  },
  OrderedUntilNow: {
    en: 'Ordered',
    nb: 'Bestilt',
  },
  AmountOfShareholders: {
    en: 'Amount of investors',
    nb: 'Antall investorer',
  },
  SeeLess: {
    en: 'See less',
    nb: 'Se mindre',
  },
  SeeFullText: {
    en: 'See full text',
    nb: 'Se hele teksten',
  },
  HowManySharesWouldYouLike: {
    en: ' How many shares would you like in this issue? ',
    nb: 'Hvor mange aksjer vil du bestille i denne emisjonen?',
  },
  SignAgreement: {
    en: ' Sign agreement ',
    nb: 'Signér avtale',
  },
  FinishingAgreement: {
    en: 'Finishing agreement',
    nb: 'Ferdigstill avtale',
  },
  AwaitingSignature: {
    en: 'Awaiting signature',
    nb: 'Avventer signatur',
  },
  NewDraft: {
    en: 'New draft',
    nb: 'Nytt utkast',
  },
  AreYouSureToEditMinutes: {
    en: 'Do you want to edit the minutes PDF, or start with a new draft? Editing the PDF will be overwritten if you generate a new draft.',
    nb: 'Ønsker du å redigere på protokoll PDF-en, eller starte med å generere et nytt utkast? Redigering på PDF vil bli overskrevet om du generer et nytt utkast.',
  },
  EditMinutesPDF: {
    en: 'Edit PDF',
    nb: 'Rediger PDF',
  },
  EditMinutes: {
    en: 'Edit minutes',
    nb: 'Rediger protokoll',
  },
  SignContract: {
    en: ' Sign contract ',
    nb: 'Signér avtale',
  },
  EmissionsContractSignedTitle: {
    en: 'You have placed an order in the equity issue',
    nb: 'Du har bestilt aksjer i kapitalforhøyelsen',
  },
  YourDetails: {
    en: 'Your details',
    nb: 'Dine detaljer',
  },
  TranscriptionDaysRemainingTooltip: {
    en: 'The transcription subscription will expire in ',
    nb: 'Abonnementet for transkripsjon vil utløpe om ',
  },
  TranscriptionCustomPricesTexts: {
    en: 'Contact for tailored price',
    nb: 'Ta kontakt for tilpasset pris',
  },
  SharePrice: {
    en: 'Share price',
    nb: 'Aksjekurs',
  },
  DownloadTheSignedDocument: {
    en: 'Download the signed document',
    nb: 'Last ned det signerte dokumentet',
  },
  ShareIssueNoLongerAvailable: {
    en: ' This share issue is completed and no longer accepts investors ',
    nb: 'Emisjonen er ferdig og godtar ikke lenger investorer',
  },
  hours: {
    en: 'hours',
    nb: 'timer',
  },
  MeetingTypePlaceHolder: {
    en: 'Meeting type',
    nb: 'Møtetype:',
  },
  ProcedureTypePlaceHolder: {
    en: 'Processing Method',
    nb: 'Behandlingsmåte',
  },
  generateRecommendedAgendaItems: {
    en: 'Generate recommended agenda items ',
    nb: 'Bruk anbefalte agendapunkter\n',
  },
  startPlanFrom: {
    en: 'Start plan from',
    nb: 'Start plan fra',
  },
  numberOfMeetings: {
    en: 'Number of meetings',
    nb: 'Antall møter',
  },
  preferredWeekday: {
    en: 'Preferred weekday',
    nb: 'Ønsket ukedag',
  },
  'Any workday': {
    en: 'Any workday',
    nb: 'Tilfeldig arbeidsdag',
  },
  Monday: {
    en: 'Monday',
    nb: 'Mandag',
  },
  Tuesday: {
    en: 'Tuesday',
    nb: 'Tirsdag',
  },
  Wednesday: {
    en: 'Wednesday',
    nb: 'Onsdag',
  },
  Thursday: {
    en: 'Thursday',
    nb: 'Torsdag',
  },
  Friday: {
    en: 'Friday',
    nb: 'Fredag',
  },
  Saturday: {
    en: 'Saturday',
    nb: 'Lørdag',
  },
  Sunday: {
    en: 'Sunday',
    nb: 'Søndag',
  },
  preferredTimeOfDay: {
    en: 'Preferred time of day',
    nb: 'Ønsket tidspunkt på dagen',
  },
  preferredDuration: {
    en: 'Preferred duration',
    nb: 'Ønsket varighet',
  },
  preferredLocation: {
    en: 'Preferred location',
    nb: 'Ønsket sted',
  },
  procedureType: {
    en: 'Processing Method',
    nb: 'Behandlingsmåte',
  },
  create: {
    en: 'Create',
    nb: 'Opprett',
  },
  edit: {
    en: 'Edit',
    nb: 'Rediger',
  },
  LoadingNewRecordings: {
    en: 'Loading new recordings',
    nb: 'Laster nye opptak',
  },
  gaVoteRequirementForApproval: {
    en: 'Vote requirement for approval',
    nb: 'Avstemningskrav for vedtak',
  },
  title: {
    en: 'Title',
    nb: 'Tittel',
  },
  category: {
    en: 'Category',
    nb: 'Kategori',
  },
  description: {
    en: 'Description',
    nb: 'Beskrivelse',
    sv: 'Beskrivning',
  },
  Risks: {
    en: 'Risks',
    nb: 'Risikoer',
  },
  AgendaItems: {
    en: 'Agenda items',
    nb: 'Agendapunkter',
  },
  TopicTasksAndQuestions: {
    en: 'Tasks and questions ',
    nb: 'Oppgaver og spørsmål ',
  },
  proposed_resolution: {
    en: 'Proposed resolution',
    nb: 'Forslag til vedtak',
  },
  'FileBrowserTip-UploadFile': {
    en: 'Upload file',
    nb: 'Last opp fil',
  },
  votingForThisAgendaItemIsClosed: {
    en: 'Voting for this agenda item is closed',
    nb: 'Avstemningen for dette agendapunkt er stengt',
  },
  snackbarRemoveAttachmentInfo: {
    en: 'Attachment removed. The file is still accessible in the file attachments section.',
    nb: 'Vedlegget er fjernet. Filen er fremdeles tilgjengelig i seksjonen "Filvedlegg".',
  },
  NotChangedMinuteText: {
    en: 'The protocol is unchanged after this edit',
    nb: 'Protokollen er uendret etter denne redigeringen',
  },
  TranscriptionsDisabled: {
    en: 'Meeting AI is disabled for this organization. Go to Organization settings to enable this.',
    nb: 'Møte-AI er deaktivert for denne organisasjonen. Gå til Organisasjonsinnstillinger for å aktivere dette.',
  },
  MeetingTookPlace: {
    en: 'Meeting took place',
    nb: 'Møtet er avsluttet',
  },
  EntitiesWithDisplayIdentityWithoutSSNTitle: {
    en: 'Entities without entity identifier',
    nb: 'Eiere uten aksjonæridentifikasjon',
  },
  EntitiesWithDisplayIdentityWithoutSSNText: {
    en: 'The following entities are missing an entity identifier, confirm that it is correct.',
    nb: 'Følgende eiere mangler en aksjonæridentifikasjon, bekreft at det er riktig.',
  },
  NonValidSubmission: {
    en: 'Non valid submission, no data was sent to Altinn',
    nb: 'Innleveringen ble ikke godkjent, ingen data ble sendt til Altinn',
  },
  noAgendaAddedYet: {
    en: 'No agenda items added.',
    nb: 'Ingen agendapunkter er lagt til.',
  },
  MarkAsFinished: {
    en: 'Mark as finished',
    nb: 'Merk som fullført',
  },
  ShowAgendaItemDescriptions: {
    en: 'Show agenda item descriptions',
    nb: 'Vis agendapunktbeskrivelser',
  },
  ClickToAddProposedResolution: {
    en: 'Click to add proposed resolution',
    nb: 'Klikk for å legge til forslag til vedtak',
  },
  Attendance: {
    en: 'Attendance',
    nb: 'Deltagelse',
  },
  SpeakingTimeDistribution: {
    en: 'Speaking time distribution',
    nb: 'Fordeling av taletid',
  },
  VotingResults: {
    en: 'Voting Results',
    nb: 'Stemmeresultater',
  },
  AgendaItemDescription: {
    en: 'Agenda Item Description',
    nb: 'Agendabeskrivelse',
  },
  AgendaItemVoting: {
    en: 'Vote',
    nb: 'Avstemning',
  },
  NoticeOfMeeting: {
    en: 'Notice of meeting',
    nb: 'Innkalling',
  },
  NoticeOfMeetingDescription: {
    nb: 'Dette feltet er valgfritt og brukes til praktisk møteinformasjon til deltakerne. Når du inviterer til møtet, legges teksten automatisk som forslag i e-posten til deltakerne. Du kan redigere eller slette tekstforslaget i e-posten før utsendelse. Teksten vises også øverst i innkallingen på oversiktssiden.',
    en: 'This field is optional and used for practical meeting information for participants. When you invite to the meeting, the text is automatically added as a suggestion in the email to the participants. You can edit or delete the text suggestion in the email before sending. The text also appears at the top of the invitation on the overview page.',
  },
  MeetingFilesTab: {
    en: 'Attachments',
    nb: 'Vedlegg',
  },
  MeetingFilesHelpText: {
    nb: 'Her kan du laste opp filer som tilhører møtet. For enkel tilgang anbefaler vi å laste opp vedlegg direkte på agendapunktet de gjelder. Da blir det tydelig hvilket dokument som hører til hver sak, og dokumentene vises også i denne filoversikten.',
    en: 'Here you can upload files that belong to the meeting. For easy access, we recommend uploading attachments directly on the agenda item they relate to. This makes it clear which document belongs to which case, and the documents are also displayed in this file overview.',
  },

  PracticalInformationAboutMeeting: {
    en: 'Practical information about the meeting',
    nb: 'Praktisk informasjon om møtet',
  },
  PracticalInformationText: {
    nb: 'Skriv praktisk informasjon til deltakerne',
    en: 'Write practical information to participants',
  },
  AgendaItemWithoutATitle: {
    en: 'Agenda item with no title',
    nb: 'Agendapunkt uten tittel',
  },
  generalcomments: {
    en: 'General comments',
    nb: 'Generelle kommentarer',
  },
  decision_notes_if_different: {
    en: 'Decision notes (if different from the proposed resolution)',
    nb: 'Vedtakstekst (hvis denne avviker fra forslag til vedtak)',
  },
  AgendaDescription: {
    nb: 'Saksbeskrivelse',
    en: 'Agenda description',
  },
  voted_for: {
    en: ' Voted for ',
    nb: 'Stemte for',
  },
  voted_against: {
    en: ' Voted against ',
    nb: 'Stemte imot',
  },
  unanimous: {
    en: 'Unanimous',
    nb: 'Enstemmig',
  },
  loading: {
    en: 'Loading',
    nb: 'Laster',
  },
  for_voting: {
    en: 'For',
    nb: 'For',
  },
  against_voting: {
    en: 'Against',
    nb: 'Imot',
  },
  MaximumElectedNumber: {
    en: 'Maximum elected number',
    nb: 'Antall posisjoner',
  },
  save: {
    en: ' Save ',
    nb: 'Lagre',
  },
  customAgendaSuggestionsForThisOrganization: {
    en: ' Custom Agenda Suggestions ',
    nb: 'Egendefinerte agendaforslag',
  },
  manageAgendaSuggestionsHelpCustomAgendaSuggestions: {
    en: ' Click the plus button in the lower right corner to add new custom agenda suggestions. Drag an agenda item up or down to change the order in which the custom agenda suggestions appear in the list. This list will appear when you edit the agenda for a meeting. ',
    nb: 'Klikk på pluss-knappen nede til høyre for å legge til nye egendefinerte agendaforslag. Dra et agendaforslag opp eller ned for å endre rekkefølgen de egendefinerte agendaforslagene har i listen som dukker opp når du redigerer agendaen for et møte.',
  },
  orgbrainsAgendaSuggestions: {
    en: ' Built-in Agenda Suggestions ',
    nb: 'Innebygde agendaforslag',
  },
  manageAgendaSuggestionsHelpOrgbrainAgendaSuggestions: {
    en: ' If you edit and save these, your modified version of the agenda suggestion will be added to the list of custom agenda suggestions. You will not modify the original Orgbrain agenda suggestion. ',
    nb: 'Hvis du redigerer og lagrer en av disse, så vil din modifiserte versjon av agendaforslaget bli lagt til i listen med egendefinerte agendaforslag. Du endrer ikke Orgbrain sin originale versjonen.',
  },
  add_new_agenda_suggestion: {
    en: 'Add new agenda suggestion',
    nb: 'Nytt agendaforslag',
  },
  sort_by: {
    en: 'Sort by',
    nb: 'Sorter',
  },
  roleOrRoles: {
    en: ' Role(s) ',
    nb: 'Rolle(r)',
  },
  votingright: {
    en: 'Vote',
    nb: ' Stemme',
  },
  MobileYearwheelHelper: {
    en: ' To be able to see the calendar on mobile you have to use landscape mode... ',
    nb: 'For å se årshjulet på mobil må du bruke landskapsmodus... ',
  },
  TimeText: {
    en: 'Time',
    nb: 'Tid',
    sv: 'Tid',
  },
  SendInviteTOSignButton: {
    en: ' Send ',
    nb: 'Send',
  },
  send_invitation_by_email: {
    en: 'Send notification of meeting by email',
    nb: 'Send varsel om møtet på e-post',
  },
  invite_to_meeting: {
    en: 'Invite to meeting',
    nb: 'Inviter til møtet',
  },
  ProceedDataUnsaved: {
    en: 'Proceed with unsaved meeting data?',
    nb: 'Fortsett med ulagrede møtedata?',
  },
  OutdatedMeetingDetails: {
    en: 'If you continue, invitation may contain outdated meeting details.',
    nb: 'Hvis du fortsetter, kan invitasjon inneholde utdaterte møtedetaljer.',
  },
  CloseMeetingForParticipants: {
    en: 'Close participation',
    nb: 'Steng påmelding',
  },
  CloseMeetingForParticipantsTooltip: {
    en: 'Close participation for this meeting so that no more participants can confirm their attendance.',
    nb: 'Steng påmelding for dette møtet slik at ingen flere deltagere kan bekrefte oppmøtet sitt.',
  },
  FirstWithdrawCurrentVoteText: {
    en: 'Maximum number of votes reached. To change the vote, current vote must first be withdrawn.',
    nb: 'Maksimalt antall stemmer avgitt. For å endre avstemningen må avgitt stemme først trekkes tilbake.',
  },
  CloseAgendaLibrary: {
    en: 'Close agenda library',
    nb: 'Lukk agendabibliotek',
  },
  OpenAgendaLibrary: {
    en: 'Open agenda library',
    nb: 'Åpne agendabibliotek',
  },
  NoticeOfMeetingText: {
    en: 'Practical information',
    nb: 'Praktisk informasjon',
  },
  votingOutcome: {
    en: ' Voting outcome ',
    nb: 'Resultat av avstemning',
  },
  Lottery: {
    en: 'Lottery',
    nb: 'Loddtrekning',
  },
  OnElection: {
    en: 'On election',
    nb: 'På valg',
  },
  numberOfVotes_electionResults: {
    en: 'Number of votes',
    nb: 'Antall stemmer',
  },
  totalRepresented: {
    en: 'Total represented',
    nb: 'Totalt representert',
  },
  VotesFor: {
    en: 'Votes for',
    nb: 'Stemmer for',
  },
  SumOfVotes: {
    en: 'Sum of votes',
    nb: 'Summen av stemmene',
  },
  result: {
    en: 'Result',
    nb: 'Resultat',
  },
  elected: {
    en: 'elected',
    nb: 'valgt',
  },
  openVotingForAgendaItem: {
    en: 'Open voting for this agenda item',
    nb: 'Åpne avstemningen for dette agendapunktet',
  },
  closeVotingForAgendaItem: {
    en: 'Close voting for this agenda item',
    nb: 'Steng avstemning for dette agendapunktet',
  },
  attachments: {
    en: 'Attachments',
    nb: 'Vedlegg',
  },
  DownloadOwnersFileName: {
    en: 'File name',
    nb: 'Filnavn',
  },
  MenuRename: {
    en: 'Rename',
    nb: 'Endre navn',
  },
  RemoveAttachment: {
    en: 'Remove attachment',
    nb: 'Fjern vedlegg',
  },
  RemoveFileAttachment: {
    en: 'Remove the attachment.',
    nb: 'Fjern vedlegget',
  },
  RemoveFileAttachmentConfirm: {
    en: 'The attachment will be removed from the agenda item, but remains in the file attachments folder.',
    nb: 'Vedlegget blir fjernet fra agendapunktet, men blir fortsatt liggende i mappen med filvedlegg.',
  },
  ConfirmToProceed: {
    en: 'Please confirm to proceed.',
    nb: 'Bekreft for å fortsette.',
  },
  file_attachments: {
    en: 'File attachments',
    nb: 'Filvedlegg',
  },
  followupCase: {
    en: 'Follow-up task (Action point)',
    nb: 'Oppfølgingssak (Oppgave)',
  },
  newFollowupCase: {
    en: 'New follow-up task (Action point)',
    nb: 'Ny oppfølgingssak (Oppgave)',
  },
  completed: {
    en: ' Completed',
    nb: 'Fullført',
  },
  responsible_followup: {
    en: 'Responsible for follow-up',
    nb: 'Ansvarlig for oppfølging',
  },
  followup_date: {
    en: 'Follow-up date',
    nb: 'Oppfølgingsdato',
  },
  responsibleForFollowup: {
    en: 'Responsible for follow-up',
    nb: 'Ansvarlig for oppfølgingssak',
  },
  followupDate: {
    en: 'Follow-up date',
    nb: 'Dato for oppfølgingssak',
  },
  followup_case: {
    en: 'Follow-up case',
    nb: 'Oppfølgingssak (Oppgave)',
  },
  'client.ClientUsers': {
    en: 'Client users',
    nb: 'Klientbrukere',
  },
  notAnswered: {
    en: 'Not answered',
    nb: 'Ikke svart',
  },

  all_answered_invitation: {
    en: 'Everyone has answered the invitation.',
    nb: 'Alle har besvart invitasjonen.',
  },
  not_attending: {
    en: 'Not attending',
    nb: 'Deltar ikke',
  },
  none_attending: {
    en: 'No one has clicked not attending yet. ',
    nb: 'Ingen har enda klikket "Deltar ikke". ',
  },
  attending: {
    en: 'Attending',
    nb: 'Deltar',
  },
  no_attending_clicks: {
    en: 'No one has clicked attending yet. ',
    nb: 'Ingen har klikket "Deltar" enda. ',
  },
  part: {
    en: 'Part',
    nb: 'Andel',
  },
  proxy: {
    en: 'Proxy',
    nb: 'Fullmektig',
  },
  RepresentedWith: {
    en: 'Represented by',
    nb: 'Representert ved',
  },
  removeFromParticipants: {
    en: 'Remove from participants',
    nb: ' Ta vekk fra "Deltakere" ',
  },
  'meetings.Agendainformation': {
    en: 'Information about the agenda suggestion',
    nb: 'Informasjon om agendapunktet',
  },

  'shareholders.CreateStockSplitTooltip': {
    en: 'Here you can carry out a share split, where each share in the company is divided into several shares. This is relevant to do when the company wants to reduce the value per share. As the number of shares changes in a share split, this requires a general meeting resolution as the articles of association must be updated.',
    nb: 'Her kan du gjennomføre en aksjesplitt, der hver aksje i selskapet deles opp i flere aksjer. Dette er relevant å gjøre når selskapet ønsker å redusere verdien per aksje. Da antall aksjer endrer seg ved en aksjesplitt, krever dette en generalforsamlingsbeslutning da vedtektene må oppdateres.',
  },
  'shareholders.CreateStockSpliceTooltip': {
    en: 'Here you can carry out a share split, where you reduce the number of shares in the company by merging existing shares. This may be relevant to do if the company wants to increase the value per share. As the number of shares changes in a share split, this requires a general meeting resolution as the articles of association must be updated.',
    nb: 'Her kan du gjennomføre en aksjespleis, der du reduserer antall aksjer i selskapet ved å slå sammen eksiterende aksjer. Dette kan være relevant å gjøre dersom selskapet ønsker å øke verdien per aksje. Da antall aksjer endrer seg ved en aksjespleis, krever dette en generalforsamlingsbeslutning da vedtektene må oppdateres.',
  },

  no_invited_boardmembers: {
    en: ' No invited boardmembers yet. ',
    nb: 'Enda ingen inviterte styremedlemmer.',
  },
  no: {
    en: 'No',
    nb: 'Nei',
  },
  attendingWithVotingRights: {
    en: 'Attending with voting rights',
    nb: 'Deltar med stemmerett',
  },
  attendingWithoutVotingRights: {
    en: 'Attending without voting rights',
    nb: 'Deltar uten stemmerett',
  },
  appointAsMeetingLeader: {
    en: ' Appoint as meeting leader ',
    nb: 'Angi som møteleder',
  },
  go_to_meeting: {
    en: 'Go to meeting',
    nb: 'Gå til møte',
  },
  calendar: {
    en: 'Calendar',
    nb: 'Kalender',
  },
  createannualplan: {
    en: 'Create annual plan',
    nb: 'Lag ny årsplan',
  },
  deleteannualplan: {
    en: 'Delete annual plan',
    nb: 'Slett årsplan',
  },
  DownloadOwnerDataTitle: {
    en: 'Download data',
    nb: 'Last ned data',
  },
  updatedAt: {
    en: 'Created at',
    nb: 'Created at',
  },
  submittedBy: {
    en: 'Submitted by',
    nb: 'Registrert av',
  },
  Regarding: {
    en: 'Regarding',
    nb: 'Vedrørende',
  },
  PowerProxyGivenTo: {
    en: 'Power of attorney shall be given to',
    nb: 'Fullmakt skal bli gitt til',
  },
  ChairmanOfTheBoard: {
    en: 'Chairman of the Board',
    nb: 'Styreleder',
  },
  OtherPerson: {
    en: 'Other person',
    nb: 'Annen person',
  },
  EmailOfProxy: {
    en: 'Email of Proxy',
    nb: 'E-postadresse til fullmektig',
  },
  FinishEditing: {
    en: ' Finish editing ',
    nb: 'Avslutt redigering',
  },
  Sign: {
    en: 'Sign',
    nb: 'Signer',
  },
  CheckToSign: {
    en: 'Check to submit electronic signature',
    nb: 'Kryss av for å avgi elektronisk signatur',
  },
  DeviceDeleted: {
    en: 'Deleted',
    nb: 'Slettet',
  },
  StartMeetingAction: {
    en: 'Start Meeting',
    nb: 'Start møtet',
  },
  IAmAttending: {
    en: 'I am attending',
    nb: 'Jeg deltar',
  },
  IAmNotAttending: {
    en: 'I am not attending',
    nb: 'Jeg deltar ikke',
  },
  copyMeeting: {
    en: 'Copy meeting',
    nb: 'Kopier møtet',
  },
  deleteMeeting: {
    en: 'Delete meeting',
    nb: 'Slett møtet',
  },
  seeEmailInvitation: {
    en: 'See email invitation',
    nb: 'Se e-postinvitasjon',
  },
  buttonPrevious: {
    en: 'Previous meeting',
    nb: 'Forrige møte',
  },
  buttonNext: {
    en: 'Next meeting',
    nb: 'Neste møte',
  },
  MeetingChat: {
    en: 'Chat',
    nb: 'Møtechat',
  },
  Modify: {
    en: 'Modify',
    nb: 'Endre',
  },
  TrustDeviceButtonYes: {
    en: 'Yes',
    nb: 'Ja',
  },
  TrustDeviceButtonNo: {
    en: 'No',
    nb: ' Nei ',
  },
  DatePlaceHolder: {
    en: 'Date',
    nb: 'Dato',
  },
  MeetingLocation: {
    en: 'Meeting location',
    nb: 'Møtested',
  },
  customVideoConfUrlHint: {
    en: "Orgbrain's default video conference solution is based on Jitsi (see jitsi.org). We recommend the use of another solution if your meeting exceeds 15 participants. If you will be using another solution, you can provide the sharing link to the video meeting here.",
    nb: 'Orgbrain har en innebygget løsning for videokonferanser basert på Jitsi (se jitsi.org). Vi anbefaler å bruke annen løsning ved mer enn 15 deltakere. Om dere vil benytte en annen løsning kan du legge inn delingslenken til videomøtet her.',
  },
  customVideoConfUrl: {
    en: 'Video conference link',
    nb: 'Lenke til videokonferanse',
  },
  MeetingStatusPlaceHolder: {
    en: 'Meeting Status',
    nb: 'Møtestatus',
  },
  meetingTypeIsRequired: {
    en: 'Meeting type is required',
    nb: 'Møtetype er påkrevd',
  },
  HideVideoIcon: {
    en: 'Hide video icon',
    nb: 'Skjul videoikon',
  },
  HideProxyForm: {
    en: 'Hide proxy form',
    nb: 'Skjul fullmaktsskjema',
  },
  'meetingEmail_meeting-address-info': {
    en: ' Send an email to the address below, and the email content and attached files will appear here. ',
    nb: 'Send en e-post til adressen under, så vil e-posten og eventuelle filvedlegg dukke opp her.',
  },
  meetingEmail_attachments: {
    en: 'Attachments',
    nb: 'Filvedlegg',
  },
  meetingEmails_newEmailReceived: {
    en: 'New email received for this meeting',
    nb: 'Ny e-post mottatt for møtet',
  },
  meetingEmails_emailDeleted: {
    en: 'An email was deleted',
    nb: 'En e-post ble slettet',
  },
  meetingEmails_markAsReadError: {
    en: 'Could not mark email as read',
    nb: 'Kunne ikke merke e-posten som lest',
  },
  meetingEmails_markAsUnreadError: {
    en: 'Could not mark email as unread',
    nb: 'Kunne ikke merke e-posten som ulest',
  },
  meetingEmails_deleteEmailConfirmationDialogHeader: {
    en: 'Delete email for everyone?',
    nb: 'Slett e-posten for alle?',
  },
  meetingEmails_deleteEmailConfirmationDialogText: {
    en: 'Are you sure you want to delete the email? This will delete the email for everyone who has access to the meeting.',
    nb: 'Er du sikker på at du vil slette e-posten? Dette vil slette e-posten for alle som har tilgang til møtet.',
  },
  meetingEmails_deleteEmailConfirmationDialogTextAttachmentFilesWillBeDeleted: {
    en: 'The attachment files will also be deleted.',
    nb: 'De vedlagte filene vil også bli slettet.',
  },
  meetinEmails_meetingEmailObjectNotFoundErrorMessage: {
    en: 'Could not find the email. Maybe it has already been deleted?',
    nb: 'Kunne ikke finne e-posten. Kanskje den allerede er blitt slettet?',
  },
  meetinEmails_meetingEmailObjectDeletionFailedErrorMessage: {
    en: 'An error occurred when trying to delete the email.',
    nb: 'Det oppstod en feil under sletting av e-posten.',
  },
  meetingEmails_oneProblemDeletingTheEmailDialogHeader: {
    en: 'There was a problem deleting the email',
    nb: 'Det oppstod et problem ved sletting av e-posten',
  },
  meetingEmails_multipleProblemsDeletingTheEmailDialogHeader: {
    en: 'There were some problems deleting the email',
    nb: 'Det oppstod noen problemer ved sletting av e-posten',
  },
  meetingEmailCopiedToClipboard: {
    en: 'Meeting email address copied to clipboard.',
    nb: 'E-postadresse til møte ble kopiert til utklippstavlen.',
    sv: 'Mötes e-postadress kopierad till urklipp.',
  },
  AllSignOrderCheckboxText: {
    en: 'All',
    nb: 'Alle',
    sv: 'Alla',
  },
  next: {
    en: 'Next',
    nb: 'Neste',
    sv: 'Nästa',
  },
  StartTimeText: {
    en: 'Start time',
    nb: 'Starttid',
    sv: 'Starttid',
  },
  DraftMeetingInfo: {
    en: 'Find a date for the meeting, create an agenda, attach documents to the agenda items, and invite participants.',
    nb: 'Finn tid til møtet, lag agenda (gjerne med agendabiblioteket), legg ved dokumenter til agendapunktene og inviter deltakere.',
  },
  AttendPhysicalMeeting: {
    en: 'Select that you can attend the meeting',
    nb: 'Velg at du kan delta på møtet',
  },
  AttendDigitalMeeting: {
    en: 'Select that you can attend the meeting digitally',
    nb: 'Velg at du kan delta digitalt på møtet',
  },
  AttendMeeting: {
    en: 'Select that you can attend the meeting',
    nb: 'Velg at du kan delta på møtet',
  },
  DonNotAttendTooltip: {
    en: 'Select that you cannot attend the meeting',
    nb: 'Velg at du ikke kan delta på møtet',
  },
  AverageEngagementMeeting: {
    en: 'Average engagement in the meeting',
    nb: 'Gjennomsnittlig forberedelse blant møtedeltakerne',
  },
  CalledMeetingInfo: {
    en: 'Select “Notify of updates” if needed, or wait and click “Start the meeting”.',
    nb: 'Velg «Informer om oppdatering» ved behov/endringer, eller vent til det er tid til for å trykke «Start møtet».',
    sv: 'Välj "Informera om uppdateringar" vid behov, eller vänta och klicka på "Starta mötet".',
  },
  ActiveMeetingInfo: {
    en: 'Hold the meeting physically, hybrid or digitally, and conduct polls. Finally, select "End meeting".',
    nb: 'Avhold møtet fysisk, hybrid eller digitalt, og gjennomfør avstemninger. Velg «Avslutt møtet» til slutt.',
  },
  RequiresSignaturesMeetingInfo: {
    en: 'Reminders are sent after 3, 7, and 21 days, but it is also possible to trigger reminders manually.',
    nb: 'Påminnelse sendes etter 3, 7 og 21 dager, men det er også mulig å sende påminnelse manuelt.',
  },
  CompletedMeetingInfo: {
    en: 'The signed minutes are available in the minutes section below.',
    nb: 'Den signerte protokollen ligger i protokoll-seksjonen nedenfor.',
  },
  EndMeetingAction: {
    en: 'End Meeting',
    nb: 'Avslutt møtet',
  },
  BoardMeetingAdminView: {
    en: 'Admin view',
    nb: 'Redigeringsvisning',
  },
  BoardMeetingHideAgendaItems: {
    en: 'Hide agenda suggestions',
    nb: 'Skjul agendaforslag',
  },
  agenda_suggestions: {
    en: 'Agenda Suggestions',
    nb: 'Agendaforslag',
    sv: 'Dagordningsförslag',
  },
  AdministerAgendaSuggestions: {
    en: 'Edit Agenda Suggestions',
    nb: 'Endre agendaforslag',
  },
  hideCustomSuggestions: {
    en: 'Hide custom suggestions',
    nb: 'Skjul egendefinerte forslag',
  },
  showCustomSuggestions: {
    en: 'Show custom suggestions',
    nb: 'Vis egendefinerte forslag',
  },
  hideAlreadyUsedSuggestions: {
    en: 'Hide already used suggestions',
    nb: 'Skjul allerede brukte forslag',
  },
  showAlreadyUsedSuggestions: {
    en: 'Show already used suggestions',
    nb: 'Vis allerede brukte forslag',
  },
  AudioTitleForMeetingRecording: {
    en: 'Recording from ',
    nb: 'Opptak fra ',
  },
  addToAgenda: {
    en: 'Add to agenda',
    nb: 'Legg til i agenda',
  },
  DraftGenerated: {
    en: 'Draft generated',
    nb: 'Utkast generert',
  },
  DraftSentForDiscussion: {
    en: 'Draft sent for discussion',
    nb: 'Utkast sendt på høring',
  },
  SentForSigning: {
    en: 'Sent for signing',
    nb: 'Sendt til signering',
  },
  Signed: {
    en: 'Signed',
    nb: 'Signert',
  },
  SendDraftForDiscussion: {
    en: 'Send draft for review',
    nb: 'Send utkast på høring',
  },
  SendPurringReminder: {
    en: 'Send reminder',
    nb: 'Send påminnelse',
  },
  MenuSign: {
    en: 'Sign',
    nb: 'Signer',
  },
  CommentsKeyword: {
    en: 'Comments',
    nb: 'Kommentarer',
  },
  CofirmationDialogGenericTitle: {
    en: 'Completed',
    nb: 'Fullført',
  },
  CofirmationDialogGenericMessage: {
    en: 'The action has been completed successfully.',
    nb: 'Handlingen ble  fullført.',
  },
  AltinnConfirmationDialogGenericTitle: {
    en: 'Submission completed',
    nb: 'Innlevering fullført',
  },
  AltinnConfirmationDialogGenericMessage: {
    en: 'The submission to Altinn has been completed successfully. You can find the submission in "New Altinn".',
    nb: 'Innleveringen til Altinn er fullført. Du kan finne innleveringen i "Nye Altinn".',
  },
  MinutesDraft: {
    en: 'Minutes draft',
    nb: 'Protokollutkast',
  },
  PDFOptions: {
    en: 'Extra options',
    nb: 'Ekstra valg',
  },
  MeetingMinutesFilePDFCommentsHeader: {
    en: 'Comments in PDF',
    nb: 'Kommentar i PDF',
  },
  makeminutesinfotitle: {
    en: 'Minutes PDF file made',
    nb: 'Protokoll-PDF ble generert',
  },
  SignicatSigningNoEmails: {
    en: 'Request aborted',
    nb: 'Forespørsel ble avbrutt',
  },
  SignicatSigningSubmittedNoEmailsDetail: {
    en: 'Request with no emails',
    nb: 'Forespørsel uten epost-adresser',
  },
  Optional: {
    en: 'Optional',
    nb: 'Valgfritt',
  },
  Reply: {
    en: 'Reply',
    nb: 'Svar',
  },
  quorum: {
    en: 'Quorum ',
    nb: 'Beslutningsdyktig',
  },
  not_quorum: {
    en: ' Not quorum',
    nb: 'Ikke beslutningsdyktig',
  },
  minutesAbsentees: {
    en: 'Did not participate',
    nb: 'Deltok ikke',
  },
  meetingLeader: {
    en: 'Meeting leader',
    nb: 'Møteleder',
  },
  own_notes: {
    en: 'Personal comments',
    nb: 'Egne notater',
  },
  shared_notes: {
    en: 'Shared comments',
    nb: 'Delte kommentarer',
  },

  noCandidates: {
    en: 'No candidates',
    nb: 'Ingen kandidater',
  },
  numberOfCandidatesToBeElected: {
    en: 'Number of candidates to be elected',
    nb: 'Antall kandidater som skal velges',
  },
  editCandidates: {
    en: 'Edit candidates',
    nb: 'Rediger kandidater',
  },
  'howManyOfTheseCandidatesAreToBeElected?': {
    en: 'How many of these candidates are to be elected?',
    nb: 'Hvor mange av disse kandidatene skal velges?',
  },
  mustBeAtLeastOne_validationError: {
    en: ' Must be at least 1 ',
    nb: 'Må være minst 1',
  },
  cantBeHigherThanNumber_validationError: {
    en: "Can't be higher than",
    nb: 'Kan ikke være høyere enn',
  },
  removeCandidate: {
    en: 'Remove candidate',
    nb: 'Fjern kandidat',
  },
  voting: {
    en: 'Voting',
    nb: 'Avstemning',
  },
  votingIsCurrentlyClosed: {
    en: ' Voting is currently closed. ',
    nb: 'Avstemningen er ikke åpen på nåværende tidspunkt.',
  },
  submitMoreVotes: {
    en: 'Submit more votes',
    nb: 'Send inn flere stemmer',
  },
  changeVote: {
    en: 'Change vote',
    nb: 'Endre stemme',
  },
  VoteForSelected: {
    en: 'Vote for selected',
    nb: 'Stem på valgte',
  },
  VoteBlank: {
    en: 'Vote blank',
    nb: 'Stem blankt',
  },
  withdrawVote: {
    en: 'Withdraw vote',
    nb: 'Trekk stemme',
  },
  asAdministrator: {
    en: 'as administrator',
    nb: 'som administrator',
  },
  youHaveSelectedTheMaximumNumberOfCandidates: {
    en: ' You have selected the maximum number of candidates.',
    nb: 'Du har valgt maksimalt antall kandidater.',
  },
  youMustSelectAtLeastOneCandidate: {
    en: ' You must select at least one candidate. ',
    nb: 'Du må velge minst én kandidat.',
  },
  youHaveSelectedTooManyCandidates: {
    en: ' You have selected too many candidates. ',
    nb: 'Du har valgt for mange kandidater.',
  },
  vote: {
    en: ' Vote ',
    nb: 'Stem',
  },
  'whichShareOwnersAreYouVotingOnBehalfOf?': {
    en: 'Which shareholders are you voting on behalf of?',
    nb: 'Hvilke aksjeeiere stemmer du på vegne av?',
  },
  selectAtLeastOneShareOwner: {
    en: ' Select at least one shareholder. ',
    nb: 'Velg minst en aksjeeier.',
  },
  thereAreNoCandidatesRegisteredYet: {
    en: 'There are no candidates registered yet.',
    nb: 'Ingen kandidater er registrert ennå.',
  },
  showTable: {
    en: 'Show table',
    nb: 'Vis tabell',
  },
  hideTable: {
    en: 'Hide table',
    nb: 'Gjem tabell',
  },

  gaVotesAdministrationHowToVote: {
    en: " To register a vote on behalf of others, first select the voter's name in the table, then continue below the table.\n",
    nb: 'For å registrere stemme på vegne av andre, velg først den stemmeberettiget sitt navn i tabellen, og fortsett så under tabellen.\n',
  },
  when: {
    en: ' When ',
    nb: 'Når',
  },
  see_vote: {
    en: 'See',
    nb: 'Se',
  },
  selectShareOwnersAboveToSetTheirVote: {
    en: 'Choose voters over to vote on their behalf.',
    nb: 'Velg stemmeberettigede over for å avgi stemme på deres vegne.',
  },
  youCan_gaVotingAdmin: {
    en: 'You can',
    nb: 'Du kan',
  },

  withdrawVotesForSelectedShareOwners: {
    en: 'Withdraw selected votes',
    nb: 'Trekk tilbake valgte stemmer',
  },
  orVoteOnBehalfOfSelectedShareOwners: {
    en: 'Or you can vote on behalf of the selected voters:',
    nb: 'Eller du kan stemme på vegne av de valgte stemmeberettigede:',
  },
  MeetingStatusDraft: {
    en: 'Draft',
    nb: 'Utkast',
    sv: 'Utkast',
  },
  CreateANewMessage: {
    en: 'New announcement',
    nb: 'Ny kunngjøring',
    sv: 'Ny meddelande',
  },
  CouldNotFindOrgNumberData: {
    en: ' Could not find any data using your organization number... ',
    nb: 'Fant ikke data med ditt organisasjonsnummer...',
    sv: 'Kunde inte hitta några data med ditt organisationsnummer...',
  },
  InformationAboutTheBoard: {
    en: ' Information about the board ',
    nb: 'Informasjon om styret',
  },
  Position: {
    en: 'Position',
    nb: 'Verv',
  },
  CompanyType: {
    en: 'Company type',
    nb: 'Organisasjonsform',
  },
  Accountant: {
    en: 'Number of board positions',
    nb: 'Regnskapsfører',
  },
  Auditor: {
    en: 'Auditor',
    nb: 'Revisor',
  },
  IncomeStatementInThousands: {
    en: ' Income statement (all numbers in thousands) ',
    nb: 'Årsregnskap (tall i hele 1000)',
  },
  BalanceSheet: {
    en: 'Balance sheet',
    nb: 'Balanseregnskap',
  },
  AssetsInThousands: {
    en: 'Assets (all numbers in thousands)',
    nb: 'Eiendeler (tall i hele 1000)',
  },
  FinancingInThousands: {
    en: 'Financing (all numbers in thousands)',
    nb: 'Egenkapital og Gjeld (tall i hele 1000)',
  },
  TotalCurrentAssets: {
    en: 'Total current assets',
    nb: 'Sum omløpsmidler',
  },
  TotalFixedAssets: {
    en: 'Total fixed assets',
    nb: 'Sum anleggsmidler',
  },
  TotalAssets: {
    en: 'Total assets',
    nb: 'Sum eiendeler',
  },
  TotalEquity: {
    en: 'Total equity',
    nb: 'Sum egenkapital',
  },
  TotalLongTermLiabilities: {
    en: 'Total long-term liabilities',
    nb: 'Sum langsiktig gjeld',
  },
  TotalShortTermLiabilities: {
    en: 'Total short-term liabilities',
    nb: 'Sum kortsiktig gjeld',
  },
  TotalLiabilities: {
    en: 'Total liabilities',
    nb: 'Sum gjeld',
  },
  TotalEquityAndLiabilities: {
    en: 'Total equity and liabilities',
    nb: 'Sum egenkapital og gjeld',
  },
  TotalIncome: {
    en: 'Total income',
    nb: 'Sum inntekter',
  },
  TotalOperatingIncome: {
    en: 'Total operating income',
    nb: 'Sum driftsinntekter',
  },
  OrdinaryResultBeforeTaxes: {
    en: 'Ordinary result before taxes',
    nb: 'Ordinært resultat før skatt',
  },
  OrdinaryResult: {
    en: 'Ordinary result',
    nb: 'Ordinært resultat',
  },
  OperatingProfit: {
    en: 'Operating profit',
    nb: 'Driftsresultat',
  },
  PersonnelExpenses: {
    en: 'Personnel expenses',
    nb: 'Lønnskostnader',
  },
  TotalFinancialExpenses: {
    en: 'Total financial expenses',
    nb: 'Sum finanskostnader',
  },
  Taxes: {
    en: 'Taxes',
    nb: 'Skatt',
  },
  TotalSales: {
    en: 'Total sales',
    nb: 'Sum salgsinntekt',
  },
  OtherOperatingIncome: {
    en: 'Other operating income',
    nb: 'Andre driftsinntekter',
  },
  CostOfMaterials: {
    en: 'Cost of materials',
    nb: 'Varekostnad',
  },
  Depreciation: {
    en: 'Depreciation',
    nb: 'Avskrivninger',
  },
  WriteDowns: {
    en: 'Write-downs',
    nb: 'Nedskrivninger',
  },
  OtherOperatingExpenses: {
    en: 'Other operating expenses',
    nb: 'Andre driftskostnader',
  },
  TotalFinancialIncome: {
    en: 'Total financial income',
    nb: 'Sum finansinntekter',
  },
  PaidUpEquity: {
    en: 'Paid-up equity',
    nb: 'Innskutt egenkapital',
  },
  ShareCapital: {
    en: 'Share capital',
    nb: 'Aksjekapital',
  },
  RetainedEarnings: {
    en: 'Retained earnings',
    nb: 'Opptjent egenkapital',
  },
  OtherEquity: {
    en: 'Other equity',
    nb: 'Annen egenkapital',
  },
  ConvertibleDebt: {
    en: 'Convertible debt',
    nb: 'Konvertibelt lån',
  },
  DebentureLoans: {
    en: 'Debenture loans',
    nb: 'Obligasjonslån',
  },
  LongTermCreditDebt: {
    en: 'Long-term credit debt',
    nb: 'Lang kredittgjeld',
  },
  LongTermDebtGroupCompanies: {
    en: 'Long-term debt group companies',
    nb: 'Langsiktig gjeld konsern',
  },
  PensionLiabilities: {
    en: 'Pension liabilities',
    nb: 'Pensjonsforpliktelser',
  },
  DefferedTax: {
    en: 'Deffered tax',
    nb: 'Utsatt skatt',
  },
  OtherAllowances: {
    en: 'Other allowances',
    nb: 'Andre avsetninger',
  },
  OtherLongTermDebt: {
    en: 'Other long-term debt',
    nb: 'Annen langsiktig gjeld',
  },
  Licences: {
    en: 'Licenses',
    nb: 'Konsesjoner',
  },
  Goodwill: {
    en: 'Goodwill',
    nb: 'Goodwill',
  },
  NotInMeetingTitle: {
    en: 'Not in a meeting',
    nb: 'Ikke i et møte',
  },
  generateCompleteMeetingSummary: {
    en: 'Generate minutes',
    nb: 'Generer protokoll',
  },
  NotInMeetingMessage: {
    en: 'You are not currently in a meeting. To view this tour, please enter a meeting using the calendar page.',
    nb: 'Du er foreløpig ikke i et møte. For å se denne omvisningen, vennligst gå inn i et møte ved å bruke kalendersiden.',
  },
  FixedAssets: {
    en: 'Fixed assets',
    nb: 'Anleggsmidler',
  },
  RealEstate: {
    en: 'Real estate',
    nb: 'Fast eiendom',
  },
  TotalIntangibleAssets: {
    en: 'Total intangible assets',
    nb: 'Sum immaterielle eiendeler',
  },
  EquityInvestments: {
    en: 'Equity investments',
    nb: 'Aksjeinvesteringer',
  },
  Bonds: {
    en: 'Bonds',
    nb: 'Obligasjoner',
  },
  TotalFinancialFixedAssets: {
    en: 'Total financial fixed assets',
    nb: 'Sum finansielle anleggsmidler',
  },
  Inventories: {
    en: 'Inventories',
    nb: 'Varer',
  },
  AccountsReceivables: {
    en: 'Accounts receivables',
    nb: 'Kundefordringer',
  },
  AccountsReceivablesGroupCompanies: {
    en: 'Accounts receivables group companies',
    nb: 'Kundefordringer på selskap i samme konsern',
  },
  OtherShortTermReceivables: {
    en: 'Other short-term receivables',
    nb: 'Andre fordringer',
  },
  BankDeposits: {
    en: 'Bank deposits',
    nb: 'Bankinnskud',
  },
  TotalShortTermInvestments: {
    en: 'Total short-term investments',
    nb: 'Sum investeringer',
  },
  OtherCurrentAssets: {
    en: 'Other current assets',
    nb: 'Andre omløpsmidler',
  },
  CompanyInfoHelpText: {
    en: ' The information presented here is public information about the organization from Brønnøysundregistrene. It is only updated once the information is made available to the public. ',
    nb: 'Her er offentlig informasjon om organisasjonen fra Brønnøysundregistrene. Denne informasjonen blir kun oppdatert når informasjonen er gjort offentlig.',
  },
  BoardLibraryInfo: {
    en: ' In the board library, you will find a range of guides and webinars with content that is relevant to the board and management. The board library is continuously updated with new content. ',
    nb: ' I styrebibliotek finner du en rekke veiledere og webinarer med innhold som er relevant for styret og ledelsen. Styrebiblioteket blir fortløpende oppdatert med nytt innhold. ',
  },
  totalNumberOfMeetings: {
    en: 'Number of meetings',
    nb: 'Antall møter',
  },
  SettingOff: {
    en: 'Off',
    nb: 'Av',
  },
  SettingOn: {
    en: 'On',
    nb: 'På',
  },
  Problemuploadingfile: {
    en: 'Problem uploading file',
    nb: 'Problemer med å laste opp fil',
  },
  RefreshPDFSignStatus: {
    en: 'Refresh',
    nb: 'Oppdater',
  },
  OtherWindowForBankIdLogon: {
    en: 'There should be another window to logon with bankid',
    nb: 'Det skal være et annet vindu for å logge på med BankID',
  },
  SettingsNameDialofTitle: {
    en: 'Name',
    nb: 'Navn',
  },
  PleaseLookAtEmailResetLink: {
    en: 'Please look at your email for reset link',
    nb: 'Sjekk din e-post for tilbakestillingslenke',
  },
  CurrentEmailPlaceholder: {
    en: 'Current Email',
    nb: 'Fra ',
  },
  NewEmailPlaceholder: {
    en: 'New Email',
    nb: 'Til ',
  },
  PlaceholderValidationCode: {
    en: 'Code',
    nb: 'Valideringskode',
  },
  PhoneAuthFailMessage: {
    en: 'Authorisation failed. Please check the SMS code.',
    nb: 'Autorisasjonen mislyktes. Kontroller e-post-koden og passordet.',
  },
  ShowDeletedDevices: {
    en: ' Show deleted ',
    nb: 'Vis slettede',
  },
  DeviceExpiresTime: {
    en: 'Expires',
    nb: 'Utløper:',
  },
  Sessions: {
    en: 'Sessions',
    nb: 'Økter',
  },
  ShowExpired: {
    en: ' Show expired ',
    nb: ' Vis utløpt ',
  },
  SessionCreatedTime: {
    en: 'Created',
    nb: 'Opprettet',
  },
  SessionLastAccessTime: {
    en: 'Last Access',
    nb: 'Siste tilgang',
  },
  SessionExpiresTime: {
    en: 'Session Expires',
    nb: 'Økten utløper',
  },
  SessionDeletedTime: {
    en: 'Deleted',
    nb: 'Slettet',
  },
  COZONE_Friendly: {
    en: 'Last Cozone logon',
    nb: 'Siste Cozone-pålogging',
  },
  COGNITO_Friendly: {
    en: 'Last password check',
    nb: 'Siste passordkontroll',
  },
  SMS_Friendly: {
    en: 'Last SMS 2FA',
    nb: 'Siste SMS 2FA-kontroll',
  },
  BANKID_Friendly: {
    en: 'Last BankID 2FA',
    nb: 'Siste BankID 2FA-kontroll',
  },
  TOTP_Friendly: {
    en: 'Last TOTP 2FA',
    nb: 'Siste TOTP 2FA-kontroll',
  },
  TRUSTED_Friendly: {
    en: 'Last trusted logon',
    nb: 'Siste økt på trygg enhet',
  },
  CalendarSettings: {
    en: 'Calendar settings',
    nb: 'Innstilling for kalender',
  },
  AddToGoogleCalendarMsg: {
    en: ' Add meetings to your calendar (with Google Calendar API) ',
    nb: ' Legg til møter i kalenderen din (med Google alender API)',
  },
  StylePreferencePgeHeader: {
    en: 'Style Preferences',
    nb: 'Stilinnstillinger',
  },
  TermsOfUseSettingsText: {
    en: ' Terms of Use ',
    nb: 'Brukervilkår',
  },
  DataProcessingAggreementSettingsText: {
    en: 'Data Processing Agreements',
    nb: 'Databehandleravtale',
  },
  DataProcessing: {
    en: 'Data Processing Agreements',
    nb: 'Databehandleravtale',
  },
  PrivacyPolicySettingsText: {
    en: ' Privacy Policy ',
    nb: 'Personvernerklæring',
  },
  TransferAccountDonorEmailPlaceholder: {
    en: 'Donor',
    nb: 'Giver',
  },
  TransferAccountRecipientEmailPlaceholder: {
    en: 'Recipient',
    nb: 'Mottaker',
  },
  TransferAccountAbortIfInvitesCheckBoxLabel: {
    en: 'Abort if donor has invites',
    nb: 'Avbryt hvis giver har invitasjoner',
  },
  TransferAccountDryrun: {
    en: 'Dryrun',
    nb: 'Dryrun',
  },
  TransferAccountButtonLabel: {
    en: ' Transfer ',
    nb: ' Overfør ',
  },
  TransferAccountUndoWarning: {
    en: ' Warning this can not be undone. ',
    nb: 'Advarsel dette kan ikke angres.',
  },
  TransferAccountSuccessMessage: {
    en: ' Your roles have been successfully transfered. Your current account has been deleted. ',
    nb: ' Your roles has been successfully transfered. Your current account has been deleted. ',
  },
  TransferAccountSuccessMessageSuper: {
    en: ' The donor roles has been successfully transfered the account has been deleted. ',
    nb: ' The donor roles has been successfully transfered the account has been deleted. ',
  },

  TotalIssue: {
    en: 'Total',
    nb: 'Tegningsbeløp',
  },
  InputShareAmount: {
    en: 'Input amount',
    nb: 'Skriv inn antall aksjer',
  },
  Person: {
    en: 'Person',
    nb: 'Person',
  },
  CompanyName: {
    en: 'Company name',
    nb: 'Selskapsnavn',
  },
  OrgNumberRequired: {
    en: 'Org.nr*',
    nb: 'Org.nr*',
  },
  FirstNameRequired: {
    en: 'First name*',
    nb: 'Fornavn*',
  },
  LastNameRequired: {
    en: 'Last name*',
    nb: 'Etternavn*',
  },
  EmailRequired: {
    en: 'Email*',
    nb: 'E-post*',
  },
  TelephoneNumber: {
    en: 'Telephone number',
    nb: 'Telefonnummer',
  },
  Town: {
    en: 'Town',
    nb: 'By',
  },
  PostCode: {
    en: 'Postcode',
    nb: 'Postnr',
  },
  SixDigits: {
    en: '(6 digits)',
    nb: '(6 tall)',
  },
  SSN: {
    en: 'Social security number',
    nb: 'Personnummer',
  },
  FiveDigits: {
    en: '(5 digits)',
    nb: '(5 tall)',
  },
  NUmberOfSharesAndTotalAmount: {
    en: ' Number of shares and total amount ',
    nb: 'Antall aksjer og totalt antall',
  },
  NumberOfShares: {
    en: 'Number of shares',
    nb: 'Antall aksjer',
  },
  OrderingInformation: {
    en: 'Orderer information',
    nb: 'Opplysninger om bestiller',
  },
  OrgNr: {
    en: 'Org nr.',
    nb: 'Org nr.',
  },
  SocialSecurityNumber: {
    en: 'Social security number',
    nb: 'Fødselsnummer',
  },
  TransactionTableClass: {
    en: 'Class',
    nb: ' Aksjeklasse',
  },
  sharePriceNok: {
    en: 'Price (NOK)',
    nb: 'Kurs (NOK)',
  },
  totalPriceNok: {
    en: 'Total price (NOK)',
    nb: ' Total pris (NOK) ',
  },
  ItIsEasierWithSameEmail: {
    en: ' It is easier for the user if the same e-mail address is used if it is already registered in the portal. ',
    nb: ' Det er enklere for brukeren om det benyttes samme e-postadresse om denne allerede er registrert i portalen. ',
  },
  'Empty user': {
    en: ' Empty user ',
    nb: 'Tøm brukerinfo',
  },
  PleaseConfirm: {
    en: 'Please confirm',
    nb: 'Vennligst bekreft',
  },
  NoAgendaItemsYet: {
    en: 'No agenda items are added yet',
    nb: 'Ingen agendapunkter er lagt til ennå',
  },
  LEINumber: {
    en: 'LEI Number',
    nb: 'LEI-nummer',
  },
  VPSNumber: {
    en: 'VPS Number',
    nb: 'VPS-nummer',
  },
  OwnersMembershipNumber: {
    en: 'Membership Number',
    nb: 'Medlemsnummer',
  },
  Citizenship: {
    en: 'Citizenship',
    nb: 'Statsborgerskap',
  },
  EntityRepresentativeUser: {
    en: ' Representative (user) ',
    nb: 'Representant (bruker) ',
  },
  CannotDelete: {
    en: 'Cannot delete ',
    nb: 'Kunne ikke slette ',
  },
  CannotDeleteAllText: {
    en: 'Cannot delete last ',
    nb: 'Kan ikke slette siste ',
  },
  TheEventIsNotAnImport: {
    en: 'the last event is not an import.',
    nb: 'Den siste hendelsen er ikke et øyebliksbilde.',
  },
  DeleteOwnerConfirm: {
    en: 'Delete owner from this organization',
    nb: 'Slett eier fra denne organisasjonen',
  },
  OfTheSelected: {
    en: 'The number that can be deleted: ',
    nb: 'Antallet som kan slettes: ',
  },
  DoYouWantToDelete: {
    en: '. Do you want to delete these?',
    nb: '. Ønsker du å slette disse?',
  },
  CanNotDeleteEntry: {
    en: 'Unable to delete the entry',
    nb: 'Kunne ikke å slette entitet',
  },
  CanNotDeleteEntityWithShares: {
    en: 'Unable to delete an owner with shares',
    nb: 'Kan ikke slette en eier med delinger',
  },
  IsPartOfTheRegistry: {
    en: 'has votes in the registry',
    nb: 'er del av registeret',
  },
  CannotDeleteSomeoneThatIsPartOfTheRegistry: {
    en: 'Cannot delete someone that is part of the registry',
    nb: 'Kan ikke slette en som er del av registeret',
  },
  HasTransactions: {
    en: 'is part of the transaction history',
    nb: 'er del av transaksjonshistorikken',
  },
  CannotDeleteSomeoneWithTransactions: {
    en: 'Could not delete any of the selected entries since they have shares, or is a part of transaction history.',
    nb: 'Kan ikke slette noen som er del av transaksjonshistorikken',
  },
  UserAssignedToThisShareholder: {
    en: 'User assigned to this shareholder',
    nb: 'Det finnes en bruker knyttet til denne eieren',
  },
  HasBisnodeRef: {
    en: 'has bisnode ref',
    nb: 'har Bisnode-referanse',
  },
  NoUserAssignedToShareholder: {
    en: 'No user assigned to this shareholder',
    nb: 'Ingen bruker knyttet til denne eieren',
  },
  EntityAddress: {
    en: 'Address',
    nb: 'Adresse',
  },
  EntityAddressField: {
    en: 'Address: ',
    nb: 'Adresse: ',
  },
  AddressZip: {
    en: 'Zip: ',
    nb: 'Postnr: ',
  },
  AddressCity: {
    en: 'City: ',
    nb: 'By: ',
  },
  DobOrOrg: {
    en: 'Birthdate/investor identity',
    nb: 'Fødselsdato/nr eller orgnr',
  },
  TransactionType: {
    en: 'Transaction type',
    nb: 'Hendelsestype',
  },
  TransactionDate: {
    en: ' Transaction date ',
    nb: 'Hendelsesdato',
  },
  NameInUseWarning: {
    en: 'This name is already in use by another entity.',
    nb: 'Dette navnet er allerede i bruk hos en annen aksjonær.',
  },
  SsnInUseWarning: {
    en: 'This social security number is already in use by another entity.',
    nb: 'Dette fødselsnummeret er allerede i bruk hos en annen aksjonær.',
  },
  OrgnrInUseWarning: {
    en: 'This orgnr is already in use by another entity.',
    nb: 'Dette orgnummeret er allerede i bruk hos en annen aksjonær.',
  },
  CompanyNameInUseWarning: {
    en: 'This company name is already in use by another entity.',
    nb: 'Dette selskapsnavnet er allerede i bruk hos en annen aksjonær.',
  },
  ImportEventTypeAlt: {
    en: 'Type',
    nb: 'Type',
  },
  TransactionTableSeller: {
    en: 'Seller',
    nb: 'Selger',
  },
  TransactionTableBuyer: {
    en: 'Buyer',
    nb: 'Kjøper',
  },
  TransactionTableAmount: {
    en: 'Amount',
    nb: ' Antall',
  },
  Dividend: {
    en: 'Dividend',
    nb: 'Utbytte',
  },
  TotalDividend: {
    en: 'Total dividend',
    nb: 'Totalt utbytte',
  },
  DateHeader: {
    en: ' Date ',
    nb: 'Dato',
  },
  UserTransactionTableClass: {
    en: ' Creator ',
    nb: 'Opprettet av',
  },
  SelectBidnodeUserButton: {
    en: ' Select ',
    nb: 'Velg',
  },
  SelectUserButton: {
    en: 'Select',
    nb: 'Velg',
  },
  Postcode: {
    en: 'Postcode',
    nb: 'Postnummer',
  },
  EntityRepresentative: {
    en: 'Representative',
    nb: 'Representant',
  },
  ThereWasAProblem: {
    en: 'There was a problem with your request',
    nb: 'Det var et problem, kontakt support',
  },
  ShareholdersWithoutEmailWarningMessage: {
    en: 'There are shareholders without email addresses. This can be repaired in the owners submodule',
    nb: 'Det er tegnere uten e-postadresser. Dette kan gjøres i undermodulen "eiere".',
  },
  Transactiontype: {
    en: 'Transaction type',
    nb: 'Transaksjonstype',
  },
  Timepoint: {
    en: 'Time',
    nb: 'Tidspunkt',
  },
  Attachments: {
    en: 'Attachments',
    nb: 'Vedlegg',
  },
  Finished: {
    en: 'Finished',
    nb: 'Ferdig',
  },
  ContractUpdated: {
    en: 'Contract updated',
    nb: 'Avtale ble oppdatert',
  },
  CancelProcess: {
    en: 'Cancel process',
    nb: 'Avbryt prosess',
  },
  WhichPositionsTriggerBeneficialOwnership: {
    en: ' Which positions trigger beneficial ownership, state one or more of the following positions ',
    nb: 'Hvilke posisjoner medfører reelt eierskap, angi en eller flere av følgende posisjoner',
  },
  OnWhichGroundsAreThePositionsAchieved: {
    en: ' On which grounds are the above-mentioned positions achieved? ',
    nb: 'På hvilket grunnlag er de overstående posisjonene oppnådd?',
  },
  DirectOwnership: {
    en: 'Direct ownership',
    nb: 'Direkte eierskap',
  },
  IndirectOwnership: {
    en: 'Indirect ownership',
    nb: 'Indirekte eierskap',
  },
  ThroughAgreementOrContract: {
    en: 'Through agreement or contract',
    nb: 'Gjennom enighet eller avtale, formell eller uformell',
  },
  BeneficialOwnersNoteIdentified: {
    en: ' Information regarding the beneficial owner ',
    nb: 'Informasjon om reell rettighetshaver',
  },
  BeneficialOwnersNoteNoneIdentifiedAndNone: {
    en: ' Note ',
    nb: 'Merknad',
  },

  Ownership: {
    en: 'Ownership',
    nb: 'Eierskap',
  },

  DilutedOwnership: {
    en: ' Diluted ownership ',
    nb: ' Utvannet eierskap ',
  },
  ContractPrice: {
    en: ' Contract price ',
    nb: ' Avtalepris ',
  },
  ValueDistribution: {
    en: ' Value distribution ',
    nb: ' Verdifordeling ',
  },
  CapTableInfo: {
    en: ' If options, warrant or convertible debt contract have been entered using the Financial contracts menu option, you can here simulate the distribution of ownership at different share prices. The simulation takes into account both the redemption price and the number of shares for the financial contracts. ',
    nb: ' Dersom det er lagt inn opsjoner, tegningsretter eller konvertible lån ved hjelp av menyvalget Finansielle avtaler kan du her simulere eierfordelingen ved ulike aksjekurser. Simuleringen tar hensyn til både innløsningskurs og antall aksjer for de finansielle avtalene. ',
  },
  FullDilution: {
    en: ' Full dilution ',
    nb: ' Full utvanning ',
  },
  Others: {
    en: 'Others',
    nb: 'Andre',
  },
  CapitalEventsModuleInfo: {
    en: 'Capital events are transactions that affect the capital of the individual shares and/or the company as a whole.',
    nb: 'Kapitalhendelser er hendelser som endrer på kapitalen til individuelle aksjer og/eller selskapet som helhet.',
  },
  CreateStockSplit: {
    en: 'Create stock split',
    nb: 'Registrer aksjeplitt',
  },
  CreateStockSplice: {
    en: 'Create stock splice',
    nb: 'Registrer aksjespleis',
  },
  'shareholders.Splice': {
    en: 'Splice',
    nb: 'Spleis',
  },
  'shareholders.Split': {
    en: 'Split',
    nb: 'Splitt',
  },
  SnapshotAftherSpliceEvent: {
    en: 'There is a snapshot afther this event. the event will not have an effect on the current shareholderbook. Move the snapshot or the splice event to a different date if you want to correct this.',
    nb: 'Det er et øyeblikksbilde etter denne hendelsen. Dennne hendelsen vil ikke ha innvirkning på gjeldende aksjonærbok. Flytt øyeblikksbildet eller spleis hendelsen til en annen dato hvis du ønsker å rette opp i dette.',
  },
  SpliceInfo: {
    en: 'Stock splice decrease the amount of shares in circulation without changing the total capital of the company. Usually this is done when the price of an individual share is too small.',
    nb: 'Aksjespleiser reduserer antall aksjer i sirkulasjon uten å endre på totalkapitalen til selskapet. Vanligvis gjøres dette i større selskaper hvor kursen på den individuelle aksjen er for lav.',
  },
  FromSlashTo: {
    en: 'From/to',
    nb: 'Fra/til',
  },
  FromSlashToSpliceExplanation: {
    en: 'A stock splice needs information about how the shares will be converted. An example of this is when 2 shares are converted to 1. To do this you specify from as 2 and to as 1.',
    nb: 'En aksjespleis trenger informasjon om hvor mange aksjer som skal bli konvertert. Et eksempel på dette er når 2 aksjer skal bli konvertert til 1. Da spesifiserer man fra til å være 2 og til til å være 1.',
  },
  RoundingStrategy: {
    en: 'Rounding strategy',
    nb: 'Avrundingsstrategi',
  },
  RoundingStrategyExplanation: {
    en: 'If the number of shares are not perfectly divisble by the conversion the splice needs a strategy for how to handle non-discrete amounts of shares. Currently Orgbrain supports rounding up or down.',
    nb: 'Hvis antall aksjer ikke er et heltall etter konverteringen, trenger spleisen en strategi for hvordan kontinuerlige verdier skal avrundes. På nåværende tidspunkt godtar Orgbrain å runde opp og ned.',
  },
  ShareclassRequired: {
    en: 'Shareclass*',
    nb: 'Aksjeklasse*',
  },
  Registryafterchange: {
    en: 'Registry after change',
    nb: 'Aksjeeierbok etter endringen',
  },
  CompleteText: {
    en: 'Complete',
    nb: 'Gjennomfør',
    sv: 'Genomför',
  },
  Down: {
    en: 'Down',
    nb: 'Ned',
  },
  Up: {
    en: 'Up',
    nb: 'Opp',
  },
  TheEventWasAddedToYourHistory: {
    en: 'The transaction was added to your history',
    nb: 'Hendelsen ble lagt til i historikken',
  },
  SnapshotAftherSplitEvent: {
    en: 'There is a snapshot afther this event. the event will not have an effect on the current shareholderbook. Move the snapshot or the split event to a different date if you want to correct this.',
    nb: 'Det er et øyeblikksbilde etter denne hendelsen. Dennne hendelsen vil ikke ha innvirkning på gjeldende aksjonærbok. Flytt øyeblikksbildet eller splitt hendelsen til en annen dato hvis du ønsker å rette opp i dette.',
  },
  StockSplitHelpText: {
    en: 'Stock splits increase the amount of shares in circulation without changing the total capital of the company. Usually this is done when the price of an individual share is too high for smaller investors and/or the amount of shares can not satisfy the desired voting percentages.',
    nb: 'Aksjesplitter øker mengden aksjer i sirkulasjon uten å endre den totale kapitalen til selskapet. Vanligvis gjøres dette når prisen på den individuelle aksjen er for høy for mindre investorer og/eller når antallet aksjer ikke kan tilfredsstille en gitt stemmeprosent.',
  },
  FromSlashToText: {
    en: 'In a share split you must specify how the shares will be converted. For example, if 1 share is to be split into 2, specify from = 1 and to = 2.',
    nb: 'Ved en aksjesplitt må du angi hvordan aksjene skal konverteres. For eksempel, dersom 1 aksje skal deles til 2, spesifiserer du fra = 1 og til = 2.',
  },
  RoundingStrategyExplanationSplit: {
    en: 'If the number of shares are not perfectly divisble by the conversion, the split needs a strategy for how to handle non-discrete amounts of shares. Currently Orgbrain supports rounding up or down.',
    nb: 'Hvis antallet aksjer ikke er en diskret verdi etter konverteringen, trenger splitten en avrundingsstrategi for å kunne håndtere et antall aksjer som ikke er et heltall. På nåværende tidspunkt støtter Orgbrain det å runde opp og det å runde ned.',
  },
  RepresentativesWithoutInvite: {
    en: 'Representatives without invite',
    nb: 'Representanter uten invitasjoner',
  },
  DownloadCurrentHistory: {
    en: 'Download the current history of the organization',
    nb: 'Last ned organisasjonens nåværende transaksjons historie',
  },
  DownloadCurrentState: {
    en: 'Download the current info of ',
    nb: 'Last ned gjeldende informasjon om ',
  },
  ProblemFetchingBisnodeData: {
    en: 'Problem fetching Bisnode data. Please report',
    nb: 'Problemer med å hente data fra Brønnøysund. Vennligst rapporter',
  },
  DownloadSheetFormatLabel: {
    en: 'File format',
    nb: 'Filformat',
  },
  IncludeSensitiveInfo: {
    en: 'Include sensitive info',
    nb: 'Inkluder sensitiv info',
  },
  DownloadSheetCancel: {
    en: ' Cancel ',
    nb: ' Avbryt',
  },
  DownloadSheetContinue: {
    en: ' Continue ',
    nb: ' Fortsett',
  },
  CompanyTemplateFilename: {
    en: 'CompanyTemplate',
    nb: 'OrganisasjonsMal',
  },
  ImportDate: {
    en: 'Import date',
    nb: 'Importdato',
  },
  ImportDateHelpText: {
    en: ' To be able to know exactly when the shareholder registry was in the state of the import, we require a date to place the import in the transaction history. ',
    nb: 'For å kunne plassere importen i transaksjonshistorikken trenger vi en dato',
  },
  ImportNewRegistry: {
    en: 'New registry',
    nb: 'Nytt register',
    sv: 'Nytt register',
  },
  FinishText: {
    en: 'Finish',
    nb: 'Fullfør',
    sv: 'Slutför',
  },
  ImportInEventsAfter: {
    en: 'The events after the chosen date contain an import. A new import at this date\n will have no effect on the shareholder registry. You can pick a new date after the\n one chosen or adjust your transactions.',
    nb: 'Det finnes allerede en import med en dato som er etter den nye importen du nå er i ferd med å gjennomføre. En ny import med dato som er tidligere enn annen import, vil ikke endre registeret du allerede har. For å gjøre endringer i registeret, må du for denne import velge en dato som er etter forrige import. Du kan også foreta endringer i registeret ved å redigere hendelsene manuelt.',
  },
  DateWillCauseInconsistentRegistry: {
    en: 'Chosen date will cause an inconsistent registry. Check your transactions or choose a different date',
    nb: 'Valgt dato vil føre til et inkonsekvent register. Sjekk hendelsene dine eller velg en annen dato.',
  },

  ImportTaxofficeData: {
    en: 'Import Taxoffice Data',
    nb: 'Hent data fra Skatteetaten',
  },
  EmailsOrgNrAndNames: {
    en: 'Emails, organization numbers and names',
    nb: 'E-post, organisasjonsnummer og navn',
    sv: 'E-post, organisationsnummer och namn',
  },
  NameOf: {
    en: 'Name of',
    nb: 'Navn på',
    sv: 'Namn på',
  },
  ImportOptionalFieldsTitle: {
    en: 'Optional fields',
    nb: 'Ekstra felter',
  },
  ImportDateOfBirth: {
    en: 'Date of birth: ',
    nb: 'Fødselsdato: ',
  },
  ImportDateOfBirthTextAS: {
    en: ' In many cases the date of birth is used as an extra identifier for ',
    nb: ' I mange tilfeller brukes fødselsdatoen som en ekstra identifikator for ',
  },
  ImportDateOfBirthTextAS2: {
    en: ' Preferably it should be formated as the first part of a Norwegian identity number i.e. ddmmyy. ',
    nb: ' Fortrinnsvis bør det formateres som første del av et norsk identitetsnummer, altså ddmmyy. ',
  },
  ImportSSN: {
    en: 'Social security number:',
    nb: 'Personnummer:',
  },
  AdditionalColumnsHelpText: {
    en: ' These additional columns will be interpreted by Orgbrain ',
    nb: 'Under vil du finne hvilke felter som er mulig å laste opp ved bruk av regneark',
  },
  ExampleSpreadsheet: {
    en: 'Example spreadsheet',
    nb: 'Eksempel på regneark',
  },
  MissingNameData: {
    en: 'You must supply first and last name.',
    nb: 'Du må oppgi fornavn og etternavn.',
  },
  MissingIdentification: {
    en: 'Some owners are missing identifying properties like firstname and lastname, or an email address',
    nb: 'Noen eiere mangler felter for identifisering, som fornavn og etternavn, eller en e-post adresse',
  },
  MissingCompanyName: {
    en: 'Some rows have org numbers, but no company name',
    nb: 'Noen rader har orgnummer, men mangler navn på organisasjonen',
  },
  MissingOrgNumber: {
    en: 'Some rows have company names, but no org numbers',
    nb: 'Noen rader har organisasjonsnavn, men ingen orgnummere',
  },
  IncorrectDateFormat: {
    en: 'Incorrect date format, must either be ddmmyy, dd-mm-yy, dd.mm.yy or dd/mm/yy',
    nb: 'Feil datoformat, formatet må enten være på formen ddmmyy, dd-mm-yy, dd.mm.yy eller dd/mm/yy',
  },
  CouldntFindTaxData: {
    en: "Couldn't find tax data with this orgnumber",
    nb: 'Kunne ikke finne skattedata med dette orgnummeret',
  },
  ProblemOnboardingShareholders: {
    en: 'There was a problem',
    nb: 'Det oppstod et problem',
  },
  PleaseReportToSupport: {
    en: 'Please report this to support',
    nb: 'Vennligst rapporter dette for å støtte',
  },
  PleaseFixYourSpreadSheet: {
    en: 'Please fix your spread sheet.',
    nb: 'Vennligst fiks regnearket ditt.',
  },
  ImportsData: {
    en: 'Import data',
    nb: 'Importdata',
  },
  SharenumbersAreInconsistent: {
    en: 'Share numbers are inconsistent',
    nb: 'Aksjenummere er ikke konsekvente',
  },
  DoYouWantOrgbrainToGenerateSharenumbers: {
    en: 'Do you want Orgbrain to generate sharenumbers?',
    nb: 'Vil du at Orgbrain skal generere aksjenummere?',
  },
  ImportsGenerateSharenumbers: {
    en: ' Generate sharenumbers ',
    nb: 'Generer aksjenummer',
  },
  DataYouAreTryingToImport: {
    en: ' This is the data that you are trying to import to Orgbrain ',
    nb: 'Dette er dataen du prøver å importere til Orgbrain',
  },
  DuplicateRows: {
    en: 'Duplicate rows merged:',
    nb: 'Dupliserte rader som blir sammenslått:',
  },
  DateOfBirthOrOrgNr: {
    en: 'Date of birth or Orgnr',
    nb: 'Fødselsdato eller Orgno',
  },
  RowLine: {
    en: 'Line No',
    nb: 'Linje Nr',
  },
  ExpirationDate: {
    en: 'Expiration date',
    nb: 'Utløpsdato',
  },
  StrikePrice: {
    en: 'Strikeprice',
    nb: 'Innløsningskurs',
  },
  LoanSize: {
    en: 'Loan size',
    nb: 'Størrelsen på lånet',
  },
  ConvertiblePart: {
    en: 'Convertible share of the loan',
    nb: 'Konvertibel andel av lånet',
  },
  InterestPerYear: {
    en: 'Interest per year',
    nb: 'Effektiv rente per annum',
  },
  AreTheConditionsMet: {
    en: 'Are the conditions met?',
    nb: 'Er betingelsene oppfylt?',
  },
  ContractWasDeleted: {
    en: 'Contract was deleted',
    nb: 'Avtale ble slettet',
  },
  FinancialContractsModuleInfo: {
    en: ' In this module, you enter share-related agreements that the company has entered into. This gives the company a comprehensive and structured overview of the obligations that may affect the ownership of the company. ',
    nb: 'I denne modulen legger du inn aksjerelaterte avtaler som selskapet har inngått. Dette gir selskapet en samlet og strukturert oversikt over de forpliktelser som kan påvirke eierskapet i selskapet.',
  },
  ConvertibleLoanInformation: {
    en: ' A convertible loan is a loan where the lender has the right to be issued shares in the company, either in exchange for the lender paying a share contribution in money or by the loan being used as an offset. ',
    nb: ' Et konvertibelt lån er et lån der långiveren har rett til å få utstedt aksjer i selskapet, enten mot at långiver betaler et aksjeinnskudd i penger eller ved at lånet brukes til motregning. ',
  },
  LoanInformation: {
    en: ' Loan information ',
    nb: 'Informasjon om lånet',
  },
  ConvertibleLoanSuccesfullyCreated: {
    en: 'Convertible loan created',
    nb: 'Konvertibelt lån ble registrert',
  },
  UseNewJitsi: {
    en: 'Use expanded video solution',
    nb: 'Bruk utvidet videoløsning',
  },
  UseNewJitsiMessage: {
    en: 'Do you want to use an extended version of the video solution from Jitsi, with the possibility of recording and transcription? No calls will be recorded without this being activated manually.',
    nb: 'Ønsker du å ta i bruk en utvidet versjon av videoløsningen fra Jitsi, med mulighet for opptak og transkribering? Ingen samtaler blir tatt opp uten at dette aktiveres manuelt.',
  },
  scrollToCurrentTranscriptionEvent: {
    nb: 'Gå til nåværende tidspunkt i transkripsjonen',
    en: 'Go to the current transcription event',
  },

  scrollToTop: {
    nb: 'Gå til begynnelsen av transkripsjonen',
    en: 'Go to the start of the transcription',
  },
  scrollToCurrentTranscriptionEventText: {
    nb: 'Til nåværende',
    en: 'To the current',
  },
  scrollToTopText: {
    nb: 'Til start',
    en: 'To the start',
  },
  OptionInformation: {
    en: ' An option is a right or an opportunity someone has to buy or sell shares in a company. This can, for example, be related to an incentive program that the company aims at key people, often in order to be able to keep fixed costs at a lower level. ',
    nb: 'En opsjon er en rett eller en mulighet noen har til å kjøpe eller selge aksjer i et selskap. Dette kan for eksempel være relatert til et insentivprogram som selskapet retter mot nøkkelpersoner, ofte for å kunne holde de faste kostnader på et lavere nivå. ',
  },
  OptionSuccesfullyCreated: {
    en: 'Option created',
    nb: 'Opsjon ble registrert',
  },
  WarrantInformation: {
    en: ' ​A warrant is a right to buy (subscribe) shares in a future issue, at a predetermined price (subscription price). The procedure for using warrants is regulated in Chapter 11 of the Norwegian Companies Act. ',
    nb: '​En tegningsrett er en rettighet til å kjøpe (tegne) aksjer i en fremtidig emisjon, til en på forhånd fastsatt pris (tegningskurs). Fremgangsmåten ved bruk av tegningsretter er regulert i aksjelovens kapittel 11. ',
  },
  WarrantSuccesfullyCreated: {
    en: 'Warrant created',
    nb: 'Tegningsrett ble registrert',
  },
  ContactPersonPendingInTable: {
    en: 'pending',
    nb: 'venter',
  },
  AmountPerShare: {
    en: 'Amount per share',
    nb: 'Beløp per aksje',
  },
  TotalAmountDividend: {
    en: 'Total amount',
    nb: 'Totalt beløp',
  },
  DfalseownloadTableAsSpreadsheet: {
    en: ' Dowload table as spreadsheet',
    nb: 'Last ned tabell som regneark',
  },
  DownloadOwnerDividendTitle: {
    en: 'Download dividend',
    nb: 'Last ned utbytte/utbetaling',
  },
  Payout: {
    en: 'Payout',
    nb: 'Utbetaling',
  },
  TotalAmount: {
    en: 'Total amount',
    nb: 'Totalt beløp',
  },
  DividendHelptextModuleInfo: {
    en: ' Here you have the opportunity to register allocations so that the company has an overview in Orgbrain of which allocations have been given to shareholders. It is also possible to send e-mails to shareholders about the allocation. ',
    nb: ' Her har du mulighet til å registrere tildelinger slik at selskapet har oversikt i Orgbrain over hvilke tildelinger som er gitt til aksjeeierne. Det er også mulig å sende e-post til aksjeeierne om tildelingen. ',
  },
  Subtype: {
    en: 'Subtype',
    nb: 'Type',
  },
  AwardDate: {
    en: 'Date of award',
    nb: 'Tildelingsdato',
  },
  TimeOfAward: {
    en: 'Time of award',
    nb: 'Tildelingstid',
  },
  PaymentDate: {
    en: 'Payment date',
    nb: 'Utbetalingsdato',
  },
  RegisterSkewedDistribution: {
    en: 'Register skewed distribution',
    nb: 'Registrer skjevdeling',
  },
  SubmitTransaction: {
    en: ' Submit ',
    nb: ' Gjennomfør ',
  },
  sendingEmail: {
    en: 'Registered dividend sending email to selected investors',
    nb: 'Utbytte registrert, epost sendt til valgte investorer',
  },
  PaymentEmailSent: {
    en: 'Payment emails were sent',
    nb: 'E-poster ble sendt',
  },
  ProblemSendingPaymentEmail: {
    en: 'There was a problem sending the payment email',
    nb: 'Det var et problem med å sende e-postene',
  },
  DividendEmailTextPart3: {
    en: ' as described under: ',
    nb: ' som beskrevet under: ',
  },
  AwardTimeText: {
    en: 'Award time:',
    nb: 'Tildelingstidspunkt:',
  },
  ShareholdersTotalShares: {
    en: 'Shareholders total shares',
    nb: 'Aksjonærens nye beholdning',
  },
  YourDividend: {
    en: 'Your dividend:',
    nb: 'Utbetaling totalt:',
  },
  ShareholdersTotalDividend: {
    en: 'Shareholders total dividend',
    nb: 'Aksjonærs totale utbetaling',
  },
  ShareholdersAccount: {
    en: 'Shareholders account',
    nb: 'Aksjonærs bankkonto',
  },
  claimOwner: {
    en: ' Claim owner ',
    nb: ' Pantehaver ',
  },
  ReferenceNu: {
    en: 'Reference nr.',
    nb: 'Referanse nr.',
  },
  ClaimOwner: {
    en: 'Claim owner',
    nb: 'Pantehaver',
  },
  'shareholders.Notes': {
    en: 'Notes',
    nb: 'Merknad',
  },
  Open: {
    en: 'Open',
    nb: 'Åpen',
  },
  Deleted: {
    en: 'Deleted',
    nb: 'Slettet',
  },
  EntityNote: {
    en: 'Note',
    nb: 'Notat',
  },
  EntityNoteSaved: {
    en: 'Entity note saved',
    nb: 'Aksjonærnotat lagret',
  },
  ShareholderEditPositionAdditionalHelpText: {
    en: 'or any other transactions that influences this shareholders position',
    nb: 'eller andre hendelser som påvirker aksjonærens posisjon',
  },
  HistoryTabHeader: {
    en: 'History',
    nb: 'Historikk',
  },
  InconsistentStateWarningTitle: {
    en: 'State would be inconsistent',
    nb: 'Registeret vil bli inkonsistent',
  },
  InconsistentStateWarniongContent: {
    en: 'With the current changes you are proposing the state of the shareholder registry will be inconsistent',
    nb: 'Med endringene du foreslår vil tilstanden til registeret bli inkonsistent.',
  },
  With: {
    en: 'with',
    nb: 'med',
  },
  UnableToDeleteTheLast: {
    en: 'Unable to delete the last',
    nb: 'Kan ikke slette det siste',
  },
  ShareclassesHelpTextModuleInfoAS: {
    en: ' Normally, a company has only one type of share, often referred to as "Ordinary shares", which gives all shares equal rights in the company. The articles of association may nevertheless stipulate that there shall be shares of different types, and which give different rights (for example A-shares and B-shares). In that case, the articles of association shall state what distinguishes the share classes (for example, dividends or voting rights), and the shares\' total nominal value within each share class, cf. the Norwegian Companies Act § 4-1. In this window you can add new share classes as well as change and delete information on existing share classes. ',
    nb: 'Normalt har et selskap kun én type aksjer, ofte benevnt som «Ordinære aksjer», som gir alle aksjer lik rett i selskapet. I vedtektene kan det likevel bestemmes at det skal være aksjer av ulike slag, og som gir ulike rettigheter (for eksempel A-aksjer og B-aksjer). Vedtektene skal i så fall angi hva som skiller aksjeklassene (for eksempel utbytte eller stemmerett), og aksjenes samlede pålydende innen hver aksjeklasse, jf. aksjeloven § 4-1. I dette vinduet kan du legge til nye aksjeklasser samt endre og slette informasjon på eksisterende aksjeklasse. ',
  },
  CreatedDate: {
    en: 'Created at',
    nb: 'Opprettet',
  },
  AllocatedAmount: {
    en: ' Allocated amount ',
    nb: 'Tildelt beløp',
  },
  AllocatedUntilNow: {
    en: ' Allocated shares',
    nb: 'Aksjer tildelt',
  },
  Belop: {
    en: ' Total ',
    nb: 'Beløp',
  },
  SendContractToAddedInvestor: {
    en: 'Invite the shareholder to sign an order form confirming their intention of investing the stated amount. ',
    nb: 'Inviter investoren til å signere en bestillingsblankett med antall aksjer utfylt.',
  },
  RemindOnlyThoseInvestorsNotOrdered: {
    en: 'Remind only those investors who have not ordered ',
    nb: 'Påminn kun de investorer som ikke har bestilt ',
  },
  SearchForInvestors: {
    en: 'Search for investors',
    nb: 'Søk i investorer',
  },
  Invite: {
    en: ' Invite ',
    nb: ' Inviter',
  },

  ShowOnlyFilledIn: {
    en: 'Show only filled in',
    nb: 'Vis kun utfylt',
  },

  TotalOrdered: {
    en: ' Total ordered ',
    nb: 'Bestilt beløp',
  },
  DateInvited: {
    en: ' Date Invited ',
    nb: 'Dato invitert',
  },
  Allocated: {
    en: 'Allocated',
    nb: 'Tildelt beløp',
  },
  Emission: {
    en: 'Issue',
    nb: 'Kapitalforhøyelse',
  },
  Completion: {
    en: 'Finish',
    nb: 'Ferdigstill ',
  },
  Tweaked: {
    en: 'Tweaked',
    nb: 'Tweaked',
  },
  FinishAndSendEmail: {
    en: ' Finish and send e-mail ',
    nb: ' Ferdigstill og send e-post ',
  },
  ProblemAddingInvitees: {
    en: 'There was a problem adding your invitees',
    nb: 'Det var et problem med å legge til inviterte',
  },
  AddMoreShareholders: {
    en: 'Add more shareholders?',
    nb: 'Legg til flere eiere?',
  },
  InvestorInvitesSentSuccessfully: {
    en: 'The invitations were sent successfully',
    nb: 'Invitasjonene ble sendt',
  },
  EmissionCompleted: {
    en: 'Capital issue completed',
    nb: 'Kapitalforhøyelsen er registrert',
  },
  EmissionRegistered: {
    en: 'Capital issue registered',
    nb: 'Kapitalforhøyelse ble registrert',
  },
  RegisterPayment: {
    en: 'Register payment',
    nb: 'Registrer betaling',
  },
  DatePaid: {
    en: 'Date paid',
    nb: 'Dato betalt',
  },
  DownloadTableAsAttachment: {
    en: 'Dowload table as PDF',
    nb: 'Last ned tabell som PDF',
  },
  OptionalTextToBeIncludedInTheDocument: {
    en: ' Optional text to be included in the document ',
    nb: 'Fritekst for dokumentet',
  },
  IdNB: {
    en: ' Id ( no social security numbers ) ',
    nb: ' Id ( ingen fødselsnummer ) ',
  },
  Signature: {
    en: ' Signature ',
    nb: 'Signatur',
  },
  CommitTransaction: {
    en: 'Commit transaction',
    nb: 'Ferdigstill kapitalforhøyelse',
  },
  SnapshotAftherEvent: {
    en: 'There is a snapshot afther this event. The event will not have an effect on the current shareholderbook.',
    nb: 'Det er et øyeblikksbilde etter denne hendelsen. Denne hendelsen vil ikke ha innvirkning på gjeldende aksjonærbok.',
  },
  DateOfIntroductionToTheShareRegister: {
    en: 'Date of introduction to the share register',
    nb: 'Dato for innføring i aksjeeierboken',
  },
  TimeDate: {
    en: 'Time:',
    nb: 'Tidspunkt:',
  },
  NameOfShareholder: {
    en: 'Name of shareholder',
    nb: 'Navn på aksjonær',
  },
  NewShares: {
    en: 'New shares:',
    nb: 'Nye aksjer:',
  },
  ShareholdersAddedShares: {
    en: 'Shareholders added shares',
    nb: 'Antall nye aksjer',
  },
  NewAmountOfShares: {
    en: 'New amount of shares:',
    nb: 'Ny beholdning:',
  },
  DueDate: {
    en: 'Payment due',
    nb: 'Betalingsfrist',
  },
  SummaryText: {
    en: 'Summary',
    nb: 'Oppsummering',
  },
  EmissionPrice: {
    en: 'Emission price',
    nb: 'Emisjonskurs',
  },
  Banknr: {
    en: 'Account number',
    nb: 'Kontonummer',
  },
  TotalPaid: {
    en: ' Total paid ',
    nb: ' Total betalt ',
  },
  OrderForm: {
    en: 'Order form',
    nb: 'Bestillingsblankett',
  },
  InternalNote: {
    en: 'Internal note',
    nb: 'Internt notat',
  },
  ShareIssueTable: {
    en: 'Share issue table',
    nb: 'Kapitalforhøyelsestabell',
  },
  EmissionTableName: {
    en: 'ShareIssueTable',
    nb: 'Kapitalforhøyelsestabell',
  },
  Id: {
    en: 'Id',
    nb: 'Id',
  },
  AllocatedShares: {
    en: 'Allocated shares',
    nb: 'Tildelte aksjer',
  },
  Premium: {
    en: 'Premium',
    nb: 'Overkurs',
  },
  Value: {
    en: 'Value',
    nb: 'Verdi',
  },
  PreEmission: {
    en: 'Before issue',
    nb: 'Før kapitalforhøyelse',
  },
  EmissionShareCapital: {
    en: 'in share capital',
    nb: 'i aksjekapital',
  },
  NewEmissionShareCapital: {
    en: 'in acquired share capital',
    nb: 'i innhentet aksjekapital',
  },
  EmissionShares: {
    en: 'Shares',
    nb: 'aksjer',
  },
  EmissionIncrease: {
    en: '% of existing shares',
    nb: '% av eksisterende aksjer',
  },
  EmissionValue: {
    en: 'in raised capital',
    nb: 'i innhentet kapital',
  },
  PreEmissionValue: {
    en: 'in pre money valuation',
    nb: 'i forhåndsverdi på selskapet (pre money)',
  },
  PostEmissionValue: {
    en: 'in post money valuation',
    nb: 'i verdi på selskapet (post money)',
  },
  NewSharePercentage: {
    en: 'New shares',
    nb: 'nye aksjer',
  },
  ExistingSharePercentage: {
    en: 'of existing shares',
    nb: 'av eksisterende aksjer',
  },
  PreEmissionTableHeader: {
    en: 'Before issue',
    nb: 'Før kapitalforhøyelse',
  },
  Minimum: {
    en: 'Minimum',
    nb: 'Minimum',
  },
  AfterEmission: {
    en: 'After issue',
    nb: 'Etter kapitalforhøyelse',
  },
  AfterEmissionTableHeader: {
    en: 'After issue',
    nb: 'Etter kapitalforhøyelse',
  },
  EmissionAddKeyInformation: {
    en: 'Add key information',
    nb: 'Legg til nøkkelopplysninger',
  },
  EmissionAddKeyInformationTooltip: {
    en: 'Here you enter key information about the capital increase',
    nb: 'Her legger du inn nøkkelopplysninger om kapitalforhøyelsen',
  },
  EmissionCreateAnOrderForm: {
    en: 'Create an order form',
    nb: 'Lag en bestillingsblankett',
  },
  EmissionCreateAnOrderFormTooltip: {
    en: 'Here you create a form for ordering shares and upload any attachments that you want the investors to receive.',
    nb: 'Her lager du blankett for bestilling av aksjer og laster opp eventuelle vedlegg som du ønsker at investorene skal motta. ',
  },
  EmissionInviteInvestorsStepper: {
    en: 'Invite investors',
    nb: 'Inviter investorer',
  },
  EmissionInviteInvestorsStepperTooltip: {
    en: 'Here you invite those who are to participate in the capital increase, keep an overview of those who subscribed for shares',
    nb: 'Her inviterer du de som skal delta i kapitalforhøyelsen, holder oversikt over de som tegner seg samt sluttfører emisjonen',
  },
  EmissionAllocateSharesStepper: {
    en: 'Allocate shares',
    nb: 'Tildel aksjer',
  },
  EmissionAllocateSharesStepperTooltip: {
    en: 'Here you allocate shares to the investors',
    nb: 'Her tildeler du aksjer til investorene',
  },
  EmissionConfirmEmissionStepper: {
    en: 'Confirm capital increase',
    nb: 'Bekreft kapitalforhøyelsen',
  },
  EmissionConfirmEmissionStepperTooltip: {
    en: 'Here you confirm the capital increase, a transaction for the issue is created, and the shareholder book is updated',
    nb: 'Her bekrefter du kapitalforhøyelsen, hendelsen for kapitalforhøyelsen blir laget, og aksjeeierboka blir oppdatert',
  },
  ShareIssues: {
    en: 'Share Issues',
    nb: 'Kapitalforhøyelser',
  },
  NewShareIssue: {
    en: ' New share issue ',
    nb: 'Ny kapitalforhøyelse',
  },
  RegisterPastShareIssue: {
    en: 'Register share issue',
    nb: 'Etterregistrer kapitalforhøyelse',
  },
  PointOneNewShareIssueInfo: {
    en: 'Add key information about the capital raise',
    nb: 'Legg inn nøkkelopplysninger om kapitalforhøyelsen',
  },
  PointThreeNewShareIssueInfo: {
    en: 'Invite investors, who order and sign digitally',
    nb: 'Inviter investorer, som bestiller og signerer digitalt',
  },
  PointFourNewShareIssueInfo: {
    en: ' Allocate shares, complete the formal resolution and send out payment information ',
    nb: 'Tildel aksjer, gjennomfør det formelle vedtaket om kapitalforhøyelse og send ut betalingsinformasjon',
  },
  PointFiveNewShareIssueInfo: {
    en: ' Get payment confirmation, send coordinated registry message to the business register, update the the shareholder book and send a message to the investors ',
    nb: 'Få innbetalingene bekreftet, send samordnet registermelding til Foretaksregisteret, oppdater aksjeeierboken og send melding til investorene',
  },
  PointOneRegisterShareIssueInfo: {
    en: ' Add key information about the completed share issue ',
    nb: 'Legg inn nøkkelopplysninger om den gjennomførte kapitalforhøyelsen',
  },
  PointTwoRegisterShareIssueInfo: {
    en: ' Add the investors who participated in the issue with the correct amount of shares ',
    nb: 'Legg til investorer som har deltatt i kapitalforhøyelsen med korrekt antall aksjer',
  },
  PointThreeRegisterShareIssueInfo: {
    en: ' Update the shareholder book and send a message to the investors ',
    nb: 'Oppdater aksjeeierboka og send melding til investorene',
  },
  HISTORYTOOLTIP: {
    en: ' Here you can see equity issues previously completed through Orgbrain ',
    nb: 'Her kan du se kapitalforhøyelser som tidligere har blitt gjennomført gjennom Orgbrain',
  },
  CurrentlyNoShareissueHistory: {
    en: ' There is currently no history of completed equity issues ',
    nb: 'Det finnes foreløpig ingen emisjonshistorikk',
  },
  'shareholders.TaxIncentiveinfotext0part1': {
    en: 'Personal taxpayers can get a deduction in general income by investing in startup companies if all the requirements described in ',
    nb: 'Personlige skattytere kan få fradrag i alminnelig inntekt ved investering i oppstartsselskap om alle krav beskrevet i ',
  },
  'shareholders.TaxIncentiveinfotext0part2': {
    en: ' tax law § 6-53 ',
    nb: ' skatteloven § 6-53 ',
  },
  'shareholders.TaxIncentiveinfotext0part3': {
    en: 'and in',
    nb: 'og i',
  },
  'shareholders.TaxIncentiveinfotext0part4': {
    en: ' Skatte-ABC ',
    nb: ' Skatte-ABC ',
  },
  'shareholders.TaxIncentiveinfotext0part5': {
    en: ' under the heading "Aksjer – aksjeinnskudd i oppstartsselskap" are met. ',
    nb: ' under temaet «Aksjer – aksjeinnskudd i oppstartsselskap» er oppfylt.',
  },

  'shareholders.TaxIncentiveinfotext1': {
    en: 'Demands on the company',
    nb: 'Krav til selskapet',
  },
  'shareholders.TaxIncentiveinfotext2': {
    en: ' Must be a Norwegian limited liability company(AS) 6 years or younger (or equivalent EEA-company) ',
    nb: ' Må være et norsk aksjeselskap 6 år eller yngre (eller tilsvarende EØS-selskap) ',
  },
  'shareholders.TaxIncentiveinfotext3': {
    en: ' Yearliy salary base at least NOK 400 000, less than 25 full time employee equivalents ',
    nb: ' Årlig lønnsgrunnlag minst kr 400 000, færre enn 25 årsverk ',
  },
  'shareholders.TaxIncentiveinfotext4': {
    en: ' Revenue and balance sheet total of less than MNOK 40 ',
    nb: ' Driftsinntekter og balansesum på maks kr 40 millioner ',
  },
  'shareholders.TaxIncentiveinfotext5part1': {
    en: 'Cannot be in financial difficulties at the time of capital increase, cf. ',
    nb: 'Kan ikke være i økonomiske vanskeligheter ved på tidspunktet for kapitalforhøyelsen, jf. ',
  },
  'shareholders.TaxIncentiveinfotext5part2': {
    en: ' EU regulation no. 651/2014 article 2 (18) ',
    nb: ' EU-forordning nr. 651/2014 artikkel 2 (18) ',
  },
  'shareholders.TaxIncentiveinfotext6': {
    en: ' Must primarily engage in other activities than passive asset management ',
    nb: ' Må hovedsakelig drive annen aktivitet enn passiv kapitalforvaltning ',
  },
  'shareholders.TaxIncentiveinfotext7': {
    en: ' Subscription of new shares at incorporation or share issue must be registered in the Norwegian company register in the year in question ',
    nb: ' Nytegning av aksjer ved stiftelse eller kapitalforhøyelse må være registrert i foretaksregisteret det aktuelle året ',
  },
  'shareholders.TaxIncentiveinfotext8': {
    en: ' Can receive a maximum of MNOK 5 per year under the scheme ',
    nb: ' Kan årlig motta maks kr 5 millioner under ordningen ',
  },
  'shareholders.TaxIncentiveinfotext9': {
    en: ' Must report the amount received and investors to Altinn (RF-1086) ',
    nb: ' Må innrapportere mottatte beløp og investorer til Altinn (RF-1086) ',
  },
  'shareholders.TaxIncentiveinfotext10': {
    en: ' Demands on the investor ',
    nb: ' Krav til investor ',
  },
  'shareholders.TaxIncentiveinfotext11': {
    en: ' Direct or indirect investment (if indirect investment from a limited liability company, the direct owners must have a proportional share of the company that makes the investment) ',
    nb: ' Direkte eller indirekte investering (hvis indirekte investering fra et aksjeselskap skal de direkte eierne ha forholdsmessig fordeling etter eierandelen i selskapet som foretar investeringen)',
  },
  'shareholders.TaxIncentiveinfotext12': {
    en: ' Minimum investment of NOK 30,000 per capital increase, max MNOK 1 per person per year ',
    nb: ' Minsteinvestering på kr 30 000 per kapitalforhøyelse, maks kr 1 million per person per år ',
  },
  'shareholders.TaxIncentiveinfotext13': {
    en: ' The investor (and close relatives) must be new as a shareholder at the capital increase - only the first investment gives grounds for tax incentive ',
    nb: ' Investoren (og nærstående) må være ny som aksjonær ved kapitalforhøyelsen - kun første investering gir grunnlag for støtte ',
  },
  'shareholders.TaxIncentiveinfotext14': {
    en: ' Not for employees (pure board members are not considered employees) ',
    nb: ' Ikke for ansatte (rene styremedlemmer regnes ikke som ansatt) ',
  },
  'shareholders.TaxIncentiveinfotext15': {
    en: ' Must own the shares for at least three full calendar years without receiving dividends or capital reduction payback from the company ',
    nb: ' Må eie aksjene i minst tre hele kalenderår uten å motta utbytte eller kapitalnedsettelse fra selskapet ',
  },
  'shareholders.TaxIncentiveinfotext17': {
    en: ' By indirect investment, the intermediary company must report the amount received and investors to Altinn (RF-1086) ',
    nb: ' Ved indirekte investering må det mellomliggende innrapportere beløp og investorer til Altinn (RF-1086) ',
  },
  'shareholders.TaxIncentiveinfotext18': {
    en: ' Solution in Orgbrain ',
    nb: ' Løsning i Orgbrain ',
  },
  'shareholders.TaxIncentiveinfotext19': {
    en: ' By pressing the correct year and the button "+ Add", a table with drafts for reporting based on incorperation and share issues that have been entered in the portal will appear. It is the company\'s responsibility to check that all requirements are met and distribute the incentive to investors by filling out the column "Incentive to RF-1086". When the table is completed and saved, it will automatically be used as a basis for reporting the shareholder register report from the portal. It is post 9 at the company level and post 23 at the shareholder level that are affected by this. Reporting of a shareholder register report is done from Owners -> Share register -> three dots menu at the top right -> Altinn (RF-1086). ',
    nb: ' Ved å trykke på riktig år og knappen «+ Legg til», kommer det opp en tabell med utkast til rapportering basert på stiftelse og kapitalforhøyelser som er lagt inn i portalen. Det er selskapets ansvar å kvalitetssikre om alle krav er oppfylt og fordele insentivgrunnlagene på investorene ved å fylle ut kolonnen «Insentiv til RF-1086». Når tabellen er ferdigstilt og lagret vil den automatisk bli benyttet som grunnlag ved rapportering av aksjonærregisteroppgaven fra portalen. Det er post 9 på selskapsnivå og post\n23 på aksjonærnivå som blir påvirket av dette. Rapportering av aksjonærregisteroppgaven gjøres fra Eiere -> Aksjeeierbok -> tre prikker-menyen oppe til høyre -> Altinn (RF-1086). ',
  },
  'shareholders.TaxIncentiveinfotext20': {
    en: ' Look at the guide for use of the tax incentive scheme in Orgbrain ',
    nb: ' Se veileder for for bruk av skatteinsentivordningen i Orgbrain ',
  },
  'shareholders.NewEvent': {
    en: 'New event',
    nb: 'Ny hendelse',
  },
  'shareholders.Translaction': {
    en: 'Transaction',
    nb: 'Transaksjon',
  },
  'shareholders.ShareIssue': {
    en: 'Share issue',
    nb: 'Kapitalforhøyelse',
  },

  'shareholders.Dividend': {
    en: 'Dividend',
    nb: 'Utbytte/utbetaling',
  },
  'shareholders.ParValueChange': {
    en: 'Par value change',
    nb: 'Endring av pålydende',
  },
  'shareholders.ThereAreNoTransactionsOfThisType': {
    en: 'There are currently no transactions of this type.',
    nb: 'Det er foreløpig ingen hendelser av denne typen.',
  },
  'shareholders.NotExercised': {
    en: 'Not exercised',
    nb: 'Ikke utøvd',
  },
  'shareholders.Expired': {
    en: 'Expired',
    nb: 'Utløper',
  },
  'shareholders.Cancelled': {
    en: 'Cancelled',
    nb: 'Annulert',
  },
  'shareholders.Exercised': {
    en: 'Exercised',
    nb: 'Utøvd',
  },
  EmissionStep1: {
    en: 'Key information',
    nb: 'Nøkkelopplysninger',
  },

  InvitationToParticipateInEquityIssue: {
    en: ' Invitation to participate in equity issue ',
    nb: 'Invitasjon til å delta i kapitalforhøyelse',
  },
  InvestorAttachmentHelpText: {
    en: ' Here you upload any attachments that you want investors to receive together with the order form, such as articles of association, accounts or shareholder agreement.',
    nb: 'Her laster du opp eventuelle vedlegg som du ønsker at investorene skal motta sammen med bestillingsblanketten, for eksempel vedtekter, regnskap eller aksjonæravtale.',
  },
  KeyInformation: {
    en: 'Key information',
    nb: 'Nøkkelopplysninger',
  },
  EmissionTitle: {
    en: 'Title',
    nb: 'Tittel',
  },
  emissionSubtype: {
    en: 'Emissiontype',
    nb: 'Transaksjon',
  },
  BankAccount: {
    en: 'Bank account',
    nb: 'Bankkonto',
  },
  TotalVisibleToInvestors: {
    en: 'Do you want investors to see information about the ongoing capital raise?',
    nb: 'Vil du at investorene skal se informasjon om den pågående kapitalforhøyelsen?',
  },
  infoOnEditTaxincentive1: {
    en: 'Amounts under 30000 will not give incentives and can therfore not be input into the system. ',
    nb: 'Beløp under 30.000 vil ikke gi fradrag og kan derfor ikke legges inn. ',
  },
  TaxIncentiveGiven: {
    en: ' Tax incentive given ',
    nb: ' Skattefradrag utdelt ',
  },
  ShowOnlyWithpotentialincentives: {
    en: 'Show only with potential taxincenitves',
    nb: 'Vis bare mulige skatteinsentiv',
  },
  Sharesamount: {
    en: 'Number of Shares',
    nb: 'Antall aksjer',
  },
  SavedIncentive1: {
    en: 'Information about tax incentive for: ',
    nb: 'Skatteinsentiv for: ',
  },
  SavedIncentive2: {
    en: ' saved.',
    nb: ' lagret.',
  },
  'History (event log)': {
    en: 'History',
    nb: 'Historikk',
  },
  NoShareholdersHelpText1: {
    en: ' There are no registered ',
    nb: 'Det er ingen registrerte ',
  },
  NoShareholdersHelpText3: {
    en: ' You can add ',
    nb: ' Du kan legge til ',
  },
  NoShareholdersHelpText4: {
    en: ' by importing data in ',
    nb: ' ved å importere data i ',
  },
  ParValueEventsModuleInfo: {
    en: ' Here you can change the par value of the share from a given time. ',
    nb: 'Her kan du endre aksjens pålydende fra et gitt tidspunkt. ',
  },
  ClassCommnet: {
    en: 'Comment',
    nb: 'Kommentar',
  },
  More: {
    en: 'More',
    nb: 'Mer',
    sv: 'Mer',
  },
  AVoteWeight: {
    en: 'Voting Weight',
    nb: 'Stemmevekt',
    sv: 'Röstvikt',
  },
  ShareclassNumberFrom: {
    en: 'Number from',
    nb: 'Nummer fra',
    sv: 'Nummer från',
  },
  NumberTo: {
    en: 'Number to',
    nb: 'Nummer til',
    sv: 'Nummer till',
  },
  EmptyAllNotes: {
    en: ' Empty all sharenumbers ',
    nb: 'Tøm alle aksjenummere',
  },
  RegisteredInBrønnøysund: {
    en: 'Registered in Brønnøysund',
    nb: 'Kunngjort i Brønnøysund',
  },
  YourSharenumbersAreInconsistent: {
    en: 'Your sharenumbers are inconsistent',
    nb: 'Dine aksjenummer er ikke konsekvente',
  },
  InconsistentSharenumberOptionsText: {
    en: 'To fix this you can either leave the sharenumber fields empty, or try to repair the numbers.',
    nb: 'For å fikse dette kan du enten la aksjenummerene være tomme, generere nye, eller prøve reparere nummerene manuelt.',
  },
  WeSuspectTheErrorIsRelatedToTheseNotes: {
    en: 'We suspect the error to be related to line ',
    nb: 'Vi mistenker at feilen ligger på  ',
  },
  ContinueWithoutSharenumbers: {
    en: 'Continue without sharenumbers?',
    nb: 'Fortsett uten aksjenummer?',
  },
  EditTransaction: {
    en: 'Edit transaction',
    nb: 'Rediger transaksjon',
  },
  EditRegistry: {
    en: 'Edit registry',
    nb: 'Rediger register',
  },
  ShareRegisterInfo1: {
    en: "Here you can add the company's",
    nb: 'Her kan du legge til selskapets',
  },
  ShareRegisterInfo2: {
    en: ' by importing a spreadsheet or entering the information manually. A spreadsheet can either be a snapshot of how ',
    nb: ' ved å importere et regneark eller legge inn informasjonen manuelt. Et regneark kan enten være et øyeblikksbilde av hvordan ',
  },
  ShareRegisterInfo3: {
    en: ' looks like right now or a record of all events (capital raises and transactions) that provide a detailed history of the current ownership situation arisen. ',
    nb: ' ser ut akkurat nå eller en oversikt over alle hendelser (kapitalforhøyelser og transaksjoner) som gir en detaljert historikk for hvordan dagens eiersituasjon har oppstått. ',
  },
  editSnapshot: {
    en: 'Edit snapshot',
    nb: 'Rediger øyeblikksbilde',
  },
  ThisCompanyNotSetYet: {
    en: 'This registry has not been set up yet',
    nb: 'Dette registeret er enda ikke satt opp',
  },
  NoDataForGivenPeriodAndShareclass: {
    en: 'Did not find any price data for given period and shareclass',
    nb: 'Fant ikke prisdata for gitt periode eller aksjeklasse',
  },
  PleaseContactAdmin: {
    en: 'Please contact your admin',
    nb: 'Vennligst kontakt en administrator for denne organisasjonen',
  },

  TheSpreadsheedMustShow: {
    en: 'The spreadsheet must show',
    nb: 'Regnearket må vise',
  },
  ImportSnapshot: {
    en: ' Import snapshot ',
    nb: ' Importer øyeblikksbilde ',
  },
  ManualRegister: {
    en: 'Manual register',
    nb: 'Manuell registrering',
  },
  Manually: {
    en: 'manually',
    nb: 'manuelt',
  },
  GoTo: {
    en: 'Go to ',
    nb: 'Gå til ',
  },
  CreateANew: {
    en: 'Create a new',
    nb: 'Lag en ny',
  },
  OrdinayShareOrWhatItIsNamedInStatute: {
    en: '("Ordinary shares" or what it is named in the statutes)',
    nb: '("Ordinære aksjer" eller det som er omtalt i vedtektene)',
  },
  AddOneOrMore: {
    en: 'Add one or more ',
    nb: 'Legg til en eller flere ',
  },
  Or: {
    en: 'or ',
    nb: 'eller ',
  },
  goTo: {
    en: 'go to ',
    nb: 'gå til ',
  },
  TransferShares: {
    en: 'Transfer shares',
    nb: 'Overfør aksjer',
  },
  ShareholderDistributionTitle: {
    en: 'Distribution',
    nb: 'Fordeling',
  },
  LastTransactionWasNotAnImport: {
    en: 'Last transaction was not an import',
    nb: 'Siste hendelse var ikke et øyeblikksbilde',
  },
  NotImportLastTransaction: {
    en: 'Because the last transaction was not an import we cannot allow edits that might affect the consistency of the shareholder registry. In transactions you can rewind until the last event is an import.',
    nb: 'Siste hendelse var ikke et øyeblikksbilde, og vi kan derfor ikke tillate redigering som kan påvirke om registeret er konsistent.',
  },
  ThereWasAProblemLoadingTheData: {
    en: 'There was a problem loading the necessary data',
    nb: 'Det var et problem med å laste inn dataen',
  },
  totalPrice: {
    en: 'Total price',
    nb: ' Total pris ',
  },
  RewindLastTransaction: {
    en: 'Rewind last transaction',
    nb: 'Spol tilbake siste transaksjon',
  },
  LastTransaction: {
    en: 'Last transaction',
    nb: 'Siste hendelse',
  },
  Rewind: {
    en: ' Rewind ',
    nb: ' Spol tilbake',
  },
  Overwrite: {
    en: 'Overwrite',
    nb: 'Overskriv',
  },
  OverwriteDescription: {
    en: ' An overwrite deletes all the current events in the registry and writes a new registry using the events in the import. ',
    nb: 'En overskriving sletter alle hendelser som eksisterer i Orgbrain og importdataen blir de gjeldende hendelsene. Et nytt register vil bli generert med den nye dataen.',
  },
  Append: {
    en: 'Append',
    nb: 'Tillegg',
  },
  AppendDescription: {
    en: ' Append deletes events that are registered to be after the first event in your import. The current events that are before the first event in the import are kept. ',
    nb: 'Tillegg sletter hendelser registrert etter den første hendelsen i importen. Hendelser med datoer før de importerte hendelsene vil bli værende.',
  },
  Import: {
    en: 'Import',
    nb: 'Import',
  },
  ValidDateDescription: {
    en: ' Valid dates must be in the format: YYYY/MM/DD HH:mm, YYYY-MM-DD HH:mm, or YYYY.MM.DD HH:mm. The time of the event is optional and defaults to 00:00. ',
    nb: ' Datoer må være på formatet: YYYY/MM/DD HH:mm, YYYY-MM-DD HH:mm, or YYYY.MM.DD HH:mm. Tidspunktet for hendelsen er valgfritt, hvis den ikke er spesifisert blir den satt til 00:00. ',
  },
  DownloadEventsTemplate: {
    en: 'Download template',
    nb: 'Last ned mal',
  },
  LegalReferenceTransactionImport: {
    en: 'More information about the boards responsibilities',
    nb: 'Mer informasjon om ansvarsområder',
  },
  TypesOfTransactions: {
    en: 'Types of transactions',
    nb: 'Typer hendelser',
  },
  EstablishAndSnapshot: {
    en: 'Establish and snapshot',
    nb: 'Stiftelse og øyeblikksbilde',
  },
  EstablishAndSnapshotExplanation: {
    en: ' the first event can either be an establish transaction or snapshot transaction. This is to have a starting point for all the other transactions to build upon. This type of transaction can span multiple rows and therefore multiple participants, as long as the date is the same. This needs to be the earliest transaction in the history and should therefore have the oldest date.',
    nb: ' den første hendelsen kan enten være en stiftelse eller et øyeblikksbilde. Dette er for å ha et startpunkt som resten av hendelsene kan basere seg på. Denne typen hendelse kan gå over flere rader og gir derfor mulighet til å inkludere flere aksjonærer, så lenge datoen er den samme i hver rad. Dette bør være den første hendelsen i historikken.',
  },
  SplitAndSplice: {
    en: 'Split and splice',
    nb: 'Splitt og spleis',
  },
  TransferExplanation: {
    en: 'This type of transaction can take many forms. It is necessary when shares are transferred from one shareholder to another. This event therefore requires a buyer and seller in the spreadsheet.',
    nb: 'Denne typen hendelse kan ta mange former. Den brukes når aksjer overføres fra en aksjonær til en annen. Denne hendelsen behøver både en kjøper og en selger i regnearket.',
  },
  SupportedTransferTypes: {
    en: 'Supported transfer types',
    nb: 'Støttede overføringstyper',
  },
  MoreInformationAboutTypesOfTransactions: {
    en: 'More information about transfer types',
    nb: 'Mer informasjon om transaksjonstyper',
  },
  AdditionalInformationAboutTheTransactions: {
    en: ' Additional transaction information ',
    nb: 'Mer informasjon om hendelser',
  },
  DateExplanationTransaction: {
    en: 'Every transaction needs a date. This does not necessarily mean it needs a time, but an additional time can be specified in the same column.',
    nb: 'Hver hendelse trenger en dato. Dette betyr ikke at tidspunktet er påkrevd, men man kan legge til tidspunktet i samme kolonne.',
  },
  DateFormatExplanationTransaction: {
    en: 'Many date formats are supported, however preferably the date is in the format',
    nb: 'Mange datoformater støttes. Det foretrukne formatet er på formen ',
  },
  AmountExplanationTransaction: {
    en: 'This is the quantity of shares that the specified buyer acquires in the transaction. For transfer it is equally the amount the seller sells.',
    nb: 'Dette er antallet aksjer som kjøperen tilegner seg i hendelsen. For overføringer er det også antallet selgeren selger.',
  },
  PriceExplanationTransaction: {
    en: 'This is the price of the shares sold at the specific transaction. This field can be left blank if the price is unknown.',
    nb: 'Dette er prisen per aksje solgt i den spesifikke hendelsen. Dette feltet kan stå tomt om prisen er ukjent.',
  },
  ShareIssueTransactionExplanation: {
    en: 'This is a type of transaction that creates new shares to be distributed in the company. A transaction of this type can span multiple rows and therefore multiple participants. However this will only count as a single emission when the date is the same in all the rows.',
    nb: 'Denne typen hendelse lager nye aksjer som blir distribuert til de spesifiserte aksjonærene. En hendelse av denne typen kan gå over flere rader og kan derfor ha flere aksjonærer. Forutsetningen for at radene blir inkludert i samme hendelse, er at datoen er den samme for hver rad.',
  },
  ShareNumbers: {
    en: 'Share numbers',
    nb: 'Aksjenummer',
  },
  ShareNumberExplanationTransaction: {
    en: 'Optionally the share numbers that were sold/purchased can be specified. If this field is left blank, Orgbrain will use its own algorithm to calculate the share numbers sold and purchased, based on the FIFO principle.',
    nb: 'Alternativt kan man spesifisere hvilke aksjenummer som ble solgt/kjøpt. Hvis dette feltet er tomt, vil Orgbrain bruke sin egen algoritme for å kalkulere hvilke aksjenummer som ble solgt og kjøpt, basert på FIFU-prinsippet (først inn, først ut).',
  },
  InformationAboutBuyerAndSellers: {
    en: ' Information about buyers and sellers ',
    nb: 'Informasjon om kjøpere og selgere',
  },
  TransactionImportsVsNormalImports: {
    en: ' Transaction imports support many of the same fields that a snapshot import has. However, there are some notable differences.',
    nb: 'En transaksjonsimport støtter mange av de samme feltene som en import av et øyeblikksbilde. Men det er noen forskjeller det er verdt å merke seg.',
  },
  Names: {
    en: 'Names',
    nb: 'Navn',
  },
  NamesExplanation: {
    en: 'There is one field for names, both for companies and persons. This is possible to do because the organization number and social security number is a required field, which makes it possible to easily distinguish between companies and people. There are two required columns containing names',
    nb: 'Det er ett felt for navn, både selskapsnavn og personnavn. Dette er mulig fordi vi kan skille mellom organisasjoner og fysiske personer gjennom organisasjonsnummer og fødselsnummer. Det er to påkrevde kolonner for navn.',
  },
  EmailsExplanationTransactions: {
    en: 'Emails are used as an identifier for owners who are physical persons. The email address is used to create a user in Orgbrain, and is therefore also required. The columns that contain emails, must be one of',
    nb: 'E-postadresser blir brukt som en identifikator for fysiske personer. E-postadressen blir brukt for å generere en bruker i Orgbrain, og er derfor også påkrevd. Kolonnene som inneholder e-postadresser, må være en av ',
  },
  BuyerEmail: {
    en: 'Buyer email',
    nb: 'E-post kjøper',
  },
  SellerEmail: {
    en: 'Seller email',
    nb: 'E-post selger',
  },
  OrgnrOrSocialSec: {
    en: 'Organization number/social security number',
    nb: 'Fødselsnummer/orgnr',
  },
  OrgnrSocialSecExplantionTransaction: {
    en: 'This is the last necessary identifier. There are four possible columns for this information',
    nb: 'Dette er den siste påkrevde identifikatoren. Det er fire mulige kolonner for denne informasjonen',
  },
  SocialOrgnrBuyer: {
    en: 'Social security/orgnr buyer',
    nb: 'Fødselsnummer/orgnr kjøper',
  },
  SocialOrgnrSeller: {
    en: 'Social security/orgnr seller',
    nb: 'Fødselsnummer/orgnr selger',
  },
  InvestoridBuyer: {
    en: 'Investorid buyer',
    nb: 'Investorid kjøper',
  },
  InvestorIdSeller: {
    en: 'investorid seller',
    nb: 'Investorid selger',
  },
  InvestorIdVsOrgnr: {
    en: 'Investorid and social security/orgnr are interchangable and can contain the same information',
    nb: 'Investorid og fødselsnummer/orgnr er synonyme og utskiftbare med hverandre.',
  },
  AdditionalShareholderColumns: {
    en: 'Additional shareholder columns',
    nb: 'Flere aksjonærkolonner',
  },
  BuyerAddress: {
    en: 'Buyer address',
    nb: 'Adresse kjøper',
  },
  SellerAddress: {
    en: 'Seller address',
    nb: 'Adresse selger',
  },
  BuyerPostnr: {
    en: 'Buyer zip',
    nb: 'Postnr kjøper',
  },
  BuyerCitizenship: {
    en: 'Buyer citizenship',
    nb: 'Kjøper land',
  },
  SellerPostnr: {
    en: 'Seller zip',
    nb: 'Postnr selger',
  },
  BuyerCity: {
    en: 'Buyer city',
    nb: 'By kjøper',
  },
  SellerCity: {
    en: 'Seller city',
    nb: 'By selger',
  },
  SelerCitizenship: {
    en: 'Seller citizenship',
    nb: 'Selger land',
  },
  TlfBuyer: {
    en: 'Buyer telephone',
    nb: 'Telefonnummer kjøper',
  },
  TlfSeller: {
    en: 'Seller telephone',
    nb: 'Telefonnummer selger',
  },
  VPSNumberInfo: {
    en: 'VPS-number: VPS-number of the buyer',
    nb: 'VPS-nummer: VPS-nummer til kjøper',
  },
  LEINumberInfo: {
    en: 'LEI-number: LEI-number of the buyer',
    nb: 'LEI-nummer: LEI-nummer til kjøper',
  },
  ThereWasIssuesWithYourEvents: {
    en: 'There were issues with your events.\nCheck that you have an establish or snapshot event,\nand that the events make sense in terms of who has shares at what points in time.',
    nb: 'Det var problemer med hendelsene dine.\nSjekk at du har en stiftelsestransaksjon eller et øyeblikksbilde,\nog at hendelsene er konsekvente med tanke på hvem som har hvilke aksjer på forskjellige tidspunkter.',
  },
  ProblemsFoundInFollowingRow: {
    en: 'There were issues found in the following row(s)',
    nb: 'Det var problemer funnet med følgene rad(er)',
  },
  NotDefinedEventType: {
    en: 'Not defined event type',
    nb: 'Event type ikke fylt ut',
  },
  EmptyField: {
    en: 'Field cannot be empty',
    nb: 'Felt kan ikke være tomt',
  },
  FieldNotValidEmail: {
    en: 'Field need to be a valid email',
    nb: 'Feltet må være en gyldig e-postadresse',
  },
  FieldNotANumber: {
    en: 'Field need to be a number',
    nb: 'Feltet må være et tall',
  },
  TheSameOrgId: {
    en: 'The same organization id is sett for two different organizations.',
    nb: 'Samme organisasjons-ID er satt for to ulike organisasjoner.',
  },
  UnknownError: {
    en: 'Unknown error',
    nb: 'Ukjent feil',
  },
  Row: {
    en: 'Row',
    nb: 'Rad',
  },
  HeaderName: {
    en: 'Header name',
    nb: 'Kolonne navn',
  },
  Problem: {
    en: 'Problem',
    nb: 'Årsak',
  },
  EventType: {
    en: 'Event type',
    nb: 'Type hendelse',
  },
  ProblemsFoundInFollowing: {
    en: 'There were issues found for the following',
    nb: 'Det er funnet problemer for følgende',
  },
  NoValidHeaders: {
    en: 'No valid headers were found in your spreadsheet',
    nb: 'Ingen gyldige overskrifter funnet i regnearket',
  },
  NoDataAfterHeader: {
    en: 'No data was found after the header',
    nb: 'Ingen rader funnet under overskriftene',
  },
  TransactionsInImport: {
    en: 'Imported transactions',
    nb: 'Importerte hendelser',
  },
  TransactionsHelptextModuleInfo: {
    en: ' Here you can edit, view and delete the transactions that make up the history of the shareholder registry. The transactions provide the basis for the shareholder registry and editing and deleting them have a direct effect on the registry. ',
    nb: 'Her kan du redigere, se og slette hendelser som danner historikken til aksjeeierboka. Hendelsene gir en basis for aksjeeierboka, så ved å redigere og slette disse, har det en direkte effekt på aksjeeierboka.',
  },
  Transfers: {
    en: 'Transactions',
    nb: 'Transaksjoner',
  },
  Snapshots: {
    en: 'Snapshots',
    nb: 'Øyeblikksbilder',
  },

  NewTransaction: {
    en: 'New transaction',
    nb: 'Ny transaksjon',
  },
  EventHadEmissionPlan: {
    en: 'The share issue plan related to this event has been recovered. It can be found in the share issue page',
    nb: 'Kapitalforhøyelsesplanen relatert til denne hendelsen har blitt gjenvunnet. Du finner planen i kapitalforhøyelser.',
  },
  InconsistentStatesDetected: {
    en: 'Inconsistent states detected',
    nb: 'Inkonsekvente tilstander oppdaget i hendelser etter sletting',
  },
  DeletingTheseEventsWillCauseAnInconsistentState: {
    en: 'Deleting these events will cause an inconsistent state',
    nb: 'Ved å slette disse hendelsene vil det føre til et inkonsekvent aksjeregister',
  },
  DeleteAnyways: {
    en: 'Delete anyways',
    nb: 'Slett uansett',
  },
  SelectASurvey: {
    en: ' Select a survey ',
    nb: 'Velg en undersøkelse',
  },
  MySurveysInfoText: {
    en: ' Here you will find surveys that you have been invited to answer, and which have not yet been answered by you. ',
    nb: ' Her finner du undersøkelser som du er blitt invitert til å svare på, og som enda ikke er blitt besvart av deg. ',
  },
  date: {
    en: 'Date',
    nb: 'Dato',
  },
  Questions: {
    en: 'Questions ',
    nb: 'Spørsmål ',
  },
  MaximumAnswersOnQuestion: {
    en: 'Maximum allowed answers is ',
    nb: 'Maks tillatte svar er ',
  },
  AboutSurvey: {
    en: ' About survey ',
    nb: ' Om spørreskjema ',
  },
  QuestionsOverviewSurvey: {
    en: ' Overview of the questions in the survey ',
    nb: ' Oversikt over spørsmålene i undersøkelsen ',
  },
  SurveyReportInfoText: {
    en: ' This report provides a graphical overview of the responses provided by participants invited to participate in the survey. The answers are intended to form the basis for further discussion in the board. The process in the board could end with the introduction of concrete measures to prepare the situation. Here it can be an advantage to divide into short-term, medium-term and long-term measures. ',
    nb: ' Denne rapporten viser en grafisk oversikt over de de svarene som er gitt av deltakerne som er invitert til å delta i undersøkelsen. Svarene er ment å danne grunnlag for videre diskusjon i styret. Prosessen i styret vil kunne ende med at det innføres konkrete tiltak for å forberede situasjonen. Her kan det være en fordel å dele opp i kortsiktige, mellomlange og langsiktige tiltak. ',
  },
  SurveyReportInfoCustomText: {
    en: ' This report provides a graphical overview of the responses provided by participants invited to participate in the survey.',
    nb: ' Denne rapporten viser en grafisk oversikt over de de svarene som er gitt av deltakerne som er invitert til å delta i undersøkelsen.',
  },
  Answers: {
    en: 'answers',
    nb: 'svar',
  },
  SurveyListInfoText: {
    en: ' Here you will find all the surveys that have been created. ',
    nb: ' Her finner du alle de undersøkelser som er blitt opprettet. ',
  },
  NoSurveysYet: {
    en: 'No surveys yet',
    nb: 'Ingen spørreskjema ennå',
  },

  ShowReport: {
    en: 'Show report ',
    nb: 'Se rapport ',
  },
  ADDMoreUsers: {
    en: 'Add more users',
    nb: 'Legg til flere brukere',
  },
  ViewFolderInDataRoom: {
    en: 'View folder in data room',
    nb: 'Se dokumentet i datarommet',
  },
  annotation_edit_record: {
    en: 'Edit',
    nb: 'Endre',
  },
  'chat_delete-message': {
    en: 'Delete',
    nb: 'Slett melding',
  },
  AnnotationPanelButtonSave: {
    en: 'Save',
    nb: 'Lagre',
  },
  AnnotationPanelButtonSaveAndPublish: {
    en: 'Publish ',
    nb: 'Publiser',
  },
  PublicCommentTooltip: {
    en: 'Public comment. Click to make private.',
    nb: 'Offentlig kommentar. Klikk for å gjøre privat.',
  },
  PrivateCommentTooltip: {
    en: 'Private comment. Click to make public.',
    nb: 'Privat kommentar. Klikk for å gjøre offentlig.',
  },
  YourReplyPlaceHolder: {
    en: 'Reply',
    nb: 'Svar',
  },
  YourCommentPlaceHolder: {
    en: 'Comment',
    nb: 'Kommentar',
  },
  CompanyValue: {
    en: 'Company Value',
    nb: 'Selskapets verdi',
  },
  ShareAmount: {
    en: 'Share amount',
    nb: 'Antall aksjer',
  },
  shareVolume: {
    en: 'Volume',
    nb: 'Volum',
  },
  SelectedShareClass: {
    en: 'Selected shareclass',
    nb: 'Aksjeklasse',
  },
  SelectedPeriod: {
    en: 'Selected period',
    nb: 'Valgt periode',
  },
  'shareValueGraph.periods.1M': {
    en: '1M',
    nb: '1 måned',
  },
  'shareValueGraph.periods.3M': {
    en: '3M',
    nb: '3 måneder',
  },
  'shareValueGraph.periods.6M': {
    en: '6M',
    nb: '6 måneder',
  },
  'shareValueGraph.periods.YTD': {
    en: 'YTD',
    nb: 'i år',
  },
  'shareValueGraph.periods.1YR': {
    en: '1YR',
    nb: '1 år',
  },
  'shareValueGraph.periods.3YR': {
    en: '3YR',
    nb: '3 år',
  },
  'shareValueGraph.periods.5YR': {
    en: '5YR',
    nb: '5 år',
  },
  'shareValueGraph.periods.AllTime': {
    en: 'All time',
    nb: 'All tid',
  },
  'chat_new-messages-below-notification': {
    en: 'New messages',
    nb: 'Nye meldinger',
  },
  'chat_nothing-has-been-said-here-yet': {
    en: ' Nothing has been said here yet ',
    nb: 'Ingenting har blitt sagt her ennå',
  },
  chat_sending: {
    en: 'Sending',
    nb: 'Sender',
  },
  'chat_you-are-replying-to': {
    en: 'You are replying to',
    nb: 'Du svarer',
  },
  'chat_the-message-has-been-deleted': {
    en: ' The message has been deleted ',
    nb: 'Denne meldingen har blitt slettet',
  },
  Help: {
    en: 'Help',
    nb: 'Hjelp',
  },
  already_invited: {
    en: 'Already invited',
    nb: 'Allerede invitert',
  },
  send_to_non_users: {
    en: 'Send to non-users',
    nb: 'Send til person som ikke er registrert som bruker',
  },
  sign_email_help_text: {
    en: ' Use a comma to send to more recipients ',
    nb: ' Bruk komma for å sende til flere mottakere',
  },
  message_to_signers: {
    en: 'Email message to signers (not required)',
    nb: 'Melding til de som skal signere (ikke påkrevd)',
  },
  invite_signers: {
    en: 'Request signatures',
    nb: 'Be om signaturer',
  },
  EmailsAreNotValid: {
    en: 'Please check if all email addresses are correct',
    nb: 'Sjekk om alle e-postadressene er riktige',
  },
  SelectAll: {
    en: 'Select all',
    nb: 'Velg alle',
  },
  HelloMessage: {
    en: 'Hi',
    nb: 'Hei',
  },
  HelpTextStartPageToStart: {
    en: ' On this page, you will find an overview of your tasks to help you get started. ',
    nb: ' På denne startsiden finner du en oversikt som hjelper deg med å komme i gang med dine oppgaver. ',
  },
  ShowAllModules: {
    en: 'Show all modules',
    nb: 'Vis alle moduler',
  },
  AccountSettingsMenuItem: {
    en: 'Account settings',
    nb: 'Kontoinnstillinger',
  },
  logOut: {
    en: 'Log out',
    nb: 'Logg ut',
  },
  OrganizationSupportSettingHeader: {
    en: ' Orgbrain Support ',
    nb: ' Orgbrain Support ',
  },
  NotificationsDeleteAll: {
    en: 'Delete All ',
    nb: 'Slett alle data',
  },
  NotificationsMarkAllRead: {
    en: 'Mark all as read',
    nb: 'Merk som lest',
  },
  CreateNewConfigInfoText: {
    en: ' Here you have the opportunity to change an existing survey or create a completely new one. You can invite all those who are users to participate in the survey. The surveys are anonymous, so you cannot see who has given the various answers. You can enter both multiple choice questions and questions that can be answered with free text. To modify an existing survey, click on the copy symbol at the top of the survey. You will then receive a copy that you can make changes to. To create a whole new survey, click on the "New survey" button. ',
    nb: ' Her har du mulighet til å endre på en eksisterende spørreundersøkelse, eller lag en helt ny. Du kan invitere alle de som ligger som brukere til å delta i undersøkelsen. Undersøkelsene er anonyme, slik at du ikke kan se hvem som har gitt de ulike svarene. Du kan både legge inn flervalgsspørsmål (multiple choice) og spørsmål som kan besvares med fritekst. For å endre en eksisterende undersøkelse, klikker du på kopieringssymbolet øverst på spørreskjema. Du får da en kopi som du kan gjøre endringer på. For å lage en helt ny spørreundersøkelse, klikker du på knappen «Nytt spørreskjema». ',
  },
  ModifySurveysOrCreateNewOnes: {
    en: ' Modify surveys or create new ones ',
    nb: ' Endre undersøkelser eller opprett nye ',
  },
  NewSurvey: {
    en: 'New survey',
    nb: 'Nytt spørreskjema',
  },
  PleaseCropImage: {
    en: 'Please crop the image',
    nb: ' Beskjær bildet',
  },
  Downloading: {
    en: 'Downloading',
    nb: 'Laster ned',
  },

  DocumentViewerCanNotBeDisplayed: {
    en: ' can not be displayed. See downloads',
    nb: 'Kan ikke vises',
  },
  SaveSignature: {
    en: 'Save signature',
    nb: 'Gjenbruk denne signaturen',
  },
  DocumentViewerUploadImageButton: {
    en: ' Upload signature image ',
    nb: 'Last opp signatur ',
  },
  DocumentViewerSignClearButton: {
    en: ' Clear ',
    nb: 'Fjern',
  },
  DocumentViewerSignSubmitButton: {
    en: ' Sign ',
    nb: 'Signer',
  },
  WindowIsThinTryLandscape: {
    en: 'Signing could be more convenient with the device in landscape mode',
    nb: 'Signering kan være mer praktisk med enheten i landskapsmodus.',
  },
  ConfirmEmptyWetSignTitle: {
    en: 'You have not provided a visual signature',
    nb: 'Du har ikke lagt inn en skriftlig signatur',
  },
  ConfirmEmptyWetSignDetail: {
    en: 'If you proceed, the document will only have a digital stamp.',
    nb: 'Dersom du fortsetter, vil dokumentet kun inneholde et digitalt signaturstempel.',
  },
  ConfirmEmptyWetSignAddWet: {
    en: 'Add visual signature',
    nb: 'Legg inn signatur',
  },
  ConfirmEmptyWetSignNoWet: {
    en: 'Sign with no visual signature',
    nb: 'Signer uten skriftlig signatur',
  },
  WaitingForSignserver: {
    en: 'Waiting for sign server',
    nb: 'Venter på signeringsserver',
  },
  LoadingDocumentWithSignature: {
    en: 'Reloading document',
    nb: 'Oppdaterer dokument',
  },
  DocumentViewerSignMessageTitle: {
    en: 'Message from:',
    nb: 'Melding fra:',
  },
  DocumentViewerSignMessageDefault: {
    en: ' Please sign this document ',
    nb: 'Dokument til signering',
  },
  SigningProviderDialogTitle: {
    en: 'Choose your signing setup.',
    nb: 'Hvilket signeringsoppsett vil du bruke?',
  },
  AlsoForExternalUser: {
    en: ' (Also for external users) ',
    nb: ' (Også for eksterne brukere) ',
  },
  DocumentViewerFreeText: {
    en: 'FREE',
    nb: 'GRATIS',
  },
  AboutEsigning: {
    en: 'More info on electronic signing',
    nb: 'Mer info om elektronisk signering',
  },
  OrgbrainSigningSummary: {
    en: ' Standard electronic signature compliant with EU regulation 910/2014 (eIDAS) ',
    nb: 'Standard elektronisk signatur i samsvar med EU-forordning 910/2014 (eIDAS) ',
  },
  OnlyForInternalUser: {
    en: ' (Only for Orgbrain users) ',
    nb: ' (Kun for Orgbrain-brukere) ',
  },
  WaitingForSignee: {
    en: 'Waiting for signee',
    nb: 'Venter på signatur',
  },
  GotoToSign: {
    en: 'Go to sign',
    nb: 'Gå til signering',
  },
  close: {
    en: 'Close',
    nb: 'Lukk',
  },
  SighningTaskEmailOfSigneeHeader: {
    en: ' Email of Signee ',
    nb: 'Underskrivers e-post',
  },
  SighningTaskStatusHeader: {
    en: ' Request status ',
    nb: 'Status på forespørsel',
  },
  SighningTaskCopyURLHeader: {
    en: ' Signing link ',
    nb: ' Signeringslenke',
  },
  CopySignUrl: {
    en: 'Signing URL has been copied to paste buffer',
    nb: 'URL-adressen for signering er kopiert for å lime inn buffer',
  },
  CompletedSignOrderCheckboxText: {
    en: 'Completed',
    nb: 'Fullførte',
  },
  IncompleteSignOrderCheckboxText: {
    en: 'Incomplete',
    nb: 'Ikke fullførte',
  },
  SignOrderCreatedBy: {
    en: 'Created by:',
    nb: 'Opprettet av:',
  },
  SignOrderCreated: {
    en: 'Created:',
    nb: 'Opprettet:',
  },
  SignOrderExpires: {
    en: 'Expires:',
    nb: 'Utløper:',
  },
  ViewSignOrderDetailsText: {
    en: ' View details ',
    nb: 'Se detaljer',
  },

  TimeStamp: {
    en: 'Date',
    nb: 'Dato',
  },
  FileLogAction: {
    en: ' Action ',
    nb: 'Handling',
  },
  FileLogFileName: {
    en: ' File ',
    nb: ' Fil ',
  },
  FilePermissionGroupDeleteHeader: {
    en: 'Delete',
    nb: 'Slett',
  },
  SomeGroupsHaveMixedPrivileges: {
    en: ' Please set any MIXED permissions before saving. ',
    nb: ' Angi eventuelle  «blandede» tillatelser før du lagrer.  ',
  },
  FilePermissionGroup: {
    en: 'Group',
    nb: 'Gruppe',
  },
  FilePermission: {
    en: 'Privilege',
    nb: 'Privilegium',
  },
  AccessTopLevelExplination: {
    en: 'Below you have the opportunity to limit which users should have access to the contents of the folder. Accesses you set here will be reused in all underlying folders. You also have the option to further restrict access to fewer users in the underlying folders.',
    nb: 'Under har du mulighet til å avgrense hvilke brukere som skal ha tilgang til innholdet i mappen. Tilganger du setter her vil gjenbrukes i alle underliggende mapper. Du har også mulighet til å avgrense tilgangen ytterligere til færre brukere i underliggende mapper.',
  },
  InheritPrivMode: {
    en: 'Inherit',
    nb: 'Gjenbruk',
  },
  ACLPrivMode: {
    en: 'Override',
    nb: 'Overstyre',
  },
  ECLPrivMode: {
    en: 'Deny',
    nb: 'Avgrens',
  },
  PrivilegeNoListTitle: {
    en: ' No permissions',
    nb: 'Ingen rettigheter',
  },
  PrivilegeNoListBody: {
    en: ' You have not defined any permissions.  If you go ahead permissions will be inherited from the containing folder.',
    nb: ' Du har ikke definert noen rettigheter.  Hvis du går videre vil rettighetene gjenbrukes fra mappen over. ',
  },
  PrivilegeECLNoListTitle: {
    en: ' Deny list is empty.',
    nb: ' Listen med avgrensninger er tom.',
  },
  PrivilegeECLNoListBody: {
    en: ' You have not defined any permissions. This will have no effect.',
    nb: ' Du har ikke definert noen rettigheter. Dette vil ikke ha noen effekt.',
  },
  ForbidenPrivilegeChangeTitle: {
    en: 'Forbiden permissions change',
    nb: 'Endring av innrykkrettighet',
  },
  ForbidenPrivilegeChangeBody: {
    en: 'The chosen permissions would remove your WRITE permission. Please fix this and try again.',
    nb: 'De valgte rettighetene vil fjerne skrivetillatelsen. Løs dette, og prøv på nytt.',
  },
  ACLExplination: {
    en: ' Submit will override the inherited permissions.',
    nb: ' Overstyr rettighetene fra mappen over.',
  },
  ECLExplination: {
    en: ' Submit will remove permissions from the inherited permisions. ',
    nb: ' Avgrens rettigheter fra mappen over. ',
  },
  FileOwner: {
    en: 'File owner',
    nb: 'Fileier',
  },
  Usage: {
    en: 'Usage',
    nb: 'Forbruk',
  },
  NameType: {
    en: 'Name type',
    nb: 'Type',
  },
  PermissionsText: {
    en: 'Permissions',
    nb: 'Rettigheter',
  },
  PermissionsAdvanced: {
    en: 'Permissions(advanced)',
    nb: 'Tillatelser (avansert)',
  },
  AllowOnThisEntry: {
    en: 'Direct Allow',
    nb: 'Direkte tillat',
  },
  DenyOnThisEntry: {
    en: 'Direct Deny',
    nb: 'Direkte nekt',
  },
  DenyOnParent: {
    en: 'Parent Deny',
    nb: 'Morselskap Nekt',
  },
  dropFilesHere: {
    en: 'Drop files here',
    nb: 'Slipp filer her',
  },
  UploadPdf: {
    en: 'Upload PDF',
    nb: 'Last opp PDF',
  },
  UploadFile: {
    en: 'Upload',
    nb: 'Last opp',
    sv: 'Ladda upp',
  },
  FilterLabel: {
    en: 'Filter',
    nb: 'Filtrer',
  },
  Privileges: {
    en: 'Permissions',
    nb: 'Rettigheter',
  },

  FilebrowserControllerInfoText: {
    en: 'The data room consists of pre-defined "main folders" and suggestions for certain subfolders. The administrator can easily add new subfolders, delete subfolders, and rename them. It is also easy for the administrator to insert folders or files from external devices by dragging these directly into the file list ("drag & drop"). It is also possible to create a folder that can be shared with other organizations where the user has administrative rights. The data room has various features, such as electronic signing and task management. Folders and files marked with a branch symbol can be easily shared with other users.',
    nb: 'Datarom består av ferdigdefinerte «hovedmapper», og forslag til enkelte undermapper. Administrator kan enkelt legge til nye undermapper, slette undermapper og endre navn på disse. Det er også enkelt for administrator å legge inn mapper eller filer fra eksterne enheter ved å dra disse rett inn i fillisten («drag & drop»). Det er også mulig å opprette en mappe som kan deles med andre organisasjoner der brukeren har administratorrettigheter. Datarommet har en rekke funksjoner, slik som elektronisk signering og oppgavehåndtering. Mapper og filer som er merket med forgreningssymbol, kan enkelt deles med andre brukere.',
  },
  PleaseConfirmPermanentDeleteText: {
    en: 'Please confirm permanent deletion',
    nb: 'Vennligst bekreft permanent sletting',
  },
  ConfirmPermanentDelete: {
    en: 'Delete permanently',
    nb: 'Slett permanent',
  },
  LoadingInformation: {
    en: 'Loading please wait',
    nb: 'Laster, vennligst vent',
  },
  HideDeletedFiles: {
    en: ' Hide deleted ',
    nb: 'Skjul slettet',
  },
  ShowDeletedFiles: {
    en: ' Show deleted ',
    nb: 'Vis slettet',
  },
  MenuDetails: {
    en: ' Details ',
    nb: 'Detaljer',
  },
  MenuFirstSignRequest: {
    en: ' Create signing request ',
    nb: ' Opprett signeringsforespørsel ',
  },
  MenuAddSigneesRequest: {
    en: ' Add signees ',
    nb: 'Legg til flere som skal signere',
  },
  MenuSignReminder: {
    en: ' Send signing reminder ',
    nb: 'Send påminnelse om signering',
  },
  FileMenuShare: {
    en: ' Copy ',
    nb: ' Kopiere ',
  },
  'FileBrowserTip-NewFolder': {
    en: 'New folder',
    nb: 'Ny mappe',
  },
  FailedToPermanenentDelete: {
    en: 'Failed to permanently delete some files',
    nb: 'Mislyktes med å slette noen filer permanent',
  },
  FileCopiedtoPasteBufferInstruction: {
    en: 'Navigate to the destination folder, then paste.',
    nb: 'Naviger til mappen, og lim deretter inn.',
  },
  CopyingFiles: {
    en: 'Copying files',
    nb: 'Kopiere filer',
  },
  PleaseConfirmRestore: {
    en: 'Please confirm restore',
    nb: 'Vennligst bekreft gjenoppretting',
  },
  ConfirmDoNotrestore: {
    en: 'Do not restore',
    nb: 'Ikke gjenopprett',
  },
  //new
  ToggleAdminClient: {
    en: 'Toggle admin status',
    nb: 'Bytt administrator-status',
  },
  ToggleSalesClient: {
    en: 'Toggle sales status',
    nb: 'Bytt selgerstatus',
  },
  GroupViewTooltip: {
    en: 'Only allow user to view',
    nb: 'Tillat kun lesetilgang',
  },
  GroupWatermarkTooltip: {
    en: 'Download with watermark',
    nb: 'Last ned med vannmerke',
  },
  GroupDownloadTooltip: {
    en: 'Download no watermark',
    nb: 'Ikke last ned vannmerke',
  },
  UserManualIdTooltip: {
    en: 'The user administrator can choose to give the user access to the organization by ticking the manual identity',
    nb: ' Her kan brukeradministrator velge å gi bruker tilgang organisasjonen ved å krysse av for manuell identifisering',
  },
  ChangeImage: {
    en: 'Change image',
    nb: 'Endre bilde',
  },
  MenuSelectRole: {
    en: 'Select Role',
    nb: 'Velg rolle',
  },
  OrgNumberExamp: {
    en: 'Identifier e.g. 987654321',
    nb: 'Identifikator, for eksempel 987654321',
  },
  ChangeLanguageTooltip: {
    en: 'Change language. To change language for agenda points, click Organization - settings',
    nb: 'Endre språk. For å endre språk på innholdet i agendapunktene, klikker du på Organisasjon - innstillinger.',
  },
  AnnotationToolTipPrivateCommentClick: {
    en: 'The comment is private. Click to make it visible to others.',
    nb: 'Kommentaren er privat. Klikk for å gjøre den synlig for andre. ',
  },
  AnnotationToolTipPublicCommentClick: {
    en: 'Everyone can see the comment. Click to make private.',
    nb: 'Alle kan se kommentaren. Klikk for å gjøre privat. ',
  },
  Agendainformation: {
    en: 'Information about the agenda item',
    nb: 'Informasjon om agendapunktet',
  },
  editAgenda: {
    en: 'Edit agenda',
    nb: 'Rediger agenda',
  },
  AttachFileToAgenda: {
    en: 'Attach file to agenda item',
    nb: 'Legg en fil til agendapunktet',
  },
  QuitMeetingHelpText: {
    en: 'To start the meeting again, press the edit meeting button and change the status of the meeting to active',
    nb: 'For å starte møtet igjen, rediger møtet og endre statusen på møtet til aktiv',
  },
  ViewAttachment: {
    en: 'View attachment',
    nb: 'Se vedlegg',
  },
  CalendarPrevQuarter: {
    en: 'Previous quarter',
    nb: 'Forrige kvartal',
  },
  CalendarCurrentQuarter: {
    en: 'Go to current quarter',
    nb: 'Gå til nåværende kvartal',
  },
  CalendarNextQuarter: {
    en: 'Next quarter',
    nb: 'Neste kvartal',
  },
  SwitchAdminToUserViewTooltip: {
    en: 'Preview the meeting as a regular user.',
    nb: 'Her kan du veksle mellom å se møtet som en vanlig bruker og som administrator.',
  },
  openMeetingChat: {
    en: 'Open the meeting chat. Ask questions and communicate with all participants of the meeting.',
    nb: 'Åpne møte-chat. Her kan du stille spørsmål og kommunisere med alle som har tilgang til møtet.',
  },
  editMeetingDetails: {
    en: 'Edit meeting details',
    nb: 'Rediger møtedetaljer',
  },
  MeetingStatusTooltip: {
    en: 'This icon indicates the status of the\n      meeting',
    nb: 'Dette ikonet forteller hvilken status møtet har',
  },
  CheckVideolinkInMeetingCardTootlip: {
    en: 'Check, if the participants are not to have access to the video link via the meeting card.',
    nb: 'Kryss av dersom deltakerne ikke skal ha tilgang til videokonferanse via møtekortet.',
  },
  CheckForAccessToChatMeetingCardTooltip: {
    en: 'Check, if the participants are not to have access to the chat on the meeting card.',
    nb: 'Kryss av dersom deltakerne ikke skal ha tilgang til chatten på møtekortet.',
  },
  AllowAdvanceVotingTooltip: {
    en: 'Tick if the company allows voting by using advance voting.',
    nb: 'Kryss av dersom virksomheten åpner for stemmegivning ved bruk av forhåndsstemme.',
  },
  CheckForUseProxyFormTooltip: {
    en: 'Check if the company does not want to use the built-in proxy form.',
    nb: 'Kryss av dersom virksomheten ikke ønsker å benytte seg av innebygget fullmaktsskjema.',
  },
  copy_email: {
    en: 'Copy email address to clipboard',
    nb: 'Kopier e-postadresse til utklippstavle',
  },
  meetingEmail_markAsUnread: {
    en: 'Mark as unread',
    nb: 'Merk som ulest',
  },
  meetingEmail_markAsRead: {
    en: 'Mark as read',
    nb: 'Merk som lest',
  },
  meetingEmail_deleteEmailForEveryone: {
    en: 'Delete email for everyone',
    nb: 'Slett e-posten for alle',
  },
  stopSearching: {
    en: 'Stop searching',
    nb: 'Stopp søk',
  },
  ViewDocument: {
    en: 'Open document',
    nb: 'Åpne dokument',
  },

  ClearImperativeQuorumStatus: {
    en: 'Go back to automatically set quorum status',
    nb: 'Gå tilbake til automatisk satt status for beslutningsdyktighet',
  },
  TermsOfUseTip: {
    en: 'Click to see terms of use',
    nb: 'Klikk for å se vilkårene for bruk',
  },
  DataprocessingTip: {
    en: 'Click to see data processing agreement',
    nb: 'Klikk for å se databehandlingsavtale',
  },
  PrivacyPolicyTip: {
    en: 'click to see privacy policy',
    nb: 'Klikk for å se personvernreglene',
  },
  PrivacyPolicy: {
    en: 'Privacy policy',
    nb: 'Personvernerklæring',
  },
  CalendarHelpTip: {
    en: 'If Calendar API is enabled the meeting entry will add itself directly into your calendar (provided that your calendar is suported by the API). Alternatively, you can update the calendar yourself based on the ICS file that comes with the invitation.',
    nb: 'Hvis Kalender API er aktivert vil møteinnkallingen legge seg direkte inn i din kalender (forutsatt at din kalender er støttet av API-et). Alternativt kan du selv oppdatere kalenderen ut fra ICS-filen som følger med e-posten-invitasjonen.',
  },
  RemoveDevice: {
    en: 'Invalidate device and all associated sessions',
    nb: 'Ugyldiggjøre enheten og alle tilknyttede økter',
  },
  DeviceIsTrusted: {
    en: 'This device is trusted',
    nb: 'Denne enheten er klarert',
  },
  DeleteSelected: {
    en: 'Delete selected',
    nb: 'Slett merket',
  },
  Alternatives: {
    en: 'Alternatives',
    nb: 'Alternativer',
  },
  ValueDistributionTooltip: {
    en: 'The column shows the value distribution on a sale of the whole company with the above share price',
    nb: 'Kolonnen viser hvordan verdiene blir fordelt om hele selskapet blir solgt til aksjekursen ovenfor',
  },
  RegistryWillBeInconsistent: {
    en: 'Your registry will be inconsistent. Change the date',
    nb: 'Ditt register vil være inkonsekvent. Endre datoen.',
  },
  AgreementTitleTooltip: {
    en: 'Here you give the agreement a title.',
    nb: 'Her gir du avtalen en tittel.',
  },
  AgreementShareholderTooltip: {
    en: 'Here you enter who the company has as counterparty in the agreement, for example an employee or bank',
    nb: 'Her legger du inn hvem som er motparten i avtalen. Dette er nødt til å være en registrert investor.',
  },
  AgreementUnderlyingTooltip: {
    en: 'If the company has several share classes, enter here which share class the agreement applies to',
    nb: 'Dersom selskapet har flere aksjeklasser, så legger du her inn hvilken aksjeklasse avtalen gjelder for',
  },
  AgreementDateTooltip: {
    en: 'If the agreement has a specific expiry date, enter it here',
    nb: 'Hvis avtalen har en spesifikk utløpsdato, skriv den inn her',
  },
  AgreementStrikeTooltip: {
    en: 'Here you enter the price (rate) that the agreement owner must pay for each share',
    nb: 'Her legger du inn pris (kurs) som skal betales for hver aksje ved utøvelse',
  },
  AgreementAmountTooltip: {
    en: 'Here you enter the number of shares that the agreement covers',
    nb: 'Her legger du inn antall aksjer som avtalen omfatter',
  },
  'shareholder.LoanSizeTooltip': {
    en: 'Here you enter the original loan amount (principal)',
    nb: 'Her legger du inn det opprinnelige lånebeløpet (hovedstolen)',
  },
  LoanShareTooltip: {
    en: 'Here you enter the size of the loan that is applicable to the contract',
    nb: 'Her legger du inn andelen av lånet som er relevant for kontrakten',
  },
  LoanInterestTooltip: {
    en: 'Here you enter the annual interest rate on the loan',
    nb: 'Her legger du inn den årlige rentesatsen som er på lånet',
  },
  LoanStructureTooltip: {
    en: 'Here you can enter conditions for repayment of the loan',
    nb: 'Her kan du legge inn betingelser for tilbakebetaling av lånet ',
  },
  AgreementConditionsTooltip: {
    en: 'Here you can enter free text, for example whether there are criteria that must be met for the agreement to be exercised.',
    nb: 'Her kan du legge inn fritekst, for eksempel om det er kriterier som må være oppfylt for at avtalen skal kunne utøves.',
  },
  DownloadAndUploadData: {
    en: 'Download and upload data',
    nb: 'Last ned eller last opp data',
  },
  InviteShareholdersTooltip: {
    en: "Here you invite the investors you want to participate in the equity issue. Only registered users registered under 'Owners' in the shareholder book can be invited. If you want to invite new investors, you have to first register them under 'Owners'",
    nb: 'Her inviterer du de som skal delta i kapitalforhøyelsen. Kun brukere som er registrert som "Investor" i aksjeeierboken kan inviteres. Dersom du ønsker å invitere nye investorer må du først registrere dem som "Investor"',
  },
  RegisterSkewedDistributionTooltip: {
    en: 'If one or more shareholders are to have payments that deviate from the rest, this can be entered here',
    nb: 'Dersom en eller flere aksjeeier skal ha utbetaling som avviker fra resten, kan dette legges inn her',
  },
  AddInvestorTooltip: {
    en: 'Here you can manually enter a position on an investor who has not been invited.',
    nb: 'Her kan du manuelt legge inn posisjon på en investor som ikke er invitert.',
  },
  RemoveSelectedFromEmission: {
    en: 'Remove selected from emission',
    nb: 'Slett merkede fra kapitalforhøyelsen',
  },
  SendInvitationsAgainToMarkedInvestors: {
    en: 'Send invitations again to marked investors',
    nb: 'Send invitasjon igjen til merkede investorer',
  },
  SendPaymentInformationToMarkedInvestors: {
    en: 'Send payment information to marked investors',
    nb: 'Send betalingsinformasjon til merkede investorer',
  },
  RegisterPastShareIssueTooltip: {
    en: 'Register a share issue that has already happened.',
    nb: 'Etterregistrer en kapitalforhøyelse som allerede har hendt',
  },
  EmissionModuleInfoTooltip: {
    en: 'There are several ways to carry out a capital increase. The solution in Orgbrain is intended to assist with many of the practicalities. It is important to ensure that investors receive sufficient information through the order form and any attachments. The formal decision must be made at a general meeting (or board meeting, subject to board authorization). The capital increase must be confirmed by the auditor / bank / lawyer / accountant before a coordinated registration notification is submitted to the Register of Business Enterprises regarding the capital increase.There are several ways to carry out a capital increase. The solution in Orgbrain is intended to assist with many of the practicalities. It is important that you make sure to provide investors with sufficient information through the order form and any attachments, implement the formal decision at the general meeting (or board meeting, subject to board authorization), have the capital increase confirmed by the auditor / bank / lawyer / accountant and submit a coordinated register message to the Register of Business Enterprises. about the capital increase.',
    nb: 'Det er flere måter å gjennomføre en kapitalforhøyelse på. Løsningen i Orgbrain er ment å bistå med mange av de praktiske forholdene. Det er viktig å påse at investorene får tilstrekkelig informasjon gjennom bestillingsblankett og eventuelle vedlegg. Det formelle vedtaket må gjøres i generalforsamling (eller styremøte, forutsatt styrefullmakt). Kapitalforhøyelsen må bekreftes av revisor/bank/advokat/regnskapsfører før det sendes inn en samordnet registermelding til Foretaksregisteret om kapitalforhøyelsen.',
  },
  EmissionModuleInfoTooltipPart2: {
    en: 'If you have carried out a capital increase in any other way than using «New capital increase», you can register the shareholding in the portal by using «Post-register capital increase» so that the shareholder book in Orgbrain is properly updated.',
    nb: 'Dersom du har gjennomført en kapitalforhøyelse på annen måte enn ved bruk av «Ny kapitalforhøyelse», kan du ved bruk av «Etterregistrer kapitalforhøyelse» få registrert kapitalforhøyelsen i portalen slik at aksjeeierboken i Orgbrain blir riktig oppdatert.',
  },
  EmissionFolderTooltip: {
    en: 'Here you upload attachments that you want the investors to receive with their order form, for example resolutions, accounting information, or the shareholder agreement',
    nb: 'Her laster du opp eventuelle vedlegg som du ønsker at investorene skal motta sammen med bestillingsblanketten, for eksempel vedtekter, regnskap eller aksjonæravtale',
  },
  InternalCommentTooltipEmission: {
    en: 'This is an internal note field where you can add notes that only administrators can see',
    nb: 'Dette er et internt notatfelt der du kan legge inn notater som kun administrator ser',
  },
  EmissionTitleTooltip: {
    en: 'Here you give the Capital issue a name, for example «Capital issue in connection with exercising options». This is a title that also is vissible for investores.',
    nb: 'Her gir du emisjonen en tittel, f.eks. “Kapitalforhøyelse i forbindelse med innløsning av opsjoner”. Dette er en tittel som også vil være synlig for investorene.',
  },
  EmissionTypeTooltip: {
    en: 'The type of issue is used, among other things, in connection with the reporting of the shareholder register statement (RF-1086). The issue type «New issue»  is used for ordinary capital increases with settlement in money.',
    nb: 'Emisjonstype benyttes blant annet i forbindelse med rapportering av aksjonærregisteroppgaven (RF-1086). Emisjonstypen «Nyemisjon» benyttes ved ordinær kapitalforhøyelse med oppgjør i penger.',
  },
  SharePriceEmissionTooltip: {
    en: 'Here you enter the price for the equity issue',
    nb: 'Her legger du inn tegningskursen i ved kapitalforhøyelsen',
  },
  ShareclassEmissionTooltip: {
    en: 'Here you choose the subject shareclass for the equity issue',
    nb: 'Her velger du den aksjeklassen som kapitalforhøyelsen gjelder for',
  },
  MinSharesForIssueTooltip: {
    en: 'If the company has to raise a minimum amount of shares for the equity issue, it can be entered here',
    nb: 'Dersom selskapet minimum må hente inn et visst antall aksjer i kapitalforhøyelsen, må dette legges inn her.',
  },
  BankAccountEmissionTooltip: {
    en: 'Here you enter the account number that the investors should transfer to when paying for the allocated amount of shares',
    nb: 'Her legger du inn selskapets bankkonto som investorene skal benytte ved innbetaling av tegningsbeløpet',
  },
  MinSharesperShareholderTooltip: {
    en: 'If the investors has to order a minimum amount of shares it should be entered here',
    nb: 'Dersom investorene må minimum tegne seg for et visst antall aksjer, må dette legges inn her.',
  },
  MaxSharesPerShareholderTooltip: {
    en: 'If there is a max amount of shares that can be ordered per shareholder it could be entered here',
    nb: 'Dersom det er begrensninger i hvor mange aksjer en enkeltinvestor kan bestille, må dette legges inn her.',
  },
  ClickForEmailSuggestions: {
    en: 'Click for email suggestions',
    nb: 'Klikk for forslag til e-post',
  },
  DateUsedForTaxReporting: {
    en: 'The date is used, among other things, for tax reporting',
    nb: 'Datoen benyttes blant annet ved skatterapportering',
  },
  MarkThisEventAsIrrelavantToTheCompanyValue: {
    en: "Mark this event as irrelevant to the company's value.",
    nb: 'Marker denne hendelsen som irrelevant for selskapsverdien. Dette vil skjule prisen og volumet for denne hendelsen i grafer som viser selskapsverdien eller prishistorikk.',
  },
  'shareholders.EventIsInvalidForCompanyValue': {
    en: 'Irrelevant for company value',
    nb: 'Irrelevant for selskapsverdien',
  },
  IrrelevantForCompanyValue: {
    en: 'Irrelevant for company value',
    nb: 'Irrelevant for selskapsverdien',
  },
  DeleteSelectedTransactions: {
    en: 'Delete selected transactions',
    nb: 'Slette valgte hendelser',
  },
  MeetingActionPoint: {
    en: 'This action point is related to a meeting',
    nb: 'Dette aksjonspunktet er relatert til et møte',
  },
  UserAndSettings: {
    en: 'User and settings',
    nb: 'Konto & innstillinger',
  },
  ToggleComments: {
    en: 'Toggle comments',
    nb: 'Vis kommentarer',
  },
  AnnotationSelectTextTip: {
    en: 'Select text',
    nb: 'Marker tekst',
  },
  ClickToViewADifferentVersionToolTip: {
    en: 'Version history',
    nb: 'Versjonshistorikk',
  },
  ClickToDownloadToolTip: {
    en: 'Download',
    nb: 'Last ned',
  },
  CalendarItemPastDue: {
    en: 'Past due',
    nb: 'Forfalt',
  },
  CopySigningLink: {
    en: 'Copy signing link',
    nb: 'Kopier signeringslenke',
  },
  ViewSignedDocumentTip: {
    en: 'View Signed Document',
    nb: 'Se signert dokument',
  },
  VIEWFileLogAction: {
    en: 'Viewed',
    nb: 'Åpnet',
  },
  DOWNLOADFileLogAction: {
    en: 'Downloaded',
    nb: 'Last ned',
  },
  DOWNLOAD_WATERMARKEDFileLogAction: {
    en: 'Downloaded with watermark',
    nb: 'Last ned med vannmerke',
  },
  COPYFileLogAction: {
    en: 'Copied',
    nb: 'Kopiert',
  },
  STATUSFileLogAction: {
    en: 'File status modified',
    nb: 'Filstatus endret',
  },
  VIEW_SIGNEDFileLogAction: {
    en: 'View signed file',
    nb: 'Vis signert fil',
  },
  PERMISSIONSFileLogAction: {
    en: 'File permissions',
    nb: 'Filtillatelser',
  },
  CREATEDFileLogAction: {
    en: 'File created',
    nb: 'Fil opprettet',
  },
  RESTOREDFileLogAction: {
    en: 'File restored',
    nb: 'Fil gjenopprettet',
  },
  DELETEDFileLogAction: {
    en: 'File deleted',
    nb: 'Fil slettet',
  },
  RENAMEFileLogAction: {
    en: 'File renamed',
    nb: 'Fil omdøpt',
  },
  RESPONSIBLEFileLogAction: {
    en: 'Assigned responsible person',
    nb: 'Tildelt ansvarlig person',
  },
  ViewOrderProgreessTip: {
    en: 'View Order Progress',
    nb: 'Se progresjon i signeringsordre',
  },
  HistoryLogTip: {
    en: 'View history log',
    nb: 'Se historikk',
  },
  'FileBrowserTip-Restorefiles': {
    en: 'Restore',
    nb: 'Gjenopprett',
  },
  'FileBrowserTip-PasteFiles': {
    en: 'Paste into this folder',
    nb: 'Kopier fra utklippsbuffer til denne mappen',
  },
  OrganizationCheck: {
    en: 'Super Check',
    nb: 'Super sjekk',
  },
  SentLog: {
    en: 'Sent log',
    nb: 'Sendingslogg',
  },
  Clients: {
    en: 'Clients',
    nb: 'Klienter',
  },
  SuperListOrganizations: {
    en: 'Organizations',
    nb: 'Organisasjoner',
  },
  allAttendees: {
    en: 'All',
    nb: 'Alle',
  },

  StylePreference: {
    en: 'Style',
    nb: 'Stil',
  },
  MyOrganizationsTab: {
    en: 'Organizations',
    nb: 'Organisasjoner',
  },
  'shareholders.TimeOfTransaction': {
    en: 'Time of transaction',
    nb: 'Transaksjonstidspunkt',
  },
  Results: {
    en: 'Results',
    nb: 'Resultater',
  },

  MinimumAmountOfSharesForIssueOptional: {
    en: 'Minimum amount of shares for share issue (optional)',
    nb: 'Minimum antall aksjer for kapitalforhøyelsen (frivillig)',
  },
  MinimumAmountOfSharesPerShareholder: {
    en: 'Minimum amount of shares per shareholder',
    nb: 'Minimum antall aksjer per investor',
  },
  MaximumAmountOfSharesPerShareholderOptional: {
    en: 'Maximum amount of shares per shareholder (optional)',
    nb: 'Maksimum antall aksjer per investor (frivillig)',
  },
  IntroductionToTheShareRegister: {
    en: 'Introduction to the share register',
    nb: 'Transaksjons dato',
  },
  StartDate: {
    en: 'Start date',
    nb: ' Startdato ',
  },
  message_to_invitees: {
    en: 'Email message to invitees (not required)',
    nb: 'E-postmelding til de inviterte (ikke påkrevd)',
  },
  message_to_recipients: {
    en: 'Message to recipients (not required)',
    nb: 'Beskjed til mottagere (valgfritt)',
  },
  AgendaSuggestionTopics: {
    en: 'Agenda suggestion topics',
    nb: 'Agendaforslag-tema',
  },

  MessageToEmissionInvestorsPlaceholder: {
    en: 'Email message to investors',
    nb: 'E-postmelding til investorer',
  },
  MessageToEmissionInviteesPlaceholder: {
    en: 'Email message to invitees',
    nb: 'E-postmelding til de inviterte (ikke påkrevd)',
  },
  InternalCommentPlaceholder: {
    en: 'Here you can enter an internal note or information related to the issue that only the administrator can see.',
    nb: 'Her kan du legge inn en intern kommentar eller opplysninger som er relatert til kapitalforhøyelse som kun administrator kan se. ',
  },
  MenuSearchFiles: {
    en: 'Search in all files',
    nb: 'Søk i alle filer',
  },

  CapitalEvents: {
    en: 'Capital events',
    nb: 'Kapitalhendelser',
  },
  NewStockSplice: {
    en: 'New stock splice',
    nb: 'Ny aksjespleis',
  },
  NewStockSplit: {
    en: 'New stock split',
    nb: 'Ny aksjesplitt',
  },
  'Dividend/payout': {
    en: 'Dividend/payout',
    nb: 'Utbytte/utbetaling',
  },
  Onboard: {
    en: 'Onboard',
    nb: 'Legge inn',
  },
  AlterParValue: {
    en: 'Alter par value',
    nb: 'Endre pålydene',
  },
  NewSnapshot: {
    en: 'New snapshot',
    nb: 'Nytt øyeblikksbilde',
  },
  NotAnswered: {
    en: 'Not answered',
    nb: 'Ubesvart',
  },
  SignicatOrderListHeader: {
    en: 'Manage Signatures',
    nb: 'Administrer signaturer',
  },
  TransferInviteToAnotherEmailDialogTitle: {
    en: 'Transfer invite to another email',
    nb: 'Overfør invitasjonen til annen e-postadresse',
  },
  ChangeEmail: {
    en: 'Change email',
    nb: 'Registrer ny e-postadresse',
  },
  SendInformationByEmail: {
    en: 'Send information by e-mail',
    nb: 'Send informasjon på e-post',
  },
  EditTaxIncentive: {
    en: 'Edit Tax Incentive',
    nb: 'Endre skatteinsentiv',
  },
  DocumentViewerSignHereTitle: {
    en: 'Sign here',
    nb: 'Signer i feltet under',
  },
  DialogViewSignRequests: {
    en: 'Signing Requests',
    nb: 'Signeringsforespørsler\n',
  },
  AccesControlTitle: {
    en: 'Access control',
    nb: 'Tilgangsstyring',
  },
  nameOfCandidate: {
    en: 'Name of candidate',
    nb: 'Kandidatens navn',
  },
  PaymentStructurePlaceholder: {
    en: 'Here you can enter the structure of the loan is payed',
    nb: 'Her kan du skrive om betalingstrukturen til lånet',
  },
  ConditionsPlaceholderText: {
    en: 'Here you can enter the conditions of the contract',
    nb: 'Her kan du skrive om betingelsene til kontrakten',
  },
  NewConvertibleLoan: {
    en: 'New convertible loan',
    nb: 'Nytt konvertibelt lån',
  },
  NewOption: {
    en: 'New option',
    nb: 'Ny opsjon',
  },
  NewWarrant: {
    en: 'New warrant',
    nb: 'Ny tegningsrett',
  },
  'shareholders.EmissionSimulation': {
    en: 'Emission Simulation',
    nb: 'Simulering av kapitalforhøyelse',
  },
  'shareholders.IncludeOptions': {
    en: 'Include options',
    nb: 'Inkluder opsjoner',
  },
  'shareholders.CompanyValueBeforeSimulation': {
    en: 'Company value before simulation',
    nb: 'Selskapsverdi før simulering',
  },
  'shareholders.byIssuing': {
    en: 'by issuing',
    nb: 'ved utstedelse av',
    sv: 'genom att utfärda',
  },
  'shareholders.InvestmentAmount': {
    en: 'Investment amount',
    nb: 'Investeringsbeløp',
    sv: 'Investeringsbelopp',
  },
  'shareholders.PercentageOfOwnershipAfterInvestment': {
    en: 'Percentage of ownership after investment',
    nb: 'Prosent eierskap etter investering',
    sv: 'Procent ägande efter investering',
  },
  'shareholders.AmountInvested': {
    en: 'Amount invested',
    nb: 'Investeringsbeløp',
    sv: 'Investeringsbelopp',
  },
  'shareholders.CompanyValue': {
    en: 'Company value',
    nb: 'Prising av selskapet',
    sv: 'Företagsvärde',
  },
  'shareholders.Post-money': {
    en: 'Post-money',
    nb: 'Post-money',
    sv: 'Post-money',
  },
  'shareholders.Reset': {
    en: 'Reset',
    nb: 'Tilbakestill',
    sv: 'Återställ',
  },
  'shareholders.EditTotalShares': {
    en: 'Edit total shares',
    nb: 'Rediger antall aksjer',
    sv: 'Redigera totala aktier',
  },
  'shareholders.Transaction': {
    en: 'Transaction',
    nb: 'Transaksjon',
    sv: 'Transaktion',
  },
  'shareholders.InformationAboutRecipient': {
    en: 'Information about Recipient',
    nb: 'Informasjon om mottaker',
    sv: 'Information om mottagare',
  },
  'shareholders.ConfirmTransaction': {
    en: 'Confirm transaction',
    nb: 'Bekreft hendelse',
    sv: 'Bekräfta hendelse',
  },
  'shareholders.PleaseConfirmThatAllInformationUnderneathIsCorrectBeforeYouSave': {
    en: 'Please confirm that all information underneath is correct before you save',
    nb: 'Vennligst bekreft at all informasjon er riktig før du fullfører',
    sv: 'Vänligen bekräfta att all information nedan är korrekt innan du sparar',
  },
  'shareholders.NoShareclassesOrRecordsText': {
    en: 'You need to create a shareclass and there shares has to be registered to be able to do transactions',
    nb: 'Du må lage en aksjeklasse og det må finnes aksjer for å kunne registrere nye hendelser',
  },
  'shareholders.InformationAboutTheTransaction': {
    en: 'Information about the transaction',
    nb: 'Informasjon om transaksjonen',
    sv: 'Information om transaktionen',
  },
  'shareholders.Disposer': {
    en: 'Disposer',
    nb: 'Avhender',
    sv: 'Disponent',
  },
  'shareholders.EventDateHint': {
    en: 'Must be between last event and the current time',
    nb: 'Må være mellom siste hendelse og nåværende tidspunkt',
  },
  'shareholders.AvailableShares': {
    en: 'Available shares',
    nb: 'Tilgjengelige aksjer',
    sv: 'Tillgängliga aktier',
  },
  'shareholders.NumberOfSharesToBeSold': {
    en: 'Number of shares to be sold',
    nb: 'Antall aksjer som skal selges',
    sv: 'Antal aktier som ska säljas',
  },
  'shareholders.PricePerShare': {
    en: 'Price per share',
    nb: 'Pris per aksje',
    sv: 'Pris per aktie',
  },
  'shareholders.TotalNOK': {
    en: 'Total (NOK)',
    nb: 'Total (NOK)',
    sv: 'Total (NOK)',
  },
  'shareholders.RecipientRepresentative': {
    en: 'Recipient representative',
    nb: 'Mottaker representant',
    sv: 'Mottagare representant',
  },
  'app-user-list.BalcklistedEmailTip': {
    en: 'Blacklisted email\n  Click for details',
    nb: 'Svartelistet e-post\n  Klikk for detaljer',
  },
  'files.AccessControlDeleteTooltip': {
    en: 'Remove group from access list',
    nb: 'Slett tilgangskontroll',
  },

  BasicInformationMeetingDescription: {
    en: 'Basic information about the meeting',
    nb: 'Grunnleggende informasjon om møtet',
    sv: 'Grundläggande information om mötet',
  },
  MeetingTimeSettings: {
    en: 'Meeting time settings',
    nb: 'Møtetidspunkt',
  },
  MeetingTimeSettingsDescription: {
    en: 'Set the time and date for the meeting',
    nb: 'Sett tidspunkt og dato for møtet',
  },
  FormOfMeetingText: {
    en: 'Location and type of the meeting',
    nb: 'Sted og form for møtet',
  },
  VideoSettings: {
    en: 'Video Call',
    nb: 'Videomøte',
  },
  PrepareMeeting: {
    en: 'Preparation',
    nb: 'Forberedelse',
  },
  SelectTime: {
    en: 'Select a time.',
    nb: 'Velg et tidspunkt.',
  },
  InviteToMeeting: {
    en: 'Send out invitations.',
    nb: 'Send ut invitasjoner.',
  },
  CalledMeeting: {
    en: 'Called',
    nb: 'Innkalt',
  },
  StartMeeting: {
    en: 'Start the meeting.',
    nb: 'Start møtet.',
  },
  MeetingParticipants: {
    en: 'Participants',
    nb: 'Deltakere',
  },
  SpeakingTimeAndActivity: {
    en: 'Speaking time and activity',
    nb: 'Taletid og aktivitet',
  },
  CloseMeeting: {
    en: 'End the meeting.',
    nb: 'Avslutt møtet.',
  },
  CreateProtocolMeeting: {
    en: 'Protocol',
    nb: 'Protokoll',
  },
  GenerateProtocol: {
    en: 'Generate the protocol draft for the meeting.',
    nb: 'Generer protokoll utkast for møtet.',
  },
  SendProtocolForReview: {
    en: 'Send the protocol for review.',
    nb: 'Send protokollen til høring.',
  },
  SendSigningInvitation: {
    en: 'Send invitation for signing the protocol.',
    nb: 'Send invitasjon for signering av protokollen.',
  },
  CompletedMeeting: {
    en: 'Completed',
    nb: 'Fullført',
  },

  VideoSettingsText: {
    en: 'Change the video meeting service used for the meeting.',
    nb: 'Endre videomøtetjenesten som benyttes for møtet.',
  },
  ExtraSettingsMeetingText: {
    en: 'Advanced meeting settings',
    nb: 'Avanserte innstillinger for møtet.',
  },
  DashboardModules: {
    en: 'Quick access',
    nb: 'Hurtigmeny',
  },
  BoardPositionAds: {
    en: 'Positions ads',
    nb: 'Stillingsannonser',
  },
  YourProfile: {
    en: 'Your profile',
    nb: 'Din profil',
  },
  OpenBoardPositions: {
    en: 'Open board positions',
    nb: 'Ledige styreverv',
  },
  hasMultipleOrganization: {
    en: 'Role in multiple organizations',
    nb: 'Rolle i flere organisasjoner',
  },
  OpenBoardPositionsText: {
    en: 'The boardroom is changing – find your place in it. Boardmatch matches board candidates and companies based on more than just CVs.',
    nb: 'Styreverdenen er i endring – finn din plass i den. Styrematch matcher styrekandidater og selskaper basert på mer enn CV-er.',
  },
  EditDashboard: {
    en: 'Edit dashboard',
    nb: 'Rediger dashbord',
  },
  DeleteActivityItem: {
    en: 'Remove from activities',
    nb: 'Fjern fra aktiviteter',
  },
  TranscriptionHelpText: {
    en: 'When you stop the recording of the meeting or upload an external audio file, the transcription is displayed here. If you have selected to save the audio file in the settings, the audio file will also be available here. You can search for specific words or phrases in the transcription.',
    nb: 'Når du stopper opptaket av møtet eller laster opp en ekstern lydfil, vises transkripsjonen her. Hvis du i innstillingene har valgt at lydfilen skal lagres, vil også lydfilen være tilgjengelig her. Du kan søke etter spesifikke ord eller setninger i transkripsjonen.',
  },
  MeetingNotesHelpText: {
    en: 'The meeting notes page shows an AI-generated summary of the meeting. The content is grouped by topics that AI has identified automatically. Under each topic you will find tasks, questions, decisions and risk elements that have also been suggested by AI.',
    nb: 'Referatet er en AI-generert oppsummering av møtet. Innholdet er gruppert etter emner som AI har identifisert automatisk. Under hvert emne finner du oppgaver, spørsmål, beslutninger og risikoelementer som også er foreslått av AI.',
  },
  MinutesHelpText: {
    en: `Here you will find a draft of the protocol based on the agenda that has been added to the meeting. AI suggests both a short and an extended protocol text. You can use one of the suggestions as is, or choose one and edit further. When you save, the protocol on the meeting card will be automatically updated.

    If AI has identified topics that cannot be directly linked to the agenda, you can show these by turning on the "Show new agenda item suggestions" switch. You can then choose to delete the suggestion, add it as an agenda item at the suggested location, or add it as a new agenda item at the bottom of the protocol.',
    `,
    nb: `Her finner du et utkast til protokoll basert på agendaen som er lagt inn på møtet. AI foreslår både en kort og en utvidet protokolltekst. Du kan bruke et av forslagene som det er, eller velge ett og redigere videre. Når du lagrer, blir protokollen på møtekortet automatisk oppdatert.

    Dersom AI har identifisert emner som ikke kan knyttes direkte til agendaen, kan du vise disse ved å slå på bryteren "Vis nye forslag til agendapunkter". Du kan da velge å slette forslaget, legge det inn som agendapunkt på den plasseringen som er foreslått, eller legge det inn som nytt agendapunkt nederst i protokollen.
  `,
  },
  DeleteAudioRecordingTitle: {
    en: 'Delete audio recording',
    nb: 'Slett opptak',
  },
  DeleteAudioRecordingText: {
    en: 'Are you sure you want to delete the audio recording?',
    nb: 'Er du sikker på at du vil slette opptaket?',
  },
  DeleteAudioRecording: {
    en: 'Delete audio recording',
    nb: 'Slett opptak',
  },
  EnableOtherOptionsForTranscriptionsWarning: {
    en: 'For transcriptions to be useful, you must also enable one or more of the options below.',
    nb: 'For å få nytte av transkribering må du også aktivere et eller flere av valgene under.',
  },
  AddAgendaItemHere: {
    en: 'Add here',
    nb: 'Legg til her',
  },
  StatisticsHelpText: {
    en: 'Here you will find statistics from the meeting. This includes speaking time statistics per participant, how long the different agenda items took to discuss and an overview of questions, risks, decisions and tasks that were identified in the meeting.',
    nb: 'Her finner du statistikk fra møtet. Dette inkluderer talestatistikk per deltaker, hvor lang tid de ulike agendapunktene tok å utrede og en oversikt over spørsmål, risikoer, beslutninger og oppgaver som ble identifisert i møtet.',
  },
  DeleteNotificationItem: {
    en: 'Delete notification',
    nb: 'Slett notifikasjonen',
  },
  DeleteSuggestion: {
    en: 'Delete suggestion',
    nb: 'Slett forslag',
  },
  AddAgendaItemToBottom: {
    en: 'Add to bottom',
    nb: 'Legg til nederst',
  },
  'access-control.People': {
    en: 'People',
    nb: 'Personer',
  },
  'orgbrain-layout.ServersAreLockedToolTip': {
    en: 'Server config is locked. Click to unlock',
    nb: 'Serverkonfigurasjon er låst. Klikk for å låse opp',
  },
  'user-credentials.TOTP2FASetupTitle': {
    en: 'TOTP 2FA',
    nb: '2FA ved bruk av app (TOTP)',
  },
  'user-credentials.SettingsSetTOTPUseExisitng': {
    en: 'Keep existing',
    nb: 'Bruk eksisterende',
  },
  'user-credentials.SettingsSetTOTPCreatenew': {
    en: ' new',
    nb: ' ny',
  },
  'user-credentials.TOTPScaninstructions': {
    en: 'Scan the QR code or manually enter the key below into your TOTP app',
    nb: 'Skann QR-koden eller skriv inn koden nedenfor manuelt i 2FA-appen',
  },
  'user-credentials.ShowSecretKey': {
    en: 'Show secret key',
    nb: 'Vis hemmelig nøkkel',
  },
  'user-credentials.TOTPKeyToolTip': {
    en: 'Click to copy key to your paste buffer.',
    nb: 'Klikk for å kopiere nøkkelen',
  },
  'user-credetials.TOTPEntercodeInstructions': {
    en: 'Enter the code generated by your app and click continue to enable TOTP 2FA',
    nb: 'Skriv inn koden fra appen, og klikk fortsett for å aktivere 2FA',
  },
  'user-credetials.PlaceholderTOTPCode': {
    en: 'Code',
    nb: 'Kode',
  },
  'register.TransferInviteDialogTitle': {
    en: 'Transfer invite',
    nb: 'Overfør invitasjon',
  },
  'register.Email': {
    en: 'Email',
    nb: 'E-post',
  },
  'register.TransferInviteExplanation': {
    en: 'NB! A e-mail with a login link will be sent from Orgbrain to the e-mail address you have entered.',
    nb: 'NB!  En e-post med innloggingslenke vil bli sendt fra Orgbrain til e-postadressen du har oppgitt.',
  },
  'register.TransferInviteSuccesTitle': {
    en: 'Your invite has been transfered.',
    nb: 'Din invitasjon er blitt overført.',
  },
  'register.TransferInviteSuccesBody1': {
    en: 'An invation email has been sent to',
    nb: 'En invitasjon er blitt sendt til',
  },
  'register.TransferInviteSuccesBody2': {
    en: 'using email',
    nb: 'på e-post',
  },
  'register.TransferInviteSuccesBody3': {
    en: 'Your previous email invitation is now invalid. If you have made an mistake transferring your invite you will need to contact Orgbrain.',
    nb: 'Dersom du angrer på denne overføringen må du ta kontakt med Orgbrain support.',
  },
  'register.TransferInviteSuccesBody4': {
    en: 'You can now close this window',
    nb: 'Du kan nå lukke dette vinduet',
  },
  'register.CreateUser': {
    en: 'Create user',
    nb: 'Opprett bruker',
  },
  TermsAnd: {
    en: 'and',
    nb: 'og',
  },
  MarketingCheckBoxConfirmation: {
    nb: 'Hold deg oppdatert med nyheter, tips og gratis webinarer fra Orgbrain.',
    en: 'Stay up to date with news, tips and free webinars from Orgbrain.',
  },
  'register.SubmitRegistration': {
    en: 'Sign up',
    nb: 'Registrer deg',
  },
  'register.RegistrerMedIdrettensId': {
    en: 'Register with Idrettens ID',
    nb: 'Registrer med Idrettens ID',
  },
  'register.EmailInviteIsInvalidTitle': {
    en: 'Email invite is invalid!',
    nb: 'E-postinvitasjon er ugyldig!',
  },
  'register.EmailInviteIsInvalidText': {
    en: 'This can happen if you have already registered OR your invite has expired. Please contact your system administrator for help.',
    nb: 'Dette kan skje hvis du allerede har registrert deg ELLER invitasjonen din har utløpt. Vennligst kontakt systemadministratoren din for hjelp.',
  },
  'register.ItIsNoUsePleaseStopTrying': {
    en: 'It is no use, please stop trying.',
    nb: 'Det nytter ikke.',
  },
  PermissionTableHeader: {
    en: 'Permission',
    nb: 'Tillatelse',
  },
  PermissionTableHeaderEnabled: {
    en: 'Enabled',
    nb: 'Aktiv',
  },
  PermissionTableHeaderPurchased: {
    en: 'Purchased',
    nb: 'Tilgjengelig i abonnement',
  },
  SearchNothingFound: {
    en: 'No files or folders match search',
    nb: 'Ingen filer eller mapper samsvarer med søk',
  },
  'filebrowser.or': {
    en: 'or',
    nb: 'eller',
  },
  'filebrowser.upload': {
    en: 'upload',
    nb: 'last opp',
  },
  'files.DenyOnDervied': {
    en: 'Derived Deny',
    nb: 'Avledet nekt',
  },
  'files.AllowOnDervied': {
    en: 'Derived Allow',
    nb: 'Avledet tillat',
  },
  'files.AllowOnParent': {
    en: 'Parent Allow',
    nb: 'Tillatelse til overordnet',
  },
  'document.VersionSecectorSigning': {
    en: 'Signing',
    nb: 'Signering',
  },
  'document.VersionSecectorComments': {
    en: 'Comments',
    nb: 'Kommentarer',
  },
  'document.VersionSecectorViewed': {
    en: 'Viewed',
    nb: 'Vist',
  },
  'document.VersionSecectorCreated': {
    en: 'Created',
    nb: 'Opprettet',
  },
  'document.VersionSecectorId': {
    en: 'Version',
    nb: 'Versjon',
  },
  'user-id.ValidationCodePlaceholder': {
    en: 'Code',
    nb: 'Kode',
  },
  'user-id.ValidateIdentitySMSInstructionsPre': {
    en: 'An SMS message will be sent to your phone.',
    nb: 'En SMS vil bli sendt til din telefon.',
  },
  'user-id.ValidateIdentitySMSInstructions': {
    en: 'An SMS message has been sent to your phone. Please enter this code to validate your identity.',
    nb: 'En SMS med en kode er sendt til din telefon. Skriv inn denne koden for å bekrefte identiteten din.',
  },
  'user-id.ResendSMSCode': {
    en: 'Resend Code',
    nb: 'Ny Kode',
  },
  'user-id.NewMobilePhonePlaceholder': {
    en: 'New number',
    nb: 'Nytt nummer',
  },
  'user-id.MobilePhonePlaceholder': {
    en: 'Phone number',
    nb: 'Mobiltelefon',
  },
  'phone-settings.MobilePhonePlaceholder': {
    en: 'Phone number',
    nb: 'Mobiltelefon',
  },
  'user-id.IdentityVerfificationWaitingForBankid': {
    en: 'Waiting for you to sign into bankid in popup',
    nb: 'Benytter BankID for 2FA ... . venter på at du skal logge på',
  },
  'user-id.IdentityVerfificationMethod': {
    en: 'Select Method',
    nb: 'Velg metode',
  },
  UserPermissionChangeReloadHeader: {
    en: 'Permissions have changed.',
    nb: 'Tilganger er blitt endret.',
  },
  UserPermissionChangeReloadNowBody: {
    en: 'Your user permissions have been changed (probably by an organization admininistrator). You should reload this web page to avoid problems.',
    nb: 'Brukertilgangene dine er endret (sannsynligvis av en administrator). Du bør laste inn denne nettsiden på nytt for å unngå problemer.',
  },
  'files.SearchNothingFound': {
    en: 'No files or folders match search',
    nb: 'Ingen filer eller mapper samsvarer med søk',
  },
  'investments.EmissionNoLongerExists': {
    en: 'Emission no longer exists or you are not part of it.',
    nb: 'Kapitalforhøyelsen eksisterer ikke lenger, eller så er du ikke del av kapitalforhøyelsen lenger.',
  },
  'investments.EmissionNoLongerExistsTwo': {
    en: 'Contact your administrator for further information.',
    nb: 'Kontakt administratoren for mer informasjon.',
  },
  helpTextAgendaOption: {
    en: 'Orgbrain will automatically include recommended agenda items for your meetings. These will vary depending on the number of meetings. You may modify the agenda items later.',
    nb: 'Orgbrain vil automatisk legge ved anbefalte agendapunkter til møtene dine. Disse vil variere avhengig av antall møter. Du kan alltid endre på disse senere. ',
  },
  helpTextAgendaOption2: {
    en: 'Deselect this if you would prefer to select your own agenda points from scratch.',
    nb: 'Fjern merket dersom du ønsker å velge dine egne agendapunkter fra bunnen av.',
  },
  'meetings.setParticipantStatusFor': {
    en: 'Set participant status for',
    nb: 'Legg inn deltakerstatus for',
  },
  'meetings.PreVoting': {
    en: 'Pre-voting',
    nb: 'Forhåndsstemme',
  },
  'meetings.AllowPreVoting': {
    en: 'Allow pre-voting',
    nb: 'Tillat å forhåndsstemme',
  },
  'meetings.HideChatIcon': {
    en: 'Hide chat icon',
    nb: 'Skjul chatikon',
  },
  'meetings.orderBy': {
    en: 'Order by',
    nb: 'Sorter etter',
  },
  'meetings.most-used-order': {
    en: 'Most used',
    nb: 'Mest brukt',
  },
  'meetings.alphabeticOrder': {
    en: 'Alphabetic',
    nb: 'Alfabetisk',
  },
  'meetings.ShowAllMinutes': {
    en: 'Show all',
    nb: 'Vis alt',
  },
  'meetings.hasVoted': {
    en: 'has voted',
    nb: 'har stemt',
  },
  'meetings.for_voting': {
    en: 'For',
    nb: 'For',
  },
  'meetings.against_voting': {
    en: 'Against',
    nb: 'Imot',
  },
  TrustedDeviceDialogPart3: {
    en: 'Device name',
    nb: 'Enhets navn',
  },
  'login-dialog.SignIntoOrgbrain2FAHeader': {
    en: '2FA Sign into Orgbrain',
    nb: 'Logg inn ved bruk av 2FA',
  },
  'login-dialog.CodeLabel': {
    en: 'Code',
    nb: 'Kode',
  },
  'login-dialog.ResendSMSCode': {
    en: 'Resend code',
    nb: 'Ny kode',
  },
  'login-dialog.Login': {
    en: 'Login',
    nb: 'Logg inn',
  },
  'login-dialog.UseSMS2FAButton': {
    en: 'Use SMS for 2FA',
    nb: 'Benytt SMS for 2FA',
  },
  'login-dialog.UseBankid2FAButton': {
    en: 'Use BankID 2FA',
    nb: 'Benytt tofaktorautentisering (2FA) ved bruk av BankID',
  },
  'login-dialog.UseTOTP2FAButton': {
    en: 'Use TOTP 2FA',
    nb: 'Benytt app (TOTP) for 2FA',
  },
  'login-dialog.ItsNoUseStopTrying': {
    en: 'It is no use, please stop trying.',
    nb: 'Det er ingen vits, vennligst slutt å prøve.',
  },
  'login-dialog.PasswordExpiredHelpMessage': {
    en: 'Please contact your system administrator for help.',
    nb: 'Kontakt systemansvarlig for å få hjelp',
  },
  'login-dialog.SendEmail': {
    en: 'Send email',
    nb: 'Send epost',
  },
  'login-dialog.TemporaryPasswordHasExpired': {
    en: 'Temporary password has expired',
    nb: 'Midlertidig passord er utløpt',
  },
  'login-dialog.SignIntoOrgbrainHeader': {
    en: 'Sign into Orgbrain',
    nb: 'Logg inn',
  },
  'login-dialog.ResetYourPasswordHeader': {
    en: 'Reset your password',
    nb: 'Tilbakestill passordet ditt',
  },
  'login-dialog.RecoveryLinkSentIfAccountExists': {
    en: 'If there is an account for your email a recovery link will have been sent.',
    nb: 'Hvis det er opprettet en konto med din e-postadresse, vil en gjenopprettingslink ha blitt sendt.',
  },
  'login-dialog.ResetPasswordDescription': {
    en: 'Enter your email address and we will send you a recovery link to reset your password.',
    nb: 'Skriv inn e-postadressen din, så sender vi deg en link for å tilbakestille passordet ditt.',
  },
  'login-dialog.Email': {
    en: 'Email',
    nb: 'E-postadresse',
  },
  'login-dialog.ForgotPassword': {
    en: 'Forgot password',
    nb: 'Glemt passord',
  },
  AcceptTransfer: {
    en: 'Accept transfer?',
    nb: 'Godta overføring?',
  },
  'self-service.acceptTermsText1': {
    en: 'I have read and accept the',
    nb: 'Jeg har lest og godtar',
  },
  'self-service.acceptTermsText2': {
    en: 'terms of use',
    nb: 'brukervilkårene',
  },
  'self-service.acceptTermsText5': {
    en: 'privacy policy',
    nb: 'personvernbetingelsene',
  },
  'self-service.acceptTermsText6': {
    en: 'and I give my consent to store the information specified in the',
    nb: 'og gir mitt samtykke til å lagre informasjonen spesifisert i',
  },
  'self-service.acceptTermsText7': {
    en: 'guidelines',
    nb: 'retningslinjene',
  },
  UploadTemplate: {
    en: 'Upload spreadsheet',
    nb: 'Last opp regneark',
  },
  UploadTemplateText: {
    en: "Upload a spreadsheet that contains the company's shareholderregister.",
    nb: 'Last opp et regneark som inneholder foretakets aksjeeierbok. Her finner du også mal for regnearket.',
  },
  AcademyTitle: {
    en: 'Academy',
    nb: 'Academy',
  },
  AcademyExam: {
    en: 'Exam',
    nb: 'Eksamen',
  },
  AcademyQuiz: {
    en: 'Quiz',
    nb: 'Quiz',
  },
  AcademyGuides: {
    en: 'Guides',
    nb: 'Veiledere',
  },
  AcademyProfile: {
    en: 'Profile',
    nb: 'Min side',
  },
  AcademyWebinars: {
    en: 'Webinars',
    nb: 'Webinarer',
  },
  AcademyBoardSchool: {
    en: 'Board School',
    nb: 'Styreskolen',
  },
  AcademyBoardBlog: {
    en: 'Board Blog',
    nb: 'Styrebloggen',
  },
  GoToAcademyBoardBlog: {
    en: 'Go to Academy Board Blog',
    nb: 'Gå til styrebloggen',
  },
  AcademyTemplates: {
    en: 'Templates',
    nb: 'Maler',
  },
  AcademyResults: {
    en: 'See Results',
    nb: 'Se resultat',
  },
  TemplateEditDocument: {
    en: 'Edit document again',
    nb: 'Rediger dokumentet på nytt',
  },
  TemplateShowPdf: {
    en: 'Show PDF',
    nb: 'Vis PDF',
  },
  TemplateViewFolder: {
    en: 'View folder in data room',
    nb: 'Se dokument i datarom',
  },
  TemplateAmountCreated: {
    en: 'Documents created from this template',
    nb: 'Dokumenter opprettet fra denne malen',
  },
  MakeNewDocument: {
    en: 'Make new document',
    nb: 'Lag nytt dokument',
  },
  TemplateInfoTitle: {
    en: 'How it works',
    nb: 'Slik fungerer det',
  },
  TemplateInfo1: {
    en: 'Select the template you want to use',
    nb: 'Velg malen du ønsker å benytte',
  },
  TemplateInfo2: {
    en: 'Enter your information in the form fields',
    nb: 'Legg inn dine opplysninger i skjemafeltene',
  },
  TemplateInfo3: {
    en: 'You can then edit the template text',
    nb: 'Du kan deretter redigere selve malteksten',
  },
  TemplateInfo4: {
    en: 'Users with administrator access can now finalize the PDF and save the form in the Data Room. ',
    nb: 'De som er gitt admin-tilgang, kan nå ferdigstille PDF og lagre skjemaet i datarommet. Øvrige brukere kan kopiere teksten til et tekstdokument for ferdigstillelse.',
  },
  TemplateCreate: {
    en: 'Create Document from Template',
    nb: 'Lag dokument fra mal',
  },
  TemplateNoCreated: {
    en: 'No saved templates yet',
    nb: 'Ingen lagrede maler ennå',
  },
  NoTemplates: {
    en: 'No templates yet',
    nb: 'Ingen maler ennå',
  },
  YourTemplates: {
    en: 'Your Documents',
    nb: 'Dine dokumenter',
  },
  CertificateLinkedin: {
    en: 'Share certificate on LinkedIn',
    nb: 'Del kursbevis på LinkedIn',
  },
  DownloadCertificate: {
    en: 'Download Certificate',
    nb: 'Last ned diplom',
  },
  RetakeExam: {
    en: 'Retake Exam',
    nb: 'Ta eksamen på nyt',
  },
  ReadyForExam: {
    en: 'Exam will open when all modules are completed',
    nb: 'Eksamen åpnes når alle modulene er fullført',
  },
  SurveyAnswers: {
    en: 'Total answers:',
    nb: 'Antall svar:',
  },
  SurveysConfirmMergeSection: {
    en: 'Section name already exists - quesions will be merged with existing section',
    nb: 'Seksjon eksisterer - Spørsmålene blir lagt til i eksisterende seksjon',
  },
  SurveysConfirmMergeSectionSingle: {
    en: 'Section name already exists - this question will be added to the exixting section',
    nb: 'Seksjon eksisterer - Dette spørsmålet vil bli lagt til i eksisterende seksjon',
  },
  SurveysTotalQuestions: {
    en: 'Total Questions',
    nb: 'Antall spørsmål',
  },
  SurveysTotalSections: {
    en: 'Total Sections',
    nb: 'Antall seksjoner',
  },
  SurveysTitlePlaceholder: {
    en: 'Survey',
    nb: 'Undersøkelse',
  },
  SurveysCopySurvey: {
    en: 'Copy Survey',
    nb: 'Kopier skjema',
  },
  SurveysMoveQuestion: {
    en: 'Move to different section',
    nb: 'Flytt til annen seksjon',
  },
  SurveysSaveSection: {
    en: 'Save',
    nb: 'Lagre',
  },
  SurveysAddSection: {
    en: 'Add Section',
    nb: 'Legg til seksjon',
  },
  SurveysManagerText: {
    en: 'This is an overview of the questions and answers for this survey.',
    nb: 'Nedenfor kan du se alle spørsmålene og svaralternativene for denne undersøkelsen.',
  },
  SurveysSelectParticipants: {
    en: 'Select participants',
    nb: 'Velg deltakere',
  },
  SurveysChooseVisability: {
    en: 'Public or anonymous survey?',
    nb: 'Anonym eller åpen undersøkelse?',
  },
  SurveysAnonymous: {
    en: 'Anonymous',
    nb: 'Anonym',
  },
  FreeForm: {
    en: 'Free Form alternative',
    nb: 'Svar med fritekst',
  },

  ExtraFreeForm: {
    en: 'Additional Free Form',
    nb: 'Utdypende fritekst',
  },
  ExtraFreeFormHelpText: {
    en: 'Add an additional free text answer for the question.',
    nb: 'Legg til et utdypende fritekst svar til spørsmålet. Du må fortsatt velge et svaralternativ, og fritekstsvarene vises i tillegg til multiple choice-svarene.',
  },
  AllowExtraFreeForm: {
    en: 'Allow an Additional Free Form',
    nb: 'Tillat ekstra fritekst',
  },
  ExtraFreeFormTooltip: {
    en: 'Enable an additional free text answer for each question.',
    nb: 'Her kan du la deltakerne skrive et tilleggssvar som fritekst. De må fortsatt velge et svaralternativ, og fritekstsvarene vises i tillegg til multiple choice-svarene.',
  },
  SurveysPublic: {
    en: 'Public',
    nb: 'Åpen',
  },
  SurveysPublicText: {
    en: '<span style="color:#F57C00;">The survey is public. Your name will be visible together with the answers.<span>',
    nb: '<span style="color:#F57C00;">Undersøkelsen er offentlig. Ditt navn vil være synlig sammen med svarene.<span>',
  },
  SurveysPrivateText: {
    en: '<span style="color:#F57C00;">The survey is anonymous<span>',
    nb: '<span style="color:#F57C00;">Undersøkelsen er anonym<span>',
  },
  SurveysDialogTitle: {
    en: 'Invitation sent!',
    nb: 'Invitasjon sendt!',
  },
  SurveysDialogText: {
    en: 'The invitation has now been sent to the participants.',
    nb: 'Invitasjonen er nå sendt til deltakerne.',
  },
  SurveysUpdatedAt: {
    en: 'Updated At',
    nb: 'Sist oppdatert',
  },
  Allocation: {
    en: 'Allocation',
    nb: 'Tildeling',
  },
  AddAllocatedInvestor: {
    en: 'Add Allocated Investor',
    nb: 'Legg til forhåndsfylt investor',
  },
  MinIssues: {
    en: 'Minimum number of shares',
    nb: 'Miimum antall aksjer',
  },
  DownloadTableAsSpreadsheet: {
    en: 'Download table as spreadsheet',
    nb: 'Last ned tabell som regneark',
  },
  AmountOfInvestors: {
    en: 'Amount of Investors signed',
    nb: 'Antall signerte investorer',
  },
  AmountInvited: {
    en: 'Amount of Invited Investors',
    nb: 'Antall inviterte investorer',
  },
  EmissionNewInvestor: {
    en: 'New Investor',
    nb: 'Ny investor',
  },
  EmissionInvestorHelp1: {
    en: 'Here you can invite investors to participate in the share issue. You can add completely new investors manually, invite investors from the user list (for example, existing shareholders), upload investors from a spreadsheet, or manually register investors who have signed up in a way other than through this solution.',
    nb: 'Her kan du invitere investorer til å delta i kapitalforhøyelsen. Du kan legge til helt nye investorer manuelt, invitere investorer fra brukerlisten (for eksempel eksisterende aksjeeiere), laste opp investorer fra et regneark, eller manuelt registrere investorer som har tegnet seg på annen måte enn via denne løsningen.',
  },
  EmissionInvestorHelp2: {
    en: 'You can invite investors in multiple rounds and send reminders to those who have not yet signed the order.',
    nb: 'Du kan invitere investorer i flere omganger og sende påminnelser til dem som ennå ikke har signert bestillingen.',
  },
  EmissionInvestorHelp3: {
    en: 'As soon as an investor is invited, they will receive an email. When the investor logs in, they will first be taken to a page where they are asked to confirm that the company has registered the correct information about them. They will then gain access to the order form and any attachments. If the investor wishes to participate in the share issue, they fill in the desired number of shares and sign the agreement digitally.',
    nb: 'Så snart en investor er invitert, mottar vedkommende en e-post. Når investoren logger inn, kommer de først til en side der de bes bekrefte at selskapet har registrert riktig informasjon om dem. Deretter får de tilgang til bestillingsblanketten og eventuelle vedlegg. Ønsker investoren å delta i kapitalforhøyelsen, fyller vedkommende inn ønsket antall aksjer og signerer avtalen digitalt.',
  },
  EmissionInvestorHelp4: {
    en: 'As investors sign the order forms, you as the administrator will have full oversight of all incoming orders, including a copy of the signed form.',
    nb: 'Etter hvert som investorer signerer bestillingsblankettene, får du som administrator full oversikt over alle innkommende bestillinger, inkludert kopi av signert blankett',
  },
  EmissionInvestorHelp5: {
    en: 'You can read more about how share issues work on our support page.',
    nb: 'Du kan lese mer om hvordan kapitalforhøyelse fungerer på vår supportside.',
  },
  EmissionInfoTitle1: {
    en: 'Explanation of the share issue function',
    nb: 'Forklaring av funksjonen for kapitalforhøyelse',
  },
  EmissionInfoTitle2: {
    en: 'This is how it works',
    nb: 'Slik fungerer løsningen',
  },
  EmissionInfo: {
    en: 'Here you can create and invite investors to participate in a share issue. You can either create a new share issue, clone a previous one, or register an already completed share issue. This ensures that the event register and shareholder register are correctly updated.',
    nb: 'Her kan du opprette og invitere investorer til å delta i en kapitalforhøyelse. Du kan enten opprette en ny kapitalforhøyelse, klone en tidligere kapitalforhøyelse eller etterregistrere en allerede gjennomført kapitalforhøyelse. Dette sikrer at hendelsesregisteret og aksjeeierboken blir korrekt oppdatert.',
  },
  EmissionInfoLink: {
    en: 'You can read more about how share issues work on our support page.',
    nb: 'Du kan lese mer om hvordan kapitalforhøyelse fungerer på vår supportside.',
  },
  EmissionInfoBold1: {
    en: 'Choose how you want to get started',
    nb: 'Velg hvordan du vil komme i gang',
  },
  EmissionInfo1: {
    en: 'Start with a new share issue, clone a previous one, or register one that has already been completed.',
    nb: 'Start med en ny kapitalforhøyelse, klon en tidligere, eller etterregistrer en som allerede er gjennomført.',
  },
  EmissionInfoBold2: {
    en: 'Register key information',
    nb: 'Registrer nøkkelopplysninger',
  },
  EmissionInfo2: {
    en: 'For a new share issue, you enter information such as the subscription price, payment account, and other relevant information.',
    nb: 'Ved ny kapitalforhøyelse legger du inn informasjon som tegningskurs, betalingskonto og annen relevant informasjon.',
  },
  EmissionInfoBold3: {
    en: 'Upload documents',
    nb: 'Last opp dokumenter',
  },
  EmissionInfo3: {
    en: 'Generate a share issue order form based on a template from Orgbrain, and upload any attachments you wish to share with the investors (e.g., shareholder agreement, articles of association).',
    nb: 'Generer en bestillingsblankett basert på mal fra Orgbrain, og last opp eventuelle vedlegg du ønsker å dele med investorene (f.eks. aksjonæravtale, vedtekter).',
  },
  EmissionInfoBold4: {
    en: 'Invite investors',
    nb: 'Inviter investorer',
  },
  EmissionInfo4: {
    en: 'Select investors from the shareholder register, or add new ones. The invited will receive an email with a login link to a dedicated investor area, where they can access the order form and any attachments. You can also register an investor without sending an invitation.',
    nb: 'Velg investorer fra aksjeeierboken, eller legg til nye. De inviterte mottar en e-post med innloggingslenke til et eget investorområde, hvor de får tilgang til bestillingsblankett og eventuelle vedlegg. Du kan også etterregistrere en investor uten å sende invitasjon',
  },
  EmissionInfoBold5: {
    en: 'Allocation and signing',
    nb: 'Tegning og signering',
  },
  EmissionInfo5: {
    en: 'The investors fill out the desired number of shares and sign digitally.',
    nb: 'Investorene fyller ut ønsket antall aksjer og signerer digitalt.',
  },
  EmissionInfoBold6: {
    en: 'Ongoing overview',
    nb: 'Løpende oversikt',
  },
  EmissionInfo6: {
    en: 'You will have an ongoing overview of received orders and interest from investors.',
    nb: 'Du får fortløpende oversikt over mottatte bestillinger og interesse fra investorer.',
  },
  EmissionInfoBold7: {
    en: 'Allocation of shares',
    nb: 'Tildeling av aksjer',
  },
  EmissionInfo7: {
    en: 'When the subscription period is over, or all orders have been received, shares can be allocated.',
    nb: 'Når tegningsfristen er utløpt, eller alle bestillinger er mottatt, kan aksjer tildeles.',
  },
  EmissionInfoBold8: {
    en: 'Generating decisions',
    nb: 'Generering av vedtak',
  },
  EmissionInfo8: {
    en: 'The solution prepares proposals for resolutions for the board meeting or general meeting (depending on the power of attorney structure).',
    nb: 'Løsningen utarbeider forslag til vedtak for styremøte eller generalforsamling (avhengig av fullmaktsstruktur).',
  },
  EmissionInfoBold9: {
    en: 'Payment',
    nb: 'Innbetaling',
  },
  EmissionInfo9: {
    en: 'It is easy to automatically send out messages with payment details to all who have signed up, while keeping track of who has paid.',
    nb: 'Det er enkelt å sende ut meldinger med betalingsdetaljer automatisk til alle som har tegnet seg, og samtidig holde oversikt over hvem som har betalt.',
  },
  EmissionInfoBold10: {
    en: 'Update',
    nb: 'Oppdatering',
  },
  EmissionInfo10: {
    en: 'When the payments are confirmed and the share issue is registered in the Register of Business Enterprises, the shareholder register is automatically updated. The investors then receive a notification that they have been entered into the register.',
    nb: 'Når innbetalingene er bekreftet og kapitalforhøyelsen er registrert i Foretaksregisteret, oppdateres aksjeeierboken automatisk. Investorene får deretter melding om at de er innført i boken.',
  },
  StartTourGuide: {
    en: 'Start Tour Guide',
    nb: 'Start produktomvisning',
  },
  DashboardTourTitle: {
    en: 'Get to know Orgbrain',
    nb: 'Bli kjent med Orgbrain',
  },
  DashboardTourDesc: {
    en: 'Would you like a quick introduction to the homepage and the key features of the portal? It only takes a couple of minutes. You can restart the product tour at any time by clicking on the question mark (?) in the upper right corner.',
    nb: 'Vil du ha en rask introduksjon til startsiden og de viktigste funksjonene i portalen? Det tar bare et par minutter. Du kan når som helst starte produktomvisningen på nytt ved å klikke på spørsmålstegnet (?) øverst til høyre.',
  },

  DontShowAgain: {
    en: "Don't Show Again",
    nb: 'Ikke vis igjen',
  },
  TourGuides: {
    en: 'Tour Guides',
    nb: 'Produktomvisninger',
  },
  AcademyBoardSchoolSteps: {
    en: 'Academy Board School',
    nb: 'Academy Styreskolen',
  },
  AcademyTemplatesSteps: {
    en: 'Academy Templates',
    nb: 'Academy Maler',
  },
  TasksCreateSteps: {
    en: 'Create Task',
    nb: 'Opprett oppgave',
  },
  TasksSteps: {
    en: 'Tasks',
    nb: 'Oppgaver',
  },
  FilesSteps: {
    en: 'Files',
    nb: 'Filer',
  },
  UnknownUserFirstName: {
    en: 'Unknown',
    nb: 'Ukjent',
  },
  UnknownUserLastName: {
    en: 'user',
    nb: 'bruker',
  },
  UnknownUserName: {
    en: 'Unknown user',
    nb: 'Ukjent bruker',
  },
  DashboardSteps: {
    en: 'Dashboard',
    nb: 'Dashbord',
  },
  DashbboardBoardmemberSteps: {
    en: 'Dashboard (Board Member)',
    nb: 'Dashbord (Styremedlem)',
  },
  DashboardAdminSteps: {
    en: 'Dashboard (Admin)',
    nb: 'Dashbord (Admin)',
  },
  TourAcademyBoardschoolTitle1: {
    en: 'Academy',
    nb: 'Academy',
  },
  TourAcademyBoardschoolDesc1: {
    en: 'Welcome to the Academy module',
    nb: 'Velkommen til Academy modulen',
  },
  TourAcademyBoardschoolTitle2: {
    en: 'Sections',
    nb: 'Seksjoner',
  },
  TourAcademyBoardschoolDesc2: {
    en: 'The academy is divided into different sections',
    nb: 'Akademiet er delt inn i forskjellige seksjoner',
  },

  TourAcademyBoardschoolTitle3: {
    en: 'Boardschool',
    nb: 'Styreskolen',
  },
  TourAcademyBoardschoolDesc3: {
    en: 'The first section is the boardschool',
    nb: 'Den første seksjonen er styreopplæringen',
  },

  TourAcademyBoardschoolTitle4: {
    en: 'Courses',
    nb: 'Kurs',
  },
  TourAcademyBoardschoolDesc4: {
    en: 'The boardschool consists of 20 courses',
    nb: 'Styreskolen består av 20 kurs',
  },

  TourAcademyBoardschoolTitle5: {
    en: 'Course',
    nb: 'Kurs',
  },
  TourAcademyBoardschoolDesc5: {
    en: 'Each section has a takes you through a topic',
    nb: 'Hver seksjon tar deg gjennom et tema',
  },

  TourAcademyBoardschoolTitle6: {
    en: 'Search',
    nb: 'Søk',
  },
  TourAcademyBoardschoolDesc6: {
    en: 'You can also search through the contents each section',
    nb: 'Du kan også søke i innholdet i hver seksjon',
  },

  TourAcademyBoardschoolTitle7: {
    en: 'Quiz',
    nb: 'Quiz',
  },
  TourAcademyBoardschoolDesc7: {
    en: 'Take a quiz to test your knowledge',
    nb: 'Ta en quiz for å teste kunnskapen din',
  },

  TourAcademyBoardschoolTitle8: {
    en: 'Exam',
    nb: 'Eksamen',
  },
  TourAcademyBoardschoolDesc8: {
    en: 'Take the exam when you are ready',
    nb: 'Ta eksamen når du er klar',
  },
  TourAcademyTemplatesTitle1: {
    en: 'Templates',
    nb: 'Maler',
  },
  TourAcademyTemplatesDesc1: {
    en: 'This is the templates section',
    nb: 'Dette er maler-seksjonen',
  },
  TourAcademyTemplatesTitle2: {
    en: 'Predefined Templates',
    nb: 'Forhåndsdefinerte maler',
  },
  TourAcademyTemplatesDesc2: {
    en: 'You can create a document from one of our predefined templates',
    nb: 'Du kan opprette et dokument fra en av våre forhåndsdefinerte maler',
  },
  TourAcademyTemplatesTitle3: {
    en: 'Your Documents',
    nb: 'Dine dokumenter',
  },
  TourAcademyTemplatesDesc3: {
    en: 'Clicking on a template will open a list of your documents',
    nb: 'Klikk på en mal for å åpne en liste over dine dokumenter',
  },
  TourAcademyTemplatesTitle4: {
    en: 'Create a New Document',
    nb: 'Opprett et nytt dokument',
  },
  TourAcademyTemplatesDesc4: {
    en: 'You can create a new document from the template you selected',
    nb: 'Du kan opprette et nytt dokument fra malen du valgte',
  },
  TourFilesTitle1: {
    en: 'Files',
    nb: 'Datarom',
  },
  TourFilesDesc1: {
    en: 'Welcome to the Files module',
    nb: 'Velkommen til Datarom-modulen',
  },
  TourFilesTitle2: {
    en: 'Files Overview',
    nb: 'Oversikt over filer',
  },
  TourFilesDesc2: {
    en: 'Here you can see an overview of the organization files',
    nb: 'Her kan du se en oversikt over organisasjonens filer',
  },
  TourFilesTitle3: {
    en: 'Folders',
    nb: 'Mapper',
  },
  TourFilesDesc3: {
    en: 'Entering a folder will show you all the files within that folder',
    nb: 'Å gå inn i en mappe viser deg alle filer i den mappen',
  },
  TourFilesTitle4: {
    en: 'Search',
    nb: 'Søk',
  },
  TourFilesDesc4: {
    en: 'You can search for files by name or type',
    nb: 'Du kan søke etter filer med navn eller type',
  },
  TourTasksTitle1: {
    en: 'Tasks',
    nb: 'Oppgaver',
  },
  TourTasksDesc1: {
    en: 'Welcome to the Tasks module',
    nb: 'Velkommen til Oppgaver-modulen',
  },
  TourTasksTitle2: {
    en: 'Tasks Overview',
    nb: 'Oppgaveoversikt',
  },
  TourTasksDesc2: {
    en: 'Here you can manage the tasks of your organization',
    nb: 'Her kan du administrere oppgavene i organisasjonen din',
  },
  TourTasksTitle3: {
    en: 'Filter Options',
    nb: 'Filtervalg',
  },
  TourTasksDesc3: {
    en: 'You can select different filters and views of the tasks',
    nb: 'Du kan velge ulike filtre og visninger av oppgavene',
  },
  TourTasksTitle4: {
    en: 'Tasks',
    nb: 'Oppgaver',
  },
  TourTasksDesc4: {
    en: 'The list of tasks are shown here -- ordered by your filter settings',
    nb: 'Listen over oppgaver vises her – sortert etter dine filterinnstillinger',
  },
  TourTasksTitle5: {
    en: 'Search',
    nb: 'Søk',
  },
  TourTasksDesc5: {
    en: 'Use the search field to search for specific tasks',
    nb: 'Bruk søkefeltet for å finne spesifikke oppgaver',
  },
  TourTasksTitle6: {
    en: 'Conditions',
    nb: 'Betingelser',
  },
  TourTasksDesc6: {
    en: 'Filter the tasks based on the following condutions: <list of conditions>',
    nb: 'Filtrer oppgavene basert på følgende betingelser: <liste over betingelser>',
  },
  TourTasksTitle7: {
    en: 'Tags',
    nb: 'Merkelapper',
  },
  TourTasksDesc7: {
    en: 'Filter the tasks based on the following tags: <list of tags>',
    nb: 'Filtrer oppgavene basert på følgende merkelapper: <liste over tagger>',
  },
  TourTasksTitle8: {
    en: 'Create Task',
    nb: 'Opprett oppgave',
  },
  TourTasksDesc8: {
    en: 'Create a new task by clicking here',
    nb: 'Opprett en ny oppgave ved å klikke her',
  },
  TourTasksCreateTitle1: {
    en: 'Create Task',
    nb: 'Opprett oppgave',
  },
  TourTasksCreateDesc1: {
    en: 'In this module, you can create a new task',
    nb: 'I denne modulen kan du opprette en ny oppgave',
  },
  TourTasksCreateTitle2: {
    en: 'Title',
    nb: 'Tittel',
  },
  TourTasksCreateDesc2: {
    en: 'Create a title for your new task',
    nb: 'Sett en tittel for den nye oppgaven',
  },
  TourTasksCreateTitle3: {
    en: 'Description',
    nb: 'Beskrivelse',
  },
  TourTasksCreateDesc3: {
    en: 'Describe the task',
    nb: 'Beskriv oppgaven som skal utføres',
  },
  TourTasksCreateTitle4: {
    en: 'Options',
    nb: 'Valg',
  },
  TourTasksCreateDesc4: {
    en: 'Explore the optiohns and settings for your new task',
    nb: 'Utforsk valg og innstillinger for den nye oppgaven',
  },
  TourTasksCreateTitle5: {
    en: 'Save Task',
    nb: 'Lagre oppgave',
  },
  TourTasksCreateDesc5: {
    en: 'Save the task when you are done',
    nb: 'Lagre oppgaven når du er ferdig',
  },

  TourDashboardTitle1: {
    en: 'Product Tour',
    nb: 'Produktomvisning',
  },
  TourDashboardDesc1: {
    en: 'Here you will get a quick introduction to the dashboard in Orgbrain. We will show you where to find important information and features that help the board work more efficiently and structured. (You can use the arrow keys to navigate back and forward)',
    nb: 'Her får du en rask introduksjon til startsiden (“Dashboardet”) i Orgbrain. Vi viser deg hvor du finner viktig informasjon og funksjoner som hjelper styret å jobbe mer effektivt og strukturert. (Du kan bruke piltastene for å navigere frem og tilbake)',
  },
  TourDashboardTitle2: {
    en: 'Quick Access Menu',
    nb: 'Hurtigmeny',
  },
  TourDashboardDesc2: {
    en: 'The access to features in the portal depends on the subscription your organization has, and the role you have. The features are organized in modules that you can easily open via the quick access menu.',
    nb: 'Tilgangen din til funksjoner i portalen avhenger av hvilket abonnement organisasjonen har, og hvilken rolle du har. Funksjonene er organisert i moduler som du enkelt kan åpne via hurtigmenyen.',
  },
  TourDashboardTitle3: {
    en: 'Side Menu',
    nb: 'Venstremeny',
  },
  TourDashboardDesc3: {
    en: 'You can find the same features in the left side menu.',
    nb: 'De samme funksjonene finner du også i venstremenyen.',
  },
  TourDashboardTitle4: {
    en: 'Search Field',
    nb: 'Søkefelt',
  },
  TourDashboardDesc4: {
    en: 'Use the search field to find features and other relevant information.',
    nb: 'Bruk søkefeltet for å finne funksjoner og annen relevant informasjon.',
  },
  TourDashboardTitle5: {
    en: 'Meetings',
    nb: 'Møter',
  },
  TourDashboardDesc5: {
    en: 'The meeting module is used to create, manage and conduct meetings in the portal – whether it is board meetings, general meetings or other company meetings.',
    nb: 'Møtemodulen brukes til å opprette, administrere og gjennomføre møter i portalen – enten det er styremøter, generalforsamlinger eller andre selskapsmøter.',
  },
  TourDashboardTitle6: {
    en: 'Owners',
    nb: 'Eiere',
  },
  TourDashboardDesc6: {
    en: 'This module contains all functionality for managing and administering owners, including shareholder register, transactions, capital increases, and similar.',
    nb: 'Denne modulen inneholder all funksjonalitet for oppfølging og administrasjon av eiere, inkludert aksjeeierregister, transaksjoner, kapitalforhøyelser og lignende.',
  },
  TourDashboardTitle7: {
    en: 'Communication',
    nb: 'Kommunikasjon',
  },
  TourDashboardDesc7: {
    en: 'Here you can safely and easily communicate with the board, owners, individual users, and custom private chat groups. You can also create contact groups that allow different stakeholders to communicate with the organization. Additionally, you can send out reports and messages.',
    nb: 'Her kan du trygt og enkelt kommunisere med styret, eiere, enkeltbrukere og egendefinerte private chatgrupper. Du kan også opprette kontaktgrupper som gjør det mulig for ulike interessenter å kommunisere med virksomheten. I tillegg kan du sende ut rapporter og meldinger.',
  },
  TourDashboardTitle8: {
    en: 'Data Room',
    nb: 'Datarom',
  },
  TourDashboardDesc8: {
    en: 'In the data room, you can create folders, store files, and assign different access levels. You can also share folders across organizations and create signing requests. All files created in connection with meetings are automatically stored in a structured manner in the data room.',
    nb: 'I datarommet kan du opprette mapper, lagre filer og tildele ulike tilgangsnivåer. Du kan også dele mapper på tvers av organisasjoner og opprette signeringsforespørsler. Alle filer som opprettes i forbindelse med møter, blir automatisk lagret på en strukturert måte i datarommet.',
  },
  TourDashboardTitle9: {
    en: 'Tasks',
    nb: 'Oppgaver',
  },
  TourDashboardDesc9: {
    en: 'This module contains functionality for tracking and managing tasks and other matters that need to be followed up, including decisions from board meetings.',
    nb: 'Denne modulen inneholder funksjonalitet for oppfølging og administrasjon av oppgaver og andre saker som skal følges opp, inkludert vedtak fra styremøter.',
  },
  TourDashboardTitle10: {
    en: 'Surveys',
    nb: 'Undersøkelser',
  },
  TourDashboardDesc10: {
    en: 'Here you can create and manage surveys, such as board evaluations, CEO evaluations, meeting evaluations, or other types of surveys. You can use ready-made templates from Orgbrain or create your own.',
    nb: 'Her kan du gjennomføre styreevaluering, evaluering av daglig leder, møteevaluering eller andre typer undersøkelser. Du kan bruke ferdige maler fra Orgbrain eller lage dine egne.',
  },
  TourDashboardTitle11: {
    en: 'Academy',
    nb: 'Academy',
  },
  TourDashboardDesc11: {
    en: 'Here you will find professional content that keeps you updated on relevant topics in board work and corporate governance. You will have access to certification courses in board work, webinars, and e-books, developed in collaboration with strong professional environments.',
    nb: 'Her finner du faglig innhold som holder deg oppdatert på relevante temaer innen styrearbeid og selskapsledelse. Du får blant annet tilgang til sertifiseringskurs i styrearbeid, webinarer og e-bøker, utviklet i samarbeid med sterke fagmiljøer.',
  },
  TourDashboardTitle12: {
    en: 'Signatures',
    nb: 'Signaturer',
  },
  TourDashboardDesc12: {
    en: 'Here you can manage all signatures in the organization, whether they are signed with BankID, Vipps, or Orgbrain eSign.',
    nb: 'Her finner du en oversikt over både åpne og fullførte signaturoppgaver, enten de er signert med BankID, Vipps eller Orgbrain eSign.',
  },
  TourDashboardTitle13: {
    en: 'My Boardmatch',
    nb: 'Min styrematch',
  },
  TourDashboardDesc13: {
    en: 'Here you can create your own profile and be matched with available board positions that fit your qualifications and preferences. You can choose whether the profile should be open or anonymous.',
    nb: 'Her kan du legge ut din egen profil og bli matchet med ledige verv som passer dine kvalifikasjoner og preferanser. Du velger selv om profilen skal være åpen eller anonym.',
  },
  TourDashboardTitle14: {
    en: 'New Organization',
    nb: 'Ny organisasjon',
  },
  TourDashboardDesc14: {
    en: 'Here you can easily add new organizations you want to test or use Orgbrain on. Each account starts with a 14-day free trial. You can upgrade to a subscription at any time. If not, the account will automatically end without cost.',
    nb: 'Her kan du enkelt legge til nye virksomheter du ønsker å teste eller bruke Orgbrain på. Hver konto starter som en gratis prøveversjon i 14 dager. Du kan når som helst oppgradere til et abonnement. Hvis ikke, avsluttes kontoen automatisk uten kostnad.',
  },
  TourDashboardTitle15: {
    en: 'Extra Services',
    nb: 'Ekstra tjenester',
  },
  TourDashboardDesc15: {
    en: 'Here you will find access to discounted prices from partners on relevant additional services.',
    nb: 'Her får du blant annet tilgang til rabatterte priser fra samarbeidspartnere på relevante tilleggstjenester.',
  },
  TourDashboardTitle16: {
    en: 'Activities',
    nb: 'Aktiviteter',
  },
  TourDashboardDesc16: {
    en: 'Here you get an overview of all activities related to you in Orgbrain, across the organizations you are connected to. You can easily filter by activity type to quickly access what is most relevant for you. This gives you full control over your own tasks and deadlines – all in one place.',
    nb: 'Her får du en samlet oversikt over alle aktiviteter knyttet til deg i Orgbrain, på tvers av organisasjonene du er tilknyttet. Du kan enkelt filtrere etter aktivitetstype for å få rask tilgang til det som er mest relevant for deg. Dette gir deg full kontroll over egne oppgaver og frister – alt på ett sted.',
  },
  TourDashboardTitle17: {
    en: 'Your Activities',
    nb: 'Dine aktiviteter',
  },
  TourDashboardDesc17: {
    en: 'Here you also get a quick overview of your own activities, across all the organizations you are connected to.',
    nb: 'Her får du også et raskt overblikk over dine egne aktiviteter, på tvers av alle organisasjonene du er tilknyttet.',
  },
  TourDashboardTitle18: {
    en: 'News and Information',
    nb: 'Nyheter og informasjon',
  },
  TourDashboardDesc18: {
    en: 'Here you will find updates on new features, important deadlines, and other relevant information related to the use of Orgbrain.',
    nb: 'Her finner du oppdateringer om nye funksjoner, viktige frister og annen relevant informasjon knyttet til bruken av Orgbrain.',
  },
  TourDashboardTitle19: {
    en: 'Get Started with Orgbrain',
    nb: 'Kom i gang med Orgbrain',
  },
  TourDashboardDesc19: {
    en: 'Here you will find shortcuts to three introductory videos tailored to your user level that will help you get started.',
    nb: 'Her har vi lagt frem snarveier til tre introduksjons-videoer tilpasset til brukernivå som hjelper dere i gang.',
  },
  TourDashboardTitle20: {
    en: 'Open Board Positions',
    nb: 'Ledige styreverv',
  },
  TourDashboardDesc20: {
    en: 'Here you can find open board positions that match your profile. You can apply for positions that interest you, and you can also create your own profile to be matched with available positions.',
    nb: 'Her ser du hvor mange kandidater som søker verv, og hvor mange stillingsannonser som er publisert.',
  },
  TourDashboardTitle21: {
    en: 'Your Profile',
    nb: 'Din profil',
  },
  TourDashboardDesc21: {
    en: 'Here you can see how complete your Orgbrain profile is. A profile at 100% indicates that you are an active and well-prepared user.',
    nb: 'Her ser du hvor komplett Orgbrain-profilen din er. En profil på 100 % indikerer at du er en aktiv og godt forberedt bruker.',
  },
  TourDashboardTitle22: {
    en: 'Board Insurance',
    nb: 'Styreansvarsforsikring',
  },
  TourDashboardDesc22: {
    en: 'Orgbrain has negotiated discounted board liability insurance for our customers. In addition, many companies that previously did not meet the requirements for such insurance can now obtain it if they use Orgbrain in their board work – as this helps reduce risk.',
    nb: 'Orgbrain har forhandlet frem rabattert styreansvarsforsikring for våre kunder. I tillegg kan mange virksomheter som tidligere ikke oppfylte vilkårene for slik forsikring, likevel få den dersom de bruker Orgbrain i styrearbeidet – ettersom dette bidrar til å redusere risikoen.',
  },
  TourDashboardTitle23: {
    en: 'Latest News',
    nb: 'Siste nytt',
  },
  TourDashboardDesc23: {
    en: 'Here you get quick access to the latest published news.',
    nb: 'Her får du rask tilgang til den sist publiserte nyheten.',
  },
  TourDashboardTitle24: {
    en: 'Support Chat',
    nb: 'Support-chat',
  },
  TourDashboardDesc24: {
    en: 'To the bottom right of the homepage, you will find a chat that you can use to contact our support team.',
    nb: 'Nederst til høyre på startsiden finner du en chat som du kan bruke for å komme i kontakt med vårt supportteam.',
  },
  TourDashboardTitle25: {
    en: 'Personal Settings',
    nb: 'Personlige innstillinger',
  },
  TourDashboardDesc25: {
    en: 'Get a quick overview of whether two-factor authentication (2FA) is enabled, and access your personal settings.',
    nb: 'Få rask oversikt over om tofaktorautentisering (2FA) er aktivert, og få tilgang til dine personlige innstillinger.',
  },
  TourDashboardTitle26: {
    en: 'Edit Dashboard',
    nb: 'Rediger dashboard',
  },
  TourDashboardDesc26: {
    en: 'Edit the dashboard to show what you think is most important.',
    nb: 'Tilpass dashboardet slik at det viser det du synes er viktigst.',
  },
  TourDashboardTitle27: {
    en: 'Select Organization',
    nb: 'Velg organisasjon',
  },
  TourDashboardDesc27: {
    en: 'If you have access to multiple organizations, you can easily switch between them.',
    nb: 'Dersom du har tilgang til flere virksomheter, kan du enkelt bytte mellom dem.',
  },
  TourDashboardTitle28: {
    en: 'Notifications',
    nb: 'Varsler',
  },
  TourDashboardDesc28: {
    en: 'Notifications center will notify you when there is something new you should be aware of. Important notifications are also sent to you via email.',
    nb: 'Varslingssenteret gir deg beskjed når det er noe nytt du bør være oppmerksom på. Viktige varsler sendes også til deg på e-post.',
  },
  TourDashboardTitle29: {
    en: 'The Board Chat',
    nb: 'Styrets nettprat',
  },
  TourDashboardDesc29: {
    en: 'Get quick access to chat with users who have board access. You can also find this chat under "Communication" in the left menu.',
    nb: 'Få rask tilgang til chat med brukere som har styretilgang. Du finner også denne chatten under "Kommunikasjon" i venstremenyen.',
  },
  TourDashboardTitle30: {
    en: 'Support',
    nb: 'Support',
  },
  TourDashboardDesc30: {
    en: 'Would you like to learn more about what Orgbrain offers? The support center gives you access to useful information about the features and capabilities. \n \n \n Here you will also find a rich library of training videos and guides that help you get started.',
    nb: 'Vil du bli bedre kjent med hva Orgbrain tilbyr? Supportsenteret gir deg tilgang til nyttig informasjon om løsningens funksjoner og muligheter. \n \n \n Her finner du også et innholdsrikt bibliotek med opplæringsfilmer og veiledere som hjelper deg godt i gang.',
  },
  TourDashboardTitle31: {
    en: 'Account & Settings',
    nb: 'Konto & instillinger',
  },
  TourDashboardDesc31: {
    en: 'Here you will find various settings and other information related to you as a user.',
    nb: 'Her finner du ulike innstillinger og annen informasjon som er knyttet til deg som bruker.',
  },
  TourDashboardAdminTitle1: {
    en: 'Product Tour',
    nb: 'Produktomvisning',
  },
  TourDashboardAdminDesc1: {
    en: 'Here you will get a quick introduction to the dashboard in Orgbrain. We will show you where to find important information and features that help the board work more efficiently and structured. (You can use the arrow keys to navigate back and forward)',
    nb: 'Her får du en rask introduksjon til startsiden (“Dashboardet”) i Orgbrain. Vi viser deg hvor du finner viktig informasjon og funksjoner som hjelper styret å jobbe mer effektivt og strukturert. (Du kan bruke piltastene for å navigere frem og tilbake)',
  },
  TourDashboardAdminTitle2: {
    en: 'Quick Access Menu',
    nb: 'Hurtigmeny',
  },
  TourDashboardAdminDesc2: {
    en: 'The access to features in the portal depends on the subscription your organization has, and the role you have. The features are organized in modules that you can easily open via the quick access menu.',
    nb: 'Tilgangen din til funksjoner i portalen avhenger av hvilket abonnement organisasjonen har, og hvilken rolle du har. Funksjonene er organisert i moduler som du enkelt kan åpne via hurtigmenyen.',
  },
  TourDashboardAdminTitle3: {
    en: 'Side Menu',
    nb: 'Venstremeny',
  },
  TourDashboardAdminDesc3: {
    en: 'You can find the same features in the left side menu.',
    nb: 'De samme funksjonene finner du også i venstremenyen.',
  },
  TourDashboardAdminTitle4: {
    en: 'Search Field',
    nb: 'Søkefelt',
  },
  TourDashboardAdminDesc4: {
    en: 'Use the search field to find features and other relevant information.',
    nb: 'Bruk søkefeltet for å finne funksjoner og annen relevant informasjon.',
  },
  TourDashboardAdminTitle5: {
    en: 'Meetings',
    nb: 'Møter',
  },
  TourDashboardAdminDesc5: {
    en: 'The meeting module is used to create, manage and conduct meetings in the portal – whether it is board meetings, general meetings or other company meetings.',
    nb: 'Møtemodulen brukes til å opprette, administrere og gjennomføre møter i portalen – enten det er styremøter, generalforsamlinger eller andre selskapsmøter.',
  },

  TourDashboardAdminTitle7: {
    en: 'Communication',
    nb: 'Kommunikasjon',
  },
  TourDashboardAdminDesc7: {
    en: 'Here you can safely and easily communicate with the board, owners, individual users, and custom private chat groups. You can also create contact groups that allow different stakeholders to communicate with the organization. Additionally, you can send out reports and messages.',
    nb: 'Her kan du trygt og enkelt kommunisere med styret, eiere, enkeltbrukere og egendefinerte private chatgrupper. Du kan også opprette kontaktgrupper som gjør det mulig for ulike interessenter å kommunisere med virksomheten. I tillegg kan du sende ut rapporter og meldinger.',
  },
  TourDashboardAdminTitle8: {
    en: 'Data Room',
    nb: 'Datarom',
  },
  TourDashboardAdminDesc8: {
    en: 'In the data room, you can create folders, store files, and assign different access levels. You can also share folders across organizations and create signing requests. All files created in connection with meetings are automatically stored in a structured manner in the data room.',
    nb: 'I datarommet kan du opprette mapper, lagre filer og tildele ulike tilgangsnivåer. Du kan også dele mapper på tvers av organisasjoner og opprette signeringsforespørsler. Alle filer som opprettes i forbindelse med møter, blir automatisk lagret på en strukturert måte i datarommet.',
  },
  TourDashboardAdminTitle9: {
    en: 'Tasks',
    nb: 'Oppgaver',
  },
  TourDashboardAdminDesc9: {
    en: 'This module contains functionality for tracking and managing tasks and other matters that need to be followed up, including decisions from board meetings.',
    nb: 'Denne modulen inneholder funksjonalitet for oppfølging og administrasjon av oppgaver og andre saker som skal følges opp, inkludert vedtak fra styremøter.',
  },
  TourDashboardAdminTitle10: {
    en: 'Surveys',
    nb: 'Undersøkelser',
  },
  TourDashboardAdminDesc10: {
    en: 'Here you can create and manage surveys, such as board evaluations, CEO evaluations, meeting evaluations, or other types of surveys. You can use ready-made templates from Orgbrain or create your own.',
    nb: 'Her kan du gjennomføre styreevaluering, evaluering av daglig leder, møteevaluering eller andre typer undersøkelser. Du kan bruke ferdige maler fra Orgbrain eller lage dine egne.',
  },
  TourDashboardAdminTitle11: {
    en: 'Academy',
    nb: 'Academy',
  },
  TourDashboardAdminDesc11: {
    en: 'Here you will find professional content that keeps you updated on relevant topics in board work and corporate governance. You will have access to certification courses in board work, webinars, and e-books, developed in collaboration with strong professional environments.',
    nb: 'Her finner du faglig innhold som holder deg oppdatert på relevante temaer innen styrearbeid og selskapsledelse. Du får blant annet tilgang til sertifiseringskurs i styrearbeid, webinarer og e-bøker, utviklet i samarbeid med sterke fagmiljøer.',
  },
  TourDashboardAdminTitle12: {
    en: 'Board Match',
    nb: 'Styrematch',
  },
  TourDashboardAdminDesc12: {
    en: 'Find the right people for the board or other positions. With access to Orgbrain’s candidate database and smart matching, you will receive qualified suggestions – quickly and accurately.',
    nb: 'Finn de rette personene til styret eller andre verv. Med tilgang til Orgbrains kandidatbase og smart matching får dere kvalifiserte forslag – raskt og treffsikkert.',
  },
  TourDashboardAdminTitle13: {
    en: 'Signatures',
    nb: 'Signaturer',
  },
  TourDashboardAdminDesc13: {
    en: 'Here you can manage all signatures in the organization, whether they are signed with BankID, Vipps, or Orgbrain eSign. You can also create signing requests and see the status of ongoing and completed signing tasks.',
    nb: 'Her finner du en oversikt over både åpne og fullførte signaturoppgaver, enten de er signert med BankID, Vipps eller Orgbrain eSign',
  },
  TourDashboardAdminTitle14: {
    en: 'Organization',
    nb: 'Organisasjon',
  },
  TourDashboardAdminDesc14: {
    en: 'Here you manage everything related to your organization, including inviting new users, organization-specific settings, and subscriptions.',
    nb: 'Her administrerer du alt som gjelder din organisasjon, inkludert invitasjon av nye brukere, organisasjonsspesifikke innstillinger og abonnement.',
  },
  TourDashboardAdminTitle15: {
    en: 'My Boardmatch',
    nb: 'Min styrematch',
  },
  TourDashboardAdminDesc15: {
    en: 'Here you can create your own profile and be matched with available board positions that fit your qualifications and preferences. You can choose whether the profile should be open or anonymous.',
    nb: 'Her kan du legge ut din egen profil og bli matchet med ledige verv som passer dine kvalifikasjoner og preferanser. Du velger selv om profilen skal være åpen eller anonym.',
  },
  TourDashboardAdminTitle16: {
    en: 'New Organization',
    nb: 'Ny organisasjon',
  },
  TourDashboardAdminDesc16: {
    en: 'Here you can easily add new organizations you want to test or use Orgbrain on. Each account starts with a 14-day free trial. You can upgrade to a subscription at any time. If not, the account will automatically end without cost.',
    nb: 'Her kan du enkelt legge til nye virksomheter du ønsker å teste eller bruke Orgbrain på. Hver konto starter som en gratis prøveversjon i 14 dager. Du kan når som helst oppgradere til et abonnement. Hvis ikke, avsluttes kontoen automatisk uten kostnad.',
  },
  TourDashboardAdminTitle17: {
    en: 'Investments',
    nb: 'Investeringer',
  },
  TourDashboardAdminDesc17: {
    en: 'Here you get an overview of your ownership and all investments registered in companies where you use Orgbrain.',
    nb: 'Her får du oversikt over ditt eierskap og alle investeringer som er registrert i selskaper der du bruker Orgbrain.',
  },
  TourDashboardAdminTitle18: {
    en: 'External Services',
    nb: 'Eksterne tjenester',
  },
  TourDashboardAdminDesc18: {
    en: 'Here you will find access to discounted prices from partners on relevant additional services.',
    nb: 'Her får du blant annet tilgang til rabatterte priser fra samarbeidspartnere på relevante tilleggstjenester.',
  },
  TourDashboardAdminTitle19: {
    en: 'Activities',
    nb: 'Aktiviteter',
  },
  TourDashboardAdminDesc19: {
    en: 'Here you get an overview of all activities related to you in Orgbrain, across the organizations you are connected to. You can easily filter by activity type to quickly access what is most relevant for you. This gives you full control over your own tasks and deadlines – all in one place.',
    nb: 'Her får du en samlet oversikt over alle aktiviteter knyttet til deg i Orgbrain, på tvers av organisasjonene du er tilknyttet. Du kan enkelt filtrere etter aktivitetstype for å få rask tilgang til det som er mest relevant for deg. Dette gir deg full kontroll over egne oppgaver og frister – alt på ett sted.',
  },
  TourDashboardAdminTitle20: {
    en: 'Your Activities',
    nb: 'Dine aktiviteter',
  },
  TourDashboardAdminDesc20: {
    en: 'Here you also get a quick overview of your own activities, across all the organizations you are connected to.',
    nb: 'Her får du også et raskt overblikk over dine egne aktiviteter, på tvers av alle organisasjonene du er tilknyttet.',
  },
  TourDashboardAdminTitle21: {
    en: 'News and Information',
    nb: 'Nyheter og informasjon',
  },
  TourDashboardAdminDesc21: {
    en: 'Here you will find updates on new features, important deadlines, and other relevant information related to the use of Orgbrain.',
    nb: 'Her finner du oppdateringer om nye funksjoner, viktige frister og annen relevant informasjon knyttet til bruken av Orgbrain.',
  },
  TourDashboardAdminTitle22: {
    en: 'Get Started with Orgbrain',
    nb: 'Kom i gang med Orgbrain',
  },
  TourDashboardAdminDesc22: {
    en: 'Here you will find quick access to three introductory videos tailored to your user level that help you get started.',
    nb: 'Her har vi lagt frem snarveier til tre introduksjons-videoer tilpasset til brukernivå som hjelper dere i gang.',
  },
  TourDashboardAdminTitle23: {
    en: 'Open Board Positions',
    nb: 'Ledige styreverv',
  },
  TourDashboardAdminDesc23: {
    en: 'Here you can find open board positions that match your profile. You can apply for positions that interest you, and you can also create your own profile to be matched with available positions.',
    nb: 'Her ser du hvor mange kandidater som søker verv, og hvor mange stillingsannonser som er publisert.',
  },
  TourDashboardAdminTitle24: {
    en: 'Your Profile',
    nb: 'Din profil',
  },
  TourDashboardAdminDesc24: {
    en: 'Here you can see how complete your Orgbrain profile is. A profile at 100% indicates that you are an active and well-prepared user.',
    nb: 'Her ser du hvor komplett Orgbrain-profilen din er. En profil på 100 % indikerer at du er en aktiv og godt forberedt bruker.',
  },
  TourDashboardAdminTitle25: {
    en: 'Board Insurance',
    nb: 'Styreansvarsforsikring',
  },
  TourDashboardAdminDesc25: {
    en: 'Orgbrain has negotiated discounted board liability insurance for our customers. In addition, many companies that previously did not meet the requirements for such insurance can now obtain it if they use Orgbrain in their board work – as this helps reduce risk.',
    nb: 'Orgbrain har forhandlet frem rabattert styreansvarsforsikring for våre kunder. I tillegg kan mange virksomheter som tidligere ikke oppfylte vilkårene for slik forsikring, likevel få den dersom de bruker Orgbrain i styrearbeidet – ettersom dette bidrar til å redusere risikoen.',
  },
  TourDashboardAdminTitle26: {
    en: 'Latest News',
    nb: 'Siste nytt',
  },
  TourDashboardAdminDesc26: {
    en: 'Here you get quick access to the latest published news.',
    nb: 'Her får du rask tilgang til den sist publiserte nyheten.',
  },
  TourDashboardAdminTitle27: {
    en: 'Support Chat',
    nb: 'Support-chat',
  },
  TourDashboardAdminDesc27: {
    en: 'To the bottom right of the homepage, you will find a chat that you can use to contact our support team.',
    nb: 'Nederst til høyre på startsiden finner du en chat som du kan bruke for å komme i kontakt med vårt supportteam.',
  },
  TourDashboardAdminTitle28: {
    en: 'Personal Settings',
    nb: 'Personlige innstillinger',
  },
  TourDashboardAdminDesc28: {
    en: 'Get a quick overview of whether two-factor authentication (2FA) is enabled, and access your personal settings.',
    nb: 'Få rask oversikt over om tofaktorautentisering (2FA) er aktivert, og få tilgang til dine personlige innstillinger.',
  },
  TourDashboardAdminTitle29: {
    en: 'Edit Dashboard',
    nb: 'Rediger dashboard',
  },
  TourDashboardAdminDesc29: {
    en: 'Edit the dashboard to show what you think is most important.',
    nb: 'Tilpass dashboardet slik at det viser det du synes er viktigst.',
  },
  TourDashboardAdminTitle30: {
    en: 'Select Organization',
    nb: 'Velg organisasjon',
  },
  TourDashboardAdminDesc30: {
    en: 'If you have access to multiple organizations, you can easily switch between them.',
    nb: 'Dersom du har tilgang til flere virksomheter, kan du enkelt bytte mellom dem.',
  },
  TourDashboardAdminTitle31: {
    en: 'Notifications',
    nb: 'Varsler',
  },
  TourDashboardAdminDesc31: {
    en: 'Notifications center will notify you when there is something new you should be aware of. Important notifications are also sent to you via email.',
    nb: 'Varslingssenteret gir deg beskjed når det er noe nytt du bør være oppmerksom på. Viktige varsler sendes også til deg på e-post.',
  },
  TourDashboardAdminTitle32: {
    en: 'The Board Chat',
    nb: 'Styrets nettprat',
  },
  TourDashboardAdminDesc32: {
    en: 'Get quick access to chat with users who have board access. You can also find this chat under "Communication" in the left menu.',
    nb: 'Få rask tilgang til chat med brukere som har styretilgang. Du finner også denne chatten under "Kommunikasjon" i venstremenyen.',
  },
  TourDashboardAdminTitle33: {
    en: 'Support',
    nb: 'Support',
  },
  TourDashboardAdminDesc33: {
    en: 'Do you want to learn more about what Orgbrain offers? The support center gives you access to useful information about the features and capabilities. \n \n \n Here you will also find a rich library of training videos and guides that help you get started.',
    nb: 'Vil du bli bedre kjent med hva Orgbrain tilbyr? Supportsenteret gir deg tilgang til nyttig informasjon om løsningens funksjoner og muligheter. \n \n \n Her finner du også et innholdsrikt bibliotek med opplæringsfilmer og veiledere som hjelper deg godt i gang.',
  },
  TourDashboardAdminTitle34: {
    en: 'Account & Settings',
    nb: 'Konto & instillinger',
  },
  TourDashboardAdminDesc34: {
    en: 'Here you will find various settings and other information related to you as a user.',
    nb: 'Her finner du ulike innstillinger og annen informasjon som er knyttet til deg som bruker.',
  },
  TourDashboardOwnerTitle1: {
    en: 'Product Tour',
    nb: 'Produktomvisning',
  },
  TourDashboardOwnerDesc1: {
    en: 'Here you will get a quick introduction to the dashboard in Orgbrain. We will show you where to find important information and features that help you use Orgbrain more efficiently and structured. You will see what is relevant for your role. Administrators have access to more features. (You can use the arrow keys to navigate back and forward)',
    nb: 'Her får du en rask introduksjon til startsiden (“Dashboardet”) i Orgbrain. Vi viser deg hvor du finner viktig informasjon og funksjoner som hjelper deg å bruke Orgbrain mer effektivt og strukturert. Du vil se det som er relevant for din rolle. Administratorer har tilgang til flere funksjoner. (Du kan bruke piltastene for å navigere frem og tilbake)',
  },
  TourDashboardOwnerTitle2: {
    en: 'Quick Access Menu',
    nb: 'Hurtigmeny',
  },
  TourDashboardOwnerDesc2: {
    en: 'The access to features in the portal depends on the subscription your organization has, and the role you have. The features are organized in modules that you can easily open via the quick access menu.',
    nb: 'Tilgangen din til funksjoner i portalen avhenger av hvilket abonnement organisasjonen har, og hvilken rolle du har. Funksjonene er organisert i moduler som du enkelt kan åpne via hurtigmenyen.',
  },
  TourDashboardOwnerTitle3: {
    en: 'Side Menu',
    nb: 'Venstremeny',
  },
  TourDashboardOwnerDesc3: {
    en: 'You can find the same features in the left side menu.',
    nb: 'De samme funksjonene finner du også i venstremenyen.',
  },
  TourDashboardOwnerTitle4: {
    en: 'Search Field',
    nb: 'Søkefelt',
  },
  TourDashboardOwnerDesc4: {
    en: 'Use the search field to find features and other relevant information.',
    nb: 'Bruk søkefeltet for å finne funksjoner og annen relevant informasjon.',
  },
  TourDashboardOwnerTitle5: {
    en: 'Meetings',
    nb: 'Møter',
  },
  TourDashboardOwnerDesc5: {
    en: 'The meeting module is used to create, manage and conduct meetings in the portal – whether it is board meetings, general meetings or other company meetings.',
    nb: 'Møtemodulen gir deg oversikt over alle generalforsamlinger, årsmøter og andre møter du er invitert til, samt historiske møter du har fått tilgang til.',
  },
  TourDashboardOwnerTitle6: {
    en: 'Owners',
    nb: 'Eiere',
  },
  TourDashboardOwnerDesc6: {
    en: 'Here you will find all functionality for managing and administering owners, including shareholder register, transactions, capital increases, and similar.',
    nb: 'Her vil du få tilgang til aksjeeierboken dersom selskapet har åpnet for det.',
  },
  TourDashboardOwnerTitle7: {
    en: 'Communication',
    nb: 'Kommunikasjon',
  },
  TourDashboardOwnerDesc7: {
    en: 'Here you can safely and easily communicate with the board, owners, individual users, and custom private chat groups. You can also create contact groups that allow different stakeholders to communicate with the organization. Additionally, you can send out reports and messages.',
    nb: 'Her kan virksomheten publisere meldinger, invitere deg til chatsamtaler eller opprette kontaktgrupper du kan ta kontakt med.',
  },
  TourDashboardOwnerTitle8: {
    en: 'Data Room',
    nb: 'Datarom',
  },
  TourDashboardOwnerDesc8: {
    en: 'In the data room, you can create folders, store files, and assign different access levels. You can also share folders across organizations and create signing requests. All files created in connection with meetings are automatically stored in a structured manner in the data room.',
    nb: 'I datarommet kan du opprette mapper, lagre filer og tildele ulike tilgangsnivåer. Du kan også dele mapper på tvers av organisasjoner og opprette signeringsforespørsler. Alle filer som opprettes i forbindelse med møter, blir automatisk lagret på en strukturert måte i datarommet.',
  },
  TourDashboardOwnerTitle9: {
    en: 'Surveys',
    nb: 'Undersøkelser',
  },
  TourDashboardOwnerDesc9: {
    en: 'Here you can create and manage surveys, such as board evaluations, CEO evaluations, meeting evaluations, or other types of surveys. You can use ready-made templates from Orgbrain or create your own.',
    nb: 'Her kan virksomheten gjennomføre styreevaluering, evaluering av daglig leder, møteevaluering eller andre typer undersøkelser. Administrator kan bruke ferdige maler fra Orgbrain eller lage sine egne.',
  },
  TourDashboardOwnerTitle10: {
    en: 'My Boardmatch',
    nb: 'Min styrematch',
  },
  TourDashboardOwnerDesc10: {
    en: 'Here you can create your own profile and be matched with available board positions that fit your qualifications and preferences. You can choose whether the profile should be open or anonymous.',
    nb: 'Her kan du legge ut din egen profil og bli matchet med ledige verv som passer dine kvalifikasjoner og preferanser. Du velger selv om profilen skal være åpen eller anonym.',
  },
  TourDashboardOwnerTitle11: {
    en: 'New Organization',
    nb: 'Ny organisasjon',
  },
  TourDashboardOwnerDesc11: {
    en: 'Here you can easily add new organizations you want to test or use Orgbrain on. Each account starts with a 14-day free trial. You can upgrade to a subscription at any time. If not, the account will automatically end without cost.',
    nb: 'Her kan du enkelt legge til nye virksomheter du ønsker å teste eller bruke Orgbrain på. Hver konto starter som en gratis prøveversjon i 14 dager. Du kan når som helst oppgradere til et abonnement. Hvis ikke, avsluttes kontoen automatisk uten kostnad.',
  },
  TourDashboardOwnerTitle12: {
    en: 'Investments',
    nb: 'Investeringer',
  },
  TourDashboardOwnerDesc12: {
    en: 'Here you get an overview of your ownership and all investments registered in companies where you use Orgbrain.',
    nb: 'Her får du oversikt over ditt eierskap og alle investeringer som er registrert i selskaper der du bruker Orgbrain.',
  },
  TourDashboardOwnerTitle13: {
    en: 'External Services',
    nb: 'Eksterne tjenester',
  },
  TourDashboardOwnerDesc13: {
    en: 'Here you will find access to discounted prices from partners on relevant additional services.',
    nb: 'Her får du blant annet tilgang til rabatterte priser fra samarbeidspartnere på relevante tilleggstjenester.',
  },
  TourDashboardOwnerTitle14: {
    en: 'Activities',
    nb: 'Aktiviteter',
  },
  TourDashboardOwnerDesc14: {
    en: 'Here you get an overview of all activities related to you in Orgbrain, across the organizations you are connected to. You can easily filter by activity type to quickly access what is most relevant for you. This gives you full control over your own tasks and deadlines – all in one place.',
    nb: 'Her får du en samlet oversikt over alle aktiviteter knyttet til deg i Orgbrain, på tvers av organisasjonene du er tilknyttet. Du kan enkelt filtrere etter aktivitetstype for å få rask tilgang til det som er mest relevant for deg. Dette gir deg full kontroll over egne oppgaver og frister – alt på ett sted.',
  },
  TourDashboardOwnerTitle15: {
    en: 'Your Activities',
    nb: 'Dine aktiviteter',
  },
  TourDashboardOwnerDesc15: {
    en: 'Here you also get a quick overview of your own activities, across all the organizations you are connected to.',
    nb: 'Her får du også et raskt overblikk over dine egne aktiviteter, på tvers av alle organisasjonene du er tilknyttet.',
  },
  TourDashboardOwnerTitle16: {
    en: 'News and Information',
    nb: 'Nyheter og informasjon',
  },
  TourDashboardOwnerDesc16: {
    en: 'Here you will find updates on new features, important deadlines, and other relevant information related to the use of Orgbrain.',
    nb: 'Her finner du oppdateringer om nye funksjoner, viktige frister og annen relevant informasjon knyttet til bruken av Orgbrain.',
  },
  TourDashboardOwnerTitle17: {
    en: 'Get Started with Orgbrain',
    nb: 'Kom i gang med Orgbrain',
  },
  TourDashboardOwnerDesc17: {
    en: 'Here you will find quick access to three introductory videos tailored to your user level that help you get started.',
    nb: 'Her har vi lagt frem snarveier til tre introduksjons-videoer tilpasset til brukernivå som hjelper dere i gang.',
  },
  TourDashboardOwnerTitle18: {
    en: 'Open Board Positions',
    nb: 'Ledige styreverv',
  },
  TourDashboardOwnerDesc18: {
    en: 'Here you can find open board positions that match your profile. You can apply for positions that interest you, and you can also create your own profile to be matched with available positions.',
    nb: 'Her ser du hvor mange kandidater som søker verv, og hvor mange stillingsannonser som er publisert.',
  },
  TourDashboardOwnerTitle19: {
    en: 'Your Profile',
    nb: 'Din profil',
  },
  TourDashboardOwnerDesc19: {
    en: 'Here you can see how complete your Orgbrain profile is. A profile at 100% indicates that you are an active and well-prepared user.',
    nb: 'Her ser du hvor komplett Orgbrain-profilen din er. En profil på 100 % indikerer at du er en aktiv og godt forberedt bruker.',
  },
  TourDashboardOwnerTitle20: {
    en: 'Board Insurance',
    nb: 'Styreansvarsforsikring',
  },
  TourDashboardOwnerDesc20: {
    en: 'Orgbrain has negotiated discounted board liability insurance for our customers. In addition, many companies that previously did not meet the requirements for such insurance can now obtain it if they use Orgbrain in their board work – as this helps reduce risk.',
    nb: 'Orgbrain har forhandlet frem rabattert styreansvarsforsikring for våre kunder. I tillegg kan mange virksomheter som tidligere ikke oppfylte vilkårene for slik forsikring, likevel få den dersom de bruker Orgbrain i styrearbeidet – ettersom dette bidrar til å redusere risikoen.',
  },
  TourDashboardOwnerTitle21: {
    en: 'Latest News',
    nb: 'Siste nytt',
  },
  TourDashboardOwnerDesc21: {
    en: 'Here you get quick access to the latest published news.',
    nb: 'Her får du rask tilgang til den sist publiserte nyheten.',
  },
  TourDashboardOwnerTitle22: {
    en: 'Support Chat',
    nb: 'Support-chat',
  },
  TourDashboardOwnerDesc22: {
    en: 'To the bottom right of the homepage, you will find a chat that you can use to contact our support team.',
    nb: 'Nederst til høyre på startsiden finner du en chat som du kan bruke for å komme i kontakt med vårt supportteam.',
  },
  TourDashboardOwnerTitle23: {
    en: 'Personal Settings',
    nb: 'Personlige innstillinger',
  },
  TourDashboardOwnerDesc23: {
    en: 'Get a quick overview of whether two-factor authentication (2FA) is enabled, and access your personal settings.',
    nb: 'Få rask oversikt over om tofaktorautentisering (2FA) er aktivert, og få tilgang til dine personlige innstillinger.',
  },
  TourDashboardOwnerTitle24: {
    en: 'Edit Dashboard',
    nb: 'Rediger dashboard',
  },
  TourDashboardOwnerDesc24: {
    en: 'Edit the dashboard to show what you think is most important.',
    nb: 'Tilpass dashboardet slik at det viser det du synes er viktigst.',
  },
  TourDashboardOwnerTitle25: {
    en: 'Select Organization',
    nb: 'Velg organisasjon',
  },
  TourDashboardOwnerDesc25: {
    en: 'If you have access to multiple organizations, you can easily switch between them.',
    nb: 'Dersom du har tilgang til flere virksomheter, kan du enkelt bytte mellom dem.',
  },
  TourDashboardOwnerTitle26: {
    en: 'Notifications',
    nb: 'Varsler',
  },
  TourDashboardOwnerDesc26: {
    en: 'Notifications center will notify you when there is something new you should be aware of. Important notifications are also sent to you via email.',
    nb: 'Varslingssenteret gir deg beskjed når det er noe nytt du bør være oppmerksom på. Viktige varsler sendes også til deg på e-post.',
  },
  TourDashboardOwnerTitle27: {
    en: 'Support',
    nb: 'Support',
  },
  TourDashboardOwnerDesc27: {
    en: 'Do you want to learn more about what Orgbrain offers? The support center gives you access to useful information about the features and capabilities. \n \n \n Here you will also find a rich library of training videos and guides that help you get started.',
    nb: 'Vil du bli bedre kjent med hva Orgbrain tilbyr? Supportsenteret gir deg tilgang til nyttig informasjon om løsningens funksjoner og muligheter. \n \n \n Her finner du også et innholdsrikt bibliotek med opplæringsfilmer og veiledere som hjelper deg godt i gang.',
  },
  TourDashboardOwnerTitle28: {
    en: 'Account & Settings',
    nb: 'Konto & instillinger',
  },
  TourDashboardOwnerDesc28: {
    en: 'Here you will find various settings and other information related to you as a user.',
    nb: 'Her finner du ulike innstillinger og annen informasjon som er knyttet til deg som bruker.',
  },

  TourMeetingAdminTitle1: {
    en: 'Board meeting product tour',
    nb: 'Produktomvisning styremøter',
  },
  TourMeetingAdminDesc1: {
    en: "Here's a quick run-through of how to create a board meeting and invite participants in Orgbrain. The tour takes less than two minutes.",
    nb: 'Her får du en rask gjennomgang av hvordan du oppretter et styremøte og inviterer deltakere i Orgbrain. Turen tar under to minutter.',
  },
  TourMeetingAdminTitle2: {
    en: 'Open meeting overview',
    nb: 'Åpne møteoversikten',
  },
  TourMeetingAdminDesc2: {
    en: "Click on 'Meetings' on the home page.",
    nb: "Klikk på 'Møter' på startsiden.",
  },
  TourMeetingAdminTitle3: {
    en: 'Go to the meeting menu',
    nb: 'Gå til møtemeny',
  },
  TourMeetingAdminDesc3: {
    en: "You can easily go to 'Meetings' via the left-hand menu.",
    nb: "Du kan enkelt gå til 'Møter' via venstremenyen.",
  },
  TourMeetingAdminTitle4: {
    en: 'Create new meeting',
    nb: 'Opprett nytt møte',
  },
  TourMeetingAdminDesc4: {
    en: "Use 'New meeting' to create new meetings, this feature is also located in the calendar.",
    nb: "Bruk 'Nytt møte' for å opprette nye møter, denne funksjonen ligger også i kalenderen.",
  },
  TourMeetingAdminTitle5: {
    en: 'Select board meeting',
    nb: 'Velg styremøte',
  },
  TourMeetingAdminDesc5: {
    en: "You will now get an overview of all the meeting types you have access to. Select 'Board meeting'.",
    nb: "Du vil nå få oversikt over alle møtetypene du har tilgang til. Velg 'Styremøte'.",
  },
  TourMeetingAdminTitle6: {
    en: 'Open meeting details',
    nb: 'Åpne møtedetaljer',
  },
  TourMeetingAdminDesc6: {
    en: 'A form for key information will now appear. You can return here later to change or add information.',
    nb: 'Du får nå opp et skjema for nøkkelinformasjon. Du kan gå tilbake hit senere for å endre eller legge til informasjon.',
  },
  TourMeetingAdminTitle7: {
    en: 'Change title',
    nb: 'Endre tittel',
  },
  TourMeetingAdminDesc7: {
    en: "Each board meeting is automatically given the title 'Board meeting' followed by a serial number. You can change both the title and additional title (for example 'Strategy' or 'Workshop') to clarify the meeting's topic.",
    nb: "Hvert styremøte blir automatisk gitt tittelen 'Styremøte' etterfulgt av løpenummer. Du kan endre både tittel og tilleggstittel (for eksempel 'Strategi' eller 'Workshop') for å tydeliggjøre møte­tema.",
  },
  TourMeetingAdminTitle8: {
    en: 'Adjust meeting number',
    nb: 'Juster møtenummer',
  },
  TourMeetingAdminDesc8: {
    en: 'Each meeting is automatically assigned a number. This number can be changed, for example, if you start using Orgbrain in the middle of a board year and want to have the correct number from the start in Orgbrain.',
    nb: 'Hvert møte blir automatisk gitt et nummer. Dette nummeret kan endres, noe som for eksempel kan være aktuelt dersom dere begynner å benytte Orgbrain midt i et styreår, og ønsker å få rett nummer fra start i Orgbrain.',
  },
  TourMeetingAdminTitle9: {
    en: 'Set time',
    nb: 'Angi tidspunkt',
  },
  TourMeetingAdminDesc9: {
    en: 'Enter the start and end date and time. Use a preliminary time if the final time has not been decided.',
    nb: 'Legg inn dato og klokkeslett for start og slutt. Bruk foreløpig tidspunkt hvis endelig tid ikke er avklart.',
  },
  TourMeetingAdminTitle10: {
    en: 'Choose meeting format',
    nb: 'Velg møteform',
  },
  TourMeetingAdminDesc10: {
    en: 'Select the treatment method and meeting format (physical, hybrid or digital). Add an address for a physical meeting.',
    nb: 'Velg behandlingsmåte og møteform (fysisk, hybrid eller digitalt). Legg til adresse ved fysisk møte.',
  },
  TourMeetingAdminTitle11: {
    en: 'Standard video solution',
    nb: 'Standard videoløsning',
  },
  TourMeetingAdminDesc11: {
    en: 'Orgbrain has a built-in video solution that automatically generates a unique video address for each meeting, without you having to do anything.',
    nb: 'Orgbrain har en innebygd videoløsning som automatisk genererer en unik videoadresse for hvert møte, uten at du trenger å gjøre noe.',
  },
  TourMeetingAdminTitle12: {
    en: 'External video link',
    nb: 'Ekstern videolenke',
  },
  TourMeetingAdminDesc12: {
    en: 'If you want to use another video solution (Teams, Google Meet or similar), you can paste the sharing link by clicking the button on the right.',
    nb: 'Hvis dere ønsker å bruke en annen videoløsning (Teams, Google Meet eller lignende), kan du lime inn delingslenken ved å klikke på knappen til høyre.',
  },
  TourMeetingAdminTitle13: {
    en: 'Hide features',
    nb: 'Skjul funksjoner',
  },
  TourMeetingAdminDesc13: {
    en: 'If you do not want participants to be able to attend the video meeting or get access to the automatically created meeting chat, you can hide these here.',
    nb: 'Hvis du ikke ønsker at deltakerne skal kunne delta i videomøtet eller få tilgang til den automatisk opprettede møtechatten, kan du skjule disse her.',
  },
  TourMeetingAdminTitle14: {
    en: 'Save',
    nb: 'Lagre',
  },
  TourMeetingAdminDesc14: {
    en: "Click on 'Save' to proceed.",
    nb: "Klikk på 'Lagre' for å gå videre.",
  },
  TourMeetingAdminTitle15: {
    en: 'Overview page',
    nb: 'Oversiktsside',
  },
  TourMeetingAdminDesc15: {
    en: 'You now come to a page where you can finalize the agenda and send the invitation.',
    nb: 'Du kommer nå til en side der du kan ferdigstille agendaen og sende innkallingen.',
  },
  TourMeetingAdminTitle16: {
    en: 'Quick menu',
    nb: 'Hurtigmeny',
  },
  TourMeetingAdminDesc16: {
    en: 'At the top you will find a menu to switch between meetings with a few clicks.',
    nb: 'Øverst finner du en meny for å veksle mellom møter med få klikk.',
  },
  TourMeetingAdminTitle17: {
    en: 'Summary',
    nb: 'Oppsummering',
  },
  TourMeetingAdminDesc17: {
    en: 'On the left, practical information about the selected meeting is displayed.',
    nb: 'Til venstre vises praktisk informasjon om det valgte møtet.',
  },
  TourMeetingAdminTitle18: {
    en: 'Feature menu',
    nb: 'Funksjonsmeny',
  },
  TourMeetingAdminDesc18: {
    en: 'On the right you will find a menu with several functions for the meeting: a video icon to open the video meeting, a chat icon to participate in the meeting chat, an eye icon to see how the meeting card is displayed to a regular user, and a pen icon to edit the meeting. The three dots contain additional functionality for the meeting.',
    nb: 'Til høyre finner du en meny med flere funksjoner for møtet: et videosymbol for å åpne videomøtet, et chatsymbol for å delta i møtechatten, et øyesymbol for å se hvordan møtekortet vises for en vanlig bruker, og et pennsymbol for å redigere møtet. De tre prikkene inneholder ekstra funksjonalitet for møtet.',
  },
  TourMeetingAdminTitle19: {
    en: 'Activity line',
    nb: 'Aktivitetslinje',
  },
  TourMeetingAdminDesc19: {
    en: 'On the far right, you see an activity line that shows all the steps in the meeting process. Click directly on the line to navigate between the steps. Hide the activity line by clicking on the arrow icon to the left of the line.',
    nb: 'På helt høyre side ser du en aktivitetslinje som viser alle steg i møteprosessen. Klikk direkte på linjen for å navigere mellom stegene. Skjul aktivitetslinjen ved å klikke på pilikonet til venstre for linjen.',
  },
  TourMeetingAdminTitle20: {
    en: 'Find time',
    nb: 'Finn tid',
  },
  TourMeetingAdminDesc20: {
    en: "Click 'Find time' to invite participants to vote on relevant times.",
    nb: 'Klikk «Finn tid» for å invitere deltakere til å stemme på aktuelle tidspunkter.',
  },
  TourMeetingAdminTitle21: {
    en: 'Invite to the meeting',
    nb: 'Inviter til møtet',
  },
  TourMeetingAdminDesc21: {
    en: "You can invite participants via the 'Invite' button.",
    nb: "Du kan invitere deltakerne via knappen 'Inviter'.",
  },
  TourMeetingAdminTitle22: {
    en: 'Tabs',
    nb: 'Faner',
  },
  TourMeetingAdminDesc22: {
    en: 'Further down the page are several tabs related to the meeting.',
    nb: 'Lengre ned på siden er det flere faner knyttet til møtet.',
  },
  TourMeetingAdminTitle23: {
    en: 'Agenda',
    nb: 'Agenda',
  },
  TourMeetingAdminDesc23: {
    en: "In the 'Agenda' tab, you can add the meeting agenda by creating a new case or selecting a case from the agenda library.",
    nb: "I fanen 'Agenda' kan du legge inn møteagendaen ved å opprette en ny sak eller velge en sak fra agendabiblioteket.",
  },
  TourMeetingAdminTitle24: {
    en: 'Participants',
    nb: 'Deltakere',
  },
  TourMeetingAdminDesc24: {
    en: "In the 'Participants' tab, you can invite participants to the meeting and manage participant status.",
    nb: "I fanen 'Deltakere' kan du invitere deltakere til møtet og administrere deltakerstatus.",
  },
  TourMeetingAdminTitle25: {
    en: 'Minutes',
    nb: 'Protokoll',
  },
  TourMeetingAdminDesc25: {
    en: "In the 'Minutes' section, you handle the minutes for the meeting.",
    nb: "I seksjonen 'Protokoll' håndterer du protokollføringen for møtet.",
  },
  TourMeetingAdminTitle26: {
    en: 'Files',
    nb: 'Filer',
  },
  TourMeetingAdminDesc26: {
    en: "In 'Files' you can upload documents for the meeting. If you have uploaded files to an agenda item, you will find a copy here.",
    nb: "I 'Filer' kan du laste opp dokumenter til møtet. Dersom du har lastet opp filer på et agendapunkt, finner du en kopi her.",
  },
  TourMeetingAdminTitle27: {
    en: 'Meeting emails',
    nb: 'Møte-eposter',
  },
  TourMeetingAdminDesc27: {
    en: "Each meeting gets its unique email address. All emails sent to this email address can be found in the 'Meeting emails' tab.",
    nb: "Hvert møte får sin unike e-postadresse. Alle e-poster som sendes til denne e-postadressen finner du i fanen 'Møte-eposter'.",
  },
  TourMeetingAdminTitle28: {
    en: 'Notes',
    nb: 'Notater',
  },
  TourMeetingAdminDesc28: {
    en: "In 'Notes' you can enter your personal notes for the meeting or enter a note that everyone else can see.",
    nb: "I 'Notater' kan du legge inn dine personlige notater til møtet eller legge inn et notat som alle andre kan se.",
  },
  TourMeetingAdminTitle29: {
    en: 'Thank you',
    nb: 'Takk',
  },
  TourMeetingAdminDesc29: {
    en: 'Thank you for completing this product tour. You can easily delete the meeting by opening the 3-dot menu in the upper right corner of the meeting card. If you have any questions, you can contact us via the chat on the home page.',
    nb: 'Takk for at du gjennomførte denne produktomvisningen. Du kan enkelt slette møtet ved å åpne 3-prikkersmenyen øverst til høyre på møtekortet. Har du spørsmål, kan du kontakte oss via chatten på startsiden.',
  },
  MeetingSteps: {
    en: 'Meetings in Orgbrain',
    nb: 'Møter i Orgbrain',
  },
  TourMeetingTitle1: {
    en: 'Product tour: Participate in a meeting',
    nb: 'Produkttomvisning: Delta i møte',
  },
  TourMeetingDesc1: {
    en: 'Here is a quick overview of how to participate in a meeting you are invited to in Orgbrain. The tour takes less than two minutes.',
    nb: 'Her får du en rask gjennomgang av hvordan du deltar i et møte du er invitert til i Orgbrain. Omvisningen tar under to minutter.',
  },
  TourMeetingTitle2: {
    en: 'The meeting card',
    nb: 'Møtekortet',
  },

  TourMeetingDesc2: {
    en: 'In Orgbrain, all information related to a meeting is collected on a card.',
    nb: 'I Orgbrain så er all informasjon relatert til et møte samlet på et kort.',
  },
  TourMeetingTitle3: {
    en: 'Meeting name and meeting number',
    nb: 'Møtenavn og møtenummer',
  },
  TourMeetingDesc3: {
    en: 'At the top of the meeting card, the meeting name and number are shown.',
    nb: 'Øverst på møtekortet vises møtets navn og nummer.',
  },
  TourMeetingTitle4: {
    en: 'Meeting status',
    nb: 'Møtestatus',
  },
  TourMeetingDesc4: {
    en: 'Here the status of the meeting is shown.',
    nb: 'Her vises status for møtet.',
  },
  TourMeetingTitle5: {
    en: 'Meeting time',
    nb: 'Møtetid',
  },
  TourMeetingDesc5: {
    en: 'Here the meeting time is shown.',
    nb: 'Her vises møtets tidspunkt.',
  },
  TourMeetingTitle6: {
    en: 'Meeting type',
    nb: 'Møtetype',
  },
  TourMeetingDesc6: {
    en: 'Here the meeting type and any location are shown.',
    nb: 'Her vises møtetypen og eventuelt sted.',
  },
  TourMeetingTitle7: {
    en: 'Preparation meter',
    nb: 'Forberedelsemåler',
  },
  TourMeetingDesc7: {
    en: 'The preparation meter is visible when you are invited to a meeting with agenda items. It shows whether you have opened all the cases and attachments on the agenda, and what may remain. New updates to the agenda are also shown in the preparation meter.',
    nb: 'Forberedelsesmåleren er synlig når du er invitert til et møte med agendapunkter. Den viser om du har åpnet alle sakene og vedleggene på agendaen, og hva som eventuelt gjenstår. Nye oppdateringer i agendaen vises også i forberedelsesmåleren.',
  },
  TourMeetingTitle8: {
    en: 'Participant status',
    nb: 'Deltakerstatus',
  },
  TourMeetingDesc8: {
    en: 'Here the status of participation in the meeting is shown.',
    nb: 'Her vises status for deltakelse i møtet.',
  },
  TourMeetingTitle9: {
    en: 'Confirm participation',
    nb: 'Bekrefte deltakelse',
  },
  TourMeetingDesc9: {
    en: 'When you are invited to a meeting, you can confirm participation on the meeting card.',
    nb: 'Når du er invitert til et møte kan du bekrefte deltakelse på møtekortet.',
  },
  TourMeetingTitle10: {
    en: 'Function menu',
    nb: 'Funksjonsmeny',
  },
  TourMeetingDesc10: {
    en: "Here you will find a menu with available functions. The content varies according to the meeting administrators' settings. Each icon has a help text that is displayed when you hold the mouse pointer over it.",
    nb: 'Her finner du en meny med tilgjengelige funksjoner. Innholdet varierer etter oppsettet til møteadministratorene. Hvert ikon har en hjelpetekst som vises når du holder musepekeren over det.',
  },
  TourMeetingTitle11: {
    en: 'Tabs',
    nb: 'Faner',
  },
  TourMeetingDesc11: {
    en: 'Further down on the meeting card, there are several tabs related to the meeting.',
    nb: 'Lengre ned på møtekortet er det flere faner knyttet til møtet.',
  },
  TourMeetingTitle12: {
    en: 'Agenda',
    nb: 'Agenda',
  },
  TourMeetingDesc12: {
    en: 'In the "Agenda" tab you will find an overview of all the items on the agenda. Click on an agenda item to see the case description and any attachments.',
    nb: 'I fanen "Agenda" finner du en oversikt over alle sakene som står på agendaen. Klikk på et agendapunkt for å se saksbeskrivelsen og eventuelle vedlegg.',
  },
  TourMeetingTitle13: {
    en: 'Participants',
    nb: 'Deltakere',
  },
  TourMeetingDesc13: {
    en: 'In the “Participants” tab you will find information about those who are invited to the meeting.',
    nb: 'I fanen “Deltakere” finner du informasjon om de som er invitert til møtet.',
  },
  TourMeetingTitle14: {
    en: 'Protocol',
    nb: 'Protokoll',
  },
  TourMeetingDesc14: {
    en: 'When the meeting is over, you will find the "Protocol" tab showing the status of the meeting protocol.',
    nb: 'Når møtet er over vil du finne fanen "Protokoll" som viser status for møteprotokollen.',
  },
  TourMeetingTitle15: {
    en: 'Files',
    nb: 'Filer',
  },
  TourMeetingDesc15: {
    en: 'In the "Files" tab you will find all the documents that belong to the meeting.',
    nb: 'I fanen "Filer" finner du alle dokumentene som tilhører møtet.',
  },
  TourMeetingTitle16: {
    en: 'Meeting emails',
    nb: 'Møte-eposter',
  },
  TourMeetingDesc16: {
    en: 'Each meeting gets its unique email address. All emails sent to this email address can be found in the email tab.',
    nb: 'Hvert møte får sin unike e-postadresse. Alle e-poster som sendes til denne e-postadressen finner du i e-postfanen.',
  },
  TourMeetingTitle17: {
    en: 'Notes',
    nb: 'Notater',
  },
  TourMeetingDesc17: {
    en: 'In “Notes” you can add your personal notes to the meeting or add a note that everyone else can see.',
    nb: 'I “Notater” kan du legge inn dine personlige notater til møtet eller legge inn et notat som alle andre kan se.',
  },
  TourMeetingTitle18: {
    en: 'Thank you',
    nb: 'Takk',
  },
  TourMeetingDesc18: {
    en: 'Thank you for using this product tour. If you have any questions, you can contact us via the chat on the home page.',
    nb: 'Takk for at du brukte denne produktomvisningen. Har du spørsmål, kan du kontakte oss via chatten på startsiden.',
  },

  RatingSaved: {
    en: 'Rating Saved',
    nb: 'Vurdering lagret',
  },
  RatingSavedInfo: {
    en: 'Your rating of this candidate has been saved.',
    nb: 'Din vurdering av denne kandidaten har blitt lagret.',
  },
  GivePositiveRating: {
    en: 'Add to favourites',
    nb: 'Legg til i favoritter',
  },
  GiveNeutralRating: {
    en: 'Add to maybe',
    nb: 'Legg til i kanskje',
  },
  GiveNegativeRating: {
    en: 'Add to dislikes',
    nb: 'Legg til i avsluttende',
  },
  QuickMinuteCaseWarning: {
    en: 'We only look for meetings in the future. Please create a future meeting first.',
    nb: 'Vi ser kun etter møter i fremtiden. Vennligst opprett et fremtidig møte først.',
  },
  AllMeetingsAndTasks: {
    en: 'All meetings and tasks',
    nb: 'Alle møter og oppgaver',
  },
  surveyCompleteDialog: {
    nb: 'Takk for at du deltok',
    en: 'Thank you for your participation!',
  },
  youHaveNowAnsweredTheQuestions: {
    nb: 'Du har nå fullført undersøkelsen. Klikk på "OK" for å avslutte.',
    en: 'You have now answered the survey. Click the "OK" button to finish.',
  },
  answerAnonymous: {
    nb: 'Ditt svar (anonymt)',
    en: 'Your answer (anonymous)',
  },

  dialogTitle: {
    nb: 'Invitasjon sendt!',
    en: 'Invitation sent!',
  },
  dialogText: {
    nb: 'Invitasjonen er nå sendt til deltakerne.',
    en: 'The invitation has now been sent to the participants.',
  },
  dialogTitleNoInvitesSendt: {
    nb: 'Ingen invitasjoner sendt',
    en: 'No invitations sent',
  },
  dialogTextNoInvitesSendt: {
    nb: 'Det er ingen ubesvarte med epost å sende påminnelser til.',
    en: 'There are no unanswered with email to send reminders to.',
  },
  reminder: {
    nb: 'Påminnelse for undersøkelsen: ',
    en: 'Reminder to the survey: ',
  },
  SendReminders: {
    nb: 'Send påminnelse',
    en: 'Send reminder',
  },
  sendRemindertitle: {
    nb: 'Send påminnelse',
    en: 'Send reminder',
  },
  sendRemindertext: {
    nb: 'Ønsker du å sende påminnelse til de som ikke har svart på undersøkelsen?',
    en: 'Do you want to send a reminder to those who have not responded to the survey?',
  },
  reminderSendtDialog: {
    nb: 'Påminnelse er sendt!',
    en: 'Reminder is sent!',
  },
  reminderSendtDialogText: {
    nb: 'En påminnelse er sendt til de som ennå ikke har svart.',
    en: 'A reminder has been sent to those who have not yet responded.',
  },
  answerPublic: {
    nb: 'Ditt svar (offentlig)',
    en: 'Your answer (public)',
  },
  SurveyConfirmAnswersTitle: {
    nb: 'Send inn svarene dine?',
    en: 'Are you sure you want to submit your answer?',
  },
  SurveyConfirmAnswersDescription: {
    nb: 'Velg fortsett hvis du ønsker å fullføre innsendingen. Svarene kan ikke endres etter at de er sendt inn.',
    en: 'Click yes if you are sure you want to submit your answer. You will not be able to change the answer after submission.',
  },
  Pleaseanswerunansweredquestionsbyclickingthenumberedbuttonsbelow: {
    nb: 'Du har noen ubesvarte spørsmål. Klikk på knappene under for å svare:',
    en: 'You have some unanswered questions. Click the buttons below to answer:',
  },
  InternalServerErrorTitle: {
    nb: 'Intern serverfeil',
    en: 'Internal Server Error',
  },
  InternalServerErrorMessage: {
    nb: 'Noe gikk galt på serveren. Vennligst prøv igjen senere eller kontakt support hvis problemet vedvarer.',
    en: 'Something went wrong on the server. Please try again later or contact support if the problem persists.',
  },
  SonnerErrorReport: {
    nb: 'Feilrapport',
    en: 'Error Report',
  },
  SonnerTitle: {
    nb: 'Tittel',
    en: 'Title',
  },
  SonnerStatus: {
    nb: 'Status',
    en: 'Status',
  },
  SonnerMessage: {
    nb: 'Melding',
    en: 'Message',
  },
  SonnerError: {
    nb: 'Feil',
    en: 'Error',
  },
  SonnerRequestId: {
    nb: 'Forespørsels-ID',
    en: 'Request ID',
  },
  SonnerTimestamp: {
    nb: 'Tidsstempel',
    en: 'Timestamp',
  },
  ...newsMappings,
  ...pwaMappings,
};
